// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * This injects Tailwind's base styles, which is a combination of
 * Normalize.css and some additional base styles.
 *
 * You can see the styles here:
 * https://github.com/tailwindcss/tailwindcss/blob/master/css/preflight.css
 *
 * If using \`postcss-import\`, you should import this line from it's own file:
 *
 * @import "./tailwind-preflight.css";
 *
 * See: https://github.com/tailwindcss/tailwindcss/issues/53#issuecomment-341413622
 */

/*NOTE: 'preflight' IS RENAMED TO 'base'*/

/*@tailwind base;*/

/**
 * Here you would add any of your custom component classes; stuff that you'd
 * want loaded *before* the utilities so that the utilities could still
 * override them.
 *
 * Example:
 *
 * .btn { ... }
 * .form-input { ... }
 *
 * Or if using a preprocessor or \`postcss-import\`:
 *
 * @import "components/buttons";
 * @import "components/forms";
 */

.container{
  width: 100%;
}

[dir=ltr] .container{
  margin-right: auto;
  margin-left: auto;
  padding-right: 1rem;
  padding-left: 1rem;
}

[dir=rtl] .container{
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 576px){
  .container{
    max-width: 576px;
  }
}

@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}

@media (min-width: 992px){
  .container{
    max-width: 992px;
  }
}

@media (min-width: 1200px){
  .container{
    max-width: 1200px;
  }
}

/**
 * This injects all of Tailwind's utility classes, generated based on your
 * config file.
 *
 * If using \`postcss-import\`, you should import this line from it's own file:
 *
 * @import "./tailwind-utilities.css";
 *
 * See: https://github.com/tailwindcss/tailwindcss/issues/53#issuecomment-341413622
 */

.space-y-0 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-0 > :not(template) ~ :not(template){
  margin-top: calc(0px * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(0px * var(--space-y-reverse)) !important;
}

.space-x-0 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-0 > :not(template) ~ :not(template){
  margin-right: calc(0px * var(--space-x-reverse)) !important;
  margin-left: calc(0px * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-0 > :not(template) ~ :not(template){
  margin-left: calc(0px * var(--space-x-reverse)) !important;
  margin-right: calc(0px * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-1 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-1 > :not(template) ~ :not(template){
  margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(0.25rem * var(--space-y-reverse)) !important;
}

.space-x-1 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-1 > :not(template) ~ :not(template){
  margin-right: calc(0.25rem * var(--space-x-reverse)) !important;
  margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-1 > :not(template) ~ :not(template){
  margin-left: calc(0.25rem * var(--space-x-reverse)) !important;
  margin-right: calc(0.25rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-2 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-2 > :not(template) ~ :not(template){
  margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(0.5rem * var(--space-y-reverse)) !important;
}

.space-x-2 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-2 > :not(template) ~ :not(template){
  margin-right: calc(0.5rem * var(--space-x-reverse)) !important;
  margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-2 > :not(template) ~ :not(template){
  margin-left: calc(0.5rem * var(--space-x-reverse)) !important;
  margin-right: calc(0.5rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-3 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-3 > :not(template) ~ :not(template){
  margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(0.75rem * var(--space-y-reverse)) !important;
}

.space-x-3 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-3 > :not(template) ~ :not(template){
  margin-right: calc(0.75rem * var(--space-x-reverse)) !important;
  margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-3 > :not(template) ~ :not(template){
  margin-left: calc(0.75rem * var(--space-x-reverse)) !important;
  margin-right: calc(0.75rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-4 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-4 > :not(template) ~ :not(template){
  margin-top: calc(1rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(1rem * var(--space-y-reverse)) !important;
}

.space-x-4 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-4 > :not(template) ~ :not(template){
  margin-right: calc(1rem * var(--space-x-reverse)) !important;
  margin-left: calc(1rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-4 > :not(template) ~ :not(template){
  margin-left: calc(1rem * var(--space-x-reverse)) !important;
  margin-right: calc(1rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-5 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-5 > :not(template) ~ :not(template){
  margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(1.25rem * var(--space-y-reverse)) !important;
}

.space-x-5 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-5 > :not(template) ~ :not(template){
  margin-right: calc(1.25rem * var(--space-x-reverse)) !important;
  margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-5 > :not(template) ~ :not(template){
  margin-left: calc(1.25rem * var(--space-x-reverse)) !important;
  margin-right: calc(1.25rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-6 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-6 > :not(template) ~ :not(template){
  margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(1.5rem * var(--space-y-reverse)) !important;
}

.space-x-6 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-6 > :not(template) ~ :not(template){
  margin-right: calc(1.5rem * var(--space-x-reverse)) !important;
  margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-6 > :not(template) ~ :not(template){
  margin-left: calc(1.5rem * var(--space-x-reverse)) !important;
  margin-right: calc(1.5rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-8 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-8 > :not(template) ~ :not(template){
  margin-top: calc(2rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(2rem * var(--space-y-reverse)) !important;
}

.space-x-8 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-8 > :not(template) ~ :not(template){
  margin-right: calc(2rem * var(--space-x-reverse)) !important;
  margin-left: calc(2rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-8 > :not(template) ~ :not(template){
  margin-left: calc(2rem * var(--space-x-reverse)) !important;
  margin-right: calc(2rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-10 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-10 > :not(template) ~ :not(template){
  margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(2.5rem * var(--space-y-reverse)) !important;
}

.space-x-10 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-10 > :not(template) ~ :not(template){
  margin-right: calc(2.5rem * var(--space-x-reverse)) !important;
  margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-10 > :not(template) ~ :not(template){
  margin-left: calc(2.5rem * var(--space-x-reverse)) !important;
  margin-right: calc(2.5rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-12 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-12 > :not(template) ~ :not(template){
  margin-top: calc(3rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(3rem * var(--space-y-reverse)) !important;
}

.space-x-12 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-12 > :not(template) ~ :not(template){
  margin-right: calc(3rem * var(--space-x-reverse)) !important;
  margin-left: calc(3rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-12 > :not(template) ~ :not(template){
  margin-left: calc(3rem * var(--space-x-reverse)) !important;
  margin-right: calc(3rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-16 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-16 > :not(template) ~ :not(template){
  margin-top: calc(4rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(4rem * var(--space-y-reverse)) !important;
}

.space-x-16 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-16 > :not(template) ~ :not(template){
  margin-right: calc(4rem * var(--space-x-reverse)) !important;
  margin-left: calc(4rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-16 > :not(template) ~ :not(template){
  margin-left: calc(4rem * var(--space-x-reverse)) !important;
  margin-right: calc(4rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-20 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-20 > :not(template) ~ :not(template){
  margin-top: calc(5rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(5rem * var(--space-y-reverse)) !important;
}

.space-x-20 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-20 > :not(template) ~ :not(template){
  margin-right: calc(5rem * var(--space-x-reverse)) !important;
  margin-left: calc(5rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-20 > :not(template) ~ :not(template){
  margin-left: calc(5rem * var(--space-x-reverse)) !important;
  margin-right: calc(5rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-24 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-24 > :not(template) ~ :not(template){
  margin-top: calc(6rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(6rem * var(--space-y-reverse)) !important;
}

.space-x-24 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-24 > :not(template) ~ :not(template){
  margin-right: calc(6rem * var(--space-x-reverse)) !important;
  margin-left: calc(6rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-24 > :not(template) ~ :not(template){
  margin-left: calc(6rem * var(--space-x-reverse)) !important;
  margin-right: calc(6rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-32 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-32 > :not(template) ~ :not(template){
  margin-top: calc(8rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(8rem * var(--space-y-reverse)) !important;
}

.space-x-32 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-32 > :not(template) ~ :not(template){
  margin-right: calc(8rem * var(--space-x-reverse)) !important;
  margin-left: calc(8rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-32 > :not(template) ~ :not(template){
  margin-left: calc(8rem * var(--space-x-reverse)) !important;
  margin-right: calc(8rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-40 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-40 > :not(template) ~ :not(template){
  margin-top: calc(10rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(10rem * var(--space-y-reverse)) !important;
}

.space-x-40 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-40 > :not(template) ~ :not(template){
  margin-right: calc(10rem * var(--space-x-reverse)) !important;
  margin-left: calc(10rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-40 > :not(template) ~ :not(template){
  margin-left: calc(10rem * var(--space-x-reverse)) !important;
  margin-right: calc(10rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-48 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-48 > :not(template) ~ :not(template){
  margin-top: calc(12rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(12rem * var(--space-y-reverse)) !important;
}

.space-x-48 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-48 > :not(template) ~ :not(template){
  margin-right: calc(12rem * var(--space-x-reverse)) !important;
  margin-left: calc(12rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-48 > :not(template) ~ :not(template){
  margin-left: calc(12rem * var(--space-x-reverse)) !important;
  margin-right: calc(12rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-56 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-56 > :not(template) ~ :not(template){
  margin-top: calc(14rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(14rem * var(--space-y-reverse)) !important;
}

.space-x-56 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-56 > :not(template) ~ :not(template){
  margin-right: calc(14rem * var(--space-x-reverse)) !important;
  margin-left: calc(14rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-56 > :not(template) ~ :not(template){
  margin-left: calc(14rem * var(--space-x-reverse)) !important;
  margin-right: calc(14rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-64 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-64 > :not(template) ~ :not(template){
  margin-top: calc(16rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(16rem * var(--space-y-reverse)) !important;
}

.space-x-64 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-64 > :not(template) ~ :not(template){
  margin-right: calc(16rem * var(--space-x-reverse)) !important;
  margin-left: calc(16rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-64 > :not(template) ~ :not(template){
  margin-left: calc(16rem * var(--space-x-reverse)) !important;
  margin-right: calc(16rem * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-px > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .space-y-px > :not(template) ~ :not(template){
  margin-top: calc(1px * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(1px * var(--space-y-reverse)) !important;
}

.space-x-px > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .space-x-px > :not(template) ~ :not(template){
  margin-right: calc(1px * var(--space-x-reverse)) !important;
  margin-left: calc(1px * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .space-x-px > :not(template) ~ :not(template){
  margin-left: calc(1px * var(--space-x-reverse)) !important;
  margin-right: calc(1px * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-1 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-1 > :not(template) ~ :not(template){
  margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-0.25rem * var(--space-y-reverse)) !important;
}

.-space-x-1 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-1 > :not(template) ~ :not(template){
  margin-right: calc(-0.25rem * var(--space-x-reverse)) !important;
  margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-1 > :not(template) ~ :not(template){
  margin-left: calc(-0.25rem * var(--space-x-reverse)) !important;
  margin-right: calc(-0.25rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-2 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-2 > :not(template) ~ :not(template){
  margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-0.5rem * var(--space-y-reverse)) !important;
}

.-space-x-2 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-2 > :not(template) ~ :not(template){
  margin-right: calc(-0.5rem * var(--space-x-reverse)) !important;
  margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-2 > :not(template) ~ :not(template){
  margin-left: calc(-0.5rem * var(--space-x-reverse)) !important;
  margin-right: calc(-0.5rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-3 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-3 > :not(template) ~ :not(template){
  margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-0.75rem * var(--space-y-reverse)) !important;
}

.-space-x-3 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-3 > :not(template) ~ :not(template){
  margin-right: calc(-0.75rem * var(--space-x-reverse)) !important;
  margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-3 > :not(template) ~ :not(template){
  margin-left: calc(-0.75rem * var(--space-x-reverse)) !important;
  margin-right: calc(-0.75rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-4 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-4 > :not(template) ~ :not(template){
  margin-top: calc(-1rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-1rem * var(--space-y-reverse)) !important;
}

.-space-x-4 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-4 > :not(template) ~ :not(template){
  margin-right: calc(-1rem * var(--space-x-reverse)) !important;
  margin-left: calc(-1rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-4 > :not(template) ~ :not(template){
  margin-left: calc(-1rem * var(--space-x-reverse)) !important;
  margin-right: calc(-1rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-5 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-5 > :not(template) ~ :not(template){
  margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-1.25rem * var(--space-y-reverse)) !important;
}

.-space-x-5 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-5 > :not(template) ~ :not(template){
  margin-right: calc(-1.25rem * var(--space-x-reverse)) !important;
  margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-5 > :not(template) ~ :not(template){
  margin-left: calc(-1.25rem * var(--space-x-reverse)) !important;
  margin-right: calc(-1.25rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-6 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-6 > :not(template) ~ :not(template){
  margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-1.5rem * var(--space-y-reverse)) !important;
}

.-space-x-6 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-6 > :not(template) ~ :not(template){
  margin-right: calc(-1.5rem * var(--space-x-reverse)) !important;
  margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-6 > :not(template) ~ :not(template){
  margin-left: calc(-1.5rem * var(--space-x-reverse)) !important;
  margin-right: calc(-1.5rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-8 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-8 > :not(template) ~ :not(template){
  margin-top: calc(-2rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-2rem * var(--space-y-reverse)) !important;
}

.-space-x-8 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-8 > :not(template) ~ :not(template){
  margin-right: calc(-2rem * var(--space-x-reverse)) !important;
  margin-left: calc(-2rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-8 > :not(template) ~ :not(template){
  margin-left: calc(-2rem * var(--space-x-reverse)) !important;
  margin-right: calc(-2rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-10 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-10 > :not(template) ~ :not(template){
  margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-2.5rem * var(--space-y-reverse)) !important;
}

.-space-x-10 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-10 > :not(template) ~ :not(template){
  margin-right: calc(-2.5rem * var(--space-x-reverse)) !important;
  margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-10 > :not(template) ~ :not(template){
  margin-left: calc(-2.5rem * var(--space-x-reverse)) !important;
  margin-right: calc(-2.5rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-12 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-12 > :not(template) ~ :not(template){
  margin-top: calc(-3rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-3rem * var(--space-y-reverse)) !important;
}

.-space-x-12 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-12 > :not(template) ~ :not(template){
  margin-right: calc(-3rem * var(--space-x-reverse)) !important;
  margin-left: calc(-3rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-12 > :not(template) ~ :not(template){
  margin-left: calc(-3rem * var(--space-x-reverse)) !important;
  margin-right: calc(-3rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-16 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-16 > :not(template) ~ :not(template){
  margin-top: calc(-4rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-4rem * var(--space-y-reverse)) !important;
}

.-space-x-16 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-16 > :not(template) ~ :not(template){
  margin-right: calc(-4rem * var(--space-x-reverse)) !important;
  margin-left: calc(-4rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-16 > :not(template) ~ :not(template){
  margin-left: calc(-4rem * var(--space-x-reverse)) !important;
  margin-right: calc(-4rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-20 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-20 > :not(template) ~ :not(template){
  margin-top: calc(-5rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-5rem * var(--space-y-reverse)) !important;
}

.-space-x-20 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-20 > :not(template) ~ :not(template){
  margin-right: calc(-5rem * var(--space-x-reverse)) !important;
  margin-left: calc(-5rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-20 > :not(template) ~ :not(template){
  margin-left: calc(-5rem * var(--space-x-reverse)) !important;
  margin-right: calc(-5rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-24 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-24 > :not(template) ~ :not(template){
  margin-top: calc(-6rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-6rem * var(--space-y-reverse)) !important;
}

.-space-x-24 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-24 > :not(template) ~ :not(template){
  margin-right: calc(-6rem * var(--space-x-reverse)) !important;
  margin-left: calc(-6rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-24 > :not(template) ~ :not(template){
  margin-left: calc(-6rem * var(--space-x-reverse)) !important;
  margin-right: calc(-6rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-32 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-32 > :not(template) ~ :not(template){
  margin-top: calc(-8rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-8rem * var(--space-y-reverse)) !important;
}

.-space-x-32 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-32 > :not(template) ~ :not(template){
  margin-right: calc(-8rem * var(--space-x-reverse)) !important;
  margin-left: calc(-8rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-32 > :not(template) ~ :not(template){
  margin-left: calc(-8rem * var(--space-x-reverse)) !important;
  margin-right: calc(-8rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-40 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-40 > :not(template) ~ :not(template){
  margin-top: calc(-10rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-10rem * var(--space-y-reverse)) !important;
}

.-space-x-40 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-40 > :not(template) ~ :not(template){
  margin-right: calc(-10rem * var(--space-x-reverse)) !important;
  margin-left: calc(-10rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-40 > :not(template) ~ :not(template){
  margin-left: calc(-10rem * var(--space-x-reverse)) !important;
  margin-right: calc(-10rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-48 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-48 > :not(template) ~ :not(template){
  margin-top: calc(-12rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-12rem * var(--space-y-reverse)) !important;
}

.-space-x-48 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-48 > :not(template) ~ :not(template){
  margin-right: calc(-12rem * var(--space-x-reverse)) !important;
  margin-left: calc(-12rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-48 > :not(template) ~ :not(template){
  margin-left: calc(-12rem * var(--space-x-reverse)) !important;
  margin-right: calc(-12rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-56 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-56 > :not(template) ~ :not(template){
  margin-top: calc(-14rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-14rem * var(--space-y-reverse)) !important;
}

.-space-x-56 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-56 > :not(template) ~ :not(template){
  margin-right: calc(-14rem * var(--space-x-reverse)) !important;
  margin-left: calc(-14rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-56 > :not(template) ~ :not(template){
  margin-left: calc(-14rem * var(--space-x-reverse)) !important;
  margin-right: calc(-14rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-64 > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-64 > :not(template) ~ :not(template){
  margin-top: calc(-16rem * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-16rem * var(--space-y-reverse)) !important;
}

.-space-x-64 > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-64 > :not(template) ~ :not(template){
  margin-right: calc(-16rem * var(--space-x-reverse)) !important;
  margin-left: calc(-16rem * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-64 > :not(template) ~ :not(template){
  margin-left: calc(-16rem * var(--space-x-reverse)) !important;
  margin-right: calc(-16rem * calc(1 - var(--space-x-reverse))) !important;
}

.-space-y-px > :not(template) ~ :not(template){
  --space-y-reverse: 0 !important;
}

[dir] .-space-y-px > :not(template) ~ :not(template){
  margin-top: calc(-1px * calc(1 - var(--space-y-reverse))) !important;
  margin-bottom: calc(-1px * var(--space-y-reverse)) !important;
}

.-space-x-px > :not(template) ~ :not(template){
  --space-x-reverse: 0 !important;
}

[dir=ltr] .-space-x-px > :not(template) ~ :not(template){
  margin-right: calc(-1px * var(--space-x-reverse)) !important;
  margin-left: calc(-1px * calc(1 - var(--space-x-reverse))) !important;
}

[dir=rtl] .-space-x-px > :not(template) ~ :not(template){
  margin-left: calc(-1px * var(--space-x-reverse)) !important;
  margin-right: calc(-1px * calc(1 - var(--space-x-reverse))) !important;
}

.space-y-reverse > :not(template) ~ :not(template){
  --space-y-reverse: 1 !important;
}

.space-x-reverse > :not(template) ~ :not(template){
  --space-x-reverse: 1 !important;
}

.divide-y-0 > :not(template) ~ :not(template){
  --divide-y-reverse: 0 !important;
}

[dir] .divide-y-0 > :not(template) ~ :not(template){
  border-top-width: calc(0px * calc(1 - var(--divide-y-reverse))) !important;
  border-bottom-width: calc(0px * var(--divide-y-reverse)) !important;
}

.divide-x-0 > :not(template) ~ :not(template){
  --divide-x-reverse: 0 !important;
}

[dir=ltr] .divide-x-0 > :not(template) ~ :not(template){
  border-right-width: calc(0px * var(--divide-x-reverse)) !important;
  border-left-width: calc(0px * calc(1 - var(--divide-x-reverse))) !important;
}

[dir=rtl] .divide-x-0 > :not(template) ~ :not(template){
  border-left-width: calc(0px * var(--divide-x-reverse)) !important;
  border-right-width: calc(0px * calc(1 - var(--divide-x-reverse))) !important;
}

.divide-y-2 > :not(template) ~ :not(template){
  --divide-y-reverse: 0 !important;
}

[dir] .divide-y-2 > :not(template) ~ :not(template){
  border-top-width: calc(2px * calc(1 - var(--divide-y-reverse))) !important;
  border-bottom-width: calc(2px * var(--divide-y-reverse)) !important;
}

.divide-x-2 > :not(template) ~ :not(template){
  --divide-x-reverse: 0 !important;
}

[dir=ltr] .divide-x-2 > :not(template) ~ :not(template){
  border-right-width: calc(2px * var(--divide-x-reverse)) !important;
  border-left-width: calc(2px * calc(1 - var(--divide-x-reverse))) !important;
}

[dir=rtl] .divide-x-2 > :not(template) ~ :not(template){
  border-left-width: calc(2px * var(--divide-x-reverse)) !important;
  border-right-width: calc(2px * calc(1 - var(--divide-x-reverse))) !important;
}

.divide-y-4 > :not(template) ~ :not(template){
  --divide-y-reverse: 0 !important;
}

[dir] .divide-y-4 > :not(template) ~ :not(template){
  border-top-width: calc(4px * calc(1 - var(--divide-y-reverse))) !important;
  border-bottom-width: calc(4px * var(--divide-y-reverse)) !important;
}

.divide-x-4 > :not(template) ~ :not(template){
  --divide-x-reverse: 0 !important;
}

[dir=ltr] .divide-x-4 > :not(template) ~ :not(template){
  border-right-width: calc(4px * var(--divide-x-reverse)) !important;
  border-left-width: calc(4px * calc(1 - var(--divide-x-reverse))) !important;
}

[dir=rtl] .divide-x-4 > :not(template) ~ :not(template){
  border-left-width: calc(4px * var(--divide-x-reverse)) !important;
  border-right-width: calc(4px * calc(1 - var(--divide-x-reverse))) !important;
}

.divide-y-8 > :not(template) ~ :not(template){
  --divide-y-reverse: 0 !important;
}

[dir] .divide-y-8 > :not(template) ~ :not(template){
  border-top-width: calc(8px * calc(1 - var(--divide-y-reverse))) !important;
  border-bottom-width: calc(8px * var(--divide-y-reverse)) !important;
}

.divide-x-8 > :not(template) ~ :not(template){
  --divide-x-reverse: 0 !important;
}

[dir=ltr] .divide-x-8 > :not(template) ~ :not(template){
  border-right-width: calc(8px * var(--divide-x-reverse)) !important;
  border-left-width: calc(8px * calc(1 - var(--divide-x-reverse))) !important;
}

[dir=rtl] .divide-x-8 > :not(template) ~ :not(template){
  border-left-width: calc(8px * var(--divide-x-reverse)) !important;
  border-right-width: calc(8px * calc(1 - var(--divide-x-reverse))) !important;
}

.divide-y > :not(template) ~ :not(template){
  --divide-y-reverse: 0 !important;
}

[dir] .divide-y > :not(template) ~ :not(template){
  border-top-width: calc(1px * calc(1 - var(--divide-y-reverse))) !important;
  border-bottom-width: calc(1px * var(--divide-y-reverse)) !important;
}

.divide-x > :not(template) ~ :not(template){
  --divide-x-reverse: 0 !important;
}

[dir=ltr] .divide-x > :not(template) ~ :not(template){
  border-right-width: calc(1px * var(--divide-x-reverse)) !important;
  border-left-width: calc(1px * calc(1 - var(--divide-x-reverse))) !important;
}

[dir=rtl] .divide-x > :not(template) ~ :not(template){
  border-left-width: calc(1px * var(--divide-x-reverse)) !important;
  border-right-width: calc(1px * calc(1 - var(--divide-x-reverse))) !important;
}

.divide-y-reverse > :not(template) ~ :not(template){
  --divide-y-reverse: 1 !important;
}

.divide-x-reverse > :not(template) ~ :not(template){
  --divide-x-reverse: 1 !important;
}

[dir] .divide-transparent > :not(template) ~ :not(template){
  border-color: transparent !important;
}

.divide-black > :not(template) ~ :not(template){
  --divide-opacity: 1 !important;
}

[dir] .divide-black > :not(template) ~ :not(template){
  border-color: #22292f !important;
  border-color: rgba(34, 41, 47, var(--divide-opacity)) !important;
}

.divide-white > :not(template) ~ :not(template){
  --divide-opacity: 1 !important;
}

[dir] .divide-white > :not(template) ~ :not(template){
  border-color: #ffffff !important;
  border-color: rgba(255, 255, 255, var(--divide-opacity)) !important;
}

.divide-grey > :not(template) ~ :not(template){
  --divide-opacity: 1 !important;
}

[dir] .divide-grey > :not(template) ~ :not(template){
  border-color: #b8c2cc !important;
  border-color: rgba(184, 194, 204, var(--divide-opacity)) !important;
}

.divide-grey-light > :not(template) ~ :not(template){
  --divide-opacity: 1 !important;
}

[dir] .divide-grey-light > :not(template) ~ :not(template){
  border-color: #dae1e7 !important;
  border-color: rgba(218, 225, 231, var(--divide-opacity)) !important;
}

[dir] .divide-solid > :not(template) ~ :not(template){
  border-style: solid !important;
}

[dir] .divide-dashed > :not(template) ~ :not(template){
  border-style: dashed !important;
}

[dir] .divide-dotted > :not(template) ~ :not(template){
  border-style: dotted !important;
}

[dir] .divide-double > :not(template) ~ :not(template){
  border-style: double !important;
}

[dir] .divide-none > :not(template) ~ :not(template){
  border-style: none !important;
}

.divide-opacity-0 > :not(template) ~ :not(template){
  --divide-opacity: 0 !important;
}

.divide-opacity-25 > :not(template) ~ :not(template){
  --divide-opacity: 0.25 !important;
}

.divide-opacity-50 > :not(template) ~ :not(template){
  --divide-opacity: 0.5 !important;
}

.divide-opacity-75 > :not(template) ~ :not(template){
  --divide-opacity: 0.75 !important;
}

.divide-opacity-100 > :not(template) ~ :not(template){
  --divide-opacity: 1 !important;
}

.sr-only{
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
}

[dir] .sr-only{
  padding: 0 !important;
  margin: -1px !important;
  border-width: 0 !important;
}

.not-sr-only{
  position: static !important;
  width: auto !important;
  height: auto !important;
  overflow: visible !important;
  clip: auto !important;
  white-space: normal !important;
}

[dir] .not-sr-only{
  padding: 0 !important;
  margin: 0 !important;
}

.focus\\:sr-only:focus{
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
}

[dir] .focus\\:sr-only:focus{
  padding: 0 !important;
  margin: -1px !important;
  border-width: 0 !important;
}

.focus\\:not-sr-only:focus{
  position: static !important;
  width: auto !important;
  height: auto !important;
  overflow: visible !important;
  clip: auto !important;
  white-space: normal !important;
}

[dir] .focus\\:not-sr-only:focus{
  padding: 0 !important;
  margin: 0 !important;
}

.appearance-none{
  -webkit-appearance: none !important;
          appearance: none !important;
}

[dir] .bg-fixed{
  background-attachment: fixed !important;
}

[dir] .bg-local{
  background-attachment: local !important;
}

[dir] .bg-scroll{
  background-attachment: scroll !important;
}

[dir] .bg-clip-border{
  background-clip: border-box !important;
}

[dir] .bg-clip-padding{
  background-clip: padding-box !important;
}

[dir] .bg-clip-content{
  background-clip: content-box !important;
}

[dir] .bg-clip-text{
  -webkit-background-clip: text !important;
          background-clip: text !important;
}

[dir] .bg-transparent{
  background-color: transparent !important;
}

.bg-black{
  --bg-opacity: 1 !important;
}

[dir] .bg-black{
  background-color: #22292f !important;
  background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
}

.bg-white{
  --bg-opacity: 1 !important;
}

[dir] .bg-white{
  background-color: #ffffff !important;
  background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
}

.bg-grey{
  --bg-opacity: 1 !important;
}

[dir] .bg-grey{
  background-color: #b8c2cc !important;
  background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
}

.bg-grey-light{
  --bg-opacity: 1 !important;
}

[dir] .bg-grey-light{
  background-color: #dae1e7 !important;
  background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
}

[dir] .hover\\:bg-transparent:hover{
  background-color: transparent !important;
}

.hover\\:bg-black:hover{
  --bg-opacity: 1 !important;
}

[dir] .hover\\:bg-black:hover{
  background-color: #22292f !important;
  background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
}

.hover\\:bg-white:hover{
  --bg-opacity: 1 !important;
}

[dir] .hover\\:bg-white:hover{
  background-color: #ffffff !important;
  background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
}

.hover\\:bg-grey:hover{
  --bg-opacity: 1 !important;
}

[dir] .hover\\:bg-grey:hover{
  background-color: #b8c2cc !important;
  background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
}

.hover\\:bg-grey-light:hover{
  --bg-opacity: 1 !important;
}

[dir] .hover\\:bg-grey-light:hover{
  background-color: #dae1e7 !important;
  background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
}

[dir] .focus\\:bg-transparent:focus{
  background-color: transparent !important;
}

.focus\\:bg-black:focus{
  --bg-opacity: 1 !important;
}

[dir] .focus\\:bg-black:focus{
  background-color: #22292f !important;
  background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
}

.focus\\:bg-white:focus{
  --bg-opacity: 1 !important;
}

[dir] .focus\\:bg-white:focus{
  background-color: #ffffff !important;
  background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
}

.focus\\:bg-grey:focus{
  --bg-opacity: 1 !important;
}

[dir] .focus\\:bg-grey:focus{
  background-color: #b8c2cc !important;
  background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
}

.focus\\:bg-grey-light:focus{
  --bg-opacity: 1 !important;
}

[dir] .focus\\:bg-grey-light:focus{
  background-color: #dae1e7 !important;
  background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
}

[dir] .bg-none{
  background-image: none !important;
}

[dir] .bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--gradient-color-stops)) !important;
}

[dir=ltr] .bg-gradient-to-tr{
  background-image: linear-gradient(to top right, var(--gradient-color-stops)) !important;
}

[dir=rtl] .bg-gradient-to-tr{
  background-image: linear-gradient(to top left, var(--gradient-color-stops)) !important;
}

[dir=ltr] .bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--gradient-color-stops)) !important;
}

[dir=rtl] .bg-gradient-to-r{
  background-image: linear-gradient(to left, var(--gradient-color-stops)) !important;
}

[dir=ltr] .bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--gradient-color-stops)) !important;
}

[dir=rtl] .bg-gradient-to-br{
  background-image: linear-gradient(to bottom left, var(--gradient-color-stops)) !important;
}

[dir] .bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--gradient-color-stops)) !important;
}

[dir=ltr] .bg-gradient-to-bl{
  background-image: linear-gradient(to bottom left, var(--gradient-color-stops)) !important;
}

[dir=rtl] .bg-gradient-to-bl{
  background-image: linear-gradient(to bottom right, var(--gradient-color-stops)) !important;
}

[dir=ltr] .bg-gradient-to-l{
  background-image: linear-gradient(to left, var(--gradient-color-stops)) !important;
}

[dir=rtl] .bg-gradient-to-l{
  background-image: linear-gradient(to right, var(--gradient-color-stops)) !important;
}

[dir=ltr] .bg-gradient-to-tl{
  background-image: linear-gradient(to top left, var(--gradient-color-stops)) !important;
}

[dir=rtl] .bg-gradient-to-tl{
  background-image: linear-gradient(to top right, var(--gradient-color-stops)) !important;
}

.from-transparent{
  --gradient-from-color: transparent !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
}

.from-black{
  --gradient-from-color: #22292f !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
}

.from-white{
  --gradient-from-color: #ffffff !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
}

.from-grey{
  --gradient-from-color: #b8c2cc !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
}

.from-grey-light{
  --gradient-from-color: #dae1e7 !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
}

.via-transparent{
  --gradient-via-color: transparent !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
}

.via-black{
  --gradient-via-color: #22292f !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
}

.via-white{
  --gradient-via-color: #ffffff !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
}

.via-grey{
  --gradient-via-color: #b8c2cc !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
}

.via-grey-light{
  --gradient-via-color: #dae1e7 !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
}

.to-transparent{
  --gradient-to-color: transparent !important;
}

.to-black{
  --gradient-to-color: #22292f !important;
}

.to-white{
  --gradient-to-color: #ffffff !important;
}

.to-grey{
  --gradient-to-color: #b8c2cc !important;
}

.to-grey-light{
  --gradient-to-color: #dae1e7 !important;
}

.hover\\:from-transparent:hover{
  --gradient-from-color: transparent !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
}

.hover\\:from-black:hover{
  --gradient-from-color: #22292f !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
}

.hover\\:from-white:hover{
  --gradient-from-color: #ffffff !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
}

.hover\\:from-grey:hover{
  --gradient-from-color: #b8c2cc !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
}

.hover\\:from-grey-light:hover{
  --gradient-from-color: #dae1e7 !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
}

.hover\\:via-transparent:hover{
  --gradient-via-color: transparent !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
}

.hover\\:via-black:hover{
  --gradient-via-color: #22292f !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
}

.hover\\:via-white:hover{
  --gradient-via-color: #ffffff !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
}

.hover\\:via-grey:hover{
  --gradient-via-color: #b8c2cc !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
}

.hover\\:via-grey-light:hover{
  --gradient-via-color: #dae1e7 !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
}

.hover\\:to-transparent:hover{
  --gradient-to-color: transparent !important;
}

.hover\\:to-black:hover{
  --gradient-to-color: #22292f !important;
}

.hover\\:to-white:hover{
  --gradient-to-color: #ffffff !important;
}

.hover\\:to-grey:hover{
  --gradient-to-color: #b8c2cc !important;
}

.hover\\:to-grey-light:hover{
  --gradient-to-color: #dae1e7 !important;
}

.focus\\:from-transparent:focus{
  --gradient-from-color: transparent !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
}

.focus\\:from-black:focus{
  --gradient-from-color: #22292f !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
}

.focus\\:from-white:focus{
  --gradient-from-color: #ffffff !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
}

.focus\\:from-grey:focus{
  --gradient-from-color: #b8c2cc !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
}

.focus\\:from-grey-light:focus{
  --gradient-from-color: #dae1e7 !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
}

.focus\\:via-transparent:focus{
  --gradient-via-color: transparent !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
}

.focus\\:via-black:focus{
  --gradient-via-color: #22292f !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
}

.focus\\:via-white:focus{
  --gradient-via-color: #ffffff !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
}

.focus\\:via-grey:focus{
  --gradient-via-color: #b8c2cc !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
}

.focus\\:via-grey-light:focus{
  --gradient-via-color: #dae1e7 !important;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
}

.focus\\:to-transparent:focus{
  --gradient-to-color: transparent !important;
}

.focus\\:to-black:focus{
  --gradient-to-color: #22292f !important;
}

.focus\\:to-white:focus{
  --gradient-to-color: #ffffff !important;
}

.focus\\:to-grey:focus{
  --gradient-to-color: #b8c2cc !important;
}

.focus\\:to-grey-light:focus{
  --gradient-to-color: #dae1e7 !important;
}

.bg-opacity-0{
  --bg-opacity: 0 !important;
}

.bg-opacity-25{
  --bg-opacity: 0.25 !important;
}

.bg-opacity-50{
  --bg-opacity: 0.5 !important;
}

.bg-opacity-75{
  --bg-opacity: 0.75 !important;
}

.bg-opacity-100{
  --bg-opacity: 1 !important;
}

.hover\\:bg-opacity-0:hover{
  --bg-opacity: 0 !important;
}

.hover\\:bg-opacity-25:hover{
  --bg-opacity: 0.25 !important;
}

.hover\\:bg-opacity-50:hover{
  --bg-opacity: 0.5 !important;
}

.hover\\:bg-opacity-75:hover{
  --bg-opacity: 0.75 !important;
}

.hover\\:bg-opacity-100:hover{
  --bg-opacity: 1 !important;
}

.focus\\:bg-opacity-0:focus{
  --bg-opacity: 0 !important;
}

.focus\\:bg-opacity-25:focus{
  --bg-opacity: 0.25 !important;
}

.focus\\:bg-opacity-50:focus{
  --bg-opacity: 0.5 !important;
}

.focus\\:bg-opacity-75:focus{
  --bg-opacity: 0.75 !important;
}

.focus\\:bg-opacity-100:focus{
  --bg-opacity: 1 !important;
}

[dir] .bg-auto{
  background-size: auto !important;
}

[dir] .bg-cover{
  background-size: cover !important;
}

[dir] .bg-contain{
  background-size: contain !important;
}

.border-collapse{
  border-collapse: collapse !important;
}

.border-separate{
  border-collapse: separate !important;
}

[dir] .border-transparent{
  border-color: transparent !important;
}

.border-black{
  --border-opacity: 1 !important;
}

[dir] .border-black{
  border-color: #22292f !important;
  border-color: rgba(34, 41, 47, var(--border-opacity)) !important;
}

.border-white{
  --border-opacity: 1 !important;
}

[dir] .border-white{
  border-color: #ffffff !important;
  border-color: rgba(255, 255, 255, var(--border-opacity)) !important;
}

.border-grey{
  --border-opacity: 1 !important;
}

[dir] .border-grey{
  border-color: #b8c2cc !important;
  border-color: rgba(184, 194, 204, var(--border-opacity)) !important;
}

.border-grey-light{
  --border-opacity: 1 !important;
}

[dir] .border-grey-light{
  border-color: #dae1e7 !important;
  border-color: rgba(218, 225, 231, var(--border-opacity)) !important;
}

[dir] .hover\\:border-transparent:hover{
  border-color: transparent !important;
}

.hover\\:border-black:hover{
  --border-opacity: 1 !important;
}

[dir] .hover\\:border-black:hover{
  border-color: #22292f !important;
  border-color: rgba(34, 41, 47, var(--border-opacity)) !important;
}

.hover\\:border-white:hover{
  --border-opacity: 1 !important;
}

[dir] .hover\\:border-white:hover{
  border-color: #ffffff !important;
  border-color: rgba(255, 255, 255, var(--border-opacity)) !important;
}

.hover\\:border-grey:hover{
  --border-opacity: 1 !important;
}

[dir] .hover\\:border-grey:hover{
  border-color: #b8c2cc !important;
  border-color: rgba(184, 194, 204, var(--border-opacity)) !important;
}

.hover\\:border-grey-light:hover{
  --border-opacity: 1 !important;
}

[dir] .hover\\:border-grey-light:hover{
  border-color: #dae1e7 !important;
  border-color: rgba(218, 225, 231, var(--border-opacity)) !important;
}

.border-opacity-0{
  --border-opacity: 0 !important;
}

.border-opacity-25{
  --border-opacity: 0.25 !important;
}

.border-opacity-50{
  --border-opacity: 0.5 !important;
}

.border-opacity-75{
  --border-opacity: 0.75 !important;
}

.border-opacity-100{
  --border-opacity: 1 !important;
}

.hover\\:border-opacity-0:hover{
  --border-opacity: 0 !important;
}

.hover\\:border-opacity-25:hover{
  --border-opacity: 0.25 !important;
}

.hover\\:border-opacity-50:hover{
  --border-opacity: 0.5 !important;
}

.hover\\:border-opacity-75:hover{
  --border-opacity: 0.75 !important;
}

.hover\\:border-opacity-100:hover{
  --border-opacity: 1 !important;
}

.focus\\:border-opacity-0:focus{
  --border-opacity: 0 !important;
}

.focus\\:border-opacity-25:focus{
  --border-opacity: 0.25 !important;
}

.focus\\:border-opacity-50:focus{
  --border-opacity: 0.5 !important;
}

.focus\\:border-opacity-75:focus{
  --border-opacity: 0.75 !important;
}

.focus\\:border-opacity-100:focus{
  --border-opacity: 1 !important;
}

[dir] .rounded-none{
  border-radius: 0 !important;
}

[dir] .rounded-sm{
  border-radius: .125rem !important;
}

[dir] .rounded{
  border-radius: .25rem !important;
}

[dir] .rounded-lg{
  border-radius: .5rem !important;
}

[dir] .rounded-full{
  border-radius: 9999px !important;
}

[dir=ltr] .rounded-t-none{
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

[dir=rtl] .rounded-t-none{
  border-top-right-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

[dir=ltr] .rounded-r-none{
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

[dir=rtl] .rounded-r-none{
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

[dir=ltr] .rounded-b-none{
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

[dir=rtl] .rounded-b-none{
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

[dir=ltr] .rounded-l-none{
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

[dir=rtl] .rounded-l-none{
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

[dir=ltr] .rounded-t-sm{
  border-top-left-radius: .125rem !important;
  border-top-right-radius: .125rem !important;
}

[dir=rtl] .rounded-t-sm{
  border-top-right-radius: .125rem !important;
  border-top-left-radius: .125rem !important;
}

[dir=ltr] .rounded-r-sm{
  border-top-right-radius: .125rem !important;
  border-bottom-right-radius: .125rem !important;
}

[dir=rtl] .rounded-r-sm{
  border-top-left-radius: .125rem !important;
  border-bottom-left-radius: .125rem !important;
}

[dir=ltr] .rounded-b-sm{
  border-bottom-right-radius: .125rem !important;
  border-bottom-left-radius: .125rem !important;
}

[dir=rtl] .rounded-b-sm{
  border-bottom-left-radius: .125rem !important;
  border-bottom-right-radius: .125rem !important;
}

[dir=ltr] .rounded-l-sm{
  border-top-left-radius: .125rem !important;
  border-bottom-left-radius: .125rem !important;
}

[dir=rtl] .rounded-l-sm{
  border-top-right-radius: .125rem !important;
  border-bottom-right-radius: .125rem !important;
}

[dir=ltr] .rounded-t{
  border-top-left-radius: .25rem !important;
  border-top-right-radius: .25rem !important;
}

[dir=rtl] .rounded-t{
  border-top-right-radius: .25rem !important;
  border-top-left-radius: .25rem !important;
}

[dir=ltr] .rounded-r{
  border-top-right-radius: .25rem !important;
  border-bottom-right-radius: .25rem !important;
}

[dir=rtl] .rounded-r{
  border-top-left-radius: .25rem !important;
  border-bottom-left-radius: .25rem !important;
}

[dir=ltr] .rounded-b{
  border-bottom-right-radius: .25rem !important;
  border-bottom-left-radius: .25rem !important;
}

[dir=rtl] .rounded-b{
  border-bottom-left-radius: .25rem !important;
  border-bottom-right-radius: .25rem !important;
}

[dir=ltr] .rounded-l{
  border-top-left-radius: .25rem !important;
  border-bottom-left-radius: .25rem !important;
}

[dir=rtl] .rounded-l{
  border-top-right-radius: .25rem !important;
  border-bottom-right-radius: .25rem !important;
}

[dir=ltr] .rounded-t-lg{
  border-top-left-radius: .5rem !important;
  border-top-right-radius: .5rem !important;
}

[dir=rtl] .rounded-t-lg{
  border-top-right-radius: .5rem !important;
  border-top-left-radius: .5rem !important;
}

[dir=ltr] .rounded-r-lg{
  border-top-right-radius: .5rem !important;
  border-bottom-right-radius: .5rem !important;
}

[dir=rtl] .rounded-r-lg{
  border-top-left-radius: .5rem !important;
  border-bottom-left-radius: .5rem !important;
}

[dir=ltr] .rounded-b-lg{
  border-bottom-right-radius: .5rem !important;
  border-bottom-left-radius: .5rem !important;
}

[dir=rtl] .rounded-b-lg{
  border-bottom-left-radius: .5rem !important;
  border-bottom-right-radius: .5rem !important;
}

[dir=ltr] .rounded-l-lg{
  border-top-left-radius: .5rem !important;
  border-bottom-left-radius: .5rem !important;
}

[dir=rtl] .rounded-l-lg{
  border-top-right-radius: .5rem !important;
  border-bottom-right-radius: .5rem !important;
}

[dir=ltr] .rounded-t-full{
  border-top-left-radius: 9999px !important;
  border-top-right-radius: 9999px !important;
}

[dir=rtl] .rounded-t-full{
  border-top-right-radius: 9999px !important;
  border-top-left-radius: 9999px !important;
}

[dir=ltr] .rounded-r-full{
  border-top-right-radius: 9999px !important;
  border-bottom-right-radius: 9999px !important;
}

[dir=rtl] .rounded-r-full{
  border-top-left-radius: 9999px !important;
  border-bottom-left-radius: 9999px !important;
}

[dir=ltr] .rounded-b-full{
  border-bottom-right-radius: 9999px !important;
  border-bottom-left-radius: 9999px !important;
}

[dir=rtl] .rounded-b-full{
  border-bottom-left-radius: 9999px !important;
  border-bottom-right-radius: 9999px !important;
}

[dir=ltr] .rounded-l-full{
  border-top-left-radius: 9999px !important;
  border-bottom-left-radius: 9999px !important;
}

[dir=rtl] .rounded-l-full{
  border-top-right-radius: 9999px !important;
  border-bottom-right-radius: 9999px !important;
}

[dir=ltr] .rounded-tl-none{
  border-top-left-radius: 0 !important;
}

[dir=rtl] .rounded-tl-none{
  border-top-right-radius: 0 !important;
}

[dir=ltr] .rounded-tr-none{
  border-top-right-radius: 0 !important;
}

[dir=rtl] .rounded-tr-none{
  border-top-left-radius: 0 !important;
}

[dir=ltr] .rounded-br-none{
  border-bottom-right-radius: 0 !important;
}

[dir=rtl] .rounded-br-none{
  border-bottom-left-radius: 0 !important;
}

[dir=ltr] .rounded-bl-none{
  border-bottom-left-radius: 0 !important;
}

[dir=rtl] .rounded-bl-none{
  border-bottom-right-radius: 0 !important;
}

[dir=ltr] .rounded-tl-sm{
  border-top-left-radius: .125rem !important;
}

[dir=rtl] .rounded-tl-sm{
  border-top-right-radius: .125rem !important;
}

[dir=ltr] .rounded-tr-sm{
  border-top-right-radius: .125rem !important;
}

[dir=rtl] .rounded-tr-sm{
  border-top-left-radius: .125rem !important;
}

[dir=ltr] .rounded-br-sm{
  border-bottom-right-radius: .125rem !important;
}

[dir=rtl] .rounded-br-sm{
  border-bottom-left-radius: .125rem !important;
}

[dir=ltr] .rounded-bl-sm{
  border-bottom-left-radius: .125rem !important;
}

[dir=rtl] .rounded-bl-sm{
  border-bottom-right-radius: .125rem !important;
}

[dir=ltr] .rounded-tl{
  border-top-left-radius: .25rem !important;
}

[dir=rtl] .rounded-tl{
  border-top-right-radius: .25rem !important;
}

[dir=ltr] .rounded-tr{
  border-top-right-radius: .25rem !important;
}

[dir=rtl] .rounded-tr{
  border-top-left-radius: .25rem !important;
}

[dir=ltr] .rounded-br{
  border-bottom-right-radius: .25rem !important;
}

[dir=rtl] .rounded-br{
  border-bottom-left-radius: .25rem !important;
}

[dir=ltr] .rounded-bl{
  border-bottom-left-radius: .25rem !important;
}

[dir=rtl] .rounded-bl{
  border-bottom-right-radius: .25rem !important;
}

[dir=ltr] .rounded-tl-lg{
  border-top-left-radius: .5rem !important;
}

[dir=rtl] .rounded-tl-lg{
  border-top-right-radius: .5rem !important;
}

[dir=ltr] .rounded-tr-lg{
  border-top-right-radius: .5rem !important;
}

[dir=rtl] .rounded-tr-lg{
  border-top-left-radius: .5rem !important;
}

[dir=ltr] .rounded-br-lg{
  border-bottom-right-radius: .5rem !important;
}

[dir=rtl] .rounded-br-lg{
  border-bottom-left-radius: .5rem !important;
}

[dir=ltr] .rounded-bl-lg{
  border-bottom-left-radius: .5rem !important;
}

[dir=rtl] .rounded-bl-lg{
  border-bottom-right-radius: .5rem !important;
}

[dir=ltr] .rounded-tl-full{
  border-top-left-radius: 9999px !important;
}

[dir=rtl] .rounded-tl-full{
  border-top-right-radius: 9999px !important;
}

[dir=ltr] .rounded-tr-full{
  border-top-right-radius: 9999px !important;
}

[dir=rtl] .rounded-tr-full{
  border-top-left-radius: 9999px !important;
}

[dir=ltr] .rounded-br-full{
  border-bottom-right-radius: 9999px !important;
}

[dir=rtl] .rounded-br-full{
  border-bottom-left-radius: 9999px !important;
}

[dir=ltr] .rounded-bl-full{
  border-bottom-left-radius: 9999px !important;
}

[dir=rtl] .rounded-bl-full{
  border-bottom-right-radius: 9999px !important;
}

[dir] .border-solid{
  border-style: solid !important;
}

[dir] .border-dashed{
  border-style: dashed !important;
}

[dir] .border-dotted{
  border-style: dotted !important;
}

[dir] .border-double{
  border-style: double !important;
}

[dir] .border-none{
  border-style: none !important;
}

[dir] .border-0{
  border-width: 0 !important;
}

[dir] .border-2{
  border-width: 2px !important;
}

[dir] .border-4{
  border-width: 4px !important;
}

[dir] .border-8{
  border-width: 8px !important;
}

[dir] .border{
  border-width: 1px !important;
}

[dir] .border-t-0{
  border-top-width: 0 !important;
}

[dir=ltr] .border-r-0{
  border-right-width: 0 !important;
}

[dir=rtl] .border-r-0{
  border-left-width: 0 !important;
}

[dir] .border-b-0{
  border-bottom-width: 0 !important;
}

[dir=ltr] .border-l-0{
  border-left-width: 0 !important;
}

[dir=rtl] .border-l-0{
  border-right-width: 0 !important;
}

[dir] .border-t-2{
  border-top-width: 2px !important;
}

[dir=ltr] .border-r-2{
  border-right-width: 2px !important;
}

[dir=rtl] .border-r-2{
  border-left-width: 2px !important;
}

[dir] .border-b-2{
  border-bottom-width: 2px !important;
}

[dir=ltr] .border-l-2{
  border-left-width: 2px !important;
}

[dir=rtl] .border-l-2{
  border-right-width: 2px !important;
}

[dir] .border-t-4{
  border-top-width: 4px !important;
}

[dir=ltr] .border-r-4{
  border-right-width: 4px !important;
}

[dir=rtl] .border-r-4{
  border-left-width: 4px !important;
}

[dir] .border-b-4{
  border-bottom-width: 4px !important;
}

[dir=ltr] .border-l-4{
  border-left-width: 4px !important;
}

[dir=rtl] .border-l-4{
  border-right-width: 4px !important;
}

[dir] .border-t-8{
  border-top-width: 8px !important;
}

[dir=ltr] .border-r-8{
  border-right-width: 8px !important;
}

[dir=rtl] .border-r-8{
  border-left-width: 8px !important;
}

[dir] .border-b-8{
  border-bottom-width: 8px !important;
}

[dir=ltr] .border-l-8{
  border-left-width: 8px !important;
}

[dir=rtl] .border-l-8{
  border-right-width: 8px !important;
}

[dir] .border-t{
  border-top-width: 1px !important;
}

[dir=ltr] .border-r{
  border-right-width: 1px !important;
}

[dir=rtl] .border-r{
  border-left-width: 1px !important;
}

[dir] .border-b{
  border-bottom-width: 1px !important;
}

[dir=ltr] .border-l{
  border-left-width: 1px !important;
}

[dir=rtl] .border-l{
  border-right-width: 1px !important;
}

.box-border{
  box-sizing: border-box !important;
}

.box-content{
  box-sizing: content-box !important;
}

[dir] .cursor-auto{
  cursor: auto !important;
}

[dir] .cursor-default{
  cursor: default !important;
}

[dir] .cursor-pointer{
  cursor: pointer !important;
}

[dir] .cursor-wait{
  cursor: wait !important;
}

[dir] .cursor-text{
  cursor: text !important;
}

[dir] .cursor-move{
  cursor: move !important;
}

[dir] .cursor-not-allowed{
  cursor: not-allowed !important;
}

.block{
  display: block !important;
}

.inline-block{
  display: inline-block !important;
}

.inline{
  display: inline !important;
}

.flex{
  display: flex !important;
}

.inline-flex{
  display: inline-flex !important;
}

.table{
  display: table !important;
}

.table-caption{
  display: table-caption !important;
}

.table-cell{
  display: table-cell !important;
}

.table-column{
  display: table-column !important;
}

.table-column-group{
  display: table-column-group !important;
}

.table-footer-group{
  display: table-footer-group !important;
}

.table-header-group{
  display: table-header-group !important;
}

.table-row-group{
  display: table-row-group !important;
}

.table-row{
  display: table-row !important;
}

.flow-root{
  display: flow-root !important;
}

.grid{
  display: grid !important;
}

.inline-grid{
  display: inline-grid !important;
}

.contents{
  display: contents !important;
}

.hidden{
  display: none !important;
}

.flex-row{
  flex-direction: row !important;
}

.flex-row-reverse{
  flex-direction: row-reverse !important;
}

.flex-col{
  flex-direction: column !important;
}

.flex-col-reverse{
  flex-direction: column-reverse !important;
}

.flex-wrap{
  flex-wrap: wrap !important;
}

.flex-wrap-reverse{
  flex-wrap: wrap-reverse !important;
}

.flex-no-wrap{
  flex-wrap: nowrap !important;
}

.place-items-auto{
  place-items: auto !important;
}

.place-items-start{
  place-items: start !important;
}

.place-items-end{
  place-items: end !important;
}

.place-items-center{
  place-items: center !important;
}

.place-items-stretch{
  place-items: stretch !important;
}

.place-content-center{
  place-content: center !important;
}

.place-content-start{
  place-content: start !important;
}

.place-content-end{
  place-content: end !important;
}

.place-content-between{
  place-content: space-between !important;
}

.place-content-around{
  place-content: space-around !important;
}

.place-content-evenly{
  place-content: space-evenly !important;
}

.place-content-stretch{
  place-content: stretch !important;
}

.place-self-auto{
  place-self: auto !important;
}

.place-self-start{
  place-self: start !important;
}

.place-self-end{
  place-self: end !important;
}

.place-self-center{
  place-self: center !important;
}

.place-self-stretch{
  place-self: stretch !important;
}

.items-start{
  align-items: flex-start !important;
}

.items-end{
  align-items: flex-end !important;
}

.items-center{
  align-items: center !important;
}

.items-baseline{
  align-items: baseline !important;
}

.items-stretch{
  align-items: stretch !important;
}

.content-center{
  align-content: center !important;
}

.content-start{
  align-content: flex-start !important;
}

.content-end{
  align-content: flex-end !important;
}

.content-between{
  align-content: space-between !important;
}

.content-around{
  align-content: space-around !important;
}

.content-evenly{
  align-content: space-evenly !important;
}

.self-auto{
  align-self: auto !important;
}

.self-start{
  align-self: flex-start !important;
}

.self-end{
  align-self: flex-end !important;
}

.self-center{
  align-self: center !important;
}

.self-stretch{
  align-self: stretch !important;
}

.justify-items-auto{
  justify-items: auto !important;
}

.justify-items-start{
  justify-items: start !important;
}

.justify-items-end{
  justify-items: end !important;
}

.justify-items-center{
  justify-items: center !important;
}

.justify-items-stretch{
  justify-items: stretch !important;
}

.justify-start{
  justify-content: flex-start !important;
}

.justify-end{
  justify-content: flex-end !important;
}

.justify-center{
  justify-content: center !important;
}

.justify-between{
  justify-content: space-between !important;
}

.justify-around{
  justify-content: space-around !important;
}

.justify-evenly{
  justify-content: space-evenly !important;
}

.justify-self-auto{
  justify-self: auto !important;
}

.justify-self-start{
  justify-self: start !important;
}

.justify-self-end{
  justify-self: end !important;
}

.justify-self-center{
  justify-self: center !important;
}

.justify-self-stretch{
  justify-self: stretch !important;
}

.flex-1{
  flex: 1 1 0% !important;
}

.flex-auto{
  flex: 1 1 auto !important;
}

.flex-initial{
  flex: 0 1 auto !important;
}

.flex-none{
  flex: none !important;
}

.flex-grow-0{
  flex-grow: 0 !important;
}

.flex-grow{
  flex-grow: 1 !important;
}

.flex-shrink-0{
  flex-shrink: 0 !important;
}

.flex-shrink{
  flex-shrink: 1 !important;
}

.order-1{
  order: 1 !important;
}

.order-2{
  order: 2 !important;
}

.order-3{
  order: 3 !important;
}

.order-4{
  order: 4 !important;
}

.order-5{
  order: 5 !important;
}

.order-6{
  order: 6 !important;
}

.order-first{
  order: -1 !important;
}

.order-last{
  order: 999 !important;
}

.order-normal{
  order: 0 !important;
}

.hover\\:order-1:hover{
  order: 1 !important;
}

.hover\\:order-2:hover{
  order: 2 !important;
}

.hover\\:order-3:hover{
  order: 3 !important;
}

.hover\\:order-4:hover{
  order: 4 !important;
}

.hover\\:order-5:hover{
  order: 5 !important;
}

.hover\\:order-6:hover{
  order: 6 !important;
}

.hover\\:order-first:hover{
  order: -1 !important;
}

.hover\\:order-last:hover{
  order: 999 !important;
}

.hover\\:order-normal:hover{
  order: 0 !important;
}

.focus\\:order-1:focus{
  order: 1 !important;
}

.focus\\:order-2:focus{
  order: 2 !important;
}

.focus\\:order-3:focus{
  order: 3 !important;
}

.focus\\:order-4:focus{
  order: 4 !important;
}

.focus\\:order-5:focus{
  order: 5 !important;
}

.focus\\:order-6:focus{
  order: 6 !important;
}

.focus\\:order-first:focus{
  order: -1 !important;
}

.focus\\:order-last:focus{
  order: 999 !important;
}

.focus\\:order-normal:focus{
  order: 0 !important;
}

[dir=ltr] .float-right{
  float: right !important;
}

[dir=rtl] .float-right{
  float: left !important;
}

[dir=ltr] .float-left{
  float: left !important;
}

[dir=rtl] .float-left{
  float: right !important;
}

[dir] .float-none{
  float: none !important;
}

.clearfix:after{
  content: "" !important;
  display: table !important;
}

[dir] .clearfix:after{
  clear: both !important;
}

[dir=ltr] .clear-left{
  clear: left !important;
}

[dir=rtl] .clear-left{
  clear: right !important;
}

[dir=ltr] .clear-right{
  clear: right !important;
}

[dir=rtl] .clear-right{
  clear: left !important;
}

[dir] .clear-both{
  clear: both !important;
}

[dir] .clear-none{
  clear: none !important;
}

.font-light{
  font-weight: 300 !important;
}

.font-normal{
  font-weight: 400 !important;
}

.font-medium{
  font-weight: 500 !important;
}

.font-semibold{
  font-weight: 600 !important;
}

.font-bold{
  font-weight: 700 !important;
}

.font-extrabold{
  font-weight: 800 !important;
}

.font-black{
  font-weight: 900 !important;
}

.hover\\:font-light:hover{
  font-weight: 300 !important;
}

.hover\\:font-normal:hover{
  font-weight: 400 !important;
}

.hover\\:font-medium:hover{
  font-weight: 500 !important;
}

.hover\\:font-semibold:hover{
  font-weight: 600 !important;
}

.hover\\:font-bold:hover{
  font-weight: 700 !important;
}

.hover\\:font-extrabold:hover{
  font-weight: 800 !important;
}

.hover\\:font-black:hover{
  font-weight: 900 !important;
}

.h-1{
  height: 0.25rem !important;
}

.h-2{
  height: 0.5rem !important;
}

.h-3{
  height: 0.75rem !important;
}

.h-4{
  height: 1rem !important;
}

.h-5{
  height: 1.25rem !important;
}

.h-6{
  height: 1.5rem !important;
}

.h-8{
  height: 2rem !important;
}

.h-10{
  height: 2.5rem !important;
}

.h-12{
  height: 3rem !important;
}

.h-16{
  height: 4rem !important;
}

.h-24{
  height: 6rem !important;
}

.h-32{
  height: 8rem !important;
}

.h-48{
  height: 12rem !important;
}

.h-64{
  height: 16rem !important;
}

.h-auto{
  height: auto !important;
}

.h-px{
  height: 1px !important;
}

.h-full{
  height: 100% !important;
}

.h-screen{
  height: 100vh !important;
}

.text-xs{
  font-size: .75rem !important;
}

.text-sm{
  font-size: .875rem !important;
}

.text-base{
  font-size: 1rem !important;
}

.text-lg{
  font-size: 1.125rem !important;
}

.text-xl{
  font-size: 1.25rem !important;
}

.text-2xl{
  font-size: 1.5rem !important;
}

.text-3xl{
  font-size: 1.875rem !important;
}

.text-4xl{
  font-size: 2.25rem !important;
}

.text-5xl{
  font-size: 3rem !important;
}

.text-6xl{
  font-size: 4rem !important;
}

.leading-none{
  line-height: 1 !important;
}

.leading-tight{
  line-height: 1.25 !important;
}

.leading-normal{
  line-height: 1.5 !important;
}

.leading-loose{
  line-height: 2 !important;
}

.list-inside{
  list-style-position: inside !important;
}

.list-outside{
  list-style-position: outside !important;
}

[dir] .m-0{
  margin: 0 !important;
}

[dir] .m-1{
  margin: 0.25rem !important;
}

[dir] .m-2{
  margin: 0.5rem !important;
}

[dir] .m-3{
  margin: 0.75rem !important;
}

[dir] .m-4{
  margin: 1rem !important;
}

[dir] .m-5{
  margin: 1.25rem !important;
}

[dir] .m-6{
  margin: 1.5rem !important;
}

[dir] .m-8{
  margin: 2rem !important;
}

[dir] .m-10{
  margin: 2.5rem !important;
}

[dir] .m-12{
  margin: 3rem !important;
}

[dir] .m-16{
  margin: 4rem !important;
}

[dir] .m-20{
  margin: 5rem !important;
}

[dir] .m-24{
  margin: 6rem !important;
}

[dir] .m-32{
  margin: 8rem !important;
}

[dir] .m-auto{
  margin: auto !important;
}

[dir] .m-px{
  margin: 1px !important;
}

[dir] .m-base{
  margin: 2.2rem !important;
}

[dir] .-m-px{
  margin: -1px !important;
}

[dir] .-m-1{
  margin: -0.25rem !important;
}

[dir] .-m-2{
  margin: -0.5rem !important;
}

[dir] .-m-3{
  margin: -0.75rem !important;
}

[dir] .-m-4{
  margin: -1rem !important;
}

[dir] .my-0{
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

[dir=ltr] .mx-0{
  margin-left: 0 !important;
  margin-right: 0 !important;
}

[dir=rtl] .mx-0{
  margin-right: 0 !important;
  margin-left: 0 !important;
}

[dir] .my-1{
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

[dir=ltr] .mx-1{
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}

[dir=rtl] .mx-1{
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

[dir] .my-2{
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

[dir=ltr] .mx-2{
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
}

[dir=rtl] .mx-2{
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

[dir] .my-3{
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

[dir=ltr] .mx-3{
  margin-left: 0.75rem !important;
  margin-right: 0.75rem !important;
}

[dir=rtl] .mx-3{
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
}

[dir] .my-4{
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

[dir=ltr] .mx-4{
  margin-left: 1rem !important;
  margin-right: 1rem !important;
}

[dir=rtl] .mx-4{
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

[dir] .my-5{
  margin-top: 1.25rem !important;
  margin-bottom: 1.25rem !important;
}

[dir=ltr] .mx-5{
  margin-left: 1.25rem !important;
  margin-right: 1.25rem !important;
}

[dir=rtl] .mx-5{
  margin-right: 1.25rem !important;
  margin-left: 1.25rem !important;
}

[dir] .my-6{
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

[dir=ltr] .mx-6{
  margin-left: 1.5rem !important;
  margin-right: 1.5rem !important;
}

[dir=rtl] .mx-6{
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

[dir] .my-8{
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}

[dir=ltr] .mx-8{
  margin-left: 2rem !important;
  margin-right: 2rem !important;
}

[dir=rtl] .mx-8{
  margin-right: 2rem !important;
  margin-left: 2rem !important;
}

[dir] .my-10{
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}

[dir=ltr] .mx-10{
  margin-left: 2.5rem !important;
  margin-right: 2.5rem !important;
}

[dir=rtl] .mx-10{
  margin-right: 2.5rem !important;
  margin-left: 2.5rem !important;
}

[dir] .my-12{
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

[dir=ltr] .mx-12{
  margin-left: 3rem !important;
  margin-right: 3rem !important;
}

[dir=rtl] .mx-12{
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

[dir] .my-16{
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

[dir=ltr] .mx-16{
  margin-left: 4rem !important;
  margin-right: 4rem !important;
}

[dir=rtl] .mx-16{
  margin-right: 4rem !important;
  margin-left: 4rem !important;
}

[dir] .my-20{
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

[dir=ltr] .mx-20{
  margin-left: 5rem !important;
  margin-right: 5rem !important;
}

[dir=rtl] .mx-20{
  margin-right: 5rem !important;
  margin-left: 5rem !important;
}

[dir] .my-24{
  margin-top: 6rem !important;
  margin-bottom: 6rem !important;
}

[dir=ltr] .mx-24{
  margin-left: 6rem !important;
  margin-right: 6rem !important;
}

[dir=rtl] .mx-24{
  margin-right: 6rem !important;
  margin-left: 6rem !important;
}

[dir] .my-32{
  margin-top: 8rem !important;
  margin-bottom: 8rem !important;
}

[dir=ltr] .mx-32{
  margin-left: 8rem !important;
  margin-right: 8rem !important;
}

[dir=rtl] .mx-32{
  margin-right: 8rem !important;
  margin-left: 8rem !important;
}

[dir] .my-auto{
  margin-top: auto !important;
  margin-bottom: auto !important;
}

[dir=ltr] .mx-auto{
  margin-left: auto !important;
  margin-right: auto !important;
}

[dir=rtl] .mx-auto{
  margin-right: auto !important;
  margin-left: auto !important;
}

[dir] .my-px{
  margin-top: 1px !important;
  margin-bottom: 1px !important;
}

[dir=ltr] .mx-px{
  margin-left: 1px !important;
  margin-right: 1px !important;
}

[dir=rtl] .mx-px{
  margin-right: 1px !important;
  margin-left: 1px !important;
}

[dir] .my-base{
  margin-top: 2.2rem !important;
  margin-bottom: 2.2rem !important;
}

[dir=ltr] .mx-base{
  margin-left: 2.2rem !important;
  margin-right: 2.2rem !important;
}

[dir=rtl] .mx-base{
  margin-right: 2.2rem !important;
  margin-left: 2.2rem !important;
}

[dir] .-my-px{
  margin-top: -1px !important;
  margin-bottom: -1px !important;
}

[dir=ltr] .-mx-px{
  margin-left: -1px !important;
  margin-right: -1px !important;
}

[dir=rtl] .-mx-px{
  margin-right: -1px !important;
  margin-left: -1px !important;
}

[dir] .-my-1{
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

[dir=ltr] .-mx-1{
  margin-left: -0.25rem !important;
  margin-right: -0.25rem !important;
}

[dir=rtl] .-mx-1{
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

[dir] .-my-2{
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

[dir=ltr] .-mx-2{
  margin-left: -0.5rem !important;
  margin-right: -0.5rem !important;
}

[dir=rtl] .-mx-2{
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

[dir] .-my-3{
  margin-top: -0.75rem !important;
  margin-bottom: -0.75rem !important;
}

[dir=ltr] .-mx-3{
  margin-left: -0.75rem !important;
  margin-right: -0.75rem !important;
}

[dir=rtl] .-mx-3{
  margin-right: -0.75rem !important;
  margin-left: -0.75rem !important;
}

[dir] .-my-4{
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

[dir=ltr] .-mx-4{
  margin-left: -1rem !important;
  margin-right: -1rem !important;
}

[dir=rtl] .-mx-4{
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

[dir] .mt-0{
  margin-top: 0 !important;
}

[dir=ltr] .mr-0{
  margin-right: 0 !important;
}

[dir=rtl] .mr-0{
  margin-left: 0 !important;
}

[dir] .mb-0{
  margin-bottom: 0 !important;
}

[dir=ltr] .ml-0{
  margin-left: 0 !important;
}

[dir=rtl] .ml-0{
  margin-right: 0 !important;
}

[dir] .mt-1{
  margin-top: 0.25rem !important;
}

[dir=ltr] .mr-1{
  margin-right: 0.25rem !important;
}

[dir=rtl] .mr-1{
  margin-left: 0.25rem !important;
}

[dir] .mb-1{
  margin-bottom: 0.25rem !important;
}

[dir=ltr] .ml-1{
  margin-left: 0.25rem !important;
}

[dir=rtl] .ml-1{
  margin-right: 0.25rem !important;
}

[dir] .mt-2{
  margin-top: 0.5rem !important;
}

[dir=ltr] .mr-2{
  margin-right: 0.5rem !important;
}

[dir=rtl] .mr-2{
  margin-left: 0.5rem !important;
}

[dir] .mb-2{
  margin-bottom: 0.5rem !important;
}

[dir=ltr] .ml-2{
  margin-left: 0.5rem !important;
}

[dir=rtl] .ml-2{
  margin-right: 0.5rem !important;
}

[dir] .mt-3{
  margin-top: 0.75rem !important;
}

[dir=ltr] .mr-3{
  margin-right: 0.75rem !important;
}

[dir=rtl] .mr-3{
  margin-left: 0.75rem !important;
}

[dir] .mb-3{
  margin-bottom: 0.75rem !important;
}

[dir=ltr] .ml-3{
  margin-left: 0.75rem !important;
}

[dir=rtl] .ml-3{
  margin-right: 0.75rem !important;
}

[dir] .mt-4{
  margin-top: 1rem !important;
}

[dir=ltr] .mr-4{
  margin-right: 1rem !important;
}

[dir=rtl] .mr-4{
  margin-left: 1rem !important;
}

[dir] .mb-4{
  margin-bottom: 1rem !important;
}

[dir=ltr] .ml-4{
  margin-left: 1rem !important;
}

[dir=rtl] .ml-4{
  margin-right: 1rem !important;
}

[dir] .mt-5{
  margin-top: 1.25rem !important;
}

[dir=ltr] .mr-5{
  margin-right: 1.25rem !important;
}

[dir=rtl] .mr-5{
  margin-left: 1.25rem !important;
}

[dir] .mb-5{
  margin-bottom: 1.25rem !important;
}

[dir=ltr] .ml-5{
  margin-left: 1.25rem !important;
}

[dir=rtl] .ml-5{
  margin-right: 1.25rem !important;
}

[dir] .mt-6{
  margin-top: 1.5rem !important;
}

[dir=ltr] .mr-6{
  margin-right: 1.5rem !important;
}

[dir=rtl] .mr-6{
  margin-left: 1.5rem !important;
}

[dir] .mb-6{
  margin-bottom: 1.5rem !important;
}

[dir=ltr] .ml-6{
  margin-left: 1.5rem !important;
}

[dir=rtl] .ml-6{
  margin-right: 1.5rem !important;
}

[dir] .mt-8{
  margin-top: 2rem !important;
}

[dir=ltr] .mr-8{
  margin-right: 2rem !important;
}

[dir=rtl] .mr-8{
  margin-left: 2rem !important;
}

[dir] .mb-8{
  margin-bottom: 2rem !important;
}

[dir=ltr] .ml-8{
  margin-left: 2rem !important;
}

[dir=rtl] .ml-8{
  margin-right: 2rem !important;
}

[dir] .mt-10{
  margin-top: 2.5rem !important;
}

[dir=ltr] .mr-10{
  margin-right: 2.5rem !important;
}

[dir=rtl] .mr-10{
  margin-left: 2.5rem !important;
}

[dir] .mb-10{
  margin-bottom: 2.5rem !important;
}

[dir=ltr] .ml-10{
  margin-left: 2.5rem !important;
}

[dir=rtl] .ml-10{
  margin-right: 2.5rem !important;
}

[dir] .mt-12{
  margin-top: 3rem !important;
}

[dir=ltr] .mr-12{
  margin-right: 3rem !important;
}

[dir=rtl] .mr-12{
  margin-left: 3rem !important;
}

[dir] .mb-12{
  margin-bottom: 3rem !important;
}

[dir=ltr] .ml-12{
  margin-left: 3rem !important;
}

[dir=rtl] .ml-12{
  margin-right: 3rem !important;
}

[dir] .mt-16{
  margin-top: 4rem !important;
}

[dir=ltr] .mr-16{
  margin-right: 4rem !important;
}

[dir=rtl] .mr-16{
  margin-left: 4rem !important;
}

[dir] .mb-16{
  margin-bottom: 4rem !important;
}

[dir=ltr] .ml-16{
  margin-left: 4rem !important;
}

[dir=rtl] .ml-16{
  margin-right: 4rem !important;
}

[dir] .mt-20{
  margin-top: 5rem !important;
}

[dir=ltr] .mr-20{
  margin-right: 5rem !important;
}

[dir=rtl] .mr-20{
  margin-left: 5rem !important;
}

[dir] .mb-20{
  margin-bottom: 5rem !important;
}

[dir=ltr] .ml-20{
  margin-left: 5rem !important;
}

[dir=rtl] .ml-20{
  margin-right: 5rem !important;
}

[dir] .mt-24{
  margin-top: 6rem !important;
}

[dir=ltr] .mr-24{
  margin-right: 6rem !important;
}

[dir=rtl] .mr-24{
  margin-left: 6rem !important;
}

[dir] .mb-24{
  margin-bottom: 6rem !important;
}

[dir=ltr] .ml-24{
  margin-left: 6rem !important;
}

[dir=rtl] .ml-24{
  margin-right: 6rem !important;
}

[dir] .mt-32{
  margin-top: 8rem !important;
}

[dir=ltr] .mr-32{
  margin-right: 8rem !important;
}

[dir=rtl] .mr-32{
  margin-left: 8rem !important;
}

[dir] .mb-32{
  margin-bottom: 8rem !important;
}

[dir=ltr] .ml-32{
  margin-left: 8rem !important;
}

[dir=rtl] .ml-32{
  margin-right: 8rem !important;
}

[dir] .mt-auto{
  margin-top: auto !important;
}

[dir=ltr] .mr-auto{
  margin-right: auto !important;
}

[dir=rtl] .mr-auto{
  margin-left: auto !important;
}

[dir] .mb-auto{
  margin-bottom: auto !important;
}

[dir=ltr] .ml-auto{
  margin-left: auto !important;
}

[dir=rtl] .ml-auto{
  margin-right: auto !important;
}

[dir] .mt-px{
  margin-top: 1px !important;
}

[dir=ltr] .mr-px{
  margin-right: 1px !important;
}

[dir=rtl] .mr-px{
  margin-left: 1px !important;
}

[dir] .mb-px{
  margin-bottom: 1px !important;
}

[dir=ltr] .ml-px{
  margin-left: 1px !important;
}

[dir=rtl] .ml-px{
  margin-right: 1px !important;
}

[dir] .mt-base{
  margin-top: 2.2rem !important;
}

[dir=ltr] .mr-base{
  margin-right: 2.2rem !important;
}

[dir=rtl] .mr-base{
  margin-left: 2.2rem !important;
}

[dir] .mb-base{
  margin-bottom: 2.2rem !important;
}

[dir=ltr] .ml-base{
  margin-left: 2.2rem !important;
}

[dir=rtl] .ml-base{
  margin-right: 2.2rem !important;
}

[dir] .-mt-px{
  margin-top: -1px !important;
}

[dir=ltr] .-mr-px{
  margin-right: -1px !important;
}

[dir=rtl] .-mr-px{
  margin-left: -1px !important;
}

[dir] .-mb-px{
  margin-bottom: -1px !important;
}

[dir=ltr] .-ml-px{
  margin-left: -1px !important;
}

[dir=rtl] .-ml-px{
  margin-right: -1px !important;
}

[dir] .-mt-1{
  margin-top: -0.25rem !important;
}

[dir=ltr] .-mr-1{
  margin-right: -0.25rem !important;
}

[dir=rtl] .-mr-1{
  margin-left: -0.25rem !important;
}

[dir] .-mb-1{
  margin-bottom: -0.25rem !important;
}

[dir=ltr] .-ml-1{
  margin-left: -0.25rem !important;
}

[dir=rtl] .-ml-1{
  margin-right: -0.25rem !important;
}

[dir] .-mt-2{
  margin-top: -0.5rem !important;
}

[dir=ltr] .-mr-2{
  margin-right: -0.5rem !important;
}

[dir=rtl] .-mr-2{
  margin-left: -0.5rem !important;
}

[dir] .-mb-2{
  margin-bottom: -0.5rem !important;
}

[dir=ltr] .-ml-2{
  margin-left: -0.5rem !important;
}

[dir=rtl] .-ml-2{
  margin-right: -0.5rem !important;
}

[dir] .-mt-3{
  margin-top: -0.75rem !important;
}

[dir=ltr] .-mr-3{
  margin-right: -0.75rem !important;
}

[dir=rtl] .-mr-3{
  margin-left: -0.75rem !important;
}

[dir] .-mb-3{
  margin-bottom: -0.75rem !important;
}

[dir=ltr] .-ml-3{
  margin-left: -0.75rem !important;
}

[dir=rtl] .-ml-3{
  margin-right: -0.75rem !important;
}

[dir] .-mt-4{
  margin-top: -1rem !important;
}

[dir=ltr] .-mr-4{
  margin-right: -1rem !important;
}

[dir=rtl] .-mr-4{
  margin-left: -1rem !important;
}

[dir] .-mb-4{
  margin-bottom: -1rem !important;
}

[dir=ltr] .-ml-4{
  margin-left: -1rem !important;
}

[dir=rtl] .-ml-4{
  margin-right: -1rem !important;
}

.max-h-full{
  max-height: 100% !important;
}

.max-h-screen{
  max-height: 100vh !important;
}

.max-w-xs{
  max-width: 20rem !important;
}

.max-w-sm{
  max-width: 30rem !important;
}

.max-w-md{
  max-width: 40rem !important;
}

.max-w-lg{
  max-width: 50rem !important;
}

.max-w-xl{
  max-width: 60rem !important;
}

.max-w-2xl{
  max-width: 70rem !important;
}

.max-w-3xl{
  max-width: 80rem !important;
}

.max-w-4xl{
  max-width: 90rem !important;
}

.max-w-5xl{
  max-width: 100rem !important;
}

.max-w-full{
  max-width: 100% !important;
}

.min-h-0{
  min-height: 0 !important;
}

.min-h-full{
  min-height: 100% !important;
}

.min-h-screen{
  min-height: 100vh !important;
}

.min-w-0{
  min-width: 0 !important;
}

.min-w-full{
  min-width: 100% !important;
}

.object-contain{
  object-fit: contain !important;
}

.object-cover{
  object-fit: cover !important;
}

.object-fill{
  object-fit: fill !important;
}

.object-none{
  object-fit: none !important;
}

.object-scale-down{
  object-fit: scale-down !important;
}

.object-bottom{
  object-position: bottom !important;
}

.object-center{
  object-position: center !important;
}

.object-left{
  object-position: left !important;
}

.object-left-bottom{
  object-position: left bottom !important;
}

.object-left-top{
  object-position: left top !important;
}

.object-right{
  object-position: right !important;
}

.object-right-bottom{
  object-position: right bottom !important;
}

.object-right-top{
  object-position: right top !important;
}

.object-top{
  object-position: top !important;
}

.opacity-0{
  opacity: 0 !important;
}

.opacity-25{
  opacity: 0.25 !important;
}

.opacity-50{
  opacity: 0.5 !important;
}

.opacity-75{
  opacity: 0.75 !important;
}

.opacity-100{
  opacity: 1 !important;
}

.outline-none{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.outline-white{
  outline: 2px dotted white !important;
  outline-offset: 2px !important;
}

.outline-black{
  outline: 2px dotted black !important;
  outline-offset: 2px !important;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}

.focus\\:outline-white:focus{
  outline: 2px dotted white !important;
  outline-offset: 2px !important;
}

.focus\\:outline-black:focus{
  outline: 2px dotted black !important;
  outline-offset: 2px !important;
}

.overflow-auto{
  overflow: auto !important;
}

.overflow-hidden{
  overflow: hidden !important;
}

.overflow-visible{
  overflow: visible !important;
}

.overflow-scroll{
  overflow: scroll !important;
}

.overflow-x-auto{
  overflow-x: auto !important;
}

.overflow-y-auto{
  overflow-y: auto !important;
}

.overflow-x-hidden{
  overflow-x: hidden !important;
}

.overflow-y-hidden{
  overflow-y: hidden !important;
}

.overflow-x-visible{
  overflow-x: visible !important;
}

.overflow-y-visible{
  overflow-y: visible !important;
}

.overflow-x-scroll{
  overflow-x: scroll !important;
}

.overflow-y-scroll{
  overflow-y: scroll !important;
}

.scrolling-touch{
  -webkit-overflow-scrolling: touch !important;
}

.scrolling-auto{
  -webkit-overflow-scrolling: auto !important;
}

.overscroll-auto{
  overscroll-behavior: auto !important;
}

.overscroll-contain{
  overscroll-behavior: contain !important;
}

.overscroll-none{
  overscroll-behavior: none !important;
}

.overscroll-y-auto{
  overscroll-behavior-y: auto !important;
}

.overscroll-y-contain{
  overscroll-behavior-y: contain !important;
}

.overscroll-y-none{
  overscroll-behavior-y: none !important;
}

.overscroll-x-auto{
  overscroll-behavior-x: auto !important;
}

.overscroll-x-contain{
  overscroll-behavior-x: contain !important;
}

.overscroll-x-none{
  overscroll-behavior-x: none !important;
}

[dir] .p-0{
  padding: 0 !important;
}

[dir] .p-1{
  padding: 0.25rem !important;
}

[dir] .p-2{
  padding: 0.5rem !important;
}

[dir] .p-3{
  padding: 0.75rem !important;
}

[dir] .p-4{
  padding: 1rem !important;
}

[dir] .p-5{
  padding: 1.25rem !important;
}

[dir] .p-6{
  padding: 1.5rem !important;
}

[dir] .p-8{
  padding: 2rem !important;
}

[dir] .p-10{
  padding: 2.5rem !important;
}

[dir] .p-12{
  padding: 3rem !important;
}

[dir] .p-16{
  padding: 4rem !important;
}

[dir] .p-20{
  padding: 5rem !important;
}

[dir] .p-24{
  padding: 6rem !important;
}

[dir] .p-32{
  padding: 8rem !important;
}

[dir] .p-px{
  padding: 1px !important;
}

[dir] .p-base{
  padding: 2.2rem !important;
}

[dir] .py-0{
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

[dir=ltr] .px-0{
  padding-left: 0 !important;
  padding-right: 0 !important;
}

[dir=rtl] .px-0{
  padding-right: 0 !important;
  padding-left: 0 !important;
}

[dir] .py-1{
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

[dir=ltr] .px-1{
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}

[dir=rtl] .px-1{
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

[dir] .py-2{
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

[dir=ltr] .px-2{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

[dir=rtl] .px-2{
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

[dir] .py-3{
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

[dir=ltr] .px-3{
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}

[dir=rtl] .px-3{
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
}

[dir] .py-4{
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

[dir=ltr] .px-4{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

[dir=rtl] .px-4{
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

[dir] .py-5{
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}

[dir=ltr] .px-5{
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}

[dir=rtl] .px-5{
  padding-right: 1.25rem !important;
  padding-left: 1.25rem !important;
}

[dir] .py-6{
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

[dir=ltr] .px-6{
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}

[dir=rtl] .px-6{
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

[dir] .py-8{
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

[dir=ltr] .px-8{
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}

[dir=rtl] .px-8{
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}

[dir] .py-10{
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}

[dir=ltr] .px-10{
  padding-left: 2.5rem !important;
  padding-right: 2.5rem !important;
}

[dir=rtl] .px-10{
  padding-right: 2.5rem !important;
  padding-left: 2.5rem !important;
}

[dir] .py-12{
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

[dir=ltr] .px-12{
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

[dir=rtl] .px-12{
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

[dir] .py-16{
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

[dir=ltr] .px-16{
  padding-left: 4rem !important;
  padding-right: 4rem !important;
}

[dir=rtl] .px-16{
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

[dir] .py-20{
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}

[dir=ltr] .px-20{
  padding-left: 5rem !important;
  padding-right: 5rem !important;
}

[dir=rtl] .px-20{
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}

[dir] .py-24{
  padding-top: 6rem !important;
  padding-bottom: 6rem !important;
}

[dir=ltr] .px-24{
  padding-left: 6rem !important;
  padding-right: 6rem !important;
}

[dir=rtl] .px-24{
  padding-right: 6rem !important;
  padding-left: 6rem !important;
}

[dir] .py-32{
  padding-top: 8rem !important;
  padding-bottom: 8rem !important;
}

[dir=ltr] .px-32{
  padding-left: 8rem !important;
  padding-right: 8rem !important;
}

[dir=rtl] .px-32{
  padding-right: 8rem !important;
  padding-left: 8rem !important;
}

[dir] .py-px{
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}

[dir=ltr] .px-px{
  padding-left: 1px !important;
  padding-right: 1px !important;
}

[dir=rtl] .px-px{
  padding-right: 1px !important;
  padding-left: 1px !important;
}

[dir] .py-base{
  padding-top: 2.2rem !important;
  padding-bottom: 2.2rem !important;
}

[dir=ltr] .px-base{
  padding-left: 2.2rem !important;
  padding-right: 2.2rem !important;
}

[dir=rtl] .px-base{
  padding-right: 2.2rem !important;
  padding-left: 2.2rem !important;
}

[dir] .pt-0{
  padding-top: 0 !important;
}

[dir=ltr] .pr-0{
  padding-right: 0 !important;
}

[dir=rtl] .pr-0{
  padding-left: 0 !important;
}

[dir] .pb-0{
  padding-bottom: 0 !important;
}

[dir=ltr] .pl-0{
  padding-left: 0 !important;
}

[dir=rtl] .pl-0{
  padding-right: 0 !important;
}

[dir] .pt-1{
  padding-top: 0.25rem !important;
}

[dir=ltr] .pr-1{
  padding-right: 0.25rem !important;
}

[dir=rtl] .pr-1{
  padding-left: 0.25rem !important;
}

[dir] .pb-1{
  padding-bottom: 0.25rem !important;
}

[dir=ltr] .pl-1{
  padding-left: 0.25rem !important;
}

[dir=rtl] .pl-1{
  padding-right: 0.25rem !important;
}

[dir] .pt-2{
  padding-top: 0.5rem !important;
}

[dir=ltr] .pr-2{
  padding-right: 0.5rem !important;
}

[dir=rtl] .pr-2{
  padding-left: 0.5rem !important;
}

[dir] .pb-2{
  padding-bottom: 0.5rem !important;
}

[dir=ltr] .pl-2{
  padding-left: 0.5rem !important;
}

[dir=rtl] .pl-2{
  padding-right: 0.5rem !important;
}

[dir] .pt-3{
  padding-top: 0.75rem !important;
}

[dir=ltr] .pr-3{
  padding-right: 0.75rem !important;
}

[dir=rtl] .pr-3{
  padding-left: 0.75rem !important;
}

[dir] .pb-3{
  padding-bottom: 0.75rem !important;
}

[dir=ltr] .pl-3{
  padding-left: 0.75rem !important;
}

[dir=rtl] .pl-3{
  padding-right: 0.75rem !important;
}

[dir] .pt-4{
  padding-top: 1rem !important;
}

[dir=ltr] .pr-4{
  padding-right: 1rem !important;
}

[dir=rtl] .pr-4{
  padding-left: 1rem !important;
}

[dir] .pb-4{
  padding-bottom: 1rem !important;
}

[dir=ltr] .pl-4{
  padding-left: 1rem !important;
}

[dir=rtl] .pl-4{
  padding-right: 1rem !important;
}

[dir] .pt-5{
  padding-top: 1.25rem !important;
}

[dir=ltr] .pr-5{
  padding-right: 1.25rem !important;
}

[dir=rtl] .pr-5{
  padding-left: 1.25rem !important;
}

[dir] .pb-5{
  padding-bottom: 1.25rem !important;
}

[dir=ltr] .pl-5{
  padding-left: 1.25rem !important;
}

[dir=rtl] .pl-5{
  padding-right: 1.25rem !important;
}

[dir] .pt-6{
  padding-top: 1.5rem !important;
}

[dir=ltr] .pr-6{
  padding-right: 1.5rem !important;
}

[dir=rtl] .pr-6{
  padding-left: 1.5rem !important;
}

[dir] .pb-6{
  padding-bottom: 1.5rem !important;
}

[dir=ltr] .pl-6{
  padding-left: 1.5rem !important;
}

[dir=rtl] .pl-6{
  padding-right: 1.5rem !important;
}

[dir] .pt-8{
  padding-top: 2rem !important;
}

[dir=ltr] .pr-8{
  padding-right: 2rem !important;
}

[dir=rtl] .pr-8{
  padding-left: 2rem !important;
}

[dir] .pb-8{
  padding-bottom: 2rem !important;
}

[dir=ltr] .pl-8{
  padding-left: 2rem !important;
}

[dir=rtl] .pl-8{
  padding-right: 2rem !important;
}

[dir] .pt-10{
  padding-top: 2.5rem !important;
}

[dir=ltr] .pr-10{
  padding-right: 2.5rem !important;
}

[dir=rtl] .pr-10{
  padding-left: 2.5rem !important;
}

[dir] .pb-10{
  padding-bottom: 2.5rem !important;
}

[dir=ltr] .pl-10{
  padding-left: 2.5rem !important;
}

[dir=rtl] .pl-10{
  padding-right: 2.5rem !important;
}

[dir] .pt-12{
  padding-top: 3rem !important;
}

[dir=ltr] .pr-12{
  padding-right: 3rem !important;
}

[dir=rtl] .pr-12{
  padding-left: 3rem !important;
}

[dir] .pb-12{
  padding-bottom: 3rem !important;
}

[dir=ltr] .pl-12{
  padding-left: 3rem !important;
}

[dir=rtl] .pl-12{
  padding-right: 3rem !important;
}

[dir] .pt-16{
  padding-top: 4rem !important;
}

[dir=ltr] .pr-16{
  padding-right: 4rem !important;
}

[dir=rtl] .pr-16{
  padding-left: 4rem !important;
}

[dir] .pb-16{
  padding-bottom: 4rem !important;
}

[dir=ltr] .pl-16{
  padding-left: 4rem !important;
}

[dir=rtl] .pl-16{
  padding-right: 4rem !important;
}

[dir] .pt-20{
  padding-top: 5rem !important;
}

[dir=ltr] .pr-20{
  padding-right: 5rem !important;
}

[dir=rtl] .pr-20{
  padding-left: 5rem !important;
}

[dir] .pb-20{
  padding-bottom: 5rem !important;
}

[dir=ltr] .pl-20{
  padding-left: 5rem !important;
}

[dir=rtl] .pl-20{
  padding-right: 5rem !important;
}

[dir] .pt-24{
  padding-top: 6rem !important;
}

[dir=ltr] .pr-24{
  padding-right: 6rem !important;
}

[dir=rtl] .pr-24{
  padding-left: 6rem !important;
}

[dir] .pb-24{
  padding-bottom: 6rem !important;
}

[dir=ltr] .pl-24{
  padding-left: 6rem !important;
}

[dir=rtl] .pl-24{
  padding-right: 6rem !important;
}

[dir] .pt-32{
  padding-top: 8rem !important;
}

[dir=ltr] .pr-32{
  padding-right: 8rem !important;
}

[dir=rtl] .pr-32{
  padding-left: 8rem !important;
}

[dir] .pb-32{
  padding-bottom: 8rem !important;
}

[dir=ltr] .pl-32{
  padding-left: 8rem !important;
}

[dir=rtl] .pl-32{
  padding-right: 8rem !important;
}

[dir] .pt-px{
  padding-top: 1px !important;
}

[dir=ltr] .pr-px{
  padding-right: 1px !important;
}

[dir=rtl] .pr-px{
  padding-left: 1px !important;
}

[dir] .pb-px{
  padding-bottom: 1px !important;
}

[dir=ltr] .pl-px{
  padding-left: 1px !important;
}

[dir=rtl] .pl-px{
  padding-right: 1px !important;
}

[dir] .pt-base{
  padding-top: 2.2rem !important;
}

[dir=ltr] .pr-base{
  padding-right: 2.2rem !important;
}

[dir=rtl] .pr-base{
  padding-left: 2.2rem !important;
}

[dir] .pb-base{
  padding-bottom: 2.2rem !important;
}

[dir=ltr] .pl-base{
  padding-left: 2.2rem !important;
}

[dir=rtl] .pl-base{
  padding-right: 2.2rem !important;
}

.placeholder-transparent::placeholder{
  color: transparent !important;
}

.placeholder-black::placeholder{
  --placeholder-opacity: 1 !important;
  color: #22292f !important;
  color: rgba(34, 41, 47, var(--placeholder-opacity)) !important;
}

.placeholder-white::placeholder{
  --placeholder-opacity: 1 !important;
  color: #ffffff !important;
  color: rgba(255, 255, 255, var(--placeholder-opacity)) !important;
}

.placeholder-grey::placeholder{
  --placeholder-opacity: 1 !important;
  color: #b8c2cc !important;
  color: rgba(184, 194, 204, var(--placeholder-opacity)) !important;
}

.placeholder-grey-light::placeholder{
  --placeholder-opacity: 1 !important;
  color: #dae1e7 !important;
  color: rgba(218, 225, 231, var(--placeholder-opacity)) !important;
}

.focus\\:placeholder-transparent:focus::placeholder{
  color: transparent !important;
}

.focus\\:placeholder-black:focus::placeholder{
  --placeholder-opacity: 1 !important;
  color: #22292f !important;
  color: rgba(34, 41, 47, var(--placeholder-opacity)) !important;
}

.focus\\:placeholder-white:focus::placeholder{
  --placeholder-opacity: 1 !important;
  color: #ffffff !important;
  color: rgba(255, 255, 255, var(--placeholder-opacity)) !important;
}

.focus\\:placeholder-grey:focus::placeholder{
  --placeholder-opacity: 1 !important;
  color: #b8c2cc !important;
  color: rgba(184, 194, 204, var(--placeholder-opacity)) !important;
}

.focus\\:placeholder-grey-light:focus::placeholder{
  --placeholder-opacity: 1 !important;
  color: #dae1e7 !important;
  color: rgba(218, 225, 231, var(--placeholder-opacity)) !important;
}

.placeholder-opacity-0::placeholder{
  --placeholder-opacity: 0 !important;
}

.placeholder-opacity-25::placeholder{
  --placeholder-opacity: 0.25 !important;
}

.placeholder-opacity-50::placeholder{
  --placeholder-opacity: 0.5 !important;
}

.placeholder-opacity-75::placeholder{
  --placeholder-opacity: 0.75 !important;
}

.placeholder-opacity-100::placeholder{
  --placeholder-opacity: 1 !important;
}

.focus\\:placeholder-opacity-0:focus::placeholder{
  --placeholder-opacity: 0 !important;
}

.focus\\:placeholder-opacity-25:focus::placeholder{
  --placeholder-opacity: 0.25 !important;
}

.focus\\:placeholder-opacity-50:focus::placeholder{
  --placeholder-opacity: 0.5 !important;
}

.focus\\:placeholder-opacity-75:focus::placeholder{
  --placeholder-opacity: 0.75 !important;
}

.focus\\:placeholder-opacity-100:focus::placeholder{
  --placeholder-opacity: 1 !important;
}

.pointer-events-none{
  pointer-events: none !important;
}

.pointer-events-auto{
  pointer-events: auto !important;
}

.static{
  position: static !important;
}

.fixed{
  position: fixed !important;
}

.absolute{
  position: absolute !important;
}

.relative{
  position: relative !important;
}

.sticky{
  position: sticky !important;
}

.inset-0{
  top: 0 !important;
  bottom: 0 !important;
}

[dir=ltr] .inset-0{
  right: 0 !important;
  left: 0 !important;
}

[dir=rtl] .inset-0{
  left: 0 !important;
  right: 0 !important;
}

.inset-auto{
  top: auto !important;
  bottom: auto !important;
}

[dir=ltr] .inset-auto{
  right: auto !important;
  left: auto !important;
}

[dir=rtl] .inset-auto{
  left: auto !important;
  right: auto !important;
}

.inset-y-0{
  top: 0 !important;
  bottom: 0 !important;
}

[dir=ltr] .inset-x-0{
  right: 0 !important;
  left: 0 !important;
}

[dir=rtl] .inset-x-0{
  left: 0 !important;
  right: 0 !important;
}

.inset-y-auto{
  top: auto !important;
  bottom: auto !important;
}

[dir=ltr] .inset-x-auto{
  right: auto !important;
  left: auto !important;
}

[dir=rtl] .inset-x-auto{
  left: auto !important;
  right: auto !important;
}

.top-0{
  top: 0 !important;
}

[dir=ltr] .right-0{
  right: 0 !important;
}

[dir=rtl] .right-0{
  left: 0 !important;
}

.bottom-0{
  bottom: 0 !important;
}

[dir=ltr] .left-0{
  left: 0 !important;
}

[dir=rtl] .left-0{
  right: 0 !important;
}

.top-auto{
  top: auto !important;
}

[dir=ltr] .right-auto{
  right: auto !important;
}

[dir=rtl] .right-auto{
  left: auto !important;
}

.bottom-auto{
  bottom: auto !important;
}

[dir=ltr] .left-auto{
  left: auto !important;
}

[dir=rtl] .left-auto{
  right: auto !important;
}

.resize-none{
  resize: none !important;
}

.resize-y{
  resize: vertical !important;
}

.resize-x{
  resize: horizontal !important;
}

.resize{
  resize: both !important;
}

[dir] .shadow{
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
}

[dir] .shadow-md{
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
}

[dir] .shadow-lg{
  box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
}

[dir] .shadow-inner{
  box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
}

[dir] .shadow-xl{
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

[dir] .shadow-2xl{
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}

[dir] .shadow-outline{
  box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
}

[dir] .shadow-none{
  box-shadow: none !important;
}

[dir] .shadow-drop{
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
}

[dir] .hover\\:shadow:hover{
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
}

[dir] .hover\\:shadow-md:hover{
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
}

[dir] .hover\\:shadow-lg:hover{
  box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
}

[dir] .hover\\:shadow-inner:hover{
  box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
}

[dir] .hover\\:shadow-xl:hover{
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

[dir] .hover\\:shadow-2xl:hover{
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}

[dir] .hover\\:shadow-outline:hover{
  box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
}

[dir] .hover\\:shadow-none:hover{
  box-shadow: none !important;
}

[dir] .hover\\:shadow-drop:hover{
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
}

[dir] .focus\\:shadow:focus{
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
}

[dir] .focus\\:shadow-md:focus{
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
}

[dir] .focus\\:shadow-lg:focus{
  box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
}

[dir] .focus\\:shadow-inner:focus{
  box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
}

[dir] .focus\\:shadow-xl:focus{
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

[dir] .focus\\:shadow-2xl:focus{
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}

[dir] .focus\\:shadow-outline:focus{
  box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
}

[dir] .focus\\:shadow-none:focus{
  box-shadow: none !important;
}

[dir] .focus\\:shadow-drop:focus{
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
}

.fill-current{
  fill: currentColor !important;
}

.stroke-current{
  stroke: currentColor !important;
}

.stroke-0{
  stroke-width: 0 !important;
}

.stroke-1{
  stroke-width: 1 !important;
}

.stroke-2{
  stroke-width: 2 !important;
}

.table-auto{
  table-layout: auto !important;
}

.table-fixed{
  table-layout: fixed !important;
}

[dir=ltr] .text-left{
  text-align: left !important;
}

[dir=rtl] .text-left{
  text-align: right !important;
}

[dir] .text-center{
  text-align: center !important;
}

[dir=ltr] .text-right{
  text-align: right !important;
}

[dir=rtl] .text-right{
  text-align: left !important;
}

[dir] .text-justify{
  text-align: justify !important;
}

.text-inherit{
  color: inherit !important;
}

.text-transparent{
  color: transparent !important;
}

.text-black{
  --text-opacity: 1 !important;
  color: #22292f !important;
  color: rgba(34, 41, 47, var(--text-opacity)) !important;
}

.text-white{
  --text-opacity: 1 !important;
  color: #ffffff !important;
  color: rgba(255, 255, 255, var(--text-opacity)) !important;
}

.text-grey{
  --text-opacity: 1 !important;
  color: #b8c2cc !important;
  color: rgba(184, 194, 204, var(--text-opacity)) !important;
}

.text-grey-light{
  --text-opacity: 1 !important;
  color: #dae1e7 !important;
  color: rgba(218, 225, 231, var(--text-opacity)) !important;
}

.hover\\:text-inherit:hover{
  color: inherit !important;
}

.hover\\:text-transparent:hover{
  color: transparent !important;
}

.hover\\:text-black:hover{
  --text-opacity: 1 !important;
  color: #22292f !important;
  color: rgba(34, 41, 47, var(--text-opacity)) !important;
}

.hover\\:text-white:hover{
  --text-opacity: 1 !important;
  color: #ffffff !important;
  color: rgba(255, 255, 255, var(--text-opacity)) !important;
}

.hover\\:text-grey:hover{
  --text-opacity: 1 !important;
  color: #b8c2cc !important;
  color: rgba(184, 194, 204, var(--text-opacity)) !important;
}

.hover\\:text-grey-light:hover{
  --text-opacity: 1 !important;
  color: #dae1e7 !important;
  color: rgba(218, 225, 231, var(--text-opacity)) !important;
}

.focus\\:text-inherit:focus{
  color: inherit !important;
}

.focus\\:text-transparent:focus{
  color: transparent !important;
}

.focus\\:text-black:focus{
  --text-opacity: 1 !important;
  color: #22292f !important;
  color: rgba(34, 41, 47, var(--text-opacity)) !important;
}

.focus\\:text-white:focus{
  --text-opacity: 1 !important;
  color: #ffffff !important;
  color: rgba(255, 255, 255, var(--text-opacity)) !important;
}

.focus\\:text-grey:focus{
  --text-opacity: 1 !important;
  color: #b8c2cc !important;
  color: rgba(184, 194, 204, var(--text-opacity)) !important;
}

.focus\\:text-grey-light:focus{
  --text-opacity: 1 !important;
  color: #dae1e7 !important;
  color: rgba(218, 225, 231, var(--text-opacity)) !important;
}

.text-opacity-0{
  --text-opacity: 0 !important;
}

.text-opacity-25{
  --text-opacity: 0.25 !important;
}

.text-opacity-50{
  --text-opacity: 0.5 !important;
}

.text-opacity-75{
  --text-opacity: 0.75 !important;
}

.text-opacity-100{
  --text-opacity: 1 !important;
}

.hover\\:text-opacity-0:hover{
  --text-opacity: 0 !important;
}

.hover\\:text-opacity-25:hover{
  --text-opacity: 0.25 !important;
}

.hover\\:text-opacity-50:hover{
  --text-opacity: 0.5 !important;
}

.hover\\:text-opacity-75:hover{
  --text-opacity: 0.75 !important;
}

.hover\\:text-opacity-100:hover{
  --text-opacity: 1 !important;
}

.focus\\:text-opacity-0:focus{
  --text-opacity: 0 !important;
}

.focus\\:text-opacity-25:focus{
  --text-opacity: 0.25 !important;
}

.focus\\:text-opacity-50:focus{
  --text-opacity: 0.5 !important;
}

.focus\\:text-opacity-75:focus{
  --text-opacity: 0.75 !important;
}

.focus\\:text-opacity-100:focus{
  --text-opacity: 1 !important;
}

.italic{
  font-style: italic !important;
}

.not-italic{
  font-style: normal !important;
}

.hover\\:italic:hover{
  font-style: italic !important;
}

.hover\\:not-italic:hover{
  font-style: normal !important;
}

.focus\\:italic:focus{
  font-style: italic !important;
}

.focus\\:not-italic:focus{
  font-style: normal !important;
}

.uppercase{
  text-transform: uppercase !important;
}

.lowercase{
  text-transform: lowercase !important;
}

.capitalize{
  text-transform: capitalize !important;
}

.normal-case{
  text-transform: none !important;
}

.hover\\:uppercase:hover{
  text-transform: uppercase !important;
}

.hover\\:lowercase:hover{
  text-transform: lowercase !important;
}

.hover\\:capitalize:hover{
  text-transform: capitalize !important;
}

.hover\\:normal-case:hover{
  text-transform: none !important;
}

.focus\\:uppercase:focus{
  text-transform: uppercase !important;
}

.focus\\:lowercase:focus{
  text-transform: lowercase !important;
}

.focus\\:capitalize:focus{
  text-transform: capitalize !important;
}

.focus\\:normal-case:focus{
  text-transform: none !important;
}

.underline{
  text-decoration: underline !important;
}

.line-through{
  text-decoration: line-through !important;
}

.no-underline{
  text-decoration: none !important;
}

.hover\\:underline:hover{
  text-decoration: underline !important;
}

.hover\\:line-through:hover{
  text-decoration: line-through !important;
}

.hover\\:no-underline:hover{
  text-decoration: none !important;
}

.focus\\:underline:focus{
  text-decoration: underline !important;
}

.focus\\:line-through:focus{
  text-decoration: line-through !important;
}

.focus\\:no-underline:focus{
  text-decoration: none !important;
}

.antialiased{
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}

.subpixel-antialiased{
  -webkit-font-smoothing: auto !important;
  -moz-osx-font-smoothing: auto !important;
}

.hover\\:antialiased:hover{
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}

.hover\\:subpixel-antialiased:hover{
  -webkit-font-smoothing: auto !important;
  -moz-osx-font-smoothing: auto !important;
}

.focus\\:antialiased:focus{
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}

.focus\\:subpixel-antialiased:focus{
  -webkit-font-smoothing: auto !important;
  -moz-osx-font-smoothing: auto !important;
}

.ordinal, .slashed-zero, .lining-nums, .oldstyle-nums, .proportional-nums, .tabular-nums, .diagonal-fractions, .stacked-fractions{
  --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/) !important;
  --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/) !important;
  --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/) !important;
  --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/) !important;
  --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/) !important;
  font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction) !important;
}

.normal-nums{
  font-variant-numeric: normal !important;
}

.ordinal{
  --font-variant-numeric-ordinal: ordinal !important;
}

.slashed-zero{
  --font-variant-numeric-slashed-zero: slashed-zero !important;
}

.lining-nums{
  --font-variant-numeric-figure: lining-nums !important;
}

.oldstyle-nums{
  --font-variant-numeric-figure: oldstyle-nums !important;
}

.proportional-nums{
  --font-variant-numeric-spacing: proportional-nums !important;
}

.tabular-nums{
  --font-variant-numeric-spacing: tabular-nums !important;
}

.diagonal-fractions{
  --font-variant-numeric-fraction: diagonal-fractions !important;
}

.stacked-fractions{
  --font-variant-numeric-fraction: stacked-fractions !important;
}

.select-none{
  -webkit-user-select: none !important;
          user-select: none !important;
}

.select-text{
  -webkit-user-select: text !important;
          user-select: text !important;
}

.select-all{
  -webkit-user-select: all !important;
          user-select: all !important;
}

.select-auto{
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.align-baseline{
  vertical-align: baseline !important;
}

.align-top{
  vertical-align: top !important;
}

.align-middle{
  vertical-align: middle !important;
}

.align-bottom{
  vertical-align: bottom !important;
}

.align-text-top{
  vertical-align: text-top !important;
}

.align-text-bottom{
  vertical-align: text-bottom !important;
}

.visible{
  visibility: visible !important;
}

.invisible{
  visibility: hidden !important;
}

.whitespace-normal{
  white-space: normal !important;
}

.whitespace-no-wrap{
  white-space: nowrap !important;
}

.whitespace-pre{
  white-space: pre !important;
}

.whitespace-pre-line{
  white-space: pre-line !important;
}

.whitespace-pre-wrap{
  white-space: pre-wrap !important;
}

.break-normal{
  word-wrap: normal !important;
  overflow-wrap: normal !important;
  word-break: normal !important;
}

.break-words{
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
}

.break-all{
  word-break: break-all !important;
}

.truncate{
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.w-1{
  width: 0.25rem !important;
}

.w-2{
  width: 0.5rem !important;
}

.w-3{
  width: 0.75rem !important;
}

.w-4{
  width: 1rem !important;
}

.w-5{
  width: 1.25rem !important;
}

.w-6{
  width: 1.5rem !important;
}

.w-8{
  width: 2rem !important;
}

.w-10{
  width: 2.5rem !important;
}

.w-12{
  width: 3rem !important;
}

.w-16{
  width: 4rem !important;
}

.w-24{
  width: 6rem !important;
}

.w-32{
  width: 8rem !important;
}

.w-48{
  width: 12rem !important;
}

.w-64{
  width: 16rem !important;
}

.w-auto{
  width: auto !important;
}

.w-px{
  width: 1px !important;
}

.w-1\\/2{
  width: 50% !important;
}

.w-1\\/3{
  width: 33.33333% !important;
}

.w-2\\/3{
  width: 66.66667% !important;
}

.w-1\\/4{
  width: 25% !important;
}

.w-3\\/4{
  width: 75% !important;
}

.w-1\\/5{
  width: 20% !important;
}

.w-2\\/5{
  width: 40% !important;
}

.w-3\\/5{
  width: 60% !important;
}

.w-4\\/5{
  width: 80% !important;
}

.w-1\\/6{
  width: 16.66667% !important;
}

.w-5\\/6{
  width: 83.33333% !important;
}

.w-1\\/12{
  width: 8.33333% !important;
}

.w-2\\/12{
  width: 16.66667% !important;
}

.w-3\\/12{
  width: 25% !important;
}

.w-4\\/12{
  width: 33.33333% !important;
}

.w-5\\/12{
  width: 41.66667% !important;
}

.w-6\\/12{
  width: 50% !important;
}

.w-7\\/12{
  width: 58.33333% !important;
}

.w-8\\/12{
  width: 66.66667% !important;
}

.w-9\\/12{
  width: 75% !important;
}

.w-10\\/12{
  width: 83.33333% !important;
}

.w-11\\/12{
  width: 91.66667% !important;
}

.w-full{
  width: 100% !important;
}

.w-screen{
  width: 100vw !important;
}

.z-0{
  z-index: 0 !important;
}

.z-10{
  z-index: 10 !important;
}

.z-20{
  z-index: 20 !important;
}

.z-30{
  z-index: 30 !important;
}

.z-40{
  z-index: 40 !important;
}

.z-50{
  z-index: 50 !important;
}

.z-auto{
  z-index: auto !important;
}

.gap-0{
  grid-gap: 0 !important;
  gap: 0 !important;
}

.gap-1{
  grid-gap: 0.25rem !important;
  gap: 0.25rem !important;
}

.gap-2{
  grid-gap: 0.5rem !important;
  gap: 0.5rem !important;
}

.gap-3{
  grid-gap: 0.75rem !important;
  gap: 0.75rem !important;
}

.gap-4{
  grid-gap: 1rem !important;
  gap: 1rem !important;
}

.gap-5{
  grid-gap: 1.25rem !important;
  gap: 1.25rem !important;
}

.gap-6{
  grid-gap: 1.5rem !important;
  gap: 1.5rem !important;
}

.gap-8{
  grid-gap: 2rem !important;
  gap: 2rem !important;
}

.gap-10{
  grid-gap: 2.5rem !important;
  gap: 2.5rem !important;
}

.gap-12{
  grid-gap: 3rem !important;
  gap: 3rem !important;
}

.gap-16{
  grid-gap: 4rem !important;
  gap: 4rem !important;
}

.gap-20{
  grid-gap: 5rem !important;
  gap: 5rem !important;
}

.gap-24{
  grid-gap: 6rem !important;
  gap: 6rem !important;
}

.gap-32{
  grid-gap: 8rem !important;
  gap: 8rem !important;
}

.gap-40{
  grid-gap: 10rem !important;
  gap: 10rem !important;
}

.gap-48{
  grid-gap: 12rem !important;
  gap: 12rem !important;
}

.gap-56{
  grid-gap: 14rem !important;
  gap: 14rem !important;
}

.gap-64{
  grid-gap: 16rem !important;
  gap: 16rem !important;
}

.gap-px{
  grid-gap: 1px !important;
  gap: 1px !important;
}

.col-gap-0{
  grid-column-gap: 0 !important;
  -moz-column-gap: 0 !important;
       column-gap: 0 !important;
}

.col-gap-1{
  grid-column-gap: 0.25rem !important;
  -moz-column-gap: 0.25rem !important;
       column-gap: 0.25rem !important;
}

.col-gap-2{
  grid-column-gap: 0.5rem !important;
  -moz-column-gap: 0.5rem !important;
       column-gap: 0.5rem !important;
}

.col-gap-3{
  grid-column-gap: 0.75rem !important;
  -moz-column-gap: 0.75rem !important;
       column-gap: 0.75rem !important;
}

.col-gap-4{
  grid-column-gap: 1rem !important;
  -moz-column-gap: 1rem !important;
       column-gap: 1rem !important;
}

.col-gap-5{
  grid-column-gap: 1.25rem !important;
  -moz-column-gap: 1.25rem !important;
       column-gap: 1.25rem !important;
}

.col-gap-6{
  grid-column-gap: 1.5rem !important;
  -moz-column-gap: 1.5rem !important;
       column-gap: 1.5rem !important;
}

.col-gap-8{
  grid-column-gap: 2rem !important;
  -moz-column-gap: 2rem !important;
       column-gap: 2rem !important;
}

.col-gap-10{
  grid-column-gap: 2.5rem !important;
  -moz-column-gap: 2.5rem !important;
       column-gap: 2.5rem !important;
}

.col-gap-12{
  grid-column-gap: 3rem !important;
  -moz-column-gap: 3rem !important;
       column-gap: 3rem !important;
}

.col-gap-16{
  grid-column-gap: 4rem !important;
  -moz-column-gap: 4rem !important;
       column-gap: 4rem !important;
}

.col-gap-20{
  grid-column-gap: 5rem !important;
  -moz-column-gap: 5rem !important;
       column-gap: 5rem !important;
}

.col-gap-24{
  grid-column-gap: 6rem !important;
  -moz-column-gap: 6rem !important;
       column-gap: 6rem !important;
}

.col-gap-32{
  grid-column-gap: 8rem !important;
  -moz-column-gap: 8rem !important;
       column-gap: 8rem !important;
}

.col-gap-40{
  grid-column-gap: 10rem !important;
  -moz-column-gap: 10rem !important;
       column-gap: 10rem !important;
}

.col-gap-48{
  grid-column-gap: 12rem !important;
  -moz-column-gap: 12rem !important;
       column-gap: 12rem !important;
}

.col-gap-56{
  grid-column-gap: 14rem !important;
  -moz-column-gap: 14rem !important;
       column-gap: 14rem !important;
}

.col-gap-64{
  grid-column-gap: 16rem !important;
  -moz-column-gap: 16rem !important;
       column-gap: 16rem !important;
}

.col-gap-px{
  grid-column-gap: 1px !important;
  -moz-column-gap: 1px !important;
       column-gap: 1px !important;
}

.gap-x-0{
  grid-column-gap: 0 !important;
  -moz-column-gap: 0 !important;
       column-gap: 0 !important;
}

.gap-x-1{
  grid-column-gap: 0.25rem !important;
  -moz-column-gap: 0.25rem !important;
       column-gap: 0.25rem !important;
}

.gap-x-2{
  grid-column-gap: 0.5rem !important;
  -moz-column-gap: 0.5rem !important;
       column-gap: 0.5rem !important;
}

.gap-x-3{
  grid-column-gap: 0.75rem !important;
  -moz-column-gap: 0.75rem !important;
       column-gap: 0.75rem !important;
}

.gap-x-4{
  grid-column-gap: 1rem !important;
  -moz-column-gap: 1rem !important;
       column-gap: 1rem !important;
}

.gap-x-5{
  grid-column-gap: 1.25rem !important;
  -moz-column-gap: 1.25rem !important;
       column-gap: 1.25rem !important;
}

.gap-x-6{
  grid-column-gap: 1.5rem !important;
  -moz-column-gap: 1.5rem !important;
       column-gap: 1.5rem !important;
}

.gap-x-8{
  grid-column-gap: 2rem !important;
  -moz-column-gap: 2rem !important;
       column-gap: 2rem !important;
}

.gap-x-10{
  grid-column-gap: 2.5rem !important;
  -moz-column-gap: 2.5rem !important;
       column-gap: 2.5rem !important;
}

.gap-x-12{
  grid-column-gap: 3rem !important;
  -moz-column-gap: 3rem !important;
       column-gap: 3rem !important;
}

.gap-x-16{
  grid-column-gap: 4rem !important;
  -moz-column-gap: 4rem !important;
       column-gap: 4rem !important;
}

.gap-x-20{
  grid-column-gap: 5rem !important;
  -moz-column-gap: 5rem !important;
       column-gap: 5rem !important;
}

.gap-x-24{
  grid-column-gap: 6rem !important;
  -moz-column-gap: 6rem !important;
       column-gap: 6rem !important;
}

.gap-x-32{
  grid-column-gap: 8rem !important;
  -moz-column-gap: 8rem !important;
       column-gap: 8rem !important;
}

.gap-x-40{
  grid-column-gap: 10rem !important;
  -moz-column-gap: 10rem !important;
       column-gap: 10rem !important;
}

.gap-x-48{
  grid-column-gap: 12rem !important;
  -moz-column-gap: 12rem !important;
       column-gap: 12rem !important;
}

.gap-x-56{
  grid-column-gap: 14rem !important;
  -moz-column-gap: 14rem !important;
       column-gap: 14rem !important;
}

.gap-x-64{
  grid-column-gap: 16rem !important;
  -moz-column-gap: 16rem !important;
       column-gap: 16rem !important;
}

.gap-x-px{
  grid-column-gap: 1px !important;
  -moz-column-gap: 1px !important;
       column-gap: 1px !important;
}

.row-gap-0{
  grid-row-gap: 0 !important;
  row-gap: 0 !important;
}

.row-gap-1{
  grid-row-gap: 0.25rem !important;
  row-gap: 0.25rem !important;
}

.row-gap-2{
  grid-row-gap: 0.5rem !important;
  row-gap: 0.5rem !important;
}

.row-gap-3{
  grid-row-gap: 0.75rem !important;
  row-gap: 0.75rem !important;
}

.row-gap-4{
  grid-row-gap: 1rem !important;
  row-gap: 1rem !important;
}

.row-gap-5{
  grid-row-gap: 1.25rem !important;
  row-gap: 1.25rem !important;
}

.row-gap-6{
  grid-row-gap: 1.5rem !important;
  row-gap: 1.5rem !important;
}

.row-gap-8{
  grid-row-gap: 2rem !important;
  row-gap: 2rem !important;
}

.row-gap-10{
  grid-row-gap: 2.5rem !important;
  row-gap: 2.5rem !important;
}

.row-gap-12{
  grid-row-gap: 3rem !important;
  row-gap: 3rem !important;
}

.row-gap-16{
  grid-row-gap: 4rem !important;
  row-gap: 4rem !important;
}

.row-gap-20{
  grid-row-gap: 5rem !important;
  row-gap: 5rem !important;
}

.row-gap-24{
  grid-row-gap: 6rem !important;
  row-gap: 6rem !important;
}

.row-gap-32{
  grid-row-gap: 8rem !important;
  row-gap: 8rem !important;
}

.row-gap-40{
  grid-row-gap: 10rem !important;
  row-gap: 10rem !important;
}

.row-gap-48{
  grid-row-gap: 12rem !important;
  row-gap: 12rem !important;
}

.row-gap-56{
  grid-row-gap: 14rem !important;
  row-gap: 14rem !important;
}

.row-gap-64{
  grid-row-gap: 16rem !important;
  row-gap: 16rem !important;
}

.row-gap-px{
  grid-row-gap: 1px !important;
  row-gap: 1px !important;
}

.gap-y-0{
  grid-row-gap: 0 !important;
  row-gap: 0 !important;
}

.gap-y-1{
  grid-row-gap: 0.25rem !important;
  row-gap: 0.25rem !important;
}

.gap-y-2{
  grid-row-gap: 0.5rem !important;
  row-gap: 0.5rem !important;
}

.gap-y-3{
  grid-row-gap: 0.75rem !important;
  row-gap: 0.75rem !important;
}

.gap-y-4{
  grid-row-gap: 1rem !important;
  row-gap: 1rem !important;
}

.gap-y-5{
  grid-row-gap: 1.25rem !important;
  row-gap: 1.25rem !important;
}

.gap-y-6{
  grid-row-gap: 1.5rem !important;
  row-gap: 1.5rem !important;
}

.gap-y-8{
  grid-row-gap: 2rem !important;
  row-gap: 2rem !important;
}

.gap-y-10{
  grid-row-gap: 2.5rem !important;
  row-gap: 2.5rem !important;
}

.gap-y-12{
  grid-row-gap: 3rem !important;
  row-gap: 3rem !important;
}

.gap-y-16{
  grid-row-gap: 4rem !important;
  row-gap: 4rem !important;
}

.gap-y-20{
  grid-row-gap: 5rem !important;
  row-gap: 5rem !important;
}

.gap-y-24{
  grid-row-gap: 6rem !important;
  row-gap: 6rem !important;
}

.gap-y-32{
  grid-row-gap: 8rem !important;
  row-gap: 8rem !important;
}

.gap-y-40{
  grid-row-gap: 10rem !important;
  row-gap: 10rem !important;
}

.gap-y-48{
  grid-row-gap: 12rem !important;
  row-gap: 12rem !important;
}

.gap-y-56{
  grid-row-gap: 14rem !important;
  row-gap: 14rem !important;
}

.gap-y-64{
  grid-row-gap: 16rem !important;
  row-gap: 16rem !important;
}

.gap-y-px{
  grid-row-gap: 1px !important;
  row-gap: 1px !important;
}

.grid-flow-row{
  grid-auto-flow: row !important;
}

.grid-flow-col{
  grid-auto-flow: column !important;
}

.grid-flow-row-dense{
  grid-auto-flow: row dense !important;
}

.grid-flow-col-dense{
  grid-auto-flow: column dense !important;
}

.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}

.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}

.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}

.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}

.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
}

.grid-cols-6{
  grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
}

.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
}

.grid-cols-8{
  grid-template-columns: repeat(8, minmax(0, 1fr)) !important;
}

.grid-cols-9{
  grid-template-columns: repeat(9, minmax(0, 1fr)) !important;
}

.grid-cols-10{
  grid-template-columns: repeat(10, minmax(0, 1fr)) !important;
}

.grid-cols-11{
  grid-template-columns: repeat(11, minmax(0, 1fr)) !important;
}

.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
}

.grid-cols-none{
  grid-template-columns: none !important;
}

.auto-cols-auto{
  grid-auto-columns: auto !important;
}

.auto-cols-min{
  grid-auto-columns: min-content !important;
}

.auto-cols-max{
  grid-auto-columns: max-content !important;
}

.auto-cols-fr{
  grid-auto-columns: minmax(0, 1fr) !important;
}

.col-auto{
  grid-column: auto !important;
}

.col-span-1{
  grid-column: span 1 / span 1 !important;
}

.col-span-2{
  grid-column: span 2 / span 2 !important;
}

.col-span-3{
  grid-column: span 3 / span 3 !important;
}

.col-span-4{
  grid-column: span 4 / span 4 !important;
}

.col-span-5{
  grid-column: span 5 / span 5 !important;
}

.col-span-6{
  grid-column: span 6 / span 6 !important;
}

.col-span-7{
  grid-column: span 7 / span 7 !important;
}

.col-span-8{
  grid-column: span 8 / span 8 !important;
}

.col-span-9{
  grid-column: span 9 / span 9 !important;
}

.col-span-10{
  grid-column: span 10 / span 10 !important;
}

.col-span-11{
  grid-column: span 11 / span 11 !important;
}

.col-span-12{
  grid-column: span 12 / span 12 !important;
}

.col-span-full{
  grid-column: 1 / -1 !important;
}

.col-start-1{
  grid-column-start: 1 !important;
}

.col-start-2{
  grid-column-start: 2 !important;
}

.col-start-3{
  grid-column-start: 3 !important;
}

.col-start-4{
  grid-column-start: 4 !important;
}

.col-start-5{
  grid-column-start: 5 !important;
}

.col-start-6{
  grid-column-start: 6 !important;
}

.col-start-7{
  grid-column-start: 7 !important;
}

.col-start-8{
  grid-column-start: 8 !important;
}

.col-start-9{
  grid-column-start: 9 !important;
}

.col-start-10{
  grid-column-start: 10 !important;
}

.col-start-11{
  grid-column-start: 11 !important;
}

.col-start-12{
  grid-column-start: 12 !important;
}

.col-start-13{
  grid-column-start: 13 !important;
}

.col-start-auto{
  grid-column-start: auto !important;
}

.col-end-1{
  grid-column-end: 1 !important;
}

.col-end-2{
  grid-column-end: 2 !important;
}

.col-end-3{
  grid-column-end: 3 !important;
}

.col-end-4{
  grid-column-end: 4 !important;
}

.col-end-5{
  grid-column-end: 5 !important;
}

.col-end-6{
  grid-column-end: 6 !important;
}

.col-end-7{
  grid-column-end: 7 !important;
}

.col-end-8{
  grid-column-end: 8 !important;
}

.col-end-9{
  grid-column-end: 9 !important;
}

.col-end-10{
  grid-column-end: 10 !important;
}

.col-end-11{
  grid-column-end: 11 !important;
}

.col-end-12{
  grid-column-end: 12 !important;
}

.col-end-13{
  grid-column-end: 13 !important;
}

.col-end-auto{
  grid-column-end: auto !important;
}

.grid-rows-1{
  grid-template-rows: repeat(1, minmax(0, 1fr)) !important;
}

.grid-rows-2{
  grid-template-rows: repeat(2, minmax(0, 1fr)) !important;
}

.grid-rows-3{
  grid-template-rows: repeat(3, minmax(0, 1fr)) !important;
}

.grid-rows-4{
  grid-template-rows: repeat(4, minmax(0, 1fr)) !important;
}

.grid-rows-5{
  grid-template-rows: repeat(5, minmax(0, 1fr)) !important;
}

.grid-rows-6{
  grid-template-rows: repeat(6, minmax(0, 1fr)) !important;
}

.grid-rows-none{
  grid-template-rows: none !important;
}

.auto-rows-auto{
  grid-auto-rows: auto !important;
}

.auto-rows-min{
  grid-auto-rows: min-content !important;
}

.auto-rows-max{
  grid-auto-rows: max-content !important;
}

.auto-rows-fr{
  grid-auto-rows: minmax(0, 1fr) !important;
}

.row-auto{
  grid-row: auto !important;
}

.row-span-1{
  grid-row: span 1 / span 1 !important;
}

.row-span-2{
  grid-row: span 2 / span 2 !important;
}

.row-span-3{
  grid-row: span 3 / span 3 !important;
}

.row-span-4{
  grid-row: span 4 / span 4 !important;
}

.row-span-5{
  grid-row: span 5 / span 5 !important;
}

.row-span-6{
  grid-row: span 6 / span 6 !important;
}

.row-span-full{
  grid-row: 1 / -1 !important;
}

.row-start-1{
  grid-row-start: 1 !important;
}

.row-start-2{
  grid-row-start: 2 !important;
}

.row-start-3{
  grid-row-start: 3 !important;
}

.row-start-4{
  grid-row-start: 4 !important;
}

.row-start-5{
  grid-row-start: 5 !important;
}

.row-start-6{
  grid-row-start: 6 !important;
}

.row-start-7{
  grid-row-start: 7 !important;
}

.row-start-auto{
  grid-row-start: auto !important;
}

.row-end-1{
  grid-row-end: 1 !important;
}

.row-end-2{
  grid-row-end: 2 !important;
}

.row-end-3{
  grid-row-end: 3 !important;
}

.row-end-4{
  grid-row-end: 4 !important;
}

.row-end-5{
  grid-row-end: 5 !important;
}

.row-end-6{
  grid-row-end: 6 !important;
}

.row-end-7{
  grid-row-end: 7 !important;
}

.row-end-auto{
  grid-row-end: auto !important;
}

.transform{
  --transform-translate-x: 0 !important;
  --transform-translate-y: 0 !important;
  --transform-rotate: 0 !important;
  --transform-skew-x: 0 !important;
  --transform-skew-y: 0 !important;
  --transform-scale-x: 1 !important;
  --transform-scale-y: 1 !important;
}

[dir] .transform{
  transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y)) !important;
}

[dir] .transform-none{
  transform: none !important;
}

[dir] .origin-center{
  transform-origin: center !important;
}

[dir] .origin-top{
  transform-origin: top !important;
}

[dir=ltr] .origin-top-right{
  transform-origin: top right !important;
}

[dir=rtl] .origin-top-right{
  transform-origin: top left !important;
}

[dir=ltr] .origin-right{
  transform-origin: right !important;
}

[dir=rtl] .origin-right{
  transform-origin: left !important;
}

[dir=ltr] .origin-bottom-right{
  transform-origin: bottom right !important;
}

[dir=rtl] .origin-bottom-right{
  transform-origin: bottom left !important;
}

[dir] .origin-bottom{
  transform-origin: bottom !important;
}

[dir=ltr] .origin-bottom-left{
  transform-origin: bottom left !important;
}

[dir=rtl] .origin-bottom-left{
  transform-origin: bottom right !important;
}

[dir=ltr] .origin-left{
  transform-origin: left !important;
}

[dir=rtl] .origin-left{
  transform-origin: right !important;
}

[dir=ltr] .origin-top-left{
  transform-origin: top left !important;
}

[dir=rtl] .origin-top-left{
  transform-origin: top right !important;
}

.scale-0{
  --transform-scale-x: 0 !important;
  --transform-scale-y: 0 !important;
}

.scale-50{
  --transform-scale-x: .5 !important;
  --transform-scale-y: .5 !important;
}

.scale-75{
  --transform-scale-x: .75 !important;
  --transform-scale-y: .75 !important;
}

.scale-90{
  --transform-scale-x: .9 !important;
  --transform-scale-y: .9 !important;
}

.scale-95{
  --transform-scale-x: .95 !important;
  --transform-scale-y: .95 !important;
}

.scale-100{
  --transform-scale-x: 1 !important;
  --transform-scale-y: 1 !important;
}

.scale-105{
  --transform-scale-x: 1.05 !important;
  --transform-scale-y: 1.05 !important;
}

.scale-110{
  --transform-scale-x: 1.1 !important;
  --transform-scale-y: 1.1 !important;
}

.scale-125{
  --transform-scale-x: 1.25 !important;
  --transform-scale-y: 1.25 !important;
}

.scale-150{
  --transform-scale-x: 1.5 !important;
  --transform-scale-y: 1.5 !important;
}

.scale-x-0{
  --transform-scale-x: 0 !important;
}

.scale-x-50{
  --transform-scale-x: .5 !important;
}

.scale-x-75{
  --transform-scale-x: .75 !important;
}

.scale-x-90{
  --transform-scale-x: .9 !important;
}

.scale-x-95{
  --transform-scale-x: .95 !important;
}

.scale-x-100{
  --transform-scale-x: 1 !important;
}

.scale-x-105{
  --transform-scale-x: 1.05 !important;
}

.scale-x-110{
  --transform-scale-x: 1.1 !important;
}

.scale-x-125{
  --transform-scale-x: 1.25 !important;
}

.scale-x-150{
  --transform-scale-x: 1.5 !important;
}

.scale-y-0{
  --transform-scale-y: 0 !important;
}

.scale-y-50{
  --transform-scale-y: .5 !important;
}

.scale-y-75{
  --transform-scale-y: .75 !important;
}

.scale-y-90{
  --transform-scale-y: .9 !important;
}

.scale-y-95{
  --transform-scale-y: .95 !important;
}

.scale-y-100{
  --transform-scale-y: 1 !important;
}

.scale-y-105{
  --transform-scale-y: 1.05 !important;
}

.scale-y-110{
  --transform-scale-y: 1.1 !important;
}

.scale-y-125{
  --transform-scale-y: 1.25 !important;
}

.scale-y-150{
  --transform-scale-y: 1.5 !important;
}

.hover\\:scale-0:hover{
  --transform-scale-x: 0 !important;
  --transform-scale-y: 0 !important;
}

.hover\\:scale-50:hover{
  --transform-scale-x: .5 !important;
  --transform-scale-y: .5 !important;
}

.hover\\:scale-75:hover{
  --transform-scale-x: .75 !important;
  --transform-scale-y: .75 !important;
}

.hover\\:scale-90:hover{
  --transform-scale-x: .9 !important;
  --transform-scale-y: .9 !important;
}

.hover\\:scale-95:hover{
  --transform-scale-x: .95 !important;
  --transform-scale-y: .95 !important;
}

.hover\\:scale-100:hover{
  --transform-scale-x: 1 !important;
  --transform-scale-y: 1 !important;
}

.hover\\:scale-105:hover{
  --transform-scale-x: 1.05 !important;
  --transform-scale-y: 1.05 !important;
}

.hover\\:scale-110:hover{
  --transform-scale-x: 1.1 !important;
  --transform-scale-y: 1.1 !important;
}

.hover\\:scale-125:hover{
  --transform-scale-x: 1.25 !important;
  --transform-scale-y: 1.25 !important;
}

.hover\\:scale-150:hover{
  --transform-scale-x: 1.5 !important;
  --transform-scale-y: 1.5 !important;
}

.hover\\:scale-x-0:hover{
  --transform-scale-x: 0 !important;
}

.hover\\:scale-x-50:hover{
  --transform-scale-x: .5 !important;
}

.hover\\:scale-x-75:hover{
  --transform-scale-x: .75 !important;
}

.hover\\:scale-x-90:hover{
  --transform-scale-x: .9 !important;
}

.hover\\:scale-x-95:hover{
  --transform-scale-x: .95 !important;
}

.hover\\:scale-x-100:hover{
  --transform-scale-x: 1 !important;
}

.hover\\:scale-x-105:hover{
  --transform-scale-x: 1.05 !important;
}

.hover\\:scale-x-110:hover{
  --transform-scale-x: 1.1 !important;
}

.hover\\:scale-x-125:hover{
  --transform-scale-x: 1.25 !important;
}

.hover\\:scale-x-150:hover{
  --transform-scale-x: 1.5 !important;
}

.hover\\:scale-y-0:hover{
  --transform-scale-y: 0 !important;
}

.hover\\:scale-y-50:hover{
  --transform-scale-y: .5 !important;
}

.hover\\:scale-y-75:hover{
  --transform-scale-y: .75 !important;
}

.hover\\:scale-y-90:hover{
  --transform-scale-y: .9 !important;
}

.hover\\:scale-y-95:hover{
  --transform-scale-y: .95 !important;
}

.hover\\:scale-y-100:hover{
  --transform-scale-y: 1 !important;
}

.hover\\:scale-y-105:hover{
  --transform-scale-y: 1.05 !important;
}

.hover\\:scale-y-110:hover{
  --transform-scale-y: 1.1 !important;
}

.hover\\:scale-y-125:hover{
  --transform-scale-y: 1.25 !important;
}

.hover\\:scale-y-150:hover{
  --transform-scale-y: 1.5 !important;
}

.focus\\:scale-0:focus{
  --transform-scale-x: 0 !important;
  --transform-scale-y: 0 !important;
}

.focus\\:scale-50:focus{
  --transform-scale-x: .5 !important;
  --transform-scale-y: .5 !important;
}

.focus\\:scale-75:focus{
  --transform-scale-x: .75 !important;
  --transform-scale-y: .75 !important;
}

.focus\\:scale-90:focus{
  --transform-scale-x: .9 !important;
  --transform-scale-y: .9 !important;
}

.focus\\:scale-95:focus{
  --transform-scale-x: .95 !important;
  --transform-scale-y: .95 !important;
}

.focus\\:scale-100:focus{
  --transform-scale-x: 1 !important;
  --transform-scale-y: 1 !important;
}

.focus\\:scale-105:focus{
  --transform-scale-x: 1.05 !important;
  --transform-scale-y: 1.05 !important;
}

.focus\\:scale-110:focus{
  --transform-scale-x: 1.1 !important;
  --transform-scale-y: 1.1 !important;
}

.focus\\:scale-125:focus{
  --transform-scale-x: 1.25 !important;
  --transform-scale-y: 1.25 !important;
}

.focus\\:scale-150:focus{
  --transform-scale-x: 1.5 !important;
  --transform-scale-y: 1.5 !important;
}

.focus\\:scale-x-0:focus{
  --transform-scale-x: 0 !important;
}

.focus\\:scale-x-50:focus{
  --transform-scale-x: .5 !important;
}

.focus\\:scale-x-75:focus{
  --transform-scale-x: .75 !important;
}

.focus\\:scale-x-90:focus{
  --transform-scale-x: .9 !important;
}

.focus\\:scale-x-95:focus{
  --transform-scale-x: .95 !important;
}

.focus\\:scale-x-100:focus{
  --transform-scale-x: 1 !important;
}

.focus\\:scale-x-105:focus{
  --transform-scale-x: 1.05 !important;
}

.focus\\:scale-x-110:focus{
  --transform-scale-x: 1.1 !important;
}

.focus\\:scale-x-125:focus{
  --transform-scale-x: 1.25 !important;
}

.focus\\:scale-x-150:focus{
  --transform-scale-x: 1.5 !important;
}

.focus\\:scale-y-0:focus{
  --transform-scale-y: 0 !important;
}

.focus\\:scale-y-50:focus{
  --transform-scale-y: .5 !important;
}

.focus\\:scale-y-75:focus{
  --transform-scale-y: .75 !important;
}

.focus\\:scale-y-90:focus{
  --transform-scale-y: .9 !important;
}

.focus\\:scale-y-95:focus{
  --transform-scale-y: .95 !important;
}

.focus\\:scale-y-100:focus{
  --transform-scale-y: 1 !important;
}

.focus\\:scale-y-105:focus{
  --transform-scale-y: 1.05 !important;
}

.focus\\:scale-y-110:focus{
  --transform-scale-y: 1.1 !important;
}

.focus\\:scale-y-125:focus{
  --transform-scale-y: 1.25 !important;
}

.focus\\:scale-y-150:focus{
  --transform-scale-y: 1.5 !important;
}

.rotate-0{
  --transform-rotate: 0 !important;
}

.rotate-1{
  --transform-rotate: 1deg !important;
}

.rotate-2{
  --transform-rotate: 2deg !important;
}

.rotate-3{
  --transform-rotate: 3deg !important;
}

.rotate-6{
  --transform-rotate: 6deg !important;
}

.rotate-12{
  --transform-rotate: 12deg !important;
}

.rotate-45{
  --transform-rotate: 45deg !important;
}

.rotate-90{
  --transform-rotate: 90deg !important;
}

.rotate-180{
  --transform-rotate: 180deg !important;
}

.-rotate-180{
  --transform-rotate: -180deg !important;
}

.-rotate-90{
  --transform-rotate: -90deg !important;
}

.-rotate-45{
  --transform-rotate: -45deg !important;
}

.-rotate-12{
  --transform-rotate: -12deg !important;
}

.-rotate-6{
  --transform-rotate: -6deg !important;
}

.-rotate-3{
  --transform-rotate: -3deg !important;
}

.-rotate-2{
  --transform-rotate: -2deg !important;
}

.-rotate-1{
  --transform-rotate: -1deg !important;
}

.hover\\:rotate-0:hover{
  --transform-rotate: 0 !important;
}

.hover\\:rotate-1:hover{
  --transform-rotate: 1deg !important;
}

.hover\\:rotate-2:hover{
  --transform-rotate: 2deg !important;
}

.hover\\:rotate-3:hover{
  --transform-rotate: 3deg !important;
}

.hover\\:rotate-6:hover{
  --transform-rotate: 6deg !important;
}

.hover\\:rotate-12:hover{
  --transform-rotate: 12deg !important;
}

.hover\\:rotate-45:hover{
  --transform-rotate: 45deg !important;
}

.hover\\:rotate-90:hover{
  --transform-rotate: 90deg !important;
}

.hover\\:rotate-180:hover{
  --transform-rotate: 180deg !important;
}

.hover\\:-rotate-180:hover{
  --transform-rotate: -180deg !important;
}

.hover\\:-rotate-90:hover{
  --transform-rotate: -90deg !important;
}

.hover\\:-rotate-45:hover{
  --transform-rotate: -45deg !important;
}

.hover\\:-rotate-12:hover{
  --transform-rotate: -12deg !important;
}

.hover\\:-rotate-6:hover{
  --transform-rotate: -6deg !important;
}

.hover\\:-rotate-3:hover{
  --transform-rotate: -3deg !important;
}

.hover\\:-rotate-2:hover{
  --transform-rotate: -2deg !important;
}

.hover\\:-rotate-1:hover{
  --transform-rotate: -1deg !important;
}

.focus\\:rotate-0:focus{
  --transform-rotate: 0 !important;
}

.focus\\:rotate-1:focus{
  --transform-rotate: 1deg !important;
}

.focus\\:rotate-2:focus{
  --transform-rotate: 2deg !important;
}

.focus\\:rotate-3:focus{
  --transform-rotate: 3deg !important;
}

.focus\\:rotate-6:focus{
  --transform-rotate: 6deg !important;
}

.focus\\:rotate-12:focus{
  --transform-rotate: 12deg !important;
}

.focus\\:rotate-45:focus{
  --transform-rotate: 45deg !important;
}

.focus\\:rotate-90:focus{
  --transform-rotate: 90deg !important;
}

.focus\\:rotate-180:focus{
  --transform-rotate: 180deg !important;
}

.focus\\:-rotate-180:focus{
  --transform-rotate: -180deg !important;
}

.focus\\:-rotate-90:focus{
  --transform-rotate: -90deg !important;
}

.focus\\:-rotate-45:focus{
  --transform-rotate: -45deg !important;
}

.focus\\:-rotate-12:focus{
  --transform-rotate: -12deg !important;
}

.focus\\:-rotate-6:focus{
  --transform-rotate: -6deg !important;
}

.focus\\:-rotate-3:focus{
  --transform-rotate: -3deg !important;
}

.focus\\:-rotate-2:focus{
  --transform-rotate: -2deg !important;
}

.focus\\:-rotate-1:focus{
  --transform-rotate: -1deg !important;
}

.translate-x-0{
  --transform-translate-x: 0 !important;
}

.translate-x-1{
  --transform-translate-x: 0.25rem !important;
}

.translate-x-2{
  --transform-translate-x: 0.5rem !important;
}

.translate-x-3{
  --transform-translate-x: 0.75rem !important;
}

.translate-x-4{
  --transform-translate-x: 1rem !important;
}

.translate-x-5{
  --transform-translate-x: 1.25rem !important;
}

.translate-x-6{
  --transform-translate-x: 1.5rem !important;
}

.translate-x-8{
  --transform-translate-x: 2rem !important;
}

.translate-x-10{
  --transform-translate-x: 2.5rem !important;
}

.translate-x-12{
  --transform-translate-x: 3rem !important;
}

.translate-x-16{
  --transform-translate-x: 4rem !important;
}

.translate-x-20{
  --transform-translate-x: 5rem !important;
}

.translate-x-24{
  --transform-translate-x: 6rem !important;
}

.translate-x-32{
  --transform-translate-x: 8rem !important;
}

.translate-x-40{
  --transform-translate-x: 10rem !important;
}

.translate-x-48{
  --transform-translate-x: 12rem !important;
}

.translate-x-56{
  --transform-translate-x: 14rem !important;
}

.translate-x-64{
  --transform-translate-x: 16rem !important;
}

.translate-x-px{
  --transform-translate-x: 1px !important;
}

.-translate-x-1{
  --transform-translate-x: -0.25rem !important;
}

.-translate-x-2{
  --transform-translate-x: -0.5rem !important;
}

.-translate-x-3{
  --transform-translate-x: -0.75rem !important;
}

.-translate-x-4{
  --transform-translate-x: -1rem !important;
}

.-translate-x-5{
  --transform-translate-x: -1.25rem !important;
}

.-translate-x-6{
  --transform-translate-x: -1.5rem !important;
}

.-translate-x-8{
  --transform-translate-x: -2rem !important;
}

.-translate-x-10{
  --transform-translate-x: -2.5rem !important;
}

.-translate-x-12{
  --transform-translate-x: -3rem !important;
}

.-translate-x-16{
  --transform-translate-x: -4rem !important;
}

.-translate-x-20{
  --transform-translate-x: -5rem !important;
}

.-translate-x-24{
  --transform-translate-x: -6rem !important;
}

.-translate-x-32{
  --transform-translate-x: -8rem !important;
}

.-translate-x-40{
  --transform-translate-x: -10rem !important;
}

.-translate-x-48{
  --transform-translate-x: -12rem !important;
}

.-translate-x-56{
  --transform-translate-x: -14rem !important;
}

.-translate-x-64{
  --transform-translate-x: -16rem !important;
}

.-translate-x-px{
  --transform-translate-x: -1px !important;
}

.-translate-x-full{
  --transform-translate-x: -100% !important;
}

.-translate-x-1\\/2{
  --transform-translate-x: -50% !important;
}

.translate-x-1\\/2{
  --transform-translate-x: 50% !important;
}

.translate-x-full{
  --transform-translate-x: 100% !important;
}

.translate-y-0{
  --transform-translate-y: 0 !important;
}

.translate-y-1{
  --transform-translate-y: 0.25rem !important;
}

.translate-y-2{
  --transform-translate-y: 0.5rem !important;
}

.translate-y-3{
  --transform-translate-y: 0.75rem !important;
}

.translate-y-4{
  --transform-translate-y: 1rem !important;
}

.translate-y-5{
  --transform-translate-y: 1.25rem !important;
}

.translate-y-6{
  --transform-translate-y: 1.5rem !important;
}

.translate-y-8{
  --transform-translate-y: 2rem !important;
}

.translate-y-10{
  --transform-translate-y: 2.5rem !important;
}

.translate-y-12{
  --transform-translate-y: 3rem !important;
}

.translate-y-16{
  --transform-translate-y: 4rem !important;
}

.translate-y-20{
  --transform-translate-y: 5rem !important;
}

.translate-y-24{
  --transform-translate-y: 6rem !important;
}

.translate-y-32{
  --transform-translate-y: 8rem !important;
}

.translate-y-40{
  --transform-translate-y: 10rem !important;
}

.translate-y-48{
  --transform-translate-y: 12rem !important;
}

.translate-y-56{
  --transform-translate-y: 14rem !important;
}

.translate-y-64{
  --transform-translate-y: 16rem !important;
}

.translate-y-px{
  --transform-translate-y: 1px !important;
}

.-translate-y-1{
  --transform-translate-y: -0.25rem !important;
}

.-translate-y-2{
  --transform-translate-y: -0.5rem !important;
}

.-translate-y-3{
  --transform-translate-y: -0.75rem !important;
}

.-translate-y-4{
  --transform-translate-y: -1rem !important;
}

.-translate-y-5{
  --transform-translate-y: -1.25rem !important;
}

.-translate-y-6{
  --transform-translate-y: -1.5rem !important;
}

.-translate-y-8{
  --transform-translate-y: -2rem !important;
}

.-translate-y-10{
  --transform-translate-y: -2.5rem !important;
}

.-translate-y-12{
  --transform-translate-y: -3rem !important;
}

.-translate-y-16{
  --transform-translate-y: -4rem !important;
}

.-translate-y-20{
  --transform-translate-y: -5rem !important;
}

.-translate-y-24{
  --transform-translate-y: -6rem !important;
}

.-translate-y-32{
  --transform-translate-y: -8rem !important;
}

.-translate-y-40{
  --transform-translate-y: -10rem !important;
}

.-translate-y-48{
  --transform-translate-y: -12rem !important;
}

.-translate-y-56{
  --transform-translate-y: -14rem !important;
}

.-translate-y-64{
  --transform-translate-y: -16rem !important;
}

.-translate-y-px{
  --transform-translate-y: -1px !important;
}

.-translate-y-full{
  --transform-translate-y: -100% !important;
}

.-translate-y-1\\/2{
  --transform-translate-y: -50% !important;
}

.translate-y-1\\/2{
  --transform-translate-y: 50% !important;
}

.translate-y-full{
  --transform-translate-y: 100% !important;
}

.hover\\:translate-x-0:hover{
  --transform-translate-x: 0 !important;
}

.hover\\:translate-x-1:hover{
  --transform-translate-x: 0.25rem !important;
}

.hover\\:translate-x-2:hover{
  --transform-translate-x: 0.5rem !important;
}

.hover\\:translate-x-3:hover{
  --transform-translate-x: 0.75rem !important;
}

.hover\\:translate-x-4:hover{
  --transform-translate-x: 1rem !important;
}

.hover\\:translate-x-5:hover{
  --transform-translate-x: 1.25rem !important;
}

.hover\\:translate-x-6:hover{
  --transform-translate-x: 1.5rem !important;
}

.hover\\:translate-x-8:hover{
  --transform-translate-x: 2rem !important;
}

.hover\\:translate-x-10:hover{
  --transform-translate-x: 2.5rem !important;
}

.hover\\:translate-x-12:hover{
  --transform-translate-x: 3rem !important;
}

.hover\\:translate-x-16:hover{
  --transform-translate-x: 4rem !important;
}

.hover\\:translate-x-20:hover{
  --transform-translate-x: 5rem !important;
}

.hover\\:translate-x-24:hover{
  --transform-translate-x: 6rem !important;
}

.hover\\:translate-x-32:hover{
  --transform-translate-x: 8rem !important;
}

.hover\\:translate-x-40:hover{
  --transform-translate-x: 10rem !important;
}

.hover\\:translate-x-48:hover{
  --transform-translate-x: 12rem !important;
}

.hover\\:translate-x-56:hover{
  --transform-translate-x: 14rem !important;
}

.hover\\:translate-x-64:hover{
  --transform-translate-x: 16rem !important;
}

.hover\\:translate-x-px:hover{
  --transform-translate-x: 1px !important;
}

.hover\\:-translate-x-1:hover{
  --transform-translate-x: -0.25rem !important;
}

.hover\\:-translate-x-2:hover{
  --transform-translate-x: -0.5rem !important;
}

.hover\\:-translate-x-3:hover{
  --transform-translate-x: -0.75rem !important;
}

.hover\\:-translate-x-4:hover{
  --transform-translate-x: -1rem !important;
}

.hover\\:-translate-x-5:hover{
  --transform-translate-x: -1.25rem !important;
}

.hover\\:-translate-x-6:hover{
  --transform-translate-x: -1.5rem !important;
}

.hover\\:-translate-x-8:hover{
  --transform-translate-x: -2rem !important;
}

.hover\\:-translate-x-10:hover{
  --transform-translate-x: -2.5rem !important;
}

.hover\\:-translate-x-12:hover{
  --transform-translate-x: -3rem !important;
}

.hover\\:-translate-x-16:hover{
  --transform-translate-x: -4rem !important;
}

.hover\\:-translate-x-20:hover{
  --transform-translate-x: -5rem !important;
}

.hover\\:-translate-x-24:hover{
  --transform-translate-x: -6rem !important;
}

.hover\\:-translate-x-32:hover{
  --transform-translate-x: -8rem !important;
}

.hover\\:-translate-x-40:hover{
  --transform-translate-x: -10rem !important;
}

.hover\\:-translate-x-48:hover{
  --transform-translate-x: -12rem !important;
}

.hover\\:-translate-x-56:hover{
  --transform-translate-x: -14rem !important;
}

.hover\\:-translate-x-64:hover{
  --transform-translate-x: -16rem !important;
}

.hover\\:-translate-x-px:hover{
  --transform-translate-x: -1px !important;
}

.hover\\:-translate-x-full:hover{
  --transform-translate-x: -100% !important;
}

.hover\\:-translate-x-1\\/2:hover{
  --transform-translate-x: -50% !important;
}

.hover\\:translate-x-1\\/2:hover{
  --transform-translate-x: 50% !important;
}

.hover\\:translate-x-full:hover{
  --transform-translate-x: 100% !important;
}

.hover\\:translate-y-0:hover{
  --transform-translate-y: 0 !important;
}

.hover\\:translate-y-1:hover{
  --transform-translate-y: 0.25rem !important;
}

.hover\\:translate-y-2:hover{
  --transform-translate-y: 0.5rem !important;
}

.hover\\:translate-y-3:hover{
  --transform-translate-y: 0.75rem !important;
}

.hover\\:translate-y-4:hover{
  --transform-translate-y: 1rem !important;
}

.hover\\:translate-y-5:hover{
  --transform-translate-y: 1.25rem !important;
}

.hover\\:translate-y-6:hover{
  --transform-translate-y: 1.5rem !important;
}

.hover\\:translate-y-8:hover{
  --transform-translate-y: 2rem !important;
}

.hover\\:translate-y-10:hover{
  --transform-translate-y: 2.5rem !important;
}

.hover\\:translate-y-12:hover{
  --transform-translate-y: 3rem !important;
}

.hover\\:translate-y-16:hover{
  --transform-translate-y: 4rem !important;
}

.hover\\:translate-y-20:hover{
  --transform-translate-y: 5rem !important;
}

.hover\\:translate-y-24:hover{
  --transform-translate-y: 6rem !important;
}

.hover\\:translate-y-32:hover{
  --transform-translate-y: 8rem !important;
}

.hover\\:translate-y-40:hover{
  --transform-translate-y: 10rem !important;
}

.hover\\:translate-y-48:hover{
  --transform-translate-y: 12rem !important;
}

.hover\\:translate-y-56:hover{
  --transform-translate-y: 14rem !important;
}

.hover\\:translate-y-64:hover{
  --transform-translate-y: 16rem !important;
}

.hover\\:translate-y-px:hover{
  --transform-translate-y: 1px !important;
}

.hover\\:-translate-y-1:hover{
  --transform-translate-y: -0.25rem !important;
}

.hover\\:-translate-y-2:hover{
  --transform-translate-y: -0.5rem !important;
}

.hover\\:-translate-y-3:hover{
  --transform-translate-y: -0.75rem !important;
}

.hover\\:-translate-y-4:hover{
  --transform-translate-y: -1rem !important;
}

.hover\\:-translate-y-5:hover{
  --transform-translate-y: -1.25rem !important;
}

.hover\\:-translate-y-6:hover{
  --transform-translate-y: -1.5rem !important;
}

.hover\\:-translate-y-8:hover{
  --transform-translate-y: -2rem !important;
}

.hover\\:-translate-y-10:hover{
  --transform-translate-y: -2.5rem !important;
}

.hover\\:-translate-y-12:hover{
  --transform-translate-y: -3rem !important;
}

.hover\\:-translate-y-16:hover{
  --transform-translate-y: -4rem !important;
}

.hover\\:-translate-y-20:hover{
  --transform-translate-y: -5rem !important;
}

.hover\\:-translate-y-24:hover{
  --transform-translate-y: -6rem !important;
}

.hover\\:-translate-y-32:hover{
  --transform-translate-y: -8rem !important;
}

.hover\\:-translate-y-40:hover{
  --transform-translate-y: -10rem !important;
}

.hover\\:-translate-y-48:hover{
  --transform-translate-y: -12rem !important;
}

.hover\\:-translate-y-56:hover{
  --transform-translate-y: -14rem !important;
}

.hover\\:-translate-y-64:hover{
  --transform-translate-y: -16rem !important;
}

.hover\\:-translate-y-px:hover{
  --transform-translate-y: -1px !important;
}

.hover\\:-translate-y-full:hover{
  --transform-translate-y: -100% !important;
}

.hover\\:-translate-y-1\\/2:hover{
  --transform-translate-y: -50% !important;
}

.hover\\:translate-y-1\\/2:hover{
  --transform-translate-y: 50% !important;
}

.hover\\:translate-y-full:hover{
  --transform-translate-y: 100% !important;
}

.focus\\:translate-x-0:focus{
  --transform-translate-x: 0 !important;
}

.focus\\:translate-x-1:focus{
  --transform-translate-x: 0.25rem !important;
}

.focus\\:translate-x-2:focus{
  --transform-translate-x: 0.5rem !important;
}

.focus\\:translate-x-3:focus{
  --transform-translate-x: 0.75rem !important;
}

.focus\\:translate-x-4:focus{
  --transform-translate-x: 1rem !important;
}

.focus\\:translate-x-5:focus{
  --transform-translate-x: 1.25rem !important;
}

.focus\\:translate-x-6:focus{
  --transform-translate-x: 1.5rem !important;
}

.focus\\:translate-x-8:focus{
  --transform-translate-x: 2rem !important;
}

.focus\\:translate-x-10:focus{
  --transform-translate-x: 2.5rem !important;
}

.focus\\:translate-x-12:focus{
  --transform-translate-x: 3rem !important;
}

.focus\\:translate-x-16:focus{
  --transform-translate-x: 4rem !important;
}

.focus\\:translate-x-20:focus{
  --transform-translate-x: 5rem !important;
}

.focus\\:translate-x-24:focus{
  --transform-translate-x: 6rem !important;
}

.focus\\:translate-x-32:focus{
  --transform-translate-x: 8rem !important;
}

.focus\\:translate-x-40:focus{
  --transform-translate-x: 10rem !important;
}

.focus\\:translate-x-48:focus{
  --transform-translate-x: 12rem !important;
}

.focus\\:translate-x-56:focus{
  --transform-translate-x: 14rem !important;
}

.focus\\:translate-x-64:focus{
  --transform-translate-x: 16rem !important;
}

.focus\\:translate-x-px:focus{
  --transform-translate-x: 1px !important;
}

.focus\\:-translate-x-1:focus{
  --transform-translate-x: -0.25rem !important;
}

.focus\\:-translate-x-2:focus{
  --transform-translate-x: -0.5rem !important;
}

.focus\\:-translate-x-3:focus{
  --transform-translate-x: -0.75rem !important;
}

.focus\\:-translate-x-4:focus{
  --transform-translate-x: -1rem !important;
}

.focus\\:-translate-x-5:focus{
  --transform-translate-x: -1.25rem !important;
}

.focus\\:-translate-x-6:focus{
  --transform-translate-x: -1.5rem !important;
}

.focus\\:-translate-x-8:focus{
  --transform-translate-x: -2rem !important;
}

.focus\\:-translate-x-10:focus{
  --transform-translate-x: -2.5rem !important;
}

.focus\\:-translate-x-12:focus{
  --transform-translate-x: -3rem !important;
}

.focus\\:-translate-x-16:focus{
  --transform-translate-x: -4rem !important;
}

.focus\\:-translate-x-20:focus{
  --transform-translate-x: -5rem !important;
}

.focus\\:-translate-x-24:focus{
  --transform-translate-x: -6rem !important;
}

.focus\\:-translate-x-32:focus{
  --transform-translate-x: -8rem !important;
}

.focus\\:-translate-x-40:focus{
  --transform-translate-x: -10rem !important;
}

.focus\\:-translate-x-48:focus{
  --transform-translate-x: -12rem !important;
}

.focus\\:-translate-x-56:focus{
  --transform-translate-x: -14rem !important;
}

.focus\\:-translate-x-64:focus{
  --transform-translate-x: -16rem !important;
}

.focus\\:-translate-x-px:focus{
  --transform-translate-x: -1px !important;
}

.focus\\:-translate-x-full:focus{
  --transform-translate-x: -100% !important;
}

.focus\\:-translate-x-1\\/2:focus{
  --transform-translate-x: -50% !important;
}

.focus\\:translate-x-1\\/2:focus{
  --transform-translate-x: 50% !important;
}

.focus\\:translate-x-full:focus{
  --transform-translate-x: 100% !important;
}

.focus\\:translate-y-0:focus{
  --transform-translate-y: 0 !important;
}

.focus\\:translate-y-1:focus{
  --transform-translate-y: 0.25rem !important;
}

.focus\\:translate-y-2:focus{
  --transform-translate-y: 0.5rem !important;
}

.focus\\:translate-y-3:focus{
  --transform-translate-y: 0.75rem !important;
}

.focus\\:translate-y-4:focus{
  --transform-translate-y: 1rem !important;
}

.focus\\:translate-y-5:focus{
  --transform-translate-y: 1.25rem !important;
}

.focus\\:translate-y-6:focus{
  --transform-translate-y: 1.5rem !important;
}

.focus\\:translate-y-8:focus{
  --transform-translate-y: 2rem !important;
}

.focus\\:translate-y-10:focus{
  --transform-translate-y: 2.5rem !important;
}

.focus\\:translate-y-12:focus{
  --transform-translate-y: 3rem !important;
}

.focus\\:translate-y-16:focus{
  --transform-translate-y: 4rem !important;
}

.focus\\:translate-y-20:focus{
  --transform-translate-y: 5rem !important;
}

.focus\\:translate-y-24:focus{
  --transform-translate-y: 6rem !important;
}

.focus\\:translate-y-32:focus{
  --transform-translate-y: 8rem !important;
}

.focus\\:translate-y-40:focus{
  --transform-translate-y: 10rem !important;
}

.focus\\:translate-y-48:focus{
  --transform-translate-y: 12rem !important;
}

.focus\\:translate-y-56:focus{
  --transform-translate-y: 14rem !important;
}

.focus\\:translate-y-64:focus{
  --transform-translate-y: 16rem !important;
}

.focus\\:translate-y-px:focus{
  --transform-translate-y: 1px !important;
}

.focus\\:-translate-y-1:focus{
  --transform-translate-y: -0.25rem !important;
}

.focus\\:-translate-y-2:focus{
  --transform-translate-y: -0.5rem !important;
}

.focus\\:-translate-y-3:focus{
  --transform-translate-y: -0.75rem !important;
}

.focus\\:-translate-y-4:focus{
  --transform-translate-y: -1rem !important;
}

.focus\\:-translate-y-5:focus{
  --transform-translate-y: -1.25rem !important;
}

.focus\\:-translate-y-6:focus{
  --transform-translate-y: -1.5rem !important;
}

.focus\\:-translate-y-8:focus{
  --transform-translate-y: -2rem !important;
}

.focus\\:-translate-y-10:focus{
  --transform-translate-y: -2.5rem !important;
}

.focus\\:-translate-y-12:focus{
  --transform-translate-y: -3rem !important;
}

.focus\\:-translate-y-16:focus{
  --transform-translate-y: -4rem !important;
}

.focus\\:-translate-y-20:focus{
  --transform-translate-y: -5rem !important;
}

.focus\\:-translate-y-24:focus{
  --transform-translate-y: -6rem !important;
}

.focus\\:-translate-y-32:focus{
  --transform-translate-y: -8rem !important;
}

.focus\\:-translate-y-40:focus{
  --transform-translate-y: -10rem !important;
}

.focus\\:-translate-y-48:focus{
  --transform-translate-y: -12rem !important;
}

.focus\\:-translate-y-56:focus{
  --transform-translate-y: -14rem !important;
}

.focus\\:-translate-y-64:focus{
  --transform-translate-y: -16rem !important;
}

.focus\\:-translate-y-px:focus{
  --transform-translate-y: -1px !important;
}

.focus\\:-translate-y-full:focus{
  --transform-translate-y: -100% !important;
}

.focus\\:-translate-y-1\\/2:focus{
  --transform-translate-y: -50% !important;
}

.focus\\:translate-y-1\\/2:focus{
  --transform-translate-y: 50% !important;
}

.focus\\:translate-y-full:focus{
  --transform-translate-y: 100% !important;
}

.skew-x-0{
  --transform-skew-x: 0 !important;
}

.skew-x-1{
  --transform-skew-x: 1deg !important;
}

.skew-x-2{
  --transform-skew-x: 2deg !important;
}

.skew-x-3{
  --transform-skew-x: 3deg !important;
}

.skew-x-6{
  --transform-skew-x: 6deg !important;
}

.skew-x-12{
  --transform-skew-x: 12deg !important;
}

.-skew-x-12{
  --transform-skew-x: -12deg !important;
}

.-skew-x-6{
  --transform-skew-x: -6deg !important;
}

.-skew-x-3{
  --transform-skew-x: -3deg !important;
}

.-skew-x-2{
  --transform-skew-x: -2deg !important;
}

.-skew-x-1{
  --transform-skew-x: -1deg !important;
}

.skew-y-0{
  --transform-skew-y: 0 !important;
}

.skew-y-1{
  --transform-skew-y: 1deg !important;
}

.skew-y-2{
  --transform-skew-y: 2deg !important;
}

.skew-y-3{
  --transform-skew-y: 3deg !important;
}

.skew-y-6{
  --transform-skew-y: 6deg !important;
}

.skew-y-12{
  --transform-skew-y: 12deg !important;
}

.-skew-y-12{
  --transform-skew-y: -12deg !important;
}

.-skew-y-6{
  --transform-skew-y: -6deg !important;
}

.-skew-y-3{
  --transform-skew-y: -3deg !important;
}

.-skew-y-2{
  --transform-skew-y: -2deg !important;
}

.-skew-y-1{
  --transform-skew-y: -1deg !important;
}

.hover\\:skew-x-0:hover{
  --transform-skew-x: 0 !important;
}

.hover\\:skew-x-1:hover{
  --transform-skew-x: 1deg !important;
}

.hover\\:skew-x-2:hover{
  --transform-skew-x: 2deg !important;
}

.hover\\:skew-x-3:hover{
  --transform-skew-x: 3deg !important;
}

.hover\\:skew-x-6:hover{
  --transform-skew-x: 6deg !important;
}

.hover\\:skew-x-12:hover{
  --transform-skew-x: 12deg !important;
}

.hover\\:-skew-x-12:hover{
  --transform-skew-x: -12deg !important;
}

.hover\\:-skew-x-6:hover{
  --transform-skew-x: -6deg !important;
}

.hover\\:-skew-x-3:hover{
  --transform-skew-x: -3deg !important;
}

.hover\\:-skew-x-2:hover{
  --transform-skew-x: -2deg !important;
}

.hover\\:-skew-x-1:hover{
  --transform-skew-x: -1deg !important;
}

.hover\\:skew-y-0:hover{
  --transform-skew-y: 0 !important;
}

.hover\\:skew-y-1:hover{
  --transform-skew-y: 1deg !important;
}

.hover\\:skew-y-2:hover{
  --transform-skew-y: 2deg !important;
}

.hover\\:skew-y-3:hover{
  --transform-skew-y: 3deg !important;
}

.hover\\:skew-y-6:hover{
  --transform-skew-y: 6deg !important;
}

.hover\\:skew-y-12:hover{
  --transform-skew-y: 12deg !important;
}

.hover\\:-skew-y-12:hover{
  --transform-skew-y: -12deg !important;
}

.hover\\:-skew-y-6:hover{
  --transform-skew-y: -6deg !important;
}

.hover\\:-skew-y-3:hover{
  --transform-skew-y: -3deg !important;
}

.hover\\:-skew-y-2:hover{
  --transform-skew-y: -2deg !important;
}

.hover\\:-skew-y-1:hover{
  --transform-skew-y: -1deg !important;
}

.focus\\:skew-x-0:focus{
  --transform-skew-x: 0 !important;
}

.focus\\:skew-x-1:focus{
  --transform-skew-x: 1deg !important;
}

.focus\\:skew-x-2:focus{
  --transform-skew-x: 2deg !important;
}

.focus\\:skew-x-3:focus{
  --transform-skew-x: 3deg !important;
}

.focus\\:skew-x-6:focus{
  --transform-skew-x: 6deg !important;
}

.focus\\:skew-x-12:focus{
  --transform-skew-x: 12deg !important;
}

.focus\\:-skew-x-12:focus{
  --transform-skew-x: -12deg !important;
}

.focus\\:-skew-x-6:focus{
  --transform-skew-x: -6deg !important;
}

.focus\\:-skew-x-3:focus{
  --transform-skew-x: -3deg !important;
}

.focus\\:-skew-x-2:focus{
  --transform-skew-x: -2deg !important;
}

.focus\\:-skew-x-1:focus{
  --transform-skew-x: -1deg !important;
}

.focus\\:skew-y-0:focus{
  --transform-skew-y: 0 !important;
}

.focus\\:skew-y-1:focus{
  --transform-skew-y: 1deg !important;
}

.focus\\:skew-y-2:focus{
  --transform-skew-y: 2deg !important;
}

.focus\\:skew-y-3:focus{
  --transform-skew-y: 3deg !important;
}

.focus\\:skew-y-6:focus{
  --transform-skew-y: 6deg !important;
}

.focus\\:skew-y-12:focus{
  --transform-skew-y: 12deg !important;
}

.focus\\:-skew-y-12:focus{
  --transform-skew-y: -12deg !important;
}

.focus\\:-skew-y-6:focus{
  --transform-skew-y: -6deg !important;
}

.focus\\:-skew-y-3:focus{
  --transform-skew-y: -3deg !important;
}

.focus\\:-skew-y-2:focus{
  --transform-skew-y: -2deg !important;
}

.focus\\:-skew-y-1:focus{
  --transform-skew-y: -1deg !important;
}

[dir] .transition-none{
  transition-property: none !important;
}

[dir] .transition-all{
  transition-property: all !important;
}

[dir] .transition{
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform !important;
}

[dir] .transition-colors{
  transition-property: background-color, border-color, color, fill, stroke !important;
}

[dir] .transition-opacity{
  transition-property: opacity !important;
}

[dir] .transition-shadow{
  transition-property: box-shadow !important;
}

[dir] .transition-transform{
  transition-property: transform !important;
}

[dir] .ease-linear{
  transition-timing-function: linear !important;
}

[dir] .ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1) !important;
}

[dir] .ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
}

[dir] .ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}

[dir] .duration-75{
  transition-duration: 75ms !important;
}

[dir] .duration-100{
  transition-duration: 100ms !important;
}

[dir] .duration-150{
  transition-duration: 150ms !important;
}

[dir] .duration-200{
  transition-duration: 200ms !important;
}

[dir] .duration-300{
  transition-duration: 300ms !important;
}

[dir] .duration-500{
  transition-duration: 500ms !important;
}

[dir] .duration-700{
  transition-duration: 700ms !important;
}

[dir] .duration-1000{
  transition-duration: 1000ms !important;
}

[dir] .delay-75{
  transition-delay: 75ms !important;
}

[dir] .delay-100{
  transition-delay: 100ms !important;
}

[dir] .delay-150{
  transition-delay: 150ms !important;
}

[dir] .delay-200{
  transition-delay: 200ms !important;
}

[dir] .delay-300{
  transition-delay: 300ms !important;
}

[dir] .delay-500{
  transition-delay: 500ms !important;
}

[dir] .delay-700{
  transition-delay: 700ms !important;
}

[dir] .delay-1000{
  transition-delay: 1000ms !important;
}

@keyframes spin-ltr{
  to{
    transform: rotate(360deg);
  }
}

@keyframes spin-rtl{
  to{
    transform: rotate(-360deg);
  }
}

@keyframes ping{
  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes pulse{
  50%{
    opacity: .5;
  }
}

@keyframes bounce{
  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}

[dir=ltr] .animate-none{
  animation: none !important;
}

[dir=rtl] .animate-none{
  animation: none !important;
}

[dir=ltr] .animate-spin{
  animation:  spin-ltr 1s linear infinite !important;
}

[dir=rtl] .animate-spin{
  animation:  spin-rtl 1s linear infinite !important;
}

[dir=ltr] .animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite !important;
}

[dir=rtl] .animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite !important;
}

[dir=ltr] .animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
}

[dir=rtl] .animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
}

[dir=ltr] .animate-bounce{
  animation: bounce 1s infinite !important;
}

[dir=rtl] .animate-bounce{
  animation: bounce 1s infinite !important;
}

/**
 * Here you would add any custom utilities you need that don't come out of the
 * box with Tailwind.
 *
 * Example :
 *
 * .bg-pattern-graph-paper { ... }
 * .skew-45 { ... }
 *
 * Or if using a preprocessor or \`postcss-import\`:
 *
 * @import "utilities/background-patterns";
 * @import "utilities/skew-transforms";
 */

[dir] *:disabled{
  cursor: no-drop;
}

pre.prism-editor__editor {
  color: #ccc !important;
}

@media (min-width: 576px){
  .sm\\:container{
    width: 100%;
  }
  [dir=ltr] .sm\\:container{
    margin-right: auto;
    margin-left: auto;
    padding-right: 1rem;
    padding-left: 1rem;
  }
  [dir=rtl] .sm\\:container{
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media (min-width: 576px){
    .sm\\:container{
      max-width: 576px;
    }
  }

  @media (min-width: 768px){
    .sm\\:container{
      max-width: 768px;
    }
  }

  @media (min-width: 992px){
    .sm\\:container{
      max-width: 992px;
    }
  }

  @media (min-width: 1200px){
    .sm\\:container{
      max-width: 1200px;
    }
  }

  .sm\\:space-y-0 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-0 > :not(template) ~ :not(template){
    margin-top: calc(0px * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0px * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-0 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-0 > :not(template) ~ :not(template){
    margin-right: calc(0px * var(--space-x-reverse)) !important;
    margin-left: calc(0px * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-0 > :not(template) ~ :not(template){
    margin-left: calc(0px * var(--space-x-reverse)) !important;
    margin-right: calc(0px * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-1 > :not(template) ~ :not(template){
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0.25rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-1 > :not(template) ~ :not(template){
    margin-right: calc(0.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-1 > :not(template) ~ :not(template){
    margin-left: calc(0.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-2 > :not(template) ~ :not(template){
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0.5rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-2 > :not(template) ~ :not(template){
    margin-right: calc(0.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-2 > :not(template) ~ :not(template){
    margin-left: calc(0.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-3 > :not(template) ~ :not(template){
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0.75rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-3 > :not(template) ~ :not(template){
    margin-right: calc(0.75rem * var(--space-x-reverse)) !important;
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-3 > :not(template) ~ :not(template){
    margin-left: calc(0.75rem * var(--space-x-reverse)) !important;
    margin-right: calc(0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-4 > :not(template) ~ :not(template){
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-4 > :not(template) ~ :not(template){
    margin-right: calc(1rem * var(--space-x-reverse)) !important;
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-4 > :not(template) ~ :not(template){
    margin-left: calc(1rem * var(--space-x-reverse)) !important;
    margin-right: calc(1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-5 > :not(template) ~ :not(template){
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1.25rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-5 > :not(template) ~ :not(template){
    margin-right: calc(1.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-5 > :not(template) ~ :not(template){
    margin-left: calc(1.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-6 > :not(template) ~ :not(template){
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1.5rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-6 > :not(template) ~ :not(template){
    margin-right: calc(1.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-6 > :not(template) ~ :not(template){
    margin-left: calc(1.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-8 > :not(template) ~ :not(template){
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(2rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-8 > :not(template) ~ :not(template){
    margin-right: calc(2rem * var(--space-x-reverse)) !important;
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-8 > :not(template) ~ :not(template){
    margin-left: calc(2rem * var(--space-x-reverse)) !important;
    margin-right: calc(2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-10 > :not(template) ~ :not(template){
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(2.5rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-10 > :not(template) ~ :not(template){
    margin-right: calc(2.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-10 > :not(template) ~ :not(template){
    margin-left: calc(2.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-12 > :not(template) ~ :not(template){
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(3rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-12 > :not(template) ~ :not(template){
    margin-right: calc(3rem * var(--space-x-reverse)) !important;
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-12 > :not(template) ~ :not(template){
    margin-left: calc(3rem * var(--space-x-reverse)) !important;
    margin-right: calc(3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-16 > :not(template) ~ :not(template){
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(4rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-16 > :not(template) ~ :not(template){
    margin-right: calc(4rem * var(--space-x-reverse)) !important;
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-16 > :not(template) ~ :not(template){
    margin-left: calc(4rem * var(--space-x-reverse)) !important;
    margin-right: calc(4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-20 > :not(template) ~ :not(template){
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(5rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-20 > :not(template) ~ :not(template){
    margin-right: calc(5rem * var(--space-x-reverse)) !important;
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-20 > :not(template) ~ :not(template){
    margin-left: calc(5rem * var(--space-x-reverse)) !important;
    margin-right: calc(5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-24 > :not(template) ~ :not(template){
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(6rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-24 > :not(template) ~ :not(template){
    margin-right: calc(6rem * var(--space-x-reverse)) !important;
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-24 > :not(template) ~ :not(template){
    margin-left: calc(6rem * var(--space-x-reverse)) !important;
    margin-right: calc(6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-32 > :not(template) ~ :not(template){
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(8rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-32 > :not(template) ~ :not(template){
    margin-right: calc(8rem * var(--space-x-reverse)) !important;
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-32 > :not(template) ~ :not(template){
    margin-left: calc(8rem * var(--space-x-reverse)) !important;
    margin-right: calc(8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-40 > :not(template) ~ :not(template){
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(10rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-40 > :not(template) ~ :not(template){
    margin-right: calc(10rem * var(--space-x-reverse)) !important;
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-40 > :not(template) ~ :not(template){
    margin-left: calc(10rem * var(--space-x-reverse)) !important;
    margin-right: calc(10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-48 > :not(template) ~ :not(template){
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(12rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-48 > :not(template) ~ :not(template){
    margin-right: calc(12rem * var(--space-x-reverse)) !important;
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-48 > :not(template) ~ :not(template){
    margin-left: calc(12rem * var(--space-x-reverse)) !important;
    margin-right: calc(12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-56 > :not(template) ~ :not(template){
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(14rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-56 > :not(template) ~ :not(template){
    margin-right: calc(14rem * var(--space-x-reverse)) !important;
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-56 > :not(template) ~ :not(template){
    margin-left: calc(14rem * var(--space-x-reverse)) !important;
    margin-right: calc(14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-64 > :not(template) ~ :not(template){
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(16rem * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-64 > :not(template) ~ :not(template){
    margin-right: calc(16rem * var(--space-x-reverse)) !important;
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-64 > :not(template) ~ :not(template){
    margin-left: calc(16rem * var(--space-x-reverse)) !important;
    margin-right: calc(16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:space-y-px > :not(template) ~ :not(template){
    margin-top: calc(1px * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1px * var(--space-y-reverse)) !important;
  }

  .sm\\:space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:space-x-px > :not(template) ~ :not(template){
    margin-right: calc(1px * var(--space-x-reverse)) !important;
    margin-left: calc(1px * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:space-x-px > :not(template) ~ :not(template){
    margin-left: calc(1px * var(--space-x-reverse)) !important;
    margin-right: calc(1px * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-1 > :not(template) ~ :not(template){
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-0.25rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-1 > :not(template) ~ :not(template){
    margin-right: calc(-0.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-1 > :not(template) ~ :not(template){
    margin-left: calc(-0.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(-0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-2 > :not(template) ~ :not(template){
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-0.5rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-2 > :not(template) ~ :not(template){
    margin-right: calc(-0.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-2 > :not(template) ~ :not(template){
    margin-left: calc(-0.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-3 > :not(template) ~ :not(template){
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-0.75rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-3 > :not(template) ~ :not(template){
    margin-right: calc(-0.75rem * var(--space-x-reverse)) !important;
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-3 > :not(template) ~ :not(template){
    margin-left: calc(-0.75rem * var(--space-x-reverse)) !important;
    margin-right: calc(-0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-4 > :not(template) ~ :not(template){
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-4 > :not(template) ~ :not(template){
    margin-right: calc(-1rem * var(--space-x-reverse)) !important;
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-4 > :not(template) ~ :not(template){
    margin-left: calc(-1rem * var(--space-x-reverse)) !important;
    margin-right: calc(-1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-5 > :not(template) ~ :not(template){
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1.25rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-5 > :not(template) ~ :not(template){
    margin-right: calc(-1.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-5 > :not(template) ~ :not(template){
    margin-left: calc(-1.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(-1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-6 > :not(template) ~ :not(template){
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1.5rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-6 > :not(template) ~ :not(template){
    margin-right: calc(-1.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-6 > :not(template) ~ :not(template){
    margin-left: calc(-1.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-8 > :not(template) ~ :not(template){
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-2rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-8 > :not(template) ~ :not(template){
    margin-right: calc(-2rem * var(--space-x-reverse)) !important;
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-8 > :not(template) ~ :not(template){
    margin-left: calc(-2rem * var(--space-x-reverse)) !important;
    margin-right: calc(-2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-10 > :not(template) ~ :not(template){
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-2.5rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-10 > :not(template) ~ :not(template){
    margin-right: calc(-2.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-10 > :not(template) ~ :not(template){
    margin-left: calc(-2.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-12 > :not(template) ~ :not(template){
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-3rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-12 > :not(template) ~ :not(template){
    margin-right: calc(-3rem * var(--space-x-reverse)) !important;
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-12 > :not(template) ~ :not(template){
    margin-left: calc(-3rem * var(--space-x-reverse)) !important;
    margin-right: calc(-3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-16 > :not(template) ~ :not(template){
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-4rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-16 > :not(template) ~ :not(template){
    margin-right: calc(-4rem * var(--space-x-reverse)) !important;
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-16 > :not(template) ~ :not(template){
    margin-left: calc(-4rem * var(--space-x-reverse)) !important;
    margin-right: calc(-4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-20 > :not(template) ~ :not(template){
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-5rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-20 > :not(template) ~ :not(template){
    margin-right: calc(-5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-20 > :not(template) ~ :not(template){
    margin-left: calc(-5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-24 > :not(template) ~ :not(template){
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-6rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-24 > :not(template) ~ :not(template){
    margin-right: calc(-6rem * var(--space-x-reverse)) !important;
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-24 > :not(template) ~ :not(template){
    margin-left: calc(-6rem * var(--space-x-reverse)) !important;
    margin-right: calc(-6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-32 > :not(template) ~ :not(template){
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-8rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-32 > :not(template) ~ :not(template){
    margin-right: calc(-8rem * var(--space-x-reverse)) !important;
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-32 > :not(template) ~ :not(template){
    margin-left: calc(-8rem * var(--space-x-reverse)) !important;
    margin-right: calc(-8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-40 > :not(template) ~ :not(template){
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-10rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-40 > :not(template) ~ :not(template){
    margin-right: calc(-10rem * var(--space-x-reverse)) !important;
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-40 > :not(template) ~ :not(template){
    margin-left: calc(-10rem * var(--space-x-reverse)) !important;
    margin-right: calc(-10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-48 > :not(template) ~ :not(template){
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-12rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-48 > :not(template) ~ :not(template){
    margin-right: calc(-12rem * var(--space-x-reverse)) !important;
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-48 > :not(template) ~ :not(template){
    margin-left: calc(-12rem * var(--space-x-reverse)) !important;
    margin-right: calc(-12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-56 > :not(template) ~ :not(template){
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-14rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-56 > :not(template) ~ :not(template){
    margin-right: calc(-14rem * var(--space-x-reverse)) !important;
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-56 > :not(template) ~ :not(template){
    margin-left: calc(-14rem * var(--space-x-reverse)) !important;
    margin-right: calc(-14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-64 > :not(template) ~ :not(template){
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-16rem * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-64 > :not(template) ~ :not(template){
    margin-right: calc(-16rem * var(--space-x-reverse)) !important;
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-64 > :not(template) ~ :not(template){
    margin-left: calc(-16rem * var(--space-x-reverse)) !important;
    margin-right: calc(-16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:-space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .sm\\:-space-y-px > :not(template) ~ :not(template){
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1px * var(--space-y-reverse)) !important;
  }

  .sm\\:-space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:-space-x-px > :not(template) ~ :not(template){
    margin-right: calc(-1px * var(--space-x-reverse)) !important;
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:-space-x-px > :not(template) ~ :not(template){
    margin-left: calc(-1px * var(--space-x-reverse)) !important;
    margin-right: calc(-1px * calc(1 - var(--space-x-reverse))) !important;
  }

  .sm\\:space-y-reverse > :not(template) ~ :not(template){
    --space-y-reverse: 1 !important;
  }

  .sm\\:space-x-reverse > :not(template) ~ :not(template){
    --space-x-reverse: 1 !important;
  }

  .sm\\:divide-y-0 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .sm\\:divide-y-0 > :not(template) ~ :not(template){
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(0px * var(--divide-y-reverse)) !important;
  }

  .sm\\:divide-x-0 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:divide-x-0 > :not(template) ~ :not(template){
    border-right-width: calc(0px * var(--divide-x-reverse)) !important;
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:divide-x-0 > :not(template) ~ :not(template){
    border-left-width: calc(0px * var(--divide-x-reverse)) !important;
    border-right-width: calc(0px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .sm\\:divide-y-2 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .sm\\:divide-y-2 > :not(template) ~ :not(template){
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(2px * var(--divide-y-reverse)) !important;
  }

  .sm\\:divide-x-2 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:divide-x-2 > :not(template) ~ :not(template){
    border-right-width: calc(2px * var(--divide-x-reverse)) !important;
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:divide-x-2 > :not(template) ~ :not(template){
    border-left-width: calc(2px * var(--divide-x-reverse)) !important;
    border-right-width: calc(2px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .sm\\:divide-y-4 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .sm\\:divide-y-4 > :not(template) ~ :not(template){
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(4px * var(--divide-y-reverse)) !important;
  }

  .sm\\:divide-x-4 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:divide-x-4 > :not(template) ~ :not(template){
    border-right-width: calc(4px * var(--divide-x-reverse)) !important;
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:divide-x-4 > :not(template) ~ :not(template){
    border-left-width: calc(4px * var(--divide-x-reverse)) !important;
    border-right-width: calc(4px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .sm\\:divide-y-8 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .sm\\:divide-y-8 > :not(template) ~ :not(template){
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(8px * var(--divide-y-reverse)) !important;
  }

  .sm\\:divide-x-8 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:divide-x-8 > :not(template) ~ :not(template){
    border-right-width: calc(8px * var(--divide-x-reverse)) !important;
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:divide-x-8 > :not(template) ~ :not(template){
    border-left-width: calc(8px * var(--divide-x-reverse)) !important;
    border-right-width: calc(8px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .sm\\:divide-y > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .sm\\:divide-y > :not(template) ~ :not(template){
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(1px * var(--divide-y-reverse)) !important;
  }

  .sm\\:divide-x > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .sm\\:divide-x > :not(template) ~ :not(template){
    border-right-width: calc(1px * var(--divide-x-reverse)) !important;
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .sm\\:divide-x > :not(template) ~ :not(template){
    border-left-width: calc(1px * var(--divide-x-reverse)) !important;
    border-right-width: calc(1px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .sm\\:divide-y-reverse > :not(template) ~ :not(template){
    --divide-y-reverse: 1 !important;
  }

  .sm\\:divide-x-reverse > :not(template) ~ :not(template){
    --divide-x-reverse: 1 !important;
  }

  [dir] .sm\\:divide-transparent > :not(template) ~ :not(template){
    border-color: transparent !important;
  }

  .sm\\:divide-black > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .sm\\:divide-black > :not(template) ~ :not(template){
    border-color: #22292f !important;
    border-color: rgba(34, 41, 47, var(--divide-opacity)) !important;
  }

  .sm\\:divide-white > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .sm\\:divide-white > :not(template) ~ :not(template){
    border-color: #ffffff !important;
    border-color: rgba(255, 255, 255, var(--divide-opacity)) !important;
  }

  .sm\\:divide-grey > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .sm\\:divide-grey > :not(template) ~ :not(template){
    border-color: #b8c2cc !important;
    border-color: rgba(184, 194, 204, var(--divide-opacity)) !important;
  }

  .sm\\:divide-grey-light > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .sm\\:divide-grey-light > :not(template) ~ :not(template){
    border-color: #dae1e7 !important;
    border-color: rgba(218, 225, 231, var(--divide-opacity)) !important;
  }

  [dir] .sm\\:divide-solid > :not(template) ~ :not(template){
    border-style: solid !important;
  }

  [dir] .sm\\:divide-dashed > :not(template) ~ :not(template){
    border-style: dashed !important;
  }

  [dir] .sm\\:divide-dotted > :not(template) ~ :not(template){
    border-style: dotted !important;
  }

  [dir] .sm\\:divide-double > :not(template) ~ :not(template){
    border-style: double !important;
  }

  [dir] .sm\\:divide-none > :not(template) ~ :not(template){
    border-style: none !important;
  }

  .sm\\:divide-opacity-0 > :not(template) ~ :not(template){
    --divide-opacity: 0 !important;
  }

  .sm\\:divide-opacity-25 > :not(template) ~ :not(template){
    --divide-opacity: 0.25 !important;
  }

  .sm\\:divide-opacity-50 > :not(template) ~ :not(template){
    --divide-opacity: 0.5 !important;
  }

  .sm\\:divide-opacity-75 > :not(template) ~ :not(template){
    --divide-opacity: 0.75 !important;
  }

  .sm\\:divide-opacity-100 > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  .sm\\:sr-only{
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
  }

  [dir] .sm\\:sr-only{
    padding: 0 !important;
    margin: -1px !important;
    border-width: 0 !important;
  }

  .sm\\:not-sr-only{
    position: static !important;
    width: auto !important;
    height: auto !important;
    overflow: visible !important;
    clip: auto !important;
    white-space: normal !important;
  }

  [dir] .sm\\:not-sr-only{
    padding: 0 !important;
    margin: 0 !important;
  }

  .sm\\:focus\\:sr-only:focus{
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
  }

  [dir] .sm\\:focus\\:sr-only:focus{
    padding: 0 !important;
    margin: -1px !important;
    border-width: 0 !important;
  }

  .sm\\:focus\\:not-sr-only:focus{
    position: static !important;
    width: auto !important;
    height: auto !important;
    overflow: visible !important;
    clip: auto !important;
    white-space: normal !important;
  }

  [dir] .sm\\:focus\\:not-sr-only:focus{
    padding: 0 !important;
    margin: 0 !important;
  }

  .sm\\:appearance-none{
    -webkit-appearance: none !important;
            appearance: none !important;
  }

  [dir] .sm\\:bg-fixed{
    background-attachment: fixed !important;
  }

  [dir] .sm\\:bg-local{
    background-attachment: local !important;
  }

  [dir] .sm\\:bg-scroll{
    background-attachment: scroll !important;
  }

  [dir] .sm\\:bg-clip-border{
    background-clip: border-box !important;
  }

  [dir] .sm\\:bg-clip-padding{
    background-clip: padding-box !important;
  }

  [dir] .sm\\:bg-clip-content{
    background-clip: content-box !important;
  }

  [dir] .sm\\:bg-clip-text{
    -webkit-background-clip: text !important;
            background-clip: text !important;
  }

  [dir] .sm\\:bg-transparent{
    background-color: transparent !important;
  }

  .sm\\:bg-black{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:bg-black{
    background-color: #22292f !important;
    background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
  }

  .sm\\:bg-white{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:bg-white{
    background-color: #ffffff !important;
    background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
  }

  .sm\\:bg-grey{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:bg-grey{
    background-color: #b8c2cc !important;
    background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
  }

  .sm\\:bg-grey-light{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:bg-grey-light{
    background-color: #dae1e7 !important;
    background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
  }

  [dir] .sm\\:hover\\:bg-transparent:hover{
    background-color: transparent !important;
  }

  .sm\\:hover\\:bg-black:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:hover\\:bg-black:hover{
    background-color: #22292f !important;
    background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
  }

  .sm\\:hover\\:bg-white:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:hover\\:bg-white:hover{
    background-color: #ffffff !important;
    background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
  }

  .sm\\:hover\\:bg-grey:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:hover\\:bg-grey:hover{
    background-color: #b8c2cc !important;
    background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
  }

  .sm\\:hover\\:bg-grey-light:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:hover\\:bg-grey-light:hover{
    background-color: #dae1e7 !important;
    background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
  }

  [dir] .sm\\:focus\\:bg-transparent:focus{
    background-color: transparent !important;
  }

  .sm\\:focus\\:bg-black:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:focus\\:bg-black:focus{
    background-color: #22292f !important;
    background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
  }

  .sm\\:focus\\:bg-white:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:focus\\:bg-white:focus{
    background-color: #ffffff !important;
    background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
  }

  .sm\\:focus\\:bg-grey:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:focus\\:bg-grey:focus{
    background-color: #b8c2cc !important;
    background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
  }

  .sm\\:focus\\:bg-grey-light:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:focus\\:bg-grey-light:focus{
    background-color: #dae1e7 !important;
    background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
  }

  [dir] .sm\\:bg-none{
    background-image: none !important;
  }

  [dir] .sm\\:bg-gradient-to-t{
    background-image: linear-gradient(to top, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .sm\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top right, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .sm\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top left, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .sm\\:bg-gradient-to-r{
    background-image: linear-gradient(to right, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .sm\\:bg-gradient-to-r{
    background-image: linear-gradient(to left, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .sm\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .sm\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops)) !important;
  }

  [dir] .sm\\:bg-gradient-to-b{
    background-image: linear-gradient(to bottom, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .sm\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .sm\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .sm\\:bg-gradient-to-l{
    background-image: linear-gradient(to left, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .sm\\:bg-gradient-to-l{
    background-image: linear-gradient(to right, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .sm\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top left, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .sm\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top right, var(--gradient-color-stops)) !important;
  }

  .sm\\:from-transparent{
    --gradient-from-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .sm\\:from-black{
    --gradient-from-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .sm\\:from-white{
    --gradient-from-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .sm\\:from-grey{
    --gradient-from-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .sm\\:from-grey-light{
    --gradient-from-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .sm\\:via-transparent{
    --gradient-via-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .sm\\:via-black{
    --gradient-via-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .sm\\:via-white{
    --gradient-via-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .sm\\:via-grey{
    --gradient-via-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .sm\\:via-grey-light{
    --gradient-via-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .sm\\:to-transparent{
    --gradient-to-color: transparent !important;
  }

  .sm\\:to-black{
    --gradient-to-color: #22292f !important;
  }

  .sm\\:to-white{
    --gradient-to-color: #ffffff !important;
  }

  .sm\\:to-grey{
    --gradient-to-color: #b8c2cc !important;
  }

  .sm\\:to-grey-light{
    --gradient-to-color: #dae1e7 !important;
  }

  .sm\\:hover\\:from-transparent:hover{
    --gradient-from-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .sm\\:hover\\:from-black:hover{
    --gradient-from-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .sm\\:hover\\:from-white:hover{
    --gradient-from-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .sm\\:hover\\:from-grey:hover{
    --gradient-from-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .sm\\:hover\\:from-grey-light:hover{
    --gradient-from-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .sm\\:hover\\:via-transparent:hover{
    --gradient-via-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .sm\\:hover\\:via-black:hover{
    --gradient-via-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .sm\\:hover\\:via-white:hover{
    --gradient-via-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .sm\\:hover\\:via-grey:hover{
    --gradient-via-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .sm\\:hover\\:via-grey-light:hover{
    --gradient-via-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .sm\\:hover\\:to-transparent:hover{
    --gradient-to-color: transparent !important;
  }

  .sm\\:hover\\:to-black:hover{
    --gradient-to-color: #22292f !important;
  }

  .sm\\:hover\\:to-white:hover{
    --gradient-to-color: #ffffff !important;
  }

  .sm\\:hover\\:to-grey:hover{
    --gradient-to-color: #b8c2cc !important;
  }

  .sm\\:hover\\:to-grey-light:hover{
    --gradient-to-color: #dae1e7 !important;
  }

  .sm\\:focus\\:from-transparent:focus{
    --gradient-from-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .sm\\:focus\\:from-black:focus{
    --gradient-from-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .sm\\:focus\\:from-white:focus{
    --gradient-from-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .sm\\:focus\\:from-grey:focus{
    --gradient-from-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .sm\\:focus\\:from-grey-light:focus{
    --gradient-from-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .sm\\:focus\\:via-transparent:focus{
    --gradient-via-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .sm\\:focus\\:via-black:focus{
    --gradient-via-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .sm\\:focus\\:via-white:focus{
    --gradient-via-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .sm\\:focus\\:via-grey:focus{
    --gradient-via-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .sm\\:focus\\:via-grey-light:focus{
    --gradient-via-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .sm\\:focus\\:to-transparent:focus{
    --gradient-to-color: transparent !important;
  }

  .sm\\:focus\\:to-black:focus{
    --gradient-to-color: #22292f !important;
  }

  .sm\\:focus\\:to-white:focus{
    --gradient-to-color: #ffffff !important;
  }

  .sm\\:focus\\:to-grey:focus{
    --gradient-to-color: #b8c2cc !important;
  }

  .sm\\:focus\\:to-grey-light:focus{
    --gradient-to-color: #dae1e7 !important;
  }

  .sm\\:bg-opacity-0{
    --bg-opacity: 0 !important;
  }

  .sm\\:bg-opacity-25{
    --bg-opacity: 0.25 !important;
  }

  .sm\\:bg-opacity-50{
    --bg-opacity: 0.5 !important;
  }

  .sm\\:bg-opacity-75{
    --bg-opacity: 0.75 !important;
  }

  .sm\\:bg-opacity-100{
    --bg-opacity: 1 !important;
  }

  .sm\\:hover\\:bg-opacity-0:hover{
    --bg-opacity: 0 !important;
  }

  .sm\\:hover\\:bg-opacity-25:hover{
    --bg-opacity: 0.25 !important;
  }

  .sm\\:hover\\:bg-opacity-50:hover{
    --bg-opacity: 0.5 !important;
  }

  .sm\\:hover\\:bg-opacity-75:hover{
    --bg-opacity: 0.75 !important;
  }

  .sm\\:hover\\:bg-opacity-100:hover{
    --bg-opacity: 1 !important;
  }

  .sm\\:focus\\:bg-opacity-0:focus{
    --bg-opacity: 0 !important;
  }

  .sm\\:focus\\:bg-opacity-25:focus{
    --bg-opacity: 0.25 !important;
  }

  .sm\\:focus\\:bg-opacity-50:focus{
    --bg-opacity: 0.5 !important;
  }

  .sm\\:focus\\:bg-opacity-75:focus{
    --bg-opacity: 0.75 !important;
  }

  .sm\\:focus\\:bg-opacity-100:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .sm\\:bg-auto{
    background-size: auto !important;
  }

  [dir] .sm\\:bg-cover{
    background-size: cover !important;
  }

  [dir] .sm\\:bg-contain{
    background-size: contain !important;
  }

  [dir] .sm\\:border-transparent{
    border-color: transparent !important;
  }

  .sm\\:border-black{
    --border-opacity: 1 !important;
  }

  [dir] .sm\\:border-black{
    border-color: #22292f !important;
    border-color: rgba(34, 41, 47, var(--border-opacity)) !important;
  }

  .sm\\:border-white{
    --border-opacity: 1 !important;
  }

  [dir] .sm\\:border-white{
    border-color: #ffffff !important;
    border-color: rgba(255, 255, 255, var(--border-opacity)) !important;
  }

  .sm\\:border-grey{
    --border-opacity: 1 !important;
  }

  [dir] .sm\\:border-grey{
    border-color: #b8c2cc !important;
    border-color: rgba(184, 194, 204, var(--border-opacity)) !important;
  }

  .sm\\:border-grey-light{
    --border-opacity: 1 !important;
  }

  [dir] .sm\\:border-grey-light{
    border-color: #dae1e7 !important;
    border-color: rgba(218, 225, 231, var(--border-opacity)) !important;
  }

  [dir] .sm\\:hover\\:border-transparent:hover{
    border-color: transparent !important;
  }

  .sm\\:hover\\:border-black:hover{
    --border-opacity: 1 !important;
  }

  [dir] .sm\\:hover\\:border-black:hover{
    border-color: #22292f !important;
    border-color: rgba(34, 41, 47, var(--border-opacity)) !important;
  }

  .sm\\:hover\\:border-white:hover{
    --border-opacity: 1 !important;
  }

  [dir] .sm\\:hover\\:border-white:hover{
    border-color: #ffffff !important;
    border-color: rgba(255, 255, 255, var(--border-opacity)) !important;
  }

  .sm\\:hover\\:border-grey:hover{
    --border-opacity: 1 !important;
  }

  [dir] .sm\\:hover\\:border-grey:hover{
    border-color: #b8c2cc !important;
    border-color: rgba(184, 194, 204, var(--border-opacity)) !important;
  }

  .sm\\:hover\\:border-grey-light:hover{
    --border-opacity: 1 !important;
  }

  [dir] .sm\\:hover\\:border-grey-light:hover{
    border-color: #dae1e7 !important;
    border-color: rgba(218, 225, 231, var(--border-opacity)) !important;
  }

  .sm\\:border-opacity-0{
    --border-opacity: 0 !important;
  }

  .sm\\:border-opacity-25{
    --border-opacity: 0.25 !important;
  }

  .sm\\:border-opacity-50{
    --border-opacity: 0.5 !important;
  }

  .sm\\:border-opacity-75{
    --border-opacity: 0.75 !important;
  }

  .sm\\:border-opacity-100{
    --border-opacity: 1 !important;
  }

  .sm\\:hover\\:border-opacity-0:hover{
    --border-opacity: 0 !important;
  }

  .sm\\:hover\\:border-opacity-25:hover{
    --border-opacity: 0.25 !important;
  }

  .sm\\:hover\\:border-opacity-50:hover{
    --border-opacity: 0.5 !important;
  }

  .sm\\:hover\\:border-opacity-75:hover{
    --border-opacity: 0.75 !important;
  }

  .sm\\:hover\\:border-opacity-100:hover{
    --border-opacity: 1 !important;
  }

  .sm\\:focus\\:border-opacity-0:focus{
    --border-opacity: 0 !important;
  }

  .sm\\:focus\\:border-opacity-25:focus{
    --border-opacity: 0.25 !important;
  }

  .sm\\:focus\\:border-opacity-50:focus{
    --border-opacity: 0.5 !important;
  }

  .sm\\:focus\\:border-opacity-75:focus{
    --border-opacity: 0.75 !important;
  }

  .sm\\:focus\\:border-opacity-100:focus{
    --border-opacity: 1 !important;
  }

  [dir] .sm\\:border-solid{
    border-style: solid !important;
  }

  [dir] .sm\\:border-dashed{
    border-style: dashed !important;
  }

  [dir] .sm\\:border-dotted{
    border-style: dotted !important;
  }

  [dir] .sm\\:border-double{
    border-style: double !important;
  }

  [dir] .sm\\:border-none{
    border-style: none !important;
  }

  [dir] .sm\\:border-0{
    border-width: 0 !important;
  }

  [dir] .sm\\:border-2{
    border-width: 2px !important;
  }

  [dir] .sm\\:border-4{
    border-width: 4px !important;
  }

  [dir] .sm\\:border-8{
    border-width: 8px !important;
  }

  [dir] .sm\\:border{
    border-width: 1px !important;
  }

  [dir] .sm\\:border-t-0{
    border-top-width: 0 !important;
  }

  [dir=ltr] .sm\\:border-r-0{
    border-right-width: 0 !important;
  }

  [dir=rtl] .sm\\:border-r-0{
    border-left-width: 0 !important;
  }

  [dir] .sm\\:border-b-0{
    border-bottom-width: 0 !important;
  }

  [dir=ltr] .sm\\:border-l-0{
    border-left-width: 0 !important;
  }

  [dir=rtl] .sm\\:border-l-0{
    border-right-width: 0 !important;
  }

  [dir] .sm\\:border-t-2{
    border-top-width: 2px !important;
  }

  [dir=ltr] .sm\\:border-r-2{
    border-right-width: 2px !important;
  }

  [dir=rtl] .sm\\:border-r-2{
    border-left-width: 2px !important;
  }

  [dir] .sm\\:border-b-2{
    border-bottom-width: 2px !important;
  }

  [dir=ltr] .sm\\:border-l-2{
    border-left-width: 2px !important;
  }

  [dir=rtl] .sm\\:border-l-2{
    border-right-width: 2px !important;
  }

  [dir] .sm\\:border-t-4{
    border-top-width: 4px !important;
  }

  [dir=ltr] .sm\\:border-r-4{
    border-right-width: 4px !important;
  }

  [dir=rtl] .sm\\:border-r-4{
    border-left-width: 4px !important;
  }

  [dir] .sm\\:border-b-4{
    border-bottom-width: 4px !important;
  }

  [dir=ltr] .sm\\:border-l-4{
    border-left-width: 4px !important;
  }

  [dir=rtl] .sm\\:border-l-4{
    border-right-width: 4px !important;
  }

  [dir] .sm\\:border-t-8{
    border-top-width: 8px !important;
  }

  [dir=ltr] .sm\\:border-r-8{
    border-right-width: 8px !important;
  }

  [dir=rtl] .sm\\:border-r-8{
    border-left-width: 8px !important;
  }

  [dir] .sm\\:border-b-8{
    border-bottom-width: 8px !important;
  }

  [dir=ltr] .sm\\:border-l-8{
    border-left-width: 8px !important;
  }

  [dir=rtl] .sm\\:border-l-8{
    border-right-width: 8px !important;
  }

  [dir] .sm\\:border-t{
    border-top-width: 1px !important;
  }

  [dir=ltr] .sm\\:border-r{
    border-right-width: 1px !important;
  }

  [dir=rtl] .sm\\:border-r{
    border-left-width: 1px !important;
  }

  [dir] .sm\\:border-b{
    border-bottom-width: 1px !important;
  }

  [dir=ltr] .sm\\:border-l{
    border-left-width: 1px !important;
  }

  [dir=rtl] .sm\\:border-l{
    border-right-width: 1px !important;
  }

  .sm\\:box-border{
    box-sizing: border-box !important;
  }

  .sm\\:box-content{
    box-sizing: content-box !important;
  }

  .sm\\:block{
    display: block !important;
  }

  .sm\\:inline-block{
    display: inline-block !important;
  }

  .sm\\:inline{
    display: inline !important;
  }

  .sm\\:flex{
    display: flex !important;
  }

  .sm\\:inline-flex{
    display: inline-flex !important;
  }

  .sm\\:table{
    display: table !important;
  }

  .sm\\:table-caption{
    display: table-caption !important;
  }

  .sm\\:table-cell{
    display: table-cell !important;
  }

  .sm\\:table-column{
    display: table-column !important;
  }

  .sm\\:table-column-group{
    display: table-column-group !important;
  }

  .sm\\:table-footer-group{
    display: table-footer-group !important;
  }

  .sm\\:table-header-group{
    display: table-header-group !important;
  }

  .sm\\:table-row-group{
    display: table-row-group !important;
  }

  .sm\\:table-row{
    display: table-row !important;
  }

  .sm\\:flow-root{
    display: flow-root !important;
  }

  .sm\\:grid{
    display: grid !important;
  }

  .sm\\:inline-grid{
    display: inline-grid !important;
  }

  .sm\\:contents{
    display: contents !important;
  }

  .sm\\:hidden{
    display: none !important;
  }

  .sm\\:flex-row{
    flex-direction: row !important;
  }

  .sm\\:flex-row-reverse{
    flex-direction: row-reverse !important;
  }

  .sm\\:flex-col{
    flex-direction: column !important;
  }

  .sm\\:flex-col-reverse{
    flex-direction: column-reverse !important;
  }

  .sm\\:flex-wrap{
    flex-wrap: wrap !important;
  }

  .sm\\:flex-wrap-reverse{
    flex-wrap: wrap-reverse !important;
  }

  .sm\\:flex-no-wrap{
    flex-wrap: nowrap !important;
  }

  .sm\\:place-items-auto{
    place-items: auto !important;
  }

  .sm\\:place-items-start{
    place-items: start !important;
  }

  .sm\\:place-items-end{
    place-items: end !important;
  }

  .sm\\:place-items-center{
    place-items: center !important;
  }

  .sm\\:place-items-stretch{
    place-items: stretch !important;
  }

  .sm\\:place-content-center{
    place-content: center !important;
  }

  .sm\\:place-content-start{
    place-content: start !important;
  }

  .sm\\:place-content-end{
    place-content: end !important;
  }

  .sm\\:place-content-between{
    place-content: space-between !important;
  }

  .sm\\:place-content-around{
    place-content: space-around !important;
  }

  .sm\\:place-content-evenly{
    place-content: space-evenly !important;
  }

  .sm\\:place-content-stretch{
    place-content: stretch !important;
  }

  .sm\\:place-self-auto{
    place-self: auto !important;
  }

  .sm\\:place-self-start{
    place-self: start !important;
  }

  .sm\\:place-self-end{
    place-self: end !important;
  }

  .sm\\:place-self-center{
    place-self: center !important;
  }

  .sm\\:place-self-stretch{
    place-self: stretch !important;
  }

  .sm\\:items-start{
    align-items: flex-start !important;
  }

  .sm\\:items-end{
    align-items: flex-end !important;
  }

  .sm\\:items-center{
    align-items: center !important;
  }

  .sm\\:items-baseline{
    align-items: baseline !important;
  }

  .sm\\:items-stretch{
    align-items: stretch !important;
  }

  .sm\\:content-center{
    align-content: center !important;
  }

  .sm\\:content-start{
    align-content: flex-start !important;
  }

  .sm\\:content-end{
    align-content: flex-end !important;
  }

  .sm\\:content-between{
    align-content: space-between !important;
  }

  .sm\\:content-around{
    align-content: space-around !important;
  }

  .sm\\:content-evenly{
    align-content: space-evenly !important;
  }

  .sm\\:self-auto{
    align-self: auto !important;
  }

  .sm\\:self-start{
    align-self: flex-start !important;
  }

  .sm\\:self-end{
    align-self: flex-end !important;
  }

  .sm\\:self-center{
    align-self: center !important;
  }

  .sm\\:self-stretch{
    align-self: stretch !important;
  }

  .sm\\:justify-items-auto{
    justify-items: auto !important;
  }

  .sm\\:justify-items-start{
    justify-items: start !important;
  }

  .sm\\:justify-items-end{
    justify-items: end !important;
  }

  .sm\\:justify-items-center{
    justify-items: center !important;
  }

  .sm\\:justify-items-stretch{
    justify-items: stretch !important;
  }

  .sm\\:justify-start{
    justify-content: flex-start !important;
  }

  .sm\\:justify-end{
    justify-content: flex-end !important;
  }

  .sm\\:justify-center{
    justify-content: center !important;
  }

  .sm\\:justify-between{
    justify-content: space-between !important;
  }

  .sm\\:justify-around{
    justify-content: space-around !important;
  }

  .sm\\:justify-evenly{
    justify-content: space-evenly !important;
  }

  .sm\\:justify-self-auto{
    justify-self: auto !important;
  }

  .sm\\:justify-self-start{
    justify-self: start !important;
  }

  .sm\\:justify-self-end{
    justify-self: end !important;
  }

  .sm\\:justify-self-center{
    justify-self: center !important;
  }

  .sm\\:justify-self-stretch{
    justify-self: stretch !important;
  }

  .sm\\:flex-1{
    flex: 1 1 0% !important;
  }

  .sm\\:flex-auto{
    flex: 1 1 auto !important;
  }

  .sm\\:flex-initial{
    flex: 0 1 auto !important;
  }

  .sm\\:flex-none{
    flex: none !important;
  }

  .sm\\:flex-grow-0{
    flex-grow: 0 !important;
  }

  .sm\\:flex-grow{
    flex-grow: 1 !important;
  }

  .sm\\:flex-shrink-0{
    flex-shrink: 0 !important;
  }

  .sm\\:flex-shrink{
    flex-shrink: 1 !important;
  }

  .sm\\:order-1{
    order: 1 !important;
  }

  .sm\\:order-2{
    order: 2 !important;
  }

  .sm\\:order-3{
    order: 3 !important;
  }

  .sm\\:order-4{
    order: 4 !important;
  }

  .sm\\:order-5{
    order: 5 !important;
  }

  .sm\\:order-6{
    order: 6 !important;
  }

  .sm\\:order-first{
    order: -1 !important;
  }

  .sm\\:order-last{
    order: 999 !important;
  }

  .sm\\:order-normal{
    order: 0 !important;
  }

  .sm\\:hover\\:order-1:hover{
    order: 1 !important;
  }

  .sm\\:hover\\:order-2:hover{
    order: 2 !important;
  }

  .sm\\:hover\\:order-3:hover{
    order: 3 !important;
  }

  .sm\\:hover\\:order-4:hover{
    order: 4 !important;
  }

  .sm\\:hover\\:order-5:hover{
    order: 5 !important;
  }

  .sm\\:hover\\:order-6:hover{
    order: 6 !important;
  }

  .sm\\:hover\\:order-first:hover{
    order: -1 !important;
  }

  .sm\\:hover\\:order-last:hover{
    order: 999 !important;
  }

  .sm\\:hover\\:order-normal:hover{
    order: 0 !important;
  }

  .sm\\:focus\\:order-1:focus{
    order: 1 !important;
  }

  .sm\\:focus\\:order-2:focus{
    order: 2 !important;
  }

  .sm\\:focus\\:order-3:focus{
    order: 3 !important;
  }

  .sm\\:focus\\:order-4:focus{
    order: 4 !important;
  }

  .sm\\:focus\\:order-5:focus{
    order: 5 !important;
  }

  .sm\\:focus\\:order-6:focus{
    order: 6 !important;
  }

  .sm\\:focus\\:order-first:focus{
    order: -1 !important;
  }

  .sm\\:focus\\:order-last:focus{
    order: 999 !important;
  }

  .sm\\:focus\\:order-normal:focus{
    order: 0 !important;
  }

  [dir=ltr] .sm\\:float-right{
    float: right !important;
  }

  [dir=rtl] .sm\\:float-right{
    float: left !important;
  }

  [dir=ltr] .sm\\:float-left{
    float: left !important;
  }

  [dir=rtl] .sm\\:float-left{
    float: right !important;
  }

  [dir] .sm\\:float-none{
    float: none !important;
  }

  .sm\\:clearfix:after{
    content: "" !important;
    display: table !important;
  }

  [dir] .sm\\:clearfix:after{
    clear: both !important;
  }

  [dir=ltr] .sm\\:clear-left{
    clear: left !important;
  }

  [dir=rtl] .sm\\:clear-left{
    clear: right !important;
  }

  [dir=ltr] .sm\\:clear-right{
    clear: right !important;
  }

  [dir=rtl] .sm\\:clear-right{
    clear: left !important;
  }

  [dir] .sm\\:clear-both{
    clear: both !important;
  }

  [dir] .sm\\:clear-none{
    clear: none !important;
  }

  .sm\\:font-light{
    font-weight: 300 !important;
  }

  .sm\\:font-normal{
    font-weight: 400 !important;
  }

  .sm\\:font-medium{
    font-weight: 500 !important;
  }

  .sm\\:font-semibold{
    font-weight: 600 !important;
  }

  .sm\\:font-bold{
    font-weight: 700 !important;
  }

  .sm\\:font-extrabold{
    font-weight: 800 !important;
  }

  .sm\\:font-black{
    font-weight: 900 !important;
  }

  .sm\\:hover\\:font-light:hover{
    font-weight: 300 !important;
  }

  .sm\\:hover\\:font-normal:hover{
    font-weight: 400 !important;
  }

  .sm\\:hover\\:font-medium:hover{
    font-weight: 500 !important;
  }

  .sm\\:hover\\:font-semibold:hover{
    font-weight: 600 !important;
  }

  .sm\\:hover\\:font-bold:hover{
    font-weight: 700 !important;
  }

  .sm\\:hover\\:font-extrabold:hover{
    font-weight: 800 !important;
  }

  .sm\\:hover\\:font-black:hover{
    font-weight: 900 !important;
  }

  .sm\\:h-1{
    height: 0.25rem !important;
  }

  .sm\\:h-2{
    height: 0.5rem !important;
  }

  .sm\\:h-3{
    height: 0.75rem !important;
  }

  .sm\\:h-4{
    height: 1rem !important;
  }

  .sm\\:h-5{
    height: 1.25rem !important;
  }

  .sm\\:h-6{
    height: 1.5rem !important;
  }

  .sm\\:h-8{
    height: 2rem !important;
  }

  .sm\\:h-10{
    height: 2.5rem !important;
  }

  .sm\\:h-12{
    height: 3rem !important;
  }

  .sm\\:h-16{
    height: 4rem !important;
  }

  .sm\\:h-24{
    height: 6rem !important;
  }

  .sm\\:h-32{
    height: 8rem !important;
  }

  .sm\\:h-48{
    height: 12rem !important;
  }

  .sm\\:h-64{
    height: 16rem !important;
  }

  .sm\\:h-auto{
    height: auto !important;
  }

  .sm\\:h-px{
    height: 1px !important;
  }

  .sm\\:h-full{
    height: 100% !important;
  }

  .sm\\:h-screen{
    height: 100vh !important;
  }

  .sm\\:text-xs{
    font-size: .75rem !important;
  }

  .sm\\:text-sm{
    font-size: .875rem !important;
  }

  .sm\\:text-base{
    font-size: 1rem !important;
  }

  .sm\\:text-lg{
    font-size: 1.125rem !important;
  }

  .sm\\:text-xl{
    font-size: 1.25rem !important;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem !important;
  }

  .sm\\:text-3xl{
    font-size: 1.875rem !important;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem !important;
  }

  .sm\\:text-5xl{
    font-size: 3rem !important;
  }

  .sm\\:text-6xl{
    font-size: 4rem !important;
  }

  .sm\\:leading-none{
    line-height: 1 !important;
  }

  .sm\\:leading-tight{
    line-height: 1.25 !important;
  }

  .sm\\:leading-normal{
    line-height: 1.5 !important;
  }

  .sm\\:leading-loose{
    line-height: 2 !important;
  }

  .sm\\:list-inside{
    list-style-position: inside !important;
  }

  .sm\\:list-outside{
    list-style-position: outside !important;
  }

  [dir] .sm\\:m-0{
    margin: 0 !important;
  }

  [dir] .sm\\:m-1{
    margin: 0.25rem !important;
  }

  [dir] .sm\\:m-2{
    margin: 0.5rem !important;
  }

  [dir] .sm\\:m-3{
    margin: 0.75rem !important;
  }

  [dir] .sm\\:m-4{
    margin: 1rem !important;
  }

  [dir] .sm\\:m-5{
    margin: 1.25rem !important;
  }

  [dir] .sm\\:m-6{
    margin: 1.5rem !important;
  }

  [dir] .sm\\:m-8{
    margin: 2rem !important;
  }

  [dir] .sm\\:m-10{
    margin: 2.5rem !important;
  }

  [dir] .sm\\:m-12{
    margin: 3rem !important;
  }

  [dir] .sm\\:m-16{
    margin: 4rem !important;
  }

  [dir] .sm\\:m-20{
    margin: 5rem !important;
  }

  [dir] .sm\\:m-24{
    margin: 6rem !important;
  }

  [dir] .sm\\:m-32{
    margin: 8rem !important;
  }

  [dir] .sm\\:m-auto{
    margin: auto !important;
  }

  [dir] .sm\\:m-px{
    margin: 1px !important;
  }

  [dir] .sm\\:m-base{
    margin: 2.2rem !important;
  }

  [dir] .sm\\:-m-px{
    margin: -1px !important;
  }

  [dir] .sm\\:-m-1{
    margin: -0.25rem !important;
  }

  [dir] .sm\\:-m-2{
    margin: -0.5rem !important;
  }

  [dir] .sm\\:-m-3{
    margin: -0.75rem !important;
  }

  [dir] .sm\\:-m-4{
    margin: -1rem !important;
  }

  [dir] .sm\\:my-0{
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  [dir=ltr] .sm\\:mx-0{
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  [dir=rtl] .sm\\:mx-0{
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  [dir] .sm\\:my-1{
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  [dir=ltr] .sm\\:mx-1{
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }

  [dir=rtl] .sm\\:mx-1{
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  [dir] .sm\\:my-2{
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  [dir=ltr] .sm\\:mx-2{
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  [dir=rtl] .sm\\:mx-2{
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  [dir] .sm\\:my-3{
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  [dir=ltr] .sm\\:mx-3{
    margin-left: 0.75rem !important;
    margin-right: 0.75rem !important;
  }

  [dir=rtl] .sm\\:mx-3{
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  [dir] .sm\\:my-4{
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  [dir=ltr] .sm\\:mx-4{
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  [dir=rtl] .sm\\:mx-4{
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  [dir] .sm\\:my-5{
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  [dir=ltr] .sm\\:mx-5{
    margin-left: 1.25rem !important;
    margin-right: 1.25rem !important;
  }

  [dir=rtl] .sm\\:mx-5{
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  [dir] .sm\\:my-6{
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  [dir=ltr] .sm\\:mx-6{
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }

  [dir=rtl] .sm\\:mx-6{
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  [dir] .sm\\:my-8{
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  [dir=ltr] .sm\\:mx-8{
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }

  [dir=rtl] .sm\\:mx-8{
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  [dir] .sm\\:my-10{
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  [dir=ltr] .sm\\:mx-10{
    margin-left: 2.5rem !important;
    margin-right: 2.5rem !important;
  }

  [dir=rtl] .sm\\:mx-10{
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  [dir] .sm\\:my-12{
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  [dir=ltr] .sm\\:mx-12{
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }

  [dir=rtl] .sm\\:mx-12{
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  [dir] .sm\\:my-16{
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  [dir=ltr] .sm\\:mx-16{
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }

  [dir=rtl] .sm\\:mx-16{
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  [dir] .sm\\:my-20{
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  [dir=ltr] .sm\\:mx-20{
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }

  [dir=rtl] .sm\\:mx-20{
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  [dir] .sm\\:my-24{
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }

  [dir=ltr] .sm\\:mx-24{
    margin-left: 6rem !important;
    margin-right: 6rem !important;
  }

  [dir=rtl] .sm\\:mx-24{
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }

  [dir] .sm\\:my-32{
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }

  [dir=ltr] .sm\\:mx-32{
    margin-left: 8rem !important;
    margin-right: 8rem !important;
  }

  [dir=rtl] .sm\\:mx-32{
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }

  [dir] .sm\\:my-auto{
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  [dir=ltr] .sm\\:mx-auto{
    margin-left: auto !important;
    margin-right: auto !important;
  }

  [dir=rtl] .sm\\:mx-auto{
    margin-right: auto !important;
    margin-left: auto !important;
  }

  [dir] .sm\\:my-px{
    margin-top: 1px !important;
    margin-bottom: 1px !important;
  }

  [dir=ltr] .sm\\:mx-px{
    margin-left: 1px !important;
    margin-right: 1px !important;
  }

  [dir=rtl] .sm\\:mx-px{
    margin-right: 1px !important;
    margin-left: 1px !important;
  }

  [dir] .sm\\:my-base{
    margin-top: 2.2rem !important;
    margin-bottom: 2.2rem !important;
  }

  [dir=ltr] .sm\\:mx-base{
    margin-left: 2.2rem !important;
    margin-right: 2.2rem !important;
  }

  [dir=rtl] .sm\\:mx-base{
    margin-right: 2.2rem !important;
    margin-left: 2.2rem !important;
  }

  [dir] .sm\\:-my-px{
    margin-top: -1px !important;
    margin-bottom: -1px !important;
  }

  [dir=ltr] .sm\\:-mx-px{
    margin-left: -1px !important;
    margin-right: -1px !important;
  }

  [dir=rtl] .sm\\:-mx-px{
    margin-right: -1px !important;
    margin-left: -1px !important;
  }

  [dir] .sm\\:-my-1{
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  [dir=ltr] .sm\\:-mx-1{
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
  }

  [dir=rtl] .sm\\:-mx-1{
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  [dir] .sm\\:-my-2{
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  [dir=ltr] .sm\\:-mx-2{
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }

  [dir=rtl] .sm\\:-mx-2{
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  [dir] .sm\\:-my-3{
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  [dir=ltr] .sm\\:-mx-3{
    margin-left: -0.75rem !important;
    margin-right: -0.75rem !important;
  }

  [dir=rtl] .sm\\:-mx-3{
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  [dir] .sm\\:-my-4{
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  [dir=ltr] .sm\\:-mx-4{
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }

  [dir=rtl] .sm\\:-mx-4{
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  [dir] .sm\\:mt-0{
    margin-top: 0 !important;
  }

  [dir=ltr] .sm\\:mr-0{
    margin-right: 0 !important;
  }

  [dir=rtl] .sm\\:mr-0{
    margin-left: 0 !important;
  }

  [dir] .sm\\:mb-0{
    margin-bottom: 0 !important;
  }

  [dir=ltr] .sm\\:ml-0{
    margin-left: 0 !important;
  }

  [dir=rtl] .sm\\:ml-0{
    margin-right: 0 !important;
  }

  [dir] .sm\\:mt-1{
    margin-top: 0.25rem !important;
  }

  [dir=ltr] .sm\\:mr-1{
    margin-right: 0.25rem !important;
  }

  [dir=rtl] .sm\\:mr-1{
    margin-left: 0.25rem !important;
  }

  [dir] .sm\\:mb-1{
    margin-bottom: 0.25rem !important;
  }

  [dir=ltr] .sm\\:ml-1{
    margin-left: 0.25rem !important;
  }

  [dir=rtl] .sm\\:ml-1{
    margin-right: 0.25rem !important;
  }

  [dir] .sm\\:mt-2{
    margin-top: 0.5rem !important;
  }

  [dir=ltr] .sm\\:mr-2{
    margin-right: 0.5rem !important;
  }

  [dir=rtl] .sm\\:mr-2{
    margin-left: 0.5rem !important;
  }

  [dir] .sm\\:mb-2{
    margin-bottom: 0.5rem !important;
  }

  [dir=ltr] .sm\\:ml-2{
    margin-left: 0.5rem !important;
  }

  [dir=rtl] .sm\\:ml-2{
    margin-right: 0.5rem !important;
  }

  [dir] .sm\\:mt-3{
    margin-top: 0.75rem !important;
  }

  [dir=ltr] .sm\\:mr-3{
    margin-right: 0.75rem !important;
  }

  [dir=rtl] .sm\\:mr-3{
    margin-left: 0.75rem !important;
  }

  [dir] .sm\\:mb-3{
    margin-bottom: 0.75rem !important;
  }

  [dir=ltr] .sm\\:ml-3{
    margin-left: 0.75rem !important;
  }

  [dir=rtl] .sm\\:ml-3{
    margin-right: 0.75rem !important;
  }

  [dir] .sm\\:mt-4{
    margin-top: 1rem !important;
  }

  [dir=ltr] .sm\\:mr-4{
    margin-right: 1rem !important;
  }

  [dir=rtl] .sm\\:mr-4{
    margin-left: 1rem !important;
  }

  [dir] .sm\\:mb-4{
    margin-bottom: 1rem !important;
  }

  [dir=ltr] .sm\\:ml-4{
    margin-left: 1rem !important;
  }

  [dir=rtl] .sm\\:ml-4{
    margin-right: 1rem !important;
  }

  [dir] .sm\\:mt-5{
    margin-top: 1.25rem !important;
  }

  [dir=ltr] .sm\\:mr-5{
    margin-right: 1.25rem !important;
  }

  [dir=rtl] .sm\\:mr-5{
    margin-left: 1.25rem !important;
  }

  [dir] .sm\\:mb-5{
    margin-bottom: 1.25rem !important;
  }

  [dir=ltr] .sm\\:ml-5{
    margin-left: 1.25rem !important;
  }

  [dir=rtl] .sm\\:ml-5{
    margin-right: 1.25rem !important;
  }

  [dir] .sm\\:mt-6{
    margin-top: 1.5rem !important;
  }

  [dir=ltr] .sm\\:mr-6{
    margin-right: 1.5rem !important;
  }

  [dir=rtl] .sm\\:mr-6{
    margin-left: 1.5rem !important;
  }

  [dir] .sm\\:mb-6{
    margin-bottom: 1.5rem !important;
  }

  [dir=ltr] .sm\\:ml-6{
    margin-left: 1.5rem !important;
  }

  [dir=rtl] .sm\\:ml-6{
    margin-right: 1.5rem !important;
  }

  [dir] .sm\\:mt-8{
    margin-top: 2rem !important;
  }

  [dir=ltr] .sm\\:mr-8{
    margin-right: 2rem !important;
  }

  [dir=rtl] .sm\\:mr-8{
    margin-left: 2rem !important;
  }

  [dir] .sm\\:mb-8{
    margin-bottom: 2rem !important;
  }

  [dir=ltr] .sm\\:ml-8{
    margin-left: 2rem !important;
  }

  [dir=rtl] .sm\\:ml-8{
    margin-right: 2rem !important;
  }

  [dir] .sm\\:mt-10{
    margin-top: 2.5rem !important;
  }

  [dir=ltr] .sm\\:mr-10{
    margin-right: 2.5rem !important;
  }

  [dir=rtl] .sm\\:mr-10{
    margin-left: 2.5rem !important;
  }

  [dir] .sm\\:mb-10{
    margin-bottom: 2.5rem !important;
  }

  [dir=ltr] .sm\\:ml-10{
    margin-left: 2.5rem !important;
  }

  [dir=rtl] .sm\\:ml-10{
    margin-right: 2.5rem !important;
  }

  [dir] .sm\\:mt-12{
    margin-top: 3rem !important;
  }

  [dir=ltr] .sm\\:mr-12{
    margin-right: 3rem !important;
  }

  [dir=rtl] .sm\\:mr-12{
    margin-left: 3rem !important;
  }

  [dir] .sm\\:mb-12{
    margin-bottom: 3rem !important;
  }

  [dir=ltr] .sm\\:ml-12{
    margin-left: 3rem !important;
  }

  [dir=rtl] .sm\\:ml-12{
    margin-right: 3rem !important;
  }

  [dir] .sm\\:mt-16{
    margin-top: 4rem !important;
  }

  [dir=ltr] .sm\\:mr-16{
    margin-right: 4rem !important;
  }

  [dir=rtl] .sm\\:mr-16{
    margin-left: 4rem !important;
  }

  [dir] .sm\\:mb-16{
    margin-bottom: 4rem !important;
  }

  [dir=ltr] .sm\\:ml-16{
    margin-left: 4rem !important;
  }

  [dir=rtl] .sm\\:ml-16{
    margin-right: 4rem !important;
  }

  [dir] .sm\\:mt-20{
    margin-top: 5rem !important;
  }

  [dir=ltr] .sm\\:mr-20{
    margin-right: 5rem !important;
  }

  [dir=rtl] .sm\\:mr-20{
    margin-left: 5rem !important;
  }

  [dir] .sm\\:mb-20{
    margin-bottom: 5rem !important;
  }

  [dir=ltr] .sm\\:ml-20{
    margin-left: 5rem !important;
  }

  [dir=rtl] .sm\\:ml-20{
    margin-right: 5rem !important;
  }

  [dir] .sm\\:mt-24{
    margin-top: 6rem !important;
  }

  [dir=ltr] .sm\\:mr-24{
    margin-right: 6rem !important;
  }

  [dir=rtl] .sm\\:mr-24{
    margin-left: 6rem !important;
  }

  [dir] .sm\\:mb-24{
    margin-bottom: 6rem !important;
  }

  [dir=ltr] .sm\\:ml-24{
    margin-left: 6rem !important;
  }

  [dir=rtl] .sm\\:ml-24{
    margin-right: 6rem !important;
  }

  [dir] .sm\\:mt-32{
    margin-top: 8rem !important;
  }

  [dir=ltr] .sm\\:mr-32{
    margin-right: 8rem !important;
  }

  [dir=rtl] .sm\\:mr-32{
    margin-left: 8rem !important;
  }

  [dir] .sm\\:mb-32{
    margin-bottom: 8rem !important;
  }

  [dir=ltr] .sm\\:ml-32{
    margin-left: 8rem !important;
  }

  [dir=rtl] .sm\\:ml-32{
    margin-right: 8rem !important;
  }

  [dir] .sm\\:mt-auto{
    margin-top: auto !important;
  }

  [dir=ltr] .sm\\:mr-auto{
    margin-right: auto !important;
  }

  [dir=rtl] .sm\\:mr-auto{
    margin-left: auto !important;
  }

  [dir] .sm\\:mb-auto{
    margin-bottom: auto !important;
  }

  [dir=ltr] .sm\\:ml-auto{
    margin-left: auto !important;
  }

  [dir=rtl] .sm\\:ml-auto{
    margin-right: auto !important;
  }

  [dir] .sm\\:mt-px{
    margin-top: 1px !important;
  }

  [dir=ltr] .sm\\:mr-px{
    margin-right: 1px !important;
  }

  [dir=rtl] .sm\\:mr-px{
    margin-left: 1px !important;
  }

  [dir] .sm\\:mb-px{
    margin-bottom: 1px !important;
  }

  [dir=ltr] .sm\\:ml-px{
    margin-left: 1px !important;
  }

  [dir=rtl] .sm\\:ml-px{
    margin-right: 1px !important;
  }

  [dir] .sm\\:mt-base{
    margin-top: 2.2rem !important;
  }

  [dir=ltr] .sm\\:mr-base{
    margin-right: 2.2rem !important;
  }

  [dir=rtl] .sm\\:mr-base{
    margin-left: 2.2rem !important;
  }

  [dir] .sm\\:mb-base{
    margin-bottom: 2.2rem !important;
  }

  [dir=ltr] .sm\\:ml-base{
    margin-left: 2.2rem !important;
  }

  [dir=rtl] .sm\\:ml-base{
    margin-right: 2.2rem !important;
  }

  [dir] .sm\\:-mt-px{
    margin-top: -1px !important;
  }

  [dir=ltr] .sm\\:-mr-px{
    margin-right: -1px !important;
  }

  [dir=rtl] .sm\\:-mr-px{
    margin-left: -1px !important;
  }

  [dir] .sm\\:-mb-px{
    margin-bottom: -1px !important;
  }

  [dir=ltr] .sm\\:-ml-px{
    margin-left: -1px !important;
  }

  [dir=rtl] .sm\\:-ml-px{
    margin-right: -1px !important;
  }

  [dir] .sm\\:-mt-1{
    margin-top: -0.25rem !important;
  }

  [dir=ltr] .sm\\:-mr-1{
    margin-right: -0.25rem !important;
  }

  [dir=rtl] .sm\\:-mr-1{
    margin-left: -0.25rem !important;
  }

  [dir] .sm\\:-mb-1{
    margin-bottom: -0.25rem !important;
  }

  [dir=ltr] .sm\\:-ml-1{
    margin-left: -0.25rem !important;
  }

  [dir=rtl] .sm\\:-ml-1{
    margin-right: -0.25rem !important;
  }

  [dir] .sm\\:-mt-2{
    margin-top: -0.5rem !important;
  }

  [dir=ltr] .sm\\:-mr-2{
    margin-right: -0.5rem !important;
  }

  [dir=rtl] .sm\\:-mr-2{
    margin-left: -0.5rem !important;
  }

  [dir] .sm\\:-mb-2{
    margin-bottom: -0.5rem !important;
  }

  [dir=ltr] .sm\\:-ml-2{
    margin-left: -0.5rem !important;
  }

  [dir=rtl] .sm\\:-ml-2{
    margin-right: -0.5rem !important;
  }

  [dir] .sm\\:-mt-3{
    margin-top: -0.75rem !important;
  }

  [dir=ltr] .sm\\:-mr-3{
    margin-right: -0.75rem !important;
  }

  [dir=rtl] .sm\\:-mr-3{
    margin-left: -0.75rem !important;
  }

  [dir] .sm\\:-mb-3{
    margin-bottom: -0.75rem !important;
  }

  [dir=ltr] .sm\\:-ml-3{
    margin-left: -0.75rem !important;
  }

  [dir=rtl] .sm\\:-ml-3{
    margin-right: -0.75rem !important;
  }

  [dir] .sm\\:-mt-4{
    margin-top: -1rem !important;
  }

  [dir=ltr] .sm\\:-mr-4{
    margin-right: -1rem !important;
  }

  [dir=rtl] .sm\\:-mr-4{
    margin-left: -1rem !important;
  }

  [dir] .sm\\:-mb-4{
    margin-bottom: -1rem !important;
  }

  [dir=ltr] .sm\\:-ml-4{
    margin-left: -1rem !important;
  }

  [dir=rtl] .sm\\:-ml-4{
    margin-right: -1rem !important;
  }

  .sm\\:max-h-full{
    max-height: 100% !important;
  }

  .sm\\:max-h-screen{
    max-height: 100vh !important;
  }

  .sm\\:max-w-xs{
    max-width: 20rem !important;
  }

  .sm\\:max-w-sm{
    max-width: 30rem !important;
  }

  .sm\\:max-w-md{
    max-width: 40rem !important;
  }

  .sm\\:max-w-lg{
    max-width: 50rem !important;
  }

  .sm\\:max-w-xl{
    max-width: 60rem !important;
  }

  .sm\\:max-w-2xl{
    max-width: 70rem !important;
  }

  .sm\\:max-w-3xl{
    max-width: 80rem !important;
  }

  .sm\\:max-w-4xl{
    max-width: 90rem !important;
  }

  .sm\\:max-w-5xl{
    max-width: 100rem !important;
  }

  .sm\\:max-w-full{
    max-width: 100% !important;
  }

  .sm\\:min-h-0{
    min-height: 0 !important;
  }

  .sm\\:min-h-full{
    min-height: 100% !important;
  }

  .sm\\:min-h-screen{
    min-height: 100vh !important;
  }

  .sm\\:min-w-0{
    min-width: 0 !important;
  }

  .sm\\:min-w-full{
    min-width: 100% !important;
  }

  .sm\\:object-contain{
    object-fit: contain !important;
  }

  .sm\\:object-cover{
    object-fit: cover !important;
  }

  .sm\\:object-fill{
    object-fit: fill !important;
  }

  .sm\\:object-none{
    object-fit: none !important;
  }

  .sm\\:object-scale-down{
    object-fit: scale-down !important;
  }

  .sm\\:object-bottom{
    object-position: bottom !important;
  }

  .sm\\:object-center{
    object-position: center !important;
  }

  .sm\\:object-left{
    object-position: left !important;
  }

  .sm\\:object-left-bottom{
    object-position: left bottom !important;
  }

  .sm\\:object-left-top{
    object-position: left top !important;
  }

  .sm\\:object-right{
    object-position: right !important;
  }

  .sm\\:object-right-bottom{
    object-position: right bottom !important;
  }

  .sm\\:object-right-top{
    object-position: right top !important;
  }

  .sm\\:object-top{
    object-position: top !important;
  }

  .sm\\:opacity-0{
    opacity: 0 !important;
  }

  .sm\\:opacity-25{
    opacity: 0.25 !important;
  }

  .sm\\:opacity-50{
    opacity: 0.5 !important;
  }

  .sm\\:opacity-75{
    opacity: 0.75 !important;
  }

  .sm\\:opacity-100{
    opacity: 1 !important;
  }

  .sm\\:overflow-auto{
    overflow: auto !important;
  }

  .sm\\:overflow-hidden{
    overflow: hidden !important;
  }

  .sm\\:overflow-visible{
    overflow: visible !important;
  }

  .sm\\:overflow-scroll{
    overflow: scroll !important;
  }

  .sm\\:overflow-x-auto{
    overflow-x: auto !important;
  }

  .sm\\:overflow-y-auto{
    overflow-y: auto !important;
  }

  .sm\\:overflow-x-hidden{
    overflow-x: hidden !important;
  }

  .sm\\:overflow-y-hidden{
    overflow-y: hidden !important;
  }

  .sm\\:overflow-x-visible{
    overflow-x: visible !important;
  }

  .sm\\:overflow-y-visible{
    overflow-y: visible !important;
  }

  .sm\\:overflow-x-scroll{
    overflow-x: scroll !important;
  }

  .sm\\:overflow-y-scroll{
    overflow-y: scroll !important;
  }

  .sm\\:scrolling-touch{
    -webkit-overflow-scrolling: touch !important;
  }

  .sm\\:scrolling-auto{
    -webkit-overflow-scrolling: auto !important;
  }

  .sm\\:overscroll-auto{
    overscroll-behavior: auto !important;
  }

  .sm\\:overscroll-contain{
    overscroll-behavior: contain !important;
  }

  .sm\\:overscroll-none{
    overscroll-behavior: none !important;
  }

  .sm\\:overscroll-y-auto{
    overscroll-behavior-y: auto !important;
  }

  .sm\\:overscroll-y-contain{
    overscroll-behavior-y: contain !important;
  }

  .sm\\:overscroll-y-none{
    overscroll-behavior-y: none !important;
  }

  .sm\\:overscroll-x-auto{
    overscroll-behavior-x: auto !important;
  }

  .sm\\:overscroll-x-contain{
    overscroll-behavior-x: contain !important;
  }

  .sm\\:overscroll-x-none{
    overscroll-behavior-x: none !important;
  }

  [dir] .sm\\:p-0{
    padding: 0 !important;
  }

  [dir] .sm\\:p-1{
    padding: 0.25rem !important;
  }

  [dir] .sm\\:p-2{
    padding: 0.5rem !important;
  }

  [dir] .sm\\:p-3{
    padding: 0.75rem !important;
  }

  [dir] .sm\\:p-4{
    padding: 1rem !important;
  }

  [dir] .sm\\:p-5{
    padding: 1.25rem !important;
  }

  [dir] .sm\\:p-6{
    padding: 1.5rem !important;
  }

  [dir] .sm\\:p-8{
    padding: 2rem !important;
  }

  [dir] .sm\\:p-10{
    padding: 2.5rem !important;
  }

  [dir] .sm\\:p-12{
    padding: 3rem !important;
  }

  [dir] .sm\\:p-16{
    padding: 4rem !important;
  }

  [dir] .sm\\:p-20{
    padding: 5rem !important;
  }

  [dir] .sm\\:p-24{
    padding: 6rem !important;
  }

  [dir] .sm\\:p-32{
    padding: 8rem !important;
  }

  [dir] .sm\\:p-px{
    padding: 1px !important;
  }

  [dir] .sm\\:p-base{
    padding: 2.2rem !important;
  }

  [dir] .sm\\:py-0{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  [dir=ltr] .sm\\:px-0{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  [dir=rtl] .sm\\:px-0{
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  [dir] .sm\\:py-1{
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  [dir=ltr] .sm\\:px-1{
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }

  [dir=rtl] .sm\\:px-1{
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  [dir] .sm\\:py-2{
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  [dir=ltr] .sm\\:px-2{
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  [dir=rtl] .sm\\:px-2{
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  [dir] .sm\\:py-3{
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  [dir=ltr] .sm\\:px-3{
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }

  [dir=rtl] .sm\\:px-3{
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  [dir] .sm\\:py-4{
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  [dir=ltr] .sm\\:px-4{
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  [dir=rtl] .sm\\:px-4{
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  [dir] .sm\\:py-5{
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  [dir=ltr] .sm\\:px-5{
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }

  [dir=rtl] .sm\\:px-5{
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  [dir] .sm\\:py-6{
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  [dir=ltr] .sm\\:px-6{
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  [dir=rtl] .sm\\:px-6{
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  [dir] .sm\\:py-8{
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  [dir=ltr] .sm\\:px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  [dir=rtl] .sm\\:px-8{
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  [dir] .sm\\:py-10{
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  [dir=ltr] .sm\\:px-10{
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  [dir=rtl] .sm\\:px-10{
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  [dir] .sm\\:py-12{
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  [dir=ltr] .sm\\:px-12{
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }

  [dir=rtl] .sm\\:px-12{
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  [dir] .sm\\:py-16{
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  [dir=ltr] .sm\\:px-16{
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }

  [dir=rtl] .sm\\:px-16{
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  [dir] .sm\\:py-20{
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  [dir=ltr] .sm\\:px-20{
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }

  [dir=rtl] .sm\\:px-20{
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  [dir] .sm\\:py-24{
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }

  [dir=ltr] .sm\\:px-24{
    padding-left: 6rem !important;
    padding-right: 6rem !important;
  }

  [dir=rtl] .sm\\:px-24{
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }

  [dir] .sm\\:py-32{
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }

  [dir=ltr] .sm\\:px-32{
    padding-left: 8rem !important;
    padding-right: 8rem !important;
  }

  [dir=rtl] .sm\\:px-32{
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }

  [dir] .sm\\:py-px{
    padding-top: 1px !important;
    padding-bottom: 1px !important;
  }

  [dir=ltr] .sm\\:px-px{
    padding-left: 1px !important;
    padding-right: 1px !important;
  }

  [dir=rtl] .sm\\:px-px{
    padding-right: 1px !important;
    padding-left: 1px !important;
  }

  [dir] .sm\\:py-base{
    padding-top: 2.2rem !important;
    padding-bottom: 2.2rem !important;
  }

  [dir=ltr] .sm\\:px-base{
    padding-left: 2.2rem !important;
    padding-right: 2.2rem !important;
  }

  [dir=rtl] .sm\\:px-base{
    padding-right: 2.2rem !important;
    padding-left: 2.2rem !important;
  }

  [dir] .sm\\:pt-0{
    padding-top: 0 !important;
  }

  [dir=ltr] .sm\\:pr-0{
    padding-right: 0 !important;
  }

  [dir=rtl] .sm\\:pr-0{
    padding-left: 0 !important;
  }

  [dir] .sm\\:pb-0{
    padding-bottom: 0 !important;
  }

  [dir=ltr] .sm\\:pl-0{
    padding-left: 0 !important;
  }

  [dir=rtl] .sm\\:pl-0{
    padding-right: 0 !important;
  }

  [dir] .sm\\:pt-1{
    padding-top: 0.25rem !important;
  }

  [dir=ltr] .sm\\:pr-1{
    padding-right: 0.25rem !important;
  }

  [dir=rtl] .sm\\:pr-1{
    padding-left: 0.25rem !important;
  }

  [dir] .sm\\:pb-1{
    padding-bottom: 0.25rem !important;
  }

  [dir=ltr] .sm\\:pl-1{
    padding-left: 0.25rem !important;
  }

  [dir=rtl] .sm\\:pl-1{
    padding-right: 0.25rem !important;
  }

  [dir] .sm\\:pt-2{
    padding-top: 0.5rem !important;
  }

  [dir=ltr] .sm\\:pr-2{
    padding-right: 0.5rem !important;
  }

  [dir=rtl] .sm\\:pr-2{
    padding-left: 0.5rem !important;
  }

  [dir] .sm\\:pb-2{
    padding-bottom: 0.5rem !important;
  }

  [dir=ltr] .sm\\:pl-2{
    padding-left: 0.5rem !important;
  }

  [dir=rtl] .sm\\:pl-2{
    padding-right: 0.5rem !important;
  }

  [dir] .sm\\:pt-3{
    padding-top: 0.75rem !important;
  }

  [dir=ltr] .sm\\:pr-3{
    padding-right: 0.75rem !important;
  }

  [dir=rtl] .sm\\:pr-3{
    padding-left: 0.75rem !important;
  }

  [dir] .sm\\:pb-3{
    padding-bottom: 0.75rem !important;
  }

  [dir=ltr] .sm\\:pl-3{
    padding-left: 0.75rem !important;
  }

  [dir=rtl] .sm\\:pl-3{
    padding-right: 0.75rem !important;
  }

  [dir] .sm\\:pt-4{
    padding-top: 1rem !important;
  }

  [dir=ltr] .sm\\:pr-4{
    padding-right: 1rem !important;
  }

  [dir=rtl] .sm\\:pr-4{
    padding-left: 1rem !important;
  }

  [dir] .sm\\:pb-4{
    padding-bottom: 1rem !important;
  }

  [dir=ltr] .sm\\:pl-4{
    padding-left: 1rem !important;
  }

  [dir=rtl] .sm\\:pl-4{
    padding-right: 1rem !important;
  }

  [dir] .sm\\:pt-5{
    padding-top: 1.25rem !important;
  }

  [dir=ltr] .sm\\:pr-5{
    padding-right: 1.25rem !important;
  }

  [dir=rtl] .sm\\:pr-5{
    padding-left: 1.25rem !important;
  }

  [dir] .sm\\:pb-5{
    padding-bottom: 1.25rem !important;
  }

  [dir=ltr] .sm\\:pl-5{
    padding-left: 1.25rem !important;
  }

  [dir=rtl] .sm\\:pl-5{
    padding-right: 1.25rem !important;
  }

  [dir] .sm\\:pt-6{
    padding-top: 1.5rem !important;
  }

  [dir=ltr] .sm\\:pr-6{
    padding-right: 1.5rem !important;
  }

  [dir=rtl] .sm\\:pr-6{
    padding-left: 1.5rem !important;
  }

  [dir] .sm\\:pb-6{
    padding-bottom: 1.5rem !important;
  }

  [dir=ltr] .sm\\:pl-6{
    padding-left: 1.5rem !important;
  }

  [dir=rtl] .sm\\:pl-6{
    padding-right: 1.5rem !important;
  }

  [dir] .sm\\:pt-8{
    padding-top: 2rem !important;
  }

  [dir=ltr] .sm\\:pr-8{
    padding-right: 2rem !important;
  }

  [dir=rtl] .sm\\:pr-8{
    padding-left: 2rem !important;
  }

  [dir] .sm\\:pb-8{
    padding-bottom: 2rem !important;
  }

  [dir=ltr] .sm\\:pl-8{
    padding-left: 2rem !important;
  }

  [dir=rtl] .sm\\:pl-8{
    padding-right: 2rem !important;
  }

  [dir] .sm\\:pt-10{
    padding-top: 2.5rem !important;
  }

  [dir=ltr] .sm\\:pr-10{
    padding-right: 2.5rem !important;
  }

  [dir=rtl] .sm\\:pr-10{
    padding-left: 2.5rem !important;
  }

  [dir] .sm\\:pb-10{
    padding-bottom: 2.5rem !important;
  }

  [dir=ltr] .sm\\:pl-10{
    padding-left: 2.5rem !important;
  }

  [dir=rtl] .sm\\:pl-10{
    padding-right: 2.5rem !important;
  }

  [dir] .sm\\:pt-12{
    padding-top: 3rem !important;
  }

  [dir=ltr] .sm\\:pr-12{
    padding-right: 3rem !important;
  }

  [dir=rtl] .sm\\:pr-12{
    padding-left: 3rem !important;
  }

  [dir] .sm\\:pb-12{
    padding-bottom: 3rem !important;
  }

  [dir=ltr] .sm\\:pl-12{
    padding-left: 3rem !important;
  }

  [dir=rtl] .sm\\:pl-12{
    padding-right: 3rem !important;
  }

  [dir] .sm\\:pt-16{
    padding-top: 4rem !important;
  }

  [dir=ltr] .sm\\:pr-16{
    padding-right: 4rem !important;
  }

  [dir=rtl] .sm\\:pr-16{
    padding-left: 4rem !important;
  }

  [dir] .sm\\:pb-16{
    padding-bottom: 4rem !important;
  }

  [dir=ltr] .sm\\:pl-16{
    padding-left: 4rem !important;
  }

  [dir=rtl] .sm\\:pl-16{
    padding-right: 4rem !important;
  }

  [dir] .sm\\:pt-20{
    padding-top: 5rem !important;
  }

  [dir=ltr] .sm\\:pr-20{
    padding-right: 5rem !important;
  }

  [dir=rtl] .sm\\:pr-20{
    padding-left: 5rem !important;
  }

  [dir] .sm\\:pb-20{
    padding-bottom: 5rem !important;
  }

  [dir=ltr] .sm\\:pl-20{
    padding-left: 5rem !important;
  }

  [dir=rtl] .sm\\:pl-20{
    padding-right: 5rem !important;
  }

  [dir] .sm\\:pt-24{
    padding-top: 6rem !important;
  }

  [dir=ltr] .sm\\:pr-24{
    padding-right: 6rem !important;
  }

  [dir=rtl] .sm\\:pr-24{
    padding-left: 6rem !important;
  }

  [dir] .sm\\:pb-24{
    padding-bottom: 6rem !important;
  }

  [dir=ltr] .sm\\:pl-24{
    padding-left: 6rem !important;
  }

  [dir=rtl] .sm\\:pl-24{
    padding-right: 6rem !important;
  }

  [dir] .sm\\:pt-32{
    padding-top: 8rem !important;
  }

  [dir=ltr] .sm\\:pr-32{
    padding-right: 8rem !important;
  }

  [dir=rtl] .sm\\:pr-32{
    padding-left: 8rem !important;
  }

  [dir] .sm\\:pb-32{
    padding-bottom: 8rem !important;
  }

  [dir=ltr] .sm\\:pl-32{
    padding-left: 8rem !important;
  }

  [dir=rtl] .sm\\:pl-32{
    padding-right: 8rem !important;
  }

  [dir] .sm\\:pt-px{
    padding-top: 1px !important;
  }

  [dir=ltr] .sm\\:pr-px{
    padding-right: 1px !important;
  }

  [dir=rtl] .sm\\:pr-px{
    padding-left: 1px !important;
  }

  [dir] .sm\\:pb-px{
    padding-bottom: 1px !important;
  }

  [dir=ltr] .sm\\:pl-px{
    padding-left: 1px !important;
  }

  [dir=rtl] .sm\\:pl-px{
    padding-right: 1px !important;
  }

  [dir] .sm\\:pt-base{
    padding-top: 2.2rem !important;
  }

  [dir=ltr] .sm\\:pr-base{
    padding-right: 2.2rem !important;
  }

  [dir=rtl] .sm\\:pr-base{
    padding-left: 2.2rem !important;
  }

  [dir] .sm\\:pb-base{
    padding-bottom: 2.2rem !important;
  }

  [dir=ltr] .sm\\:pl-base{
    padding-left: 2.2rem !important;
  }

  [dir=rtl] .sm\\:pl-base{
    padding-right: 2.2rem !important;
  }

  .sm\\:placeholder-transparent::placeholder{
    color: transparent !important;
  }

  .sm\\:placeholder-black::placeholder{
    --placeholder-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--placeholder-opacity)) !important;
  }

  .sm\\:placeholder-white::placeholder{
    --placeholder-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--placeholder-opacity)) !important;
  }

  .sm\\:placeholder-grey::placeholder{
    --placeholder-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--placeholder-opacity)) !important;
  }

  .sm\\:placeholder-grey-light::placeholder{
    --placeholder-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--placeholder-opacity)) !important;
  }

  .sm\\:focus\\:placeholder-transparent:focus::placeholder{
    color: transparent !important;
  }

  .sm\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--placeholder-opacity)) !important;
  }

  .sm\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--placeholder-opacity)) !important;
  }

  .sm\\:focus\\:placeholder-grey:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--placeholder-opacity)) !important;
  }

  .sm\\:focus\\:placeholder-grey-light:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--placeholder-opacity)) !important;
  }

  .sm\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity: 0 !important;
  }

  .sm\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity: 0.25 !important;
  }

  .sm\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity: 0.5 !important;
  }

  .sm\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity: 0.75 !important;
  }

  .sm\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity: 1 !important;
  }

  .sm\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity: 0 !important;
  }

  .sm\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity: 0.25 !important;
  }

  .sm\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity: 0.5 !important;
  }

  .sm\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity: 0.75 !important;
  }

  .sm\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity: 1 !important;
  }

  .sm\\:pointer-events-none{
    pointer-events: none !important;
  }

  .sm\\:pointer-events-auto{
    pointer-events: auto !important;
  }

  .sm\\:static{
    position: static !important;
  }

  .sm\\:fixed{
    position: fixed !important;
  }

  .sm\\:absolute{
    position: absolute !important;
  }

  .sm\\:relative{
    position: relative !important;
  }

  .sm\\:sticky{
    position: sticky !important;
  }

  .sm\\:inset-0{
    top: 0 !important;
    bottom: 0 !important;
  }

  [dir=ltr] .sm\\:inset-0{
    right: 0 !important;
    left: 0 !important;
  }

  [dir=rtl] .sm\\:inset-0{
    left: 0 !important;
    right: 0 !important;
  }

  .sm\\:inset-auto{
    top: auto !important;
    bottom: auto !important;
  }

  [dir=ltr] .sm\\:inset-auto{
    right: auto !important;
    left: auto !important;
  }

  [dir=rtl] .sm\\:inset-auto{
    left: auto !important;
    right: auto !important;
  }

  .sm\\:inset-y-0{
    top: 0 !important;
    bottom: 0 !important;
  }

  [dir=ltr] .sm\\:inset-x-0{
    right: 0 !important;
    left: 0 !important;
  }

  [dir=rtl] .sm\\:inset-x-0{
    left: 0 !important;
    right: 0 !important;
  }

  .sm\\:inset-y-auto{
    top: auto !important;
    bottom: auto !important;
  }

  [dir=ltr] .sm\\:inset-x-auto{
    right: auto !important;
    left: auto !important;
  }

  [dir=rtl] .sm\\:inset-x-auto{
    left: auto !important;
    right: auto !important;
  }

  .sm\\:top-0{
    top: 0 !important;
  }

  [dir=ltr] .sm\\:right-0{
    right: 0 !important;
  }

  [dir=rtl] .sm\\:right-0{
    left: 0 !important;
  }

  .sm\\:bottom-0{
    bottom: 0 !important;
  }

  [dir=ltr] .sm\\:left-0{
    left: 0 !important;
  }

  [dir=rtl] .sm\\:left-0{
    right: 0 !important;
  }

  .sm\\:top-auto{
    top: auto !important;
  }

  [dir=ltr] .sm\\:right-auto{
    right: auto !important;
  }

  [dir=rtl] .sm\\:right-auto{
    left: auto !important;
  }

  .sm\\:bottom-auto{
    bottom: auto !important;
  }

  [dir=ltr] .sm\\:left-auto{
    left: auto !important;
  }

  [dir=rtl] .sm\\:left-auto{
    right: auto !important;
  }

  .sm\\:resize-none{
    resize: none !important;
  }

  .sm\\:resize-y{
    resize: vertical !important;
  }

  .sm\\:resize-x{
    resize: horizontal !important;
  }

  .sm\\:resize{
    resize: both !important;
  }

  [dir] .sm\\:shadow{
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
  }

  [dir] .sm\\:shadow-md{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .sm\\:shadow-lg{
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .sm\\:shadow-inner{
    box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
  }

  [dir] .sm\\:shadow-xl{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  [dir] .sm\\:shadow-2xl{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }

  [dir] .sm\\:shadow-outline{
    box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
  }

  [dir] .sm\\:shadow-none{
    box-shadow: none !important;
  }

  [dir] .sm\\:shadow-drop{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
  }

  [dir] .sm\\:hover\\:shadow:hover{
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
  }

  [dir] .sm\\:hover\\:shadow-md:hover{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .sm\\:hover\\:shadow-lg:hover{
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .sm\\:hover\\:shadow-inner:hover{
    box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
  }

  [dir] .sm\\:hover\\:shadow-xl:hover{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  [dir] .sm\\:hover\\:shadow-2xl:hover{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }

  [dir] .sm\\:hover\\:shadow-outline:hover{
    box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
  }

  [dir] .sm\\:hover\\:shadow-none:hover{
    box-shadow: none !important;
  }

  [dir] .sm\\:hover\\:shadow-drop:hover{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
  }

  [dir] .sm\\:focus\\:shadow:focus{
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
  }

  [dir] .sm\\:focus\\:shadow-md:focus{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .sm\\:focus\\:shadow-lg:focus{
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .sm\\:focus\\:shadow-inner:focus{
    box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
  }

  [dir] .sm\\:focus\\:shadow-xl:focus{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  [dir] .sm\\:focus\\:shadow-2xl:focus{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }

  [dir] .sm\\:focus\\:shadow-outline:focus{
    box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
  }

  [dir] .sm\\:focus\\:shadow-none:focus{
    box-shadow: none !important;
  }

  [dir] .sm\\:focus\\:shadow-drop:focus{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
  }

  .sm\\:stroke-0{
    stroke-width: 0 !important;
  }

  .sm\\:stroke-1{
    stroke-width: 1 !important;
  }

  .sm\\:stroke-2{
    stroke-width: 2 !important;
  }

  .sm\\:table-auto{
    table-layout: auto !important;
  }

  .sm\\:table-fixed{
    table-layout: fixed !important;
  }

  [dir=ltr] .sm\\:text-left{
    text-align: left !important;
  }

  [dir=rtl] .sm\\:text-left{
    text-align: right !important;
  }

  [dir] .sm\\:text-center{
    text-align: center !important;
  }

  [dir=ltr] .sm\\:text-right{
    text-align: right !important;
  }

  [dir=rtl] .sm\\:text-right{
    text-align: left !important;
  }

  [dir] .sm\\:text-justify{
    text-align: justify !important;
  }

  .sm\\:text-inherit{
    color: inherit !important;
  }

  .sm\\:text-transparent{
    color: transparent !important;
  }

  .sm\\:text-black{
    --text-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--text-opacity)) !important;
  }

  .sm\\:text-white{
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }

  .sm\\:text-grey{
    --text-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--text-opacity)) !important;
  }

  .sm\\:text-grey-light{
    --text-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--text-opacity)) !important;
  }

  .sm\\:hover\\:text-inherit:hover{
    color: inherit !important;
  }

  .sm\\:hover\\:text-transparent:hover{
    color: transparent !important;
  }

  .sm\\:hover\\:text-black:hover{
    --text-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--text-opacity)) !important;
  }

  .sm\\:hover\\:text-white:hover{
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }

  .sm\\:hover\\:text-grey:hover{
    --text-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--text-opacity)) !important;
  }

  .sm\\:hover\\:text-grey-light:hover{
    --text-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--text-opacity)) !important;
  }

  .sm\\:focus\\:text-inherit:focus{
    color: inherit !important;
  }

  .sm\\:focus\\:text-transparent:focus{
    color: transparent !important;
  }

  .sm\\:focus\\:text-black:focus{
    --text-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--text-opacity)) !important;
  }

  .sm\\:focus\\:text-white:focus{
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }

  .sm\\:focus\\:text-grey:focus{
    --text-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--text-opacity)) !important;
  }

  .sm\\:focus\\:text-grey-light:focus{
    --text-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--text-opacity)) !important;
  }

  .sm\\:text-opacity-0{
    --text-opacity: 0 !important;
  }

  .sm\\:text-opacity-25{
    --text-opacity: 0.25 !important;
  }

  .sm\\:text-opacity-50{
    --text-opacity: 0.5 !important;
  }

  .sm\\:text-opacity-75{
    --text-opacity: 0.75 !important;
  }

  .sm\\:text-opacity-100{
    --text-opacity: 1 !important;
  }

  .sm\\:hover\\:text-opacity-0:hover{
    --text-opacity: 0 !important;
  }

  .sm\\:hover\\:text-opacity-25:hover{
    --text-opacity: 0.25 !important;
  }

  .sm\\:hover\\:text-opacity-50:hover{
    --text-opacity: 0.5 !important;
  }

  .sm\\:hover\\:text-opacity-75:hover{
    --text-opacity: 0.75 !important;
  }

  .sm\\:hover\\:text-opacity-100:hover{
    --text-opacity: 1 !important;
  }

  .sm\\:focus\\:text-opacity-0:focus{
    --text-opacity: 0 !important;
  }

  .sm\\:focus\\:text-opacity-25:focus{
    --text-opacity: 0.25 !important;
  }

  .sm\\:focus\\:text-opacity-50:focus{
    --text-opacity: 0.5 !important;
  }

  .sm\\:focus\\:text-opacity-75:focus{
    --text-opacity: 0.75 !important;
  }

  .sm\\:focus\\:text-opacity-100:focus{
    --text-opacity: 1 !important;
  }

  .sm\\:italic{
    font-style: italic !important;
  }

  .sm\\:not-italic{
    font-style: normal !important;
  }

  .sm\\:hover\\:italic:hover{
    font-style: italic !important;
  }

  .sm\\:hover\\:not-italic:hover{
    font-style: normal !important;
  }

  .sm\\:focus\\:italic:focus{
    font-style: italic !important;
  }

  .sm\\:focus\\:not-italic:focus{
    font-style: normal !important;
  }

  .sm\\:uppercase{
    text-transform: uppercase !important;
  }

  .sm\\:lowercase{
    text-transform: lowercase !important;
  }

  .sm\\:capitalize{
    text-transform: capitalize !important;
  }

  .sm\\:normal-case{
    text-transform: none !important;
  }

  .sm\\:hover\\:uppercase:hover{
    text-transform: uppercase !important;
  }

  .sm\\:hover\\:lowercase:hover{
    text-transform: lowercase !important;
  }

  .sm\\:hover\\:capitalize:hover{
    text-transform: capitalize !important;
  }

  .sm\\:hover\\:normal-case:hover{
    text-transform: none !important;
  }

  .sm\\:focus\\:uppercase:focus{
    text-transform: uppercase !important;
  }

  .sm\\:focus\\:lowercase:focus{
    text-transform: lowercase !important;
  }

  .sm\\:focus\\:capitalize:focus{
    text-transform: capitalize !important;
  }

  .sm\\:focus\\:normal-case:focus{
    text-transform: none !important;
  }

  .sm\\:underline{
    text-decoration: underline !important;
  }

  .sm\\:line-through{
    text-decoration: line-through !important;
  }

  .sm\\:no-underline{
    text-decoration: none !important;
  }

  .sm\\:hover\\:underline:hover{
    text-decoration: underline !important;
  }

  .sm\\:hover\\:line-through:hover{
    text-decoration: line-through !important;
  }

  .sm\\:hover\\:no-underline:hover{
    text-decoration: none !important;
  }

  .sm\\:focus\\:underline:focus{
    text-decoration: underline !important;
  }

  .sm\\:focus\\:line-through:focus{
    text-decoration: line-through !important;
  }

  .sm\\:focus\\:no-underline:focus{
    text-decoration: none !important;
  }

  .sm\\:antialiased{
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }

  .sm\\:subpixel-antialiased{
    -webkit-font-smoothing: auto !important;
    -moz-osx-font-smoothing: auto !important;
  }

  .sm\\:hover\\:antialiased:hover{
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }

  .sm\\:hover\\:subpixel-antialiased:hover{
    -webkit-font-smoothing: auto !important;
    -moz-osx-font-smoothing: auto !important;
  }

  .sm\\:focus\\:antialiased:focus{
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }

  .sm\\:focus\\:subpixel-antialiased:focus{
    -webkit-font-smoothing: auto !important;
    -moz-osx-font-smoothing: auto !important;
  }

  .sm\\:ordinal, .sm\\:slashed-zero, .sm\\:lining-nums, .sm\\:oldstyle-nums, .sm\\:proportional-nums, .sm\\:tabular-nums, .sm\\:diagonal-fractions, .sm\\:stacked-fractions{
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/) !important;
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction) !important;
  }

  .sm\\:normal-nums{
    font-variant-numeric: normal !important;
  }

  .sm\\:ordinal{
    --font-variant-numeric-ordinal: ordinal !important;
  }

  .sm\\:slashed-zero{
    --font-variant-numeric-slashed-zero: slashed-zero !important;
  }

  .sm\\:lining-nums{
    --font-variant-numeric-figure: lining-nums !important;
  }

  .sm\\:oldstyle-nums{
    --font-variant-numeric-figure: oldstyle-nums !important;
  }

  .sm\\:proportional-nums{
    --font-variant-numeric-spacing: proportional-nums !important;
  }

  .sm\\:tabular-nums{
    --font-variant-numeric-spacing: tabular-nums !important;
  }

  .sm\\:diagonal-fractions{
    --font-variant-numeric-fraction: diagonal-fractions !important;
  }

  .sm\\:stacked-fractions{
    --font-variant-numeric-fraction: stacked-fractions !important;
  }

  .sm\\:select-none{
    -webkit-user-select: none !important;
            user-select: none !important;
  }

  .sm\\:select-text{
    -webkit-user-select: text !important;
            user-select: text !important;
  }

  .sm\\:select-all{
    -webkit-user-select: all !important;
            user-select: all !important;
  }

  .sm\\:select-auto{
    -webkit-user-select: auto !important;
            user-select: auto !important;
  }

  .sm\\:align-baseline{
    vertical-align: baseline !important;
  }

  .sm\\:align-top{
    vertical-align: top !important;
  }

  .sm\\:align-middle{
    vertical-align: middle !important;
  }

  .sm\\:align-bottom{
    vertical-align: bottom !important;
  }

  .sm\\:align-text-top{
    vertical-align: text-top !important;
  }

  .sm\\:align-text-bottom{
    vertical-align: text-bottom !important;
  }

  .sm\\:visible{
    visibility: visible !important;
  }

  .sm\\:invisible{
    visibility: hidden !important;
  }

  .sm\\:whitespace-normal{
    white-space: normal !important;
  }

  .sm\\:whitespace-no-wrap{
    white-space: nowrap !important;
  }

  .sm\\:whitespace-pre{
    white-space: pre !important;
  }

  .sm\\:whitespace-pre-line{
    white-space: pre-line !important;
  }

  .sm\\:whitespace-pre-wrap{
    white-space: pre-wrap !important;
  }

  .sm\\:break-normal{
    word-wrap: normal !important;
    overflow-wrap: normal !important;
    word-break: normal !important;
  }

  .sm\\:break-words{
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
  }

  .sm\\:break-all{
    word-break: break-all !important;
  }

  .sm\\:truncate{
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .sm\\:w-1{
    width: 0.25rem !important;
  }

  .sm\\:w-2{
    width: 0.5rem !important;
  }

  .sm\\:w-3{
    width: 0.75rem !important;
  }

  .sm\\:w-4{
    width: 1rem !important;
  }

  .sm\\:w-5{
    width: 1.25rem !important;
  }

  .sm\\:w-6{
    width: 1.5rem !important;
  }

  .sm\\:w-8{
    width: 2rem !important;
  }

  .sm\\:w-10{
    width: 2.5rem !important;
  }

  .sm\\:w-12{
    width: 3rem !important;
  }

  .sm\\:w-16{
    width: 4rem !important;
  }

  .sm\\:w-24{
    width: 6rem !important;
  }

  .sm\\:w-32{
    width: 8rem !important;
  }

  .sm\\:w-48{
    width: 12rem !important;
  }

  .sm\\:w-64{
    width: 16rem !important;
  }

  .sm\\:w-auto{
    width: auto !important;
  }

  .sm\\:w-px{
    width: 1px !important;
  }

  .sm\\:w-1\\/2{
    width: 50% !important;
  }

  .sm\\:w-1\\/3{
    width: 33.33333% !important;
  }

  .sm\\:w-2\\/3{
    width: 66.66667% !important;
  }

  .sm\\:w-1\\/4{
    width: 25% !important;
  }

  .sm\\:w-3\\/4{
    width: 75% !important;
  }

  .sm\\:w-1\\/5{
    width: 20% !important;
  }

  .sm\\:w-2\\/5{
    width: 40% !important;
  }

  .sm\\:w-3\\/5{
    width: 60% !important;
  }

  .sm\\:w-4\\/5{
    width: 80% !important;
  }

  .sm\\:w-1\\/6{
    width: 16.66667% !important;
  }

  .sm\\:w-5\\/6{
    width: 83.33333% !important;
  }

  .sm\\:w-1\\/12{
    width: 8.33333% !important;
  }

  .sm\\:w-2\\/12{
    width: 16.66667% !important;
  }

  .sm\\:w-3\\/12{
    width: 25% !important;
  }

  .sm\\:w-4\\/12{
    width: 33.33333% !important;
  }

  .sm\\:w-5\\/12{
    width: 41.66667% !important;
  }

  .sm\\:w-6\\/12{
    width: 50% !important;
  }

  .sm\\:w-7\\/12{
    width: 58.33333% !important;
  }

  .sm\\:w-8\\/12{
    width: 66.66667% !important;
  }

  .sm\\:w-9\\/12{
    width: 75% !important;
  }

  .sm\\:w-10\\/12{
    width: 83.33333% !important;
  }

  .sm\\:w-11\\/12{
    width: 91.66667% !important;
  }

  .sm\\:w-full{
    width: 100% !important;
  }

  .sm\\:w-screen{
    width: 100vw !important;
  }

  .sm\\:z-0{
    z-index: 0 !important;
  }

  .sm\\:z-10{
    z-index: 10 !important;
  }

  .sm\\:z-20{
    z-index: 20 !important;
  }

  .sm\\:z-30{
    z-index: 30 !important;
  }

  .sm\\:z-40{
    z-index: 40 !important;
  }

  .sm\\:z-50{
    z-index: 50 !important;
  }

  .sm\\:z-auto{
    z-index: auto !important;
  }

  .sm\\:gap-0{
    grid-gap: 0 !important;
    gap: 0 !important;
  }

  .sm\\:gap-1{
    grid-gap: 0.25rem !important;
    gap: 0.25rem !important;
  }

  .sm\\:gap-2{
    grid-gap: 0.5rem !important;
    gap: 0.5rem !important;
  }

  .sm\\:gap-3{
    grid-gap: 0.75rem !important;
    gap: 0.75rem !important;
  }

  .sm\\:gap-4{
    grid-gap: 1rem !important;
    gap: 1rem !important;
  }

  .sm\\:gap-5{
    grid-gap: 1.25rem !important;
    gap: 1.25rem !important;
  }

  .sm\\:gap-6{
    grid-gap: 1.5rem !important;
    gap: 1.5rem !important;
  }

  .sm\\:gap-8{
    grid-gap: 2rem !important;
    gap: 2rem !important;
  }

  .sm\\:gap-10{
    grid-gap: 2.5rem !important;
    gap: 2.5rem !important;
  }

  .sm\\:gap-12{
    grid-gap: 3rem !important;
    gap: 3rem !important;
  }

  .sm\\:gap-16{
    grid-gap: 4rem !important;
    gap: 4rem !important;
  }

  .sm\\:gap-20{
    grid-gap: 5rem !important;
    gap: 5rem !important;
  }

  .sm\\:gap-24{
    grid-gap: 6rem !important;
    gap: 6rem !important;
  }

  .sm\\:gap-32{
    grid-gap: 8rem !important;
    gap: 8rem !important;
  }

  .sm\\:gap-40{
    grid-gap: 10rem !important;
    gap: 10rem !important;
  }

  .sm\\:gap-48{
    grid-gap: 12rem !important;
    gap: 12rem !important;
  }

  .sm\\:gap-56{
    grid-gap: 14rem !important;
    gap: 14rem !important;
  }

  .sm\\:gap-64{
    grid-gap: 16rem !important;
    gap: 16rem !important;
  }

  .sm\\:gap-px{
    grid-gap: 1px !important;
    gap: 1px !important;
  }

  .sm\\:col-gap-0{
    grid-column-gap: 0 !important;
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .sm\\:col-gap-1{
    grid-column-gap: 0.25rem !important;
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .sm\\:col-gap-2{
    grid-column-gap: 0.5rem !important;
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .sm\\:col-gap-3{
    grid-column-gap: 0.75rem !important;
    -moz-column-gap: 0.75rem !important;
         column-gap: 0.75rem !important;
  }

  .sm\\:col-gap-4{
    grid-column-gap: 1rem !important;
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .sm\\:col-gap-5{
    grid-column-gap: 1.25rem !important;
    -moz-column-gap: 1.25rem !important;
         column-gap: 1.25rem !important;
  }

  .sm\\:col-gap-6{
    grid-column-gap: 1.5rem !important;
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .sm\\:col-gap-8{
    grid-column-gap: 2rem !important;
    -moz-column-gap: 2rem !important;
         column-gap: 2rem !important;
  }

  .sm\\:col-gap-10{
    grid-column-gap: 2.5rem !important;
    -moz-column-gap: 2.5rem !important;
         column-gap: 2.5rem !important;
  }

  .sm\\:col-gap-12{
    grid-column-gap: 3rem !important;
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  .sm\\:col-gap-16{
    grid-column-gap: 4rem !important;
    -moz-column-gap: 4rem !important;
         column-gap: 4rem !important;
  }

  .sm\\:col-gap-20{
    grid-column-gap: 5rem !important;
    -moz-column-gap: 5rem !important;
         column-gap: 5rem !important;
  }

  .sm\\:col-gap-24{
    grid-column-gap: 6rem !important;
    -moz-column-gap: 6rem !important;
         column-gap: 6rem !important;
  }

  .sm\\:col-gap-32{
    grid-column-gap: 8rem !important;
    -moz-column-gap: 8rem !important;
         column-gap: 8rem !important;
  }

  .sm\\:col-gap-40{
    grid-column-gap: 10rem !important;
    -moz-column-gap: 10rem !important;
         column-gap: 10rem !important;
  }

  .sm\\:col-gap-48{
    grid-column-gap: 12rem !important;
    -moz-column-gap: 12rem !important;
         column-gap: 12rem !important;
  }

  .sm\\:col-gap-56{
    grid-column-gap: 14rem !important;
    -moz-column-gap: 14rem !important;
         column-gap: 14rem !important;
  }

  .sm\\:col-gap-64{
    grid-column-gap: 16rem !important;
    -moz-column-gap: 16rem !important;
         column-gap: 16rem !important;
  }

  .sm\\:col-gap-px{
    grid-column-gap: 1px !important;
    -moz-column-gap: 1px !important;
         column-gap: 1px !important;
  }

  .sm\\:gap-x-0{
    grid-column-gap: 0 !important;
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .sm\\:gap-x-1{
    grid-column-gap: 0.25rem !important;
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .sm\\:gap-x-2{
    grid-column-gap: 0.5rem !important;
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .sm\\:gap-x-3{
    grid-column-gap: 0.75rem !important;
    -moz-column-gap: 0.75rem !important;
         column-gap: 0.75rem !important;
  }

  .sm\\:gap-x-4{
    grid-column-gap: 1rem !important;
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .sm\\:gap-x-5{
    grid-column-gap: 1.25rem !important;
    -moz-column-gap: 1.25rem !important;
         column-gap: 1.25rem !important;
  }

  .sm\\:gap-x-6{
    grid-column-gap: 1.5rem !important;
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .sm\\:gap-x-8{
    grid-column-gap: 2rem !important;
    -moz-column-gap: 2rem !important;
         column-gap: 2rem !important;
  }

  .sm\\:gap-x-10{
    grid-column-gap: 2.5rem !important;
    -moz-column-gap: 2.5rem !important;
         column-gap: 2.5rem !important;
  }

  .sm\\:gap-x-12{
    grid-column-gap: 3rem !important;
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  .sm\\:gap-x-16{
    grid-column-gap: 4rem !important;
    -moz-column-gap: 4rem !important;
         column-gap: 4rem !important;
  }

  .sm\\:gap-x-20{
    grid-column-gap: 5rem !important;
    -moz-column-gap: 5rem !important;
         column-gap: 5rem !important;
  }

  .sm\\:gap-x-24{
    grid-column-gap: 6rem !important;
    -moz-column-gap: 6rem !important;
         column-gap: 6rem !important;
  }

  .sm\\:gap-x-32{
    grid-column-gap: 8rem !important;
    -moz-column-gap: 8rem !important;
         column-gap: 8rem !important;
  }

  .sm\\:gap-x-40{
    grid-column-gap: 10rem !important;
    -moz-column-gap: 10rem !important;
         column-gap: 10rem !important;
  }

  .sm\\:gap-x-48{
    grid-column-gap: 12rem !important;
    -moz-column-gap: 12rem !important;
         column-gap: 12rem !important;
  }

  .sm\\:gap-x-56{
    grid-column-gap: 14rem !important;
    -moz-column-gap: 14rem !important;
         column-gap: 14rem !important;
  }

  .sm\\:gap-x-64{
    grid-column-gap: 16rem !important;
    -moz-column-gap: 16rem !important;
         column-gap: 16rem !important;
  }

  .sm\\:gap-x-px{
    grid-column-gap: 1px !important;
    -moz-column-gap: 1px !important;
         column-gap: 1px !important;
  }

  .sm\\:row-gap-0{
    grid-row-gap: 0 !important;
    row-gap: 0 !important;
  }

  .sm\\:row-gap-1{
    grid-row-gap: 0.25rem !important;
    row-gap: 0.25rem !important;
  }

  .sm\\:row-gap-2{
    grid-row-gap: 0.5rem !important;
    row-gap: 0.5rem !important;
  }

  .sm\\:row-gap-3{
    grid-row-gap: 0.75rem !important;
    row-gap: 0.75rem !important;
  }

  .sm\\:row-gap-4{
    grid-row-gap: 1rem !important;
    row-gap: 1rem !important;
  }

  .sm\\:row-gap-5{
    grid-row-gap: 1.25rem !important;
    row-gap: 1.25rem !important;
  }

  .sm\\:row-gap-6{
    grid-row-gap: 1.5rem !important;
    row-gap: 1.5rem !important;
  }

  .sm\\:row-gap-8{
    grid-row-gap: 2rem !important;
    row-gap: 2rem !important;
  }

  .sm\\:row-gap-10{
    grid-row-gap: 2.5rem !important;
    row-gap: 2.5rem !important;
  }

  .sm\\:row-gap-12{
    grid-row-gap: 3rem !important;
    row-gap: 3rem !important;
  }

  .sm\\:row-gap-16{
    grid-row-gap: 4rem !important;
    row-gap: 4rem !important;
  }

  .sm\\:row-gap-20{
    grid-row-gap: 5rem !important;
    row-gap: 5rem !important;
  }

  .sm\\:row-gap-24{
    grid-row-gap: 6rem !important;
    row-gap: 6rem !important;
  }

  .sm\\:row-gap-32{
    grid-row-gap: 8rem !important;
    row-gap: 8rem !important;
  }

  .sm\\:row-gap-40{
    grid-row-gap: 10rem !important;
    row-gap: 10rem !important;
  }

  .sm\\:row-gap-48{
    grid-row-gap: 12rem !important;
    row-gap: 12rem !important;
  }

  .sm\\:row-gap-56{
    grid-row-gap: 14rem !important;
    row-gap: 14rem !important;
  }

  .sm\\:row-gap-64{
    grid-row-gap: 16rem !important;
    row-gap: 16rem !important;
  }

  .sm\\:row-gap-px{
    grid-row-gap: 1px !important;
    row-gap: 1px !important;
  }

  .sm\\:gap-y-0{
    grid-row-gap: 0 !important;
    row-gap: 0 !important;
  }

  .sm\\:gap-y-1{
    grid-row-gap: 0.25rem !important;
    row-gap: 0.25rem !important;
  }

  .sm\\:gap-y-2{
    grid-row-gap: 0.5rem !important;
    row-gap: 0.5rem !important;
  }

  .sm\\:gap-y-3{
    grid-row-gap: 0.75rem !important;
    row-gap: 0.75rem !important;
  }

  .sm\\:gap-y-4{
    grid-row-gap: 1rem !important;
    row-gap: 1rem !important;
  }

  .sm\\:gap-y-5{
    grid-row-gap: 1.25rem !important;
    row-gap: 1.25rem !important;
  }

  .sm\\:gap-y-6{
    grid-row-gap: 1.5rem !important;
    row-gap: 1.5rem !important;
  }

  .sm\\:gap-y-8{
    grid-row-gap: 2rem !important;
    row-gap: 2rem !important;
  }

  .sm\\:gap-y-10{
    grid-row-gap: 2.5rem !important;
    row-gap: 2.5rem !important;
  }

  .sm\\:gap-y-12{
    grid-row-gap: 3rem !important;
    row-gap: 3rem !important;
  }

  .sm\\:gap-y-16{
    grid-row-gap: 4rem !important;
    row-gap: 4rem !important;
  }

  .sm\\:gap-y-20{
    grid-row-gap: 5rem !important;
    row-gap: 5rem !important;
  }

  .sm\\:gap-y-24{
    grid-row-gap: 6rem !important;
    row-gap: 6rem !important;
  }

  .sm\\:gap-y-32{
    grid-row-gap: 8rem !important;
    row-gap: 8rem !important;
  }

  .sm\\:gap-y-40{
    grid-row-gap: 10rem !important;
    row-gap: 10rem !important;
  }

  .sm\\:gap-y-48{
    grid-row-gap: 12rem !important;
    row-gap: 12rem !important;
  }

  .sm\\:gap-y-56{
    grid-row-gap: 14rem !important;
    row-gap: 14rem !important;
  }

  .sm\\:gap-y-64{
    grid-row-gap: 16rem !important;
    row-gap: 16rem !important;
  }

  .sm\\:gap-y-px{
    grid-row-gap: 1px !important;
    row-gap: 1px !important;
  }

  .sm\\:grid-flow-row{
    grid-auto-flow: row !important;
  }

  .sm\\:grid-flow-col{
    grid-auto-flow: column !important;
  }

  .sm\\:grid-flow-row-dense{
    grid-auto-flow: row dense !important;
  }

  .sm\\:grid-flow-col-dense{
    grid-auto-flow: column dense !important;
  }

  .sm\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-cols-none{
    grid-template-columns: none !important;
  }

  .sm\\:auto-cols-auto{
    grid-auto-columns: auto !important;
  }

  .sm\\:auto-cols-min{
    grid-auto-columns: min-content !important;
  }

  .sm\\:auto-cols-max{
    grid-auto-columns: max-content !important;
  }

  .sm\\:auto-cols-fr{
    grid-auto-columns: minmax(0, 1fr) !important;
  }

  .sm\\:col-auto{
    grid-column: auto !important;
  }

  .sm\\:col-span-1{
    grid-column: span 1 / span 1 !important;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2 !important;
  }

  .sm\\:col-span-3{
    grid-column: span 3 / span 3 !important;
  }

  .sm\\:col-span-4{
    grid-column: span 4 / span 4 !important;
  }

  .sm\\:col-span-5{
    grid-column: span 5 / span 5 !important;
  }

  .sm\\:col-span-6{
    grid-column: span 6 / span 6 !important;
  }

  .sm\\:col-span-7{
    grid-column: span 7 / span 7 !important;
  }

  .sm\\:col-span-8{
    grid-column: span 8 / span 8 !important;
  }

  .sm\\:col-span-9{
    grid-column: span 9 / span 9 !important;
  }

  .sm\\:col-span-10{
    grid-column: span 10 / span 10 !important;
  }

  .sm\\:col-span-11{
    grid-column: span 11 / span 11 !important;
  }

  .sm\\:col-span-12{
    grid-column: span 12 / span 12 !important;
  }

  .sm\\:col-span-full{
    grid-column: 1 / -1 !important;
  }

  .sm\\:col-start-1{
    grid-column-start: 1 !important;
  }

  .sm\\:col-start-2{
    grid-column-start: 2 !important;
  }

  .sm\\:col-start-3{
    grid-column-start: 3 !important;
  }

  .sm\\:col-start-4{
    grid-column-start: 4 !important;
  }

  .sm\\:col-start-5{
    grid-column-start: 5 !important;
  }

  .sm\\:col-start-6{
    grid-column-start: 6 !important;
  }

  .sm\\:col-start-7{
    grid-column-start: 7 !important;
  }

  .sm\\:col-start-8{
    grid-column-start: 8 !important;
  }

  .sm\\:col-start-9{
    grid-column-start: 9 !important;
  }

  .sm\\:col-start-10{
    grid-column-start: 10 !important;
  }

  .sm\\:col-start-11{
    grid-column-start: 11 !important;
  }

  .sm\\:col-start-12{
    grid-column-start: 12 !important;
  }

  .sm\\:col-start-13{
    grid-column-start: 13 !important;
  }

  .sm\\:col-start-auto{
    grid-column-start: auto !important;
  }

  .sm\\:col-end-1{
    grid-column-end: 1 !important;
  }

  .sm\\:col-end-2{
    grid-column-end: 2 !important;
  }

  .sm\\:col-end-3{
    grid-column-end: 3 !important;
  }

  .sm\\:col-end-4{
    grid-column-end: 4 !important;
  }

  .sm\\:col-end-5{
    grid-column-end: 5 !important;
  }

  .sm\\:col-end-6{
    grid-column-end: 6 !important;
  }

  .sm\\:col-end-7{
    grid-column-end: 7 !important;
  }

  .sm\\:col-end-8{
    grid-column-end: 8 !important;
  }

  .sm\\:col-end-9{
    grid-column-end: 9 !important;
  }

  .sm\\:col-end-10{
    grid-column-end: 10 !important;
  }

  .sm\\:col-end-11{
    grid-column-end: 11 !important;
  }

  .sm\\:col-end-12{
    grid-column-end: 12 !important;
  }

  .sm\\:col-end-13{
    grid-column-end: 13 !important;
  }

  .sm\\:col-end-auto{
    grid-column-end: auto !important;
  }

  .sm\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-rows-2{
    grid-template-rows: repeat(2, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-rows-3{
    grid-template-rows: repeat(3, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-rows-4{
    grid-template-rows: repeat(4, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-rows-5{
    grid-template-rows: repeat(5, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-rows-6{
    grid-template-rows: repeat(6, minmax(0, 1fr)) !important;
  }

  .sm\\:grid-rows-none{
    grid-template-rows: none !important;
  }

  .sm\\:auto-rows-auto{
    grid-auto-rows: auto !important;
  }

  .sm\\:auto-rows-min{
    grid-auto-rows: min-content !important;
  }

  .sm\\:auto-rows-max{
    grid-auto-rows: max-content !important;
  }

  .sm\\:auto-rows-fr{
    grid-auto-rows: minmax(0, 1fr) !important;
  }

  .sm\\:row-auto{
    grid-row: auto !important;
  }

  .sm\\:row-span-1{
    grid-row: span 1 / span 1 !important;
  }

  .sm\\:row-span-2{
    grid-row: span 2 / span 2 !important;
  }

  .sm\\:row-span-3{
    grid-row: span 3 / span 3 !important;
  }

  .sm\\:row-span-4{
    grid-row: span 4 / span 4 !important;
  }

  .sm\\:row-span-5{
    grid-row: span 5 / span 5 !important;
  }

  .sm\\:row-span-6{
    grid-row: span 6 / span 6 !important;
  }

  .sm\\:row-span-full{
    grid-row: 1 / -1 !important;
  }

  .sm\\:row-start-1{
    grid-row-start: 1 !important;
  }

  .sm\\:row-start-2{
    grid-row-start: 2 !important;
  }

  .sm\\:row-start-3{
    grid-row-start: 3 !important;
  }

  .sm\\:row-start-4{
    grid-row-start: 4 !important;
  }

  .sm\\:row-start-5{
    grid-row-start: 5 !important;
  }

  .sm\\:row-start-6{
    grid-row-start: 6 !important;
  }

  .sm\\:row-start-7{
    grid-row-start: 7 !important;
  }

  .sm\\:row-start-auto{
    grid-row-start: auto !important;
  }

  .sm\\:row-end-1{
    grid-row-end: 1 !important;
  }

  .sm\\:row-end-2{
    grid-row-end: 2 !important;
  }

  .sm\\:row-end-3{
    grid-row-end: 3 !important;
  }

  .sm\\:row-end-4{
    grid-row-end: 4 !important;
  }

  .sm\\:row-end-5{
    grid-row-end: 5 !important;
  }

  .sm\\:row-end-6{
    grid-row-end: 6 !important;
  }

  .sm\\:row-end-7{
    grid-row-end: 7 !important;
  }

  .sm\\:row-end-auto{
    grid-row-end: auto !important;
  }

  .sm\\:transform{
    --transform-translate-x: 0 !important;
    --transform-translate-y: 0 !important;
    --transform-rotate: 0 !important;
    --transform-skew-x: 0 !important;
    --transform-skew-y: 0 !important;
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  [dir] .sm\\:transform{
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y)) !important;
  }

  [dir] .sm\\:transform-none{
    transform: none !important;
  }

  [dir] .sm\\:origin-center{
    transform-origin: center !important;
  }

  [dir] .sm\\:origin-top{
    transform-origin: top !important;
  }

  [dir=ltr] .sm\\:origin-top-right{
    transform-origin: top right !important;
  }

  [dir=rtl] .sm\\:origin-top-right{
    transform-origin: top left !important;
  }

  [dir=ltr] .sm\\:origin-right{
    transform-origin: right !important;
  }

  [dir=rtl] .sm\\:origin-right{
    transform-origin: left !important;
  }

  [dir=ltr] .sm\\:origin-bottom-right{
    transform-origin: bottom right !important;
  }

  [dir=rtl] .sm\\:origin-bottom-right{
    transform-origin: bottom left !important;
  }

  [dir] .sm\\:origin-bottom{
    transform-origin: bottom !important;
  }

  [dir=ltr] .sm\\:origin-bottom-left{
    transform-origin: bottom left !important;
  }

  [dir=rtl] .sm\\:origin-bottom-left{
    transform-origin: bottom right !important;
  }

  [dir=ltr] .sm\\:origin-left{
    transform-origin: left !important;
  }

  [dir=rtl] .sm\\:origin-left{
    transform-origin: right !important;
  }

  [dir=ltr] .sm\\:origin-top-left{
    transform-origin: top left !important;
  }

  [dir=rtl] .sm\\:origin-top-left{
    transform-origin: top right !important;
  }

  .sm\\:scale-0{
    --transform-scale-x: 0 !important;
    --transform-scale-y: 0 !important;
  }

  .sm\\:scale-50{
    --transform-scale-x: .5 !important;
    --transform-scale-y: .5 !important;
  }

  .sm\\:scale-75{
    --transform-scale-x: .75 !important;
    --transform-scale-y: .75 !important;
  }

  .sm\\:scale-90{
    --transform-scale-x: .9 !important;
    --transform-scale-y: .9 !important;
  }

  .sm\\:scale-95{
    --transform-scale-x: .95 !important;
    --transform-scale-y: .95 !important;
  }

  .sm\\:scale-100{
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  .sm\\:scale-105{
    --transform-scale-x: 1.05 !important;
    --transform-scale-y: 1.05 !important;
  }

  .sm\\:scale-110{
    --transform-scale-x: 1.1 !important;
    --transform-scale-y: 1.1 !important;
  }

  .sm\\:scale-125{
    --transform-scale-x: 1.25 !important;
    --transform-scale-y: 1.25 !important;
  }

  .sm\\:scale-150{
    --transform-scale-x: 1.5 !important;
    --transform-scale-y: 1.5 !important;
  }

  .sm\\:scale-x-0{
    --transform-scale-x: 0 !important;
  }

  .sm\\:scale-x-50{
    --transform-scale-x: .5 !important;
  }

  .sm\\:scale-x-75{
    --transform-scale-x: .75 !important;
  }

  .sm\\:scale-x-90{
    --transform-scale-x: .9 !important;
  }

  .sm\\:scale-x-95{
    --transform-scale-x: .95 !important;
  }

  .sm\\:scale-x-100{
    --transform-scale-x: 1 !important;
  }

  .sm\\:scale-x-105{
    --transform-scale-x: 1.05 !important;
  }

  .sm\\:scale-x-110{
    --transform-scale-x: 1.1 !important;
  }

  .sm\\:scale-x-125{
    --transform-scale-x: 1.25 !important;
  }

  .sm\\:scale-x-150{
    --transform-scale-x: 1.5 !important;
  }

  .sm\\:scale-y-0{
    --transform-scale-y: 0 !important;
  }

  .sm\\:scale-y-50{
    --transform-scale-y: .5 !important;
  }

  .sm\\:scale-y-75{
    --transform-scale-y: .75 !important;
  }

  .sm\\:scale-y-90{
    --transform-scale-y: .9 !important;
  }

  .sm\\:scale-y-95{
    --transform-scale-y: .95 !important;
  }

  .sm\\:scale-y-100{
    --transform-scale-y: 1 !important;
  }

  .sm\\:scale-y-105{
    --transform-scale-y: 1.05 !important;
  }

  .sm\\:scale-y-110{
    --transform-scale-y: 1.1 !important;
  }

  .sm\\:scale-y-125{
    --transform-scale-y: 1.25 !important;
  }

  .sm\\:scale-y-150{
    --transform-scale-y: 1.5 !important;
  }

  .sm\\:hover\\:scale-0:hover{
    --transform-scale-x: 0 !important;
    --transform-scale-y: 0 !important;
  }

  .sm\\:hover\\:scale-50:hover{
    --transform-scale-x: .5 !important;
    --transform-scale-y: .5 !important;
  }

  .sm\\:hover\\:scale-75:hover{
    --transform-scale-x: .75 !important;
    --transform-scale-y: .75 !important;
  }

  .sm\\:hover\\:scale-90:hover{
    --transform-scale-x: .9 !important;
    --transform-scale-y: .9 !important;
  }

  .sm\\:hover\\:scale-95:hover{
    --transform-scale-x: .95 !important;
    --transform-scale-y: .95 !important;
  }

  .sm\\:hover\\:scale-100:hover{
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  .sm\\:hover\\:scale-105:hover{
    --transform-scale-x: 1.05 !important;
    --transform-scale-y: 1.05 !important;
  }

  .sm\\:hover\\:scale-110:hover{
    --transform-scale-x: 1.1 !important;
    --transform-scale-y: 1.1 !important;
  }

  .sm\\:hover\\:scale-125:hover{
    --transform-scale-x: 1.25 !important;
    --transform-scale-y: 1.25 !important;
  }

  .sm\\:hover\\:scale-150:hover{
    --transform-scale-x: 1.5 !important;
    --transform-scale-y: 1.5 !important;
  }

  .sm\\:hover\\:scale-x-0:hover{
    --transform-scale-x: 0 !important;
  }

  .sm\\:hover\\:scale-x-50:hover{
    --transform-scale-x: .5 !important;
  }

  .sm\\:hover\\:scale-x-75:hover{
    --transform-scale-x: .75 !important;
  }

  .sm\\:hover\\:scale-x-90:hover{
    --transform-scale-x: .9 !important;
  }

  .sm\\:hover\\:scale-x-95:hover{
    --transform-scale-x: .95 !important;
  }

  .sm\\:hover\\:scale-x-100:hover{
    --transform-scale-x: 1 !important;
  }

  .sm\\:hover\\:scale-x-105:hover{
    --transform-scale-x: 1.05 !important;
  }

  .sm\\:hover\\:scale-x-110:hover{
    --transform-scale-x: 1.1 !important;
  }

  .sm\\:hover\\:scale-x-125:hover{
    --transform-scale-x: 1.25 !important;
  }

  .sm\\:hover\\:scale-x-150:hover{
    --transform-scale-x: 1.5 !important;
  }

  .sm\\:hover\\:scale-y-0:hover{
    --transform-scale-y: 0 !important;
  }

  .sm\\:hover\\:scale-y-50:hover{
    --transform-scale-y: .5 !important;
  }

  .sm\\:hover\\:scale-y-75:hover{
    --transform-scale-y: .75 !important;
  }

  .sm\\:hover\\:scale-y-90:hover{
    --transform-scale-y: .9 !important;
  }

  .sm\\:hover\\:scale-y-95:hover{
    --transform-scale-y: .95 !important;
  }

  .sm\\:hover\\:scale-y-100:hover{
    --transform-scale-y: 1 !important;
  }

  .sm\\:hover\\:scale-y-105:hover{
    --transform-scale-y: 1.05 !important;
  }

  .sm\\:hover\\:scale-y-110:hover{
    --transform-scale-y: 1.1 !important;
  }

  .sm\\:hover\\:scale-y-125:hover{
    --transform-scale-y: 1.25 !important;
  }

  .sm\\:hover\\:scale-y-150:hover{
    --transform-scale-y: 1.5 !important;
  }

  .sm\\:focus\\:scale-0:focus{
    --transform-scale-x: 0 !important;
    --transform-scale-y: 0 !important;
  }

  .sm\\:focus\\:scale-50:focus{
    --transform-scale-x: .5 !important;
    --transform-scale-y: .5 !important;
  }

  .sm\\:focus\\:scale-75:focus{
    --transform-scale-x: .75 !important;
    --transform-scale-y: .75 !important;
  }

  .sm\\:focus\\:scale-90:focus{
    --transform-scale-x: .9 !important;
    --transform-scale-y: .9 !important;
  }

  .sm\\:focus\\:scale-95:focus{
    --transform-scale-x: .95 !important;
    --transform-scale-y: .95 !important;
  }

  .sm\\:focus\\:scale-100:focus{
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  .sm\\:focus\\:scale-105:focus{
    --transform-scale-x: 1.05 !important;
    --transform-scale-y: 1.05 !important;
  }

  .sm\\:focus\\:scale-110:focus{
    --transform-scale-x: 1.1 !important;
    --transform-scale-y: 1.1 !important;
  }

  .sm\\:focus\\:scale-125:focus{
    --transform-scale-x: 1.25 !important;
    --transform-scale-y: 1.25 !important;
  }

  .sm\\:focus\\:scale-150:focus{
    --transform-scale-x: 1.5 !important;
    --transform-scale-y: 1.5 !important;
  }

  .sm\\:focus\\:scale-x-0:focus{
    --transform-scale-x: 0 !important;
  }

  .sm\\:focus\\:scale-x-50:focus{
    --transform-scale-x: .5 !important;
  }

  .sm\\:focus\\:scale-x-75:focus{
    --transform-scale-x: .75 !important;
  }

  .sm\\:focus\\:scale-x-90:focus{
    --transform-scale-x: .9 !important;
  }

  .sm\\:focus\\:scale-x-95:focus{
    --transform-scale-x: .95 !important;
  }

  .sm\\:focus\\:scale-x-100:focus{
    --transform-scale-x: 1 !important;
  }

  .sm\\:focus\\:scale-x-105:focus{
    --transform-scale-x: 1.05 !important;
  }

  .sm\\:focus\\:scale-x-110:focus{
    --transform-scale-x: 1.1 !important;
  }

  .sm\\:focus\\:scale-x-125:focus{
    --transform-scale-x: 1.25 !important;
  }

  .sm\\:focus\\:scale-x-150:focus{
    --transform-scale-x: 1.5 !important;
  }

  .sm\\:focus\\:scale-y-0:focus{
    --transform-scale-y: 0 !important;
  }

  .sm\\:focus\\:scale-y-50:focus{
    --transform-scale-y: .5 !important;
  }

  .sm\\:focus\\:scale-y-75:focus{
    --transform-scale-y: .75 !important;
  }

  .sm\\:focus\\:scale-y-90:focus{
    --transform-scale-y: .9 !important;
  }

  .sm\\:focus\\:scale-y-95:focus{
    --transform-scale-y: .95 !important;
  }

  .sm\\:focus\\:scale-y-100:focus{
    --transform-scale-y: 1 !important;
  }

  .sm\\:focus\\:scale-y-105:focus{
    --transform-scale-y: 1.05 !important;
  }

  .sm\\:focus\\:scale-y-110:focus{
    --transform-scale-y: 1.1 !important;
  }

  .sm\\:focus\\:scale-y-125:focus{
    --transform-scale-y: 1.25 !important;
  }

  .sm\\:focus\\:scale-y-150:focus{
    --transform-scale-y: 1.5 !important;
  }

  .sm\\:rotate-0{
    --transform-rotate: 0 !important;
  }

  .sm\\:rotate-1{
    --transform-rotate: 1deg !important;
  }

  .sm\\:rotate-2{
    --transform-rotate: 2deg !important;
  }

  .sm\\:rotate-3{
    --transform-rotate: 3deg !important;
  }

  .sm\\:rotate-6{
    --transform-rotate: 6deg !important;
  }

  .sm\\:rotate-12{
    --transform-rotate: 12deg !important;
  }

  .sm\\:rotate-45{
    --transform-rotate: 45deg !important;
  }

  .sm\\:rotate-90{
    --transform-rotate: 90deg !important;
  }

  .sm\\:rotate-180{
    --transform-rotate: 180deg !important;
  }

  .sm\\:-rotate-180{
    --transform-rotate: -180deg !important;
  }

  .sm\\:-rotate-90{
    --transform-rotate: -90deg !important;
  }

  .sm\\:-rotate-45{
    --transform-rotate: -45deg !important;
  }

  .sm\\:-rotate-12{
    --transform-rotate: -12deg !important;
  }

  .sm\\:-rotate-6{
    --transform-rotate: -6deg !important;
  }

  .sm\\:-rotate-3{
    --transform-rotate: -3deg !important;
  }

  .sm\\:-rotate-2{
    --transform-rotate: -2deg !important;
  }

  .sm\\:-rotate-1{
    --transform-rotate: -1deg !important;
  }

  .sm\\:hover\\:rotate-0:hover{
    --transform-rotate: 0 !important;
  }

  .sm\\:hover\\:rotate-1:hover{
    --transform-rotate: 1deg !important;
  }

  .sm\\:hover\\:rotate-2:hover{
    --transform-rotate: 2deg !important;
  }

  .sm\\:hover\\:rotate-3:hover{
    --transform-rotate: 3deg !important;
  }

  .sm\\:hover\\:rotate-6:hover{
    --transform-rotate: 6deg !important;
  }

  .sm\\:hover\\:rotate-12:hover{
    --transform-rotate: 12deg !important;
  }

  .sm\\:hover\\:rotate-45:hover{
    --transform-rotate: 45deg !important;
  }

  .sm\\:hover\\:rotate-90:hover{
    --transform-rotate: 90deg !important;
  }

  .sm\\:hover\\:rotate-180:hover{
    --transform-rotate: 180deg !important;
  }

  .sm\\:hover\\:-rotate-180:hover{
    --transform-rotate: -180deg !important;
  }

  .sm\\:hover\\:-rotate-90:hover{
    --transform-rotate: -90deg !important;
  }

  .sm\\:hover\\:-rotate-45:hover{
    --transform-rotate: -45deg !important;
  }

  .sm\\:hover\\:-rotate-12:hover{
    --transform-rotate: -12deg !important;
  }

  .sm\\:hover\\:-rotate-6:hover{
    --transform-rotate: -6deg !important;
  }

  .sm\\:hover\\:-rotate-3:hover{
    --transform-rotate: -3deg !important;
  }

  .sm\\:hover\\:-rotate-2:hover{
    --transform-rotate: -2deg !important;
  }

  .sm\\:hover\\:-rotate-1:hover{
    --transform-rotate: -1deg !important;
  }

  .sm\\:focus\\:rotate-0:focus{
    --transform-rotate: 0 !important;
  }

  .sm\\:focus\\:rotate-1:focus{
    --transform-rotate: 1deg !important;
  }

  .sm\\:focus\\:rotate-2:focus{
    --transform-rotate: 2deg !important;
  }

  .sm\\:focus\\:rotate-3:focus{
    --transform-rotate: 3deg !important;
  }

  .sm\\:focus\\:rotate-6:focus{
    --transform-rotate: 6deg !important;
  }

  .sm\\:focus\\:rotate-12:focus{
    --transform-rotate: 12deg !important;
  }

  .sm\\:focus\\:rotate-45:focus{
    --transform-rotate: 45deg !important;
  }

  .sm\\:focus\\:rotate-90:focus{
    --transform-rotate: 90deg !important;
  }

  .sm\\:focus\\:rotate-180:focus{
    --transform-rotate: 180deg !important;
  }

  .sm\\:focus\\:-rotate-180:focus{
    --transform-rotate: -180deg !important;
  }

  .sm\\:focus\\:-rotate-90:focus{
    --transform-rotate: -90deg !important;
  }

  .sm\\:focus\\:-rotate-45:focus{
    --transform-rotate: -45deg !important;
  }

  .sm\\:focus\\:-rotate-12:focus{
    --transform-rotate: -12deg !important;
  }

  .sm\\:focus\\:-rotate-6:focus{
    --transform-rotate: -6deg !important;
  }

  .sm\\:focus\\:-rotate-3:focus{
    --transform-rotate: -3deg !important;
  }

  .sm\\:focus\\:-rotate-2:focus{
    --transform-rotate: -2deg !important;
  }

  .sm\\:focus\\:-rotate-1:focus{
    --transform-rotate: -1deg !important;
  }

  .sm\\:translate-x-0{
    --transform-translate-x: 0 !important;
  }

  .sm\\:translate-x-1{
    --transform-translate-x: 0.25rem !important;
  }

  .sm\\:translate-x-2{
    --transform-translate-x: 0.5rem !important;
  }

  .sm\\:translate-x-3{
    --transform-translate-x: 0.75rem !important;
  }

  .sm\\:translate-x-4{
    --transform-translate-x: 1rem !important;
  }

  .sm\\:translate-x-5{
    --transform-translate-x: 1.25rem !important;
  }

  .sm\\:translate-x-6{
    --transform-translate-x: 1.5rem !important;
  }

  .sm\\:translate-x-8{
    --transform-translate-x: 2rem !important;
  }

  .sm\\:translate-x-10{
    --transform-translate-x: 2.5rem !important;
  }

  .sm\\:translate-x-12{
    --transform-translate-x: 3rem !important;
  }

  .sm\\:translate-x-16{
    --transform-translate-x: 4rem !important;
  }

  .sm\\:translate-x-20{
    --transform-translate-x: 5rem !important;
  }

  .sm\\:translate-x-24{
    --transform-translate-x: 6rem !important;
  }

  .sm\\:translate-x-32{
    --transform-translate-x: 8rem !important;
  }

  .sm\\:translate-x-40{
    --transform-translate-x: 10rem !important;
  }

  .sm\\:translate-x-48{
    --transform-translate-x: 12rem !important;
  }

  .sm\\:translate-x-56{
    --transform-translate-x: 14rem !important;
  }

  .sm\\:translate-x-64{
    --transform-translate-x: 16rem !important;
  }

  .sm\\:translate-x-px{
    --transform-translate-x: 1px !important;
  }

  .sm\\:-translate-x-1{
    --transform-translate-x: -0.25rem !important;
  }

  .sm\\:-translate-x-2{
    --transform-translate-x: -0.5rem !important;
  }

  .sm\\:-translate-x-3{
    --transform-translate-x: -0.75rem !important;
  }

  .sm\\:-translate-x-4{
    --transform-translate-x: -1rem !important;
  }

  .sm\\:-translate-x-5{
    --transform-translate-x: -1.25rem !important;
  }

  .sm\\:-translate-x-6{
    --transform-translate-x: -1.5rem !important;
  }

  .sm\\:-translate-x-8{
    --transform-translate-x: -2rem !important;
  }

  .sm\\:-translate-x-10{
    --transform-translate-x: -2.5rem !important;
  }

  .sm\\:-translate-x-12{
    --transform-translate-x: -3rem !important;
  }

  .sm\\:-translate-x-16{
    --transform-translate-x: -4rem !important;
  }

  .sm\\:-translate-x-20{
    --transform-translate-x: -5rem !important;
  }

  .sm\\:-translate-x-24{
    --transform-translate-x: -6rem !important;
  }

  .sm\\:-translate-x-32{
    --transform-translate-x: -8rem !important;
  }

  .sm\\:-translate-x-40{
    --transform-translate-x: -10rem !important;
  }

  .sm\\:-translate-x-48{
    --transform-translate-x: -12rem !important;
  }

  .sm\\:-translate-x-56{
    --transform-translate-x: -14rem !important;
  }

  .sm\\:-translate-x-64{
    --transform-translate-x: -16rem !important;
  }

  .sm\\:-translate-x-px{
    --transform-translate-x: -1px !important;
  }

  .sm\\:-translate-x-full{
    --transform-translate-x: -100% !important;
  }

  .sm\\:-translate-x-1\\/2{
    --transform-translate-x: -50% !important;
  }

  .sm\\:translate-x-1\\/2{
    --transform-translate-x: 50% !important;
  }

  .sm\\:translate-x-full{
    --transform-translate-x: 100% !important;
  }

  .sm\\:translate-y-0{
    --transform-translate-y: 0 !important;
  }

  .sm\\:translate-y-1{
    --transform-translate-y: 0.25rem !important;
  }

  .sm\\:translate-y-2{
    --transform-translate-y: 0.5rem !important;
  }

  .sm\\:translate-y-3{
    --transform-translate-y: 0.75rem !important;
  }

  .sm\\:translate-y-4{
    --transform-translate-y: 1rem !important;
  }

  .sm\\:translate-y-5{
    --transform-translate-y: 1.25rem !important;
  }

  .sm\\:translate-y-6{
    --transform-translate-y: 1.5rem !important;
  }

  .sm\\:translate-y-8{
    --transform-translate-y: 2rem !important;
  }

  .sm\\:translate-y-10{
    --transform-translate-y: 2.5rem !important;
  }

  .sm\\:translate-y-12{
    --transform-translate-y: 3rem !important;
  }

  .sm\\:translate-y-16{
    --transform-translate-y: 4rem !important;
  }

  .sm\\:translate-y-20{
    --transform-translate-y: 5rem !important;
  }

  .sm\\:translate-y-24{
    --transform-translate-y: 6rem !important;
  }

  .sm\\:translate-y-32{
    --transform-translate-y: 8rem !important;
  }

  .sm\\:translate-y-40{
    --transform-translate-y: 10rem !important;
  }

  .sm\\:translate-y-48{
    --transform-translate-y: 12rem !important;
  }

  .sm\\:translate-y-56{
    --transform-translate-y: 14rem !important;
  }

  .sm\\:translate-y-64{
    --transform-translate-y: 16rem !important;
  }

  .sm\\:translate-y-px{
    --transform-translate-y: 1px !important;
  }

  .sm\\:-translate-y-1{
    --transform-translate-y: -0.25rem !important;
  }

  .sm\\:-translate-y-2{
    --transform-translate-y: -0.5rem !important;
  }

  .sm\\:-translate-y-3{
    --transform-translate-y: -0.75rem !important;
  }

  .sm\\:-translate-y-4{
    --transform-translate-y: -1rem !important;
  }

  .sm\\:-translate-y-5{
    --transform-translate-y: -1.25rem !important;
  }

  .sm\\:-translate-y-6{
    --transform-translate-y: -1.5rem !important;
  }

  .sm\\:-translate-y-8{
    --transform-translate-y: -2rem !important;
  }

  .sm\\:-translate-y-10{
    --transform-translate-y: -2.5rem !important;
  }

  .sm\\:-translate-y-12{
    --transform-translate-y: -3rem !important;
  }

  .sm\\:-translate-y-16{
    --transform-translate-y: -4rem !important;
  }

  .sm\\:-translate-y-20{
    --transform-translate-y: -5rem !important;
  }

  .sm\\:-translate-y-24{
    --transform-translate-y: -6rem !important;
  }

  .sm\\:-translate-y-32{
    --transform-translate-y: -8rem !important;
  }

  .sm\\:-translate-y-40{
    --transform-translate-y: -10rem !important;
  }

  .sm\\:-translate-y-48{
    --transform-translate-y: -12rem !important;
  }

  .sm\\:-translate-y-56{
    --transform-translate-y: -14rem !important;
  }

  .sm\\:-translate-y-64{
    --transform-translate-y: -16rem !important;
  }

  .sm\\:-translate-y-px{
    --transform-translate-y: -1px !important;
  }

  .sm\\:-translate-y-full{
    --transform-translate-y: -100% !important;
  }

  .sm\\:-translate-y-1\\/2{
    --transform-translate-y: -50% !important;
  }

  .sm\\:translate-y-1\\/2{
    --transform-translate-y: 50% !important;
  }

  .sm\\:translate-y-full{
    --transform-translate-y: 100% !important;
  }

  .sm\\:hover\\:translate-x-0:hover{
    --transform-translate-x: 0 !important;
  }

  .sm\\:hover\\:translate-x-1:hover{
    --transform-translate-x: 0.25rem !important;
  }

  .sm\\:hover\\:translate-x-2:hover{
    --transform-translate-x: 0.5rem !important;
  }

  .sm\\:hover\\:translate-x-3:hover{
    --transform-translate-x: 0.75rem !important;
  }

  .sm\\:hover\\:translate-x-4:hover{
    --transform-translate-x: 1rem !important;
  }

  .sm\\:hover\\:translate-x-5:hover{
    --transform-translate-x: 1.25rem !important;
  }

  .sm\\:hover\\:translate-x-6:hover{
    --transform-translate-x: 1.5rem !important;
  }

  .sm\\:hover\\:translate-x-8:hover{
    --transform-translate-x: 2rem !important;
  }

  .sm\\:hover\\:translate-x-10:hover{
    --transform-translate-x: 2.5rem !important;
  }

  .sm\\:hover\\:translate-x-12:hover{
    --transform-translate-x: 3rem !important;
  }

  .sm\\:hover\\:translate-x-16:hover{
    --transform-translate-x: 4rem !important;
  }

  .sm\\:hover\\:translate-x-20:hover{
    --transform-translate-x: 5rem !important;
  }

  .sm\\:hover\\:translate-x-24:hover{
    --transform-translate-x: 6rem !important;
  }

  .sm\\:hover\\:translate-x-32:hover{
    --transform-translate-x: 8rem !important;
  }

  .sm\\:hover\\:translate-x-40:hover{
    --transform-translate-x: 10rem !important;
  }

  .sm\\:hover\\:translate-x-48:hover{
    --transform-translate-x: 12rem !important;
  }

  .sm\\:hover\\:translate-x-56:hover{
    --transform-translate-x: 14rem !important;
  }

  .sm\\:hover\\:translate-x-64:hover{
    --transform-translate-x: 16rem !important;
  }

  .sm\\:hover\\:translate-x-px:hover{
    --transform-translate-x: 1px !important;
  }

  .sm\\:hover\\:-translate-x-1:hover{
    --transform-translate-x: -0.25rem !important;
  }

  .sm\\:hover\\:-translate-x-2:hover{
    --transform-translate-x: -0.5rem !important;
  }

  .sm\\:hover\\:-translate-x-3:hover{
    --transform-translate-x: -0.75rem !important;
  }

  .sm\\:hover\\:-translate-x-4:hover{
    --transform-translate-x: -1rem !important;
  }

  .sm\\:hover\\:-translate-x-5:hover{
    --transform-translate-x: -1.25rem !important;
  }

  .sm\\:hover\\:-translate-x-6:hover{
    --transform-translate-x: -1.5rem !important;
  }

  .sm\\:hover\\:-translate-x-8:hover{
    --transform-translate-x: -2rem !important;
  }

  .sm\\:hover\\:-translate-x-10:hover{
    --transform-translate-x: -2.5rem !important;
  }

  .sm\\:hover\\:-translate-x-12:hover{
    --transform-translate-x: -3rem !important;
  }

  .sm\\:hover\\:-translate-x-16:hover{
    --transform-translate-x: -4rem !important;
  }

  .sm\\:hover\\:-translate-x-20:hover{
    --transform-translate-x: -5rem !important;
  }

  .sm\\:hover\\:-translate-x-24:hover{
    --transform-translate-x: -6rem !important;
  }

  .sm\\:hover\\:-translate-x-32:hover{
    --transform-translate-x: -8rem !important;
  }

  .sm\\:hover\\:-translate-x-40:hover{
    --transform-translate-x: -10rem !important;
  }

  .sm\\:hover\\:-translate-x-48:hover{
    --transform-translate-x: -12rem !important;
  }

  .sm\\:hover\\:-translate-x-56:hover{
    --transform-translate-x: -14rem !important;
  }

  .sm\\:hover\\:-translate-x-64:hover{
    --transform-translate-x: -16rem !important;
  }

  .sm\\:hover\\:-translate-x-px:hover{
    --transform-translate-x: -1px !important;
  }

  .sm\\:hover\\:-translate-x-full:hover{
    --transform-translate-x: -100% !important;
  }

  .sm\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x: -50% !important;
  }

  .sm\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x: 50% !important;
  }

  .sm\\:hover\\:translate-x-full:hover{
    --transform-translate-x: 100% !important;
  }

  .sm\\:hover\\:translate-y-0:hover{
    --transform-translate-y: 0 !important;
  }

  .sm\\:hover\\:translate-y-1:hover{
    --transform-translate-y: 0.25rem !important;
  }

  .sm\\:hover\\:translate-y-2:hover{
    --transform-translate-y: 0.5rem !important;
  }

  .sm\\:hover\\:translate-y-3:hover{
    --transform-translate-y: 0.75rem !important;
  }

  .sm\\:hover\\:translate-y-4:hover{
    --transform-translate-y: 1rem !important;
  }

  .sm\\:hover\\:translate-y-5:hover{
    --transform-translate-y: 1.25rem !important;
  }

  .sm\\:hover\\:translate-y-6:hover{
    --transform-translate-y: 1.5rem !important;
  }

  .sm\\:hover\\:translate-y-8:hover{
    --transform-translate-y: 2rem !important;
  }

  .sm\\:hover\\:translate-y-10:hover{
    --transform-translate-y: 2.5rem !important;
  }

  .sm\\:hover\\:translate-y-12:hover{
    --transform-translate-y: 3rem !important;
  }

  .sm\\:hover\\:translate-y-16:hover{
    --transform-translate-y: 4rem !important;
  }

  .sm\\:hover\\:translate-y-20:hover{
    --transform-translate-y: 5rem !important;
  }

  .sm\\:hover\\:translate-y-24:hover{
    --transform-translate-y: 6rem !important;
  }

  .sm\\:hover\\:translate-y-32:hover{
    --transform-translate-y: 8rem !important;
  }

  .sm\\:hover\\:translate-y-40:hover{
    --transform-translate-y: 10rem !important;
  }

  .sm\\:hover\\:translate-y-48:hover{
    --transform-translate-y: 12rem !important;
  }

  .sm\\:hover\\:translate-y-56:hover{
    --transform-translate-y: 14rem !important;
  }

  .sm\\:hover\\:translate-y-64:hover{
    --transform-translate-y: 16rem !important;
  }

  .sm\\:hover\\:translate-y-px:hover{
    --transform-translate-y: 1px !important;
  }

  .sm\\:hover\\:-translate-y-1:hover{
    --transform-translate-y: -0.25rem !important;
  }

  .sm\\:hover\\:-translate-y-2:hover{
    --transform-translate-y: -0.5rem !important;
  }

  .sm\\:hover\\:-translate-y-3:hover{
    --transform-translate-y: -0.75rem !important;
  }

  .sm\\:hover\\:-translate-y-4:hover{
    --transform-translate-y: -1rem !important;
  }

  .sm\\:hover\\:-translate-y-5:hover{
    --transform-translate-y: -1.25rem !important;
  }

  .sm\\:hover\\:-translate-y-6:hover{
    --transform-translate-y: -1.5rem !important;
  }

  .sm\\:hover\\:-translate-y-8:hover{
    --transform-translate-y: -2rem !important;
  }

  .sm\\:hover\\:-translate-y-10:hover{
    --transform-translate-y: -2.5rem !important;
  }

  .sm\\:hover\\:-translate-y-12:hover{
    --transform-translate-y: -3rem !important;
  }

  .sm\\:hover\\:-translate-y-16:hover{
    --transform-translate-y: -4rem !important;
  }

  .sm\\:hover\\:-translate-y-20:hover{
    --transform-translate-y: -5rem !important;
  }

  .sm\\:hover\\:-translate-y-24:hover{
    --transform-translate-y: -6rem !important;
  }

  .sm\\:hover\\:-translate-y-32:hover{
    --transform-translate-y: -8rem !important;
  }

  .sm\\:hover\\:-translate-y-40:hover{
    --transform-translate-y: -10rem !important;
  }

  .sm\\:hover\\:-translate-y-48:hover{
    --transform-translate-y: -12rem !important;
  }

  .sm\\:hover\\:-translate-y-56:hover{
    --transform-translate-y: -14rem !important;
  }

  .sm\\:hover\\:-translate-y-64:hover{
    --transform-translate-y: -16rem !important;
  }

  .sm\\:hover\\:-translate-y-px:hover{
    --transform-translate-y: -1px !important;
  }

  .sm\\:hover\\:-translate-y-full:hover{
    --transform-translate-y: -100% !important;
  }

  .sm\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y: -50% !important;
  }

  .sm\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y: 50% !important;
  }

  .sm\\:hover\\:translate-y-full:hover{
    --transform-translate-y: 100% !important;
  }

  .sm\\:focus\\:translate-x-0:focus{
    --transform-translate-x: 0 !important;
  }

  .sm\\:focus\\:translate-x-1:focus{
    --transform-translate-x: 0.25rem !important;
  }

  .sm\\:focus\\:translate-x-2:focus{
    --transform-translate-x: 0.5rem !important;
  }

  .sm\\:focus\\:translate-x-3:focus{
    --transform-translate-x: 0.75rem !important;
  }

  .sm\\:focus\\:translate-x-4:focus{
    --transform-translate-x: 1rem !important;
  }

  .sm\\:focus\\:translate-x-5:focus{
    --transform-translate-x: 1.25rem !important;
  }

  .sm\\:focus\\:translate-x-6:focus{
    --transform-translate-x: 1.5rem !important;
  }

  .sm\\:focus\\:translate-x-8:focus{
    --transform-translate-x: 2rem !important;
  }

  .sm\\:focus\\:translate-x-10:focus{
    --transform-translate-x: 2.5rem !important;
  }

  .sm\\:focus\\:translate-x-12:focus{
    --transform-translate-x: 3rem !important;
  }

  .sm\\:focus\\:translate-x-16:focus{
    --transform-translate-x: 4rem !important;
  }

  .sm\\:focus\\:translate-x-20:focus{
    --transform-translate-x: 5rem !important;
  }

  .sm\\:focus\\:translate-x-24:focus{
    --transform-translate-x: 6rem !important;
  }

  .sm\\:focus\\:translate-x-32:focus{
    --transform-translate-x: 8rem !important;
  }

  .sm\\:focus\\:translate-x-40:focus{
    --transform-translate-x: 10rem !important;
  }

  .sm\\:focus\\:translate-x-48:focus{
    --transform-translate-x: 12rem !important;
  }

  .sm\\:focus\\:translate-x-56:focus{
    --transform-translate-x: 14rem !important;
  }

  .sm\\:focus\\:translate-x-64:focus{
    --transform-translate-x: 16rem !important;
  }

  .sm\\:focus\\:translate-x-px:focus{
    --transform-translate-x: 1px !important;
  }

  .sm\\:focus\\:-translate-x-1:focus{
    --transform-translate-x: -0.25rem !important;
  }

  .sm\\:focus\\:-translate-x-2:focus{
    --transform-translate-x: -0.5rem !important;
  }

  .sm\\:focus\\:-translate-x-3:focus{
    --transform-translate-x: -0.75rem !important;
  }

  .sm\\:focus\\:-translate-x-4:focus{
    --transform-translate-x: -1rem !important;
  }

  .sm\\:focus\\:-translate-x-5:focus{
    --transform-translate-x: -1.25rem !important;
  }

  .sm\\:focus\\:-translate-x-6:focus{
    --transform-translate-x: -1.5rem !important;
  }

  .sm\\:focus\\:-translate-x-8:focus{
    --transform-translate-x: -2rem !important;
  }

  .sm\\:focus\\:-translate-x-10:focus{
    --transform-translate-x: -2.5rem !important;
  }

  .sm\\:focus\\:-translate-x-12:focus{
    --transform-translate-x: -3rem !important;
  }

  .sm\\:focus\\:-translate-x-16:focus{
    --transform-translate-x: -4rem !important;
  }

  .sm\\:focus\\:-translate-x-20:focus{
    --transform-translate-x: -5rem !important;
  }

  .sm\\:focus\\:-translate-x-24:focus{
    --transform-translate-x: -6rem !important;
  }

  .sm\\:focus\\:-translate-x-32:focus{
    --transform-translate-x: -8rem !important;
  }

  .sm\\:focus\\:-translate-x-40:focus{
    --transform-translate-x: -10rem !important;
  }

  .sm\\:focus\\:-translate-x-48:focus{
    --transform-translate-x: -12rem !important;
  }

  .sm\\:focus\\:-translate-x-56:focus{
    --transform-translate-x: -14rem !important;
  }

  .sm\\:focus\\:-translate-x-64:focus{
    --transform-translate-x: -16rem !important;
  }

  .sm\\:focus\\:-translate-x-px:focus{
    --transform-translate-x: -1px !important;
  }

  .sm\\:focus\\:-translate-x-full:focus{
    --transform-translate-x: -100% !important;
  }

  .sm\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x: -50% !important;
  }

  .sm\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x: 50% !important;
  }

  .sm\\:focus\\:translate-x-full:focus{
    --transform-translate-x: 100% !important;
  }

  .sm\\:focus\\:translate-y-0:focus{
    --transform-translate-y: 0 !important;
  }

  .sm\\:focus\\:translate-y-1:focus{
    --transform-translate-y: 0.25rem !important;
  }

  .sm\\:focus\\:translate-y-2:focus{
    --transform-translate-y: 0.5rem !important;
  }

  .sm\\:focus\\:translate-y-3:focus{
    --transform-translate-y: 0.75rem !important;
  }

  .sm\\:focus\\:translate-y-4:focus{
    --transform-translate-y: 1rem !important;
  }

  .sm\\:focus\\:translate-y-5:focus{
    --transform-translate-y: 1.25rem !important;
  }

  .sm\\:focus\\:translate-y-6:focus{
    --transform-translate-y: 1.5rem !important;
  }

  .sm\\:focus\\:translate-y-8:focus{
    --transform-translate-y: 2rem !important;
  }

  .sm\\:focus\\:translate-y-10:focus{
    --transform-translate-y: 2.5rem !important;
  }

  .sm\\:focus\\:translate-y-12:focus{
    --transform-translate-y: 3rem !important;
  }

  .sm\\:focus\\:translate-y-16:focus{
    --transform-translate-y: 4rem !important;
  }

  .sm\\:focus\\:translate-y-20:focus{
    --transform-translate-y: 5rem !important;
  }

  .sm\\:focus\\:translate-y-24:focus{
    --transform-translate-y: 6rem !important;
  }

  .sm\\:focus\\:translate-y-32:focus{
    --transform-translate-y: 8rem !important;
  }

  .sm\\:focus\\:translate-y-40:focus{
    --transform-translate-y: 10rem !important;
  }

  .sm\\:focus\\:translate-y-48:focus{
    --transform-translate-y: 12rem !important;
  }

  .sm\\:focus\\:translate-y-56:focus{
    --transform-translate-y: 14rem !important;
  }

  .sm\\:focus\\:translate-y-64:focus{
    --transform-translate-y: 16rem !important;
  }

  .sm\\:focus\\:translate-y-px:focus{
    --transform-translate-y: 1px !important;
  }

  .sm\\:focus\\:-translate-y-1:focus{
    --transform-translate-y: -0.25rem !important;
  }

  .sm\\:focus\\:-translate-y-2:focus{
    --transform-translate-y: -0.5rem !important;
  }

  .sm\\:focus\\:-translate-y-3:focus{
    --transform-translate-y: -0.75rem !important;
  }

  .sm\\:focus\\:-translate-y-4:focus{
    --transform-translate-y: -1rem !important;
  }

  .sm\\:focus\\:-translate-y-5:focus{
    --transform-translate-y: -1.25rem !important;
  }

  .sm\\:focus\\:-translate-y-6:focus{
    --transform-translate-y: -1.5rem !important;
  }

  .sm\\:focus\\:-translate-y-8:focus{
    --transform-translate-y: -2rem !important;
  }

  .sm\\:focus\\:-translate-y-10:focus{
    --transform-translate-y: -2.5rem !important;
  }

  .sm\\:focus\\:-translate-y-12:focus{
    --transform-translate-y: -3rem !important;
  }

  .sm\\:focus\\:-translate-y-16:focus{
    --transform-translate-y: -4rem !important;
  }

  .sm\\:focus\\:-translate-y-20:focus{
    --transform-translate-y: -5rem !important;
  }

  .sm\\:focus\\:-translate-y-24:focus{
    --transform-translate-y: -6rem !important;
  }

  .sm\\:focus\\:-translate-y-32:focus{
    --transform-translate-y: -8rem !important;
  }

  .sm\\:focus\\:-translate-y-40:focus{
    --transform-translate-y: -10rem !important;
  }

  .sm\\:focus\\:-translate-y-48:focus{
    --transform-translate-y: -12rem !important;
  }

  .sm\\:focus\\:-translate-y-56:focus{
    --transform-translate-y: -14rem !important;
  }

  .sm\\:focus\\:-translate-y-64:focus{
    --transform-translate-y: -16rem !important;
  }

  .sm\\:focus\\:-translate-y-px:focus{
    --transform-translate-y: -1px !important;
  }

  .sm\\:focus\\:-translate-y-full:focus{
    --transform-translate-y: -100% !important;
  }

  .sm\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y: -50% !important;
  }

  .sm\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y: 50% !important;
  }

  .sm\\:focus\\:translate-y-full:focus{
    --transform-translate-y: 100% !important;
  }

  .sm\\:skew-x-0{
    --transform-skew-x: 0 !important;
  }

  .sm\\:skew-x-1{
    --transform-skew-x: 1deg !important;
  }

  .sm\\:skew-x-2{
    --transform-skew-x: 2deg !important;
  }

  .sm\\:skew-x-3{
    --transform-skew-x: 3deg !important;
  }

  .sm\\:skew-x-6{
    --transform-skew-x: 6deg !important;
  }

  .sm\\:skew-x-12{
    --transform-skew-x: 12deg !important;
  }

  .sm\\:-skew-x-12{
    --transform-skew-x: -12deg !important;
  }

  .sm\\:-skew-x-6{
    --transform-skew-x: -6deg !important;
  }

  .sm\\:-skew-x-3{
    --transform-skew-x: -3deg !important;
  }

  .sm\\:-skew-x-2{
    --transform-skew-x: -2deg !important;
  }

  .sm\\:-skew-x-1{
    --transform-skew-x: -1deg !important;
  }

  .sm\\:skew-y-0{
    --transform-skew-y: 0 !important;
  }

  .sm\\:skew-y-1{
    --transform-skew-y: 1deg !important;
  }

  .sm\\:skew-y-2{
    --transform-skew-y: 2deg !important;
  }

  .sm\\:skew-y-3{
    --transform-skew-y: 3deg !important;
  }

  .sm\\:skew-y-6{
    --transform-skew-y: 6deg !important;
  }

  .sm\\:skew-y-12{
    --transform-skew-y: 12deg !important;
  }

  .sm\\:-skew-y-12{
    --transform-skew-y: -12deg !important;
  }

  .sm\\:-skew-y-6{
    --transform-skew-y: -6deg !important;
  }

  .sm\\:-skew-y-3{
    --transform-skew-y: -3deg !important;
  }

  .sm\\:-skew-y-2{
    --transform-skew-y: -2deg !important;
  }

  .sm\\:-skew-y-1{
    --transform-skew-y: -1deg !important;
  }

  .sm\\:hover\\:skew-x-0:hover{
    --transform-skew-x: 0 !important;
  }

  .sm\\:hover\\:skew-x-1:hover{
    --transform-skew-x: 1deg !important;
  }

  .sm\\:hover\\:skew-x-2:hover{
    --transform-skew-x: 2deg !important;
  }

  .sm\\:hover\\:skew-x-3:hover{
    --transform-skew-x: 3deg !important;
  }

  .sm\\:hover\\:skew-x-6:hover{
    --transform-skew-x: 6deg !important;
  }

  .sm\\:hover\\:skew-x-12:hover{
    --transform-skew-x: 12deg !important;
  }

  .sm\\:hover\\:-skew-x-12:hover{
    --transform-skew-x: -12deg !important;
  }

  .sm\\:hover\\:-skew-x-6:hover{
    --transform-skew-x: -6deg !important;
  }

  .sm\\:hover\\:-skew-x-3:hover{
    --transform-skew-x: -3deg !important;
  }

  .sm\\:hover\\:-skew-x-2:hover{
    --transform-skew-x: -2deg !important;
  }

  .sm\\:hover\\:-skew-x-1:hover{
    --transform-skew-x: -1deg !important;
  }

  .sm\\:hover\\:skew-y-0:hover{
    --transform-skew-y: 0 !important;
  }

  .sm\\:hover\\:skew-y-1:hover{
    --transform-skew-y: 1deg !important;
  }

  .sm\\:hover\\:skew-y-2:hover{
    --transform-skew-y: 2deg !important;
  }

  .sm\\:hover\\:skew-y-3:hover{
    --transform-skew-y: 3deg !important;
  }

  .sm\\:hover\\:skew-y-6:hover{
    --transform-skew-y: 6deg !important;
  }

  .sm\\:hover\\:skew-y-12:hover{
    --transform-skew-y: 12deg !important;
  }

  .sm\\:hover\\:-skew-y-12:hover{
    --transform-skew-y: -12deg !important;
  }

  .sm\\:hover\\:-skew-y-6:hover{
    --transform-skew-y: -6deg !important;
  }

  .sm\\:hover\\:-skew-y-3:hover{
    --transform-skew-y: -3deg !important;
  }

  .sm\\:hover\\:-skew-y-2:hover{
    --transform-skew-y: -2deg !important;
  }

  .sm\\:hover\\:-skew-y-1:hover{
    --transform-skew-y: -1deg !important;
  }

  .sm\\:focus\\:skew-x-0:focus{
    --transform-skew-x: 0 !important;
  }

  .sm\\:focus\\:skew-x-1:focus{
    --transform-skew-x: 1deg !important;
  }

  .sm\\:focus\\:skew-x-2:focus{
    --transform-skew-x: 2deg !important;
  }

  .sm\\:focus\\:skew-x-3:focus{
    --transform-skew-x: 3deg !important;
  }

  .sm\\:focus\\:skew-x-6:focus{
    --transform-skew-x: 6deg !important;
  }

  .sm\\:focus\\:skew-x-12:focus{
    --transform-skew-x: 12deg !important;
  }

  .sm\\:focus\\:-skew-x-12:focus{
    --transform-skew-x: -12deg !important;
  }

  .sm\\:focus\\:-skew-x-6:focus{
    --transform-skew-x: -6deg !important;
  }

  .sm\\:focus\\:-skew-x-3:focus{
    --transform-skew-x: -3deg !important;
  }

  .sm\\:focus\\:-skew-x-2:focus{
    --transform-skew-x: -2deg !important;
  }

  .sm\\:focus\\:-skew-x-1:focus{
    --transform-skew-x: -1deg !important;
  }

  .sm\\:focus\\:skew-y-0:focus{
    --transform-skew-y: 0 !important;
  }

  .sm\\:focus\\:skew-y-1:focus{
    --transform-skew-y: 1deg !important;
  }

  .sm\\:focus\\:skew-y-2:focus{
    --transform-skew-y: 2deg !important;
  }

  .sm\\:focus\\:skew-y-3:focus{
    --transform-skew-y: 3deg !important;
  }

  .sm\\:focus\\:skew-y-6:focus{
    --transform-skew-y: 6deg !important;
  }

  .sm\\:focus\\:skew-y-12:focus{
    --transform-skew-y: 12deg !important;
  }

  .sm\\:focus\\:-skew-y-12:focus{
    --transform-skew-y: -12deg !important;
  }

  .sm\\:focus\\:-skew-y-6:focus{
    --transform-skew-y: -6deg !important;
  }

  .sm\\:focus\\:-skew-y-3:focus{
    --transform-skew-y: -3deg !important;
  }

  .sm\\:focus\\:-skew-y-2:focus{
    --transform-skew-y: -2deg !important;
  }

  .sm\\:focus\\:-skew-y-1:focus{
    --transform-skew-y: -1deg !important;
  }

  [dir] .sm\\:transition-none{
    transition-property: none !important;
  }

  [dir] .sm\\:transition-all{
    transition-property: all !important;
  }

  [dir] .sm\\:transition{
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform !important;
  }

  [dir] .sm\\:transition-colors{
    transition-property: background-color, border-color, color, fill, stroke !important;
  }

  [dir] .sm\\:transition-opacity{
    transition-property: opacity !important;
  }

  [dir] .sm\\:transition-shadow{
    transition-property: box-shadow !important;
  }

  [dir] .sm\\:transition-transform{
    transition-property: transform !important;
  }

  [dir] .sm\\:ease-linear{
    transition-timing-function: linear !important;
  }

  [dir] .sm\\:ease-in{
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1) !important;
  }

  [dir] .sm\\:ease-out{
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
  }

  [dir] .sm\\:ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }

  [dir] .sm\\:duration-75{
    transition-duration: 75ms !important;
  }

  [dir] .sm\\:duration-100{
    transition-duration: 100ms !important;
  }

  [dir] .sm\\:duration-150{
    transition-duration: 150ms !important;
  }

  [dir] .sm\\:duration-200{
    transition-duration: 200ms !important;
  }

  [dir] .sm\\:duration-300{
    transition-duration: 300ms !important;
  }

  [dir] .sm\\:duration-500{
    transition-duration: 500ms !important;
  }

  [dir] .sm\\:duration-700{
    transition-duration: 700ms !important;
  }

  [dir] .sm\\:duration-1000{
    transition-duration: 1000ms !important;
  }

  [dir] .sm\\:delay-75{
    transition-delay: 75ms !important;
  }

  [dir] .sm\\:delay-100{
    transition-delay: 100ms !important;
  }

  [dir] .sm\\:delay-150{
    transition-delay: 150ms !important;
  }

  [dir] .sm\\:delay-200{
    transition-delay: 200ms !important;
  }

  [dir] .sm\\:delay-300{
    transition-delay: 300ms !important;
  }

  [dir] .sm\\:delay-500{
    transition-delay: 500ms !important;
  }

  [dir] .sm\\:delay-700{
    transition-delay: 700ms !important;
  }

  [dir] .sm\\:delay-1000{
    transition-delay: 1000ms !important;
  }

  [dir=ltr] .sm\\:animate-none{
    animation: none !important;
  }

  [dir=rtl] .sm\\:animate-none{
    animation: none !important;
  }

  [dir=ltr] .sm\\:animate-spin{
    animation:  spin-ltr 1s linear infinite !important;
  }

  [dir=rtl] .sm\\:animate-spin{
    animation:  spin-rtl 1s linear infinite !important;
  }

  [dir=ltr] .sm\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite !important;
  }

  [dir=rtl] .sm\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite !important;
  }

  [dir=ltr] .sm\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
  }

  [dir=rtl] .sm\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
  }

  [dir=ltr] .sm\\:animate-bounce{
    animation: bounce 1s infinite !important;
  }

  [dir=rtl] .sm\\:animate-bounce{
    animation: bounce 1s infinite !important;
  }
}

@media (min-width: 768px){
  .md\\:container{
    width: 100%;
  }
  [dir=ltr] .md\\:container{
    margin-right: auto;
    margin-left: auto;
    padding-right: 1rem;
    padding-left: 1rem;
  }
  [dir=rtl] .md\\:container{
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media (min-width: 576px){
    .md\\:container{
      max-width: 576px;
    }
  }

  @media (min-width: 768px){
    .md\\:container{
      max-width: 768px;
    }
  }

  @media (min-width: 992px){
    .md\\:container{
      max-width: 992px;
    }
  }

  @media (min-width: 1200px){
    .md\\:container{
      max-width: 1200px;
    }
  }

  .md\\:space-y-0 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-0 > :not(template) ~ :not(template){
    margin-top: calc(0px * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0px * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-0 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-0 > :not(template) ~ :not(template){
    margin-right: calc(0px * var(--space-x-reverse)) !important;
    margin-left: calc(0px * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-0 > :not(template) ~ :not(template){
    margin-left: calc(0px * var(--space-x-reverse)) !important;
    margin-right: calc(0px * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-1 > :not(template) ~ :not(template){
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0.25rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-1 > :not(template) ~ :not(template){
    margin-right: calc(0.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-1 > :not(template) ~ :not(template){
    margin-left: calc(0.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-2 > :not(template) ~ :not(template){
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0.5rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-2 > :not(template) ~ :not(template){
    margin-right: calc(0.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-2 > :not(template) ~ :not(template){
    margin-left: calc(0.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-3 > :not(template) ~ :not(template){
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0.75rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-3 > :not(template) ~ :not(template){
    margin-right: calc(0.75rem * var(--space-x-reverse)) !important;
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-3 > :not(template) ~ :not(template){
    margin-left: calc(0.75rem * var(--space-x-reverse)) !important;
    margin-right: calc(0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-4 > :not(template) ~ :not(template){
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-4 > :not(template) ~ :not(template){
    margin-right: calc(1rem * var(--space-x-reverse)) !important;
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-4 > :not(template) ~ :not(template){
    margin-left: calc(1rem * var(--space-x-reverse)) !important;
    margin-right: calc(1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-5 > :not(template) ~ :not(template){
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1.25rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-5 > :not(template) ~ :not(template){
    margin-right: calc(1.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-5 > :not(template) ~ :not(template){
    margin-left: calc(1.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-6 > :not(template) ~ :not(template){
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1.5rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-6 > :not(template) ~ :not(template){
    margin-right: calc(1.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-6 > :not(template) ~ :not(template){
    margin-left: calc(1.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-8 > :not(template) ~ :not(template){
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(2rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-8 > :not(template) ~ :not(template){
    margin-right: calc(2rem * var(--space-x-reverse)) !important;
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-8 > :not(template) ~ :not(template){
    margin-left: calc(2rem * var(--space-x-reverse)) !important;
    margin-right: calc(2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-10 > :not(template) ~ :not(template){
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(2.5rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-10 > :not(template) ~ :not(template){
    margin-right: calc(2.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-10 > :not(template) ~ :not(template){
    margin-left: calc(2.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-12 > :not(template) ~ :not(template){
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(3rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-12 > :not(template) ~ :not(template){
    margin-right: calc(3rem * var(--space-x-reverse)) !important;
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-12 > :not(template) ~ :not(template){
    margin-left: calc(3rem * var(--space-x-reverse)) !important;
    margin-right: calc(3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-16 > :not(template) ~ :not(template){
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(4rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-16 > :not(template) ~ :not(template){
    margin-right: calc(4rem * var(--space-x-reverse)) !important;
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-16 > :not(template) ~ :not(template){
    margin-left: calc(4rem * var(--space-x-reverse)) !important;
    margin-right: calc(4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-20 > :not(template) ~ :not(template){
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(5rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-20 > :not(template) ~ :not(template){
    margin-right: calc(5rem * var(--space-x-reverse)) !important;
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-20 > :not(template) ~ :not(template){
    margin-left: calc(5rem * var(--space-x-reverse)) !important;
    margin-right: calc(5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-24 > :not(template) ~ :not(template){
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(6rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-24 > :not(template) ~ :not(template){
    margin-right: calc(6rem * var(--space-x-reverse)) !important;
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-24 > :not(template) ~ :not(template){
    margin-left: calc(6rem * var(--space-x-reverse)) !important;
    margin-right: calc(6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-32 > :not(template) ~ :not(template){
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(8rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-32 > :not(template) ~ :not(template){
    margin-right: calc(8rem * var(--space-x-reverse)) !important;
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-32 > :not(template) ~ :not(template){
    margin-left: calc(8rem * var(--space-x-reverse)) !important;
    margin-right: calc(8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-40 > :not(template) ~ :not(template){
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(10rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-40 > :not(template) ~ :not(template){
    margin-right: calc(10rem * var(--space-x-reverse)) !important;
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-40 > :not(template) ~ :not(template){
    margin-left: calc(10rem * var(--space-x-reverse)) !important;
    margin-right: calc(10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-48 > :not(template) ~ :not(template){
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(12rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-48 > :not(template) ~ :not(template){
    margin-right: calc(12rem * var(--space-x-reverse)) !important;
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-48 > :not(template) ~ :not(template){
    margin-left: calc(12rem * var(--space-x-reverse)) !important;
    margin-right: calc(12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-56 > :not(template) ~ :not(template){
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(14rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-56 > :not(template) ~ :not(template){
    margin-right: calc(14rem * var(--space-x-reverse)) !important;
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-56 > :not(template) ~ :not(template){
    margin-left: calc(14rem * var(--space-x-reverse)) !important;
    margin-right: calc(14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-64 > :not(template) ~ :not(template){
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(16rem * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-64 > :not(template) ~ :not(template){
    margin-right: calc(16rem * var(--space-x-reverse)) !important;
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-64 > :not(template) ~ :not(template){
    margin-left: calc(16rem * var(--space-x-reverse)) !important;
    margin-right: calc(16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:space-y-px > :not(template) ~ :not(template){
    margin-top: calc(1px * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1px * var(--space-y-reverse)) !important;
  }

  .md\\:space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:space-x-px > :not(template) ~ :not(template){
    margin-right: calc(1px * var(--space-x-reverse)) !important;
    margin-left: calc(1px * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:space-x-px > :not(template) ~ :not(template){
    margin-left: calc(1px * var(--space-x-reverse)) !important;
    margin-right: calc(1px * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-1 > :not(template) ~ :not(template){
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-0.25rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-1 > :not(template) ~ :not(template){
    margin-right: calc(-0.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-1 > :not(template) ~ :not(template){
    margin-left: calc(-0.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(-0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-2 > :not(template) ~ :not(template){
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-0.5rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-2 > :not(template) ~ :not(template){
    margin-right: calc(-0.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-2 > :not(template) ~ :not(template){
    margin-left: calc(-0.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-3 > :not(template) ~ :not(template){
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-0.75rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-3 > :not(template) ~ :not(template){
    margin-right: calc(-0.75rem * var(--space-x-reverse)) !important;
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-3 > :not(template) ~ :not(template){
    margin-left: calc(-0.75rem * var(--space-x-reverse)) !important;
    margin-right: calc(-0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-4 > :not(template) ~ :not(template){
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-4 > :not(template) ~ :not(template){
    margin-right: calc(-1rem * var(--space-x-reverse)) !important;
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-4 > :not(template) ~ :not(template){
    margin-left: calc(-1rem * var(--space-x-reverse)) !important;
    margin-right: calc(-1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-5 > :not(template) ~ :not(template){
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1.25rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-5 > :not(template) ~ :not(template){
    margin-right: calc(-1.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-5 > :not(template) ~ :not(template){
    margin-left: calc(-1.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(-1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-6 > :not(template) ~ :not(template){
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1.5rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-6 > :not(template) ~ :not(template){
    margin-right: calc(-1.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-6 > :not(template) ~ :not(template){
    margin-left: calc(-1.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-8 > :not(template) ~ :not(template){
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-2rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-8 > :not(template) ~ :not(template){
    margin-right: calc(-2rem * var(--space-x-reverse)) !important;
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-8 > :not(template) ~ :not(template){
    margin-left: calc(-2rem * var(--space-x-reverse)) !important;
    margin-right: calc(-2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-10 > :not(template) ~ :not(template){
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-2.5rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-10 > :not(template) ~ :not(template){
    margin-right: calc(-2.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-10 > :not(template) ~ :not(template){
    margin-left: calc(-2.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-12 > :not(template) ~ :not(template){
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-3rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-12 > :not(template) ~ :not(template){
    margin-right: calc(-3rem * var(--space-x-reverse)) !important;
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-12 > :not(template) ~ :not(template){
    margin-left: calc(-3rem * var(--space-x-reverse)) !important;
    margin-right: calc(-3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-16 > :not(template) ~ :not(template){
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-4rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-16 > :not(template) ~ :not(template){
    margin-right: calc(-4rem * var(--space-x-reverse)) !important;
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-16 > :not(template) ~ :not(template){
    margin-left: calc(-4rem * var(--space-x-reverse)) !important;
    margin-right: calc(-4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-20 > :not(template) ~ :not(template){
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-5rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-20 > :not(template) ~ :not(template){
    margin-right: calc(-5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-20 > :not(template) ~ :not(template){
    margin-left: calc(-5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-24 > :not(template) ~ :not(template){
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-6rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-24 > :not(template) ~ :not(template){
    margin-right: calc(-6rem * var(--space-x-reverse)) !important;
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-24 > :not(template) ~ :not(template){
    margin-left: calc(-6rem * var(--space-x-reverse)) !important;
    margin-right: calc(-6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-32 > :not(template) ~ :not(template){
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-8rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-32 > :not(template) ~ :not(template){
    margin-right: calc(-8rem * var(--space-x-reverse)) !important;
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-32 > :not(template) ~ :not(template){
    margin-left: calc(-8rem * var(--space-x-reverse)) !important;
    margin-right: calc(-8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-40 > :not(template) ~ :not(template){
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-10rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-40 > :not(template) ~ :not(template){
    margin-right: calc(-10rem * var(--space-x-reverse)) !important;
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-40 > :not(template) ~ :not(template){
    margin-left: calc(-10rem * var(--space-x-reverse)) !important;
    margin-right: calc(-10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-48 > :not(template) ~ :not(template){
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-12rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-48 > :not(template) ~ :not(template){
    margin-right: calc(-12rem * var(--space-x-reverse)) !important;
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-48 > :not(template) ~ :not(template){
    margin-left: calc(-12rem * var(--space-x-reverse)) !important;
    margin-right: calc(-12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-56 > :not(template) ~ :not(template){
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-14rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-56 > :not(template) ~ :not(template){
    margin-right: calc(-14rem * var(--space-x-reverse)) !important;
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-56 > :not(template) ~ :not(template){
    margin-left: calc(-14rem * var(--space-x-reverse)) !important;
    margin-right: calc(-14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-64 > :not(template) ~ :not(template){
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-16rem * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-64 > :not(template) ~ :not(template){
    margin-right: calc(-16rem * var(--space-x-reverse)) !important;
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-64 > :not(template) ~ :not(template){
    margin-left: calc(-16rem * var(--space-x-reverse)) !important;
    margin-right: calc(-16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:-space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .md\\:-space-y-px > :not(template) ~ :not(template){
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1px * var(--space-y-reverse)) !important;
  }

  .md\\:-space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:-space-x-px > :not(template) ~ :not(template){
    margin-right: calc(-1px * var(--space-x-reverse)) !important;
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .md\\:-space-x-px > :not(template) ~ :not(template){
    margin-left: calc(-1px * var(--space-x-reverse)) !important;
    margin-right: calc(-1px * calc(1 - var(--space-x-reverse))) !important;
  }

  .md\\:space-y-reverse > :not(template) ~ :not(template){
    --space-y-reverse: 1 !important;
  }

  .md\\:space-x-reverse > :not(template) ~ :not(template){
    --space-x-reverse: 1 !important;
  }

  .md\\:divide-y-0 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .md\\:divide-y-0 > :not(template) ~ :not(template){
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(0px * var(--divide-y-reverse)) !important;
  }

  .md\\:divide-x-0 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:divide-x-0 > :not(template) ~ :not(template){
    border-right-width: calc(0px * var(--divide-x-reverse)) !important;
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .md\\:divide-x-0 > :not(template) ~ :not(template){
    border-left-width: calc(0px * var(--divide-x-reverse)) !important;
    border-right-width: calc(0px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .md\\:divide-y-2 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .md\\:divide-y-2 > :not(template) ~ :not(template){
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(2px * var(--divide-y-reverse)) !important;
  }

  .md\\:divide-x-2 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:divide-x-2 > :not(template) ~ :not(template){
    border-right-width: calc(2px * var(--divide-x-reverse)) !important;
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .md\\:divide-x-2 > :not(template) ~ :not(template){
    border-left-width: calc(2px * var(--divide-x-reverse)) !important;
    border-right-width: calc(2px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .md\\:divide-y-4 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .md\\:divide-y-4 > :not(template) ~ :not(template){
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(4px * var(--divide-y-reverse)) !important;
  }

  .md\\:divide-x-4 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:divide-x-4 > :not(template) ~ :not(template){
    border-right-width: calc(4px * var(--divide-x-reverse)) !important;
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .md\\:divide-x-4 > :not(template) ~ :not(template){
    border-left-width: calc(4px * var(--divide-x-reverse)) !important;
    border-right-width: calc(4px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .md\\:divide-y-8 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .md\\:divide-y-8 > :not(template) ~ :not(template){
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(8px * var(--divide-y-reverse)) !important;
  }

  .md\\:divide-x-8 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:divide-x-8 > :not(template) ~ :not(template){
    border-right-width: calc(8px * var(--divide-x-reverse)) !important;
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .md\\:divide-x-8 > :not(template) ~ :not(template){
    border-left-width: calc(8px * var(--divide-x-reverse)) !important;
    border-right-width: calc(8px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .md\\:divide-y > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .md\\:divide-y > :not(template) ~ :not(template){
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(1px * var(--divide-y-reverse)) !important;
  }

  .md\\:divide-x > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .md\\:divide-x > :not(template) ~ :not(template){
    border-right-width: calc(1px * var(--divide-x-reverse)) !important;
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .md\\:divide-x > :not(template) ~ :not(template){
    border-left-width: calc(1px * var(--divide-x-reverse)) !important;
    border-right-width: calc(1px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .md\\:divide-y-reverse > :not(template) ~ :not(template){
    --divide-y-reverse: 1 !important;
  }

  .md\\:divide-x-reverse > :not(template) ~ :not(template){
    --divide-x-reverse: 1 !important;
  }

  [dir] .md\\:divide-transparent > :not(template) ~ :not(template){
    border-color: transparent !important;
  }

  .md\\:divide-black > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .md\\:divide-black > :not(template) ~ :not(template){
    border-color: #22292f !important;
    border-color: rgba(34, 41, 47, var(--divide-opacity)) !important;
  }

  .md\\:divide-white > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .md\\:divide-white > :not(template) ~ :not(template){
    border-color: #ffffff !important;
    border-color: rgba(255, 255, 255, var(--divide-opacity)) !important;
  }

  .md\\:divide-grey > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .md\\:divide-grey > :not(template) ~ :not(template){
    border-color: #b8c2cc !important;
    border-color: rgba(184, 194, 204, var(--divide-opacity)) !important;
  }

  .md\\:divide-grey-light > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .md\\:divide-grey-light > :not(template) ~ :not(template){
    border-color: #dae1e7 !important;
    border-color: rgba(218, 225, 231, var(--divide-opacity)) !important;
  }

  [dir] .md\\:divide-solid > :not(template) ~ :not(template){
    border-style: solid !important;
  }

  [dir] .md\\:divide-dashed > :not(template) ~ :not(template){
    border-style: dashed !important;
  }

  [dir] .md\\:divide-dotted > :not(template) ~ :not(template){
    border-style: dotted !important;
  }

  [dir] .md\\:divide-double > :not(template) ~ :not(template){
    border-style: double !important;
  }

  [dir] .md\\:divide-none > :not(template) ~ :not(template){
    border-style: none !important;
  }

  .md\\:divide-opacity-0 > :not(template) ~ :not(template){
    --divide-opacity: 0 !important;
  }

  .md\\:divide-opacity-25 > :not(template) ~ :not(template){
    --divide-opacity: 0.25 !important;
  }

  .md\\:divide-opacity-50 > :not(template) ~ :not(template){
    --divide-opacity: 0.5 !important;
  }

  .md\\:divide-opacity-75 > :not(template) ~ :not(template){
    --divide-opacity: 0.75 !important;
  }

  .md\\:divide-opacity-100 > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  .md\\:sr-only{
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
  }

  [dir] .md\\:sr-only{
    padding: 0 !important;
    margin: -1px !important;
    border-width: 0 !important;
  }

  .md\\:not-sr-only{
    position: static !important;
    width: auto !important;
    height: auto !important;
    overflow: visible !important;
    clip: auto !important;
    white-space: normal !important;
  }

  [dir] .md\\:not-sr-only{
    padding: 0 !important;
    margin: 0 !important;
  }

  .md\\:focus\\:sr-only:focus{
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
  }

  [dir] .md\\:focus\\:sr-only:focus{
    padding: 0 !important;
    margin: -1px !important;
    border-width: 0 !important;
  }

  .md\\:focus\\:not-sr-only:focus{
    position: static !important;
    width: auto !important;
    height: auto !important;
    overflow: visible !important;
    clip: auto !important;
    white-space: normal !important;
  }

  [dir] .md\\:focus\\:not-sr-only:focus{
    padding: 0 !important;
    margin: 0 !important;
  }

  .md\\:appearance-none{
    -webkit-appearance: none !important;
            appearance: none !important;
  }

  [dir] .md\\:bg-fixed{
    background-attachment: fixed !important;
  }

  [dir] .md\\:bg-local{
    background-attachment: local !important;
  }

  [dir] .md\\:bg-scroll{
    background-attachment: scroll !important;
  }

  [dir] .md\\:bg-clip-border{
    background-clip: border-box !important;
  }

  [dir] .md\\:bg-clip-padding{
    background-clip: padding-box !important;
  }

  [dir] .md\\:bg-clip-content{
    background-clip: content-box !important;
  }

  [dir] .md\\:bg-clip-text{
    -webkit-background-clip: text !important;
            background-clip: text !important;
  }

  [dir] .md\\:bg-transparent{
    background-color: transparent !important;
  }

  .md\\:bg-black{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:bg-black{
    background-color: #22292f !important;
    background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
  }

  .md\\:bg-white{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:bg-white{
    background-color: #ffffff !important;
    background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
  }

  .md\\:bg-grey{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:bg-grey{
    background-color: #b8c2cc !important;
    background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
  }

  .md\\:bg-grey-light{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:bg-grey-light{
    background-color: #dae1e7 !important;
    background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
  }

  [dir] .md\\:hover\\:bg-transparent:hover{
    background-color: transparent !important;
  }

  .md\\:hover\\:bg-black:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:hover\\:bg-black:hover{
    background-color: #22292f !important;
    background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
  }

  .md\\:hover\\:bg-white:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:hover\\:bg-white:hover{
    background-color: #ffffff !important;
    background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
  }

  .md\\:hover\\:bg-grey:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:hover\\:bg-grey:hover{
    background-color: #b8c2cc !important;
    background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
  }

  .md\\:hover\\:bg-grey-light:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:hover\\:bg-grey-light:hover{
    background-color: #dae1e7 !important;
    background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
  }

  [dir] .md\\:focus\\:bg-transparent:focus{
    background-color: transparent !important;
  }

  .md\\:focus\\:bg-black:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:focus\\:bg-black:focus{
    background-color: #22292f !important;
    background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
  }

  .md\\:focus\\:bg-white:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:focus\\:bg-white:focus{
    background-color: #ffffff !important;
    background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
  }

  .md\\:focus\\:bg-grey:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:focus\\:bg-grey:focus{
    background-color: #b8c2cc !important;
    background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
  }

  .md\\:focus\\:bg-grey-light:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:focus\\:bg-grey-light:focus{
    background-color: #dae1e7 !important;
    background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
  }

  [dir] .md\\:bg-none{
    background-image: none !important;
  }

  [dir] .md\\:bg-gradient-to-t{
    background-image: linear-gradient(to top, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .md\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top right, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .md\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top left, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .md\\:bg-gradient-to-r{
    background-image: linear-gradient(to right, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .md\\:bg-gradient-to-r{
    background-image: linear-gradient(to left, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .md\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .md\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops)) !important;
  }

  [dir] .md\\:bg-gradient-to-b{
    background-image: linear-gradient(to bottom, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .md\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .md\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .md\\:bg-gradient-to-l{
    background-image: linear-gradient(to left, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .md\\:bg-gradient-to-l{
    background-image: linear-gradient(to right, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .md\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top left, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .md\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top right, var(--gradient-color-stops)) !important;
  }

  .md\\:from-transparent{
    --gradient-from-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .md\\:from-black{
    --gradient-from-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .md\\:from-white{
    --gradient-from-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .md\\:from-grey{
    --gradient-from-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .md\\:from-grey-light{
    --gradient-from-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .md\\:via-transparent{
    --gradient-via-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .md\\:via-black{
    --gradient-via-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .md\\:via-white{
    --gradient-via-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .md\\:via-grey{
    --gradient-via-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .md\\:via-grey-light{
    --gradient-via-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .md\\:to-transparent{
    --gradient-to-color: transparent !important;
  }

  .md\\:to-black{
    --gradient-to-color: #22292f !important;
  }

  .md\\:to-white{
    --gradient-to-color: #ffffff !important;
  }

  .md\\:to-grey{
    --gradient-to-color: #b8c2cc !important;
  }

  .md\\:to-grey-light{
    --gradient-to-color: #dae1e7 !important;
  }

  .md\\:hover\\:from-transparent:hover{
    --gradient-from-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .md\\:hover\\:from-black:hover{
    --gradient-from-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .md\\:hover\\:from-white:hover{
    --gradient-from-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .md\\:hover\\:from-grey:hover{
    --gradient-from-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .md\\:hover\\:from-grey-light:hover{
    --gradient-from-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .md\\:hover\\:via-transparent:hover{
    --gradient-via-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .md\\:hover\\:via-black:hover{
    --gradient-via-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .md\\:hover\\:via-white:hover{
    --gradient-via-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .md\\:hover\\:via-grey:hover{
    --gradient-via-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .md\\:hover\\:via-grey-light:hover{
    --gradient-via-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .md\\:hover\\:to-transparent:hover{
    --gradient-to-color: transparent !important;
  }

  .md\\:hover\\:to-black:hover{
    --gradient-to-color: #22292f !important;
  }

  .md\\:hover\\:to-white:hover{
    --gradient-to-color: #ffffff !important;
  }

  .md\\:hover\\:to-grey:hover{
    --gradient-to-color: #b8c2cc !important;
  }

  .md\\:hover\\:to-grey-light:hover{
    --gradient-to-color: #dae1e7 !important;
  }

  .md\\:focus\\:from-transparent:focus{
    --gradient-from-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .md\\:focus\\:from-black:focus{
    --gradient-from-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .md\\:focus\\:from-white:focus{
    --gradient-from-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .md\\:focus\\:from-grey:focus{
    --gradient-from-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .md\\:focus\\:from-grey-light:focus{
    --gradient-from-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .md\\:focus\\:via-transparent:focus{
    --gradient-via-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .md\\:focus\\:via-black:focus{
    --gradient-via-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .md\\:focus\\:via-white:focus{
    --gradient-via-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .md\\:focus\\:via-grey:focus{
    --gradient-via-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .md\\:focus\\:via-grey-light:focus{
    --gradient-via-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .md\\:focus\\:to-transparent:focus{
    --gradient-to-color: transparent !important;
  }

  .md\\:focus\\:to-black:focus{
    --gradient-to-color: #22292f !important;
  }

  .md\\:focus\\:to-white:focus{
    --gradient-to-color: #ffffff !important;
  }

  .md\\:focus\\:to-grey:focus{
    --gradient-to-color: #b8c2cc !important;
  }

  .md\\:focus\\:to-grey-light:focus{
    --gradient-to-color: #dae1e7 !important;
  }

  .md\\:bg-opacity-0{
    --bg-opacity: 0 !important;
  }

  .md\\:bg-opacity-25{
    --bg-opacity: 0.25 !important;
  }

  .md\\:bg-opacity-50{
    --bg-opacity: 0.5 !important;
  }

  .md\\:bg-opacity-75{
    --bg-opacity: 0.75 !important;
  }

  .md\\:bg-opacity-100{
    --bg-opacity: 1 !important;
  }

  .md\\:hover\\:bg-opacity-0:hover{
    --bg-opacity: 0 !important;
  }

  .md\\:hover\\:bg-opacity-25:hover{
    --bg-opacity: 0.25 !important;
  }

  .md\\:hover\\:bg-opacity-50:hover{
    --bg-opacity: 0.5 !important;
  }

  .md\\:hover\\:bg-opacity-75:hover{
    --bg-opacity: 0.75 !important;
  }

  .md\\:hover\\:bg-opacity-100:hover{
    --bg-opacity: 1 !important;
  }

  .md\\:focus\\:bg-opacity-0:focus{
    --bg-opacity: 0 !important;
  }

  .md\\:focus\\:bg-opacity-25:focus{
    --bg-opacity: 0.25 !important;
  }

  .md\\:focus\\:bg-opacity-50:focus{
    --bg-opacity: 0.5 !important;
  }

  .md\\:focus\\:bg-opacity-75:focus{
    --bg-opacity: 0.75 !important;
  }

  .md\\:focus\\:bg-opacity-100:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .md\\:bg-auto{
    background-size: auto !important;
  }

  [dir] .md\\:bg-cover{
    background-size: cover !important;
  }

  [dir] .md\\:bg-contain{
    background-size: contain !important;
  }

  [dir] .md\\:border-transparent{
    border-color: transparent !important;
  }

  .md\\:border-black{
    --border-opacity: 1 !important;
  }

  [dir] .md\\:border-black{
    border-color: #22292f !important;
    border-color: rgba(34, 41, 47, var(--border-opacity)) !important;
  }

  .md\\:border-white{
    --border-opacity: 1 !important;
  }

  [dir] .md\\:border-white{
    border-color: #ffffff !important;
    border-color: rgba(255, 255, 255, var(--border-opacity)) !important;
  }

  .md\\:border-grey{
    --border-opacity: 1 !important;
  }

  [dir] .md\\:border-grey{
    border-color: #b8c2cc !important;
    border-color: rgba(184, 194, 204, var(--border-opacity)) !important;
  }

  .md\\:border-grey-light{
    --border-opacity: 1 !important;
  }

  [dir] .md\\:border-grey-light{
    border-color: #dae1e7 !important;
    border-color: rgba(218, 225, 231, var(--border-opacity)) !important;
  }

  [dir] .md\\:hover\\:border-transparent:hover{
    border-color: transparent !important;
  }

  .md\\:hover\\:border-black:hover{
    --border-opacity: 1 !important;
  }

  [dir] .md\\:hover\\:border-black:hover{
    border-color: #22292f !important;
    border-color: rgba(34, 41, 47, var(--border-opacity)) !important;
  }

  .md\\:hover\\:border-white:hover{
    --border-opacity: 1 !important;
  }

  [dir] .md\\:hover\\:border-white:hover{
    border-color: #ffffff !important;
    border-color: rgba(255, 255, 255, var(--border-opacity)) !important;
  }

  .md\\:hover\\:border-grey:hover{
    --border-opacity: 1 !important;
  }

  [dir] .md\\:hover\\:border-grey:hover{
    border-color: #b8c2cc !important;
    border-color: rgba(184, 194, 204, var(--border-opacity)) !important;
  }

  .md\\:hover\\:border-grey-light:hover{
    --border-opacity: 1 !important;
  }

  [dir] .md\\:hover\\:border-grey-light:hover{
    border-color: #dae1e7 !important;
    border-color: rgba(218, 225, 231, var(--border-opacity)) !important;
  }

  .md\\:border-opacity-0{
    --border-opacity: 0 !important;
  }

  .md\\:border-opacity-25{
    --border-opacity: 0.25 !important;
  }

  .md\\:border-opacity-50{
    --border-opacity: 0.5 !important;
  }

  .md\\:border-opacity-75{
    --border-opacity: 0.75 !important;
  }

  .md\\:border-opacity-100{
    --border-opacity: 1 !important;
  }

  .md\\:hover\\:border-opacity-0:hover{
    --border-opacity: 0 !important;
  }

  .md\\:hover\\:border-opacity-25:hover{
    --border-opacity: 0.25 !important;
  }

  .md\\:hover\\:border-opacity-50:hover{
    --border-opacity: 0.5 !important;
  }

  .md\\:hover\\:border-opacity-75:hover{
    --border-opacity: 0.75 !important;
  }

  .md\\:hover\\:border-opacity-100:hover{
    --border-opacity: 1 !important;
  }

  .md\\:focus\\:border-opacity-0:focus{
    --border-opacity: 0 !important;
  }

  .md\\:focus\\:border-opacity-25:focus{
    --border-opacity: 0.25 !important;
  }

  .md\\:focus\\:border-opacity-50:focus{
    --border-opacity: 0.5 !important;
  }

  .md\\:focus\\:border-opacity-75:focus{
    --border-opacity: 0.75 !important;
  }

  .md\\:focus\\:border-opacity-100:focus{
    --border-opacity: 1 !important;
  }

  [dir] .md\\:border-solid{
    border-style: solid !important;
  }

  [dir] .md\\:border-dashed{
    border-style: dashed !important;
  }

  [dir] .md\\:border-dotted{
    border-style: dotted !important;
  }

  [dir] .md\\:border-double{
    border-style: double !important;
  }

  [dir] .md\\:border-none{
    border-style: none !important;
  }

  [dir] .md\\:border-0{
    border-width: 0 !important;
  }

  [dir] .md\\:border-2{
    border-width: 2px !important;
  }

  [dir] .md\\:border-4{
    border-width: 4px !important;
  }

  [dir] .md\\:border-8{
    border-width: 8px !important;
  }

  [dir] .md\\:border{
    border-width: 1px !important;
  }

  [dir] .md\\:border-t-0{
    border-top-width: 0 !important;
  }

  [dir=ltr] .md\\:border-r-0{
    border-right-width: 0 !important;
  }

  [dir=rtl] .md\\:border-r-0{
    border-left-width: 0 !important;
  }

  [dir] .md\\:border-b-0{
    border-bottom-width: 0 !important;
  }

  [dir=ltr] .md\\:border-l-0{
    border-left-width: 0 !important;
  }

  [dir=rtl] .md\\:border-l-0{
    border-right-width: 0 !important;
  }

  [dir] .md\\:border-t-2{
    border-top-width: 2px !important;
  }

  [dir=ltr] .md\\:border-r-2{
    border-right-width: 2px !important;
  }

  [dir=rtl] .md\\:border-r-2{
    border-left-width: 2px !important;
  }

  [dir] .md\\:border-b-2{
    border-bottom-width: 2px !important;
  }

  [dir=ltr] .md\\:border-l-2{
    border-left-width: 2px !important;
  }

  [dir=rtl] .md\\:border-l-2{
    border-right-width: 2px !important;
  }

  [dir] .md\\:border-t-4{
    border-top-width: 4px !important;
  }

  [dir=ltr] .md\\:border-r-4{
    border-right-width: 4px !important;
  }

  [dir=rtl] .md\\:border-r-4{
    border-left-width: 4px !important;
  }

  [dir] .md\\:border-b-4{
    border-bottom-width: 4px !important;
  }

  [dir=ltr] .md\\:border-l-4{
    border-left-width: 4px !important;
  }

  [dir=rtl] .md\\:border-l-4{
    border-right-width: 4px !important;
  }

  [dir] .md\\:border-t-8{
    border-top-width: 8px !important;
  }

  [dir=ltr] .md\\:border-r-8{
    border-right-width: 8px !important;
  }

  [dir=rtl] .md\\:border-r-8{
    border-left-width: 8px !important;
  }

  [dir] .md\\:border-b-8{
    border-bottom-width: 8px !important;
  }

  [dir=ltr] .md\\:border-l-8{
    border-left-width: 8px !important;
  }

  [dir=rtl] .md\\:border-l-8{
    border-right-width: 8px !important;
  }

  [dir] .md\\:border-t{
    border-top-width: 1px !important;
  }

  [dir=ltr] .md\\:border-r{
    border-right-width: 1px !important;
  }

  [dir=rtl] .md\\:border-r{
    border-left-width: 1px !important;
  }

  [dir] .md\\:border-b{
    border-bottom-width: 1px !important;
  }

  [dir=ltr] .md\\:border-l{
    border-left-width: 1px !important;
  }

  [dir=rtl] .md\\:border-l{
    border-right-width: 1px !important;
  }

  .md\\:box-border{
    box-sizing: border-box !important;
  }

  .md\\:box-content{
    box-sizing: content-box !important;
  }

  .md\\:block{
    display: block !important;
  }

  .md\\:inline-block{
    display: inline-block !important;
  }

  .md\\:inline{
    display: inline !important;
  }

  .md\\:flex{
    display: flex !important;
  }

  .md\\:inline-flex{
    display: inline-flex !important;
  }

  .md\\:table{
    display: table !important;
  }

  .md\\:table-caption{
    display: table-caption !important;
  }

  .md\\:table-cell{
    display: table-cell !important;
  }

  .md\\:table-column{
    display: table-column !important;
  }

  .md\\:table-column-group{
    display: table-column-group !important;
  }

  .md\\:table-footer-group{
    display: table-footer-group !important;
  }

  .md\\:table-header-group{
    display: table-header-group !important;
  }

  .md\\:table-row-group{
    display: table-row-group !important;
  }

  .md\\:table-row{
    display: table-row !important;
  }

  .md\\:flow-root{
    display: flow-root !important;
  }

  .md\\:grid{
    display: grid !important;
  }

  .md\\:inline-grid{
    display: inline-grid !important;
  }

  .md\\:contents{
    display: contents !important;
  }

  .md\\:hidden{
    display: none !important;
  }

  .md\\:flex-row{
    flex-direction: row !important;
  }

  .md\\:flex-row-reverse{
    flex-direction: row-reverse !important;
  }

  .md\\:flex-col{
    flex-direction: column !important;
  }

  .md\\:flex-col-reverse{
    flex-direction: column-reverse !important;
  }

  .md\\:flex-wrap{
    flex-wrap: wrap !important;
  }

  .md\\:flex-wrap-reverse{
    flex-wrap: wrap-reverse !important;
  }

  .md\\:flex-no-wrap{
    flex-wrap: nowrap !important;
  }

  .md\\:place-items-auto{
    place-items: auto !important;
  }

  .md\\:place-items-start{
    place-items: start !important;
  }

  .md\\:place-items-end{
    place-items: end !important;
  }

  .md\\:place-items-center{
    place-items: center !important;
  }

  .md\\:place-items-stretch{
    place-items: stretch !important;
  }

  .md\\:place-content-center{
    place-content: center !important;
  }

  .md\\:place-content-start{
    place-content: start !important;
  }

  .md\\:place-content-end{
    place-content: end !important;
  }

  .md\\:place-content-between{
    place-content: space-between !important;
  }

  .md\\:place-content-around{
    place-content: space-around !important;
  }

  .md\\:place-content-evenly{
    place-content: space-evenly !important;
  }

  .md\\:place-content-stretch{
    place-content: stretch !important;
  }

  .md\\:place-self-auto{
    place-self: auto !important;
  }

  .md\\:place-self-start{
    place-self: start !important;
  }

  .md\\:place-self-end{
    place-self: end !important;
  }

  .md\\:place-self-center{
    place-self: center !important;
  }

  .md\\:place-self-stretch{
    place-self: stretch !important;
  }

  .md\\:items-start{
    align-items: flex-start !important;
  }

  .md\\:items-end{
    align-items: flex-end !important;
  }

  .md\\:items-center{
    align-items: center !important;
  }

  .md\\:items-baseline{
    align-items: baseline !important;
  }

  .md\\:items-stretch{
    align-items: stretch !important;
  }

  .md\\:content-center{
    align-content: center !important;
  }

  .md\\:content-start{
    align-content: flex-start !important;
  }

  .md\\:content-end{
    align-content: flex-end !important;
  }

  .md\\:content-between{
    align-content: space-between !important;
  }

  .md\\:content-around{
    align-content: space-around !important;
  }

  .md\\:content-evenly{
    align-content: space-evenly !important;
  }

  .md\\:self-auto{
    align-self: auto !important;
  }

  .md\\:self-start{
    align-self: flex-start !important;
  }

  .md\\:self-end{
    align-self: flex-end !important;
  }

  .md\\:self-center{
    align-self: center !important;
  }

  .md\\:self-stretch{
    align-self: stretch !important;
  }

  .md\\:justify-items-auto{
    justify-items: auto !important;
  }

  .md\\:justify-items-start{
    justify-items: start !important;
  }

  .md\\:justify-items-end{
    justify-items: end !important;
  }

  .md\\:justify-items-center{
    justify-items: center !important;
  }

  .md\\:justify-items-stretch{
    justify-items: stretch !important;
  }

  .md\\:justify-start{
    justify-content: flex-start !important;
  }

  .md\\:justify-end{
    justify-content: flex-end !important;
  }

  .md\\:justify-center{
    justify-content: center !important;
  }

  .md\\:justify-between{
    justify-content: space-between !important;
  }

  .md\\:justify-around{
    justify-content: space-around !important;
  }

  .md\\:justify-evenly{
    justify-content: space-evenly !important;
  }

  .md\\:justify-self-auto{
    justify-self: auto !important;
  }

  .md\\:justify-self-start{
    justify-self: start !important;
  }

  .md\\:justify-self-end{
    justify-self: end !important;
  }

  .md\\:justify-self-center{
    justify-self: center !important;
  }

  .md\\:justify-self-stretch{
    justify-self: stretch !important;
  }

  .md\\:flex-1{
    flex: 1 1 0% !important;
  }

  .md\\:flex-auto{
    flex: 1 1 auto !important;
  }

  .md\\:flex-initial{
    flex: 0 1 auto !important;
  }

  .md\\:flex-none{
    flex: none !important;
  }

  .md\\:flex-grow-0{
    flex-grow: 0 !important;
  }

  .md\\:flex-grow{
    flex-grow: 1 !important;
  }

  .md\\:flex-shrink-0{
    flex-shrink: 0 !important;
  }

  .md\\:flex-shrink{
    flex-shrink: 1 !important;
  }

  .md\\:order-1{
    order: 1 !important;
  }

  .md\\:order-2{
    order: 2 !important;
  }

  .md\\:order-3{
    order: 3 !important;
  }

  .md\\:order-4{
    order: 4 !important;
  }

  .md\\:order-5{
    order: 5 !important;
  }

  .md\\:order-6{
    order: 6 !important;
  }

  .md\\:order-first{
    order: -1 !important;
  }

  .md\\:order-last{
    order: 999 !important;
  }

  .md\\:order-normal{
    order: 0 !important;
  }

  .md\\:hover\\:order-1:hover{
    order: 1 !important;
  }

  .md\\:hover\\:order-2:hover{
    order: 2 !important;
  }

  .md\\:hover\\:order-3:hover{
    order: 3 !important;
  }

  .md\\:hover\\:order-4:hover{
    order: 4 !important;
  }

  .md\\:hover\\:order-5:hover{
    order: 5 !important;
  }

  .md\\:hover\\:order-6:hover{
    order: 6 !important;
  }

  .md\\:hover\\:order-first:hover{
    order: -1 !important;
  }

  .md\\:hover\\:order-last:hover{
    order: 999 !important;
  }

  .md\\:hover\\:order-normal:hover{
    order: 0 !important;
  }

  .md\\:focus\\:order-1:focus{
    order: 1 !important;
  }

  .md\\:focus\\:order-2:focus{
    order: 2 !important;
  }

  .md\\:focus\\:order-3:focus{
    order: 3 !important;
  }

  .md\\:focus\\:order-4:focus{
    order: 4 !important;
  }

  .md\\:focus\\:order-5:focus{
    order: 5 !important;
  }

  .md\\:focus\\:order-6:focus{
    order: 6 !important;
  }

  .md\\:focus\\:order-first:focus{
    order: -1 !important;
  }

  .md\\:focus\\:order-last:focus{
    order: 999 !important;
  }

  .md\\:focus\\:order-normal:focus{
    order: 0 !important;
  }

  [dir=ltr] .md\\:float-right{
    float: right !important;
  }

  [dir=rtl] .md\\:float-right{
    float: left !important;
  }

  [dir=ltr] .md\\:float-left{
    float: left !important;
  }

  [dir=rtl] .md\\:float-left{
    float: right !important;
  }

  [dir] .md\\:float-none{
    float: none !important;
  }

  .md\\:clearfix:after{
    content: "" !important;
    display: table !important;
  }

  [dir] .md\\:clearfix:after{
    clear: both !important;
  }

  [dir=ltr] .md\\:clear-left{
    clear: left !important;
  }

  [dir=rtl] .md\\:clear-left{
    clear: right !important;
  }

  [dir=ltr] .md\\:clear-right{
    clear: right !important;
  }

  [dir=rtl] .md\\:clear-right{
    clear: left !important;
  }

  [dir] .md\\:clear-both{
    clear: both !important;
  }

  [dir] .md\\:clear-none{
    clear: none !important;
  }

  .md\\:font-light{
    font-weight: 300 !important;
  }

  .md\\:font-normal{
    font-weight: 400 !important;
  }

  .md\\:font-medium{
    font-weight: 500 !important;
  }

  .md\\:font-semibold{
    font-weight: 600 !important;
  }

  .md\\:font-bold{
    font-weight: 700 !important;
  }

  .md\\:font-extrabold{
    font-weight: 800 !important;
  }

  .md\\:font-black{
    font-weight: 900 !important;
  }

  .md\\:hover\\:font-light:hover{
    font-weight: 300 !important;
  }

  .md\\:hover\\:font-normal:hover{
    font-weight: 400 !important;
  }

  .md\\:hover\\:font-medium:hover{
    font-weight: 500 !important;
  }

  .md\\:hover\\:font-semibold:hover{
    font-weight: 600 !important;
  }

  .md\\:hover\\:font-bold:hover{
    font-weight: 700 !important;
  }

  .md\\:hover\\:font-extrabold:hover{
    font-weight: 800 !important;
  }

  .md\\:hover\\:font-black:hover{
    font-weight: 900 !important;
  }

  .md\\:h-1{
    height: 0.25rem !important;
  }

  .md\\:h-2{
    height: 0.5rem !important;
  }

  .md\\:h-3{
    height: 0.75rem !important;
  }

  .md\\:h-4{
    height: 1rem !important;
  }

  .md\\:h-5{
    height: 1.25rem !important;
  }

  .md\\:h-6{
    height: 1.5rem !important;
  }

  .md\\:h-8{
    height: 2rem !important;
  }

  .md\\:h-10{
    height: 2.5rem !important;
  }

  .md\\:h-12{
    height: 3rem !important;
  }

  .md\\:h-16{
    height: 4rem !important;
  }

  .md\\:h-24{
    height: 6rem !important;
  }

  .md\\:h-32{
    height: 8rem !important;
  }

  .md\\:h-48{
    height: 12rem !important;
  }

  .md\\:h-64{
    height: 16rem !important;
  }

  .md\\:h-auto{
    height: auto !important;
  }

  .md\\:h-px{
    height: 1px !important;
  }

  .md\\:h-full{
    height: 100% !important;
  }

  .md\\:h-screen{
    height: 100vh !important;
  }

  .md\\:text-xs{
    font-size: .75rem !important;
  }

  .md\\:text-sm{
    font-size: .875rem !important;
  }

  .md\\:text-base{
    font-size: 1rem !important;
  }

  .md\\:text-lg{
    font-size: 1.125rem !important;
  }

  .md\\:text-xl{
    font-size: 1.25rem !important;
  }

  .md\\:text-2xl{
    font-size: 1.5rem !important;
  }

  .md\\:text-3xl{
    font-size: 1.875rem !important;
  }

  .md\\:text-4xl{
    font-size: 2.25rem !important;
  }

  .md\\:text-5xl{
    font-size: 3rem !important;
  }

  .md\\:text-6xl{
    font-size: 4rem !important;
  }

  .md\\:leading-none{
    line-height: 1 !important;
  }

  .md\\:leading-tight{
    line-height: 1.25 !important;
  }

  .md\\:leading-normal{
    line-height: 1.5 !important;
  }

  .md\\:leading-loose{
    line-height: 2 !important;
  }

  .md\\:list-inside{
    list-style-position: inside !important;
  }

  .md\\:list-outside{
    list-style-position: outside !important;
  }

  [dir] .md\\:m-0{
    margin: 0 !important;
  }

  [dir] .md\\:m-1{
    margin: 0.25rem !important;
  }

  [dir] .md\\:m-2{
    margin: 0.5rem !important;
  }

  [dir] .md\\:m-3{
    margin: 0.75rem !important;
  }

  [dir] .md\\:m-4{
    margin: 1rem !important;
  }

  [dir] .md\\:m-5{
    margin: 1.25rem !important;
  }

  [dir] .md\\:m-6{
    margin: 1.5rem !important;
  }

  [dir] .md\\:m-8{
    margin: 2rem !important;
  }

  [dir] .md\\:m-10{
    margin: 2.5rem !important;
  }

  [dir] .md\\:m-12{
    margin: 3rem !important;
  }

  [dir] .md\\:m-16{
    margin: 4rem !important;
  }

  [dir] .md\\:m-20{
    margin: 5rem !important;
  }

  [dir] .md\\:m-24{
    margin: 6rem !important;
  }

  [dir] .md\\:m-32{
    margin: 8rem !important;
  }

  [dir] .md\\:m-auto{
    margin: auto !important;
  }

  [dir] .md\\:m-px{
    margin: 1px !important;
  }

  [dir] .md\\:m-base{
    margin: 2.2rem !important;
  }

  [dir] .md\\:-m-px{
    margin: -1px !important;
  }

  [dir] .md\\:-m-1{
    margin: -0.25rem !important;
  }

  [dir] .md\\:-m-2{
    margin: -0.5rem !important;
  }

  [dir] .md\\:-m-3{
    margin: -0.75rem !important;
  }

  [dir] .md\\:-m-4{
    margin: -1rem !important;
  }

  [dir] .md\\:my-0{
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  [dir=ltr] .md\\:mx-0{
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  [dir=rtl] .md\\:mx-0{
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  [dir] .md\\:my-1{
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  [dir=ltr] .md\\:mx-1{
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }

  [dir=rtl] .md\\:mx-1{
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  [dir] .md\\:my-2{
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  [dir=ltr] .md\\:mx-2{
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  [dir=rtl] .md\\:mx-2{
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  [dir] .md\\:my-3{
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  [dir=ltr] .md\\:mx-3{
    margin-left: 0.75rem !important;
    margin-right: 0.75rem !important;
  }

  [dir=rtl] .md\\:mx-3{
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  [dir] .md\\:my-4{
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  [dir=ltr] .md\\:mx-4{
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  [dir=rtl] .md\\:mx-4{
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  [dir] .md\\:my-5{
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  [dir=ltr] .md\\:mx-5{
    margin-left: 1.25rem !important;
    margin-right: 1.25rem !important;
  }

  [dir=rtl] .md\\:mx-5{
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  [dir] .md\\:my-6{
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  [dir=ltr] .md\\:mx-6{
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }

  [dir=rtl] .md\\:mx-6{
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  [dir] .md\\:my-8{
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  [dir=ltr] .md\\:mx-8{
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }

  [dir=rtl] .md\\:mx-8{
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  [dir] .md\\:my-10{
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  [dir=ltr] .md\\:mx-10{
    margin-left: 2.5rem !important;
    margin-right: 2.5rem !important;
  }

  [dir=rtl] .md\\:mx-10{
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  [dir] .md\\:my-12{
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  [dir=ltr] .md\\:mx-12{
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }

  [dir=rtl] .md\\:mx-12{
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  [dir] .md\\:my-16{
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  [dir=ltr] .md\\:mx-16{
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }

  [dir=rtl] .md\\:mx-16{
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  [dir] .md\\:my-20{
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  [dir=ltr] .md\\:mx-20{
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }

  [dir=rtl] .md\\:mx-20{
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  [dir] .md\\:my-24{
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }

  [dir=ltr] .md\\:mx-24{
    margin-left: 6rem !important;
    margin-right: 6rem !important;
  }

  [dir=rtl] .md\\:mx-24{
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }

  [dir] .md\\:my-32{
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }

  [dir=ltr] .md\\:mx-32{
    margin-left: 8rem !important;
    margin-right: 8rem !important;
  }

  [dir=rtl] .md\\:mx-32{
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }

  [dir] .md\\:my-auto{
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  [dir=ltr] .md\\:mx-auto{
    margin-left: auto !important;
    margin-right: auto !important;
  }

  [dir=rtl] .md\\:mx-auto{
    margin-right: auto !important;
    margin-left: auto !important;
  }

  [dir] .md\\:my-px{
    margin-top: 1px !important;
    margin-bottom: 1px !important;
  }

  [dir=ltr] .md\\:mx-px{
    margin-left: 1px !important;
    margin-right: 1px !important;
  }

  [dir=rtl] .md\\:mx-px{
    margin-right: 1px !important;
    margin-left: 1px !important;
  }

  [dir] .md\\:my-base{
    margin-top: 2.2rem !important;
    margin-bottom: 2.2rem !important;
  }

  [dir=ltr] .md\\:mx-base{
    margin-left: 2.2rem !important;
    margin-right: 2.2rem !important;
  }

  [dir=rtl] .md\\:mx-base{
    margin-right: 2.2rem !important;
    margin-left: 2.2rem !important;
  }

  [dir] .md\\:-my-px{
    margin-top: -1px !important;
    margin-bottom: -1px !important;
  }

  [dir=ltr] .md\\:-mx-px{
    margin-left: -1px !important;
    margin-right: -1px !important;
  }

  [dir=rtl] .md\\:-mx-px{
    margin-right: -1px !important;
    margin-left: -1px !important;
  }

  [dir] .md\\:-my-1{
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  [dir=ltr] .md\\:-mx-1{
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
  }

  [dir=rtl] .md\\:-mx-1{
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  [dir] .md\\:-my-2{
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  [dir=ltr] .md\\:-mx-2{
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }

  [dir=rtl] .md\\:-mx-2{
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  [dir] .md\\:-my-3{
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  [dir=ltr] .md\\:-mx-3{
    margin-left: -0.75rem !important;
    margin-right: -0.75rem !important;
  }

  [dir=rtl] .md\\:-mx-3{
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  [dir] .md\\:-my-4{
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  [dir=ltr] .md\\:-mx-4{
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }

  [dir=rtl] .md\\:-mx-4{
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  [dir] .md\\:mt-0{
    margin-top: 0 !important;
  }

  [dir=ltr] .md\\:mr-0{
    margin-right: 0 !important;
  }

  [dir=rtl] .md\\:mr-0{
    margin-left: 0 !important;
  }

  [dir] .md\\:mb-0{
    margin-bottom: 0 !important;
  }

  [dir=ltr] .md\\:ml-0{
    margin-left: 0 !important;
  }

  [dir=rtl] .md\\:ml-0{
    margin-right: 0 !important;
  }

  [dir] .md\\:mt-1{
    margin-top: 0.25rem !important;
  }

  [dir=ltr] .md\\:mr-1{
    margin-right: 0.25rem !important;
  }

  [dir=rtl] .md\\:mr-1{
    margin-left: 0.25rem !important;
  }

  [dir] .md\\:mb-1{
    margin-bottom: 0.25rem !important;
  }

  [dir=ltr] .md\\:ml-1{
    margin-left: 0.25rem !important;
  }

  [dir=rtl] .md\\:ml-1{
    margin-right: 0.25rem !important;
  }

  [dir] .md\\:mt-2{
    margin-top: 0.5rem !important;
  }

  [dir=ltr] .md\\:mr-2{
    margin-right: 0.5rem !important;
  }

  [dir=rtl] .md\\:mr-2{
    margin-left: 0.5rem !important;
  }

  [dir] .md\\:mb-2{
    margin-bottom: 0.5rem !important;
  }

  [dir=ltr] .md\\:ml-2{
    margin-left: 0.5rem !important;
  }

  [dir=rtl] .md\\:ml-2{
    margin-right: 0.5rem !important;
  }

  [dir] .md\\:mt-3{
    margin-top: 0.75rem !important;
  }

  [dir=ltr] .md\\:mr-3{
    margin-right: 0.75rem !important;
  }

  [dir=rtl] .md\\:mr-3{
    margin-left: 0.75rem !important;
  }

  [dir] .md\\:mb-3{
    margin-bottom: 0.75rem !important;
  }

  [dir=ltr] .md\\:ml-3{
    margin-left: 0.75rem !important;
  }

  [dir=rtl] .md\\:ml-3{
    margin-right: 0.75rem !important;
  }

  [dir] .md\\:mt-4{
    margin-top: 1rem !important;
  }

  [dir=ltr] .md\\:mr-4{
    margin-right: 1rem !important;
  }

  [dir=rtl] .md\\:mr-4{
    margin-left: 1rem !important;
  }

  [dir] .md\\:mb-4{
    margin-bottom: 1rem !important;
  }

  [dir=ltr] .md\\:ml-4{
    margin-left: 1rem !important;
  }

  [dir=rtl] .md\\:ml-4{
    margin-right: 1rem !important;
  }

  [dir] .md\\:mt-5{
    margin-top: 1.25rem !important;
  }

  [dir=ltr] .md\\:mr-5{
    margin-right: 1.25rem !important;
  }

  [dir=rtl] .md\\:mr-5{
    margin-left: 1.25rem !important;
  }

  [dir] .md\\:mb-5{
    margin-bottom: 1.25rem !important;
  }

  [dir=ltr] .md\\:ml-5{
    margin-left: 1.25rem !important;
  }

  [dir=rtl] .md\\:ml-5{
    margin-right: 1.25rem !important;
  }

  [dir] .md\\:mt-6{
    margin-top: 1.5rem !important;
  }

  [dir=ltr] .md\\:mr-6{
    margin-right: 1.5rem !important;
  }

  [dir=rtl] .md\\:mr-6{
    margin-left: 1.5rem !important;
  }

  [dir] .md\\:mb-6{
    margin-bottom: 1.5rem !important;
  }

  [dir=ltr] .md\\:ml-6{
    margin-left: 1.5rem !important;
  }

  [dir=rtl] .md\\:ml-6{
    margin-right: 1.5rem !important;
  }

  [dir] .md\\:mt-8{
    margin-top: 2rem !important;
  }

  [dir=ltr] .md\\:mr-8{
    margin-right: 2rem !important;
  }

  [dir=rtl] .md\\:mr-8{
    margin-left: 2rem !important;
  }

  [dir] .md\\:mb-8{
    margin-bottom: 2rem !important;
  }

  [dir=ltr] .md\\:ml-8{
    margin-left: 2rem !important;
  }

  [dir=rtl] .md\\:ml-8{
    margin-right: 2rem !important;
  }

  [dir] .md\\:mt-10{
    margin-top: 2.5rem !important;
  }

  [dir=ltr] .md\\:mr-10{
    margin-right: 2.5rem !important;
  }

  [dir=rtl] .md\\:mr-10{
    margin-left: 2.5rem !important;
  }

  [dir] .md\\:mb-10{
    margin-bottom: 2.5rem !important;
  }

  [dir=ltr] .md\\:ml-10{
    margin-left: 2.5rem !important;
  }

  [dir=rtl] .md\\:ml-10{
    margin-right: 2.5rem !important;
  }

  [dir] .md\\:mt-12{
    margin-top: 3rem !important;
  }

  [dir=ltr] .md\\:mr-12{
    margin-right: 3rem !important;
  }

  [dir=rtl] .md\\:mr-12{
    margin-left: 3rem !important;
  }

  [dir] .md\\:mb-12{
    margin-bottom: 3rem !important;
  }

  [dir=ltr] .md\\:ml-12{
    margin-left: 3rem !important;
  }

  [dir=rtl] .md\\:ml-12{
    margin-right: 3rem !important;
  }

  [dir] .md\\:mt-16{
    margin-top: 4rem !important;
  }

  [dir=ltr] .md\\:mr-16{
    margin-right: 4rem !important;
  }

  [dir=rtl] .md\\:mr-16{
    margin-left: 4rem !important;
  }

  [dir] .md\\:mb-16{
    margin-bottom: 4rem !important;
  }

  [dir=ltr] .md\\:ml-16{
    margin-left: 4rem !important;
  }

  [dir=rtl] .md\\:ml-16{
    margin-right: 4rem !important;
  }

  [dir] .md\\:mt-20{
    margin-top: 5rem !important;
  }

  [dir=ltr] .md\\:mr-20{
    margin-right: 5rem !important;
  }

  [dir=rtl] .md\\:mr-20{
    margin-left: 5rem !important;
  }

  [dir] .md\\:mb-20{
    margin-bottom: 5rem !important;
  }

  [dir=ltr] .md\\:ml-20{
    margin-left: 5rem !important;
  }

  [dir=rtl] .md\\:ml-20{
    margin-right: 5rem !important;
  }

  [dir] .md\\:mt-24{
    margin-top: 6rem !important;
  }

  [dir=ltr] .md\\:mr-24{
    margin-right: 6rem !important;
  }

  [dir=rtl] .md\\:mr-24{
    margin-left: 6rem !important;
  }

  [dir] .md\\:mb-24{
    margin-bottom: 6rem !important;
  }

  [dir=ltr] .md\\:ml-24{
    margin-left: 6rem !important;
  }

  [dir=rtl] .md\\:ml-24{
    margin-right: 6rem !important;
  }

  [dir] .md\\:mt-32{
    margin-top: 8rem !important;
  }

  [dir=ltr] .md\\:mr-32{
    margin-right: 8rem !important;
  }

  [dir=rtl] .md\\:mr-32{
    margin-left: 8rem !important;
  }

  [dir] .md\\:mb-32{
    margin-bottom: 8rem !important;
  }

  [dir=ltr] .md\\:ml-32{
    margin-left: 8rem !important;
  }

  [dir=rtl] .md\\:ml-32{
    margin-right: 8rem !important;
  }

  [dir] .md\\:mt-auto{
    margin-top: auto !important;
  }

  [dir=ltr] .md\\:mr-auto{
    margin-right: auto !important;
  }

  [dir=rtl] .md\\:mr-auto{
    margin-left: auto !important;
  }

  [dir] .md\\:mb-auto{
    margin-bottom: auto !important;
  }

  [dir=ltr] .md\\:ml-auto{
    margin-left: auto !important;
  }

  [dir=rtl] .md\\:ml-auto{
    margin-right: auto !important;
  }

  [dir] .md\\:mt-px{
    margin-top: 1px !important;
  }

  [dir=ltr] .md\\:mr-px{
    margin-right: 1px !important;
  }

  [dir=rtl] .md\\:mr-px{
    margin-left: 1px !important;
  }

  [dir] .md\\:mb-px{
    margin-bottom: 1px !important;
  }

  [dir=ltr] .md\\:ml-px{
    margin-left: 1px !important;
  }

  [dir=rtl] .md\\:ml-px{
    margin-right: 1px !important;
  }

  [dir] .md\\:mt-base{
    margin-top: 2.2rem !important;
  }

  [dir=ltr] .md\\:mr-base{
    margin-right: 2.2rem !important;
  }

  [dir=rtl] .md\\:mr-base{
    margin-left: 2.2rem !important;
  }

  [dir] .md\\:mb-base{
    margin-bottom: 2.2rem !important;
  }

  [dir=ltr] .md\\:ml-base{
    margin-left: 2.2rem !important;
  }

  [dir=rtl] .md\\:ml-base{
    margin-right: 2.2rem !important;
  }

  [dir] .md\\:-mt-px{
    margin-top: -1px !important;
  }

  [dir=ltr] .md\\:-mr-px{
    margin-right: -1px !important;
  }

  [dir=rtl] .md\\:-mr-px{
    margin-left: -1px !important;
  }

  [dir] .md\\:-mb-px{
    margin-bottom: -1px !important;
  }

  [dir=ltr] .md\\:-ml-px{
    margin-left: -1px !important;
  }

  [dir=rtl] .md\\:-ml-px{
    margin-right: -1px !important;
  }

  [dir] .md\\:-mt-1{
    margin-top: -0.25rem !important;
  }

  [dir=ltr] .md\\:-mr-1{
    margin-right: -0.25rem !important;
  }

  [dir=rtl] .md\\:-mr-1{
    margin-left: -0.25rem !important;
  }

  [dir] .md\\:-mb-1{
    margin-bottom: -0.25rem !important;
  }

  [dir=ltr] .md\\:-ml-1{
    margin-left: -0.25rem !important;
  }

  [dir=rtl] .md\\:-ml-1{
    margin-right: -0.25rem !important;
  }

  [dir] .md\\:-mt-2{
    margin-top: -0.5rem !important;
  }

  [dir=ltr] .md\\:-mr-2{
    margin-right: -0.5rem !important;
  }

  [dir=rtl] .md\\:-mr-2{
    margin-left: -0.5rem !important;
  }

  [dir] .md\\:-mb-2{
    margin-bottom: -0.5rem !important;
  }

  [dir=ltr] .md\\:-ml-2{
    margin-left: -0.5rem !important;
  }

  [dir=rtl] .md\\:-ml-2{
    margin-right: -0.5rem !important;
  }

  [dir] .md\\:-mt-3{
    margin-top: -0.75rem !important;
  }

  [dir=ltr] .md\\:-mr-3{
    margin-right: -0.75rem !important;
  }

  [dir=rtl] .md\\:-mr-3{
    margin-left: -0.75rem !important;
  }

  [dir] .md\\:-mb-3{
    margin-bottom: -0.75rem !important;
  }

  [dir=ltr] .md\\:-ml-3{
    margin-left: -0.75rem !important;
  }

  [dir=rtl] .md\\:-ml-3{
    margin-right: -0.75rem !important;
  }

  [dir] .md\\:-mt-4{
    margin-top: -1rem !important;
  }

  [dir=ltr] .md\\:-mr-4{
    margin-right: -1rem !important;
  }

  [dir=rtl] .md\\:-mr-4{
    margin-left: -1rem !important;
  }

  [dir] .md\\:-mb-4{
    margin-bottom: -1rem !important;
  }

  [dir=ltr] .md\\:-ml-4{
    margin-left: -1rem !important;
  }

  [dir=rtl] .md\\:-ml-4{
    margin-right: -1rem !important;
  }

  .md\\:max-h-full{
    max-height: 100% !important;
  }

  .md\\:max-h-screen{
    max-height: 100vh !important;
  }

  .md\\:max-w-xs{
    max-width: 20rem !important;
  }

  .md\\:max-w-sm{
    max-width: 30rem !important;
  }

  .md\\:max-w-md{
    max-width: 40rem !important;
  }

  .md\\:max-w-lg{
    max-width: 50rem !important;
  }

  .md\\:max-w-xl{
    max-width: 60rem !important;
  }

  .md\\:max-w-2xl{
    max-width: 70rem !important;
  }

  .md\\:max-w-3xl{
    max-width: 80rem !important;
  }

  .md\\:max-w-4xl{
    max-width: 90rem !important;
  }

  .md\\:max-w-5xl{
    max-width: 100rem !important;
  }

  .md\\:max-w-full{
    max-width: 100% !important;
  }

  .md\\:min-h-0{
    min-height: 0 !important;
  }

  .md\\:min-h-full{
    min-height: 100% !important;
  }

  .md\\:min-h-screen{
    min-height: 100vh !important;
  }

  .md\\:min-w-0{
    min-width: 0 !important;
  }

  .md\\:min-w-full{
    min-width: 100% !important;
  }

  .md\\:object-contain{
    object-fit: contain !important;
  }

  .md\\:object-cover{
    object-fit: cover !important;
  }

  .md\\:object-fill{
    object-fit: fill !important;
  }

  .md\\:object-none{
    object-fit: none !important;
  }

  .md\\:object-scale-down{
    object-fit: scale-down !important;
  }

  .md\\:object-bottom{
    object-position: bottom !important;
  }

  .md\\:object-center{
    object-position: center !important;
  }

  .md\\:object-left{
    object-position: left !important;
  }

  .md\\:object-left-bottom{
    object-position: left bottom !important;
  }

  .md\\:object-left-top{
    object-position: left top !important;
  }

  .md\\:object-right{
    object-position: right !important;
  }

  .md\\:object-right-bottom{
    object-position: right bottom !important;
  }

  .md\\:object-right-top{
    object-position: right top !important;
  }

  .md\\:object-top{
    object-position: top !important;
  }

  .md\\:opacity-0{
    opacity: 0 !important;
  }

  .md\\:opacity-25{
    opacity: 0.25 !important;
  }

  .md\\:opacity-50{
    opacity: 0.5 !important;
  }

  .md\\:opacity-75{
    opacity: 0.75 !important;
  }

  .md\\:opacity-100{
    opacity: 1 !important;
  }

  .md\\:overflow-auto{
    overflow: auto !important;
  }

  .md\\:overflow-hidden{
    overflow: hidden !important;
  }

  .md\\:overflow-visible{
    overflow: visible !important;
  }

  .md\\:overflow-scroll{
    overflow: scroll !important;
  }

  .md\\:overflow-x-auto{
    overflow-x: auto !important;
  }

  .md\\:overflow-y-auto{
    overflow-y: auto !important;
  }

  .md\\:overflow-x-hidden{
    overflow-x: hidden !important;
  }

  .md\\:overflow-y-hidden{
    overflow-y: hidden !important;
  }

  .md\\:overflow-x-visible{
    overflow-x: visible !important;
  }

  .md\\:overflow-y-visible{
    overflow-y: visible !important;
  }

  .md\\:overflow-x-scroll{
    overflow-x: scroll !important;
  }

  .md\\:overflow-y-scroll{
    overflow-y: scroll !important;
  }

  .md\\:scrolling-touch{
    -webkit-overflow-scrolling: touch !important;
  }

  .md\\:scrolling-auto{
    -webkit-overflow-scrolling: auto !important;
  }

  .md\\:overscroll-auto{
    overscroll-behavior: auto !important;
  }

  .md\\:overscroll-contain{
    overscroll-behavior: contain !important;
  }

  .md\\:overscroll-none{
    overscroll-behavior: none !important;
  }

  .md\\:overscroll-y-auto{
    overscroll-behavior-y: auto !important;
  }

  .md\\:overscroll-y-contain{
    overscroll-behavior-y: contain !important;
  }

  .md\\:overscroll-y-none{
    overscroll-behavior-y: none !important;
  }

  .md\\:overscroll-x-auto{
    overscroll-behavior-x: auto !important;
  }

  .md\\:overscroll-x-contain{
    overscroll-behavior-x: contain !important;
  }

  .md\\:overscroll-x-none{
    overscroll-behavior-x: none !important;
  }

  [dir] .md\\:p-0{
    padding: 0 !important;
  }

  [dir] .md\\:p-1{
    padding: 0.25rem !important;
  }

  [dir] .md\\:p-2{
    padding: 0.5rem !important;
  }

  [dir] .md\\:p-3{
    padding: 0.75rem !important;
  }

  [dir] .md\\:p-4{
    padding: 1rem !important;
  }

  [dir] .md\\:p-5{
    padding: 1.25rem !important;
  }

  [dir] .md\\:p-6{
    padding: 1.5rem !important;
  }

  [dir] .md\\:p-8{
    padding: 2rem !important;
  }

  [dir] .md\\:p-10{
    padding: 2.5rem !important;
  }

  [dir] .md\\:p-12{
    padding: 3rem !important;
  }

  [dir] .md\\:p-16{
    padding: 4rem !important;
  }

  [dir] .md\\:p-20{
    padding: 5rem !important;
  }

  [dir] .md\\:p-24{
    padding: 6rem !important;
  }

  [dir] .md\\:p-32{
    padding: 8rem !important;
  }

  [dir] .md\\:p-px{
    padding: 1px !important;
  }

  [dir] .md\\:p-base{
    padding: 2.2rem !important;
  }

  [dir] .md\\:py-0{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  [dir=ltr] .md\\:px-0{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  [dir=rtl] .md\\:px-0{
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  [dir] .md\\:py-1{
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  [dir=ltr] .md\\:px-1{
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }

  [dir=rtl] .md\\:px-1{
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  [dir] .md\\:py-2{
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  [dir=ltr] .md\\:px-2{
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  [dir=rtl] .md\\:px-2{
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  [dir] .md\\:py-3{
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  [dir=ltr] .md\\:px-3{
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }

  [dir=rtl] .md\\:px-3{
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  [dir] .md\\:py-4{
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  [dir=ltr] .md\\:px-4{
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  [dir=rtl] .md\\:px-4{
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  [dir] .md\\:py-5{
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  [dir=ltr] .md\\:px-5{
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }

  [dir=rtl] .md\\:px-5{
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  [dir] .md\\:py-6{
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  [dir=ltr] .md\\:px-6{
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  [dir=rtl] .md\\:px-6{
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  [dir] .md\\:py-8{
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  [dir=ltr] .md\\:px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  [dir=rtl] .md\\:px-8{
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  [dir] .md\\:py-10{
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  [dir=ltr] .md\\:px-10{
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  [dir=rtl] .md\\:px-10{
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  [dir] .md\\:py-12{
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  [dir=ltr] .md\\:px-12{
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }

  [dir=rtl] .md\\:px-12{
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  [dir] .md\\:py-16{
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  [dir=ltr] .md\\:px-16{
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }

  [dir=rtl] .md\\:px-16{
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  [dir] .md\\:py-20{
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  [dir=ltr] .md\\:px-20{
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }

  [dir=rtl] .md\\:px-20{
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  [dir] .md\\:py-24{
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }

  [dir=ltr] .md\\:px-24{
    padding-left: 6rem !important;
    padding-right: 6rem !important;
  }

  [dir=rtl] .md\\:px-24{
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }

  [dir] .md\\:py-32{
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }

  [dir=ltr] .md\\:px-32{
    padding-left: 8rem !important;
    padding-right: 8rem !important;
  }

  [dir=rtl] .md\\:px-32{
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }

  [dir] .md\\:py-px{
    padding-top: 1px !important;
    padding-bottom: 1px !important;
  }

  [dir=ltr] .md\\:px-px{
    padding-left: 1px !important;
    padding-right: 1px !important;
  }

  [dir=rtl] .md\\:px-px{
    padding-right: 1px !important;
    padding-left: 1px !important;
  }

  [dir] .md\\:py-base{
    padding-top: 2.2rem !important;
    padding-bottom: 2.2rem !important;
  }

  [dir=ltr] .md\\:px-base{
    padding-left: 2.2rem !important;
    padding-right: 2.2rem !important;
  }

  [dir=rtl] .md\\:px-base{
    padding-right: 2.2rem !important;
    padding-left: 2.2rem !important;
  }

  [dir] .md\\:pt-0{
    padding-top: 0 !important;
  }

  [dir=ltr] .md\\:pr-0{
    padding-right: 0 !important;
  }

  [dir=rtl] .md\\:pr-0{
    padding-left: 0 !important;
  }

  [dir] .md\\:pb-0{
    padding-bottom: 0 !important;
  }

  [dir=ltr] .md\\:pl-0{
    padding-left: 0 !important;
  }

  [dir=rtl] .md\\:pl-0{
    padding-right: 0 !important;
  }

  [dir] .md\\:pt-1{
    padding-top: 0.25rem !important;
  }

  [dir=ltr] .md\\:pr-1{
    padding-right: 0.25rem !important;
  }

  [dir=rtl] .md\\:pr-1{
    padding-left: 0.25rem !important;
  }

  [dir] .md\\:pb-1{
    padding-bottom: 0.25rem !important;
  }

  [dir=ltr] .md\\:pl-1{
    padding-left: 0.25rem !important;
  }

  [dir=rtl] .md\\:pl-1{
    padding-right: 0.25rem !important;
  }

  [dir] .md\\:pt-2{
    padding-top: 0.5rem !important;
  }

  [dir=ltr] .md\\:pr-2{
    padding-right: 0.5rem !important;
  }

  [dir=rtl] .md\\:pr-2{
    padding-left: 0.5rem !important;
  }

  [dir] .md\\:pb-2{
    padding-bottom: 0.5rem !important;
  }

  [dir=ltr] .md\\:pl-2{
    padding-left: 0.5rem !important;
  }

  [dir=rtl] .md\\:pl-2{
    padding-right: 0.5rem !important;
  }

  [dir] .md\\:pt-3{
    padding-top: 0.75rem !important;
  }

  [dir=ltr] .md\\:pr-3{
    padding-right: 0.75rem !important;
  }

  [dir=rtl] .md\\:pr-3{
    padding-left: 0.75rem !important;
  }

  [dir] .md\\:pb-3{
    padding-bottom: 0.75rem !important;
  }

  [dir=ltr] .md\\:pl-3{
    padding-left: 0.75rem !important;
  }

  [dir=rtl] .md\\:pl-3{
    padding-right: 0.75rem !important;
  }

  [dir] .md\\:pt-4{
    padding-top: 1rem !important;
  }

  [dir=ltr] .md\\:pr-4{
    padding-right: 1rem !important;
  }

  [dir=rtl] .md\\:pr-4{
    padding-left: 1rem !important;
  }

  [dir] .md\\:pb-4{
    padding-bottom: 1rem !important;
  }

  [dir=ltr] .md\\:pl-4{
    padding-left: 1rem !important;
  }

  [dir=rtl] .md\\:pl-4{
    padding-right: 1rem !important;
  }

  [dir] .md\\:pt-5{
    padding-top: 1.25rem !important;
  }

  [dir=ltr] .md\\:pr-5{
    padding-right: 1.25rem !important;
  }

  [dir=rtl] .md\\:pr-5{
    padding-left: 1.25rem !important;
  }

  [dir] .md\\:pb-5{
    padding-bottom: 1.25rem !important;
  }

  [dir=ltr] .md\\:pl-5{
    padding-left: 1.25rem !important;
  }

  [dir=rtl] .md\\:pl-5{
    padding-right: 1.25rem !important;
  }

  [dir] .md\\:pt-6{
    padding-top: 1.5rem !important;
  }

  [dir=ltr] .md\\:pr-6{
    padding-right: 1.5rem !important;
  }

  [dir=rtl] .md\\:pr-6{
    padding-left: 1.5rem !important;
  }

  [dir] .md\\:pb-6{
    padding-bottom: 1.5rem !important;
  }

  [dir=ltr] .md\\:pl-6{
    padding-left: 1.5rem !important;
  }

  [dir=rtl] .md\\:pl-6{
    padding-right: 1.5rem !important;
  }

  [dir] .md\\:pt-8{
    padding-top: 2rem !important;
  }

  [dir=ltr] .md\\:pr-8{
    padding-right: 2rem !important;
  }

  [dir=rtl] .md\\:pr-8{
    padding-left: 2rem !important;
  }

  [dir] .md\\:pb-8{
    padding-bottom: 2rem !important;
  }

  [dir=ltr] .md\\:pl-8{
    padding-left: 2rem !important;
  }

  [dir=rtl] .md\\:pl-8{
    padding-right: 2rem !important;
  }

  [dir] .md\\:pt-10{
    padding-top: 2.5rem !important;
  }

  [dir=ltr] .md\\:pr-10{
    padding-right: 2.5rem !important;
  }

  [dir=rtl] .md\\:pr-10{
    padding-left: 2.5rem !important;
  }

  [dir] .md\\:pb-10{
    padding-bottom: 2.5rem !important;
  }

  [dir=ltr] .md\\:pl-10{
    padding-left: 2.5rem !important;
  }

  [dir=rtl] .md\\:pl-10{
    padding-right: 2.5rem !important;
  }

  [dir] .md\\:pt-12{
    padding-top: 3rem !important;
  }

  [dir=ltr] .md\\:pr-12{
    padding-right: 3rem !important;
  }

  [dir=rtl] .md\\:pr-12{
    padding-left: 3rem !important;
  }

  [dir] .md\\:pb-12{
    padding-bottom: 3rem !important;
  }

  [dir=ltr] .md\\:pl-12{
    padding-left: 3rem !important;
  }

  [dir=rtl] .md\\:pl-12{
    padding-right: 3rem !important;
  }

  [dir] .md\\:pt-16{
    padding-top: 4rem !important;
  }

  [dir=ltr] .md\\:pr-16{
    padding-right: 4rem !important;
  }

  [dir=rtl] .md\\:pr-16{
    padding-left: 4rem !important;
  }

  [dir] .md\\:pb-16{
    padding-bottom: 4rem !important;
  }

  [dir=ltr] .md\\:pl-16{
    padding-left: 4rem !important;
  }

  [dir=rtl] .md\\:pl-16{
    padding-right: 4rem !important;
  }

  [dir] .md\\:pt-20{
    padding-top: 5rem !important;
  }

  [dir=ltr] .md\\:pr-20{
    padding-right: 5rem !important;
  }

  [dir=rtl] .md\\:pr-20{
    padding-left: 5rem !important;
  }

  [dir] .md\\:pb-20{
    padding-bottom: 5rem !important;
  }

  [dir=ltr] .md\\:pl-20{
    padding-left: 5rem !important;
  }

  [dir=rtl] .md\\:pl-20{
    padding-right: 5rem !important;
  }

  [dir] .md\\:pt-24{
    padding-top: 6rem !important;
  }

  [dir=ltr] .md\\:pr-24{
    padding-right: 6rem !important;
  }

  [dir=rtl] .md\\:pr-24{
    padding-left: 6rem !important;
  }

  [dir] .md\\:pb-24{
    padding-bottom: 6rem !important;
  }

  [dir=ltr] .md\\:pl-24{
    padding-left: 6rem !important;
  }

  [dir=rtl] .md\\:pl-24{
    padding-right: 6rem !important;
  }

  [dir] .md\\:pt-32{
    padding-top: 8rem !important;
  }

  [dir=ltr] .md\\:pr-32{
    padding-right: 8rem !important;
  }

  [dir=rtl] .md\\:pr-32{
    padding-left: 8rem !important;
  }

  [dir] .md\\:pb-32{
    padding-bottom: 8rem !important;
  }

  [dir=ltr] .md\\:pl-32{
    padding-left: 8rem !important;
  }

  [dir=rtl] .md\\:pl-32{
    padding-right: 8rem !important;
  }

  [dir] .md\\:pt-px{
    padding-top: 1px !important;
  }

  [dir=ltr] .md\\:pr-px{
    padding-right: 1px !important;
  }

  [dir=rtl] .md\\:pr-px{
    padding-left: 1px !important;
  }

  [dir] .md\\:pb-px{
    padding-bottom: 1px !important;
  }

  [dir=ltr] .md\\:pl-px{
    padding-left: 1px !important;
  }

  [dir=rtl] .md\\:pl-px{
    padding-right: 1px !important;
  }

  [dir] .md\\:pt-base{
    padding-top: 2.2rem !important;
  }

  [dir=ltr] .md\\:pr-base{
    padding-right: 2.2rem !important;
  }

  [dir=rtl] .md\\:pr-base{
    padding-left: 2.2rem !important;
  }

  [dir] .md\\:pb-base{
    padding-bottom: 2.2rem !important;
  }

  [dir=ltr] .md\\:pl-base{
    padding-left: 2.2rem !important;
  }

  [dir=rtl] .md\\:pl-base{
    padding-right: 2.2rem !important;
  }

  .md\\:placeholder-transparent::placeholder{
    color: transparent !important;
  }

  .md\\:placeholder-black::placeholder{
    --placeholder-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--placeholder-opacity)) !important;
  }

  .md\\:placeholder-white::placeholder{
    --placeholder-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--placeholder-opacity)) !important;
  }

  .md\\:placeholder-grey::placeholder{
    --placeholder-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--placeholder-opacity)) !important;
  }

  .md\\:placeholder-grey-light::placeholder{
    --placeholder-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--placeholder-opacity)) !important;
  }

  .md\\:focus\\:placeholder-transparent:focus::placeholder{
    color: transparent !important;
  }

  .md\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--placeholder-opacity)) !important;
  }

  .md\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--placeholder-opacity)) !important;
  }

  .md\\:focus\\:placeholder-grey:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--placeholder-opacity)) !important;
  }

  .md\\:focus\\:placeholder-grey-light:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--placeholder-opacity)) !important;
  }

  .md\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity: 0 !important;
  }

  .md\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity: 0.25 !important;
  }

  .md\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity: 0.5 !important;
  }

  .md\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity: 0.75 !important;
  }

  .md\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity: 1 !important;
  }

  .md\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity: 0 !important;
  }

  .md\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity: 0.25 !important;
  }

  .md\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity: 0.5 !important;
  }

  .md\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity: 0.75 !important;
  }

  .md\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity: 1 !important;
  }

  .md\\:pointer-events-none{
    pointer-events: none !important;
  }

  .md\\:pointer-events-auto{
    pointer-events: auto !important;
  }

  .md\\:static{
    position: static !important;
  }

  .md\\:fixed{
    position: fixed !important;
  }

  .md\\:absolute{
    position: absolute !important;
  }

  .md\\:relative{
    position: relative !important;
  }

  .md\\:sticky{
    position: sticky !important;
  }

  .md\\:inset-0{
    top: 0 !important;
    bottom: 0 !important;
  }

  [dir=ltr] .md\\:inset-0{
    right: 0 !important;
    left: 0 !important;
  }

  [dir=rtl] .md\\:inset-0{
    left: 0 !important;
    right: 0 !important;
  }

  .md\\:inset-auto{
    top: auto !important;
    bottom: auto !important;
  }

  [dir=ltr] .md\\:inset-auto{
    right: auto !important;
    left: auto !important;
  }

  [dir=rtl] .md\\:inset-auto{
    left: auto !important;
    right: auto !important;
  }

  .md\\:inset-y-0{
    top: 0 !important;
    bottom: 0 !important;
  }

  [dir=ltr] .md\\:inset-x-0{
    right: 0 !important;
    left: 0 !important;
  }

  [dir=rtl] .md\\:inset-x-0{
    left: 0 !important;
    right: 0 !important;
  }

  .md\\:inset-y-auto{
    top: auto !important;
    bottom: auto !important;
  }

  [dir=ltr] .md\\:inset-x-auto{
    right: auto !important;
    left: auto !important;
  }

  [dir=rtl] .md\\:inset-x-auto{
    left: auto !important;
    right: auto !important;
  }

  .md\\:top-0{
    top: 0 !important;
  }

  [dir=ltr] .md\\:right-0{
    right: 0 !important;
  }

  [dir=rtl] .md\\:right-0{
    left: 0 !important;
  }

  .md\\:bottom-0{
    bottom: 0 !important;
  }

  [dir=ltr] .md\\:left-0{
    left: 0 !important;
  }

  [dir=rtl] .md\\:left-0{
    right: 0 !important;
  }

  .md\\:top-auto{
    top: auto !important;
  }

  [dir=ltr] .md\\:right-auto{
    right: auto !important;
  }

  [dir=rtl] .md\\:right-auto{
    left: auto !important;
  }

  .md\\:bottom-auto{
    bottom: auto !important;
  }

  [dir=ltr] .md\\:left-auto{
    left: auto !important;
  }

  [dir=rtl] .md\\:left-auto{
    right: auto !important;
  }

  .md\\:resize-none{
    resize: none !important;
  }

  .md\\:resize-y{
    resize: vertical !important;
  }

  .md\\:resize-x{
    resize: horizontal !important;
  }

  .md\\:resize{
    resize: both !important;
  }

  [dir] .md\\:shadow{
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
  }

  [dir] .md\\:shadow-md{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .md\\:shadow-lg{
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .md\\:shadow-inner{
    box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
  }

  [dir] .md\\:shadow-xl{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  [dir] .md\\:shadow-2xl{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }

  [dir] .md\\:shadow-outline{
    box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
  }

  [dir] .md\\:shadow-none{
    box-shadow: none !important;
  }

  [dir] .md\\:shadow-drop{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
  }

  [dir] .md\\:hover\\:shadow:hover{
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
  }

  [dir] .md\\:hover\\:shadow-md:hover{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .md\\:hover\\:shadow-lg:hover{
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .md\\:hover\\:shadow-inner:hover{
    box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
  }

  [dir] .md\\:hover\\:shadow-xl:hover{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  [dir] .md\\:hover\\:shadow-2xl:hover{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }

  [dir] .md\\:hover\\:shadow-outline:hover{
    box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
  }

  [dir] .md\\:hover\\:shadow-none:hover{
    box-shadow: none !important;
  }

  [dir] .md\\:hover\\:shadow-drop:hover{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
  }

  [dir] .md\\:focus\\:shadow:focus{
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
  }

  [dir] .md\\:focus\\:shadow-md:focus{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .md\\:focus\\:shadow-lg:focus{
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .md\\:focus\\:shadow-inner:focus{
    box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
  }

  [dir] .md\\:focus\\:shadow-xl:focus{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  [dir] .md\\:focus\\:shadow-2xl:focus{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }

  [dir] .md\\:focus\\:shadow-outline:focus{
    box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
  }

  [dir] .md\\:focus\\:shadow-none:focus{
    box-shadow: none !important;
  }

  [dir] .md\\:focus\\:shadow-drop:focus{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
  }

  .md\\:stroke-0{
    stroke-width: 0 !important;
  }

  .md\\:stroke-1{
    stroke-width: 1 !important;
  }

  .md\\:stroke-2{
    stroke-width: 2 !important;
  }

  .md\\:table-auto{
    table-layout: auto !important;
  }

  .md\\:table-fixed{
    table-layout: fixed !important;
  }

  [dir=ltr] .md\\:text-left{
    text-align: left !important;
  }

  [dir=rtl] .md\\:text-left{
    text-align: right !important;
  }

  [dir] .md\\:text-center{
    text-align: center !important;
  }

  [dir=ltr] .md\\:text-right{
    text-align: right !important;
  }

  [dir=rtl] .md\\:text-right{
    text-align: left !important;
  }

  [dir] .md\\:text-justify{
    text-align: justify !important;
  }

  .md\\:text-inherit{
    color: inherit !important;
  }

  .md\\:text-transparent{
    color: transparent !important;
  }

  .md\\:text-black{
    --text-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--text-opacity)) !important;
  }

  .md\\:text-white{
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }

  .md\\:text-grey{
    --text-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--text-opacity)) !important;
  }

  .md\\:text-grey-light{
    --text-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--text-opacity)) !important;
  }

  .md\\:hover\\:text-inherit:hover{
    color: inherit !important;
  }

  .md\\:hover\\:text-transparent:hover{
    color: transparent !important;
  }

  .md\\:hover\\:text-black:hover{
    --text-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--text-opacity)) !important;
  }

  .md\\:hover\\:text-white:hover{
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }

  .md\\:hover\\:text-grey:hover{
    --text-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--text-opacity)) !important;
  }

  .md\\:hover\\:text-grey-light:hover{
    --text-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--text-opacity)) !important;
  }

  .md\\:focus\\:text-inherit:focus{
    color: inherit !important;
  }

  .md\\:focus\\:text-transparent:focus{
    color: transparent !important;
  }

  .md\\:focus\\:text-black:focus{
    --text-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--text-opacity)) !important;
  }

  .md\\:focus\\:text-white:focus{
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }

  .md\\:focus\\:text-grey:focus{
    --text-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--text-opacity)) !important;
  }

  .md\\:focus\\:text-grey-light:focus{
    --text-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--text-opacity)) !important;
  }

  .md\\:text-opacity-0{
    --text-opacity: 0 !important;
  }

  .md\\:text-opacity-25{
    --text-opacity: 0.25 !important;
  }

  .md\\:text-opacity-50{
    --text-opacity: 0.5 !important;
  }

  .md\\:text-opacity-75{
    --text-opacity: 0.75 !important;
  }

  .md\\:text-opacity-100{
    --text-opacity: 1 !important;
  }

  .md\\:hover\\:text-opacity-0:hover{
    --text-opacity: 0 !important;
  }

  .md\\:hover\\:text-opacity-25:hover{
    --text-opacity: 0.25 !important;
  }

  .md\\:hover\\:text-opacity-50:hover{
    --text-opacity: 0.5 !important;
  }

  .md\\:hover\\:text-opacity-75:hover{
    --text-opacity: 0.75 !important;
  }

  .md\\:hover\\:text-opacity-100:hover{
    --text-opacity: 1 !important;
  }

  .md\\:focus\\:text-opacity-0:focus{
    --text-opacity: 0 !important;
  }

  .md\\:focus\\:text-opacity-25:focus{
    --text-opacity: 0.25 !important;
  }

  .md\\:focus\\:text-opacity-50:focus{
    --text-opacity: 0.5 !important;
  }

  .md\\:focus\\:text-opacity-75:focus{
    --text-opacity: 0.75 !important;
  }

  .md\\:focus\\:text-opacity-100:focus{
    --text-opacity: 1 !important;
  }

  .md\\:italic{
    font-style: italic !important;
  }

  .md\\:not-italic{
    font-style: normal !important;
  }

  .md\\:hover\\:italic:hover{
    font-style: italic !important;
  }

  .md\\:hover\\:not-italic:hover{
    font-style: normal !important;
  }

  .md\\:focus\\:italic:focus{
    font-style: italic !important;
  }

  .md\\:focus\\:not-italic:focus{
    font-style: normal !important;
  }

  .md\\:uppercase{
    text-transform: uppercase !important;
  }

  .md\\:lowercase{
    text-transform: lowercase !important;
  }

  .md\\:capitalize{
    text-transform: capitalize !important;
  }

  .md\\:normal-case{
    text-transform: none !important;
  }

  .md\\:hover\\:uppercase:hover{
    text-transform: uppercase !important;
  }

  .md\\:hover\\:lowercase:hover{
    text-transform: lowercase !important;
  }

  .md\\:hover\\:capitalize:hover{
    text-transform: capitalize !important;
  }

  .md\\:hover\\:normal-case:hover{
    text-transform: none !important;
  }

  .md\\:focus\\:uppercase:focus{
    text-transform: uppercase !important;
  }

  .md\\:focus\\:lowercase:focus{
    text-transform: lowercase !important;
  }

  .md\\:focus\\:capitalize:focus{
    text-transform: capitalize !important;
  }

  .md\\:focus\\:normal-case:focus{
    text-transform: none !important;
  }

  .md\\:underline{
    text-decoration: underline !important;
  }

  .md\\:line-through{
    text-decoration: line-through !important;
  }

  .md\\:no-underline{
    text-decoration: none !important;
  }

  .md\\:hover\\:underline:hover{
    text-decoration: underline !important;
  }

  .md\\:hover\\:line-through:hover{
    text-decoration: line-through !important;
  }

  .md\\:hover\\:no-underline:hover{
    text-decoration: none !important;
  }

  .md\\:focus\\:underline:focus{
    text-decoration: underline !important;
  }

  .md\\:focus\\:line-through:focus{
    text-decoration: line-through !important;
  }

  .md\\:focus\\:no-underline:focus{
    text-decoration: none !important;
  }

  .md\\:antialiased{
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }

  .md\\:subpixel-antialiased{
    -webkit-font-smoothing: auto !important;
    -moz-osx-font-smoothing: auto !important;
  }

  .md\\:hover\\:antialiased:hover{
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }

  .md\\:hover\\:subpixel-antialiased:hover{
    -webkit-font-smoothing: auto !important;
    -moz-osx-font-smoothing: auto !important;
  }

  .md\\:focus\\:antialiased:focus{
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }

  .md\\:focus\\:subpixel-antialiased:focus{
    -webkit-font-smoothing: auto !important;
    -moz-osx-font-smoothing: auto !important;
  }

  .md\\:ordinal, .md\\:slashed-zero, .md\\:lining-nums, .md\\:oldstyle-nums, .md\\:proportional-nums, .md\\:tabular-nums, .md\\:diagonal-fractions, .md\\:stacked-fractions{
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/) !important;
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction) !important;
  }

  .md\\:normal-nums{
    font-variant-numeric: normal !important;
  }

  .md\\:ordinal{
    --font-variant-numeric-ordinal: ordinal !important;
  }

  .md\\:slashed-zero{
    --font-variant-numeric-slashed-zero: slashed-zero !important;
  }

  .md\\:lining-nums{
    --font-variant-numeric-figure: lining-nums !important;
  }

  .md\\:oldstyle-nums{
    --font-variant-numeric-figure: oldstyle-nums !important;
  }

  .md\\:proportional-nums{
    --font-variant-numeric-spacing: proportional-nums !important;
  }

  .md\\:tabular-nums{
    --font-variant-numeric-spacing: tabular-nums !important;
  }

  .md\\:diagonal-fractions{
    --font-variant-numeric-fraction: diagonal-fractions !important;
  }

  .md\\:stacked-fractions{
    --font-variant-numeric-fraction: stacked-fractions !important;
  }

  .md\\:select-none{
    -webkit-user-select: none !important;
            user-select: none !important;
  }

  .md\\:select-text{
    -webkit-user-select: text !important;
            user-select: text !important;
  }

  .md\\:select-all{
    -webkit-user-select: all !important;
            user-select: all !important;
  }

  .md\\:select-auto{
    -webkit-user-select: auto !important;
            user-select: auto !important;
  }

  .md\\:align-baseline{
    vertical-align: baseline !important;
  }

  .md\\:align-top{
    vertical-align: top !important;
  }

  .md\\:align-middle{
    vertical-align: middle !important;
  }

  .md\\:align-bottom{
    vertical-align: bottom !important;
  }

  .md\\:align-text-top{
    vertical-align: text-top !important;
  }

  .md\\:align-text-bottom{
    vertical-align: text-bottom !important;
  }

  .md\\:visible{
    visibility: visible !important;
  }

  .md\\:invisible{
    visibility: hidden !important;
  }

  .md\\:whitespace-normal{
    white-space: normal !important;
  }

  .md\\:whitespace-no-wrap{
    white-space: nowrap !important;
  }

  .md\\:whitespace-pre{
    white-space: pre !important;
  }

  .md\\:whitespace-pre-line{
    white-space: pre-line !important;
  }

  .md\\:whitespace-pre-wrap{
    white-space: pre-wrap !important;
  }

  .md\\:break-normal{
    word-wrap: normal !important;
    overflow-wrap: normal !important;
    word-break: normal !important;
  }

  .md\\:break-words{
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
  }

  .md\\:break-all{
    word-break: break-all !important;
  }

  .md\\:truncate{
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .md\\:w-1{
    width: 0.25rem !important;
  }

  .md\\:w-2{
    width: 0.5rem !important;
  }

  .md\\:w-3{
    width: 0.75rem !important;
  }

  .md\\:w-4{
    width: 1rem !important;
  }

  .md\\:w-5{
    width: 1.25rem !important;
  }

  .md\\:w-6{
    width: 1.5rem !important;
  }

  .md\\:w-8{
    width: 2rem !important;
  }

  .md\\:w-10{
    width: 2.5rem !important;
  }

  .md\\:w-12{
    width: 3rem !important;
  }

  .md\\:w-16{
    width: 4rem !important;
  }

  .md\\:w-24{
    width: 6rem !important;
  }

  .md\\:w-32{
    width: 8rem !important;
  }

  .md\\:w-48{
    width: 12rem !important;
  }

  .md\\:w-64{
    width: 16rem !important;
  }

  .md\\:w-auto{
    width: auto !important;
  }

  .md\\:w-px{
    width: 1px !important;
  }

  .md\\:w-1\\/2{
    width: 50% !important;
  }

  .md\\:w-1\\/3{
    width: 33.33333% !important;
  }

  .md\\:w-2\\/3{
    width: 66.66667% !important;
  }

  .md\\:w-1\\/4{
    width: 25% !important;
  }

  .md\\:w-3\\/4{
    width: 75% !important;
  }

  .md\\:w-1\\/5{
    width: 20% !important;
  }

  .md\\:w-2\\/5{
    width: 40% !important;
  }

  .md\\:w-3\\/5{
    width: 60% !important;
  }

  .md\\:w-4\\/5{
    width: 80% !important;
  }

  .md\\:w-1\\/6{
    width: 16.66667% !important;
  }

  .md\\:w-5\\/6{
    width: 83.33333% !important;
  }

  .md\\:w-1\\/12{
    width: 8.33333% !important;
  }

  .md\\:w-2\\/12{
    width: 16.66667% !important;
  }

  .md\\:w-3\\/12{
    width: 25% !important;
  }

  .md\\:w-4\\/12{
    width: 33.33333% !important;
  }

  .md\\:w-5\\/12{
    width: 41.66667% !important;
  }

  .md\\:w-6\\/12{
    width: 50% !important;
  }

  .md\\:w-7\\/12{
    width: 58.33333% !important;
  }

  .md\\:w-8\\/12{
    width: 66.66667% !important;
  }

  .md\\:w-9\\/12{
    width: 75% !important;
  }

  .md\\:w-10\\/12{
    width: 83.33333% !important;
  }

  .md\\:w-11\\/12{
    width: 91.66667% !important;
  }

  .md\\:w-full{
    width: 100% !important;
  }

  .md\\:w-screen{
    width: 100vw !important;
  }

  .md\\:z-0{
    z-index: 0 !important;
  }

  .md\\:z-10{
    z-index: 10 !important;
  }

  .md\\:z-20{
    z-index: 20 !important;
  }

  .md\\:z-30{
    z-index: 30 !important;
  }

  .md\\:z-40{
    z-index: 40 !important;
  }

  .md\\:z-50{
    z-index: 50 !important;
  }

  .md\\:z-auto{
    z-index: auto !important;
  }

  .md\\:gap-0{
    grid-gap: 0 !important;
    gap: 0 !important;
  }

  .md\\:gap-1{
    grid-gap: 0.25rem !important;
    gap: 0.25rem !important;
  }

  .md\\:gap-2{
    grid-gap: 0.5rem !important;
    gap: 0.5rem !important;
  }

  .md\\:gap-3{
    grid-gap: 0.75rem !important;
    gap: 0.75rem !important;
  }

  .md\\:gap-4{
    grid-gap: 1rem !important;
    gap: 1rem !important;
  }

  .md\\:gap-5{
    grid-gap: 1.25rem !important;
    gap: 1.25rem !important;
  }

  .md\\:gap-6{
    grid-gap: 1.5rem !important;
    gap: 1.5rem !important;
  }

  .md\\:gap-8{
    grid-gap: 2rem !important;
    gap: 2rem !important;
  }

  .md\\:gap-10{
    grid-gap: 2.5rem !important;
    gap: 2.5rem !important;
  }

  .md\\:gap-12{
    grid-gap: 3rem !important;
    gap: 3rem !important;
  }

  .md\\:gap-16{
    grid-gap: 4rem !important;
    gap: 4rem !important;
  }

  .md\\:gap-20{
    grid-gap: 5rem !important;
    gap: 5rem !important;
  }

  .md\\:gap-24{
    grid-gap: 6rem !important;
    gap: 6rem !important;
  }

  .md\\:gap-32{
    grid-gap: 8rem !important;
    gap: 8rem !important;
  }

  .md\\:gap-40{
    grid-gap: 10rem !important;
    gap: 10rem !important;
  }

  .md\\:gap-48{
    grid-gap: 12rem !important;
    gap: 12rem !important;
  }

  .md\\:gap-56{
    grid-gap: 14rem !important;
    gap: 14rem !important;
  }

  .md\\:gap-64{
    grid-gap: 16rem !important;
    gap: 16rem !important;
  }

  .md\\:gap-px{
    grid-gap: 1px !important;
    gap: 1px !important;
  }

  .md\\:col-gap-0{
    grid-column-gap: 0 !important;
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .md\\:col-gap-1{
    grid-column-gap: 0.25rem !important;
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .md\\:col-gap-2{
    grid-column-gap: 0.5rem !important;
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .md\\:col-gap-3{
    grid-column-gap: 0.75rem !important;
    -moz-column-gap: 0.75rem !important;
         column-gap: 0.75rem !important;
  }

  .md\\:col-gap-4{
    grid-column-gap: 1rem !important;
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .md\\:col-gap-5{
    grid-column-gap: 1.25rem !important;
    -moz-column-gap: 1.25rem !important;
         column-gap: 1.25rem !important;
  }

  .md\\:col-gap-6{
    grid-column-gap: 1.5rem !important;
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .md\\:col-gap-8{
    grid-column-gap: 2rem !important;
    -moz-column-gap: 2rem !important;
         column-gap: 2rem !important;
  }

  .md\\:col-gap-10{
    grid-column-gap: 2.5rem !important;
    -moz-column-gap: 2.5rem !important;
         column-gap: 2.5rem !important;
  }

  .md\\:col-gap-12{
    grid-column-gap: 3rem !important;
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  .md\\:col-gap-16{
    grid-column-gap: 4rem !important;
    -moz-column-gap: 4rem !important;
         column-gap: 4rem !important;
  }

  .md\\:col-gap-20{
    grid-column-gap: 5rem !important;
    -moz-column-gap: 5rem !important;
         column-gap: 5rem !important;
  }

  .md\\:col-gap-24{
    grid-column-gap: 6rem !important;
    -moz-column-gap: 6rem !important;
         column-gap: 6rem !important;
  }

  .md\\:col-gap-32{
    grid-column-gap: 8rem !important;
    -moz-column-gap: 8rem !important;
         column-gap: 8rem !important;
  }

  .md\\:col-gap-40{
    grid-column-gap: 10rem !important;
    -moz-column-gap: 10rem !important;
         column-gap: 10rem !important;
  }

  .md\\:col-gap-48{
    grid-column-gap: 12rem !important;
    -moz-column-gap: 12rem !important;
         column-gap: 12rem !important;
  }

  .md\\:col-gap-56{
    grid-column-gap: 14rem !important;
    -moz-column-gap: 14rem !important;
         column-gap: 14rem !important;
  }

  .md\\:col-gap-64{
    grid-column-gap: 16rem !important;
    -moz-column-gap: 16rem !important;
         column-gap: 16rem !important;
  }

  .md\\:col-gap-px{
    grid-column-gap: 1px !important;
    -moz-column-gap: 1px !important;
         column-gap: 1px !important;
  }

  .md\\:gap-x-0{
    grid-column-gap: 0 !important;
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .md\\:gap-x-1{
    grid-column-gap: 0.25rem !important;
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .md\\:gap-x-2{
    grid-column-gap: 0.5rem !important;
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .md\\:gap-x-3{
    grid-column-gap: 0.75rem !important;
    -moz-column-gap: 0.75rem !important;
         column-gap: 0.75rem !important;
  }

  .md\\:gap-x-4{
    grid-column-gap: 1rem !important;
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .md\\:gap-x-5{
    grid-column-gap: 1.25rem !important;
    -moz-column-gap: 1.25rem !important;
         column-gap: 1.25rem !important;
  }

  .md\\:gap-x-6{
    grid-column-gap: 1.5rem !important;
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .md\\:gap-x-8{
    grid-column-gap: 2rem !important;
    -moz-column-gap: 2rem !important;
         column-gap: 2rem !important;
  }

  .md\\:gap-x-10{
    grid-column-gap: 2.5rem !important;
    -moz-column-gap: 2.5rem !important;
         column-gap: 2.5rem !important;
  }

  .md\\:gap-x-12{
    grid-column-gap: 3rem !important;
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  .md\\:gap-x-16{
    grid-column-gap: 4rem !important;
    -moz-column-gap: 4rem !important;
         column-gap: 4rem !important;
  }

  .md\\:gap-x-20{
    grid-column-gap: 5rem !important;
    -moz-column-gap: 5rem !important;
         column-gap: 5rem !important;
  }

  .md\\:gap-x-24{
    grid-column-gap: 6rem !important;
    -moz-column-gap: 6rem !important;
         column-gap: 6rem !important;
  }

  .md\\:gap-x-32{
    grid-column-gap: 8rem !important;
    -moz-column-gap: 8rem !important;
         column-gap: 8rem !important;
  }

  .md\\:gap-x-40{
    grid-column-gap: 10rem !important;
    -moz-column-gap: 10rem !important;
         column-gap: 10rem !important;
  }

  .md\\:gap-x-48{
    grid-column-gap: 12rem !important;
    -moz-column-gap: 12rem !important;
         column-gap: 12rem !important;
  }

  .md\\:gap-x-56{
    grid-column-gap: 14rem !important;
    -moz-column-gap: 14rem !important;
         column-gap: 14rem !important;
  }

  .md\\:gap-x-64{
    grid-column-gap: 16rem !important;
    -moz-column-gap: 16rem !important;
         column-gap: 16rem !important;
  }

  .md\\:gap-x-px{
    grid-column-gap: 1px !important;
    -moz-column-gap: 1px !important;
         column-gap: 1px !important;
  }

  .md\\:row-gap-0{
    grid-row-gap: 0 !important;
    row-gap: 0 !important;
  }

  .md\\:row-gap-1{
    grid-row-gap: 0.25rem !important;
    row-gap: 0.25rem !important;
  }

  .md\\:row-gap-2{
    grid-row-gap: 0.5rem !important;
    row-gap: 0.5rem !important;
  }

  .md\\:row-gap-3{
    grid-row-gap: 0.75rem !important;
    row-gap: 0.75rem !important;
  }

  .md\\:row-gap-4{
    grid-row-gap: 1rem !important;
    row-gap: 1rem !important;
  }

  .md\\:row-gap-5{
    grid-row-gap: 1.25rem !important;
    row-gap: 1.25rem !important;
  }

  .md\\:row-gap-6{
    grid-row-gap: 1.5rem !important;
    row-gap: 1.5rem !important;
  }

  .md\\:row-gap-8{
    grid-row-gap: 2rem !important;
    row-gap: 2rem !important;
  }

  .md\\:row-gap-10{
    grid-row-gap: 2.5rem !important;
    row-gap: 2.5rem !important;
  }

  .md\\:row-gap-12{
    grid-row-gap: 3rem !important;
    row-gap: 3rem !important;
  }

  .md\\:row-gap-16{
    grid-row-gap: 4rem !important;
    row-gap: 4rem !important;
  }

  .md\\:row-gap-20{
    grid-row-gap: 5rem !important;
    row-gap: 5rem !important;
  }

  .md\\:row-gap-24{
    grid-row-gap: 6rem !important;
    row-gap: 6rem !important;
  }

  .md\\:row-gap-32{
    grid-row-gap: 8rem !important;
    row-gap: 8rem !important;
  }

  .md\\:row-gap-40{
    grid-row-gap: 10rem !important;
    row-gap: 10rem !important;
  }

  .md\\:row-gap-48{
    grid-row-gap: 12rem !important;
    row-gap: 12rem !important;
  }

  .md\\:row-gap-56{
    grid-row-gap: 14rem !important;
    row-gap: 14rem !important;
  }

  .md\\:row-gap-64{
    grid-row-gap: 16rem !important;
    row-gap: 16rem !important;
  }

  .md\\:row-gap-px{
    grid-row-gap: 1px !important;
    row-gap: 1px !important;
  }

  .md\\:gap-y-0{
    grid-row-gap: 0 !important;
    row-gap: 0 !important;
  }

  .md\\:gap-y-1{
    grid-row-gap: 0.25rem !important;
    row-gap: 0.25rem !important;
  }

  .md\\:gap-y-2{
    grid-row-gap: 0.5rem !important;
    row-gap: 0.5rem !important;
  }

  .md\\:gap-y-3{
    grid-row-gap: 0.75rem !important;
    row-gap: 0.75rem !important;
  }

  .md\\:gap-y-4{
    grid-row-gap: 1rem !important;
    row-gap: 1rem !important;
  }

  .md\\:gap-y-5{
    grid-row-gap: 1.25rem !important;
    row-gap: 1.25rem !important;
  }

  .md\\:gap-y-6{
    grid-row-gap: 1.5rem !important;
    row-gap: 1.5rem !important;
  }

  .md\\:gap-y-8{
    grid-row-gap: 2rem !important;
    row-gap: 2rem !important;
  }

  .md\\:gap-y-10{
    grid-row-gap: 2.5rem !important;
    row-gap: 2.5rem !important;
  }

  .md\\:gap-y-12{
    grid-row-gap: 3rem !important;
    row-gap: 3rem !important;
  }

  .md\\:gap-y-16{
    grid-row-gap: 4rem !important;
    row-gap: 4rem !important;
  }

  .md\\:gap-y-20{
    grid-row-gap: 5rem !important;
    row-gap: 5rem !important;
  }

  .md\\:gap-y-24{
    grid-row-gap: 6rem !important;
    row-gap: 6rem !important;
  }

  .md\\:gap-y-32{
    grid-row-gap: 8rem !important;
    row-gap: 8rem !important;
  }

  .md\\:gap-y-40{
    grid-row-gap: 10rem !important;
    row-gap: 10rem !important;
  }

  .md\\:gap-y-48{
    grid-row-gap: 12rem !important;
    row-gap: 12rem !important;
  }

  .md\\:gap-y-56{
    grid-row-gap: 14rem !important;
    row-gap: 14rem !important;
  }

  .md\\:gap-y-64{
    grid-row-gap: 16rem !important;
    row-gap: 16rem !important;
  }

  .md\\:gap-y-px{
    grid-row-gap: 1px !important;
    row-gap: 1px !important;
  }

  .md\\:grid-flow-row{
    grid-auto-flow: row !important;
  }

  .md\\:grid-flow-col{
    grid-auto-flow: column !important;
  }

  .md\\:grid-flow-row-dense{
    grid-auto-flow: row dense !important;
  }

  .md\\:grid-flow-col-dense{
    grid-auto-flow: column dense !important;
  }

  .md\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
  }

  .md\\:grid-cols-none{
    grid-template-columns: none !important;
  }

  .md\\:auto-cols-auto{
    grid-auto-columns: auto !important;
  }

  .md\\:auto-cols-min{
    grid-auto-columns: min-content !important;
  }

  .md\\:auto-cols-max{
    grid-auto-columns: max-content !important;
  }

  .md\\:auto-cols-fr{
    grid-auto-columns: minmax(0, 1fr) !important;
  }

  .md\\:col-auto{
    grid-column: auto !important;
  }

  .md\\:col-span-1{
    grid-column: span 1 / span 1 !important;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2 !important;
  }

  .md\\:col-span-3{
    grid-column: span 3 / span 3 !important;
  }

  .md\\:col-span-4{
    grid-column: span 4 / span 4 !important;
  }

  .md\\:col-span-5{
    grid-column: span 5 / span 5 !important;
  }

  .md\\:col-span-6{
    grid-column: span 6 / span 6 !important;
  }

  .md\\:col-span-7{
    grid-column: span 7 / span 7 !important;
  }

  .md\\:col-span-8{
    grid-column: span 8 / span 8 !important;
  }

  .md\\:col-span-9{
    grid-column: span 9 / span 9 !important;
  }

  .md\\:col-span-10{
    grid-column: span 10 / span 10 !important;
  }

  .md\\:col-span-11{
    grid-column: span 11 / span 11 !important;
  }

  .md\\:col-span-12{
    grid-column: span 12 / span 12 !important;
  }

  .md\\:col-span-full{
    grid-column: 1 / -1 !important;
  }

  .md\\:col-start-1{
    grid-column-start: 1 !important;
  }

  .md\\:col-start-2{
    grid-column-start: 2 !important;
  }

  .md\\:col-start-3{
    grid-column-start: 3 !important;
  }

  .md\\:col-start-4{
    grid-column-start: 4 !important;
  }

  .md\\:col-start-5{
    grid-column-start: 5 !important;
  }

  .md\\:col-start-6{
    grid-column-start: 6 !important;
  }

  .md\\:col-start-7{
    grid-column-start: 7 !important;
  }

  .md\\:col-start-8{
    grid-column-start: 8 !important;
  }

  .md\\:col-start-9{
    grid-column-start: 9 !important;
  }

  .md\\:col-start-10{
    grid-column-start: 10 !important;
  }

  .md\\:col-start-11{
    grid-column-start: 11 !important;
  }

  .md\\:col-start-12{
    grid-column-start: 12 !important;
  }

  .md\\:col-start-13{
    grid-column-start: 13 !important;
  }

  .md\\:col-start-auto{
    grid-column-start: auto !important;
  }

  .md\\:col-end-1{
    grid-column-end: 1 !important;
  }

  .md\\:col-end-2{
    grid-column-end: 2 !important;
  }

  .md\\:col-end-3{
    grid-column-end: 3 !important;
  }

  .md\\:col-end-4{
    grid-column-end: 4 !important;
  }

  .md\\:col-end-5{
    grid-column-end: 5 !important;
  }

  .md\\:col-end-6{
    grid-column-end: 6 !important;
  }

  .md\\:col-end-7{
    grid-column-end: 7 !important;
  }

  .md\\:col-end-8{
    grid-column-end: 8 !important;
  }

  .md\\:col-end-9{
    grid-column-end: 9 !important;
  }

  .md\\:col-end-10{
    grid-column-end: 10 !important;
  }

  .md\\:col-end-11{
    grid-column-end: 11 !important;
  }

  .md\\:col-end-12{
    grid-column-end: 12 !important;
  }

  .md\\:col-end-13{
    grid-column-end: 13 !important;
  }

  .md\\:col-end-auto{
    grid-column-end: auto !important;
  }

  .md\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr)) !important;
  }

  .md\\:grid-rows-2{
    grid-template-rows: repeat(2, minmax(0, 1fr)) !important;
  }

  .md\\:grid-rows-3{
    grid-template-rows: repeat(3, minmax(0, 1fr)) !important;
  }

  .md\\:grid-rows-4{
    grid-template-rows: repeat(4, minmax(0, 1fr)) !important;
  }

  .md\\:grid-rows-5{
    grid-template-rows: repeat(5, minmax(0, 1fr)) !important;
  }

  .md\\:grid-rows-6{
    grid-template-rows: repeat(6, minmax(0, 1fr)) !important;
  }

  .md\\:grid-rows-none{
    grid-template-rows: none !important;
  }

  .md\\:auto-rows-auto{
    grid-auto-rows: auto !important;
  }

  .md\\:auto-rows-min{
    grid-auto-rows: min-content !important;
  }

  .md\\:auto-rows-max{
    grid-auto-rows: max-content !important;
  }

  .md\\:auto-rows-fr{
    grid-auto-rows: minmax(0, 1fr) !important;
  }

  .md\\:row-auto{
    grid-row: auto !important;
  }

  .md\\:row-span-1{
    grid-row: span 1 / span 1 !important;
  }

  .md\\:row-span-2{
    grid-row: span 2 / span 2 !important;
  }

  .md\\:row-span-3{
    grid-row: span 3 / span 3 !important;
  }

  .md\\:row-span-4{
    grid-row: span 4 / span 4 !important;
  }

  .md\\:row-span-5{
    grid-row: span 5 / span 5 !important;
  }

  .md\\:row-span-6{
    grid-row: span 6 / span 6 !important;
  }

  .md\\:row-span-full{
    grid-row: 1 / -1 !important;
  }

  .md\\:row-start-1{
    grid-row-start: 1 !important;
  }

  .md\\:row-start-2{
    grid-row-start: 2 !important;
  }

  .md\\:row-start-3{
    grid-row-start: 3 !important;
  }

  .md\\:row-start-4{
    grid-row-start: 4 !important;
  }

  .md\\:row-start-5{
    grid-row-start: 5 !important;
  }

  .md\\:row-start-6{
    grid-row-start: 6 !important;
  }

  .md\\:row-start-7{
    grid-row-start: 7 !important;
  }

  .md\\:row-start-auto{
    grid-row-start: auto !important;
  }

  .md\\:row-end-1{
    grid-row-end: 1 !important;
  }

  .md\\:row-end-2{
    grid-row-end: 2 !important;
  }

  .md\\:row-end-3{
    grid-row-end: 3 !important;
  }

  .md\\:row-end-4{
    grid-row-end: 4 !important;
  }

  .md\\:row-end-5{
    grid-row-end: 5 !important;
  }

  .md\\:row-end-6{
    grid-row-end: 6 !important;
  }

  .md\\:row-end-7{
    grid-row-end: 7 !important;
  }

  .md\\:row-end-auto{
    grid-row-end: auto !important;
  }

  .md\\:transform{
    --transform-translate-x: 0 !important;
    --transform-translate-y: 0 !important;
    --transform-rotate: 0 !important;
    --transform-skew-x: 0 !important;
    --transform-skew-y: 0 !important;
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  [dir] .md\\:transform{
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y)) !important;
  }

  [dir] .md\\:transform-none{
    transform: none !important;
  }

  [dir] .md\\:origin-center{
    transform-origin: center !important;
  }

  [dir] .md\\:origin-top{
    transform-origin: top !important;
  }

  [dir=ltr] .md\\:origin-top-right{
    transform-origin: top right !important;
  }

  [dir=rtl] .md\\:origin-top-right{
    transform-origin: top left !important;
  }

  [dir=ltr] .md\\:origin-right{
    transform-origin: right !important;
  }

  [dir=rtl] .md\\:origin-right{
    transform-origin: left !important;
  }

  [dir=ltr] .md\\:origin-bottom-right{
    transform-origin: bottom right !important;
  }

  [dir=rtl] .md\\:origin-bottom-right{
    transform-origin: bottom left !important;
  }

  [dir] .md\\:origin-bottom{
    transform-origin: bottom !important;
  }

  [dir=ltr] .md\\:origin-bottom-left{
    transform-origin: bottom left !important;
  }

  [dir=rtl] .md\\:origin-bottom-left{
    transform-origin: bottom right !important;
  }

  [dir=ltr] .md\\:origin-left{
    transform-origin: left !important;
  }

  [dir=rtl] .md\\:origin-left{
    transform-origin: right !important;
  }

  [dir=ltr] .md\\:origin-top-left{
    transform-origin: top left !important;
  }

  [dir=rtl] .md\\:origin-top-left{
    transform-origin: top right !important;
  }

  .md\\:scale-0{
    --transform-scale-x: 0 !important;
    --transform-scale-y: 0 !important;
  }

  .md\\:scale-50{
    --transform-scale-x: .5 !important;
    --transform-scale-y: .5 !important;
  }

  .md\\:scale-75{
    --transform-scale-x: .75 !important;
    --transform-scale-y: .75 !important;
  }

  .md\\:scale-90{
    --transform-scale-x: .9 !important;
    --transform-scale-y: .9 !important;
  }

  .md\\:scale-95{
    --transform-scale-x: .95 !important;
    --transform-scale-y: .95 !important;
  }

  .md\\:scale-100{
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  .md\\:scale-105{
    --transform-scale-x: 1.05 !important;
    --transform-scale-y: 1.05 !important;
  }

  .md\\:scale-110{
    --transform-scale-x: 1.1 !important;
    --transform-scale-y: 1.1 !important;
  }

  .md\\:scale-125{
    --transform-scale-x: 1.25 !important;
    --transform-scale-y: 1.25 !important;
  }

  .md\\:scale-150{
    --transform-scale-x: 1.5 !important;
    --transform-scale-y: 1.5 !important;
  }

  .md\\:scale-x-0{
    --transform-scale-x: 0 !important;
  }

  .md\\:scale-x-50{
    --transform-scale-x: .5 !important;
  }

  .md\\:scale-x-75{
    --transform-scale-x: .75 !important;
  }

  .md\\:scale-x-90{
    --transform-scale-x: .9 !important;
  }

  .md\\:scale-x-95{
    --transform-scale-x: .95 !important;
  }

  .md\\:scale-x-100{
    --transform-scale-x: 1 !important;
  }

  .md\\:scale-x-105{
    --transform-scale-x: 1.05 !important;
  }

  .md\\:scale-x-110{
    --transform-scale-x: 1.1 !important;
  }

  .md\\:scale-x-125{
    --transform-scale-x: 1.25 !important;
  }

  .md\\:scale-x-150{
    --transform-scale-x: 1.5 !important;
  }

  .md\\:scale-y-0{
    --transform-scale-y: 0 !important;
  }

  .md\\:scale-y-50{
    --transform-scale-y: .5 !important;
  }

  .md\\:scale-y-75{
    --transform-scale-y: .75 !important;
  }

  .md\\:scale-y-90{
    --transform-scale-y: .9 !important;
  }

  .md\\:scale-y-95{
    --transform-scale-y: .95 !important;
  }

  .md\\:scale-y-100{
    --transform-scale-y: 1 !important;
  }

  .md\\:scale-y-105{
    --transform-scale-y: 1.05 !important;
  }

  .md\\:scale-y-110{
    --transform-scale-y: 1.1 !important;
  }

  .md\\:scale-y-125{
    --transform-scale-y: 1.25 !important;
  }

  .md\\:scale-y-150{
    --transform-scale-y: 1.5 !important;
  }

  .md\\:hover\\:scale-0:hover{
    --transform-scale-x: 0 !important;
    --transform-scale-y: 0 !important;
  }

  .md\\:hover\\:scale-50:hover{
    --transform-scale-x: .5 !important;
    --transform-scale-y: .5 !important;
  }

  .md\\:hover\\:scale-75:hover{
    --transform-scale-x: .75 !important;
    --transform-scale-y: .75 !important;
  }

  .md\\:hover\\:scale-90:hover{
    --transform-scale-x: .9 !important;
    --transform-scale-y: .9 !important;
  }

  .md\\:hover\\:scale-95:hover{
    --transform-scale-x: .95 !important;
    --transform-scale-y: .95 !important;
  }

  .md\\:hover\\:scale-100:hover{
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  .md\\:hover\\:scale-105:hover{
    --transform-scale-x: 1.05 !important;
    --transform-scale-y: 1.05 !important;
  }

  .md\\:hover\\:scale-110:hover{
    --transform-scale-x: 1.1 !important;
    --transform-scale-y: 1.1 !important;
  }

  .md\\:hover\\:scale-125:hover{
    --transform-scale-x: 1.25 !important;
    --transform-scale-y: 1.25 !important;
  }

  .md\\:hover\\:scale-150:hover{
    --transform-scale-x: 1.5 !important;
    --transform-scale-y: 1.5 !important;
  }

  .md\\:hover\\:scale-x-0:hover{
    --transform-scale-x: 0 !important;
  }

  .md\\:hover\\:scale-x-50:hover{
    --transform-scale-x: .5 !important;
  }

  .md\\:hover\\:scale-x-75:hover{
    --transform-scale-x: .75 !important;
  }

  .md\\:hover\\:scale-x-90:hover{
    --transform-scale-x: .9 !important;
  }

  .md\\:hover\\:scale-x-95:hover{
    --transform-scale-x: .95 !important;
  }

  .md\\:hover\\:scale-x-100:hover{
    --transform-scale-x: 1 !important;
  }

  .md\\:hover\\:scale-x-105:hover{
    --transform-scale-x: 1.05 !important;
  }

  .md\\:hover\\:scale-x-110:hover{
    --transform-scale-x: 1.1 !important;
  }

  .md\\:hover\\:scale-x-125:hover{
    --transform-scale-x: 1.25 !important;
  }

  .md\\:hover\\:scale-x-150:hover{
    --transform-scale-x: 1.5 !important;
  }

  .md\\:hover\\:scale-y-0:hover{
    --transform-scale-y: 0 !important;
  }

  .md\\:hover\\:scale-y-50:hover{
    --transform-scale-y: .5 !important;
  }

  .md\\:hover\\:scale-y-75:hover{
    --transform-scale-y: .75 !important;
  }

  .md\\:hover\\:scale-y-90:hover{
    --transform-scale-y: .9 !important;
  }

  .md\\:hover\\:scale-y-95:hover{
    --transform-scale-y: .95 !important;
  }

  .md\\:hover\\:scale-y-100:hover{
    --transform-scale-y: 1 !important;
  }

  .md\\:hover\\:scale-y-105:hover{
    --transform-scale-y: 1.05 !important;
  }

  .md\\:hover\\:scale-y-110:hover{
    --transform-scale-y: 1.1 !important;
  }

  .md\\:hover\\:scale-y-125:hover{
    --transform-scale-y: 1.25 !important;
  }

  .md\\:hover\\:scale-y-150:hover{
    --transform-scale-y: 1.5 !important;
  }

  .md\\:focus\\:scale-0:focus{
    --transform-scale-x: 0 !important;
    --transform-scale-y: 0 !important;
  }

  .md\\:focus\\:scale-50:focus{
    --transform-scale-x: .5 !important;
    --transform-scale-y: .5 !important;
  }

  .md\\:focus\\:scale-75:focus{
    --transform-scale-x: .75 !important;
    --transform-scale-y: .75 !important;
  }

  .md\\:focus\\:scale-90:focus{
    --transform-scale-x: .9 !important;
    --transform-scale-y: .9 !important;
  }

  .md\\:focus\\:scale-95:focus{
    --transform-scale-x: .95 !important;
    --transform-scale-y: .95 !important;
  }

  .md\\:focus\\:scale-100:focus{
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  .md\\:focus\\:scale-105:focus{
    --transform-scale-x: 1.05 !important;
    --transform-scale-y: 1.05 !important;
  }

  .md\\:focus\\:scale-110:focus{
    --transform-scale-x: 1.1 !important;
    --transform-scale-y: 1.1 !important;
  }

  .md\\:focus\\:scale-125:focus{
    --transform-scale-x: 1.25 !important;
    --transform-scale-y: 1.25 !important;
  }

  .md\\:focus\\:scale-150:focus{
    --transform-scale-x: 1.5 !important;
    --transform-scale-y: 1.5 !important;
  }

  .md\\:focus\\:scale-x-0:focus{
    --transform-scale-x: 0 !important;
  }

  .md\\:focus\\:scale-x-50:focus{
    --transform-scale-x: .5 !important;
  }

  .md\\:focus\\:scale-x-75:focus{
    --transform-scale-x: .75 !important;
  }

  .md\\:focus\\:scale-x-90:focus{
    --transform-scale-x: .9 !important;
  }

  .md\\:focus\\:scale-x-95:focus{
    --transform-scale-x: .95 !important;
  }

  .md\\:focus\\:scale-x-100:focus{
    --transform-scale-x: 1 !important;
  }

  .md\\:focus\\:scale-x-105:focus{
    --transform-scale-x: 1.05 !important;
  }

  .md\\:focus\\:scale-x-110:focus{
    --transform-scale-x: 1.1 !important;
  }

  .md\\:focus\\:scale-x-125:focus{
    --transform-scale-x: 1.25 !important;
  }

  .md\\:focus\\:scale-x-150:focus{
    --transform-scale-x: 1.5 !important;
  }

  .md\\:focus\\:scale-y-0:focus{
    --transform-scale-y: 0 !important;
  }

  .md\\:focus\\:scale-y-50:focus{
    --transform-scale-y: .5 !important;
  }

  .md\\:focus\\:scale-y-75:focus{
    --transform-scale-y: .75 !important;
  }

  .md\\:focus\\:scale-y-90:focus{
    --transform-scale-y: .9 !important;
  }

  .md\\:focus\\:scale-y-95:focus{
    --transform-scale-y: .95 !important;
  }

  .md\\:focus\\:scale-y-100:focus{
    --transform-scale-y: 1 !important;
  }

  .md\\:focus\\:scale-y-105:focus{
    --transform-scale-y: 1.05 !important;
  }

  .md\\:focus\\:scale-y-110:focus{
    --transform-scale-y: 1.1 !important;
  }

  .md\\:focus\\:scale-y-125:focus{
    --transform-scale-y: 1.25 !important;
  }

  .md\\:focus\\:scale-y-150:focus{
    --transform-scale-y: 1.5 !important;
  }

  .md\\:rotate-0{
    --transform-rotate: 0 !important;
  }

  .md\\:rotate-1{
    --transform-rotate: 1deg !important;
  }

  .md\\:rotate-2{
    --transform-rotate: 2deg !important;
  }

  .md\\:rotate-3{
    --transform-rotate: 3deg !important;
  }

  .md\\:rotate-6{
    --transform-rotate: 6deg !important;
  }

  .md\\:rotate-12{
    --transform-rotate: 12deg !important;
  }

  .md\\:rotate-45{
    --transform-rotate: 45deg !important;
  }

  .md\\:rotate-90{
    --transform-rotate: 90deg !important;
  }

  .md\\:rotate-180{
    --transform-rotate: 180deg !important;
  }

  .md\\:-rotate-180{
    --transform-rotate: -180deg !important;
  }

  .md\\:-rotate-90{
    --transform-rotate: -90deg !important;
  }

  .md\\:-rotate-45{
    --transform-rotate: -45deg !important;
  }

  .md\\:-rotate-12{
    --transform-rotate: -12deg !important;
  }

  .md\\:-rotate-6{
    --transform-rotate: -6deg !important;
  }

  .md\\:-rotate-3{
    --transform-rotate: -3deg !important;
  }

  .md\\:-rotate-2{
    --transform-rotate: -2deg !important;
  }

  .md\\:-rotate-1{
    --transform-rotate: -1deg !important;
  }

  .md\\:hover\\:rotate-0:hover{
    --transform-rotate: 0 !important;
  }

  .md\\:hover\\:rotate-1:hover{
    --transform-rotate: 1deg !important;
  }

  .md\\:hover\\:rotate-2:hover{
    --transform-rotate: 2deg !important;
  }

  .md\\:hover\\:rotate-3:hover{
    --transform-rotate: 3deg !important;
  }

  .md\\:hover\\:rotate-6:hover{
    --transform-rotate: 6deg !important;
  }

  .md\\:hover\\:rotate-12:hover{
    --transform-rotate: 12deg !important;
  }

  .md\\:hover\\:rotate-45:hover{
    --transform-rotate: 45deg !important;
  }

  .md\\:hover\\:rotate-90:hover{
    --transform-rotate: 90deg !important;
  }

  .md\\:hover\\:rotate-180:hover{
    --transform-rotate: 180deg !important;
  }

  .md\\:hover\\:-rotate-180:hover{
    --transform-rotate: -180deg !important;
  }

  .md\\:hover\\:-rotate-90:hover{
    --transform-rotate: -90deg !important;
  }

  .md\\:hover\\:-rotate-45:hover{
    --transform-rotate: -45deg !important;
  }

  .md\\:hover\\:-rotate-12:hover{
    --transform-rotate: -12deg !important;
  }

  .md\\:hover\\:-rotate-6:hover{
    --transform-rotate: -6deg !important;
  }

  .md\\:hover\\:-rotate-3:hover{
    --transform-rotate: -3deg !important;
  }

  .md\\:hover\\:-rotate-2:hover{
    --transform-rotate: -2deg !important;
  }

  .md\\:hover\\:-rotate-1:hover{
    --transform-rotate: -1deg !important;
  }

  .md\\:focus\\:rotate-0:focus{
    --transform-rotate: 0 !important;
  }

  .md\\:focus\\:rotate-1:focus{
    --transform-rotate: 1deg !important;
  }

  .md\\:focus\\:rotate-2:focus{
    --transform-rotate: 2deg !important;
  }

  .md\\:focus\\:rotate-3:focus{
    --transform-rotate: 3deg !important;
  }

  .md\\:focus\\:rotate-6:focus{
    --transform-rotate: 6deg !important;
  }

  .md\\:focus\\:rotate-12:focus{
    --transform-rotate: 12deg !important;
  }

  .md\\:focus\\:rotate-45:focus{
    --transform-rotate: 45deg !important;
  }

  .md\\:focus\\:rotate-90:focus{
    --transform-rotate: 90deg !important;
  }

  .md\\:focus\\:rotate-180:focus{
    --transform-rotate: 180deg !important;
  }

  .md\\:focus\\:-rotate-180:focus{
    --transform-rotate: -180deg !important;
  }

  .md\\:focus\\:-rotate-90:focus{
    --transform-rotate: -90deg !important;
  }

  .md\\:focus\\:-rotate-45:focus{
    --transform-rotate: -45deg !important;
  }

  .md\\:focus\\:-rotate-12:focus{
    --transform-rotate: -12deg !important;
  }

  .md\\:focus\\:-rotate-6:focus{
    --transform-rotate: -6deg !important;
  }

  .md\\:focus\\:-rotate-3:focus{
    --transform-rotate: -3deg !important;
  }

  .md\\:focus\\:-rotate-2:focus{
    --transform-rotate: -2deg !important;
  }

  .md\\:focus\\:-rotate-1:focus{
    --transform-rotate: -1deg !important;
  }

  .md\\:translate-x-0{
    --transform-translate-x: 0 !important;
  }

  .md\\:translate-x-1{
    --transform-translate-x: 0.25rem !important;
  }

  .md\\:translate-x-2{
    --transform-translate-x: 0.5rem !important;
  }

  .md\\:translate-x-3{
    --transform-translate-x: 0.75rem !important;
  }

  .md\\:translate-x-4{
    --transform-translate-x: 1rem !important;
  }

  .md\\:translate-x-5{
    --transform-translate-x: 1.25rem !important;
  }

  .md\\:translate-x-6{
    --transform-translate-x: 1.5rem !important;
  }

  .md\\:translate-x-8{
    --transform-translate-x: 2rem !important;
  }

  .md\\:translate-x-10{
    --transform-translate-x: 2.5rem !important;
  }

  .md\\:translate-x-12{
    --transform-translate-x: 3rem !important;
  }

  .md\\:translate-x-16{
    --transform-translate-x: 4rem !important;
  }

  .md\\:translate-x-20{
    --transform-translate-x: 5rem !important;
  }

  .md\\:translate-x-24{
    --transform-translate-x: 6rem !important;
  }

  .md\\:translate-x-32{
    --transform-translate-x: 8rem !important;
  }

  .md\\:translate-x-40{
    --transform-translate-x: 10rem !important;
  }

  .md\\:translate-x-48{
    --transform-translate-x: 12rem !important;
  }

  .md\\:translate-x-56{
    --transform-translate-x: 14rem !important;
  }

  .md\\:translate-x-64{
    --transform-translate-x: 16rem !important;
  }

  .md\\:translate-x-px{
    --transform-translate-x: 1px !important;
  }

  .md\\:-translate-x-1{
    --transform-translate-x: -0.25rem !important;
  }

  .md\\:-translate-x-2{
    --transform-translate-x: -0.5rem !important;
  }

  .md\\:-translate-x-3{
    --transform-translate-x: -0.75rem !important;
  }

  .md\\:-translate-x-4{
    --transform-translate-x: -1rem !important;
  }

  .md\\:-translate-x-5{
    --transform-translate-x: -1.25rem !important;
  }

  .md\\:-translate-x-6{
    --transform-translate-x: -1.5rem !important;
  }

  .md\\:-translate-x-8{
    --transform-translate-x: -2rem !important;
  }

  .md\\:-translate-x-10{
    --transform-translate-x: -2.5rem !important;
  }

  .md\\:-translate-x-12{
    --transform-translate-x: -3rem !important;
  }

  .md\\:-translate-x-16{
    --transform-translate-x: -4rem !important;
  }

  .md\\:-translate-x-20{
    --transform-translate-x: -5rem !important;
  }

  .md\\:-translate-x-24{
    --transform-translate-x: -6rem !important;
  }

  .md\\:-translate-x-32{
    --transform-translate-x: -8rem !important;
  }

  .md\\:-translate-x-40{
    --transform-translate-x: -10rem !important;
  }

  .md\\:-translate-x-48{
    --transform-translate-x: -12rem !important;
  }

  .md\\:-translate-x-56{
    --transform-translate-x: -14rem !important;
  }

  .md\\:-translate-x-64{
    --transform-translate-x: -16rem !important;
  }

  .md\\:-translate-x-px{
    --transform-translate-x: -1px !important;
  }

  .md\\:-translate-x-full{
    --transform-translate-x: -100% !important;
  }

  .md\\:-translate-x-1\\/2{
    --transform-translate-x: -50% !important;
  }

  .md\\:translate-x-1\\/2{
    --transform-translate-x: 50% !important;
  }

  .md\\:translate-x-full{
    --transform-translate-x: 100% !important;
  }

  .md\\:translate-y-0{
    --transform-translate-y: 0 !important;
  }

  .md\\:translate-y-1{
    --transform-translate-y: 0.25rem !important;
  }

  .md\\:translate-y-2{
    --transform-translate-y: 0.5rem !important;
  }

  .md\\:translate-y-3{
    --transform-translate-y: 0.75rem !important;
  }

  .md\\:translate-y-4{
    --transform-translate-y: 1rem !important;
  }

  .md\\:translate-y-5{
    --transform-translate-y: 1.25rem !important;
  }

  .md\\:translate-y-6{
    --transform-translate-y: 1.5rem !important;
  }

  .md\\:translate-y-8{
    --transform-translate-y: 2rem !important;
  }

  .md\\:translate-y-10{
    --transform-translate-y: 2.5rem !important;
  }

  .md\\:translate-y-12{
    --transform-translate-y: 3rem !important;
  }

  .md\\:translate-y-16{
    --transform-translate-y: 4rem !important;
  }

  .md\\:translate-y-20{
    --transform-translate-y: 5rem !important;
  }

  .md\\:translate-y-24{
    --transform-translate-y: 6rem !important;
  }

  .md\\:translate-y-32{
    --transform-translate-y: 8rem !important;
  }

  .md\\:translate-y-40{
    --transform-translate-y: 10rem !important;
  }

  .md\\:translate-y-48{
    --transform-translate-y: 12rem !important;
  }

  .md\\:translate-y-56{
    --transform-translate-y: 14rem !important;
  }

  .md\\:translate-y-64{
    --transform-translate-y: 16rem !important;
  }

  .md\\:translate-y-px{
    --transform-translate-y: 1px !important;
  }

  .md\\:-translate-y-1{
    --transform-translate-y: -0.25rem !important;
  }

  .md\\:-translate-y-2{
    --transform-translate-y: -0.5rem !important;
  }

  .md\\:-translate-y-3{
    --transform-translate-y: -0.75rem !important;
  }

  .md\\:-translate-y-4{
    --transform-translate-y: -1rem !important;
  }

  .md\\:-translate-y-5{
    --transform-translate-y: -1.25rem !important;
  }

  .md\\:-translate-y-6{
    --transform-translate-y: -1.5rem !important;
  }

  .md\\:-translate-y-8{
    --transform-translate-y: -2rem !important;
  }

  .md\\:-translate-y-10{
    --transform-translate-y: -2.5rem !important;
  }

  .md\\:-translate-y-12{
    --transform-translate-y: -3rem !important;
  }

  .md\\:-translate-y-16{
    --transform-translate-y: -4rem !important;
  }

  .md\\:-translate-y-20{
    --transform-translate-y: -5rem !important;
  }

  .md\\:-translate-y-24{
    --transform-translate-y: -6rem !important;
  }

  .md\\:-translate-y-32{
    --transform-translate-y: -8rem !important;
  }

  .md\\:-translate-y-40{
    --transform-translate-y: -10rem !important;
  }

  .md\\:-translate-y-48{
    --transform-translate-y: -12rem !important;
  }

  .md\\:-translate-y-56{
    --transform-translate-y: -14rem !important;
  }

  .md\\:-translate-y-64{
    --transform-translate-y: -16rem !important;
  }

  .md\\:-translate-y-px{
    --transform-translate-y: -1px !important;
  }

  .md\\:-translate-y-full{
    --transform-translate-y: -100% !important;
  }

  .md\\:-translate-y-1\\/2{
    --transform-translate-y: -50% !important;
  }

  .md\\:translate-y-1\\/2{
    --transform-translate-y: 50% !important;
  }

  .md\\:translate-y-full{
    --transform-translate-y: 100% !important;
  }

  .md\\:hover\\:translate-x-0:hover{
    --transform-translate-x: 0 !important;
  }

  .md\\:hover\\:translate-x-1:hover{
    --transform-translate-x: 0.25rem !important;
  }

  .md\\:hover\\:translate-x-2:hover{
    --transform-translate-x: 0.5rem !important;
  }

  .md\\:hover\\:translate-x-3:hover{
    --transform-translate-x: 0.75rem !important;
  }

  .md\\:hover\\:translate-x-4:hover{
    --transform-translate-x: 1rem !important;
  }

  .md\\:hover\\:translate-x-5:hover{
    --transform-translate-x: 1.25rem !important;
  }

  .md\\:hover\\:translate-x-6:hover{
    --transform-translate-x: 1.5rem !important;
  }

  .md\\:hover\\:translate-x-8:hover{
    --transform-translate-x: 2rem !important;
  }

  .md\\:hover\\:translate-x-10:hover{
    --transform-translate-x: 2.5rem !important;
  }

  .md\\:hover\\:translate-x-12:hover{
    --transform-translate-x: 3rem !important;
  }

  .md\\:hover\\:translate-x-16:hover{
    --transform-translate-x: 4rem !important;
  }

  .md\\:hover\\:translate-x-20:hover{
    --transform-translate-x: 5rem !important;
  }

  .md\\:hover\\:translate-x-24:hover{
    --transform-translate-x: 6rem !important;
  }

  .md\\:hover\\:translate-x-32:hover{
    --transform-translate-x: 8rem !important;
  }

  .md\\:hover\\:translate-x-40:hover{
    --transform-translate-x: 10rem !important;
  }

  .md\\:hover\\:translate-x-48:hover{
    --transform-translate-x: 12rem !important;
  }

  .md\\:hover\\:translate-x-56:hover{
    --transform-translate-x: 14rem !important;
  }

  .md\\:hover\\:translate-x-64:hover{
    --transform-translate-x: 16rem !important;
  }

  .md\\:hover\\:translate-x-px:hover{
    --transform-translate-x: 1px !important;
  }

  .md\\:hover\\:-translate-x-1:hover{
    --transform-translate-x: -0.25rem !important;
  }

  .md\\:hover\\:-translate-x-2:hover{
    --transform-translate-x: -0.5rem !important;
  }

  .md\\:hover\\:-translate-x-3:hover{
    --transform-translate-x: -0.75rem !important;
  }

  .md\\:hover\\:-translate-x-4:hover{
    --transform-translate-x: -1rem !important;
  }

  .md\\:hover\\:-translate-x-5:hover{
    --transform-translate-x: -1.25rem !important;
  }

  .md\\:hover\\:-translate-x-6:hover{
    --transform-translate-x: -1.5rem !important;
  }

  .md\\:hover\\:-translate-x-8:hover{
    --transform-translate-x: -2rem !important;
  }

  .md\\:hover\\:-translate-x-10:hover{
    --transform-translate-x: -2.5rem !important;
  }

  .md\\:hover\\:-translate-x-12:hover{
    --transform-translate-x: -3rem !important;
  }

  .md\\:hover\\:-translate-x-16:hover{
    --transform-translate-x: -4rem !important;
  }

  .md\\:hover\\:-translate-x-20:hover{
    --transform-translate-x: -5rem !important;
  }

  .md\\:hover\\:-translate-x-24:hover{
    --transform-translate-x: -6rem !important;
  }

  .md\\:hover\\:-translate-x-32:hover{
    --transform-translate-x: -8rem !important;
  }

  .md\\:hover\\:-translate-x-40:hover{
    --transform-translate-x: -10rem !important;
  }

  .md\\:hover\\:-translate-x-48:hover{
    --transform-translate-x: -12rem !important;
  }

  .md\\:hover\\:-translate-x-56:hover{
    --transform-translate-x: -14rem !important;
  }

  .md\\:hover\\:-translate-x-64:hover{
    --transform-translate-x: -16rem !important;
  }

  .md\\:hover\\:-translate-x-px:hover{
    --transform-translate-x: -1px !important;
  }

  .md\\:hover\\:-translate-x-full:hover{
    --transform-translate-x: -100% !important;
  }

  .md\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x: -50% !important;
  }

  .md\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x: 50% !important;
  }

  .md\\:hover\\:translate-x-full:hover{
    --transform-translate-x: 100% !important;
  }

  .md\\:hover\\:translate-y-0:hover{
    --transform-translate-y: 0 !important;
  }

  .md\\:hover\\:translate-y-1:hover{
    --transform-translate-y: 0.25rem !important;
  }

  .md\\:hover\\:translate-y-2:hover{
    --transform-translate-y: 0.5rem !important;
  }

  .md\\:hover\\:translate-y-3:hover{
    --transform-translate-y: 0.75rem !important;
  }

  .md\\:hover\\:translate-y-4:hover{
    --transform-translate-y: 1rem !important;
  }

  .md\\:hover\\:translate-y-5:hover{
    --transform-translate-y: 1.25rem !important;
  }

  .md\\:hover\\:translate-y-6:hover{
    --transform-translate-y: 1.5rem !important;
  }

  .md\\:hover\\:translate-y-8:hover{
    --transform-translate-y: 2rem !important;
  }

  .md\\:hover\\:translate-y-10:hover{
    --transform-translate-y: 2.5rem !important;
  }

  .md\\:hover\\:translate-y-12:hover{
    --transform-translate-y: 3rem !important;
  }

  .md\\:hover\\:translate-y-16:hover{
    --transform-translate-y: 4rem !important;
  }

  .md\\:hover\\:translate-y-20:hover{
    --transform-translate-y: 5rem !important;
  }

  .md\\:hover\\:translate-y-24:hover{
    --transform-translate-y: 6rem !important;
  }

  .md\\:hover\\:translate-y-32:hover{
    --transform-translate-y: 8rem !important;
  }

  .md\\:hover\\:translate-y-40:hover{
    --transform-translate-y: 10rem !important;
  }

  .md\\:hover\\:translate-y-48:hover{
    --transform-translate-y: 12rem !important;
  }

  .md\\:hover\\:translate-y-56:hover{
    --transform-translate-y: 14rem !important;
  }

  .md\\:hover\\:translate-y-64:hover{
    --transform-translate-y: 16rem !important;
  }

  .md\\:hover\\:translate-y-px:hover{
    --transform-translate-y: 1px !important;
  }

  .md\\:hover\\:-translate-y-1:hover{
    --transform-translate-y: -0.25rem !important;
  }

  .md\\:hover\\:-translate-y-2:hover{
    --transform-translate-y: -0.5rem !important;
  }

  .md\\:hover\\:-translate-y-3:hover{
    --transform-translate-y: -0.75rem !important;
  }

  .md\\:hover\\:-translate-y-4:hover{
    --transform-translate-y: -1rem !important;
  }

  .md\\:hover\\:-translate-y-5:hover{
    --transform-translate-y: -1.25rem !important;
  }

  .md\\:hover\\:-translate-y-6:hover{
    --transform-translate-y: -1.5rem !important;
  }

  .md\\:hover\\:-translate-y-8:hover{
    --transform-translate-y: -2rem !important;
  }

  .md\\:hover\\:-translate-y-10:hover{
    --transform-translate-y: -2.5rem !important;
  }

  .md\\:hover\\:-translate-y-12:hover{
    --transform-translate-y: -3rem !important;
  }

  .md\\:hover\\:-translate-y-16:hover{
    --transform-translate-y: -4rem !important;
  }

  .md\\:hover\\:-translate-y-20:hover{
    --transform-translate-y: -5rem !important;
  }

  .md\\:hover\\:-translate-y-24:hover{
    --transform-translate-y: -6rem !important;
  }

  .md\\:hover\\:-translate-y-32:hover{
    --transform-translate-y: -8rem !important;
  }

  .md\\:hover\\:-translate-y-40:hover{
    --transform-translate-y: -10rem !important;
  }

  .md\\:hover\\:-translate-y-48:hover{
    --transform-translate-y: -12rem !important;
  }

  .md\\:hover\\:-translate-y-56:hover{
    --transform-translate-y: -14rem !important;
  }

  .md\\:hover\\:-translate-y-64:hover{
    --transform-translate-y: -16rem !important;
  }

  .md\\:hover\\:-translate-y-px:hover{
    --transform-translate-y: -1px !important;
  }

  .md\\:hover\\:-translate-y-full:hover{
    --transform-translate-y: -100% !important;
  }

  .md\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y: -50% !important;
  }

  .md\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y: 50% !important;
  }

  .md\\:hover\\:translate-y-full:hover{
    --transform-translate-y: 100% !important;
  }

  .md\\:focus\\:translate-x-0:focus{
    --transform-translate-x: 0 !important;
  }

  .md\\:focus\\:translate-x-1:focus{
    --transform-translate-x: 0.25rem !important;
  }

  .md\\:focus\\:translate-x-2:focus{
    --transform-translate-x: 0.5rem !important;
  }

  .md\\:focus\\:translate-x-3:focus{
    --transform-translate-x: 0.75rem !important;
  }

  .md\\:focus\\:translate-x-4:focus{
    --transform-translate-x: 1rem !important;
  }

  .md\\:focus\\:translate-x-5:focus{
    --transform-translate-x: 1.25rem !important;
  }

  .md\\:focus\\:translate-x-6:focus{
    --transform-translate-x: 1.5rem !important;
  }

  .md\\:focus\\:translate-x-8:focus{
    --transform-translate-x: 2rem !important;
  }

  .md\\:focus\\:translate-x-10:focus{
    --transform-translate-x: 2.5rem !important;
  }

  .md\\:focus\\:translate-x-12:focus{
    --transform-translate-x: 3rem !important;
  }

  .md\\:focus\\:translate-x-16:focus{
    --transform-translate-x: 4rem !important;
  }

  .md\\:focus\\:translate-x-20:focus{
    --transform-translate-x: 5rem !important;
  }

  .md\\:focus\\:translate-x-24:focus{
    --transform-translate-x: 6rem !important;
  }

  .md\\:focus\\:translate-x-32:focus{
    --transform-translate-x: 8rem !important;
  }

  .md\\:focus\\:translate-x-40:focus{
    --transform-translate-x: 10rem !important;
  }

  .md\\:focus\\:translate-x-48:focus{
    --transform-translate-x: 12rem !important;
  }

  .md\\:focus\\:translate-x-56:focus{
    --transform-translate-x: 14rem !important;
  }

  .md\\:focus\\:translate-x-64:focus{
    --transform-translate-x: 16rem !important;
  }

  .md\\:focus\\:translate-x-px:focus{
    --transform-translate-x: 1px !important;
  }

  .md\\:focus\\:-translate-x-1:focus{
    --transform-translate-x: -0.25rem !important;
  }

  .md\\:focus\\:-translate-x-2:focus{
    --transform-translate-x: -0.5rem !important;
  }

  .md\\:focus\\:-translate-x-3:focus{
    --transform-translate-x: -0.75rem !important;
  }

  .md\\:focus\\:-translate-x-4:focus{
    --transform-translate-x: -1rem !important;
  }

  .md\\:focus\\:-translate-x-5:focus{
    --transform-translate-x: -1.25rem !important;
  }

  .md\\:focus\\:-translate-x-6:focus{
    --transform-translate-x: -1.5rem !important;
  }

  .md\\:focus\\:-translate-x-8:focus{
    --transform-translate-x: -2rem !important;
  }

  .md\\:focus\\:-translate-x-10:focus{
    --transform-translate-x: -2.5rem !important;
  }

  .md\\:focus\\:-translate-x-12:focus{
    --transform-translate-x: -3rem !important;
  }

  .md\\:focus\\:-translate-x-16:focus{
    --transform-translate-x: -4rem !important;
  }

  .md\\:focus\\:-translate-x-20:focus{
    --transform-translate-x: -5rem !important;
  }

  .md\\:focus\\:-translate-x-24:focus{
    --transform-translate-x: -6rem !important;
  }

  .md\\:focus\\:-translate-x-32:focus{
    --transform-translate-x: -8rem !important;
  }

  .md\\:focus\\:-translate-x-40:focus{
    --transform-translate-x: -10rem !important;
  }

  .md\\:focus\\:-translate-x-48:focus{
    --transform-translate-x: -12rem !important;
  }

  .md\\:focus\\:-translate-x-56:focus{
    --transform-translate-x: -14rem !important;
  }

  .md\\:focus\\:-translate-x-64:focus{
    --transform-translate-x: -16rem !important;
  }

  .md\\:focus\\:-translate-x-px:focus{
    --transform-translate-x: -1px !important;
  }

  .md\\:focus\\:-translate-x-full:focus{
    --transform-translate-x: -100% !important;
  }

  .md\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x: -50% !important;
  }

  .md\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x: 50% !important;
  }

  .md\\:focus\\:translate-x-full:focus{
    --transform-translate-x: 100% !important;
  }

  .md\\:focus\\:translate-y-0:focus{
    --transform-translate-y: 0 !important;
  }

  .md\\:focus\\:translate-y-1:focus{
    --transform-translate-y: 0.25rem !important;
  }

  .md\\:focus\\:translate-y-2:focus{
    --transform-translate-y: 0.5rem !important;
  }

  .md\\:focus\\:translate-y-3:focus{
    --transform-translate-y: 0.75rem !important;
  }

  .md\\:focus\\:translate-y-4:focus{
    --transform-translate-y: 1rem !important;
  }

  .md\\:focus\\:translate-y-5:focus{
    --transform-translate-y: 1.25rem !important;
  }

  .md\\:focus\\:translate-y-6:focus{
    --transform-translate-y: 1.5rem !important;
  }

  .md\\:focus\\:translate-y-8:focus{
    --transform-translate-y: 2rem !important;
  }

  .md\\:focus\\:translate-y-10:focus{
    --transform-translate-y: 2.5rem !important;
  }

  .md\\:focus\\:translate-y-12:focus{
    --transform-translate-y: 3rem !important;
  }

  .md\\:focus\\:translate-y-16:focus{
    --transform-translate-y: 4rem !important;
  }

  .md\\:focus\\:translate-y-20:focus{
    --transform-translate-y: 5rem !important;
  }

  .md\\:focus\\:translate-y-24:focus{
    --transform-translate-y: 6rem !important;
  }

  .md\\:focus\\:translate-y-32:focus{
    --transform-translate-y: 8rem !important;
  }

  .md\\:focus\\:translate-y-40:focus{
    --transform-translate-y: 10rem !important;
  }

  .md\\:focus\\:translate-y-48:focus{
    --transform-translate-y: 12rem !important;
  }

  .md\\:focus\\:translate-y-56:focus{
    --transform-translate-y: 14rem !important;
  }

  .md\\:focus\\:translate-y-64:focus{
    --transform-translate-y: 16rem !important;
  }

  .md\\:focus\\:translate-y-px:focus{
    --transform-translate-y: 1px !important;
  }

  .md\\:focus\\:-translate-y-1:focus{
    --transform-translate-y: -0.25rem !important;
  }

  .md\\:focus\\:-translate-y-2:focus{
    --transform-translate-y: -0.5rem !important;
  }

  .md\\:focus\\:-translate-y-3:focus{
    --transform-translate-y: -0.75rem !important;
  }

  .md\\:focus\\:-translate-y-4:focus{
    --transform-translate-y: -1rem !important;
  }

  .md\\:focus\\:-translate-y-5:focus{
    --transform-translate-y: -1.25rem !important;
  }

  .md\\:focus\\:-translate-y-6:focus{
    --transform-translate-y: -1.5rem !important;
  }

  .md\\:focus\\:-translate-y-8:focus{
    --transform-translate-y: -2rem !important;
  }

  .md\\:focus\\:-translate-y-10:focus{
    --transform-translate-y: -2.5rem !important;
  }

  .md\\:focus\\:-translate-y-12:focus{
    --transform-translate-y: -3rem !important;
  }

  .md\\:focus\\:-translate-y-16:focus{
    --transform-translate-y: -4rem !important;
  }

  .md\\:focus\\:-translate-y-20:focus{
    --transform-translate-y: -5rem !important;
  }

  .md\\:focus\\:-translate-y-24:focus{
    --transform-translate-y: -6rem !important;
  }

  .md\\:focus\\:-translate-y-32:focus{
    --transform-translate-y: -8rem !important;
  }

  .md\\:focus\\:-translate-y-40:focus{
    --transform-translate-y: -10rem !important;
  }

  .md\\:focus\\:-translate-y-48:focus{
    --transform-translate-y: -12rem !important;
  }

  .md\\:focus\\:-translate-y-56:focus{
    --transform-translate-y: -14rem !important;
  }

  .md\\:focus\\:-translate-y-64:focus{
    --transform-translate-y: -16rem !important;
  }

  .md\\:focus\\:-translate-y-px:focus{
    --transform-translate-y: -1px !important;
  }

  .md\\:focus\\:-translate-y-full:focus{
    --transform-translate-y: -100% !important;
  }

  .md\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y: -50% !important;
  }

  .md\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y: 50% !important;
  }

  .md\\:focus\\:translate-y-full:focus{
    --transform-translate-y: 100% !important;
  }

  .md\\:skew-x-0{
    --transform-skew-x: 0 !important;
  }

  .md\\:skew-x-1{
    --transform-skew-x: 1deg !important;
  }

  .md\\:skew-x-2{
    --transform-skew-x: 2deg !important;
  }

  .md\\:skew-x-3{
    --transform-skew-x: 3deg !important;
  }

  .md\\:skew-x-6{
    --transform-skew-x: 6deg !important;
  }

  .md\\:skew-x-12{
    --transform-skew-x: 12deg !important;
  }

  .md\\:-skew-x-12{
    --transform-skew-x: -12deg !important;
  }

  .md\\:-skew-x-6{
    --transform-skew-x: -6deg !important;
  }

  .md\\:-skew-x-3{
    --transform-skew-x: -3deg !important;
  }

  .md\\:-skew-x-2{
    --transform-skew-x: -2deg !important;
  }

  .md\\:-skew-x-1{
    --transform-skew-x: -1deg !important;
  }

  .md\\:skew-y-0{
    --transform-skew-y: 0 !important;
  }

  .md\\:skew-y-1{
    --transform-skew-y: 1deg !important;
  }

  .md\\:skew-y-2{
    --transform-skew-y: 2deg !important;
  }

  .md\\:skew-y-3{
    --transform-skew-y: 3deg !important;
  }

  .md\\:skew-y-6{
    --transform-skew-y: 6deg !important;
  }

  .md\\:skew-y-12{
    --transform-skew-y: 12deg !important;
  }

  .md\\:-skew-y-12{
    --transform-skew-y: -12deg !important;
  }

  .md\\:-skew-y-6{
    --transform-skew-y: -6deg !important;
  }

  .md\\:-skew-y-3{
    --transform-skew-y: -3deg !important;
  }

  .md\\:-skew-y-2{
    --transform-skew-y: -2deg !important;
  }

  .md\\:-skew-y-1{
    --transform-skew-y: -1deg !important;
  }

  .md\\:hover\\:skew-x-0:hover{
    --transform-skew-x: 0 !important;
  }

  .md\\:hover\\:skew-x-1:hover{
    --transform-skew-x: 1deg !important;
  }

  .md\\:hover\\:skew-x-2:hover{
    --transform-skew-x: 2deg !important;
  }

  .md\\:hover\\:skew-x-3:hover{
    --transform-skew-x: 3deg !important;
  }

  .md\\:hover\\:skew-x-6:hover{
    --transform-skew-x: 6deg !important;
  }

  .md\\:hover\\:skew-x-12:hover{
    --transform-skew-x: 12deg !important;
  }

  .md\\:hover\\:-skew-x-12:hover{
    --transform-skew-x: -12deg !important;
  }

  .md\\:hover\\:-skew-x-6:hover{
    --transform-skew-x: -6deg !important;
  }

  .md\\:hover\\:-skew-x-3:hover{
    --transform-skew-x: -3deg !important;
  }

  .md\\:hover\\:-skew-x-2:hover{
    --transform-skew-x: -2deg !important;
  }

  .md\\:hover\\:-skew-x-1:hover{
    --transform-skew-x: -1deg !important;
  }

  .md\\:hover\\:skew-y-0:hover{
    --transform-skew-y: 0 !important;
  }

  .md\\:hover\\:skew-y-1:hover{
    --transform-skew-y: 1deg !important;
  }

  .md\\:hover\\:skew-y-2:hover{
    --transform-skew-y: 2deg !important;
  }

  .md\\:hover\\:skew-y-3:hover{
    --transform-skew-y: 3deg !important;
  }

  .md\\:hover\\:skew-y-6:hover{
    --transform-skew-y: 6deg !important;
  }

  .md\\:hover\\:skew-y-12:hover{
    --transform-skew-y: 12deg !important;
  }

  .md\\:hover\\:-skew-y-12:hover{
    --transform-skew-y: -12deg !important;
  }

  .md\\:hover\\:-skew-y-6:hover{
    --transform-skew-y: -6deg !important;
  }

  .md\\:hover\\:-skew-y-3:hover{
    --transform-skew-y: -3deg !important;
  }

  .md\\:hover\\:-skew-y-2:hover{
    --transform-skew-y: -2deg !important;
  }

  .md\\:hover\\:-skew-y-1:hover{
    --transform-skew-y: -1deg !important;
  }

  .md\\:focus\\:skew-x-0:focus{
    --transform-skew-x: 0 !important;
  }

  .md\\:focus\\:skew-x-1:focus{
    --transform-skew-x: 1deg !important;
  }

  .md\\:focus\\:skew-x-2:focus{
    --transform-skew-x: 2deg !important;
  }

  .md\\:focus\\:skew-x-3:focus{
    --transform-skew-x: 3deg !important;
  }

  .md\\:focus\\:skew-x-6:focus{
    --transform-skew-x: 6deg !important;
  }

  .md\\:focus\\:skew-x-12:focus{
    --transform-skew-x: 12deg !important;
  }

  .md\\:focus\\:-skew-x-12:focus{
    --transform-skew-x: -12deg !important;
  }

  .md\\:focus\\:-skew-x-6:focus{
    --transform-skew-x: -6deg !important;
  }

  .md\\:focus\\:-skew-x-3:focus{
    --transform-skew-x: -3deg !important;
  }

  .md\\:focus\\:-skew-x-2:focus{
    --transform-skew-x: -2deg !important;
  }

  .md\\:focus\\:-skew-x-1:focus{
    --transform-skew-x: -1deg !important;
  }

  .md\\:focus\\:skew-y-0:focus{
    --transform-skew-y: 0 !important;
  }

  .md\\:focus\\:skew-y-1:focus{
    --transform-skew-y: 1deg !important;
  }

  .md\\:focus\\:skew-y-2:focus{
    --transform-skew-y: 2deg !important;
  }

  .md\\:focus\\:skew-y-3:focus{
    --transform-skew-y: 3deg !important;
  }

  .md\\:focus\\:skew-y-6:focus{
    --transform-skew-y: 6deg !important;
  }

  .md\\:focus\\:skew-y-12:focus{
    --transform-skew-y: 12deg !important;
  }

  .md\\:focus\\:-skew-y-12:focus{
    --transform-skew-y: -12deg !important;
  }

  .md\\:focus\\:-skew-y-6:focus{
    --transform-skew-y: -6deg !important;
  }

  .md\\:focus\\:-skew-y-3:focus{
    --transform-skew-y: -3deg !important;
  }

  .md\\:focus\\:-skew-y-2:focus{
    --transform-skew-y: -2deg !important;
  }

  .md\\:focus\\:-skew-y-1:focus{
    --transform-skew-y: -1deg !important;
  }

  [dir] .md\\:transition-none{
    transition-property: none !important;
  }

  [dir] .md\\:transition-all{
    transition-property: all !important;
  }

  [dir] .md\\:transition{
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform !important;
  }

  [dir] .md\\:transition-colors{
    transition-property: background-color, border-color, color, fill, stroke !important;
  }

  [dir] .md\\:transition-opacity{
    transition-property: opacity !important;
  }

  [dir] .md\\:transition-shadow{
    transition-property: box-shadow !important;
  }

  [dir] .md\\:transition-transform{
    transition-property: transform !important;
  }

  [dir] .md\\:ease-linear{
    transition-timing-function: linear !important;
  }

  [dir] .md\\:ease-in{
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1) !important;
  }

  [dir] .md\\:ease-out{
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
  }

  [dir] .md\\:ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }

  [dir] .md\\:duration-75{
    transition-duration: 75ms !important;
  }

  [dir] .md\\:duration-100{
    transition-duration: 100ms !important;
  }

  [dir] .md\\:duration-150{
    transition-duration: 150ms !important;
  }

  [dir] .md\\:duration-200{
    transition-duration: 200ms !important;
  }

  [dir] .md\\:duration-300{
    transition-duration: 300ms !important;
  }

  [dir] .md\\:duration-500{
    transition-duration: 500ms !important;
  }

  [dir] .md\\:duration-700{
    transition-duration: 700ms !important;
  }

  [dir] .md\\:duration-1000{
    transition-duration: 1000ms !important;
  }

  [dir] .md\\:delay-75{
    transition-delay: 75ms !important;
  }

  [dir] .md\\:delay-100{
    transition-delay: 100ms !important;
  }

  [dir] .md\\:delay-150{
    transition-delay: 150ms !important;
  }

  [dir] .md\\:delay-200{
    transition-delay: 200ms !important;
  }

  [dir] .md\\:delay-300{
    transition-delay: 300ms !important;
  }

  [dir] .md\\:delay-500{
    transition-delay: 500ms !important;
  }

  [dir] .md\\:delay-700{
    transition-delay: 700ms !important;
  }

  [dir] .md\\:delay-1000{
    transition-delay: 1000ms !important;
  }

  [dir=ltr] .md\\:animate-none{
    animation: none !important;
  }

  [dir=rtl] .md\\:animate-none{
    animation: none !important;
  }

  [dir=ltr] .md\\:animate-spin{
    animation:  spin-ltr 1s linear infinite !important;
  }

  [dir=rtl] .md\\:animate-spin{
    animation:  spin-rtl 1s linear infinite !important;
  }

  [dir=ltr] .md\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite !important;
  }

  [dir=rtl] .md\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite !important;
  }

  [dir=ltr] .md\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
  }

  [dir=rtl] .md\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
  }

  [dir=ltr] .md\\:animate-bounce{
    animation: bounce 1s infinite !important;
  }

  [dir=rtl] .md\\:animate-bounce{
    animation: bounce 1s infinite !important;
  }
}

@media (min-width: 992px){
  .lg\\:container{
    width: 100%;
  }
  [dir=ltr] .lg\\:container{
    margin-right: auto;
    margin-left: auto;
    padding-right: 1rem;
    padding-left: 1rem;
  }
  [dir=rtl] .lg\\:container{
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media (min-width: 576px){
    .lg\\:container{
      max-width: 576px;
    }
  }

  @media (min-width: 768px){
    .lg\\:container{
      max-width: 768px;
    }
  }

  @media (min-width: 992px){
    .lg\\:container{
      max-width: 992px;
    }
  }

  @media (min-width: 1200px){
    .lg\\:container{
      max-width: 1200px;
    }
  }

  .lg\\:space-y-0 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-0 > :not(template) ~ :not(template){
    margin-top: calc(0px * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0px * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-0 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-0 > :not(template) ~ :not(template){
    margin-right: calc(0px * var(--space-x-reverse)) !important;
    margin-left: calc(0px * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-0 > :not(template) ~ :not(template){
    margin-left: calc(0px * var(--space-x-reverse)) !important;
    margin-right: calc(0px * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-1 > :not(template) ~ :not(template){
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0.25rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-1 > :not(template) ~ :not(template){
    margin-right: calc(0.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-1 > :not(template) ~ :not(template){
    margin-left: calc(0.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-2 > :not(template) ~ :not(template){
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0.5rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-2 > :not(template) ~ :not(template){
    margin-right: calc(0.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-2 > :not(template) ~ :not(template){
    margin-left: calc(0.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-3 > :not(template) ~ :not(template){
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0.75rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-3 > :not(template) ~ :not(template){
    margin-right: calc(0.75rem * var(--space-x-reverse)) !important;
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-3 > :not(template) ~ :not(template){
    margin-left: calc(0.75rem * var(--space-x-reverse)) !important;
    margin-right: calc(0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-4 > :not(template) ~ :not(template){
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-4 > :not(template) ~ :not(template){
    margin-right: calc(1rem * var(--space-x-reverse)) !important;
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-4 > :not(template) ~ :not(template){
    margin-left: calc(1rem * var(--space-x-reverse)) !important;
    margin-right: calc(1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-5 > :not(template) ~ :not(template){
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1.25rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-5 > :not(template) ~ :not(template){
    margin-right: calc(1.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-5 > :not(template) ~ :not(template){
    margin-left: calc(1.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-6 > :not(template) ~ :not(template){
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1.5rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-6 > :not(template) ~ :not(template){
    margin-right: calc(1.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-6 > :not(template) ~ :not(template){
    margin-left: calc(1.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-8 > :not(template) ~ :not(template){
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(2rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-8 > :not(template) ~ :not(template){
    margin-right: calc(2rem * var(--space-x-reverse)) !important;
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-8 > :not(template) ~ :not(template){
    margin-left: calc(2rem * var(--space-x-reverse)) !important;
    margin-right: calc(2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-10 > :not(template) ~ :not(template){
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(2.5rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-10 > :not(template) ~ :not(template){
    margin-right: calc(2.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-10 > :not(template) ~ :not(template){
    margin-left: calc(2.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-12 > :not(template) ~ :not(template){
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(3rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-12 > :not(template) ~ :not(template){
    margin-right: calc(3rem * var(--space-x-reverse)) !important;
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-12 > :not(template) ~ :not(template){
    margin-left: calc(3rem * var(--space-x-reverse)) !important;
    margin-right: calc(3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-16 > :not(template) ~ :not(template){
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(4rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-16 > :not(template) ~ :not(template){
    margin-right: calc(4rem * var(--space-x-reverse)) !important;
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-16 > :not(template) ~ :not(template){
    margin-left: calc(4rem * var(--space-x-reverse)) !important;
    margin-right: calc(4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-20 > :not(template) ~ :not(template){
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(5rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-20 > :not(template) ~ :not(template){
    margin-right: calc(5rem * var(--space-x-reverse)) !important;
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-20 > :not(template) ~ :not(template){
    margin-left: calc(5rem * var(--space-x-reverse)) !important;
    margin-right: calc(5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-24 > :not(template) ~ :not(template){
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(6rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-24 > :not(template) ~ :not(template){
    margin-right: calc(6rem * var(--space-x-reverse)) !important;
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-24 > :not(template) ~ :not(template){
    margin-left: calc(6rem * var(--space-x-reverse)) !important;
    margin-right: calc(6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-32 > :not(template) ~ :not(template){
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(8rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-32 > :not(template) ~ :not(template){
    margin-right: calc(8rem * var(--space-x-reverse)) !important;
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-32 > :not(template) ~ :not(template){
    margin-left: calc(8rem * var(--space-x-reverse)) !important;
    margin-right: calc(8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-40 > :not(template) ~ :not(template){
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(10rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-40 > :not(template) ~ :not(template){
    margin-right: calc(10rem * var(--space-x-reverse)) !important;
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-40 > :not(template) ~ :not(template){
    margin-left: calc(10rem * var(--space-x-reverse)) !important;
    margin-right: calc(10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-48 > :not(template) ~ :not(template){
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(12rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-48 > :not(template) ~ :not(template){
    margin-right: calc(12rem * var(--space-x-reverse)) !important;
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-48 > :not(template) ~ :not(template){
    margin-left: calc(12rem * var(--space-x-reverse)) !important;
    margin-right: calc(12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-56 > :not(template) ~ :not(template){
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(14rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-56 > :not(template) ~ :not(template){
    margin-right: calc(14rem * var(--space-x-reverse)) !important;
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-56 > :not(template) ~ :not(template){
    margin-left: calc(14rem * var(--space-x-reverse)) !important;
    margin-right: calc(14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-64 > :not(template) ~ :not(template){
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(16rem * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-64 > :not(template) ~ :not(template){
    margin-right: calc(16rem * var(--space-x-reverse)) !important;
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-64 > :not(template) ~ :not(template){
    margin-left: calc(16rem * var(--space-x-reverse)) !important;
    margin-right: calc(16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:space-y-px > :not(template) ~ :not(template){
    margin-top: calc(1px * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1px * var(--space-y-reverse)) !important;
  }

  .lg\\:space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:space-x-px > :not(template) ~ :not(template){
    margin-right: calc(1px * var(--space-x-reverse)) !important;
    margin-left: calc(1px * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:space-x-px > :not(template) ~ :not(template){
    margin-left: calc(1px * var(--space-x-reverse)) !important;
    margin-right: calc(1px * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-1 > :not(template) ~ :not(template){
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-0.25rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-1 > :not(template) ~ :not(template){
    margin-right: calc(-0.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-1 > :not(template) ~ :not(template){
    margin-left: calc(-0.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(-0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-2 > :not(template) ~ :not(template){
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-0.5rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-2 > :not(template) ~ :not(template){
    margin-right: calc(-0.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-2 > :not(template) ~ :not(template){
    margin-left: calc(-0.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-3 > :not(template) ~ :not(template){
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-0.75rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-3 > :not(template) ~ :not(template){
    margin-right: calc(-0.75rem * var(--space-x-reverse)) !important;
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-3 > :not(template) ~ :not(template){
    margin-left: calc(-0.75rem * var(--space-x-reverse)) !important;
    margin-right: calc(-0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-4 > :not(template) ~ :not(template){
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-4 > :not(template) ~ :not(template){
    margin-right: calc(-1rem * var(--space-x-reverse)) !important;
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-4 > :not(template) ~ :not(template){
    margin-left: calc(-1rem * var(--space-x-reverse)) !important;
    margin-right: calc(-1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-5 > :not(template) ~ :not(template){
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1.25rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-5 > :not(template) ~ :not(template){
    margin-right: calc(-1.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-5 > :not(template) ~ :not(template){
    margin-left: calc(-1.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(-1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-6 > :not(template) ~ :not(template){
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1.5rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-6 > :not(template) ~ :not(template){
    margin-right: calc(-1.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-6 > :not(template) ~ :not(template){
    margin-left: calc(-1.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-8 > :not(template) ~ :not(template){
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-2rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-8 > :not(template) ~ :not(template){
    margin-right: calc(-2rem * var(--space-x-reverse)) !important;
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-8 > :not(template) ~ :not(template){
    margin-left: calc(-2rem * var(--space-x-reverse)) !important;
    margin-right: calc(-2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-10 > :not(template) ~ :not(template){
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-2.5rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-10 > :not(template) ~ :not(template){
    margin-right: calc(-2.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-10 > :not(template) ~ :not(template){
    margin-left: calc(-2.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-12 > :not(template) ~ :not(template){
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-3rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-12 > :not(template) ~ :not(template){
    margin-right: calc(-3rem * var(--space-x-reverse)) !important;
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-12 > :not(template) ~ :not(template){
    margin-left: calc(-3rem * var(--space-x-reverse)) !important;
    margin-right: calc(-3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-16 > :not(template) ~ :not(template){
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-4rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-16 > :not(template) ~ :not(template){
    margin-right: calc(-4rem * var(--space-x-reverse)) !important;
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-16 > :not(template) ~ :not(template){
    margin-left: calc(-4rem * var(--space-x-reverse)) !important;
    margin-right: calc(-4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-20 > :not(template) ~ :not(template){
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-5rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-20 > :not(template) ~ :not(template){
    margin-right: calc(-5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-20 > :not(template) ~ :not(template){
    margin-left: calc(-5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-24 > :not(template) ~ :not(template){
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-6rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-24 > :not(template) ~ :not(template){
    margin-right: calc(-6rem * var(--space-x-reverse)) !important;
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-24 > :not(template) ~ :not(template){
    margin-left: calc(-6rem * var(--space-x-reverse)) !important;
    margin-right: calc(-6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-32 > :not(template) ~ :not(template){
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-8rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-32 > :not(template) ~ :not(template){
    margin-right: calc(-8rem * var(--space-x-reverse)) !important;
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-32 > :not(template) ~ :not(template){
    margin-left: calc(-8rem * var(--space-x-reverse)) !important;
    margin-right: calc(-8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-40 > :not(template) ~ :not(template){
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-10rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-40 > :not(template) ~ :not(template){
    margin-right: calc(-10rem * var(--space-x-reverse)) !important;
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-40 > :not(template) ~ :not(template){
    margin-left: calc(-10rem * var(--space-x-reverse)) !important;
    margin-right: calc(-10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-48 > :not(template) ~ :not(template){
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-12rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-48 > :not(template) ~ :not(template){
    margin-right: calc(-12rem * var(--space-x-reverse)) !important;
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-48 > :not(template) ~ :not(template){
    margin-left: calc(-12rem * var(--space-x-reverse)) !important;
    margin-right: calc(-12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-56 > :not(template) ~ :not(template){
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-14rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-56 > :not(template) ~ :not(template){
    margin-right: calc(-14rem * var(--space-x-reverse)) !important;
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-56 > :not(template) ~ :not(template){
    margin-left: calc(-14rem * var(--space-x-reverse)) !important;
    margin-right: calc(-14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-64 > :not(template) ~ :not(template){
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-16rem * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-64 > :not(template) ~ :not(template){
    margin-right: calc(-16rem * var(--space-x-reverse)) !important;
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-64 > :not(template) ~ :not(template){
    margin-left: calc(-16rem * var(--space-x-reverse)) !important;
    margin-right: calc(-16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:-space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .lg\\:-space-y-px > :not(template) ~ :not(template){
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1px * var(--space-y-reverse)) !important;
  }

  .lg\\:-space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:-space-x-px > :not(template) ~ :not(template){
    margin-right: calc(-1px * var(--space-x-reverse)) !important;
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:-space-x-px > :not(template) ~ :not(template){
    margin-left: calc(-1px * var(--space-x-reverse)) !important;
    margin-right: calc(-1px * calc(1 - var(--space-x-reverse))) !important;
  }

  .lg\\:space-y-reverse > :not(template) ~ :not(template){
    --space-y-reverse: 1 !important;
  }

  .lg\\:space-x-reverse > :not(template) ~ :not(template){
    --space-x-reverse: 1 !important;
  }

  .lg\\:divide-y-0 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .lg\\:divide-y-0 > :not(template) ~ :not(template){
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(0px * var(--divide-y-reverse)) !important;
  }

  .lg\\:divide-x-0 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:divide-x-0 > :not(template) ~ :not(template){
    border-right-width: calc(0px * var(--divide-x-reverse)) !important;
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:divide-x-0 > :not(template) ~ :not(template){
    border-left-width: calc(0px * var(--divide-x-reverse)) !important;
    border-right-width: calc(0px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .lg\\:divide-y-2 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .lg\\:divide-y-2 > :not(template) ~ :not(template){
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(2px * var(--divide-y-reverse)) !important;
  }

  .lg\\:divide-x-2 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:divide-x-2 > :not(template) ~ :not(template){
    border-right-width: calc(2px * var(--divide-x-reverse)) !important;
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:divide-x-2 > :not(template) ~ :not(template){
    border-left-width: calc(2px * var(--divide-x-reverse)) !important;
    border-right-width: calc(2px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .lg\\:divide-y-4 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .lg\\:divide-y-4 > :not(template) ~ :not(template){
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(4px * var(--divide-y-reverse)) !important;
  }

  .lg\\:divide-x-4 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:divide-x-4 > :not(template) ~ :not(template){
    border-right-width: calc(4px * var(--divide-x-reverse)) !important;
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:divide-x-4 > :not(template) ~ :not(template){
    border-left-width: calc(4px * var(--divide-x-reverse)) !important;
    border-right-width: calc(4px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .lg\\:divide-y-8 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .lg\\:divide-y-8 > :not(template) ~ :not(template){
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(8px * var(--divide-y-reverse)) !important;
  }

  .lg\\:divide-x-8 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:divide-x-8 > :not(template) ~ :not(template){
    border-right-width: calc(8px * var(--divide-x-reverse)) !important;
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:divide-x-8 > :not(template) ~ :not(template){
    border-left-width: calc(8px * var(--divide-x-reverse)) !important;
    border-right-width: calc(8px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .lg\\:divide-y > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .lg\\:divide-y > :not(template) ~ :not(template){
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(1px * var(--divide-y-reverse)) !important;
  }

  .lg\\:divide-x > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .lg\\:divide-x > :not(template) ~ :not(template){
    border-right-width: calc(1px * var(--divide-x-reverse)) !important;
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .lg\\:divide-x > :not(template) ~ :not(template){
    border-left-width: calc(1px * var(--divide-x-reverse)) !important;
    border-right-width: calc(1px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .lg\\:divide-y-reverse > :not(template) ~ :not(template){
    --divide-y-reverse: 1 !important;
  }

  .lg\\:divide-x-reverse > :not(template) ~ :not(template){
    --divide-x-reverse: 1 !important;
  }

  [dir] .lg\\:divide-transparent > :not(template) ~ :not(template){
    border-color: transparent !important;
  }

  .lg\\:divide-black > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .lg\\:divide-black > :not(template) ~ :not(template){
    border-color: #22292f !important;
    border-color: rgba(34, 41, 47, var(--divide-opacity)) !important;
  }

  .lg\\:divide-white > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .lg\\:divide-white > :not(template) ~ :not(template){
    border-color: #ffffff !important;
    border-color: rgba(255, 255, 255, var(--divide-opacity)) !important;
  }

  .lg\\:divide-grey > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .lg\\:divide-grey > :not(template) ~ :not(template){
    border-color: #b8c2cc !important;
    border-color: rgba(184, 194, 204, var(--divide-opacity)) !important;
  }

  .lg\\:divide-grey-light > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .lg\\:divide-grey-light > :not(template) ~ :not(template){
    border-color: #dae1e7 !important;
    border-color: rgba(218, 225, 231, var(--divide-opacity)) !important;
  }

  [dir] .lg\\:divide-solid > :not(template) ~ :not(template){
    border-style: solid !important;
  }

  [dir] .lg\\:divide-dashed > :not(template) ~ :not(template){
    border-style: dashed !important;
  }

  [dir] .lg\\:divide-dotted > :not(template) ~ :not(template){
    border-style: dotted !important;
  }

  [dir] .lg\\:divide-double > :not(template) ~ :not(template){
    border-style: double !important;
  }

  [dir] .lg\\:divide-none > :not(template) ~ :not(template){
    border-style: none !important;
  }

  .lg\\:divide-opacity-0 > :not(template) ~ :not(template){
    --divide-opacity: 0 !important;
  }

  .lg\\:divide-opacity-25 > :not(template) ~ :not(template){
    --divide-opacity: 0.25 !important;
  }

  .lg\\:divide-opacity-50 > :not(template) ~ :not(template){
    --divide-opacity: 0.5 !important;
  }

  .lg\\:divide-opacity-75 > :not(template) ~ :not(template){
    --divide-opacity: 0.75 !important;
  }

  .lg\\:divide-opacity-100 > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  .lg\\:sr-only{
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
  }

  [dir] .lg\\:sr-only{
    padding: 0 !important;
    margin: -1px !important;
    border-width: 0 !important;
  }

  .lg\\:not-sr-only{
    position: static !important;
    width: auto !important;
    height: auto !important;
    overflow: visible !important;
    clip: auto !important;
    white-space: normal !important;
  }

  [dir] .lg\\:not-sr-only{
    padding: 0 !important;
    margin: 0 !important;
  }

  .lg\\:focus\\:sr-only:focus{
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
  }

  [dir] .lg\\:focus\\:sr-only:focus{
    padding: 0 !important;
    margin: -1px !important;
    border-width: 0 !important;
  }

  .lg\\:focus\\:not-sr-only:focus{
    position: static !important;
    width: auto !important;
    height: auto !important;
    overflow: visible !important;
    clip: auto !important;
    white-space: normal !important;
  }

  [dir] .lg\\:focus\\:not-sr-only:focus{
    padding: 0 !important;
    margin: 0 !important;
  }

  .lg\\:appearance-none{
    -webkit-appearance: none !important;
            appearance: none !important;
  }

  [dir] .lg\\:bg-fixed{
    background-attachment: fixed !important;
  }

  [dir] .lg\\:bg-local{
    background-attachment: local !important;
  }

  [dir] .lg\\:bg-scroll{
    background-attachment: scroll !important;
  }

  [dir] .lg\\:bg-clip-border{
    background-clip: border-box !important;
  }

  [dir] .lg\\:bg-clip-padding{
    background-clip: padding-box !important;
  }

  [dir] .lg\\:bg-clip-content{
    background-clip: content-box !important;
  }

  [dir] .lg\\:bg-clip-text{
    -webkit-background-clip: text !important;
            background-clip: text !important;
  }

  [dir] .lg\\:bg-transparent{
    background-color: transparent !important;
  }

  .lg\\:bg-black{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:bg-black{
    background-color: #22292f !important;
    background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
  }

  .lg\\:bg-white{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:bg-white{
    background-color: #ffffff !important;
    background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
  }

  .lg\\:bg-grey{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:bg-grey{
    background-color: #b8c2cc !important;
    background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
  }

  .lg\\:bg-grey-light{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:bg-grey-light{
    background-color: #dae1e7 !important;
    background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
  }

  [dir] .lg\\:hover\\:bg-transparent:hover{
    background-color: transparent !important;
  }

  .lg\\:hover\\:bg-black:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:hover\\:bg-black:hover{
    background-color: #22292f !important;
    background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
  }

  .lg\\:hover\\:bg-white:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:hover\\:bg-white:hover{
    background-color: #ffffff !important;
    background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
  }

  .lg\\:hover\\:bg-grey:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:hover\\:bg-grey:hover{
    background-color: #b8c2cc !important;
    background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
  }

  .lg\\:hover\\:bg-grey-light:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:hover\\:bg-grey-light:hover{
    background-color: #dae1e7 !important;
    background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
  }

  [dir] .lg\\:focus\\:bg-transparent:focus{
    background-color: transparent !important;
  }

  .lg\\:focus\\:bg-black:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:focus\\:bg-black:focus{
    background-color: #22292f !important;
    background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
  }

  .lg\\:focus\\:bg-white:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:focus\\:bg-white:focus{
    background-color: #ffffff !important;
    background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
  }

  .lg\\:focus\\:bg-grey:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:focus\\:bg-grey:focus{
    background-color: #b8c2cc !important;
    background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
  }

  .lg\\:focus\\:bg-grey-light:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:focus\\:bg-grey-light:focus{
    background-color: #dae1e7 !important;
    background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
  }

  [dir] .lg\\:bg-none{
    background-image: none !important;
  }

  [dir] .lg\\:bg-gradient-to-t{
    background-image: linear-gradient(to top, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .lg\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top right, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .lg\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top left, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .lg\\:bg-gradient-to-r{
    background-image: linear-gradient(to right, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .lg\\:bg-gradient-to-r{
    background-image: linear-gradient(to left, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .lg\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .lg\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops)) !important;
  }

  [dir] .lg\\:bg-gradient-to-b{
    background-image: linear-gradient(to bottom, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .lg\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .lg\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .lg\\:bg-gradient-to-l{
    background-image: linear-gradient(to left, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .lg\\:bg-gradient-to-l{
    background-image: linear-gradient(to right, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .lg\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top left, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .lg\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top right, var(--gradient-color-stops)) !important;
  }

  .lg\\:from-transparent{
    --gradient-from-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .lg\\:from-black{
    --gradient-from-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .lg\\:from-white{
    --gradient-from-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .lg\\:from-grey{
    --gradient-from-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .lg\\:from-grey-light{
    --gradient-from-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .lg\\:via-transparent{
    --gradient-via-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .lg\\:via-black{
    --gradient-via-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .lg\\:via-white{
    --gradient-via-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .lg\\:via-grey{
    --gradient-via-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .lg\\:via-grey-light{
    --gradient-via-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .lg\\:to-transparent{
    --gradient-to-color: transparent !important;
  }

  .lg\\:to-black{
    --gradient-to-color: #22292f !important;
  }

  .lg\\:to-white{
    --gradient-to-color: #ffffff !important;
  }

  .lg\\:to-grey{
    --gradient-to-color: #b8c2cc !important;
  }

  .lg\\:to-grey-light{
    --gradient-to-color: #dae1e7 !important;
  }

  .lg\\:hover\\:from-transparent:hover{
    --gradient-from-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .lg\\:hover\\:from-black:hover{
    --gradient-from-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .lg\\:hover\\:from-white:hover{
    --gradient-from-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .lg\\:hover\\:from-grey:hover{
    --gradient-from-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .lg\\:hover\\:from-grey-light:hover{
    --gradient-from-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .lg\\:hover\\:via-transparent:hover{
    --gradient-via-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .lg\\:hover\\:via-black:hover{
    --gradient-via-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .lg\\:hover\\:via-white:hover{
    --gradient-via-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .lg\\:hover\\:via-grey:hover{
    --gradient-via-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .lg\\:hover\\:via-grey-light:hover{
    --gradient-via-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .lg\\:hover\\:to-transparent:hover{
    --gradient-to-color: transparent !important;
  }

  .lg\\:hover\\:to-black:hover{
    --gradient-to-color: #22292f !important;
  }

  .lg\\:hover\\:to-white:hover{
    --gradient-to-color: #ffffff !important;
  }

  .lg\\:hover\\:to-grey:hover{
    --gradient-to-color: #b8c2cc !important;
  }

  .lg\\:hover\\:to-grey-light:hover{
    --gradient-to-color: #dae1e7 !important;
  }

  .lg\\:focus\\:from-transparent:focus{
    --gradient-from-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .lg\\:focus\\:from-black:focus{
    --gradient-from-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .lg\\:focus\\:from-white:focus{
    --gradient-from-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .lg\\:focus\\:from-grey:focus{
    --gradient-from-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .lg\\:focus\\:from-grey-light:focus{
    --gradient-from-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .lg\\:focus\\:via-transparent:focus{
    --gradient-via-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .lg\\:focus\\:via-black:focus{
    --gradient-via-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .lg\\:focus\\:via-white:focus{
    --gradient-via-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .lg\\:focus\\:via-grey:focus{
    --gradient-via-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .lg\\:focus\\:via-grey-light:focus{
    --gradient-via-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .lg\\:focus\\:to-transparent:focus{
    --gradient-to-color: transparent !important;
  }

  .lg\\:focus\\:to-black:focus{
    --gradient-to-color: #22292f !important;
  }

  .lg\\:focus\\:to-white:focus{
    --gradient-to-color: #ffffff !important;
  }

  .lg\\:focus\\:to-grey:focus{
    --gradient-to-color: #b8c2cc !important;
  }

  .lg\\:focus\\:to-grey-light:focus{
    --gradient-to-color: #dae1e7 !important;
  }

  .lg\\:bg-opacity-0{
    --bg-opacity: 0 !important;
  }

  .lg\\:bg-opacity-25{
    --bg-opacity: 0.25 !important;
  }

  .lg\\:bg-opacity-50{
    --bg-opacity: 0.5 !important;
  }

  .lg\\:bg-opacity-75{
    --bg-opacity: 0.75 !important;
  }

  .lg\\:bg-opacity-100{
    --bg-opacity: 1 !important;
  }

  .lg\\:hover\\:bg-opacity-0:hover{
    --bg-opacity: 0 !important;
  }

  .lg\\:hover\\:bg-opacity-25:hover{
    --bg-opacity: 0.25 !important;
  }

  .lg\\:hover\\:bg-opacity-50:hover{
    --bg-opacity: 0.5 !important;
  }

  .lg\\:hover\\:bg-opacity-75:hover{
    --bg-opacity: 0.75 !important;
  }

  .lg\\:hover\\:bg-opacity-100:hover{
    --bg-opacity: 1 !important;
  }

  .lg\\:focus\\:bg-opacity-0:focus{
    --bg-opacity: 0 !important;
  }

  .lg\\:focus\\:bg-opacity-25:focus{
    --bg-opacity: 0.25 !important;
  }

  .lg\\:focus\\:bg-opacity-50:focus{
    --bg-opacity: 0.5 !important;
  }

  .lg\\:focus\\:bg-opacity-75:focus{
    --bg-opacity: 0.75 !important;
  }

  .lg\\:focus\\:bg-opacity-100:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .lg\\:bg-auto{
    background-size: auto !important;
  }

  [dir] .lg\\:bg-cover{
    background-size: cover !important;
  }

  [dir] .lg\\:bg-contain{
    background-size: contain !important;
  }

  [dir] .lg\\:border-transparent{
    border-color: transparent !important;
  }

  .lg\\:border-black{
    --border-opacity: 1 !important;
  }

  [dir] .lg\\:border-black{
    border-color: #22292f !important;
    border-color: rgba(34, 41, 47, var(--border-opacity)) !important;
  }

  .lg\\:border-white{
    --border-opacity: 1 !important;
  }

  [dir] .lg\\:border-white{
    border-color: #ffffff !important;
    border-color: rgba(255, 255, 255, var(--border-opacity)) !important;
  }

  .lg\\:border-grey{
    --border-opacity: 1 !important;
  }

  [dir] .lg\\:border-grey{
    border-color: #b8c2cc !important;
    border-color: rgba(184, 194, 204, var(--border-opacity)) !important;
  }

  .lg\\:border-grey-light{
    --border-opacity: 1 !important;
  }

  [dir] .lg\\:border-grey-light{
    border-color: #dae1e7 !important;
    border-color: rgba(218, 225, 231, var(--border-opacity)) !important;
  }

  [dir] .lg\\:hover\\:border-transparent:hover{
    border-color: transparent !important;
  }

  .lg\\:hover\\:border-black:hover{
    --border-opacity: 1 !important;
  }

  [dir] .lg\\:hover\\:border-black:hover{
    border-color: #22292f !important;
    border-color: rgba(34, 41, 47, var(--border-opacity)) !important;
  }

  .lg\\:hover\\:border-white:hover{
    --border-opacity: 1 !important;
  }

  [dir] .lg\\:hover\\:border-white:hover{
    border-color: #ffffff !important;
    border-color: rgba(255, 255, 255, var(--border-opacity)) !important;
  }

  .lg\\:hover\\:border-grey:hover{
    --border-opacity: 1 !important;
  }

  [dir] .lg\\:hover\\:border-grey:hover{
    border-color: #b8c2cc !important;
    border-color: rgba(184, 194, 204, var(--border-opacity)) !important;
  }

  .lg\\:hover\\:border-grey-light:hover{
    --border-opacity: 1 !important;
  }

  [dir] .lg\\:hover\\:border-grey-light:hover{
    border-color: #dae1e7 !important;
    border-color: rgba(218, 225, 231, var(--border-opacity)) !important;
  }

  .lg\\:border-opacity-0{
    --border-opacity: 0 !important;
  }

  .lg\\:border-opacity-25{
    --border-opacity: 0.25 !important;
  }

  .lg\\:border-opacity-50{
    --border-opacity: 0.5 !important;
  }

  .lg\\:border-opacity-75{
    --border-opacity: 0.75 !important;
  }

  .lg\\:border-opacity-100{
    --border-opacity: 1 !important;
  }

  .lg\\:hover\\:border-opacity-0:hover{
    --border-opacity: 0 !important;
  }

  .lg\\:hover\\:border-opacity-25:hover{
    --border-opacity: 0.25 !important;
  }

  .lg\\:hover\\:border-opacity-50:hover{
    --border-opacity: 0.5 !important;
  }

  .lg\\:hover\\:border-opacity-75:hover{
    --border-opacity: 0.75 !important;
  }

  .lg\\:hover\\:border-opacity-100:hover{
    --border-opacity: 1 !important;
  }

  .lg\\:focus\\:border-opacity-0:focus{
    --border-opacity: 0 !important;
  }

  .lg\\:focus\\:border-opacity-25:focus{
    --border-opacity: 0.25 !important;
  }

  .lg\\:focus\\:border-opacity-50:focus{
    --border-opacity: 0.5 !important;
  }

  .lg\\:focus\\:border-opacity-75:focus{
    --border-opacity: 0.75 !important;
  }

  .lg\\:focus\\:border-opacity-100:focus{
    --border-opacity: 1 !important;
  }

  [dir] .lg\\:border-solid{
    border-style: solid !important;
  }

  [dir] .lg\\:border-dashed{
    border-style: dashed !important;
  }

  [dir] .lg\\:border-dotted{
    border-style: dotted !important;
  }

  [dir] .lg\\:border-double{
    border-style: double !important;
  }

  [dir] .lg\\:border-none{
    border-style: none !important;
  }

  [dir] .lg\\:border-0{
    border-width: 0 !important;
  }

  [dir] .lg\\:border-2{
    border-width: 2px !important;
  }

  [dir] .lg\\:border-4{
    border-width: 4px !important;
  }

  [dir] .lg\\:border-8{
    border-width: 8px !important;
  }

  [dir] .lg\\:border{
    border-width: 1px !important;
  }

  [dir] .lg\\:border-t-0{
    border-top-width: 0 !important;
  }

  [dir=ltr] .lg\\:border-r-0{
    border-right-width: 0 !important;
  }

  [dir=rtl] .lg\\:border-r-0{
    border-left-width: 0 !important;
  }

  [dir] .lg\\:border-b-0{
    border-bottom-width: 0 !important;
  }

  [dir=ltr] .lg\\:border-l-0{
    border-left-width: 0 !important;
  }

  [dir=rtl] .lg\\:border-l-0{
    border-right-width: 0 !important;
  }

  [dir] .lg\\:border-t-2{
    border-top-width: 2px !important;
  }

  [dir=ltr] .lg\\:border-r-2{
    border-right-width: 2px !important;
  }

  [dir=rtl] .lg\\:border-r-2{
    border-left-width: 2px !important;
  }

  [dir] .lg\\:border-b-2{
    border-bottom-width: 2px !important;
  }

  [dir=ltr] .lg\\:border-l-2{
    border-left-width: 2px !important;
  }

  [dir=rtl] .lg\\:border-l-2{
    border-right-width: 2px !important;
  }

  [dir] .lg\\:border-t-4{
    border-top-width: 4px !important;
  }

  [dir=ltr] .lg\\:border-r-4{
    border-right-width: 4px !important;
  }

  [dir=rtl] .lg\\:border-r-4{
    border-left-width: 4px !important;
  }

  [dir] .lg\\:border-b-4{
    border-bottom-width: 4px !important;
  }

  [dir=ltr] .lg\\:border-l-4{
    border-left-width: 4px !important;
  }

  [dir=rtl] .lg\\:border-l-4{
    border-right-width: 4px !important;
  }

  [dir] .lg\\:border-t-8{
    border-top-width: 8px !important;
  }

  [dir=ltr] .lg\\:border-r-8{
    border-right-width: 8px !important;
  }

  [dir=rtl] .lg\\:border-r-8{
    border-left-width: 8px !important;
  }

  [dir] .lg\\:border-b-8{
    border-bottom-width: 8px !important;
  }

  [dir=ltr] .lg\\:border-l-8{
    border-left-width: 8px !important;
  }

  [dir=rtl] .lg\\:border-l-8{
    border-right-width: 8px !important;
  }

  [dir] .lg\\:border-t{
    border-top-width: 1px !important;
  }

  [dir=ltr] .lg\\:border-r{
    border-right-width: 1px !important;
  }

  [dir=rtl] .lg\\:border-r{
    border-left-width: 1px !important;
  }

  [dir] .lg\\:border-b{
    border-bottom-width: 1px !important;
  }

  [dir=ltr] .lg\\:border-l{
    border-left-width: 1px !important;
  }

  [dir=rtl] .lg\\:border-l{
    border-right-width: 1px !important;
  }

  .lg\\:box-border{
    box-sizing: border-box !important;
  }

  .lg\\:box-content{
    box-sizing: content-box !important;
  }

  .lg\\:block{
    display: block !important;
  }

  .lg\\:inline-block{
    display: inline-block !important;
  }

  .lg\\:inline{
    display: inline !important;
  }

  .lg\\:flex{
    display: flex !important;
  }

  .lg\\:inline-flex{
    display: inline-flex !important;
  }

  .lg\\:table{
    display: table !important;
  }

  .lg\\:table-caption{
    display: table-caption !important;
  }

  .lg\\:table-cell{
    display: table-cell !important;
  }

  .lg\\:table-column{
    display: table-column !important;
  }

  .lg\\:table-column-group{
    display: table-column-group !important;
  }

  .lg\\:table-footer-group{
    display: table-footer-group !important;
  }

  .lg\\:table-header-group{
    display: table-header-group !important;
  }

  .lg\\:table-row-group{
    display: table-row-group !important;
  }

  .lg\\:table-row{
    display: table-row !important;
  }

  .lg\\:flow-root{
    display: flow-root !important;
  }

  .lg\\:grid{
    display: grid !important;
  }

  .lg\\:inline-grid{
    display: inline-grid !important;
  }

  .lg\\:contents{
    display: contents !important;
  }

  .lg\\:hidden{
    display: none !important;
  }

  .lg\\:flex-row{
    flex-direction: row !important;
  }

  .lg\\:flex-row-reverse{
    flex-direction: row-reverse !important;
  }

  .lg\\:flex-col{
    flex-direction: column !important;
  }

  .lg\\:flex-col-reverse{
    flex-direction: column-reverse !important;
  }

  .lg\\:flex-wrap{
    flex-wrap: wrap !important;
  }

  .lg\\:flex-wrap-reverse{
    flex-wrap: wrap-reverse !important;
  }

  .lg\\:flex-no-wrap{
    flex-wrap: nowrap !important;
  }

  .lg\\:place-items-auto{
    place-items: auto !important;
  }

  .lg\\:place-items-start{
    place-items: start !important;
  }

  .lg\\:place-items-end{
    place-items: end !important;
  }

  .lg\\:place-items-center{
    place-items: center !important;
  }

  .lg\\:place-items-stretch{
    place-items: stretch !important;
  }

  .lg\\:place-content-center{
    place-content: center !important;
  }

  .lg\\:place-content-start{
    place-content: start !important;
  }

  .lg\\:place-content-end{
    place-content: end !important;
  }

  .lg\\:place-content-between{
    place-content: space-between !important;
  }

  .lg\\:place-content-around{
    place-content: space-around !important;
  }

  .lg\\:place-content-evenly{
    place-content: space-evenly !important;
  }

  .lg\\:place-content-stretch{
    place-content: stretch !important;
  }

  .lg\\:place-self-auto{
    place-self: auto !important;
  }

  .lg\\:place-self-start{
    place-self: start !important;
  }

  .lg\\:place-self-end{
    place-self: end !important;
  }

  .lg\\:place-self-center{
    place-self: center !important;
  }

  .lg\\:place-self-stretch{
    place-self: stretch !important;
  }

  .lg\\:items-start{
    align-items: flex-start !important;
  }

  .lg\\:items-end{
    align-items: flex-end !important;
  }

  .lg\\:items-center{
    align-items: center !important;
  }

  .lg\\:items-baseline{
    align-items: baseline !important;
  }

  .lg\\:items-stretch{
    align-items: stretch !important;
  }

  .lg\\:content-center{
    align-content: center !important;
  }

  .lg\\:content-start{
    align-content: flex-start !important;
  }

  .lg\\:content-end{
    align-content: flex-end !important;
  }

  .lg\\:content-between{
    align-content: space-between !important;
  }

  .lg\\:content-around{
    align-content: space-around !important;
  }

  .lg\\:content-evenly{
    align-content: space-evenly !important;
  }

  .lg\\:self-auto{
    align-self: auto !important;
  }

  .lg\\:self-start{
    align-self: flex-start !important;
  }

  .lg\\:self-end{
    align-self: flex-end !important;
  }

  .lg\\:self-center{
    align-self: center !important;
  }

  .lg\\:self-stretch{
    align-self: stretch !important;
  }

  .lg\\:justify-items-auto{
    justify-items: auto !important;
  }

  .lg\\:justify-items-start{
    justify-items: start !important;
  }

  .lg\\:justify-items-end{
    justify-items: end !important;
  }

  .lg\\:justify-items-center{
    justify-items: center !important;
  }

  .lg\\:justify-items-stretch{
    justify-items: stretch !important;
  }

  .lg\\:justify-start{
    justify-content: flex-start !important;
  }

  .lg\\:justify-end{
    justify-content: flex-end !important;
  }

  .lg\\:justify-center{
    justify-content: center !important;
  }

  .lg\\:justify-between{
    justify-content: space-between !important;
  }

  .lg\\:justify-around{
    justify-content: space-around !important;
  }

  .lg\\:justify-evenly{
    justify-content: space-evenly !important;
  }

  .lg\\:justify-self-auto{
    justify-self: auto !important;
  }

  .lg\\:justify-self-start{
    justify-self: start !important;
  }

  .lg\\:justify-self-end{
    justify-self: end !important;
  }

  .lg\\:justify-self-center{
    justify-self: center !important;
  }

  .lg\\:justify-self-stretch{
    justify-self: stretch !important;
  }

  .lg\\:flex-1{
    flex: 1 1 0% !important;
  }

  .lg\\:flex-auto{
    flex: 1 1 auto !important;
  }

  .lg\\:flex-initial{
    flex: 0 1 auto !important;
  }

  .lg\\:flex-none{
    flex: none !important;
  }

  .lg\\:flex-grow-0{
    flex-grow: 0 !important;
  }

  .lg\\:flex-grow{
    flex-grow: 1 !important;
  }

  .lg\\:flex-shrink-0{
    flex-shrink: 0 !important;
  }

  .lg\\:flex-shrink{
    flex-shrink: 1 !important;
  }

  .lg\\:order-1{
    order: 1 !important;
  }

  .lg\\:order-2{
    order: 2 !important;
  }

  .lg\\:order-3{
    order: 3 !important;
  }

  .lg\\:order-4{
    order: 4 !important;
  }

  .lg\\:order-5{
    order: 5 !important;
  }

  .lg\\:order-6{
    order: 6 !important;
  }

  .lg\\:order-first{
    order: -1 !important;
  }

  .lg\\:order-last{
    order: 999 !important;
  }

  .lg\\:order-normal{
    order: 0 !important;
  }

  .lg\\:hover\\:order-1:hover{
    order: 1 !important;
  }

  .lg\\:hover\\:order-2:hover{
    order: 2 !important;
  }

  .lg\\:hover\\:order-3:hover{
    order: 3 !important;
  }

  .lg\\:hover\\:order-4:hover{
    order: 4 !important;
  }

  .lg\\:hover\\:order-5:hover{
    order: 5 !important;
  }

  .lg\\:hover\\:order-6:hover{
    order: 6 !important;
  }

  .lg\\:hover\\:order-first:hover{
    order: -1 !important;
  }

  .lg\\:hover\\:order-last:hover{
    order: 999 !important;
  }

  .lg\\:hover\\:order-normal:hover{
    order: 0 !important;
  }

  .lg\\:focus\\:order-1:focus{
    order: 1 !important;
  }

  .lg\\:focus\\:order-2:focus{
    order: 2 !important;
  }

  .lg\\:focus\\:order-3:focus{
    order: 3 !important;
  }

  .lg\\:focus\\:order-4:focus{
    order: 4 !important;
  }

  .lg\\:focus\\:order-5:focus{
    order: 5 !important;
  }

  .lg\\:focus\\:order-6:focus{
    order: 6 !important;
  }

  .lg\\:focus\\:order-first:focus{
    order: -1 !important;
  }

  .lg\\:focus\\:order-last:focus{
    order: 999 !important;
  }

  .lg\\:focus\\:order-normal:focus{
    order: 0 !important;
  }

  [dir=ltr] .lg\\:float-right{
    float: right !important;
  }

  [dir=rtl] .lg\\:float-right{
    float: left !important;
  }

  [dir=ltr] .lg\\:float-left{
    float: left !important;
  }

  [dir=rtl] .lg\\:float-left{
    float: right !important;
  }

  [dir] .lg\\:float-none{
    float: none !important;
  }

  .lg\\:clearfix:after{
    content: "" !important;
    display: table !important;
  }

  [dir] .lg\\:clearfix:after{
    clear: both !important;
  }

  [dir=ltr] .lg\\:clear-left{
    clear: left !important;
  }

  [dir=rtl] .lg\\:clear-left{
    clear: right !important;
  }

  [dir=ltr] .lg\\:clear-right{
    clear: right !important;
  }

  [dir=rtl] .lg\\:clear-right{
    clear: left !important;
  }

  [dir] .lg\\:clear-both{
    clear: both !important;
  }

  [dir] .lg\\:clear-none{
    clear: none !important;
  }

  .lg\\:font-light{
    font-weight: 300 !important;
  }

  .lg\\:font-normal{
    font-weight: 400 !important;
  }

  .lg\\:font-medium{
    font-weight: 500 !important;
  }

  .lg\\:font-semibold{
    font-weight: 600 !important;
  }

  .lg\\:font-bold{
    font-weight: 700 !important;
  }

  .lg\\:font-extrabold{
    font-weight: 800 !important;
  }

  .lg\\:font-black{
    font-weight: 900 !important;
  }

  .lg\\:hover\\:font-light:hover{
    font-weight: 300 !important;
  }

  .lg\\:hover\\:font-normal:hover{
    font-weight: 400 !important;
  }

  .lg\\:hover\\:font-medium:hover{
    font-weight: 500 !important;
  }

  .lg\\:hover\\:font-semibold:hover{
    font-weight: 600 !important;
  }

  .lg\\:hover\\:font-bold:hover{
    font-weight: 700 !important;
  }

  .lg\\:hover\\:font-extrabold:hover{
    font-weight: 800 !important;
  }

  .lg\\:hover\\:font-black:hover{
    font-weight: 900 !important;
  }

  .lg\\:h-1{
    height: 0.25rem !important;
  }

  .lg\\:h-2{
    height: 0.5rem !important;
  }

  .lg\\:h-3{
    height: 0.75rem !important;
  }

  .lg\\:h-4{
    height: 1rem !important;
  }

  .lg\\:h-5{
    height: 1.25rem !important;
  }

  .lg\\:h-6{
    height: 1.5rem !important;
  }

  .lg\\:h-8{
    height: 2rem !important;
  }

  .lg\\:h-10{
    height: 2.5rem !important;
  }

  .lg\\:h-12{
    height: 3rem !important;
  }

  .lg\\:h-16{
    height: 4rem !important;
  }

  .lg\\:h-24{
    height: 6rem !important;
  }

  .lg\\:h-32{
    height: 8rem !important;
  }

  .lg\\:h-48{
    height: 12rem !important;
  }

  .lg\\:h-64{
    height: 16rem !important;
  }

  .lg\\:h-auto{
    height: auto !important;
  }

  .lg\\:h-px{
    height: 1px !important;
  }

  .lg\\:h-full{
    height: 100% !important;
  }

  .lg\\:h-screen{
    height: 100vh !important;
  }

  .lg\\:text-xs{
    font-size: .75rem !important;
  }

  .lg\\:text-sm{
    font-size: .875rem !important;
  }

  .lg\\:text-base{
    font-size: 1rem !important;
  }

  .lg\\:text-lg{
    font-size: 1.125rem !important;
  }

  .lg\\:text-xl{
    font-size: 1.25rem !important;
  }

  .lg\\:text-2xl{
    font-size: 1.5rem !important;
  }

  .lg\\:text-3xl{
    font-size: 1.875rem !important;
  }

  .lg\\:text-4xl{
    font-size: 2.25rem !important;
  }

  .lg\\:text-5xl{
    font-size: 3rem !important;
  }

  .lg\\:text-6xl{
    font-size: 4rem !important;
  }

  .lg\\:leading-none{
    line-height: 1 !important;
  }

  .lg\\:leading-tight{
    line-height: 1.25 !important;
  }

  .lg\\:leading-normal{
    line-height: 1.5 !important;
  }

  .lg\\:leading-loose{
    line-height: 2 !important;
  }

  .lg\\:list-inside{
    list-style-position: inside !important;
  }

  .lg\\:list-outside{
    list-style-position: outside !important;
  }

  [dir] .lg\\:m-0{
    margin: 0 !important;
  }

  [dir] .lg\\:m-1{
    margin: 0.25rem !important;
  }

  [dir] .lg\\:m-2{
    margin: 0.5rem !important;
  }

  [dir] .lg\\:m-3{
    margin: 0.75rem !important;
  }

  [dir] .lg\\:m-4{
    margin: 1rem !important;
  }

  [dir] .lg\\:m-5{
    margin: 1.25rem !important;
  }

  [dir] .lg\\:m-6{
    margin: 1.5rem !important;
  }

  [dir] .lg\\:m-8{
    margin: 2rem !important;
  }

  [dir] .lg\\:m-10{
    margin: 2.5rem !important;
  }

  [dir] .lg\\:m-12{
    margin: 3rem !important;
  }

  [dir] .lg\\:m-16{
    margin: 4rem !important;
  }

  [dir] .lg\\:m-20{
    margin: 5rem !important;
  }

  [dir] .lg\\:m-24{
    margin: 6rem !important;
  }

  [dir] .lg\\:m-32{
    margin: 8rem !important;
  }

  [dir] .lg\\:m-auto{
    margin: auto !important;
  }

  [dir] .lg\\:m-px{
    margin: 1px !important;
  }

  [dir] .lg\\:m-base{
    margin: 2.2rem !important;
  }

  [dir] .lg\\:-m-px{
    margin: -1px !important;
  }

  [dir] .lg\\:-m-1{
    margin: -0.25rem !important;
  }

  [dir] .lg\\:-m-2{
    margin: -0.5rem !important;
  }

  [dir] .lg\\:-m-3{
    margin: -0.75rem !important;
  }

  [dir] .lg\\:-m-4{
    margin: -1rem !important;
  }

  [dir] .lg\\:my-0{
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  [dir=ltr] .lg\\:mx-0{
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  [dir=rtl] .lg\\:mx-0{
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  [dir] .lg\\:my-1{
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  [dir=ltr] .lg\\:mx-1{
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }

  [dir=rtl] .lg\\:mx-1{
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  [dir] .lg\\:my-2{
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  [dir=ltr] .lg\\:mx-2{
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  [dir=rtl] .lg\\:mx-2{
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  [dir] .lg\\:my-3{
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  [dir=ltr] .lg\\:mx-3{
    margin-left: 0.75rem !important;
    margin-right: 0.75rem !important;
  }

  [dir=rtl] .lg\\:mx-3{
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  [dir] .lg\\:my-4{
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  [dir=ltr] .lg\\:mx-4{
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  [dir=rtl] .lg\\:mx-4{
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  [dir] .lg\\:my-5{
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  [dir=ltr] .lg\\:mx-5{
    margin-left: 1.25rem !important;
    margin-right: 1.25rem !important;
  }

  [dir=rtl] .lg\\:mx-5{
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  [dir] .lg\\:my-6{
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  [dir=ltr] .lg\\:mx-6{
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }

  [dir=rtl] .lg\\:mx-6{
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  [dir] .lg\\:my-8{
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  [dir=ltr] .lg\\:mx-8{
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }

  [dir=rtl] .lg\\:mx-8{
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  [dir] .lg\\:my-10{
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  [dir=ltr] .lg\\:mx-10{
    margin-left: 2.5rem !important;
    margin-right: 2.5rem !important;
  }

  [dir=rtl] .lg\\:mx-10{
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  [dir] .lg\\:my-12{
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  [dir=ltr] .lg\\:mx-12{
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }

  [dir=rtl] .lg\\:mx-12{
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  [dir] .lg\\:my-16{
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  [dir=ltr] .lg\\:mx-16{
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }

  [dir=rtl] .lg\\:mx-16{
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  [dir] .lg\\:my-20{
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  [dir=ltr] .lg\\:mx-20{
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }

  [dir=rtl] .lg\\:mx-20{
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  [dir] .lg\\:my-24{
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }

  [dir=ltr] .lg\\:mx-24{
    margin-left: 6rem !important;
    margin-right: 6rem !important;
  }

  [dir=rtl] .lg\\:mx-24{
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }

  [dir] .lg\\:my-32{
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }

  [dir=ltr] .lg\\:mx-32{
    margin-left: 8rem !important;
    margin-right: 8rem !important;
  }

  [dir=rtl] .lg\\:mx-32{
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }

  [dir] .lg\\:my-auto{
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  [dir=ltr] .lg\\:mx-auto{
    margin-left: auto !important;
    margin-right: auto !important;
  }

  [dir=rtl] .lg\\:mx-auto{
    margin-right: auto !important;
    margin-left: auto !important;
  }

  [dir] .lg\\:my-px{
    margin-top: 1px !important;
    margin-bottom: 1px !important;
  }

  [dir=ltr] .lg\\:mx-px{
    margin-left: 1px !important;
    margin-right: 1px !important;
  }

  [dir=rtl] .lg\\:mx-px{
    margin-right: 1px !important;
    margin-left: 1px !important;
  }

  [dir] .lg\\:my-base{
    margin-top: 2.2rem !important;
    margin-bottom: 2.2rem !important;
  }

  [dir=ltr] .lg\\:mx-base{
    margin-left: 2.2rem !important;
    margin-right: 2.2rem !important;
  }

  [dir=rtl] .lg\\:mx-base{
    margin-right: 2.2rem !important;
    margin-left: 2.2rem !important;
  }

  [dir] .lg\\:-my-px{
    margin-top: -1px !important;
    margin-bottom: -1px !important;
  }

  [dir=ltr] .lg\\:-mx-px{
    margin-left: -1px !important;
    margin-right: -1px !important;
  }

  [dir=rtl] .lg\\:-mx-px{
    margin-right: -1px !important;
    margin-left: -1px !important;
  }

  [dir] .lg\\:-my-1{
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  [dir=ltr] .lg\\:-mx-1{
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
  }

  [dir=rtl] .lg\\:-mx-1{
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  [dir] .lg\\:-my-2{
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  [dir=ltr] .lg\\:-mx-2{
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }

  [dir=rtl] .lg\\:-mx-2{
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  [dir] .lg\\:-my-3{
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  [dir=ltr] .lg\\:-mx-3{
    margin-left: -0.75rem !important;
    margin-right: -0.75rem !important;
  }

  [dir=rtl] .lg\\:-mx-3{
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  [dir] .lg\\:-my-4{
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  [dir=ltr] .lg\\:-mx-4{
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }

  [dir=rtl] .lg\\:-mx-4{
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  [dir] .lg\\:mt-0{
    margin-top: 0 !important;
  }

  [dir=ltr] .lg\\:mr-0{
    margin-right: 0 !important;
  }

  [dir=rtl] .lg\\:mr-0{
    margin-left: 0 !important;
  }

  [dir] .lg\\:mb-0{
    margin-bottom: 0 !important;
  }

  [dir=ltr] .lg\\:ml-0{
    margin-left: 0 !important;
  }

  [dir=rtl] .lg\\:ml-0{
    margin-right: 0 !important;
  }

  [dir] .lg\\:mt-1{
    margin-top: 0.25rem !important;
  }

  [dir=ltr] .lg\\:mr-1{
    margin-right: 0.25rem !important;
  }

  [dir=rtl] .lg\\:mr-1{
    margin-left: 0.25rem !important;
  }

  [dir] .lg\\:mb-1{
    margin-bottom: 0.25rem !important;
  }

  [dir=ltr] .lg\\:ml-1{
    margin-left: 0.25rem !important;
  }

  [dir=rtl] .lg\\:ml-1{
    margin-right: 0.25rem !important;
  }

  [dir] .lg\\:mt-2{
    margin-top: 0.5rem !important;
  }

  [dir=ltr] .lg\\:mr-2{
    margin-right: 0.5rem !important;
  }

  [dir=rtl] .lg\\:mr-2{
    margin-left: 0.5rem !important;
  }

  [dir] .lg\\:mb-2{
    margin-bottom: 0.5rem !important;
  }

  [dir=ltr] .lg\\:ml-2{
    margin-left: 0.5rem !important;
  }

  [dir=rtl] .lg\\:ml-2{
    margin-right: 0.5rem !important;
  }

  [dir] .lg\\:mt-3{
    margin-top: 0.75rem !important;
  }

  [dir=ltr] .lg\\:mr-3{
    margin-right: 0.75rem !important;
  }

  [dir=rtl] .lg\\:mr-3{
    margin-left: 0.75rem !important;
  }

  [dir] .lg\\:mb-3{
    margin-bottom: 0.75rem !important;
  }

  [dir=ltr] .lg\\:ml-3{
    margin-left: 0.75rem !important;
  }

  [dir=rtl] .lg\\:ml-3{
    margin-right: 0.75rem !important;
  }

  [dir] .lg\\:mt-4{
    margin-top: 1rem !important;
  }

  [dir=ltr] .lg\\:mr-4{
    margin-right: 1rem !important;
  }

  [dir=rtl] .lg\\:mr-4{
    margin-left: 1rem !important;
  }

  [dir] .lg\\:mb-4{
    margin-bottom: 1rem !important;
  }

  [dir=ltr] .lg\\:ml-4{
    margin-left: 1rem !important;
  }

  [dir=rtl] .lg\\:ml-4{
    margin-right: 1rem !important;
  }

  [dir] .lg\\:mt-5{
    margin-top: 1.25rem !important;
  }

  [dir=ltr] .lg\\:mr-5{
    margin-right: 1.25rem !important;
  }

  [dir=rtl] .lg\\:mr-5{
    margin-left: 1.25rem !important;
  }

  [dir] .lg\\:mb-5{
    margin-bottom: 1.25rem !important;
  }

  [dir=ltr] .lg\\:ml-5{
    margin-left: 1.25rem !important;
  }

  [dir=rtl] .lg\\:ml-5{
    margin-right: 1.25rem !important;
  }

  [dir] .lg\\:mt-6{
    margin-top: 1.5rem !important;
  }

  [dir=ltr] .lg\\:mr-6{
    margin-right: 1.5rem !important;
  }

  [dir=rtl] .lg\\:mr-6{
    margin-left: 1.5rem !important;
  }

  [dir] .lg\\:mb-6{
    margin-bottom: 1.5rem !important;
  }

  [dir=ltr] .lg\\:ml-6{
    margin-left: 1.5rem !important;
  }

  [dir=rtl] .lg\\:ml-6{
    margin-right: 1.5rem !important;
  }

  [dir] .lg\\:mt-8{
    margin-top: 2rem !important;
  }

  [dir=ltr] .lg\\:mr-8{
    margin-right: 2rem !important;
  }

  [dir=rtl] .lg\\:mr-8{
    margin-left: 2rem !important;
  }

  [dir] .lg\\:mb-8{
    margin-bottom: 2rem !important;
  }

  [dir=ltr] .lg\\:ml-8{
    margin-left: 2rem !important;
  }

  [dir=rtl] .lg\\:ml-8{
    margin-right: 2rem !important;
  }

  [dir] .lg\\:mt-10{
    margin-top: 2.5rem !important;
  }

  [dir=ltr] .lg\\:mr-10{
    margin-right: 2.5rem !important;
  }

  [dir=rtl] .lg\\:mr-10{
    margin-left: 2.5rem !important;
  }

  [dir] .lg\\:mb-10{
    margin-bottom: 2.5rem !important;
  }

  [dir=ltr] .lg\\:ml-10{
    margin-left: 2.5rem !important;
  }

  [dir=rtl] .lg\\:ml-10{
    margin-right: 2.5rem !important;
  }

  [dir] .lg\\:mt-12{
    margin-top: 3rem !important;
  }

  [dir=ltr] .lg\\:mr-12{
    margin-right: 3rem !important;
  }

  [dir=rtl] .lg\\:mr-12{
    margin-left: 3rem !important;
  }

  [dir] .lg\\:mb-12{
    margin-bottom: 3rem !important;
  }

  [dir=ltr] .lg\\:ml-12{
    margin-left: 3rem !important;
  }

  [dir=rtl] .lg\\:ml-12{
    margin-right: 3rem !important;
  }

  [dir] .lg\\:mt-16{
    margin-top: 4rem !important;
  }

  [dir=ltr] .lg\\:mr-16{
    margin-right: 4rem !important;
  }

  [dir=rtl] .lg\\:mr-16{
    margin-left: 4rem !important;
  }

  [dir] .lg\\:mb-16{
    margin-bottom: 4rem !important;
  }

  [dir=ltr] .lg\\:ml-16{
    margin-left: 4rem !important;
  }

  [dir=rtl] .lg\\:ml-16{
    margin-right: 4rem !important;
  }

  [dir] .lg\\:mt-20{
    margin-top: 5rem !important;
  }

  [dir=ltr] .lg\\:mr-20{
    margin-right: 5rem !important;
  }

  [dir=rtl] .lg\\:mr-20{
    margin-left: 5rem !important;
  }

  [dir] .lg\\:mb-20{
    margin-bottom: 5rem !important;
  }

  [dir=ltr] .lg\\:ml-20{
    margin-left: 5rem !important;
  }

  [dir=rtl] .lg\\:ml-20{
    margin-right: 5rem !important;
  }

  [dir] .lg\\:mt-24{
    margin-top: 6rem !important;
  }

  [dir=ltr] .lg\\:mr-24{
    margin-right: 6rem !important;
  }

  [dir=rtl] .lg\\:mr-24{
    margin-left: 6rem !important;
  }

  [dir] .lg\\:mb-24{
    margin-bottom: 6rem !important;
  }

  [dir=ltr] .lg\\:ml-24{
    margin-left: 6rem !important;
  }

  [dir=rtl] .lg\\:ml-24{
    margin-right: 6rem !important;
  }

  [dir] .lg\\:mt-32{
    margin-top: 8rem !important;
  }

  [dir=ltr] .lg\\:mr-32{
    margin-right: 8rem !important;
  }

  [dir=rtl] .lg\\:mr-32{
    margin-left: 8rem !important;
  }

  [dir] .lg\\:mb-32{
    margin-bottom: 8rem !important;
  }

  [dir=ltr] .lg\\:ml-32{
    margin-left: 8rem !important;
  }

  [dir=rtl] .lg\\:ml-32{
    margin-right: 8rem !important;
  }

  [dir] .lg\\:mt-auto{
    margin-top: auto !important;
  }

  [dir=ltr] .lg\\:mr-auto{
    margin-right: auto !important;
  }

  [dir=rtl] .lg\\:mr-auto{
    margin-left: auto !important;
  }

  [dir] .lg\\:mb-auto{
    margin-bottom: auto !important;
  }

  [dir=ltr] .lg\\:ml-auto{
    margin-left: auto !important;
  }

  [dir=rtl] .lg\\:ml-auto{
    margin-right: auto !important;
  }

  [dir] .lg\\:mt-px{
    margin-top: 1px !important;
  }

  [dir=ltr] .lg\\:mr-px{
    margin-right: 1px !important;
  }

  [dir=rtl] .lg\\:mr-px{
    margin-left: 1px !important;
  }

  [dir] .lg\\:mb-px{
    margin-bottom: 1px !important;
  }

  [dir=ltr] .lg\\:ml-px{
    margin-left: 1px !important;
  }

  [dir=rtl] .lg\\:ml-px{
    margin-right: 1px !important;
  }

  [dir] .lg\\:mt-base{
    margin-top: 2.2rem !important;
  }

  [dir=ltr] .lg\\:mr-base{
    margin-right: 2.2rem !important;
  }

  [dir=rtl] .lg\\:mr-base{
    margin-left: 2.2rem !important;
  }

  [dir] .lg\\:mb-base{
    margin-bottom: 2.2rem !important;
  }

  [dir=ltr] .lg\\:ml-base{
    margin-left: 2.2rem !important;
  }

  [dir=rtl] .lg\\:ml-base{
    margin-right: 2.2rem !important;
  }

  [dir] .lg\\:-mt-px{
    margin-top: -1px !important;
  }

  [dir=ltr] .lg\\:-mr-px{
    margin-right: -1px !important;
  }

  [dir=rtl] .lg\\:-mr-px{
    margin-left: -1px !important;
  }

  [dir] .lg\\:-mb-px{
    margin-bottom: -1px !important;
  }

  [dir=ltr] .lg\\:-ml-px{
    margin-left: -1px !important;
  }

  [dir=rtl] .lg\\:-ml-px{
    margin-right: -1px !important;
  }

  [dir] .lg\\:-mt-1{
    margin-top: -0.25rem !important;
  }

  [dir=ltr] .lg\\:-mr-1{
    margin-right: -0.25rem !important;
  }

  [dir=rtl] .lg\\:-mr-1{
    margin-left: -0.25rem !important;
  }

  [dir] .lg\\:-mb-1{
    margin-bottom: -0.25rem !important;
  }

  [dir=ltr] .lg\\:-ml-1{
    margin-left: -0.25rem !important;
  }

  [dir=rtl] .lg\\:-ml-1{
    margin-right: -0.25rem !important;
  }

  [dir] .lg\\:-mt-2{
    margin-top: -0.5rem !important;
  }

  [dir=ltr] .lg\\:-mr-2{
    margin-right: -0.5rem !important;
  }

  [dir=rtl] .lg\\:-mr-2{
    margin-left: -0.5rem !important;
  }

  [dir] .lg\\:-mb-2{
    margin-bottom: -0.5rem !important;
  }

  [dir=ltr] .lg\\:-ml-2{
    margin-left: -0.5rem !important;
  }

  [dir=rtl] .lg\\:-ml-2{
    margin-right: -0.5rem !important;
  }

  [dir] .lg\\:-mt-3{
    margin-top: -0.75rem !important;
  }

  [dir=ltr] .lg\\:-mr-3{
    margin-right: -0.75rem !important;
  }

  [dir=rtl] .lg\\:-mr-3{
    margin-left: -0.75rem !important;
  }

  [dir] .lg\\:-mb-3{
    margin-bottom: -0.75rem !important;
  }

  [dir=ltr] .lg\\:-ml-3{
    margin-left: -0.75rem !important;
  }

  [dir=rtl] .lg\\:-ml-3{
    margin-right: -0.75rem !important;
  }

  [dir] .lg\\:-mt-4{
    margin-top: -1rem !important;
  }

  [dir=ltr] .lg\\:-mr-4{
    margin-right: -1rem !important;
  }

  [dir=rtl] .lg\\:-mr-4{
    margin-left: -1rem !important;
  }

  [dir] .lg\\:-mb-4{
    margin-bottom: -1rem !important;
  }

  [dir=ltr] .lg\\:-ml-4{
    margin-left: -1rem !important;
  }

  [dir=rtl] .lg\\:-ml-4{
    margin-right: -1rem !important;
  }

  .lg\\:max-h-full{
    max-height: 100% !important;
  }

  .lg\\:max-h-screen{
    max-height: 100vh !important;
  }

  .lg\\:max-w-xs{
    max-width: 20rem !important;
  }

  .lg\\:max-w-sm{
    max-width: 30rem !important;
  }

  .lg\\:max-w-md{
    max-width: 40rem !important;
  }

  .lg\\:max-w-lg{
    max-width: 50rem !important;
  }

  .lg\\:max-w-xl{
    max-width: 60rem !important;
  }

  .lg\\:max-w-2xl{
    max-width: 70rem !important;
  }

  .lg\\:max-w-3xl{
    max-width: 80rem !important;
  }

  .lg\\:max-w-4xl{
    max-width: 90rem !important;
  }

  .lg\\:max-w-5xl{
    max-width: 100rem !important;
  }

  .lg\\:max-w-full{
    max-width: 100% !important;
  }

  .lg\\:min-h-0{
    min-height: 0 !important;
  }

  .lg\\:min-h-full{
    min-height: 100% !important;
  }

  .lg\\:min-h-screen{
    min-height: 100vh !important;
  }

  .lg\\:min-w-0{
    min-width: 0 !important;
  }

  .lg\\:min-w-full{
    min-width: 100% !important;
  }

  .lg\\:object-contain{
    object-fit: contain !important;
  }

  .lg\\:object-cover{
    object-fit: cover !important;
  }

  .lg\\:object-fill{
    object-fit: fill !important;
  }

  .lg\\:object-none{
    object-fit: none !important;
  }

  .lg\\:object-scale-down{
    object-fit: scale-down !important;
  }

  .lg\\:object-bottom{
    object-position: bottom !important;
  }

  .lg\\:object-center{
    object-position: center !important;
  }

  .lg\\:object-left{
    object-position: left !important;
  }

  .lg\\:object-left-bottom{
    object-position: left bottom !important;
  }

  .lg\\:object-left-top{
    object-position: left top !important;
  }

  .lg\\:object-right{
    object-position: right !important;
  }

  .lg\\:object-right-bottom{
    object-position: right bottom !important;
  }

  .lg\\:object-right-top{
    object-position: right top !important;
  }

  .lg\\:object-top{
    object-position: top !important;
  }

  .lg\\:opacity-0{
    opacity: 0 !important;
  }

  .lg\\:opacity-25{
    opacity: 0.25 !important;
  }

  .lg\\:opacity-50{
    opacity: 0.5 !important;
  }

  .lg\\:opacity-75{
    opacity: 0.75 !important;
  }

  .lg\\:opacity-100{
    opacity: 1 !important;
  }

  .lg\\:overflow-auto{
    overflow: auto !important;
  }

  .lg\\:overflow-hidden{
    overflow: hidden !important;
  }

  .lg\\:overflow-visible{
    overflow: visible !important;
  }

  .lg\\:overflow-scroll{
    overflow: scroll !important;
  }

  .lg\\:overflow-x-auto{
    overflow-x: auto !important;
  }

  .lg\\:overflow-y-auto{
    overflow-y: auto !important;
  }

  .lg\\:overflow-x-hidden{
    overflow-x: hidden !important;
  }

  .lg\\:overflow-y-hidden{
    overflow-y: hidden !important;
  }

  .lg\\:overflow-x-visible{
    overflow-x: visible !important;
  }

  .lg\\:overflow-y-visible{
    overflow-y: visible !important;
  }

  .lg\\:overflow-x-scroll{
    overflow-x: scroll !important;
  }

  .lg\\:overflow-y-scroll{
    overflow-y: scroll !important;
  }

  .lg\\:scrolling-touch{
    -webkit-overflow-scrolling: touch !important;
  }

  .lg\\:scrolling-auto{
    -webkit-overflow-scrolling: auto !important;
  }

  .lg\\:overscroll-auto{
    overscroll-behavior: auto !important;
  }

  .lg\\:overscroll-contain{
    overscroll-behavior: contain !important;
  }

  .lg\\:overscroll-none{
    overscroll-behavior: none !important;
  }

  .lg\\:overscroll-y-auto{
    overscroll-behavior-y: auto !important;
  }

  .lg\\:overscroll-y-contain{
    overscroll-behavior-y: contain !important;
  }

  .lg\\:overscroll-y-none{
    overscroll-behavior-y: none !important;
  }

  .lg\\:overscroll-x-auto{
    overscroll-behavior-x: auto !important;
  }

  .lg\\:overscroll-x-contain{
    overscroll-behavior-x: contain !important;
  }

  .lg\\:overscroll-x-none{
    overscroll-behavior-x: none !important;
  }

  [dir] .lg\\:p-0{
    padding: 0 !important;
  }

  [dir] .lg\\:p-1{
    padding: 0.25rem !important;
  }

  [dir] .lg\\:p-2{
    padding: 0.5rem !important;
  }

  [dir] .lg\\:p-3{
    padding: 0.75rem !important;
  }

  [dir] .lg\\:p-4{
    padding: 1rem !important;
  }

  [dir] .lg\\:p-5{
    padding: 1.25rem !important;
  }

  [dir] .lg\\:p-6{
    padding: 1.5rem !important;
  }

  [dir] .lg\\:p-8{
    padding: 2rem !important;
  }

  [dir] .lg\\:p-10{
    padding: 2.5rem !important;
  }

  [dir] .lg\\:p-12{
    padding: 3rem !important;
  }

  [dir] .lg\\:p-16{
    padding: 4rem !important;
  }

  [dir] .lg\\:p-20{
    padding: 5rem !important;
  }

  [dir] .lg\\:p-24{
    padding: 6rem !important;
  }

  [dir] .lg\\:p-32{
    padding: 8rem !important;
  }

  [dir] .lg\\:p-px{
    padding: 1px !important;
  }

  [dir] .lg\\:p-base{
    padding: 2.2rem !important;
  }

  [dir] .lg\\:py-0{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  [dir=ltr] .lg\\:px-0{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  [dir=rtl] .lg\\:px-0{
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  [dir] .lg\\:py-1{
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  [dir=ltr] .lg\\:px-1{
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }

  [dir=rtl] .lg\\:px-1{
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  [dir] .lg\\:py-2{
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  [dir=ltr] .lg\\:px-2{
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  [dir=rtl] .lg\\:px-2{
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  [dir] .lg\\:py-3{
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  [dir=ltr] .lg\\:px-3{
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }

  [dir=rtl] .lg\\:px-3{
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  [dir] .lg\\:py-4{
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  [dir=ltr] .lg\\:px-4{
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  [dir=rtl] .lg\\:px-4{
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  [dir] .lg\\:py-5{
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  [dir=ltr] .lg\\:px-5{
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }

  [dir=rtl] .lg\\:px-5{
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  [dir] .lg\\:py-6{
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  [dir=ltr] .lg\\:px-6{
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  [dir=rtl] .lg\\:px-6{
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  [dir] .lg\\:py-8{
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  [dir=ltr] .lg\\:px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  [dir=rtl] .lg\\:px-8{
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  [dir] .lg\\:py-10{
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  [dir=ltr] .lg\\:px-10{
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  [dir=rtl] .lg\\:px-10{
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  [dir] .lg\\:py-12{
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  [dir=ltr] .lg\\:px-12{
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }

  [dir=rtl] .lg\\:px-12{
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  [dir] .lg\\:py-16{
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  [dir=ltr] .lg\\:px-16{
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }

  [dir=rtl] .lg\\:px-16{
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  [dir] .lg\\:py-20{
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  [dir=ltr] .lg\\:px-20{
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }

  [dir=rtl] .lg\\:px-20{
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  [dir] .lg\\:py-24{
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }

  [dir=ltr] .lg\\:px-24{
    padding-left: 6rem !important;
    padding-right: 6rem !important;
  }

  [dir=rtl] .lg\\:px-24{
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }

  [dir] .lg\\:py-32{
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }

  [dir=ltr] .lg\\:px-32{
    padding-left: 8rem !important;
    padding-right: 8rem !important;
  }

  [dir=rtl] .lg\\:px-32{
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }

  [dir] .lg\\:py-px{
    padding-top: 1px !important;
    padding-bottom: 1px !important;
  }

  [dir=ltr] .lg\\:px-px{
    padding-left: 1px !important;
    padding-right: 1px !important;
  }

  [dir=rtl] .lg\\:px-px{
    padding-right: 1px !important;
    padding-left: 1px !important;
  }

  [dir] .lg\\:py-base{
    padding-top: 2.2rem !important;
    padding-bottom: 2.2rem !important;
  }

  [dir=ltr] .lg\\:px-base{
    padding-left: 2.2rem !important;
    padding-right: 2.2rem !important;
  }

  [dir=rtl] .lg\\:px-base{
    padding-right: 2.2rem !important;
    padding-left: 2.2rem !important;
  }

  [dir] .lg\\:pt-0{
    padding-top: 0 !important;
  }

  [dir=ltr] .lg\\:pr-0{
    padding-right: 0 !important;
  }

  [dir=rtl] .lg\\:pr-0{
    padding-left: 0 !important;
  }

  [dir] .lg\\:pb-0{
    padding-bottom: 0 !important;
  }

  [dir=ltr] .lg\\:pl-0{
    padding-left: 0 !important;
  }

  [dir=rtl] .lg\\:pl-0{
    padding-right: 0 !important;
  }

  [dir] .lg\\:pt-1{
    padding-top: 0.25rem !important;
  }

  [dir=ltr] .lg\\:pr-1{
    padding-right: 0.25rem !important;
  }

  [dir=rtl] .lg\\:pr-1{
    padding-left: 0.25rem !important;
  }

  [dir] .lg\\:pb-1{
    padding-bottom: 0.25rem !important;
  }

  [dir=ltr] .lg\\:pl-1{
    padding-left: 0.25rem !important;
  }

  [dir=rtl] .lg\\:pl-1{
    padding-right: 0.25rem !important;
  }

  [dir] .lg\\:pt-2{
    padding-top: 0.5rem !important;
  }

  [dir=ltr] .lg\\:pr-2{
    padding-right: 0.5rem !important;
  }

  [dir=rtl] .lg\\:pr-2{
    padding-left: 0.5rem !important;
  }

  [dir] .lg\\:pb-2{
    padding-bottom: 0.5rem !important;
  }

  [dir=ltr] .lg\\:pl-2{
    padding-left: 0.5rem !important;
  }

  [dir=rtl] .lg\\:pl-2{
    padding-right: 0.5rem !important;
  }

  [dir] .lg\\:pt-3{
    padding-top: 0.75rem !important;
  }

  [dir=ltr] .lg\\:pr-3{
    padding-right: 0.75rem !important;
  }

  [dir=rtl] .lg\\:pr-3{
    padding-left: 0.75rem !important;
  }

  [dir] .lg\\:pb-3{
    padding-bottom: 0.75rem !important;
  }

  [dir=ltr] .lg\\:pl-3{
    padding-left: 0.75rem !important;
  }

  [dir=rtl] .lg\\:pl-3{
    padding-right: 0.75rem !important;
  }

  [dir] .lg\\:pt-4{
    padding-top: 1rem !important;
  }

  [dir=ltr] .lg\\:pr-4{
    padding-right: 1rem !important;
  }

  [dir=rtl] .lg\\:pr-4{
    padding-left: 1rem !important;
  }

  [dir] .lg\\:pb-4{
    padding-bottom: 1rem !important;
  }

  [dir=ltr] .lg\\:pl-4{
    padding-left: 1rem !important;
  }

  [dir=rtl] .lg\\:pl-4{
    padding-right: 1rem !important;
  }

  [dir] .lg\\:pt-5{
    padding-top: 1.25rem !important;
  }

  [dir=ltr] .lg\\:pr-5{
    padding-right: 1.25rem !important;
  }

  [dir=rtl] .lg\\:pr-5{
    padding-left: 1.25rem !important;
  }

  [dir] .lg\\:pb-5{
    padding-bottom: 1.25rem !important;
  }

  [dir=ltr] .lg\\:pl-5{
    padding-left: 1.25rem !important;
  }

  [dir=rtl] .lg\\:pl-5{
    padding-right: 1.25rem !important;
  }

  [dir] .lg\\:pt-6{
    padding-top: 1.5rem !important;
  }

  [dir=ltr] .lg\\:pr-6{
    padding-right: 1.5rem !important;
  }

  [dir=rtl] .lg\\:pr-6{
    padding-left: 1.5rem !important;
  }

  [dir] .lg\\:pb-6{
    padding-bottom: 1.5rem !important;
  }

  [dir=ltr] .lg\\:pl-6{
    padding-left: 1.5rem !important;
  }

  [dir=rtl] .lg\\:pl-6{
    padding-right: 1.5rem !important;
  }

  [dir] .lg\\:pt-8{
    padding-top: 2rem !important;
  }

  [dir=ltr] .lg\\:pr-8{
    padding-right: 2rem !important;
  }

  [dir=rtl] .lg\\:pr-8{
    padding-left: 2rem !important;
  }

  [dir] .lg\\:pb-8{
    padding-bottom: 2rem !important;
  }

  [dir=ltr] .lg\\:pl-8{
    padding-left: 2rem !important;
  }

  [dir=rtl] .lg\\:pl-8{
    padding-right: 2rem !important;
  }

  [dir] .lg\\:pt-10{
    padding-top: 2.5rem !important;
  }

  [dir=ltr] .lg\\:pr-10{
    padding-right: 2.5rem !important;
  }

  [dir=rtl] .lg\\:pr-10{
    padding-left: 2.5rem !important;
  }

  [dir] .lg\\:pb-10{
    padding-bottom: 2.5rem !important;
  }

  [dir=ltr] .lg\\:pl-10{
    padding-left: 2.5rem !important;
  }

  [dir=rtl] .lg\\:pl-10{
    padding-right: 2.5rem !important;
  }

  [dir] .lg\\:pt-12{
    padding-top: 3rem !important;
  }

  [dir=ltr] .lg\\:pr-12{
    padding-right: 3rem !important;
  }

  [dir=rtl] .lg\\:pr-12{
    padding-left: 3rem !important;
  }

  [dir] .lg\\:pb-12{
    padding-bottom: 3rem !important;
  }

  [dir=ltr] .lg\\:pl-12{
    padding-left: 3rem !important;
  }

  [dir=rtl] .lg\\:pl-12{
    padding-right: 3rem !important;
  }

  [dir] .lg\\:pt-16{
    padding-top: 4rem !important;
  }

  [dir=ltr] .lg\\:pr-16{
    padding-right: 4rem !important;
  }

  [dir=rtl] .lg\\:pr-16{
    padding-left: 4rem !important;
  }

  [dir] .lg\\:pb-16{
    padding-bottom: 4rem !important;
  }

  [dir=ltr] .lg\\:pl-16{
    padding-left: 4rem !important;
  }

  [dir=rtl] .lg\\:pl-16{
    padding-right: 4rem !important;
  }

  [dir] .lg\\:pt-20{
    padding-top: 5rem !important;
  }

  [dir=ltr] .lg\\:pr-20{
    padding-right: 5rem !important;
  }

  [dir=rtl] .lg\\:pr-20{
    padding-left: 5rem !important;
  }

  [dir] .lg\\:pb-20{
    padding-bottom: 5rem !important;
  }

  [dir=ltr] .lg\\:pl-20{
    padding-left: 5rem !important;
  }

  [dir=rtl] .lg\\:pl-20{
    padding-right: 5rem !important;
  }

  [dir] .lg\\:pt-24{
    padding-top: 6rem !important;
  }

  [dir=ltr] .lg\\:pr-24{
    padding-right: 6rem !important;
  }

  [dir=rtl] .lg\\:pr-24{
    padding-left: 6rem !important;
  }

  [dir] .lg\\:pb-24{
    padding-bottom: 6rem !important;
  }

  [dir=ltr] .lg\\:pl-24{
    padding-left: 6rem !important;
  }

  [dir=rtl] .lg\\:pl-24{
    padding-right: 6rem !important;
  }

  [dir] .lg\\:pt-32{
    padding-top: 8rem !important;
  }

  [dir=ltr] .lg\\:pr-32{
    padding-right: 8rem !important;
  }

  [dir=rtl] .lg\\:pr-32{
    padding-left: 8rem !important;
  }

  [dir] .lg\\:pb-32{
    padding-bottom: 8rem !important;
  }

  [dir=ltr] .lg\\:pl-32{
    padding-left: 8rem !important;
  }

  [dir=rtl] .lg\\:pl-32{
    padding-right: 8rem !important;
  }

  [dir] .lg\\:pt-px{
    padding-top: 1px !important;
  }

  [dir=ltr] .lg\\:pr-px{
    padding-right: 1px !important;
  }

  [dir=rtl] .lg\\:pr-px{
    padding-left: 1px !important;
  }

  [dir] .lg\\:pb-px{
    padding-bottom: 1px !important;
  }

  [dir=ltr] .lg\\:pl-px{
    padding-left: 1px !important;
  }

  [dir=rtl] .lg\\:pl-px{
    padding-right: 1px !important;
  }

  [dir] .lg\\:pt-base{
    padding-top: 2.2rem !important;
  }

  [dir=ltr] .lg\\:pr-base{
    padding-right: 2.2rem !important;
  }

  [dir=rtl] .lg\\:pr-base{
    padding-left: 2.2rem !important;
  }

  [dir] .lg\\:pb-base{
    padding-bottom: 2.2rem !important;
  }

  [dir=ltr] .lg\\:pl-base{
    padding-left: 2.2rem !important;
  }

  [dir=rtl] .lg\\:pl-base{
    padding-right: 2.2rem !important;
  }

  .lg\\:placeholder-transparent::placeholder{
    color: transparent !important;
  }

  .lg\\:placeholder-black::placeholder{
    --placeholder-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--placeholder-opacity)) !important;
  }

  .lg\\:placeholder-white::placeholder{
    --placeholder-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--placeholder-opacity)) !important;
  }

  .lg\\:placeholder-grey::placeholder{
    --placeholder-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--placeholder-opacity)) !important;
  }

  .lg\\:placeholder-grey-light::placeholder{
    --placeholder-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--placeholder-opacity)) !important;
  }

  .lg\\:focus\\:placeholder-transparent:focus::placeholder{
    color: transparent !important;
  }

  .lg\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--placeholder-opacity)) !important;
  }

  .lg\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--placeholder-opacity)) !important;
  }

  .lg\\:focus\\:placeholder-grey:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--placeholder-opacity)) !important;
  }

  .lg\\:focus\\:placeholder-grey-light:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--placeholder-opacity)) !important;
  }

  .lg\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity: 0 !important;
  }

  .lg\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity: 0.25 !important;
  }

  .lg\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity: 0.5 !important;
  }

  .lg\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity: 0.75 !important;
  }

  .lg\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity: 1 !important;
  }

  .lg\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity: 0 !important;
  }

  .lg\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity: 0.25 !important;
  }

  .lg\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity: 0.5 !important;
  }

  .lg\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity: 0.75 !important;
  }

  .lg\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity: 1 !important;
  }

  .lg\\:pointer-events-none{
    pointer-events: none !important;
  }

  .lg\\:pointer-events-auto{
    pointer-events: auto !important;
  }

  .lg\\:static{
    position: static !important;
  }

  .lg\\:fixed{
    position: fixed !important;
  }

  .lg\\:absolute{
    position: absolute !important;
  }

  .lg\\:relative{
    position: relative !important;
  }

  .lg\\:sticky{
    position: sticky !important;
  }

  .lg\\:inset-0{
    top: 0 !important;
    bottom: 0 !important;
  }

  [dir=ltr] .lg\\:inset-0{
    right: 0 !important;
    left: 0 !important;
  }

  [dir=rtl] .lg\\:inset-0{
    left: 0 !important;
    right: 0 !important;
  }

  .lg\\:inset-auto{
    top: auto !important;
    bottom: auto !important;
  }

  [dir=ltr] .lg\\:inset-auto{
    right: auto !important;
    left: auto !important;
  }

  [dir=rtl] .lg\\:inset-auto{
    left: auto !important;
    right: auto !important;
  }

  .lg\\:inset-y-0{
    top: 0 !important;
    bottom: 0 !important;
  }

  [dir=ltr] .lg\\:inset-x-0{
    right: 0 !important;
    left: 0 !important;
  }

  [dir=rtl] .lg\\:inset-x-0{
    left: 0 !important;
    right: 0 !important;
  }

  .lg\\:inset-y-auto{
    top: auto !important;
    bottom: auto !important;
  }

  [dir=ltr] .lg\\:inset-x-auto{
    right: auto !important;
    left: auto !important;
  }

  [dir=rtl] .lg\\:inset-x-auto{
    left: auto !important;
    right: auto !important;
  }

  .lg\\:top-0{
    top: 0 !important;
  }

  [dir=ltr] .lg\\:right-0{
    right: 0 !important;
  }

  [dir=rtl] .lg\\:right-0{
    left: 0 !important;
  }

  .lg\\:bottom-0{
    bottom: 0 !important;
  }

  [dir=ltr] .lg\\:left-0{
    left: 0 !important;
  }

  [dir=rtl] .lg\\:left-0{
    right: 0 !important;
  }

  .lg\\:top-auto{
    top: auto !important;
  }

  [dir=ltr] .lg\\:right-auto{
    right: auto !important;
  }

  [dir=rtl] .lg\\:right-auto{
    left: auto !important;
  }

  .lg\\:bottom-auto{
    bottom: auto !important;
  }

  [dir=ltr] .lg\\:left-auto{
    left: auto !important;
  }

  [dir=rtl] .lg\\:left-auto{
    right: auto !important;
  }

  .lg\\:resize-none{
    resize: none !important;
  }

  .lg\\:resize-y{
    resize: vertical !important;
  }

  .lg\\:resize-x{
    resize: horizontal !important;
  }

  .lg\\:resize{
    resize: both !important;
  }

  [dir] .lg\\:shadow{
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
  }

  [dir] .lg\\:shadow-md{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .lg\\:shadow-lg{
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .lg\\:shadow-inner{
    box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
  }

  [dir] .lg\\:shadow-xl{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  [dir] .lg\\:shadow-2xl{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }

  [dir] .lg\\:shadow-outline{
    box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
  }

  [dir] .lg\\:shadow-none{
    box-shadow: none !important;
  }

  [dir] .lg\\:shadow-drop{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
  }

  [dir] .lg\\:hover\\:shadow:hover{
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
  }

  [dir] .lg\\:hover\\:shadow-md:hover{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .lg\\:hover\\:shadow-lg:hover{
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .lg\\:hover\\:shadow-inner:hover{
    box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
  }

  [dir] .lg\\:hover\\:shadow-xl:hover{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  [dir] .lg\\:hover\\:shadow-2xl:hover{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }

  [dir] .lg\\:hover\\:shadow-outline:hover{
    box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
  }

  [dir] .lg\\:hover\\:shadow-none:hover{
    box-shadow: none !important;
  }

  [dir] .lg\\:hover\\:shadow-drop:hover{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
  }

  [dir] .lg\\:focus\\:shadow:focus{
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
  }

  [dir] .lg\\:focus\\:shadow-md:focus{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .lg\\:focus\\:shadow-lg:focus{
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .lg\\:focus\\:shadow-inner:focus{
    box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
  }

  [dir] .lg\\:focus\\:shadow-xl:focus{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  [dir] .lg\\:focus\\:shadow-2xl:focus{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }

  [dir] .lg\\:focus\\:shadow-outline:focus{
    box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
  }

  [dir] .lg\\:focus\\:shadow-none:focus{
    box-shadow: none !important;
  }

  [dir] .lg\\:focus\\:shadow-drop:focus{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
  }

  .lg\\:stroke-0{
    stroke-width: 0 !important;
  }

  .lg\\:stroke-1{
    stroke-width: 1 !important;
  }

  .lg\\:stroke-2{
    stroke-width: 2 !important;
  }

  .lg\\:table-auto{
    table-layout: auto !important;
  }

  .lg\\:table-fixed{
    table-layout: fixed !important;
  }

  [dir=ltr] .lg\\:text-left{
    text-align: left !important;
  }

  [dir=rtl] .lg\\:text-left{
    text-align: right !important;
  }

  [dir] .lg\\:text-center{
    text-align: center !important;
  }

  [dir=ltr] .lg\\:text-right{
    text-align: right !important;
  }

  [dir=rtl] .lg\\:text-right{
    text-align: left !important;
  }

  [dir] .lg\\:text-justify{
    text-align: justify !important;
  }

  .lg\\:text-inherit{
    color: inherit !important;
  }

  .lg\\:text-transparent{
    color: transparent !important;
  }

  .lg\\:text-black{
    --text-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--text-opacity)) !important;
  }

  .lg\\:text-white{
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }

  .lg\\:text-grey{
    --text-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--text-opacity)) !important;
  }

  .lg\\:text-grey-light{
    --text-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--text-opacity)) !important;
  }

  .lg\\:hover\\:text-inherit:hover{
    color: inherit !important;
  }

  .lg\\:hover\\:text-transparent:hover{
    color: transparent !important;
  }

  .lg\\:hover\\:text-black:hover{
    --text-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--text-opacity)) !important;
  }

  .lg\\:hover\\:text-white:hover{
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }

  .lg\\:hover\\:text-grey:hover{
    --text-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--text-opacity)) !important;
  }

  .lg\\:hover\\:text-grey-light:hover{
    --text-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--text-opacity)) !important;
  }

  .lg\\:focus\\:text-inherit:focus{
    color: inherit !important;
  }

  .lg\\:focus\\:text-transparent:focus{
    color: transparent !important;
  }

  .lg\\:focus\\:text-black:focus{
    --text-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--text-opacity)) !important;
  }

  .lg\\:focus\\:text-white:focus{
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }

  .lg\\:focus\\:text-grey:focus{
    --text-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--text-opacity)) !important;
  }

  .lg\\:focus\\:text-grey-light:focus{
    --text-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--text-opacity)) !important;
  }

  .lg\\:text-opacity-0{
    --text-opacity: 0 !important;
  }

  .lg\\:text-opacity-25{
    --text-opacity: 0.25 !important;
  }

  .lg\\:text-opacity-50{
    --text-opacity: 0.5 !important;
  }

  .lg\\:text-opacity-75{
    --text-opacity: 0.75 !important;
  }

  .lg\\:text-opacity-100{
    --text-opacity: 1 !important;
  }

  .lg\\:hover\\:text-opacity-0:hover{
    --text-opacity: 0 !important;
  }

  .lg\\:hover\\:text-opacity-25:hover{
    --text-opacity: 0.25 !important;
  }

  .lg\\:hover\\:text-opacity-50:hover{
    --text-opacity: 0.5 !important;
  }

  .lg\\:hover\\:text-opacity-75:hover{
    --text-opacity: 0.75 !important;
  }

  .lg\\:hover\\:text-opacity-100:hover{
    --text-opacity: 1 !important;
  }

  .lg\\:focus\\:text-opacity-0:focus{
    --text-opacity: 0 !important;
  }

  .lg\\:focus\\:text-opacity-25:focus{
    --text-opacity: 0.25 !important;
  }

  .lg\\:focus\\:text-opacity-50:focus{
    --text-opacity: 0.5 !important;
  }

  .lg\\:focus\\:text-opacity-75:focus{
    --text-opacity: 0.75 !important;
  }

  .lg\\:focus\\:text-opacity-100:focus{
    --text-opacity: 1 !important;
  }

  .lg\\:italic{
    font-style: italic !important;
  }

  .lg\\:not-italic{
    font-style: normal !important;
  }

  .lg\\:hover\\:italic:hover{
    font-style: italic !important;
  }

  .lg\\:hover\\:not-italic:hover{
    font-style: normal !important;
  }

  .lg\\:focus\\:italic:focus{
    font-style: italic !important;
  }

  .lg\\:focus\\:not-italic:focus{
    font-style: normal !important;
  }

  .lg\\:uppercase{
    text-transform: uppercase !important;
  }

  .lg\\:lowercase{
    text-transform: lowercase !important;
  }

  .lg\\:capitalize{
    text-transform: capitalize !important;
  }

  .lg\\:normal-case{
    text-transform: none !important;
  }

  .lg\\:hover\\:uppercase:hover{
    text-transform: uppercase !important;
  }

  .lg\\:hover\\:lowercase:hover{
    text-transform: lowercase !important;
  }

  .lg\\:hover\\:capitalize:hover{
    text-transform: capitalize !important;
  }

  .lg\\:hover\\:normal-case:hover{
    text-transform: none !important;
  }

  .lg\\:focus\\:uppercase:focus{
    text-transform: uppercase !important;
  }

  .lg\\:focus\\:lowercase:focus{
    text-transform: lowercase !important;
  }

  .lg\\:focus\\:capitalize:focus{
    text-transform: capitalize !important;
  }

  .lg\\:focus\\:normal-case:focus{
    text-transform: none !important;
  }

  .lg\\:underline{
    text-decoration: underline !important;
  }

  .lg\\:line-through{
    text-decoration: line-through !important;
  }

  .lg\\:no-underline{
    text-decoration: none !important;
  }

  .lg\\:hover\\:underline:hover{
    text-decoration: underline !important;
  }

  .lg\\:hover\\:line-through:hover{
    text-decoration: line-through !important;
  }

  .lg\\:hover\\:no-underline:hover{
    text-decoration: none !important;
  }

  .lg\\:focus\\:underline:focus{
    text-decoration: underline !important;
  }

  .lg\\:focus\\:line-through:focus{
    text-decoration: line-through !important;
  }

  .lg\\:focus\\:no-underline:focus{
    text-decoration: none !important;
  }

  .lg\\:antialiased{
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }

  .lg\\:subpixel-antialiased{
    -webkit-font-smoothing: auto !important;
    -moz-osx-font-smoothing: auto !important;
  }

  .lg\\:hover\\:antialiased:hover{
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }

  .lg\\:hover\\:subpixel-antialiased:hover{
    -webkit-font-smoothing: auto !important;
    -moz-osx-font-smoothing: auto !important;
  }

  .lg\\:focus\\:antialiased:focus{
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }

  .lg\\:focus\\:subpixel-antialiased:focus{
    -webkit-font-smoothing: auto !important;
    -moz-osx-font-smoothing: auto !important;
  }

  .lg\\:ordinal, .lg\\:slashed-zero, .lg\\:lining-nums, .lg\\:oldstyle-nums, .lg\\:proportional-nums, .lg\\:tabular-nums, .lg\\:diagonal-fractions, .lg\\:stacked-fractions{
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/) !important;
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction) !important;
  }

  .lg\\:normal-nums{
    font-variant-numeric: normal !important;
  }

  .lg\\:ordinal{
    --font-variant-numeric-ordinal: ordinal !important;
  }

  .lg\\:slashed-zero{
    --font-variant-numeric-slashed-zero: slashed-zero !important;
  }

  .lg\\:lining-nums{
    --font-variant-numeric-figure: lining-nums !important;
  }

  .lg\\:oldstyle-nums{
    --font-variant-numeric-figure: oldstyle-nums !important;
  }

  .lg\\:proportional-nums{
    --font-variant-numeric-spacing: proportional-nums !important;
  }

  .lg\\:tabular-nums{
    --font-variant-numeric-spacing: tabular-nums !important;
  }

  .lg\\:diagonal-fractions{
    --font-variant-numeric-fraction: diagonal-fractions !important;
  }

  .lg\\:stacked-fractions{
    --font-variant-numeric-fraction: stacked-fractions !important;
  }

  .lg\\:select-none{
    -webkit-user-select: none !important;
            user-select: none !important;
  }

  .lg\\:select-text{
    -webkit-user-select: text !important;
            user-select: text !important;
  }

  .lg\\:select-all{
    -webkit-user-select: all !important;
            user-select: all !important;
  }

  .lg\\:select-auto{
    -webkit-user-select: auto !important;
            user-select: auto !important;
  }

  .lg\\:align-baseline{
    vertical-align: baseline !important;
  }

  .lg\\:align-top{
    vertical-align: top !important;
  }

  .lg\\:align-middle{
    vertical-align: middle !important;
  }

  .lg\\:align-bottom{
    vertical-align: bottom !important;
  }

  .lg\\:align-text-top{
    vertical-align: text-top !important;
  }

  .lg\\:align-text-bottom{
    vertical-align: text-bottom !important;
  }

  .lg\\:visible{
    visibility: visible !important;
  }

  .lg\\:invisible{
    visibility: hidden !important;
  }

  .lg\\:whitespace-normal{
    white-space: normal !important;
  }

  .lg\\:whitespace-no-wrap{
    white-space: nowrap !important;
  }

  .lg\\:whitespace-pre{
    white-space: pre !important;
  }

  .lg\\:whitespace-pre-line{
    white-space: pre-line !important;
  }

  .lg\\:whitespace-pre-wrap{
    white-space: pre-wrap !important;
  }

  .lg\\:break-normal{
    word-wrap: normal !important;
    overflow-wrap: normal !important;
    word-break: normal !important;
  }

  .lg\\:break-words{
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
  }

  .lg\\:break-all{
    word-break: break-all !important;
  }

  .lg\\:truncate{
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .lg\\:w-1{
    width: 0.25rem !important;
  }

  .lg\\:w-2{
    width: 0.5rem !important;
  }

  .lg\\:w-3{
    width: 0.75rem !important;
  }

  .lg\\:w-4{
    width: 1rem !important;
  }

  .lg\\:w-5{
    width: 1.25rem !important;
  }

  .lg\\:w-6{
    width: 1.5rem !important;
  }

  .lg\\:w-8{
    width: 2rem !important;
  }

  .lg\\:w-10{
    width: 2.5rem !important;
  }

  .lg\\:w-12{
    width: 3rem !important;
  }

  .lg\\:w-16{
    width: 4rem !important;
  }

  .lg\\:w-24{
    width: 6rem !important;
  }

  .lg\\:w-32{
    width: 8rem !important;
  }

  .lg\\:w-48{
    width: 12rem !important;
  }

  .lg\\:w-64{
    width: 16rem !important;
  }

  .lg\\:w-auto{
    width: auto !important;
  }

  .lg\\:w-px{
    width: 1px !important;
  }

  .lg\\:w-1\\/2{
    width: 50% !important;
  }

  .lg\\:w-1\\/3{
    width: 33.33333% !important;
  }

  .lg\\:w-2\\/3{
    width: 66.66667% !important;
  }

  .lg\\:w-1\\/4{
    width: 25% !important;
  }

  .lg\\:w-3\\/4{
    width: 75% !important;
  }

  .lg\\:w-1\\/5{
    width: 20% !important;
  }

  .lg\\:w-2\\/5{
    width: 40% !important;
  }

  .lg\\:w-3\\/5{
    width: 60% !important;
  }

  .lg\\:w-4\\/5{
    width: 80% !important;
  }

  .lg\\:w-1\\/6{
    width: 16.66667% !important;
  }

  .lg\\:w-5\\/6{
    width: 83.33333% !important;
  }

  .lg\\:w-1\\/12{
    width: 8.33333% !important;
  }

  .lg\\:w-2\\/12{
    width: 16.66667% !important;
  }

  .lg\\:w-3\\/12{
    width: 25% !important;
  }

  .lg\\:w-4\\/12{
    width: 33.33333% !important;
  }

  .lg\\:w-5\\/12{
    width: 41.66667% !important;
  }

  .lg\\:w-6\\/12{
    width: 50% !important;
  }

  .lg\\:w-7\\/12{
    width: 58.33333% !important;
  }

  .lg\\:w-8\\/12{
    width: 66.66667% !important;
  }

  .lg\\:w-9\\/12{
    width: 75% !important;
  }

  .lg\\:w-10\\/12{
    width: 83.33333% !important;
  }

  .lg\\:w-11\\/12{
    width: 91.66667% !important;
  }

  .lg\\:w-full{
    width: 100% !important;
  }

  .lg\\:w-screen{
    width: 100vw !important;
  }

  .lg\\:z-0{
    z-index: 0 !important;
  }

  .lg\\:z-10{
    z-index: 10 !important;
  }

  .lg\\:z-20{
    z-index: 20 !important;
  }

  .lg\\:z-30{
    z-index: 30 !important;
  }

  .lg\\:z-40{
    z-index: 40 !important;
  }

  .lg\\:z-50{
    z-index: 50 !important;
  }

  .lg\\:z-auto{
    z-index: auto !important;
  }

  .lg\\:gap-0{
    grid-gap: 0 !important;
    gap: 0 !important;
  }

  .lg\\:gap-1{
    grid-gap: 0.25rem !important;
    gap: 0.25rem !important;
  }

  .lg\\:gap-2{
    grid-gap: 0.5rem !important;
    gap: 0.5rem !important;
  }

  .lg\\:gap-3{
    grid-gap: 0.75rem !important;
    gap: 0.75rem !important;
  }

  .lg\\:gap-4{
    grid-gap: 1rem !important;
    gap: 1rem !important;
  }

  .lg\\:gap-5{
    grid-gap: 1.25rem !important;
    gap: 1.25rem !important;
  }

  .lg\\:gap-6{
    grid-gap: 1.5rem !important;
    gap: 1.5rem !important;
  }

  .lg\\:gap-8{
    grid-gap: 2rem !important;
    gap: 2rem !important;
  }

  .lg\\:gap-10{
    grid-gap: 2.5rem !important;
    gap: 2.5rem !important;
  }

  .lg\\:gap-12{
    grid-gap: 3rem !important;
    gap: 3rem !important;
  }

  .lg\\:gap-16{
    grid-gap: 4rem !important;
    gap: 4rem !important;
  }

  .lg\\:gap-20{
    grid-gap: 5rem !important;
    gap: 5rem !important;
  }

  .lg\\:gap-24{
    grid-gap: 6rem !important;
    gap: 6rem !important;
  }

  .lg\\:gap-32{
    grid-gap: 8rem !important;
    gap: 8rem !important;
  }

  .lg\\:gap-40{
    grid-gap: 10rem !important;
    gap: 10rem !important;
  }

  .lg\\:gap-48{
    grid-gap: 12rem !important;
    gap: 12rem !important;
  }

  .lg\\:gap-56{
    grid-gap: 14rem !important;
    gap: 14rem !important;
  }

  .lg\\:gap-64{
    grid-gap: 16rem !important;
    gap: 16rem !important;
  }

  .lg\\:gap-px{
    grid-gap: 1px !important;
    gap: 1px !important;
  }

  .lg\\:col-gap-0{
    grid-column-gap: 0 !important;
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .lg\\:col-gap-1{
    grid-column-gap: 0.25rem !important;
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .lg\\:col-gap-2{
    grid-column-gap: 0.5rem !important;
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .lg\\:col-gap-3{
    grid-column-gap: 0.75rem !important;
    -moz-column-gap: 0.75rem !important;
         column-gap: 0.75rem !important;
  }

  .lg\\:col-gap-4{
    grid-column-gap: 1rem !important;
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .lg\\:col-gap-5{
    grid-column-gap: 1.25rem !important;
    -moz-column-gap: 1.25rem !important;
         column-gap: 1.25rem !important;
  }

  .lg\\:col-gap-6{
    grid-column-gap: 1.5rem !important;
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .lg\\:col-gap-8{
    grid-column-gap: 2rem !important;
    -moz-column-gap: 2rem !important;
         column-gap: 2rem !important;
  }

  .lg\\:col-gap-10{
    grid-column-gap: 2.5rem !important;
    -moz-column-gap: 2.5rem !important;
         column-gap: 2.5rem !important;
  }

  .lg\\:col-gap-12{
    grid-column-gap: 3rem !important;
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  .lg\\:col-gap-16{
    grid-column-gap: 4rem !important;
    -moz-column-gap: 4rem !important;
         column-gap: 4rem !important;
  }

  .lg\\:col-gap-20{
    grid-column-gap: 5rem !important;
    -moz-column-gap: 5rem !important;
         column-gap: 5rem !important;
  }

  .lg\\:col-gap-24{
    grid-column-gap: 6rem !important;
    -moz-column-gap: 6rem !important;
         column-gap: 6rem !important;
  }

  .lg\\:col-gap-32{
    grid-column-gap: 8rem !important;
    -moz-column-gap: 8rem !important;
         column-gap: 8rem !important;
  }

  .lg\\:col-gap-40{
    grid-column-gap: 10rem !important;
    -moz-column-gap: 10rem !important;
         column-gap: 10rem !important;
  }

  .lg\\:col-gap-48{
    grid-column-gap: 12rem !important;
    -moz-column-gap: 12rem !important;
         column-gap: 12rem !important;
  }

  .lg\\:col-gap-56{
    grid-column-gap: 14rem !important;
    -moz-column-gap: 14rem !important;
         column-gap: 14rem !important;
  }

  .lg\\:col-gap-64{
    grid-column-gap: 16rem !important;
    -moz-column-gap: 16rem !important;
         column-gap: 16rem !important;
  }

  .lg\\:col-gap-px{
    grid-column-gap: 1px !important;
    -moz-column-gap: 1px !important;
         column-gap: 1px !important;
  }

  .lg\\:gap-x-0{
    grid-column-gap: 0 !important;
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .lg\\:gap-x-1{
    grid-column-gap: 0.25rem !important;
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .lg\\:gap-x-2{
    grid-column-gap: 0.5rem !important;
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .lg\\:gap-x-3{
    grid-column-gap: 0.75rem !important;
    -moz-column-gap: 0.75rem !important;
         column-gap: 0.75rem !important;
  }

  .lg\\:gap-x-4{
    grid-column-gap: 1rem !important;
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .lg\\:gap-x-5{
    grid-column-gap: 1.25rem !important;
    -moz-column-gap: 1.25rem !important;
         column-gap: 1.25rem !important;
  }

  .lg\\:gap-x-6{
    grid-column-gap: 1.5rem !important;
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .lg\\:gap-x-8{
    grid-column-gap: 2rem !important;
    -moz-column-gap: 2rem !important;
         column-gap: 2rem !important;
  }

  .lg\\:gap-x-10{
    grid-column-gap: 2.5rem !important;
    -moz-column-gap: 2.5rem !important;
         column-gap: 2.5rem !important;
  }

  .lg\\:gap-x-12{
    grid-column-gap: 3rem !important;
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  .lg\\:gap-x-16{
    grid-column-gap: 4rem !important;
    -moz-column-gap: 4rem !important;
         column-gap: 4rem !important;
  }

  .lg\\:gap-x-20{
    grid-column-gap: 5rem !important;
    -moz-column-gap: 5rem !important;
         column-gap: 5rem !important;
  }

  .lg\\:gap-x-24{
    grid-column-gap: 6rem !important;
    -moz-column-gap: 6rem !important;
         column-gap: 6rem !important;
  }

  .lg\\:gap-x-32{
    grid-column-gap: 8rem !important;
    -moz-column-gap: 8rem !important;
         column-gap: 8rem !important;
  }

  .lg\\:gap-x-40{
    grid-column-gap: 10rem !important;
    -moz-column-gap: 10rem !important;
         column-gap: 10rem !important;
  }

  .lg\\:gap-x-48{
    grid-column-gap: 12rem !important;
    -moz-column-gap: 12rem !important;
         column-gap: 12rem !important;
  }

  .lg\\:gap-x-56{
    grid-column-gap: 14rem !important;
    -moz-column-gap: 14rem !important;
         column-gap: 14rem !important;
  }

  .lg\\:gap-x-64{
    grid-column-gap: 16rem !important;
    -moz-column-gap: 16rem !important;
         column-gap: 16rem !important;
  }

  .lg\\:gap-x-px{
    grid-column-gap: 1px !important;
    -moz-column-gap: 1px !important;
         column-gap: 1px !important;
  }

  .lg\\:row-gap-0{
    grid-row-gap: 0 !important;
    row-gap: 0 !important;
  }

  .lg\\:row-gap-1{
    grid-row-gap: 0.25rem !important;
    row-gap: 0.25rem !important;
  }

  .lg\\:row-gap-2{
    grid-row-gap: 0.5rem !important;
    row-gap: 0.5rem !important;
  }

  .lg\\:row-gap-3{
    grid-row-gap: 0.75rem !important;
    row-gap: 0.75rem !important;
  }

  .lg\\:row-gap-4{
    grid-row-gap: 1rem !important;
    row-gap: 1rem !important;
  }

  .lg\\:row-gap-5{
    grid-row-gap: 1.25rem !important;
    row-gap: 1.25rem !important;
  }

  .lg\\:row-gap-6{
    grid-row-gap: 1.5rem !important;
    row-gap: 1.5rem !important;
  }

  .lg\\:row-gap-8{
    grid-row-gap: 2rem !important;
    row-gap: 2rem !important;
  }

  .lg\\:row-gap-10{
    grid-row-gap: 2.5rem !important;
    row-gap: 2.5rem !important;
  }

  .lg\\:row-gap-12{
    grid-row-gap: 3rem !important;
    row-gap: 3rem !important;
  }

  .lg\\:row-gap-16{
    grid-row-gap: 4rem !important;
    row-gap: 4rem !important;
  }

  .lg\\:row-gap-20{
    grid-row-gap: 5rem !important;
    row-gap: 5rem !important;
  }

  .lg\\:row-gap-24{
    grid-row-gap: 6rem !important;
    row-gap: 6rem !important;
  }

  .lg\\:row-gap-32{
    grid-row-gap: 8rem !important;
    row-gap: 8rem !important;
  }

  .lg\\:row-gap-40{
    grid-row-gap: 10rem !important;
    row-gap: 10rem !important;
  }

  .lg\\:row-gap-48{
    grid-row-gap: 12rem !important;
    row-gap: 12rem !important;
  }

  .lg\\:row-gap-56{
    grid-row-gap: 14rem !important;
    row-gap: 14rem !important;
  }

  .lg\\:row-gap-64{
    grid-row-gap: 16rem !important;
    row-gap: 16rem !important;
  }

  .lg\\:row-gap-px{
    grid-row-gap: 1px !important;
    row-gap: 1px !important;
  }

  .lg\\:gap-y-0{
    grid-row-gap: 0 !important;
    row-gap: 0 !important;
  }

  .lg\\:gap-y-1{
    grid-row-gap: 0.25rem !important;
    row-gap: 0.25rem !important;
  }

  .lg\\:gap-y-2{
    grid-row-gap: 0.5rem !important;
    row-gap: 0.5rem !important;
  }

  .lg\\:gap-y-3{
    grid-row-gap: 0.75rem !important;
    row-gap: 0.75rem !important;
  }

  .lg\\:gap-y-4{
    grid-row-gap: 1rem !important;
    row-gap: 1rem !important;
  }

  .lg\\:gap-y-5{
    grid-row-gap: 1.25rem !important;
    row-gap: 1.25rem !important;
  }

  .lg\\:gap-y-6{
    grid-row-gap: 1.5rem !important;
    row-gap: 1.5rem !important;
  }

  .lg\\:gap-y-8{
    grid-row-gap: 2rem !important;
    row-gap: 2rem !important;
  }

  .lg\\:gap-y-10{
    grid-row-gap: 2.5rem !important;
    row-gap: 2.5rem !important;
  }

  .lg\\:gap-y-12{
    grid-row-gap: 3rem !important;
    row-gap: 3rem !important;
  }

  .lg\\:gap-y-16{
    grid-row-gap: 4rem !important;
    row-gap: 4rem !important;
  }

  .lg\\:gap-y-20{
    grid-row-gap: 5rem !important;
    row-gap: 5rem !important;
  }

  .lg\\:gap-y-24{
    grid-row-gap: 6rem !important;
    row-gap: 6rem !important;
  }

  .lg\\:gap-y-32{
    grid-row-gap: 8rem !important;
    row-gap: 8rem !important;
  }

  .lg\\:gap-y-40{
    grid-row-gap: 10rem !important;
    row-gap: 10rem !important;
  }

  .lg\\:gap-y-48{
    grid-row-gap: 12rem !important;
    row-gap: 12rem !important;
  }

  .lg\\:gap-y-56{
    grid-row-gap: 14rem !important;
    row-gap: 14rem !important;
  }

  .lg\\:gap-y-64{
    grid-row-gap: 16rem !important;
    row-gap: 16rem !important;
  }

  .lg\\:gap-y-px{
    grid-row-gap: 1px !important;
    row-gap: 1px !important;
  }

  .lg\\:grid-flow-row{
    grid-auto-flow: row !important;
  }

  .lg\\:grid-flow-col{
    grid-auto-flow: column !important;
  }

  .lg\\:grid-flow-row-dense{
    grid-auto-flow: row dense !important;
  }

  .lg\\:grid-flow-col-dense{
    grid-auto-flow: column dense !important;
  }

  .lg\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-cols-none{
    grid-template-columns: none !important;
  }

  .lg\\:auto-cols-auto{
    grid-auto-columns: auto !important;
  }

  .lg\\:auto-cols-min{
    grid-auto-columns: min-content !important;
  }

  .lg\\:auto-cols-max{
    grid-auto-columns: max-content !important;
  }

  .lg\\:auto-cols-fr{
    grid-auto-columns: minmax(0, 1fr) !important;
  }

  .lg\\:col-auto{
    grid-column: auto !important;
  }

  .lg\\:col-span-1{
    grid-column: span 1 / span 1 !important;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2 !important;
  }

  .lg\\:col-span-3{
    grid-column: span 3 / span 3 !important;
  }

  .lg\\:col-span-4{
    grid-column: span 4 / span 4 !important;
  }

  .lg\\:col-span-5{
    grid-column: span 5 / span 5 !important;
  }

  .lg\\:col-span-6{
    grid-column: span 6 / span 6 !important;
  }

  .lg\\:col-span-7{
    grid-column: span 7 / span 7 !important;
  }

  .lg\\:col-span-8{
    grid-column: span 8 / span 8 !important;
  }

  .lg\\:col-span-9{
    grid-column: span 9 / span 9 !important;
  }

  .lg\\:col-span-10{
    grid-column: span 10 / span 10 !important;
  }

  .lg\\:col-span-11{
    grid-column: span 11 / span 11 !important;
  }

  .lg\\:col-span-12{
    grid-column: span 12 / span 12 !important;
  }

  .lg\\:col-span-full{
    grid-column: 1 / -1 !important;
  }

  .lg\\:col-start-1{
    grid-column-start: 1 !important;
  }

  .lg\\:col-start-2{
    grid-column-start: 2 !important;
  }

  .lg\\:col-start-3{
    grid-column-start: 3 !important;
  }

  .lg\\:col-start-4{
    grid-column-start: 4 !important;
  }

  .lg\\:col-start-5{
    grid-column-start: 5 !important;
  }

  .lg\\:col-start-6{
    grid-column-start: 6 !important;
  }

  .lg\\:col-start-7{
    grid-column-start: 7 !important;
  }

  .lg\\:col-start-8{
    grid-column-start: 8 !important;
  }

  .lg\\:col-start-9{
    grid-column-start: 9 !important;
  }

  .lg\\:col-start-10{
    grid-column-start: 10 !important;
  }

  .lg\\:col-start-11{
    grid-column-start: 11 !important;
  }

  .lg\\:col-start-12{
    grid-column-start: 12 !important;
  }

  .lg\\:col-start-13{
    grid-column-start: 13 !important;
  }

  .lg\\:col-start-auto{
    grid-column-start: auto !important;
  }

  .lg\\:col-end-1{
    grid-column-end: 1 !important;
  }

  .lg\\:col-end-2{
    grid-column-end: 2 !important;
  }

  .lg\\:col-end-3{
    grid-column-end: 3 !important;
  }

  .lg\\:col-end-4{
    grid-column-end: 4 !important;
  }

  .lg\\:col-end-5{
    grid-column-end: 5 !important;
  }

  .lg\\:col-end-6{
    grid-column-end: 6 !important;
  }

  .lg\\:col-end-7{
    grid-column-end: 7 !important;
  }

  .lg\\:col-end-8{
    grid-column-end: 8 !important;
  }

  .lg\\:col-end-9{
    grid-column-end: 9 !important;
  }

  .lg\\:col-end-10{
    grid-column-end: 10 !important;
  }

  .lg\\:col-end-11{
    grid-column-end: 11 !important;
  }

  .lg\\:col-end-12{
    grid-column-end: 12 !important;
  }

  .lg\\:col-end-13{
    grid-column-end: 13 !important;
  }

  .lg\\:col-end-auto{
    grid-column-end: auto !important;
  }

  .lg\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-rows-2{
    grid-template-rows: repeat(2, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-rows-3{
    grid-template-rows: repeat(3, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-rows-4{
    grid-template-rows: repeat(4, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-rows-5{
    grid-template-rows: repeat(5, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-rows-6{
    grid-template-rows: repeat(6, minmax(0, 1fr)) !important;
  }

  .lg\\:grid-rows-none{
    grid-template-rows: none !important;
  }

  .lg\\:auto-rows-auto{
    grid-auto-rows: auto !important;
  }

  .lg\\:auto-rows-min{
    grid-auto-rows: min-content !important;
  }

  .lg\\:auto-rows-max{
    grid-auto-rows: max-content !important;
  }

  .lg\\:auto-rows-fr{
    grid-auto-rows: minmax(0, 1fr) !important;
  }

  .lg\\:row-auto{
    grid-row: auto !important;
  }

  .lg\\:row-span-1{
    grid-row: span 1 / span 1 !important;
  }

  .lg\\:row-span-2{
    grid-row: span 2 / span 2 !important;
  }

  .lg\\:row-span-3{
    grid-row: span 3 / span 3 !important;
  }

  .lg\\:row-span-4{
    grid-row: span 4 / span 4 !important;
  }

  .lg\\:row-span-5{
    grid-row: span 5 / span 5 !important;
  }

  .lg\\:row-span-6{
    grid-row: span 6 / span 6 !important;
  }

  .lg\\:row-span-full{
    grid-row: 1 / -1 !important;
  }

  .lg\\:row-start-1{
    grid-row-start: 1 !important;
  }

  .lg\\:row-start-2{
    grid-row-start: 2 !important;
  }

  .lg\\:row-start-3{
    grid-row-start: 3 !important;
  }

  .lg\\:row-start-4{
    grid-row-start: 4 !important;
  }

  .lg\\:row-start-5{
    grid-row-start: 5 !important;
  }

  .lg\\:row-start-6{
    grid-row-start: 6 !important;
  }

  .lg\\:row-start-7{
    grid-row-start: 7 !important;
  }

  .lg\\:row-start-auto{
    grid-row-start: auto !important;
  }

  .lg\\:row-end-1{
    grid-row-end: 1 !important;
  }

  .lg\\:row-end-2{
    grid-row-end: 2 !important;
  }

  .lg\\:row-end-3{
    grid-row-end: 3 !important;
  }

  .lg\\:row-end-4{
    grid-row-end: 4 !important;
  }

  .lg\\:row-end-5{
    grid-row-end: 5 !important;
  }

  .lg\\:row-end-6{
    grid-row-end: 6 !important;
  }

  .lg\\:row-end-7{
    grid-row-end: 7 !important;
  }

  .lg\\:row-end-auto{
    grid-row-end: auto !important;
  }

  .lg\\:transform{
    --transform-translate-x: 0 !important;
    --transform-translate-y: 0 !important;
    --transform-rotate: 0 !important;
    --transform-skew-x: 0 !important;
    --transform-skew-y: 0 !important;
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  [dir] .lg\\:transform{
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y)) !important;
  }

  [dir] .lg\\:transform-none{
    transform: none !important;
  }

  [dir] .lg\\:origin-center{
    transform-origin: center !important;
  }

  [dir] .lg\\:origin-top{
    transform-origin: top !important;
  }

  [dir=ltr] .lg\\:origin-top-right{
    transform-origin: top right !important;
  }

  [dir=rtl] .lg\\:origin-top-right{
    transform-origin: top left !important;
  }

  [dir=ltr] .lg\\:origin-right{
    transform-origin: right !important;
  }

  [dir=rtl] .lg\\:origin-right{
    transform-origin: left !important;
  }

  [dir=ltr] .lg\\:origin-bottom-right{
    transform-origin: bottom right !important;
  }

  [dir=rtl] .lg\\:origin-bottom-right{
    transform-origin: bottom left !important;
  }

  [dir] .lg\\:origin-bottom{
    transform-origin: bottom !important;
  }

  [dir=ltr] .lg\\:origin-bottom-left{
    transform-origin: bottom left !important;
  }

  [dir=rtl] .lg\\:origin-bottom-left{
    transform-origin: bottom right !important;
  }

  [dir=ltr] .lg\\:origin-left{
    transform-origin: left !important;
  }

  [dir=rtl] .lg\\:origin-left{
    transform-origin: right !important;
  }

  [dir=ltr] .lg\\:origin-top-left{
    transform-origin: top left !important;
  }

  [dir=rtl] .lg\\:origin-top-left{
    transform-origin: top right !important;
  }

  .lg\\:scale-0{
    --transform-scale-x: 0 !important;
    --transform-scale-y: 0 !important;
  }

  .lg\\:scale-50{
    --transform-scale-x: .5 !important;
    --transform-scale-y: .5 !important;
  }

  .lg\\:scale-75{
    --transform-scale-x: .75 !important;
    --transform-scale-y: .75 !important;
  }

  .lg\\:scale-90{
    --transform-scale-x: .9 !important;
    --transform-scale-y: .9 !important;
  }

  .lg\\:scale-95{
    --transform-scale-x: .95 !important;
    --transform-scale-y: .95 !important;
  }

  .lg\\:scale-100{
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  .lg\\:scale-105{
    --transform-scale-x: 1.05 !important;
    --transform-scale-y: 1.05 !important;
  }

  .lg\\:scale-110{
    --transform-scale-x: 1.1 !important;
    --transform-scale-y: 1.1 !important;
  }

  .lg\\:scale-125{
    --transform-scale-x: 1.25 !important;
    --transform-scale-y: 1.25 !important;
  }

  .lg\\:scale-150{
    --transform-scale-x: 1.5 !important;
    --transform-scale-y: 1.5 !important;
  }

  .lg\\:scale-x-0{
    --transform-scale-x: 0 !important;
  }

  .lg\\:scale-x-50{
    --transform-scale-x: .5 !important;
  }

  .lg\\:scale-x-75{
    --transform-scale-x: .75 !important;
  }

  .lg\\:scale-x-90{
    --transform-scale-x: .9 !important;
  }

  .lg\\:scale-x-95{
    --transform-scale-x: .95 !important;
  }

  .lg\\:scale-x-100{
    --transform-scale-x: 1 !important;
  }

  .lg\\:scale-x-105{
    --transform-scale-x: 1.05 !important;
  }

  .lg\\:scale-x-110{
    --transform-scale-x: 1.1 !important;
  }

  .lg\\:scale-x-125{
    --transform-scale-x: 1.25 !important;
  }

  .lg\\:scale-x-150{
    --transform-scale-x: 1.5 !important;
  }

  .lg\\:scale-y-0{
    --transform-scale-y: 0 !important;
  }

  .lg\\:scale-y-50{
    --transform-scale-y: .5 !important;
  }

  .lg\\:scale-y-75{
    --transform-scale-y: .75 !important;
  }

  .lg\\:scale-y-90{
    --transform-scale-y: .9 !important;
  }

  .lg\\:scale-y-95{
    --transform-scale-y: .95 !important;
  }

  .lg\\:scale-y-100{
    --transform-scale-y: 1 !important;
  }

  .lg\\:scale-y-105{
    --transform-scale-y: 1.05 !important;
  }

  .lg\\:scale-y-110{
    --transform-scale-y: 1.1 !important;
  }

  .lg\\:scale-y-125{
    --transform-scale-y: 1.25 !important;
  }

  .lg\\:scale-y-150{
    --transform-scale-y: 1.5 !important;
  }

  .lg\\:hover\\:scale-0:hover{
    --transform-scale-x: 0 !important;
    --transform-scale-y: 0 !important;
  }

  .lg\\:hover\\:scale-50:hover{
    --transform-scale-x: .5 !important;
    --transform-scale-y: .5 !important;
  }

  .lg\\:hover\\:scale-75:hover{
    --transform-scale-x: .75 !important;
    --transform-scale-y: .75 !important;
  }

  .lg\\:hover\\:scale-90:hover{
    --transform-scale-x: .9 !important;
    --transform-scale-y: .9 !important;
  }

  .lg\\:hover\\:scale-95:hover{
    --transform-scale-x: .95 !important;
    --transform-scale-y: .95 !important;
  }

  .lg\\:hover\\:scale-100:hover{
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  .lg\\:hover\\:scale-105:hover{
    --transform-scale-x: 1.05 !important;
    --transform-scale-y: 1.05 !important;
  }

  .lg\\:hover\\:scale-110:hover{
    --transform-scale-x: 1.1 !important;
    --transform-scale-y: 1.1 !important;
  }

  .lg\\:hover\\:scale-125:hover{
    --transform-scale-x: 1.25 !important;
    --transform-scale-y: 1.25 !important;
  }

  .lg\\:hover\\:scale-150:hover{
    --transform-scale-x: 1.5 !important;
    --transform-scale-y: 1.5 !important;
  }

  .lg\\:hover\\:scale-x-0:hover{
    --transform-scale-x: 0 !important;
  }

  .lg\\:hover\\:scale-x-50:hover{
    --transform-scale-x: .5 !important;
  }

  .lg\\:hover\\:scale-x-75:hover{
    --transform-scale-x: .75 !important;
  }

  .lg\\:hover\\:scale-x-90:hover{
    --transform-scale-x: .9 !important;
  }

  .lg\\:hover\\:scale-x-95:hover{
    --transform-scale-x: .95 !important;
  }

  .lg\\:hover\\:scale-x-100:hover{
    --transform-scale-x: 1 !important;
  }

  .lg\\:hover\\:scale-x-105:hover{
    --transform-scale-x: 1.05 !important;
  }

  .lg\\:hover\\:scale-x-110:hover{
    --transform-scale-x: 1.1 !important;
  }

  .lg\\:hover\\:scale-x-125:hover{
    --transform-scale-x: 1.25 !important;
  }

  .lg\\:hover\\:scale-x-150:hover{
    --transform-scale-x: 1.5 !important;
  }

  .lg\\:hover\\:scale-y-0:hover{
    --transform-scale-y: 0 !important;
  }

  .lg\\:hover\\:scale-y-50:hover{
    --transform-scale-y: .5 !important;
  }

  .lg\\:hover\\:scale-y-75:hover{
    --transform-scale-y: .75 !important;
  }

  .lg\\:hover\\:scale-y-90:hover{
    --transform-scale-y: .9 !important;
  }

  .lg\\:hover\\:scale-y-95:hover{
    --transform-scale-y: .95 !important;
  }

  .lg\\:hover\\:scale-y-100:hover{
    --transform-scale-y: 1 !important;
  }

  .lg\\:hover\\:scale-y-105:hover{
    --transform-scale-y: 1.05 !important;
  }

  .lg\\:hover\\:scale-y-110:hover{
    --transform-scale-y: 1.1 !important;
  }

  .lg\\:hover\\:scale-y-125:hover{
    --transform-scale-y: 1.25 !important;
  }

  .lg\\:hover\\:scale-y-150:hover{
    --transform-scale-y: 1.5 !important;
  }

  .lg\\:focus\\:scale-0:focus{
    --transform-scale-x: 0 !important;
    --transform-scale-y: 0 !important;
  }

  .lg\\:focus\\:scale-50:focus{
    --transform-scale-x: .5 !important;
    --transform-scale-y: .5 !important;
  }

  .lg\\:focus\\:scale-75:focus{
    --transform-scale-x: .75 !important;
    --transform-scale-y: .75 !important;
  }

  .lg\\:focus\\:scale-90:focus{
    --transform-scale-x: .9 !important;
    --transform-scale-y: .9 !important;
  }

  .lg\\:focus\\:scale-95:focus{
    --transform-scale-x: .95 !important;
    --transform-scale-y: .95 !important;
  }

  .lg\\:focus\\:scale-100:focus{
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  .lg\\:focus\\:scale-105:focus{
    --transform-scale-x: 1.05 !important;
    --transform-scale-y: 1.05 !important;
  }

  .lg\\:focus\\:scale-110:focus{
    --transform-scale-x: 1.1 !important;
    --transform-scale-y: 1.1 !important;
  }

  .lg\\:focus\\:scale-125:focus{
    --transform-scale-x: 1.25 !important;
    --transform-scale-y: 1.25 !important;
  }

  .lg\\:focus\\:scale-150:focus{
    --transform-scale-x: 1.5 !important;
    --transform-scale-y: 1.5 !important;
  }

  .lg\\:focus\\:scale-x-0:focus{
    --transform-scale-x: 0 !important;
  }

  .lg\\:focus\\:scale-x-50:focus{
    --transform-scale-x: .5 !important;
  }

  .lg\\:focus\\:scale-x-75:focus{
    --transform-scale-x: .75 !important;
  }

  .lg\\:focus\\:scale-x-90:focus{
    --transform-scale-x: .9 !important;
  }

  .lg\\:focus\\:scale-x-95:focus{
    --transform-scale-x: .95 !important;
  }

  .lg\\:focus\\:scale-x-100:focus{
    --transform-scale-x: 1 !important;
  }

  .lg\\:focus\\:scale-x-105:focus{
    --transform-scale-x: 1.05 !important;
  }

  .lg\\:focus\\:scale-x-110:focus{
    --transform-scale-x: 1.1 !important;
  }

  .lg\\:focus\\:scale-x-125:focus{
    --transform-scale-x: 1.25 !important;
  }

  .lg\\:focus\\:scale-x-150:focus{
    --transform-scale-x: 1.5 !important;
  }

  .lg\\:focus\\:scale-y-0:focus{
    --transform-scale-y: 0 !important;
  }

  .lg\\:focus\\:scale-y-50:focus{
    --transform-scale-y: .5 !important;
  }

  .lg\\:focus\\:scale-y-75:focus{
    --transform-scale-y: .75 !important;
  }

  .lg\\:focus\\:scale-y-90:focus{
    --transform-scale-y: .9 !important;
  }

  .lg\\:focus\\:scale-y-95:focus{
    --transform-scale-y: .95 !important;
  }

  .lg\\:focus\\:scale-y-100:focus{
    --transform-scale-y: 1 !important;
  }

  .lg\\:focus\\:scale-y-105:focus{
    --transform-scale-y: 1.05 !important;
  }

  .lg\\:focus\\:scale-y-110:focus{
    --transform-scale-y: 1.1 !important;
  }

  .lg\\:focus\\:scale-y-125:focus{
    --transform-scale-y: 1.25 !important;
  }

  .lg\\:focus\\:scale-y-150:focus{
    --transform-scale-y: 1.5 !important;
  }

  .lg\\:rotate-0{
    --transform-rotate: 0 !important;
  }

  .lg\\:rotate-1{
    --transform-rotate: 1deg !important;
  }

  .lg\\:rotate-2{
    --transform-rotate: 2deg !important;
  }

  .lg\\:rotate-3{
    --transform-rotate: 3deg !important;
  }

  .lg\\:rotate-6{
    --transform-rotate: 6deg !important;
  }

  .lg\\:rotate-12{
    --transform-rotate: 12deg !important;
  }

  .lg\\:rotate-45{
    --transform-rotate: 45deg !important;
  }

  .lg\\:rotate-90{
    --transform-rotate: 90deg !important;
  }

  .lg\\:rotate-180{
    --transform-rotate: 180deg !important;
  }

  .lg\\:-rotate-180{
    --transform-rotate: -180deg !important;
  }

  .lg\\:-rotate-90{
    --transform-rotate: -90deg !important;
  }

  .lg\\:-rotate-45{
    --transform-rotate: -45deg !important;
  }

  .lg\\:-rotate-12{
    --transform-rotate: -12deg !important;
  }

  .lg\\:-rotate-6{
    --transform-rotate: -6deg !important;
  }

  .lg\\:-rotate-3{
    --transform-rotate: -3deg !important;
  }

  .lg\\:-rotate-2{
    --transform-rotate: -2deg !important;
  }

  .lg\\:-rotate-1{
    --transform-rotate: -1deg !important;
  }

  .lg\\:hover\\:rotate-0:hover{
    --transform-rotate: 0 !important;
  }

  .lg\\:hover\\:rotate-1:hover{
    --transform-rotate: 1deg !important;
  }

  .lg\\:hover\\:rotate-2:hover{
    --transform-rotate: 2deg !important;
  }

  .lg\\:hover\\:rotate-3:hover{
    --transform-rotate: 3deg !important;
  }

  .lg\\:hover\\:rotate-6:hover{
    --transform-rotate: 6deg !important;
  }

  .lg\\:hover\\:rotate-12:hover{
    --transform-rotate: 12deg !important;
  }

  .lg\\:hover\\:rotate-45:hover{
    --transform-rotate: 45deg !important;
  }

  .lg\\:hover\\:rotate-90:hover{
    --transform-rotate: 90deg !important;
  }

  .lg\\:hover\\:rotate-180:hover{
    --transform-rotate: 180deg !important;
  }

  .lg\\:hover\\:-rotate-180:hover{
    --transform-rotate: -180deg !important;
  }

  .lg\\:hover\\:-rotate-90:hover{
    --transform-rotate: -90deg !important;
  }

  .lg\\:hover\\:-rotate-45:hover{
    --transform-rotate: -45deg !important;
  }

  .lg\\:hover\\:-rotate-12:hover{
    --transform-rotate: -12deg !important;
  }

  .lg\\:hover\\:-rotate-6:hover{
    --transform-rotate: -6deg !important;
  }

  .lg\\:hover\\:-rotate-3:hover{
    --transform-rotate: -3deg !important;
  }

  .lg\\:hover\\:-rotate-2:hover{
    --transform-rotate: -2deg !important;
  }

  .lg\\:hover\\:-rotate-1:hover{
    --transform-rotate: -1deg !important;
  }

  .lg\\:focus\\:rotate-0:focus{
    --transform-rotate: 0 !important;
  }

  .lg\\:focus\\:rotate-1:focus{
    --transform-rotate: 1deg !important;
  }

  .lg\\:focus\\:rotate-2:focus{
    --transform-rotate: 2deg !important;
  }

  .lg\\:focus\\:rotate-3:focus{
    --transform-rotate: 3deg !important;
  }

  .lg\\:focus\\:rotate-6:focus{
    --transform-rotate: 6deg !important;
  }

  .lg\\:focus\\:rotate-12:focus{
    --transform-rotate: 12deg !important;
  }

  .lg\\:focus\\:rotate-45:focus{
    --transform-rotate: 45deg !important;
  }

  .lg\\:focus\\:rotate-90:focus{
    --transform-rotate: 90deg !important;
  }

  .lg\\:focus\\:rotate-180:focus{
    --transform-rotate: 180deg !important;
  }

  .lg\\:focus\\:-rotate-180:focus{
    --transform-rotate: -180deg !important;
  }

  .lg\\:focus\\:-rotate-90:focus{
    --transform-rotate: -90deg !important;
  }

  .lg\\:focus\\:-rotate-45:focus{
    --transform-rotate: -45deg !important;
  }

  .lg\\:focus\\:-rotate-12:focus{
    --transform-rotate: -12deg !important;
  }

  .lg\\:focus\\:-rotate-6:focus{
    --transform-rotate: -6deg !important;
  }

  .lg\\:focus\\:-rotate-3:focus{
    --transform-rotate: -3deg !important;
  }

  .lg\\:focus\\:-rotate-2:focus{
    --transform-rotate: -2deg !important;
  }

  .lg\\:focus\\:-rotate-1:focus{
    --transform-rotate: -1deg !important;
  }

  .lg\\:translate-x-0{
    --transform-translate-x: 0 !important;
  }

  .lg\\:translate-x-1{
    --transform-translate-x: 0.25rem !important;
  }

  .lg\\:translate-x-2{
    --transform-translate-x: 0.5rem !important;
  }

  .lg\\:translate-x-3{
    --transform-translate-x: 0.75rem !important;
  }

  .lg\\:translate-x-4{
    --transform-translate-x: 1rem !important;
  }

  .lg\\:translate-x-5{
    --transform-translate-x: 1.25rem !important;
  }

  .lg\\:translate-x-6{
    --transform-translate-x: 1.5rem !important;
  }

  .lg\\:translate-x-8{
    --transform-translate-x: 2rem !important;
  }

  .lg\\:translate-x-10{
    --transform-translate-x: 2.5rem !important;
  }

  .lg\\:translate-x-12{
    --transform-translate-x: 3rem !important;
  }

  .lg\\:translate-x-16{
    --transform-translate-x: 4rem !important;
  }

  .lg\\:translate-x-20{
    --transform-translate-x: 5rem !important;
  }

  .lg\\:translate-x-24{
    --transform-translate-x: 6rem !important;
  }

  .lg\\:translate-x-32{
    --transform-translate-x: 8rem !important;
  }

  .lg\\:translate-x-40{
    --transform-translate-x: 10rem !important;
  }

  .lg\\:translate-x-48{
    --transform-translate-x: 12rem !important;
  }

  .lg\\:translate-x-56{
    --transform-translate-x: 14rem !important;
  }

  .lg\\:translate-x-64{
    --transform-translate-x: 16rem !important;
  }

  .lg\\:translate-x-px{
    --transform-translate-x: 1px !important;
  }

  .lg\\:-translate-x-1{
    --transform-translate-x: -0.25rem !important;
  }

  .lg\\:-translate-x-2{
    --transform-translate-x: -0.5rem !important;
  }

  .lg\\:-translate-x-3{
    --transform-translate-x: -0.75rem !important;
  }

  .lg\\:-translate-x-4{
    --transform-translate-x: -1rem !important;
  }

  .lg\\:-translate-x-5{
    --transform-translate-x: -1.25rem !important;
  }

  .lg\\:-translate-x-6{
    --transform-translate-x: -1.5rem !important;
  }

  .lg\\:-translate-x-8{
    --transform-translate-x: -2rem !important;
  }

  .lg\\:-translate-x-10{
    --transform-translate-x: -2.5rem !important;
  }

  .lg\\:-translate-x-12{
    --transform-translate-x: -3rem !important;
  }

  .lg\\:-translate-x-16{
    --transform-translate-x: -4rem !important;
  }

  .lg\\:-translate-x-20{
    --transform-translate-x: -5rem !important;
  }

  .lg\\:-translate-x-24{
    --transform-translate-x: -6rem !important;
  }

  .lg\\:-translate-x-32{
    --transform-translate-x: -8rem !important;
  }

  .lg\\:-translate-x-40{
    --transform-translate-x: -10rem !important;
  }

  .lg\\:-translate-x-48{
    --transform-translate-x: -12rem !important;
  }

  .lg\\:-translate-x-56{
    --transform-translate-x: -14rem !important;
  }

  .lg\\:-translate-x-64{
    --transform-translate-x: -16rem !important;
  }

  .lg\\:-translate-x-px{
    --transform-translate-x: -1px !important;
  }

  .lg\\:-translate-x-full{
    --transform-translate-x: -100% !important;
  }

  .lg\\:-translate-x-1\\/2{
    --transform-translate-x: -50% !important;
  }

  .lg\\:translate-x-1\\/2{
    --transform-translate-x: 50% !important;
  }

  .lg\\:translate-x-full{
    --transform-translate-x: 100% !important;
  }

  .lg\\:translate-y-0{
    --transform-translate-y: 0 !important;
  }

  .lg\\:translate-y-1{
    --transform-translate-y: 0.25rem !important;
  }

  .lg\\:translate-y-2{
    --transform-translate-y: 0.5rem !important;
  }

  .lg\\:translate-y-3{
    --transform-translate-y: 0.75rem !important;
  }

  .lg\\:translate-y-4{
    --transform-translate-y: 1rem !important;
  }

  .lg\\:translate-y-5{
    --transform-translate-y: 1.25rem !important;
  }

  .lg\\:translate-y-6{
    --transform-translate-y: 1.5rem !important;
  }

  .lg\\:translate-y-8{
    --transform-translate-y: 2rem !important;
  }

  .lg\\:translate-y-10{
    --transform-translate-y: 2.5rem !important;
  }

  .lg\\:translate-y-12{
    --transform-translate-y: 3rem !important;
  }

  .lg\\:translate-y-16{
    --transform-translate-y: 4rem !important;
  }

  .lg\\:translate-y-20{
    --transform-translate-y: 5rem !important;
  }

  .lg\\:translate-y-24{
    --transform-translate-y: 6rem !important;
  }

  .lg\\:translate-y-32{
    --transform-translate-y: 8rem !important;
  }

  .lg\\:translate-y-40{
    --transform-translate-y: 10rem !important;
  }

  .lg\\:translate-y-48{
    --transform-translate-y: 12rem !important;
  }

  .lg\\:translate-y-56{
    --transform-translate-y: 14rem !important;
  }

  .lg\\:translate-y-64{
    --transform-translate-y: 16rem !important;
  }

  .lg\\:translate-y-px{
    --transform-translate-y: 1px !important;
  }

  .lg\\:-translate-y-1{
    --transform-translate-y: -0.25rem !important;
  }

  .lg\\:-translate-y-2{
    --transform-translate-y: -0.5rem !important;
  }

  .lg\\:-translate-y-3{
    --transform-translate-y: -0.75rem !important;
  }

  .lg\\:-translate-y-4{
    --transform-translate-y: -1rem !important;
  }

  .lg\\:-translate-y-5{
    --transform-translate-y: -1.25rem !important;
  }

  .lg\\:-translate-y-6{
    --transform-translate-y: -1.5rem !important;
  }

  .lg\\:-translate-y-8{
    --transform-translate-y: -2rem !important;
  }

  .lg\\:-translate-y-10{
    --transform-translate-y: -2.5rem !important;
  }

  .lg\\:-translate-y-12{
    --transform-translate-y: -3rem !important;
  }

  .lg\\:-translate-y-16{
    --transform-translate-y: -4rem !important;
  }

  .lg\\:-translate-y-20{
    --transform-translate-y: -5rem !important;
  }

  .lg\\:-translate-y-24{
    --transform-translate-y: -6rem !important;
  }

  .lg\\:-translate-y-32{
    --transform-translate-y: -8rem !important;
  }

  .lg\\:-translate-y-40{
    --transform-translate-y: -10rem !important;
  }

  .lg\\:-translate-y-48{
    --transform-translate-y: -12rem !important;
  }

  .lg\\:-translate-y-56{
    --transform-translate-y: -14rem !important;
  }

  .lg\\:-translate-y-64{
    --transform-translate-y: -16rem !important;
  }

  .lg\\:-translate-y-px{
    --transform-translate-y: -1px !important;
  }

  .lg\\:-translate-y-full{
    --transform-translate-y: -100% !important;
  }

  .lg\\:-translate-y-1\\/2{
    --transform-translate-y: -50% !important;
  }

  .lg\\:translate-y-1\\/2{
    --transform-translate-y: 50% !important;
  }

  .lg\\:translate-y-full{
    --transform-translate-y: 100% !important;
  }

  .lg\\:hover\\:translate-x-0:hover{
    --transform-translate-x: 0 !important;
  }

  .lg\\:hover\\:translate-x-1:hover{
    --transform-translate-x: 0.25rem !important;
  }

  .lg\\:hover\\:translate-x-2:hover{
    --transform-translate-x: 0.5rem !important;
  }

  .lg\\:hover\\:translate-x-3:hover{
    --transform-translate-x: 0.75rem !important;
  }

  .lg\\:hover\\:translate-x-4:hover{
    --transform-translate-x: 1rem !important;
  }

  .lg\\:hover\\:translate-x-5:hover{
    --transform-translate-x: 1.25rem !important;
  }

  .lg\\:hover\\:translate-x-6:hover{
    --transform-translate-x: 1.5rem !important;
  }

  .lg\\:hover\\:translate-x-8:hover{
    --transform-translate-x: 2rem !important;
  }

  .lg\\:hover\\:translate-x-10:hover{
    --transform-translate-x: 2.5rem !important;
  }

  .lg\\:hover\\:translate-x-12:hover{
    --transform-translate-x: 3rem !important;
  }

  .lg\\:hover\\:translate-x-16:hover{
    --transform-translate-x: 4rem !important;
  }

  .lg\\:hover\\:translate-x-20:hover{
    --transform-translate-x: 5rem !important;
  }

  .lg\\:hover\\:translate-x-24:hover{
    --transform-translate-x: 6rem !important;
  }

  .lg\\:hover\\:translate-x-32:hover{
    --transform-translate-x: 8rem !important;
  }

  .lg\\:hover\\:translate-x-40:hover{
    --transform-translate-x: 10rem !important;
  }

  .lg\\:hover\\:translate-x-48:hover{
    --transform-translate-x: 12rem !important;
  }

  .lg\\:hover\\:translate-x-56:hover{
    --transform-translate-x: 14rem !important;
  }

  .lg\\:hover\\:translate-x-64:hover{
    --transform-translate-x: 16rem !important;
  }

  .lg\\:hover\\:translate-x-px:hover{
    --transform-translate-x: 1px !important;
  }

  .lg\\:hover\\:-translate-x-1:hover{
    --transform-translate-x: -0.25rem !important;
  }

  .lg\\:hover\\:-translate-x-2:hover{
    --transform-translate-x: -0.5rem !important;
  }

  .lg\\:hover\\:-translate-x-3:hover{
    --transform-translate-x: -0.75rem !important;
  }

  .lg\\:hover\\:-translate-x-4:hover{
    --transform-translate-x: -1rem !important;
  }

  .lg\\:hover\\:-translate-x-5:hover{
    --transform-translate-x: -1.25rem !important;
  }

  .lg\\:hover\\:-translate-x-6:hover{
    --transform-translate-x: -1.5rem !important;
  }

  .lg\\:hover\\:-translate-x-8:hover{
    --transform-translate-x: -2rem !important;
  }

  .lg\\:hover\\:-translate-x-10:hover{
    --transform-translate-x: -2.5rem !important;
  }

  .lg\\:hover\\:-translate-x-12:hover{
    --transform-translate-x: -3rem !important;
  }

  .lg\\:hover\\:-translate-x-16:hover{
    --transform-translate-x: -4rem !important;
  }

  .lg\\:hover\\:-translate-x-20:hover{
    --transform-translate-x: -5rem !important;
  }

  .lg\\:hover\\:-translate-x-24:hover{
    --transform-translate-x: -6rem !important;
  }

  .lg\\:hover\\:-translate-x-32:hover{
    --transform-translate-x: -8rem !important;
  }

  .lg\\:hover\\:-translate-x-40:hover{
    --transform-translate-x: -10rem !important;
  }

  .lg\\:hover\\:-translate-x-48:hover{
    --transform-translate-x: -12rem !important;
  }

  .lg\\:hover\\:-translate-x-56:hover{
    --transform-translate-x: -14rem !important;
  }

  .lg\\:hover\\:-translate-x-64:hover{
    --transform-translate-x: -16rem !important;
  }

  .lg\\:hover\\:-translate-x-px:hover{
    --transform-translate-x: -1px !important;
  }

  .lg\\:hover\\:-translate-x-full:hover{
    --transform-translate-x: -100% !important;
  }

  .lg\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x: -50% !important;
  }

  .lg\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x: 50% !important;
  }

  .lg\\:hover\\:translate-x-full:hover{
    --transform-translate-x: 100% !important;
  }

  .lg\\:hover\\:translate-y-0:hover{
    --transform-translate-y: 0 !important;
  }

  .lg\\:hover\\:translate-y-1:hover{
    --transform-translate-y: 0.25rem !important;
  }

  .lg\\:hover\\:translate-y-2:hover{
    --transform-translate-y: 0.5rem !important;
  }

  .lg\\:hover\\:translate-y-3:hover{
    --transform-translate-y: 0.75rem !important;
  }

  .lg\\:hover\\:translate-y-4:hover{
    --transform-translate-y: 1rem !important;
  }

  .lg\\:hover\\:translate-y-5:hover{
    --transform-translate-y: 1.25rem !important;
  }

  .lg\\:hover\\:translate-y-6:hover{
    --transform-translate-y: 1.5rem !important;
  }

  .lg\\:hover\\:translate-y-8:hover{
    --transform-translate-y: 2rem !important;
  }

  .lg\\:hover\\:translate-y-10:hover{
    --transform-translate-y: 2.5rem !important;
  }

  .lg\\:hover\\:translate-y-12:hover{
    --transform-translate-y: 3rem !important;
  }

  .lg\\:hover\\:translate-y-16:hover{
    --transform-translate-y: 4rem !important;
  }

  .lg\\:hover\\:translate-y-20:hover{
    --transform-translate-y: 5rem !important;
  }

  .lg\\:hover\\:translate-y-24:hover{
    --transform-translate-y: 6rem !important;
  }

  .lg\\:hover\\:translate-y-32:hover{
    --transform-translate-y: 8rem !important;
  }

  .lg\\:hover\\:translate-y-40:hover{
    --transform-translate-y: 10rem !important;
  }

  .lg\\:hover\\:translate-y-48:hover{
    --transform-translate-y: 12rem !important;
  }

  .lg\\:hover\\:translate-y-56:hover{
    --transform-translate-y: 14rem !important;
  }

  .lg\\:hover\\:translate-y-64:hover{
    --transform-translate-y: 16rem !important;
  }

  .lg\\:hover\\:translate-y-px:hover{
    --transform-translate-y: 1px !important;
  }

  .lg\\:hover\\:-translate-y-1:hover{
    --transform-translate-y: -0.25rem !important;
  }

  .lg\\:hover\\:-translate-y-2:hover{
    --transform-translate-y: -0.5rem !important;
  }

  .lg\\:hover\\:-translate-y-3:hover{
    --transform-translate-y: -0.75rem !important;
  }

  .lg\\:hover\\:-translate-y-4:hover{
    --transform-translate-y: -1rem !important;
  }

  .lg\\:hover\\:-translate-y-5:hover{
    --transform-translate-y: -1.25rem !important;
  }

  .lg\\:hover\\:-translate-y-6:hover{
    --transform-translate-y: -1.5rem !important;
  }

  .lg\\:hover\\:-translate-y-8:hover{
    --transform-translate-y: -2rem !important;
  }

  .lg\\:hover\\:-translate-y-10:hover{
    --transform-translate-y: -2.5rem !important;
  }

  .lg\\:hover\\:-translate-y-12:hover{
    --transform-translate-y: -3rem !important;
  }

  .lg\\:hover\\:-translate-y-16:hover{
    --transform-translate-y: -4rem !important;
  }

  .lg\\:hover\\:-translate-y-20:hover{
    --transform-translate-y: -5rem !important;
  }

  .lg\\:hover\\:-translate-y-24:hover{
    --transform-translate-y: -6rem !important;
  }

  .lg\\:hover\\:-translate-y-32:hover{
    --transform-translate-y: -8rem !important;
  }

  .lg\\:hover\\:-translate-y-40:hover{
    --transform-translate-y: -10rem !important;
  }

  .lg\\:hover\\:-translate-y-48:hover{
    --transform-translate-y: -12rem !important;
  }

  .lg\\:hover\\:-translate-y-56:hover{
    --transform-translate-y: -14rem !important;
  }

  .lg\\:hover\\:-translate-y-64:hover{
    --transform-translate-y: -16rem !important;
  }

  .lg\\:hover\\:-translate-y-px:hover{
    --transform-translate-y: -1px !important;
  }

  .lg\\:hover\\:-translate-y-full:hover{
    --transform-translate-y: -100% !important;
  }

  .lg\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y: -50% !important;
  }

  .lg\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y: 50% !important;
  }

  .lg\\:hover\\:translate-y-full:hover{
    --transform-translate-y: 100% !important;
  }

  .lg\\:focus\\:translate-x-0:focus{
    --transform-translate-x: 0 !important;
  }

  .lg\\:focus\\:translate-x-1:focus{
    --transform-translate-x: 0.25rem !important;
  }

  .lg\\:focus\\:translate-x-2:focus{
    --transform-translate-x: 0.5rem !important;
  }

  .lg\\:focus\\:translate-x-3:focus{
    --transform-translate-x: 0.75rem !important;
  }

  .lg\\:focus\\:translate-x-4:focus{
    --transform-translate-x: 1rem !important;
  }

  .lg\\:focus\\:translate-x-5:focus{
    --transform-translate-x: 1.25rem !important;
  }

  .lg\\:focus\\:translate-x-6:focus{
    --transform-translate-x: 1.5rem !important;
  }

  .lg\\:focus\\:translate-x-8:focus{
    --transform-translate-x: 2rem !important;
  }

  .lg\\:focus\\:translate-x-10:focus{
    --transform-translate-x: 2.5rem !important;
  }

  .lg\\:focus\\:translate-x-12:focus{
    --transform-translate-x: 3rem !important;
  }

  .lg\\:focus\\:translate-x-16:focus{
    --transform-translate-x: 4rem !important;
  }

  .lg\\:focus\\:translate-x-20:focus{
    --transform-translate-x: 5rem !important;
  }

  .lg\\:focus\\:translate-x-24:focus{
    --transform-translate-x: 6rem !important;
  }

  .lg\\:focus\\:translate-x-32:focus{
    --transform-translate-x: 8rem !important;
  }

  .lg\\:focus\\:translate-x-40:focus{
    --transform-translate-x: 10rem !important;
  }

  .lg\\:focus\\:translate-x-48:focus{
    --transform-translate-x: 12rem !important;
  }

  .lg\\:focus\\:translate-x-56:focus{
    --transform-translate-x: 14rem !important;
  }

  .lg\\:focus\\:translate-x-64:focus{
    --transform-translate-x: 16rem !important;
  }

  .lg\\:focus\\:translate-x-px:focus{
    --transform-translate-x: 1px !important;
  }

  .lg\\:focus\\:-translate-x-1:focus{
    --transform-translate-x: -0.25rem !important;
  }

  .lg\\:focus\\:-translate-x-2:focus{
    --transform-translate-x: -0.5rem !important;
  }

  .lg\\:focus\\:-translate-x-3:focus{
    --transform-translate-x: -0.75rem !important;
  }

  .lg\\:focus\\:-translate-x-4:focus{
    --transform-translate-x: -1rem !important;
  }

  .lg\\:focus\\:-translate-x-5:focus{
    --transform-translate-x: -1.25rem !important;
  }

  .lg\\:focus\\:-translate-x-6:focus{
    --transform-translate-x: -1.5rem !important;
  }

  .lg\\:focus\\:-translate-x-8:focus{
    --transform-translate-x: -2rem !important;
  }

  .lg\\:focus\\:-translate-x-10:focus{
    --transform-translate-x: -2.5rem !important;
  }

  .lg\\:focus\\:-translate-x-12:focus{
    --transform-translate-x: -3rem !important;
  }

  .lg\\:focus\\:-translate-x-16:focus{
    --transform-translate-x: -4rem !important;
  }

  .lg\\:focus\\:-translate-x-20:focus{
    --transform-translate-x: -5rem !important;
  }

  .lg\\:focus\\:-translate-x-24:focus{
    --transform-translate-x: -6rem !important;
  }

  .lg\\:focus\\:-translate-x-32:focus{
    --transform-translate-x: -8rem !important;
  }

  .lg\\:focus\\:-translate-x-40:focus{
    --transform-translate-x: -10rem !important;
  }

  .lg\\:focus\\:-translate-x-48:focus{
    --transform-translate-x: -12rem !important;
  }

  .lg\\:focus\\:-translate-x-56:focus{
    --transform-translate-x: -14rem !important;
  }

  .lg\\:focus\\:-translate-x-64:focus{
    --transform-translate-x: -16rem !important;
  }

  .lg\\:focus\\:-translate-x-px:focus{
    --transform-translate-x: -1px !important;
  }

  .lg\\:focus\\:-translate-x-full:focus{
    --transform-translate-x: -100% !important;
  }

  .lg\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x: -50% !important;
  }

  .lg\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x: 50% !important;
  }

  .lg\\:focus\\:translate-x-full:focus{
    --transform-translate-x: 100% !important;
  }

  .lg\\:focus\\:translate-y-0:focus{
    --transform-translate-y: 0 !important;
  }

  .lg\\:focus\\:translate-y-1:focus{
    --transform-translate-y: 0.25rem !important;
  }

  .lg\\:focus\\:translate-y-2:focus{
    --transform-translate-y: 0.5rem !important;
  }

  .lg\\:focus\\:translate-y-3:focus{
    --transform-translate-y: 0.75rem !important;
  }

  .lg\\:focus\\:translate-y-4:focus{
    --transform-translate-y: 1rem !important;
  }

  .lg\\:focus\\:translate-y-5:focus{
    --transform-translate-y: 1.25rem !important;
  }

  .lg\\:focus\\:translate-y-6:focus{
    --transform-translate-y: 1.5rem !important;
  }

  .lg\\:focus\\:translate-y-8:focus{
    --transform-translate-y: 2rem !important;
  }

  .lg\\:focus\\:translate-y-10:focus{
    --transform-translate-y: 2.5rem !important;
  }

  .lg\\:focus\\:translate-y-12:focus{
    --transform-translate-y: 3rem !important;
  }

  .lg\\:focus\\:translate-y-16:focus{
    --transform-translate-y: 4rem !important;
  }

  .lg\\:focus\\:translate-y-20:focus{
    --transform-translate-y: 5rem !important;
  }

  .lg\\:focus\\:translate-y-24:focus{
    --transform-translate-y: 6rem !important;
  }

  .lg\\:focus\\:translate-y-32:focus{
    --transform-translate-y: 8rem !important;
  }

  .lg\\:focus\\:translate-y-40:focus{
    --transform-translate-y: 10rem !important;
  }

  .lg\\:focus\\:translate-y-48:focus{
    --transform-translate-y: 12rem !important;
  }

  .lg\\:focus\\:translate-y-56:focus{
    --transform-translate-y: 14rem !important;
  }

  .lg\\:focus\\:translate-y-64:focus{
    --transform-translate-y: 16rem !important;
  }

  .lg\\:focus\\:translate-y-px:focus{
    --transform-translate-y: 1px !important;
  }

  .lg\\:focus\\:-translate-y-1:focus{
    --transform-translate-y: -0.25rem !important;
  }

  .lg\\:focus\\:-translate-y-2:focus{
    --transform-translate-y: -0.5rem !important;
  }

  .lg\\:focus\\:-translate-y-3:focus{
    --transform-translate-y: -0.75rem !important;
  }

  .lg\\:focus\\:-translate-y-4:focus{
    --transform-translate-y: -1rem !important;
  }

  .lg\\:focus\\:-translate-y-5:focus{
    --transform-translate-y: -1.25rem !important;
  }

  .lg\\:focus\\:-translate-y-6:focus{
    --transform-translate-y: -1.5rem !important;
  }

  .lg\\:focus\\:-translate-y-8:focus{
    --transform-translate-y: -2rem !important;
  }

  .lg\\:focus\\:-translate-y-10:focus{
    --transform-translate-y: -2.5rem !important;
  }

  .lg\\:focus\\:-translate-y-12:focus{
    --transform-translate-y: -3rem !important;
  }

  .lg\\:focus\\:-translate-y-16:focus{
    --transform-translate-y: -4rem !important;
  }

  .lg\\:focus\\:-translate-y-20:focus{
    --transform-translate-y: -5rem !important;
  }

  .lg\\:focus\\:-translate-y-24:focus{
    --transform-translate-y: -6rem !important;
  }

  .lg\\:focus\\:-translate-y-32:focus{
    --transform-translate-y: -8rem !important;
  }

  .lg\\:focus\\:-translate-y-40:focus{
    --transform-translate-y: -10rem !important;
  }

  .lg\\:focus\\:-translate-y-48:focus{
    --transform-translate-y: -12rem !important;
  }

  .lg\\:focus\\:-translate-y-56:focus{
    --transform-translate-y: -14rem !important;
  }

  .lg\\:focus\\:-translate-y-64:focus{
    --transform-translate-y: -16rem !important;
  }

  .lg\\:focus\\:-translate-y-px:focus{
    --transform-translate-y: -1px !important;
  }

  .lg\\:focus\\:-translate-y-full:focus{
    --transform-translate-y: -100% !important;
  }

  .lg\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y: -50% !important;
  }

  .lg\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y: 50% !important;
  }

  .lg\\:focus\\:translate-y-full:focus{
    --transform-translate-y: 100% !important;
  }

  .lg\\:skew-x-0{
    --transform-skew-x: 0 !important;
  }

  .lg\\:skew-x-1{
    --transform-skew-x: 1deg !important;
  }

  .lg\\:skew-x-2{
    --transform-skew-x: 2deg !important;
  }

  .lg\\:skew-x-3{
    --transform-skew-x: 3deg !important;
  }

  .lg\\:skew-x-6{
    --transform-skew-x: 6deg !important;
  }

  .lg\\:skew-x-12{
    --transform-skew-x: 12deg !important;
  }

  .lg\\:-skew-x-12{
    --transform-skew-x: -12deg !important;
  }

  .lg\\:-skew-x-6{
    --transform-skew-x: -6deg !important;
  }

  .lg\\:-skew-x-3{
    --transform-skew-x: -3deg !important;
  }

  .lg\\:-skew-x-2{
    --transform-skew-x: -2deg !important;
  }

  .lg\\:-skew-x-1{
    --transform-skew-x: -1deg !important;
  }

  .lg\\:skew-y-0{
    --transform-skew-y: 0 !important;
  }

  .lg\\:skew-y-1{
    --transform-skew-y: 1deg !important;
  }

  .lg\\:skew-y-2{
    --transform-skew-y: 2deg !important;
  }

  .lg\\:skew-y-3{
    --transform-skew-y: 3deg !important;
  }

  .lg\\:skew-y-6{
    --transform-skew-y: 6deg !important;
  }

  .lg\\:skew-y-12{
    --transform-skew-y: 12deg !important;
  }

  .lg\\:-skew-y-12{
    --transform-skew-y: -12deg !important;
  }

  .lg\\:-skew-y-6{
    --transform-skew-y: -6deg !important;
  }

  .lg\\:-skew-y-3{
    --transform-skew-y: -3deg !important;
  }

  .lg\\:-skew-y-2{
    --transform-skew-y: -2deg !important;
  }

  .lg\\:-skew-y-1{
    --transform-skew-y: -1deg !important;
  }

  .lg\\:hover\\:skew-x-0:hover{
    --transform-skew-x: 0 !important;
  }

  .lg\\:hover\\:skew-x-1:hover{
    --transform-skew-x: 1deg !important;
  }

  .lg\\:hover\\:skew-x-2:hover{
    --transform-skew-x: 2deg !important;
  }

  .lg\\:hover\\:skew-x-3:hover{
    --transform-skew-x: 3deg !important;
  }

  .lg\\:hover\\:skew-x-6:hover{
    --transform-skew-x: 6deg !important;
  }

  .lg\\:hover\\:skew-x-12:hover{
    --transform-skew-x: 12deg !important;
  }

  .lg\\:hover\\:-skew-x-12:hover{
    --transform-skew-x: -12deg !important;
  }

  .lg\\:hover\\:-skew-x-6:hover{
    --transform-skew-x: -6deg !important;
  }

  .lg\\:hover\\:-skew-x-3:hover{
    --transform-skew-x: -3deg !important;
  }

  .lg\\:hover\\:-skew-x-2:hover{
    --transform-skew-x: -2deg !important;
  }

  .lg\\:hover\\:-skew-x-1:hover{
    --transform-skew-x: -1deg !important;
  }

  .lg\\:hover\\:skew-y-0:hover{
    --transform-skew-y: 0 !important;
  }

  .lg\\:hover\\:skew-y-1:hover{
    --transform-skew-y: 1deg !important;
  }

  .lg\\:hover\\:skew-y-2:hover{
    --transform-skew-y: 2deg !important;
  }

  .lg\\:hover\\:skew-y-3:hover{
    --transform-skew-y: 3deg !important;
  }

  .lg\\:hover\\:skew-y-6:hover{
    --transform-skew-y: 6deg !important;
  }

  .lg\\:hover\\:skew-y-12:hover{
    --transform-skew-y: 12deg !important;
  }

  .lg\\:hover\\:-skew-y-12:hover{
    --transform-skew-y: -12deg !important;
  }

  .lg\\:hover\\:-skew-y-6:hover{
    --transform-skew-y: -6deg !important;
  }

  .lg\\:hover\\:-skew-y-3:hover{
    --transform-skew-y: -3deg !important;
  }

  .lg\\:hover\\:-skew-y-2:hover{
    --transform-skew-y: -2deg !important;
  }

  .lg\\:hover\\:-skew-y-1:hover{
    --transform-skew-y: -1deg !important;
  }

  .lg\\:focus\\:skew-x-0:focus{
    --transform-skew-x: 0 !important;
  }

  .lg\\:focus\\:skew-x-1:focus{
    --transform-skew-x: 1deg !important;
  }

  .lg\\:focus\\:skew-x-2:focus{
    --transform-skew-x: 2deg !important;
  }

  .lg\\:focus\\:skew-x-3:focus{
    --transform-skew-x: 3deg !important;
  }

  .lg\\:focus\\:skew-x-6:focus{
    --transform-skew-x: 6deg !important;
  }

  .lg\\:focus\\:skew-x-12:focus{
    --transform-skew-x: 12deg !important;
  }

  .lg\\:focus\\:-skew-x-12:focus{
    --transform-skew-x: -12deg !important;
  }

  .lg\\:focus\\:-skew-x-6:focus{
    --transform-skew-x: -6deg !important;
  }

  .lg\\:focus\\:-skew-x-3:focus{
    --transform-skew-x: -3deg !important;
  }

  .lg\\:focus\\:-skew-x-2:focus{
    --transform-skew-x: -2deg !important;
  }

  .lg\\:focus\\:-skew-x-1:focus{
    --transform-skew-x: -1deg !important;
  }

  .lg\\:focus\\:skew-y-0:focus{
    --transform-skew-y: 0 !important;
  }

  .lg\\:focus\\:skew-y-1:focus{
    --transform-skew-y: 1deg !important;
  }

  .lg\\:focus\\:skew-y-2:focus{
    --transform-skew-y: 2deg !important;
  }

  .lg\\:focus\\:skew-y-3:focus{
    --transform-skew-y: 3deg !important;
  }

  .lg\\:focus\\:skew-y-6:focus{
    --transform-skew-y: 6deg !important;
  }

  .lg\\:focus\\:skew-y-12:focus{
    --transform-skew-y: 12deg !important;
  }

  .lg\\:focus\\:-skew-y-12:focus{
    --transform-skew-y: -12deg !important;
  }

  .lg\\:focus\\:-skew-y-6:focus{
    --transform-skew-y: -6deg !important;
  }

  .lg\\:focus\\:-skew-y-3:focus{
    --transform-skew-y: -3deg !important;
  }

  .lg\\:focus\\:-skew-y-2:focus{
    --transform-skew-y: -2deg !important;
  }

  .lg\\:focus\\:-skew-y-1:focus{
    --transform-skew-y: -1deg !important;
  }

  [dir] .lg\\:transition-none{
    transition-property: none !important;
  }

  [dir] .lg\\:transition-all{
    transition-property: all !important;
  }

  [dir] .lg\\:transition{
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform !important;
  }

  [dir] .lg\\:transition-colors{
    transition-property: background-color, border-color, color, fill, stroke !important;
  }

  [dir] .lg\\:transition-opacity{
    transition-property: opacity !important;
  }

  [dir] .lg\\:transition-shadow{
    transition-property: box-shadow !important;
  }

  [dir] .lg\\:transition-transform{
    transition-property: transform !important;
  }

  [dir] .lg\\:ease-linear{
    transition-timing-function: linear !important;
  }

  [dir] .lg\\:ease-in{
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1) !important;
  }

  [dir] .lg\\:ease-out{
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
  }

  [dir] .lg\\:ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }

  [dir] .lg\\:duration-75{
    transition-duration: 75ms !important;
  }

  [dir] .lg\\:duration-100{
    transition-duration: 100ms !important;
  }

  [dir] .lg\\:duration-150{
    transition-duration: 150ms !important;
  }

  [dir] .lg\\:duration-200{
    transition-duration: 200ms !important;
  }

  [dir] .lg\\:duration-300{
    transition-duration: 300ms !important;
  }

  [dir] .lg\\:duration-500{
    transition-duration: 500ms !important;
  }

  [dir] .lg\\:duration-700{
    transition-duration: 700ms !important;
  }

  [dir] .lg\\:duration-1000{
    transition-duration: 1000ms !important;
  }

  [dir] .lg\\:delay-75{
    transition-delay: 75ms !important;
  }

  [dir] .lg\\:delay-100{
    transition-delay: 100ms !important;
  }

  [dir] .lg\\:delay-150{
    transition-delay: 150ms !important;
  }

  [dir] .lg\\:delay-200{
    transition-delay: 200ms !important;
  }

  [dir] .lg\\:delay-300{
    transition-delay: 300ms !important;
  }

  [dir] .lg\\:delay-500{
    transition-delay: 500ms !important;
  }

  [dir] .lg\\:delay-700{
    transition-delay: 700ms !important;
  }

  [dir] .lg\\:delay-1000{
    transition-delay: 1000ms !important;
  }

  [dir=ltr] .lg\\:animate-none{
    animation: none !important;
  }

  [dir=rtl] .lg\\:animate-none{
    animation: none !important;
  }

  [dir=ltr] .lg\\:animate-spin{
    animation:  spin-ltr 1s linear infinite !important;
  }

  [dir=rtl] .lg\\:animate-spin{
    animation:  spin-rtl 1s linear infinite !important;
  }

  [dir=ltr] .lg\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite !important;
  }

  [dir=rtl] .lg\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite !important;
  }

  [dir=ltr] .lg\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
  }

  [dir=rtl] .lg\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
  }

  [dir=ltr] .lg\\:animate-bounce{
    animation: bounce 1s infinite !important;
  }

  [dir=rtl] .lg\\:animate-bounce{
    animation: bounce 1s infinite !important;
  }
}

@media (min-width: 1200px){
  .xl\\:container{
    width: 100%;
  }
  [dir=ltr] .xl\\:container{
    margin-right: auto;
    margin-left: auto;
    padding-right: 1rem;
    padding-left: 1rem;
  }
  [dir=rtl] .xl\\:container{
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media (min-width: 576px){
    .xl\\:container{
      max-width: 576px;
    }
  }

  @media (min-width: 768px){
    .xl\\:container{
      max-width: 768px;
    }
  }

  @media (min-width: 992px){
    .xl\\:container{
      max-width: 992px;
    }
  }

  @media (min-width: 1200px){
    .xl\\:container{
      max-width: 1200px;
    }
  }

  .xl\\:space-y-0 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-0 > :not(template) ~ :not(template){
    margin-top: calc(0px * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0px * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-0 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-0 > :not(template) ~ :not(template){
    margin-right: calc(0px * var(--space-x-reverse)) !important;
    margin-left: calc(0px * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-0 > :not(template) ~ :not(template){
    margin-left: calc(0px * var(--space-x-reverse)) !important;
    margin-right: calc(0px * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-1 > :not(template) ~ :not(template){
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0.25rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-1 > :not(template) ~ :not(template){
    margin-right: calc(0.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-1 > :not(template) ~ :not(template){
    margin-left: calc(0.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-2 > :not(template) ~ :not(template){
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0.5rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-2 > :not(template) ~ :not(template){
    margin-right: calc(0.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-2 > :not(template) ~ :not(template){
    margin-left: calc(0.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-3 > :not(template) ~ :not(template){
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(0.75rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-3 > :not(template) ~ :not(template){
    margin-right: calc(0.75rem * var(--space-x-reverse)) !important;
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-3 > :not(template) ~ :not(template){
    margin-left: calc(0.75rem * var(--space-x-reverse)) !important;
    margin-right: calc(0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-4 > :not(template) ~ :not(template){
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-4 > :not(template) ~ :not(template){
    margin-right: calc(1rem * var(--space-x-reverse)) !important;
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-4 > :not(template) ~ :not(template){
    margin-left: calc(1rem * var(--space-x-reverse)) !important;
    margin-right: calc(1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-5 > :not(template) ~ :not(template){
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1.25rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-5 > :not(template) ~ :not(template){
    margin-right: calc(1.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-5 > :not(template) ~ :not(template){
    margin-left: calc(1.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-6 > :not(template) ~ :not(template){
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1.5rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-6 > :not(template) ~ :not(template){
    margin-right: calc(1.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-6 > :not(template) ~ :not(template){
    margin-left: calc(1.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-8 > :not(template) ~ :not(template){
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(2rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-8 > :not(template) ~ :not(template){
    margin-right: calc(2rem * var(--space-x-reverse)) !important;
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-8 > :not(template) ~ :not(template){
    margin-left: calc(2rem * var(--space-x-reverse)) !important;
    margin-right: calc(2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-10 > :not(template) ~ :not(template){
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(2.5rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-10 > :not(template) ~ :not(template){
    margin-right: calc(2.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-10 > :not(template) ~ :not(template){
    margin-left: calc(2.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-12 > :not(template) ~ :not(template){
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(3rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-12 > :not(template) ~ :not(template){
    margin-right: calc(3rem * var(--space-x-reverse)) !important;
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-12 > :not(template) ~ :not(template){
    margin-left: calc(3rem * var(--space-x-reverse)) !important;
    margin-right: calc(3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-16 > :not(template) ~ :not(template){
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(4rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-16 > :not(template) ~ :not(template){
    margin-right: calc(4rem * var(--space-x-reverse)) !important;
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-16 > :not(template) ~ :not(template){
    margin-left: calc(4rem * var(--space-x-reverse)) !important;
    margin-right: calc(4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-20 > :not(template) ~ :not(template){
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(5rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-20 > :not(template) ~ :not(template){
    margin-right: calc(5rem * var(--space-x-reverse)) !important;
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-20 > :not(template) ~ :not(template){
    margin-left: calc(5rem * var(--space-x-reverse)) !important;
    margin-right: calc(5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-24 > :not(template) ~ :not(template){
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(6rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-24 > :not(template) ~ :not(template){
    margin-right: calc(6rem * var(--space-x-reverse)) !important;
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-24 > :not(template) ~ :not(template){
    margin-left: calc(6rem * var(--space-x-reverse)) !important;
    margin-right: calc(6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-32 > :not(template) ~ :not(template){
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(8rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-32 > :not(template) ~ :not(template){
    margin-right: calc(8rem * var(--space-x-reverse)) !important;
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-32 > :not(template) ~ :not(template){
    margin-left: calc(8rem * var(--space-x-reverse)) !important;
    margin-right: calc(8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-40 > :not(template) ~ :not(template){
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(10rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-40 > :not(template) ~ :not(template){
    margin-right: calc(10rem * var(--space-x-reverse)) !important;
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-40 > :not(template) ~ :not(template){
    margin-left: calc(10rem * var(--space-x-reverse)) !important;
    margin-right: calc(10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-48 > :not(template) ~ :not(template){
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(12rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-48 > :not(template) ~ :not(template){
    margin-right: calc(12rem * var(--space-x-reverse)) !important;
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-48 > :not(template) ~ :not(template){
    margin-left: calc(12rem * var(--space-x-reverse)) !important;
    margin-right: calc(12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-56 > :not(template) ~ :not(template){
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(14rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-56 > :not(template) ~ :not(template){
    margin-right: calc(14rem * var(--space-x-reverse)) !important;
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-56 > :not(template) ~ :not(template){
    margin-left: calc(14rem * var(--space-x-reverse)) !important;
    margin-right: calc(14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-64 > :not(template) ~ :not(template){
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(16rem * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-64 > :not(template) ~ :not(template){
    margin-right: calc(16rem * var(--space-x-reverse)) !important;
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-64 > :not(template) ~ :not(template){
    margin-left: calc(16rem * var(--space-x-reverse)) !important;
    margin-right: calc(16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:space-y-px > :not(template) ~ :not(template){
    margin-top: calc(1px * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(1px * var(--space-y-reverse)) !important;
  }

  .xl\\:space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:space-x-px > :not(template) ~ :not(template){
    margin-right: calc(1px * var(--space-x-reverse)) !important;
    margin-left: calc(1px * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:space-x-px > :not(template) ~ :not(template){
    margin-left: calc(1px * var(--space-x-reverse)) !important;
    margin-right: calc(1px * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-1 > :not(template) ~ :not(template){
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-0.25rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-1 > :not(template) ~ :not(template){
    margin-right: calc(-0.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-1 > :not(template) ~ :not(template){
    margin-left: calc(-0.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(-0.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-2 > :not(template) ~ :not(template){
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-0.5rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-2 > :not(template) ~ :not(template){
    margin-right: calc(-0.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-2 > :not(template) ~ :not(template){
    margin-left: calc(-0.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-0.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-3 > :not(template) ~ :not(template){
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-0.75rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-3 > :not(template) ~ :not(template){
    margin-right: calc(-0.75rem * var(--space-x-reverse)) !important;
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-3 > :not(template) ~ :not(template){
    margin-left: calc(-0.75rem * var(--space-x-reverse)) !important;
    margin-right: calc(-0.75rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-4 > :not(template) ~ :not(template){
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-4 > :not(template) ~ :not(template){
    margin-right: calc(-1rem * var(--space-x-reverse)) !important;
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-4 > :not(template) ~ :not(template){
    margin-left: calc(-1rem * var(--space-x-reverse)) !important;
    margin-right: calc(-1rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-5 > :not(template) ~ :not(template){
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1.25rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-5 > :not(template) ~ :not(template){
    margin-right: calc(-1.25rem * var(--space-x-reverse)) !important;
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-5 > :not(template) ~ :not(template){
    margin-left: calc(-1.25rem * var(--space-x-reverse)) !important;
    margin-right: calc(-1.25rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-6 > :not(template) ~ :not(template){
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1.5rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-6 > :not(template) ~ :not(template){
    margin-right: calc(-1.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-6 > :not(template) ~ :not(template){
    margin-left: calc(-1.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-1.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-8 > :not(template) ~ :not(template){
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-2rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-8 > :not(template) ~ :not(template){
    margin-right: calc(-2rem * var(--space-x-reverse)) !important;
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-8 > :not(template) ~ :not(template){
    margin-left: calc(-2rem * var(--space-x-reverse)) !important;
    margin-right: calc(-2rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-10 > :not(template) ~ :not(template){
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-2.5rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-10 > :not(template) ~ :not(template){
    margin-right: calc(-2.5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-10 > :not(template) ~ :not(template){
    margin-left: calc(-2.5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-2.5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-12 > :not(template) ~ :not(template){
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-3rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-12 > :not(template) ~ :not(template){
    margin-right: calc(-3rem * var(--space-x-reverse)) !important;
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-12 > :not(template) ~ :not(template){
    margin-left: calc(-3rem * var(--space-x-reverse)) !important;
    margin-right: calc(-3rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-16 > :not(template) ~ :not(template){
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-4rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-16 > :not(template) ~ :not(template){
    margin-right: calc(-4rem * var(--space-x-reverse)) !important;
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-16 > :not(template) ~ :not(template){
    margin-left: calc(-4rem * var(--space-x-reverse)) !important;
    margin-right: calc(-4rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-20 > :not(template) ~ :not(template){
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-5rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-20 > :not(template) ~ :not(template){
    margin-right: calc(-5rem * var(--space-x-reverse)) !important;
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-20 > :not(template) ~ :not(template){
    margin-left: calc(-5rem * var(--space-x-reverse)) !important;
    margin-right: calc(-5rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-24 > :not(template) ~ :not(template){
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-6rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-24 > :not(template) ~ :not(template){
    margin-right: calc(-6rem * var(--space-x-reverse)) !important;
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-24 > :not(template) ~ :not(template){
    margin-left: calc(-6rem * var(--space-x-reverse)) !important;
    margin-right: calc(-6rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-32 > :not(template) ~ :not(template){
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-8rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-32 > :not(template) ~ :not(template){
    margin-right: calc(-8rem * var(--space-x-reverse)) !important;
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-32 > :not(template) ~ :not(template){
    margin-left: calc(-8rem * var(--space-x-reverse)) !important;
    margin-right: calc(-8rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-40 > :not(template) ~ :not(template){
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-10rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-40 > :not(template) ~ :not(template){
    margin-right: calc(-10rem * var(--space-x-reverse)) !important;
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-40 > :not(template) ~ :not(template){
    margin-left: calc(-10rem * var(--space-x-reverse)) !important;
    margin-right: calc(-10rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-48 > :not(template) ~ :not(template){
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-12rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-48 > :not(template) ~ :not(template){
    margin-right: calc(-12rem * var(--space-x-reverse)) !important;
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-48 > :not(template) ~ :not(template){
    margin-left: calc(-12rem * var(--space-x-reverse)) !important;
    margin-right: calc(-12rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-56 > :not(template) ~ :not(template){
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-14rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-56 > :not(template) ~ :not(template){
    margin-right: calc(-14rem * var(--space-x-reverse)) !important;
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-56 > :not(template) ~ :not(template){
    margin-left: calc(-14rem * var(--space-x-reverse)) !important;
    margin-right: calc(-14rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-64 > :not(template) ~ :not(template){
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-16rem * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-64 > :not(template) ~ :not(template){
    margin-right: calc(-16rem * var(--space-x-reverse)) !important;
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-64 > :not(template) ~ :not(template){
    margin-left: calc(-16rem * var(--space-x-reverse)) !important;
    margin-right: calc(-16rem * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:-space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0 !important;
  }

  [dir] .xl\\:-space-y-px > :not(template) ~ :not(template){
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse))) !important;
    margin-bottom: calc(-1px * var(--space-y-reverse)) !important;
  }

  .xl\\:-space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:-space-x-px > :not(template) ~ :not(template){
    margin-right: calc(-1px * var(--space-x-reverse)) !important;
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:-space-x-px > :not(template) ~ :not(template){
    margin-left: calc(-1px * var(--space-x-reverse)) !important;
    margin-right: calc(-1px * calc(1 - var(--space-x-reverse))) !important;
  }

  .xl\\:space-y-reverse > :not(template) ~ :not(template){
    --space-y-reverse: 1 !important;
  }

  .xl\\:space-x-reverse > :not(template) ~ :not(template){
    --space-x-reverse: 1 !important;
  }

  .xl\\:divide-y-0 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .xl\\:divide-y-0 > :not(template) ~ :not(template){
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(0px * var(--divide-y-reverse)) !important;
  }

  .xl\\:divide-x-0 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:divide-x-0 > :not(template) ~ :not(template){
    border-right-width: calc(0px * var(--divide-x-reverse)) !important;
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:divide-x-0 > :not(template) ~ :not(template){
    border-left-width: calc(0px * var(--divide-x-reverse)) !important;
    border-right-width: calc(0px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .xl\\:divide-y-2 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .xl\\:divide-y-2 > :not(template) ~ :not(template){
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(2px * var(--divide-y-reverse)) !important;
  }

  .xl\\:divide-x-2 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:divide-x-2 > :not(template) ~ :not(template){
    border-right-width: calc(2px * var(--divide-x-reverse)) !important;
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:divide-x-2 > :not(template) ~ :not(template){
    border-left-width: calc(2px * var(--divide-x-reverse)) !important;
    border-right-width: calc(2px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .xl\\:divide-y-4 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .xl\\:divide-y-4 > :not(template) ~ :not(template){
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(4px * var(--divide-y-reverse)) !important;
  }

  .xl\\:divide-x-4 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:divide-x-4 > :not(template) ~ :not(template){
    border-right-width: calc(4px * var(--divide-x-reverse)) !important;
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:divide-x-4 > :not(template) ~ :not(template){
    border-left-width: calc(4px * var(--divide-x-reverse)) !important;
    border-right-width: calc(4px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .xl\\:divide-y-8 > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .xl\\:divide-y-8 > :not(template) ~ :not(template){
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(8px * var(--divide-y-reverse)) !important;
  }

  .xl\\:divide-x-8 > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:divide-x-8 > :not(template) ~ :not(template){
    border-right-width: calc(8px * var(--divide-x-reverse)) !important;
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:divide-x-8 > :not(template) ~ :not(template){
    border-left-width: calc(8px * var(--divide-x-reverse)) !important;
    border-right-width: calc(8px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .xl\\:divide-y > :not(template) ~ :not(template){
    --divide-y-reverse: 0 !important;
  }

  [dir] .xl\\:divide-y > :not(template) ~ :not(template){
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse))) !important;
    border-bottom-width: calc(1px * var(--divide-y-reverse)) !important;
  }

  .xl\\:divide-x > :not(template) ~ :not(template){
    --divide-x-reverse: 0 !important;
  }

  [dir=ltr] .xl\\:divide-x > :not(template) ~ :not(template){
    border-right-width: calc(1px * var(--divide-x-reverse)) !important;
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse))) !important;
  }

  [dir=rtl] .xl\\:divide-x > :not(template) ~ :not(template){
    border-left-width: calc(1px * var(--divide-x-reverse)) !important;
    border-right-width: calc(1px * calc(1 - var(--divide-x-reverse))) !important;
  }

  .xl\\:divide-y-reverse > :not(template) ~ :not(template){
    --divide-y-reverse: 1 !important;
  }

  .xl\\:divide-x-reverse > :not(template) ~ :not(template){
    --divide-x-reverse: 1 !important;
  }

  [dir] .xl\\:divide-transparent > :not(template) ~ :not(template){
    border-color: transparent !important;
  }

  .xl\\:divide-black > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .xl\\:divide-black > :not(template) ~ :not(template){
    border-color: #22292f !important;
    border-color: rgba(34, 41, 47, var(--divide-opacity)) !important;
  }

  .xl\\:divide-white > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .xl\\:divide-white > :not(template) ~ :not(template){
    border-color: #ffffff !important;
    border-color: rgba(255, 255, 255, var(--divide-opacity)) !important;
  }

  .xl\\:divide-grey > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .xl\\:divide-grey > :not(template) ~ :not(template){
    border-color: #b8c2cc !important;
    border-color: rgba(184, 194, 204, var(--divide-opacity)) !important;
  }

  .xl\\:divide-grey-light > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  [dir] .xl\\:divide-grey-light > :not(template) ~ :not(template){
    border-color: #dae1e7 !important;
    border-color: rgba(218, 225, 231, var(--divide-opacity)) !important;
  }

  [dir] .xl\\:divide-solid > :not(template) ~ :not(template){
    border-style: solid !important;
  }

  [dir] .xl\\:divide-dashed > :not(template) ~ :not(template){
    border-style: dashed !important;
  }

  [dir] .xl\\:divide-dotted > :not(template) ~ :not(template){
    border-style: dotted !important;
  }

  [dir] .xl\\:divide-double > :not(template) ~ :not(template){
    border-style: double !important;
  }

  [dir] .xl\\:divide-none > :not(template) ~ :not(template){
    border-style: none !important;
  }

  .xl\\:divide-opacity-0 > :not(template) ~ :not(template){
    --divide-opacity: 0 !important;
  }

  .xl\\:divide-opacity-25 > :not(template) ~ :not(template){
    --divide-opacity: 0.25 !important;
  }

  .xl\\:divide-opacity-50 > :not(template) ~ :not(template){
    --divide-opacity: 0.5 !important;
  }

  .xl\\:divide-opacity-75 > :not(template) ~ :not(template){
    --divide-opacity: 0.75 !important;
  }

  .xl\\:divide-opacity-100 > :not(template) ~ :not(template){
    --divide-opacity: 1 !important;
  }

  .xl\\:sr-only{
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
  }

  [dir] .xl\\:sr-only{
    padding: 0 !important;
    margin: -1px !important;
    border-width: 0 !important;
  }

  .xl\\:not-sr-only{
    position: static !important;
    width: auto !important;
    height: auto !important;
    overflow: visible !important;
    clip: auto !important;
    white-space: normal !important;
  }

  [dir] .xl\\:not-sr-only{
    padding: 0 !important;
    margin: 0 !important;
  }

  .xl\\:focus\\:sr-only:focus{
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
  }

  [dir] .xl\\:focus\\:sr-only:focus{
    padding: 0 !important;
    margin: -1px !important;
    border-width: 0 !important;
  }

  .xl\\:focus\\:not-sr-only:focus{
    position: static !important;
    width: auto !important;
    height: auto !important;
    overflow: visible !important;
    clip: auto !important;
    white-space: normal !important;
  }

  [dir] .xl\\:focus\\:not-sr-only:focus{
    padding: 0 !important;
    margin: 0 !important;
  }

  .xl\\:appearance-none{
    -webkit-appearance: none !important;
            appearance: none !important;
  }

  [dir] .xl\\:bg-fixed{
    background-attachment: fixed !important;
  }

  [dir] .xl\\:bg-local{
    background-attachment: local !important;
  }

  [dir] .xl\\:bg-scroll{
    background-attachment: scroll !important;
  }

  [dir] .xl\\:bg-clip-border{
    background-clip: border-box !important;
  }

  [dir] .xl\\:bg-clip-padding{
    background-clip: padding-box !important;
  }

  [dir] .xl\\:bg-clip-content{
    background-clip: content-box !important;
  }

  [dir] .xl\\:bg-clip-text{
    -webkit-background-clip: text !important;
            background-clip: text !important;
  }

  [dir] .xl\\:bg-transparent{
    background-color: transparent !important;
  }

  .xl\\:bg-black{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:bg-black{
    background-color: #22292f !important;
    background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
  }

  .xl\\:bg-white{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:bg-white{
    background-color: #ffffff !important;
    background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
  }

  .xl\\:bg-grey{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:bg-grey{
    background-color: #b8c2cc !important;
    background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
  }

  .xl\\:bg-grey-light{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:bg-grey-light{
    background-color: #dae1e7 !important;
    background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
  }

  [dir] .xl\\:hover\\:bg-transparent:hover{
    background-color: transparent !important;
  }

  .xl\\:hover\\:bg-black:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:hover\\:bg-black:hover{
    background-color: #22292f !important;
    background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
  }

  .xl\\:hover\\:bg-white:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:hover\\:bg-white:hover{
    background-color: #ffffff !important;
    background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
  }

  .xl\\:hover\\:bg-grey:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:hover\\:bg-grey:hover{
    background-color: #b8c2cc !important;
    background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
  }

  .xl\\:hover\\:bg-grey-light:hover{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:hover\\:bg-grey-light:hover{
    background-color: #dae1e7 !important;
    background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
  }

  [dir] .xl\\:focus\\:bg-transparent:focus{
    background-color: transparent !important;
  }

  .xl\\:focus\\:bg-black:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:focus\\:bg-black:focus{
    background-color: #22292f !important;
    background-color: rgba(34, 41, 47, var(--bg-opacity)) !important;
  }

  .xl\\:focus\\:bg-white:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:focus\\:bg-white:focus{
    background-color: #ffffff !important;
    background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;
  }

  .xl\\:focus\\:bg-grey:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:focus\\:bg-grey:focus{
    background-color: #b8c2cc !important;
    background-color: rgba(184, 194, 204, var(--bg-opacity)) !important;
  }

  .xl\\:focus\\:bg-grey-light:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:focus\\:bg-grey-light:focus{
    background-color: #dae1e7 !important;
    background-color: rgba(218, 225, 231, var(--bg-opacity)) !important;
  }

  [dir] .xl\\:bg-none{
    background-image: none !important;
  }

  [dir] .xl\\:bg-gradient-to-t{
    background-image: linear-gradient(to top, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .xl\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top right, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .xl\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top left, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .xl\\:bg-gradient-to-r{
    background-image: linear-gradient(to right, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .xl\\:bg-gradient-to-r{
    background-image: linear-gradient(to left, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .xl\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .xl\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops)) !important;
  }

  [dir] .xl\\:bg-gradient-to-b{
    background-image: linear-gradient(to bottom, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .xl\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .xl\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .xl\\:bg-gradient-to-l{
    background-image: linear-gradient(to left, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .xl\\:bg-gradient-to-l{
    background-image: linear-gradient(to right, var(--gradient-color-stops)) !important;
  }

  [dir=ltr] .xl\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top left, var(--gradient-color-stops)) !important;
  }

  [dir=rtl] .xl\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top right, var(--gradient-color-stops)) !important;
  }

  .xl\\:from-transparent{
    --gradient-from-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .xl\\:from-black{
    --gradient-from-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .xl\\:from-white{
    --gradient-from-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .xl\\:from-grey{
    --gradient-from-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .xl\\:from-grey-light{
    --gradient-from-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .xl\\:via-transparent{
    --gradient-via-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .xl\\:via-black{
    --gradient-via-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .xl\\:via-white{
    --gradient-via-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .xl\\:via-grey{
    --gradient-via-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .xl\\:via-grey-light{
    --gradient-via-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .xl\\:to-transparent{
    --gradient-to-color: transparent !important;
  }

  .xl\\:to-black{
    --gradient-to-color: #22292f !important;
  }

  .xl\\:to-white{
    --gradient-to-color: #ffffff !important;
  }

  .xl\\:to-grey{
    --gradient-to-color: #b8c2cc !important;
  }

  .xl\\:to-grey-light{
    --gradient-to-color: #dae1e7 !important;
  }

  .xl\\:hover\\:from-transparent:hover{
    --gradient-from-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .xl\\:hover\\:from-black:hover{
    --gradient-from-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .xl\\:hover\\:from-white:hover{
    --gradient-from-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .xl\\:hover\\:from-grey:hover{
    --gradient-from-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .xl\\:hover\\:from-grey-light:hover{
    --gradient-from-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .xl\\:hover\\:via-transparent:hover{
    --gradient-via-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .xl\\:hover\\:via-black:hover{
    --gradient-via-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .xl\\:hover\\:via-white:hover{
    --gradient-via-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .xl\\:hover\\:via-grey:hover{
    --gradient-via-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .xl\\:hover\\:via-grey-light:hover{
    --gradient-via-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .xl\\:hover\\:to-transparent:hover{
    --gradient-to-color: transparent !important;
  }

  .xl\\:hover\\:to-black:hover{
    --gradient-to-color: #22292f !important;
  }

  .xl\\:hover\\:to-white:hover{
    --gradient-to-color: #ffffff !important;
  }

  .xl\\:hover\\:to-grey:hover{
    --gradient-to-color: #b8c2cc !important;
  }

  .xl\\:hover\\:to-grey-light:hover{
    --gradient-to-color: #dae1e7 !important;
  }

  .xl\\:focus\\:from-transparent:focus{
    --gradient-from-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .xl\\:focus\\:from-black:focus{
    --gradient-from-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .xl\\:focus\\:from-white:focus{
    --gradient-from-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .xl\\:focus\\:from-grey:focus{
    --gradient-from-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .xl\\:focus\\:from-grey-light:focus{
    --gradient-from-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .xl\\:focus\\:via-transparent:focus{
    --gradient-via-color: transparent !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0)) !important;
  }

  .xl\\:focus\\:via-black:focus{
    --gradient-via-color: #22292f !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 41, 47, 0)) !important;
  }

  .xl\\:focus\\:via-white:focus{
    --gradient-via-color: #ffffff !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0)) !important;
  }

  .xl\\:focus\\:via-grey:focus{
    --gradient-via-color: #b8c2cc !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 194, 204, 0)) !important;
  }

  .xl\\:focus\\:via-grey-light:focus{
    --gradient-via-color: #dae1e7 !important;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(218, 225, 231, 0)) !important;
  }

  .xl\\:focus\\:to-transparent:focus{
    --gradient-to-color: transparent !important;
  }

  .xl\\:focus\\:to-black:focus{
    --gradient-to-color: #22292f !important;
  }

  .xl\\:focus\\:to-white:focus{
    --gradient-to-color: #ffffff !important;
  }

  .xl\\:focus\\:to-grey:focus{
    --gradient-to-color: #b8c2cc !important;
  }

  .xl\\:focus\\:to-grey-light:focus{
    --gradient-to-color: #dae1e7 !important;
  }

  .xl\\:bg-opacity-0{
    --bg-opacity: 0 !important;
  }

  .xl\\:bg-opacity-25{
    --bg-opacity: 0.25 !important;
  }

  .xl\\:bg-opacity-50{
    --bg-opacity: 0.5 !important;
  }

  .xl\\:bg-opacity-75{
    --bg-opacity: 0.75 !important;
  }

  .xl\\:bg-opacity-100{
    --bg-opacity: 1 !important;
  }

  .xl\\:hover\\:bg-opacity-0:hover{
    --bg-opacity: 0 !important;
  }

  .xl\\:hover\\:bg-opacity-25:hover{
    --bg-opacity: 0.25 !important;
  }

  .xl\\:hover\\:bg-opacity-50:hover{
    --bg-opacity: 0.5 !important;
  }

  .xl\\:hover\\:bg-opacity-75:hover{
    --bg-opacity: 0.75 !important;
  }

  .xl\\:hover\\:bg-opacity-100:hover{
    --bg-opacity: 1 !important;
  }

  .xl\\:focus\\:bg-opacity-0:focus{
    --bg-opacity: 0 !important;
  }

  .xl\\:focus\\:bg-opacity-25:focus{
    --bg-opacity: 0.25 !important;
  }

  .xl\\:focus\\:bg-opacity-50:focus{
    --bg-opacity: 0.5 !important;
  }

  .xl\\:focus\\:bg-opacity-75:focus{
    --bg-opacity: 0.75 !important;
  }

  .xl\\:focus\\:bg-opacity-100:focus{
    --bg-opacity: 1 !important;
  }

  [dir] .xl\\:bg-auto{
    background-size: auto !important;
  }

  [dir] .xl\\:bg-cover{
    background-size: cover !important;
  }

  [dir] .xl\\:bg-contain{
    background-size: contain !important;
  }

  [dir] .xl\\:border-transparent{
    border-color: transparent !important;
  }

  .xl\\:border-black{
    --border-opacity: 1 !important;
  }

  [dir] .xl\\:border-black{
    border-color: #22292f !important;
    border-color: rgba(34, 41, 47, var(--border-opacity)) !important;
  }

  .xl\\:border-white{
    --border-opacity: 1 !important;
  }

  [dir] .xl\\:border-white{
    border-color: #ffffff !important;
    border-color: rgba(255, 255, 255, var(--border-opacity)) !important;
  }

  .xl\\:border-grey{
    --border-opacity: 1 !important;
  }

  [dir] .xl\\:border-grey{
    border-color: #b8c2cc !important;
    border-color: rgba(184, 194, 204, var(--border-opacity)) !important;
  }

  .xl\\:border-grey-light{
    --border-opacity: 1 !important;
  }

  [dir] .xl\\:border-grey-light{
    border-color: #dae1e7 !important;
    border-color: rgba(218, 225, 231, var(--border-opacity)) !important;
  }

  [dir] .xl\\:hover\\:border-transparent:hover{
    border-color: transparent !important;
  }

  .xl\\:hover\\:border-black:hover{
    --border-opacity: 1 !important;
  }

  [dir] .xl\\:hover\\:border-black:hover{
    border-color: #22292f !important;
    border-color: rgba(34, 41, 47, var(--border-opacity)) !important;
  }

  .xl\\:hover\\:border-white:hover{
    --border-opacity: 1 !important;
  }

  [dir] .xl\\:hover\\:border-white:hover{
    border-color: #ffffff !important;
    border-color: rgba(255, 255, 255, var(--border-opacity)) !important;
  }

  .xl\\:hover\\:border-grey:hover{
    --border-opacity: 1 !important;
  }

  [dir] .xl\\:hover\\:border-grey:hover{
    border-color: #b8c2cc !important;
    border-color: rgba(184, 194, 204, var(--border-opacity)) !important;
  }

  .xl\\:hover\\:border-grey-light:hover{
    --border-opacity: 1 !important;
  }

  [dir] .xl\\:hover\\:border-grey-light:hover{
    border-color: #dae1e7 !important;
    border-color: rgba(218, 225, 231, var(--border-opacity)) !important;
  }

  .xl\\:border-opacity-0{
    --border-opacity: 0 !important;
  }

  .xl\\:border-opacity-25{
    --border-opacity: 0.25 !important;
  }

  .xl\\:border-opacity-50{
    --border-opacity: 0.5 !important;
  }

  .xl\\:border-opacity-75{
    --border-opacity: 0.75 !important;
  }

  .xl\\:border-opacity-100{
    --border-opacity: 1 !important;
  }

  .xl\\:hover\\:border-opacity-0:hover{
    --border-opacity: 0 !important;
  }

  .xl\\:hover\\:border-opacity-25:hover{
    --border-opacity: 0.25 !important;
  }

  .xl\\:hover\\:border-opacity-50:hover{
    --border-opacity: 0.5 !important;
  }

  .xl\\:hover\\:border-opacity-75:hover{
    --border-opacity: 0.75 !important;
  }

  .xl\\:hover\\:border-opacity-100:hover{
    --border-opacity: 1 !important;
  }

  .xl\\:focus\\:border-opacity-0:focus{
    --border-opacity: 0 !important;
  }

  .xl\\:focus\\:border-opacity-25:focus{
    --border-opacity: 0.25 !important;
  }

  .xl\\:focus\\:border-opacity-50:focus{
    --border-opacity: 0.5 !important;
  }

  .xl\\:focus\\:border-opacity-75:focus{
    --border-opacity: 0.75 !important;
  }

  .xl\\:focus\\:border-opacity-100:focus{
    --border-opacity: 1 !important;
  }

  [dir] .xl\\:border-solid{
    border-style: solid !important;
  }

  [dir] .xl\\:border-dashed{
    border-style: dashed !important;
  }

  [dir] .xl\\:border-dotted{
    border-style: dotted !important;
  }

  [dir] .xl\\:border-double{
    border-style: double !important;
  }

  [dir] .xl\\:border-none{
    border-style: none !important;
  }

  [dir] .xl\\:border-0{
    border-width: 0 !important;
  }

  [dir] .xl\\:border-2{
    border-width: 2px !important;
  }

  [dir] .xl\\:border-4{
    border-width: 4px !important;
  }

  [dir] .xl\\:border-8{
    border-width: 8px !important;
  }

  [dir] .xl\\:border{
    border-width: 1px !important;
  }

  [dir] .xl\\:border-t-0{
    border-top-width: 0 !important;
  }

  [dir=ltr] .xl\\:border-r-0{
    border-right-width: 0 !important;
  }

  [dir=rtl] .xl\\:border-r-0{
    border-left-width: 0 !important;
  }

  [dir] .xl\\:border-b-0{
    border-bottom-width: 0 !important;
  }

  [dir=ltr] .xl\\:border-l-0{
    border-left-width: 0 !important;
  }

  [dir=rtl] .xl\\:border-l-0{
    border-right-width: 0 !important;
  }

  [dir] .xl\\:border-t-2{
    border-top-width: 2px !important;
  }

  [dir=ltr] .xl\\:border-r-2{
    border-right-width: 2px !important;
  }

  [dir=rtl] .xl\\:border-r-2{
    border-left-width: 2px !important;
  }

  [dir] .xl\\:border-b-2{
    border-bottom-width: 2px !important;
  }

  [dir=ltr] .xl\\:border-l-2{
    border-left-width: 2px !important;
  }

  [dir=rtl] .xl\\:border-l-2{
    border-right-width: 2px !important;
  }

  [dir] .xl\\:border-t-4{
    border-top-width: 4px !important;
  }

  [dir=ltr] .xl\\:border-r-4{
    border-right-width: 4px !important;
  }

  [dir=rtl] .xl\\:border-r-4{
    border-left-width: 4px !important;
  }

  [dir] .xl\\:border-b-4{
    border-bottom-width: 4px !important;
  }

  [dir=ltr] .xl\\:border-l-4{
    border-left-width: 4px !important;
  }

  [dir=rtl] .xl\\:border-l-4{
    border-right-width: 4px !important;
  }

  [dir] .xl\\:border-t-8{
    border-top-width: 8px !important;
  }

  [dir=ltr] .xl\\:border-r-8{
    border-right-width: 8px !important;
  }

  [dir=rtl] .xl\\:border-r-8{
    border-left-width: 8px !important;
  }

  [dir] .xl\\:border-b-8{
    border-bottom-width: 8px !important;
  }

  [dir=ltr] .xl\\:border-l-8{
    border-left-width: 8px !important;
  }

  [dir=rtl] .xl\\:border-l-8{
    border-right-width: 8px !important;
  }

  [dir] .xl\\:border-t{
    border-top-width: 1px !important;
  }

  [dir=ltr] .xl\\:border-r{
    border-right-width: 1px !important;
  }

  [dir=rtl] .xl\\:border-r{
    border-left-width: 1px !important;
  }

  [dir] .xl\\:border-b{
    border-bottom-width: 1px !important;
  }

  [dir=ltr] .xl\\:border-l{
    border-left-width: 1px !important;
  }

  [dir=rtl] .xl\\:border-l{
    border-right-width: 1px !important;
  }

  .xl\\:box-border{
    box-sizing: border-box !important;
  }

  .xl\\:box-content{
    box-sizing: content-box !important;
  }

  .xl\\:block{
    display: block !important;
  }

  .xl\\:inline-block{
    display: inline-block !important;
  }

  .xl\\:inline{
    display: inline !important;
  }

  .xl\\:flex{
    display: flex !important;
  }

  .xl\\:inline-flex{
    display: inline-flex !important;
  }

  .xl\\:table{
    display: table !important;
  }

  .xl\\:table-caption{
    display: table-caption !important;
  }

  .xl\\:table-cell{
    display: table-cell !important;
  }

  .xl\\:table-column{
    display: table-column !important;
  }

  .xl\\:table-column-group{
    display: table-column-group !important;
  }

  .xl\\:table-footer-group{
    display: table-footer-group !important;
  }

  .xl\\:table-header-group{
    display: table-header-group !important;
  }

  .xl\\:table-row-group{
    display: table-row-group !important;
  }

  .xl\\:table-row{
    display: table-row !important;
  }

  .xl\\:flow-root{
    display: flow-root !important;
  }

  .xl\\:grid{
    display: grid !important;
  }

  .xl\\:inline-grid{
    display: inline-grid !important;
  }

  .xl\\:contents{
    display: contents !important;
  }

  .xl\\:hidden{
    display: none !important;
  }

  .xl\\:flex-row{
    flex-direction: row !important;
  }

  .xl\\:flex-row-reverse{
    flex-direction: row-reverse !important;
  }

  .xl\\:flex-col{
    flex-direction: column !important;
  }

  .xl\\:flex-col-reverse{
    flex-direction: column-reverse !important;
  }

  .xl\\:flex-wrap{
    flex-wrap: wrap !important;
  }

  .xl\\:flex-wrap-reverse{
    flex-wrap: wrap-reverse !important;
  }

  .xl\\:flex-no-wrap{
    flex-wrap: nowrap !important;
  }

  .xl\\:place-items-auto{
    place-items: auto !important;
  }

  .xl\\:place-items-start{
    place-items: start !important;
  }

  .xl\\:place-items-end{
    place-items: end !important;
  }

  .xl\\:place-items-center{
    place-items: center !important;
  }

  .xl\\:place-items-stretch{
    place-items: stretch !important;
  }

  .xl\\:place-content-center{
    place-content: center !important;
  }

  .xl\\:place-content-start{
    place-content: start !important;
  }

  .xl\\:place-content-end{
    place-content: end !important;
  }

  .xl\\:place-content-between{
    place-content: space-between !important;
  }

  .xl\\:place-content-around{
    place-content: space-around !important;
  }

  .xl\\:place-content-evenly{
    place-content: space-evenly !important;
  }

  .xl\\:place-content-stretch{
    place-content: stretch !important;
  }

  .xl\\:place-self-auto{
    place-self: auto !important;
  }

  .xl\\:place-self-start{
    place-self: start !important;
  }

  .xl\\:place-self-end{
    place-self: end !important;
  }

  .xl\\:place-self-center{
    place-self: center !important;
  }

  .xl\\:place-self-stretch{
    place-self: stretch !important;
  }

  .xl\\:items-start{
    align-items: flex-start !important;
  }

  .xl\\:items-end{
    align-items: flex-end !important;
  }

  .xl\\:items-center{
    align-items: center !important;
  }

  .xl\\:items-baseline{
    align-items: baseline !important;
  }

  .xl\\:items-stretch{
    align-items: stretch !important;
  }

  .xl\\:content-center{
    align-content: center !important;
  }

  .xl\\:content-start{
    align-content: flex-start !important;
  }

  .xl\\:content-end{
    align-content: flex-end !important;
  }

  .xl\\:content-between{
    align-content: space-between !important;
  }

  .xl\\:content-around{
    align-content: space-around !important;
  }

  .xl\\:content-evenly{
    align-content: space-evenly !important;
  }

  .xl\\:self-auto{
    align-self: auto !important;
  }

  .xl\\:self-start{
    align-self: flex-start !important;
  }

  .xl\\:self-end{
    align-self: flex-end !important;
  }

  .xl\\:self-center{
    align-self: center !important;
  }

  .xl\\:self-stretch{
    align-self: stretch !important;
  }

  .xl\\:justify-items-auto{
    justify-items: auto !important;
  }

  .xl\\:justify-items-start{
    justify-items: start !important;
  }

  .xl\\:justify-items-end{
    justify-items: end !important;
  }

  .xl\\:justify-items-center{
    justify-items: center !important;
  }

  .xl\\:justify-items-stretch{
    justify-items: stretch !important;
  }

  .xl\\:justify-start{
    justify-content: flex-start !important;
  }

  .xl\\:justify-end{
    justify-content: flex-end !important;
  }

  .xl\\:justify-center{
    justify-content: center !important;
  }

  .xl\\:justify-between{
    justify-content: space-between !important;
  }

  .xl\\:justify-around{
    justify-content: space-around !important;
  }

  .xl\\:justify-evenly{
    justify-content: space-evenly !important;
  }

  .xl\\:justify-self-auto{
    justify-self: auto !important;
  }

  .xl\\:justify-self-start{
    justify-self: start !important;
  }

  .xl\\:justify-self-end{
    justify-self: end !important;
  }

  .xl\\:justify-self-center{
    justify-self: center !important;
  }

  .xl\\:justify-self-stretch{
    justify-self: stretch !important;
  }

  .xl\\:flex-1{
    flex: 1 1 0% !important;
  }

  .xl\\:flex-auto{
    flex: 1 1 auto !important;
  }

  .xl\\:flex-initial{
    flex: 0 1 auto !important;
  }

  .xl\\:flex-none{
    flex: none !important;
  }

  .xl\\:flex-grow-0{
    flex-grow: 0 !important;
  }

  .xl\\:flex-grow{
    flex-grow: 1 !important;
  }

  .xl\\:flex-shrink-0{
    flex-shrink: 0 !important;
  }

  .xl\\:flex-shrink{
    flex-shrink: 1 !important;
  }

  .xl\\:order-1{
    order: 1 !important;
  }

  .xl\\:order-2{
    order: 2 !important;
  }

  .xl\\:order-3{
    order: 3 !important;
  }

  .xl\\:order-4{
    order: 4 !important;
  }

  .xl\\:order-5{
    order: 5 !important;
  }

  .xl\\:order-6{
    order: 6 !important;
  }

  .xl\\:order-first{
    order: -1 !important;
  }

  .xl\\:order-last{
    order: 999 !important;
  }

  .xl\\:order-normal{
    order: 0 !important;
  }

  .xl\\:hover\\:order-1:hover{
    order: 1 !important;
  }

  .xl\\:hover\\:order-2:hover{
    order: 2 !important;
  }

  .xl\\:hover\\:order-3:hover{
    order: 3 !important;
  }

  .xl\\:hover\\:order-4:hover{
    order: 4 !important;
  }

  .xl\\:hover\\:order-5:hover{
    order: 5 !important;
  }

  .xl\\:hover\\:order-6:hover{
    order: 6 !important;
  }

  .xl\\:hover\\:order-first:hover{
    order: -1 !important;
  }

  .xl\\:hover\\:order-last:hover{
    order: 999 !important;
  }

  .xl\\:hover\\:order-normal:hover{
    order: 0 !important;
  }

  .xl\\:focus\\:order-1:focus{
    order: 1 !important;
  }

  .xl\\:focus\\:order-2:focus{
    order: 2 !important;
  }

  .xl\\:focus\\:order-3:focus{
    order: 3 !important;
  }

  .xl\\:focus\\:order-4:focus{
    order: 4 !important;
  }

  .xl\\:focus\\:order-5:focus{
    order: 5 !important;
  }

  .xl\\:focus\\:order-6:focus{
    order: 6 !important;
  }

  .xl\\:focus\\:order-first:focus{
    order: -1 !important;
  }

  .xl\\:focus\\:order-last:focus{
    order: 999 !important;
  }

  .xl\\:focus\\:order-normal:focus{
    order: 0 !important;
  }

  [dir=ltr] .xl\\:float-right{
    float: right !important;
  }

  [dir=rtl] .xl\\:float-right{
    float: left !important;
  }

  [dir=ltr] .xl\\:float-left{
    float: left !important;
  }

  [dir=rtl] .xl\\:float-left{
    float: right !important;
  }

  [dir] .xl\\:float-none{
    float: none !important;
  }

  .xl\\:clearfix:after{
    content: "" !important;
    display: table !important;
  }

  [dir] .xl\\:clearfix:after{
    clear: both !important;
  }

  [dir=ltr] .xl\\:clear-left{
    clear: left !important;
  }

  [dir=rtl] .xl\\:clear-left{
    clear: right !important;
  }

  [dir=ltr] .xl\\:clear-right{
    clear: right !important;
  }

  [dir=rtl] .xl\\:clear-right{
    clear: left !important;
  }

  [dir] .xl\\:clear-both{
    clear: both !important;
  }

  [dir] .xl\\:clear-none{
    clear: none !important;
  }

  .xl\\:font-light{
    font-weight: 300 !important;
  }

  .xl\\:font-normal{
    font-weight: 400 !important;
  }

  .xl\\:font-medium{
    font-weight: 500 !important;
  }

  .xl\\:font-semibold{
    font-weight: 600 !important;
  }

  .xl\\:font-bold{
    font-weight: 700 !important;
  }

  .xl\\:font-extrabold{
    font-weight: 800 !important;
  }

  .xl\\:font-black{
    font-weight: 900 !important;
  }

  .xl\\:hover\\:font-light:hover{
    font-weight: 300 !important;
  }

  .xl\\:hover\\:font-normal:hover{
    font-weight: 400 !important;
  }

  .xl\\:hover\\:font-medium:hover{
    font-weight: 500 !important;
  }

  .xl\\:hover\\:font-semibold:hover{
    font-weight: 600 !important;
  }

  .xl\\:hover\\:font-bold:hover{
    font-weight: 700 !important;
  }

  .xl\\:hover\\:font-extrabold:hover{
    font-weight: 800 !important;
  }

  .xl\\:hover\\:font-black:hover{
    font-weight: 900 !important;
  }

  .xl\\:h-1{
    height: 0.25rem !important;
  }

  .xl\\:h-2{
    height: 0.5rem !important;
  }

  .xl\\:h-3{
    height: 0.75rem !important;
  }

  .xl\\:h-4{
    height: 1rem !important;
  }

  .xl\\:h-5{
    height: 1.25rem !important;
  }

  .xl\\:h-6{
    height: 1.5rem !important;
  }

  .xl\\:h-8{
    height: 2rem !important;
  }

  .xl\\:h-10{
    height: 2.5rem !important;
  }

  .xl\\:h-12{
    height: 3rem !important;
  }

  .xl\\:h-16{
    height: 4rem !important;
  }

  .xl\\:h-24{
    height: 6rem !important;
  }

  .xl\\:h-32{
    height: 8rem !important;
  }

  .xl\\:h-48{
    height: 12rem !important;
  }

  .xl\\:h-64{
    height: 16rem !important;
  }

  .xl\\:h-auto{
    height: auto !important;
  }

  .xl\\:h-px{
    height: 1px !important;
  }

  .xl\\:h-full{
    height: 100% !important;
  }

  .xl\\:h-screen{
    height: 100vh !important;
  }

  .xl\\:text-xs{
    font-size: .75rem !important;
  }

  .xl\\:text-sm{
    font-size: .875rem !important;
  }

  .xl\\:text-base{
    font-size: 1rem !important;
  }

  .xl\\:text-lg{
    font-size: 1.125rem !important;
  }

  .xl\\:text-xl{
    font-size: 1.25rem !important;
  }

  .xl\\:text-2xl{
    font-size: 1.5rem !important;
  }

  .xl\\:text-3xl{
    font-size: 1.875rem !important;
  }

  .xl\\:text-4xl{
    font-size: 2.25rem !important;
  }

  .xl\\:text-5xl{
    font-size: 3rem !important;
  }

  .xl\\:text-6xl{
    font-size: 4rem !important;
  }

  .xl\\:leading-none{
    line-height: 1 !important;
  }

  .xl\\:leading-tight{
    line-height: 1.25 !important;
  }

  .xl\\:leading-normal{
    line-height: 1.5 !important;
  }

  .xl\\:leading-loose{
    line-height: 2 !important;
  }

  .xl\\:list-inside{
    list-style-position: inside !important;
  }

  .xl\\:list-outside{
    list-style-position: outside !important;
  }

  [dir] .xl\\:m-0{
    margin: 0 !important;
  }

  [dir] .xl\\:m-1{
    margin: 0.25rem !important;
  }

  [dir] .xl\\:m-2{
    margin: 0.5rem !important;
  }

  [dir] .xl\\:m-3{
    margin: 0.75rem !important;
  }

  [dir] .xl\\:m-4{
    margin: 1rem !important;
  }

  [dir] .xl\\:m-5{
    margin: 1.25rem !important;
  }

  [dir] .xl\\:m-6{
    margin: 1.5rem !important;
  }

  [dir] .xl\\:m-8{
    margin: 2rem !important;
  }

  [dir] .xl\\:m-10{
    margin: 2.5rem !important;
  }

  [dir] .xl\\:m-12{
    margin: 3rem !important;
  }

  [dir] .xl\\:m-16{
    margin: 4rem !important;
  }

  [dir] .xl\\:m-20{
    margin: 5rem !important;
  }

  [dir] .xl\\:m-24{
    margin: 6rem !important;
  }

  [dir] .xl\\:m-32{
    margin: 8rem !important;
  }

  [dir] .xl\\:m-auto{
    margin: auto !important;
  }

  [dir] .xl\\:m-px{
    margin: 1px !important;
  }

  [dir] .xl\\:m-base{
    margin: 2.2rem !important;
  }

  [dir] .xl\\:-m-px{
    margin: -1px !important;
  }

  [dir] .xl\\:-m-1{
    margin: -0.25rem !important;
  }

  [dir] .xl\\:-m-2{
    margin: -0.5rem !important;
  }

  [dir] .xl\\:-m-3{
    margin: -0.75rem !important;
  }

  [dir] .xl\\:-m-4{
    margin: -1rem !important;
  }

  [dir] .xl\\:my-0{
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  [dir=ltr] .xl\\:mx-0{
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  [dir=rtl] .xl\\:mx-0{
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  [dir] .xl\\:my-1{
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  [dir=ltr] .xl\\:mx-1{
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
  }

  [dir=rtl] .xl\\:mx-1{
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  [dir] .xl\\:my-2{
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  [dir=ltr] .xl\\:mx-2{
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  [dir=rtl] .xl\\:mx-2{
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  [dir] .xl\\:my-3{
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  [dir=ltr] .xl\\:mx-3{
    margin-left: 0.75rem !important;
    margin-right: 0.75rem !important;
  }

  [dir=rtl] .xl\\:mx-3{
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  [dir] .xl\\:my-4{
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  [dir=ltr] .xl\\:mx-4{
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  [dir=rtl] .xl\\:mx-4{
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  [dir] .xl\\:my-5{
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  [dir=ltr] .xl\\:mx-5{
    margin-left: 1.25rem !important;
    margin-right: 1.25rem !important;
  }

  [dir=rtl] .xl\\:mx-5{
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  [dir] .xl\\:my-6{
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  [dir=ltr] .xl\\:mx-6{
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;
  }

  [dir=rtl] .xl\\:mx-6{
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  [dir] .xl\\:my-8{
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  [dir=ltr] .xl\\:mx-8{
    margin-left: 2rem !important;
    margin-right: 2rem !important;
  }

  [dir=rtl] .xl\\:mx-8{
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  [dir] .xl\\:my-10{
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  [dir=ltr] .xl\\:mx-10{
    margin-left: 2.5rem !important;
    margin-right: 2.5rem !important;
  }

  [dir=rtl] .xl\\:mx-10{
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  [dir] .xl\\:my-12{
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  [dir=ltr] .xl\\:mx-12{
    margin-left: 3rem !important;
    margin-right: 3rem !important;
  }

  [dir=rtl] .xl\\:mx-12{
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  [dir] .xl\\:my-16{
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  [dir=ltr] .xl\\:mx-16{
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }

  [dir=rtl] .xl\\:mx-16{
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  [dir] .xl\\:my-20{
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  [dir=ltr] .xl\\:mx-20{
    margin-left: 5rem !important;
    margin-right: 5rem !important;
  }

  [dir=rtl] .xl\\:mx-20{
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  [dir] .xl\\:my-24{
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }

  [dir=ltr] .xl\\:mx-24{
    margin-left: 6rem !important;
    margin-right: 6rem !important;
  }

  [dir=rtl] .xl\\:mx-24{
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }

  [dir] .xl\\:my-32{
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }

  [dir=ltr] .xl\\:mx-32{
    margin-left: 8rem !important;
    margin-right: 8rem !important;
  }

  [dir=rtl] .xl\\:mx-32{
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }

  [dir] .xl\\:my-auto{
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  [dir=ltr] .xl\\:mx-auto{
    margin-left: auto !important;
    margin-right: auto !important;
  }

  [dir=rtl] .xl\\:mx-auto{
    margin-right: auto !important;
    margin-left: auto !important;
  }

  [dir] .xl\\:my-px{
    margin-top: 1px !important;
    margin-bottom: 1px !important;
  }

  [dir=ltr] .xl\\:mx-px{
    margin-left: 1px !important;
    margin-right: 1px !important;
  }

  [dir=rtl] .xl\\:mx-px{
    margin-right: 1px !important;
    margin-left: 1px !important;
  }

  [dir] .xl\\:my-base{
    margin-top: 2.2rem !important;
    margin-bottom: 2.2rem !important;
  }

  [dir=ltr] .xl\\:mx-base{
    margin-left: 2.2rem !important;
    margin-right: 2.2rem !important;
  }

  [dir=rtl] .xl\\:mx-base{
    margin-right: 2.2rem !important;
    margin-left: 2.2rem !important;
  }

  [dir] .xl\\:-my-px{
    margin-top: -1px !important;
    margin-bottom: -1px !important;
  }

  [dir=ltr] .xl\\:-mx-px{
    margin-left: -1px !important;
    margin-right: -1px !important;
  }

  [dir=rtl] .xl\\:-mx-px{
    margin-right: -1px !important;
    margin-left: -1px !important;
  }

  [dir] .xl\\:-my-1{
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  [dir=ltr] .xl\\:-mx-1{
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
  }

  [dir=rtl] .xl\\:-mx-1{
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  [dir] .xl\\:-my-2{
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  [dir=ltr] .xl\\:-mx-2{
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }

  [dir=rtl] .xl\\:-mx-2{
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  [dir] .xl\\:-my-3{
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  [dir=ltr] .xl\\:-mx-3{
    margin-left: -0.75rem !important;
    margin-right: -0.75rem !important;
  }

  [dir=rtl] .xl\\:-mx-3{
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  [dir] .xl\\:-my-4{
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  [dir=ltr] .xl\\:-mx-4{
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }

  [dir=rtl] .xl\\:-mx-4{
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  [dir] .xl\\:mt-0{
    margin-top: 0 !important;
  }

  [dir=ltr] .xl\\:mr-0{
    margin-right: 0 !important;
  }

  [dir=rtl] .xl\\:mr-0{
    margin-left: 0 !important;
  }

  [dir] .xl\\:mb-0{
    margin-bottom: 0 !important;
  }

  [dir=ltr] .xl\\:ml-0{
    margin-left: 0 !important;
  }

  [dir=rtl] .xl\\:ml-0{
    margin-right: 0 !important;
  }

  [dir] .xl\\:mt-1{
    margin-top: 0.25rem !important;
  }

  [dir=ltr] .xl\\:mr-1{
    margin-right: 0.25rem !important;
  }

  [dir=rtl] .xl\\:mr-1{
    margin-left: 0.25rem !important;
  }

  [dir] .xl\\:mb-1{
    margin-bottom: 0.25rem !important;
  }

  [dir=ltr] .xl\\:ml-1{
    margin-left: 0.25rem !important;
  }

  [dir=rtl] .xl\\:ml-1{
    margin-right: 0.25rem !important;
  }

  [dir] .xl\\:mt-2{
    margin-top: 0.5rem !important;
  }

  [dir=ltr] .xl\\:mr-2{
    margin-right: 0.5rem !important;
  }

  [dir=rtl] .xl\\:mr-2{
    margin-left: 0.5rem !important;
  }

  [dir] .xl\\:mb-2{
    margin-bottom: 0.5rem !important;
  }

  [dir=ltr] .xl\\:ml-2{
    margin-left: 0.5rem !important;
  }

  [dir=rtl] .xl\\:ml-2{
    margin-right: 0.5rem !important;
  }

  [dir] .xl\\:mt-3{
    margin-top: 0.75rem !important;
  }

  [dir=ltr] .xl\\:mr-3{
    margin-right: 0.75rem !important;
  }

  [dir=rtl] .xl\\:mr-3{
    margin-left: 0.75rem !important;
  }

  [dir] .xl\\:mb-3{
    margin-bottom: 0.75rem !important;
  }

  [dir=ltr] .xl\\:ml-3{
    margin-left: 0.75rem !important;
  }

  [dir=rtl] .xl\\:ml-3{
    margin-right: 0.75rem !important;
  }

  [dir] .xl\\:mt-4{
    margin-top: 1rem !important;
  }

  [dir=ltr] .xl\\:mr-4{
    margin-right: 1rem !important;
  }

  [dir=rtl] .xl\\:mr-4{
    margin-left: 1rem !important;
  }

  [dir] .xl\\:mb-4{
    margin-bottom: 1rem !important;
  }

  [dir=ltr] .xl\\:ml-4{
    margin-left: 1rem !important;
  }

  [dir=rtl] .xl\\:ml-4{
    margin-right: 1rem !important;
  }

  [dir] .xl\\:mt-5{
    margin-top: 1.25rem !important;
  }

  [dir=ltr] .xl\\:mr-5{
    margin-right: 1.25rem !important;
  }

  [dir=rtl] .xl\\:mr-5{
    margin-left: 1.25rem !important;
  }

  [dir] .xl\\:mb-5{
    margin-bottom: 1.25rem !important;
  }

  [dir=ltr] .xl\\:ml-5{
    margin-left: 1.25rem !important;
  }

  [dir=rtl] .xl\\:ml-5{
    margin-right: 1.25rem !important;
  }

  [dir] .xl\\:mt-6{
    margin-top: 1.5rem !important;
  }

  [dir=ltr] .xl\\:mr-6{
    margin-right: 1.5rem !important;
  }

  [dir=rtl] .xl\\:mr-6{
    margin-left: 1.5rem !important;
  }

  [dir] .xl\\:mb-6{
    margin-bottom: 1.5rem !important;
  }

  [dir=ltr] .xl\\:ml-6{
    margin-left: 1.5rem !important;
  }

  [dir=rtl] .xl\\:ml-6{
    margin-right: 1.5rem !important;
  }

  [dir] .xl\\:mt-8{
    margin-top: 2rem !important;
  }

  [dir=ltr] .xl\\:mr-8{
    margin-right: 2rem !important;
  }

  [dir=rtl] .xl\\:mr-8{
    margin-left: 2rem !important;
  }

  [dir] .xl\\:mb-8{
    margin-bottom: 2rem !important;
  }

  [dir=ltr] .xl\\:ml-8{
    margin-left: 2rem !important;
  }

  [dir=rtl] .xl\\:ml-8{
    margin-right: 2rem !important;
  }

  [dir] .xl\\:mt-10{
    margin-top: 2.5rem !important;
  }

  [dir=ltr] .xl\\:mr-10{
    margin-right: 2.5rem !important;
  }

  [dir=rtl] .xl\\:mr-10{
    margin-left: 2.5rem !important;
  }

  [dir] .xl\\:mb-10{
    margin-bottom: 2.5rem !important;
  }

  [dir=ltr] .xl\\:ml-10{
    margin-left: 2.5rem !important;
  }

  [dir=rtl] .xl\\:ml-10{
    margin-right: 2.5rem !important;
  }

  [dir] .xl\\:mt-12{
    margin-top: 3rem !important;
  }

  [dir=ltr] .xl\\:mr-12{
    margin-right: 3rem !important;
  }

  [dir=rtl] .xl\\:mr-12{
    margin-left: 3rem !important;
  }

  [dir] .xl\\:mb-12{
    margin-bottom: 3rem !important;
  }

  [dir=ltr] .xl\\:ml-12{
    margin-left: 3rem !important;
  }

  [dir=rtl] .xl\\:ml-12{
    margin-right: 3rem !important;
  }

  [dir] .xl\\:mt-16{
    margin-top: 4rem !important;
  }

  [dir=ltr] .xl\\:mr-16{
    margin-right: 4rem !important;
  }

  [dir=rtl] .xl\\:mr-16{
    margin-left: 4rem !important;
  }

  [dir] .xl\\:mb-16{
    margin-bottom: 4rem !important;
  }

  [dir=ltr] .xl\\:ml-16{
    margin-left: 4rem !important;
  }

  [dir=rtl] .xl\\:ml-16{
    margin-right: 4rem !important;
  }

  [dir] .xl\\:mt-20{
    margin-top: 5rem !important;
  }

  [dir=ltr] .xl\\:mr-20{
    margin-right: 5rem !important;
  }

  [dir=rtl] .xl\\:mr-20{
    margin-left: 5rem !important;
  }

  [dir] .xl\\:mb-20{
    margin-bottom: 5rem !important;
  }

  [dir=ltr] .xl\\:ml-20{
    margin-left: 5rem !important;
  }

  [dir=rtl] .xl\\:ml-20{
    margin-right: 5rem !important;
  }

  [dir] .xl\\:mt-24{
    margin-top: 6rem !important;
  }

  [dir=ltr] .xl\\:mr-24{
    margin-right: 6rem !important;
  }

  [dir=rtl] .xl\\:mr-24{
    margin-left: 6rem !important;
  }

  [dir] .xl\\:mb-24{
    margin-bottom: 6rem !important;
  }

  [dir=ltr] .xl\\:ml-24{
    margin-left: 6rem !important;
  }

  [dir=rtl] .xl\\:ml-24{
    margin-right: 6rem !important;
  }

  [dir] .xl\\:mt-32{
    margin-top: 8rem !important;
  }

  [dir=ltr] .xl\\:mr-32{
    margin-right: 8rem !important;
  }

  [dir=rtl] .xl\\:mr-32{
    margin-left: 8rem !important;
  }

  [dir] .xl\\:mb-32{
    margin-bottom: 8rem !important;
  }

  [dir=ltr] .xl\\:ml-32{
    margin-left: 8rem !important;
  }

  [dir=rtl] .xl\\:ml-32{
    margin-right: 8rem !important;
  }

  [dir] .xl\\:mt-auto{
    margin-top: auto !important;
  }

  [dir=ltr] .xl\\:mr-auto{
    margin-right: auto !important;
  }

  [dir=rtl] .xl\\:mr-auto{
    margin-left: auto !important;
  }

  [dir] .xl\\:mb-auto{
    margin-bottom: auto !important;
  }

  [dir=ltr] .xl\\:ml-auto{
    margin-left: auto !important;
  }

  [dir=rtl] .xl\\:ml-auto{
    margin-right: auto !important;
  }

  [dir] .xl\\:mt-px{
    margin-top: 1px !important;
  }

  [dir=ltr] .xl\\:mr-px{
    margin-right: 1px !important;
  }

  [dir=rtl] .xl\\:mr-px{
    margin-left: 1px !important;
  }

  [dir] .xl\\:mb-px{
    margin-bottom: 1px !important;
  }

  [dir=ltr] .xl\\:ml-px{
    margin-left: 1px !important;
  }

  [dir=rtl] .xl\\:ml-px{
    margin-right: 1px !important;
  }

  [dir] .xl\\:mt-base{
    margin-top: 2.2rem !important;
  }

  [dir=ltr] .xl\\:mr-base{
    margin-right: 2.2rem !important;
  }

  [dir=rtl] .xl\\:mr-base{
    margin-left: 2.2rem !important;
  }

  [dir] .xl\\:mb-base{
    margin-bottom: 2.2rem !important;
  }

  [dir=ltr] .xl\\:ml-base{
    margin-left: 2.2rem !important;
  }

  [dir=rtl] .xl\\:ml-base{
    margin-right: 2.2rem !important;
  }

  [dir] .xl\\:-mt-px{
    margin-top: -1px !important;
  }

  [dir=ltr] .xl\\:-mr-px{
    margin-right: -1px !important;
  }

  [dir=rtl] .xl\\:-mr-px{
    margin-left: -1px !important;
  }

  [dir] .xl\\:-mb-px{
    margin-bottom: -1px !important;
  }

  [dir=ltr] .xl\\:-ml-px{
    margin-left: -1px !important;
  }

  [dir=rtl] .xl\\:-ml-px{
    margin-right: -1px !important;
  }

  [dir] .xl\\:-mt-1{
    margin-top: -0.25rem !important;
  }

  [dir=ltr] .xl\\:-mr-1{
    margin-right: -0.25rem !important;
  }

  [dir=rtl] .xl\\:-mr-1{
    margin-left: -0.25rem !important;
  }

  [dir] .xl\\:-mb-1{
    margin-bottom: -0.25rem !important;
  }

  [dir=ltr] .xl\\:-ml-1{
    margin-left: -0.25rem !important;
  }

  [dir=rtl] .xl\\:-ml-1{
    margin-right: -0.25rem !important;
  }

  [dir] .xl\\:-mt-2{
    margin-top: -0.5rem !important;
  }

  [dir=ltr] .xl\\:-mr-2{
    margin-right: -0.5rem !important;
  }

  [dir=rtl] .xl\\:-mr-2{
    margin-left: -0.5rem !important;
  }

  [dir] .xl\\:-mb-2{
    margin-bottom: -0.5rem !important;
  }

  [dir=ltr] .xl\\:-ml-2{
    margin-left: -0.5rem !important;
  }

  [dir=rtl] .xl\\:-ml-2{
    margin-right: -0.5rem !important;
  }

  [dir] .xl\\:-mt-3{
    margin-top: -0.75rem !important;
  }

  [dir=ltr] .xl\\:-mr-3{
    margin-right: -0.75rem !important;
  }

  [dir=rtl] .xl\\:-mr-3{
    margin-left: -0.75rem !important;
  }

  [dir] .xl\\:-mb-3{
    margin-bottom: -0.75rem !important;
  }

  [dir=ltr] .xl\\:-ml-3{
    margin-left: -0.75rem !important;
  }

  [dir=rtl] .xl\\:-ml-3{
    margin-right: -0.75rem !important;
  }

  [dir] .xl\\:-mt-4{
    margin-top: -1rem !important;
  }

  [dir=ltr] .xl\\:-mr-4{
    margin-right: -1rem !important;
  }

  [dir=rtl] .xl\\:-mr-4{
    margin-left: -1rem !important;
  }

  [dir] .xl\\:-mb-4{
    margin-bottom: -1rem !important;
  }

  [dir=ltr] .xl\\:-ml-4{
    margin-left: -1rem !important;
  }

  [dir=rtl] .xl\\:-ml-4{
    margin-right: -1rem !important;
  }

  .xl\\:max-h-full{
    max-height: 100% !important;
  }

  .xl\\:max-h-screen{
    max-height: 100vh !important;
  }

  .xl\\:max-w-xs{
    max-width: 20rem !important;
  }

  .xl\\:max-w-sm{
    max-width: 30rem !important;
  }

  .xl\\:max-w-md{
    max-width: 40rem !important;
  }

  .xl\\:max-w-lg{
    max-width: 50rem !important;
  }

  .xl\\:max-w-xl{
    max-width: 60rem !important;
  }

  .xl\\:max-w-2xl{
    max-width: 70rem !important;
  }

  .xl\\:max-w-3xl{
    max-width: 80rem !important;
  }

  .xl\\:max-w-4xl{
    max-width: 90rem !important;
  }

  .xl\\:max-w-5xl{
    max-width: 100rem !important;
  }

  .xl\\:max-w-full{
    max-width: 100% !important;
  }

  .xl\\:min-h-0{
    min-height: 0 !important;
  }

  .xl\\:min-h-full{
    min-height: 100% !important;
  }

  .xl\\:min-h-screen{
    min-height: 100vh !important;
  }

  .xl\\:min-w-0{
    min-width: 0 !important;
  }

  .xl\\:min-w-full{
    min-width: 100% !important;
  }

  .xl\\:object-contain{
    object-fit: contain !important;
  }

  .xl\\:object-cover{
    object-fit: cover !important;
  }

  .xl\\:object-fill{
    object-fit: fill !important;
  }

  .xl\\:object-none{
    object-fit: none !important;
  }

  .xl\\:object-scale-down{
    object-fit: scale-down !important;
  }

  .xl\\:object-bottom{
    object-position: bottom !important;
  }

  .xl\\:object-center{
    object-position: center !important;
  }

  .xl\\:object-left{
    object-position: left !important;
  }

  .xl\\:object-left-bottom{
    object-position: left bottom !important;
  }

  .xl\\:object-left-top{
    object-position: left top !important;
  }

  .xl\\:object-right{
    object-position: right !important;
  }

  .xl\\:object-right-bottom{
    object-position: right bottom !important;
  }

  .xl\\:object-right-top{
    object-position: right top !important;
  }

  .xl\\:object-top{
    object-position: top !important;
  }

  .xl\\:opacity-0{
    opacity: 0 !important;
  }

  .xl\\:opacity-25{
    opacity: 0.25 !important;
  }

  .xl\\:opacity-50{
    opacity: 0.5 !important;
  }

  .xl\\:opacity-75{
    opacity: 0.75 !important;
  }

  .xl\\:opacity-100{
    opacity: 1 !important;
  }

  .xl\\:overflow-auto{
    overflow: auto !important;
  }

  .xl\\:overflow-hidden{
    overflow: hidden !important;
  }

  .xl\\:overflow-visible{
    overflow: visible !important;
  }

  .xl\\:overflow-scroll{
    overflow: scroll !important;
  }

  .xl\\:overflow-x-auto{
    overflow-x: auto !important;
  }

  .xl\\:overflow-y-auto{
    overflow-y: auto !important;
  }

  .xl\\:overflow-x-hidden{
    overflow-x: hidden !important;
  }

  .xl\\:overflow-y-hidden{
    overflow-y: hidden !important;
  }

  .xl\\:overflow-x-visible{
    overflow-x: visible !important;
  }

  .xl\\:overflow-y-visible{
    overflow-y: visible !important;
  }

  .xl\\:overflow-x-scroll{
    overflow-x: scroll !important;
  }

  .xl\\:overflow-y-scroll{
    overflow-y: scroll !important;
  }

  .xl\\:scrolling-touch{
    -webkit-overflow-scrolling: touch !important;
  }

  .xl\\:scrolling-auto{
    -webkit-overflow-scrolling: auto !important;
  }

  .xl\\:overscroll-auto{
    overscroll-behavior: auto !important;
  }

  .xl\\:overscroll-contain{
    overscroll-behavior: contain !important;
  }

  .xl\\:overscroll-none{
    overscroll-behavior: none !important;
  }

  .xl\\:overscroll-y-auto{
    overscroll-behavior-y: auto !important;
  }

  .xl\\:overscroll-y-contain{
    overscroll-behavior-y: contain !important;
  }

  .xl\\:overscroll-y-none{
    overscroll-behavior-y: none !important;
  }

  .xl\\:overscroll-x-auto{
    overscroll-behavior-x: auto !important;
  }

  .xl\\:overscroll-x-contain{
    overscroll-behavior-x: contain !important;
  }

  .xl\\:overscroll-x-none{
    overscroll-behavior-x: none !important;
  }

  [dir] .xl\\:p-0{
    padding: 0 !important;
  }

  [dir] .xl\\:p-1{
    padding: 0.25rem !important;
  }

  [dir] .xl\\:p-2{
    padding: 0.5rem !important;
  }

  [dir] .xl\\:p-3{
    padding: 0.75rem !important;
  }

  [dir] .xl\\:p-4{
    padding: 1rem !important;
  }

  [dir] .xl\\:p-5{
    padding: 1.25rem !important;
  }

  [dir] .xl\\:p-6{
    padding: 1.5rem !important;
  }

  [dir] .xl\\:p-8{
    padding: 2rem !important;
  }

  [dir] .xl\\:p-10{
    padding: 2.5rem !important;
  }

  [dir] .xl\\:p-12{
    padding: 3rem !important;
  }

  [dir] .xl\\:p-16{
    padding: 4rem !important;
  }

  [dir] .xl\\:p-20{
    padding: 5rem !important;
  }

  [dir] .xl\\:p-24{
    padding: 6rem !important;
  }

  [dir] .xl\\:p-32{
    padding: 8rem !important;
  }

  [dir] .xl\\:p-px{
    padding: 1px !important;
  }

  [dir] .xl\\:p-base{
    padding: 2.2rem !important;
  }

  [dir] .xl\\:py-0{
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  [dir=ltr] .xl\\:px-0{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  [dir=rtl] .xl\\:px-0{
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  [dir] .xl\\:py-1{
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  [dir=ltr] .xl\\:px-1{
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }

  [dir=rtl] .xl\\:px-1{
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  [dir] .xl\\:py-2{
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  [dir=ltr] .xl\\:px-2{
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  [dir=rtl] .xl\\:px-2{
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  [dir] .xl\\:py-3{
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  [dir=ltr] .xl\\:px-3{
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }

  [dir=rtl] .xl\\:px-3{
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  [dir] .xl\\:py-4{
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  [dir=ltr] .xl\\:px-4{
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  [dir=rtl] .xl\\:px-4{
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  [dir] .xl\\:py-5{
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  [dir=ltr] .xl\\:px-5{
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
  }

  [dir=rtl] .xl\\:px-5{
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  [dir] .xl\\:py-6{
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  [dir=ltr] .xl\\:px-6{
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  [dir=rtl] .xl\\:px-6{
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  [dir] .xl\\:py-8{
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  [dir=ltr] .xl\\:px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }

  [dir=rtl] .xl\\:px-8{
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  [dir] .xl\\:py-10{
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  [dir=ltr] .xl\\:px-10{
    padding-left: 2.5rem !important;
    padding-right: 2.5rem !important;
  }

  [dir=rtl] .xl\\:px-10{
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  [dir] .xl\\:py-12{
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  [dir=ltr] .xl\\:px-12{
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }

  [dir=rtl] .xl\\:px-12{
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  [dir] .xl\\:py-16{
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  [dir=ltr] .xl\\:px-16{
    padding-left: 4rem !important;
    padding-right: 4rem !important;
  }

  [dir=rtl] .xl\\:px-16{
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  [dir] .xl\\:py-20{
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  [dir=ltr] .xl\\:px-20{
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }

  [dir=rtl] .xl\\:px-20{
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  [dir] .xl\\:py-24{
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }

  [dir=ltr] .xl\\:px-24{
    padding-left: 6rem !important;
    padding-right: 6rem !important;
  }

  [dir=rtl] .xl\\:px-24{
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }

  [dir] .xl\\:py-32{
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }

  [dir=ltr] .xl\\:px-32{
    padding-left: 8rem !important;
    padding-right: 8rem !important;
  }

  [dir=rtl] .xl\\:px-32{
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }

  [dir] .xl\\:py-px{
    padding-top: 1px !important;
    padding-bottom: 1px !important;
  }

  [dir=ltr] .xl\\:px-px{
    padding-left: 1px !important;
    padding-right: 1px !important;
  }

  [dir=rtl] .xl\\:px-px{
    padding-right: 1px !important;
    padding-left: 1px !important;
  }

  [dir] .xl\\:py-base{
    padding-top: 2.2rem !important;
    padding-bottom: 2.2rem !important;
  }

  [dir=ltr] .xl\\:px-base{
    padding-left: 2.2rem !important;
    padding-right: 2.2rem !important;
  }

  [dir=rtl] .xl\\:px-base{
    padding-right: 2.2rem !important;
    padding-left: 2.2rem !important;
  }

  [dir] .xl\\:pt-0{
    padding-top: 0 !important;
  }

  [dir=ltr] .xl\\:pr-0{
    padding-right: 0 !important;
  }

  [dir=rtl] .xl\\:pr-0{
    padding-left: 0 !important;
  }

  [dir] .xl\\:pb-0{
    padding-bottom: 0 !important;
  }

  [dir=ltr] .xl\\:pl-0{
    padding-left: 0 !important;
  }

  [dir=rtl] .xl\\:pl-0{
    padding-right: 0 !important;
  }

  [dir] .xl\\:pt-1{
    padding-top: 0.25rem !important;
  }

  [dir=ltr] .xl\\:pr-1{
    padding-right: 0.25rem !important;
  }

  [dir=rtl] .xl\\:pr-1{
    padding-left: 0.25rem !important;
  }

  [dir] .xl\\:pb-1{
    padding-bottom: 0.25rem !important;
  }

  [dir=ltr] .xl\\:pl-1{
    padding-left: 0.25rem !important;
  }

  [dir=rtl] .xl\\:pl-1{
    padding-right: 0.25rem !important;
  }

  [dir] .xl\\:pt-2{
    padding-top: 0.5rem !important;
  }

  [dir=ltr] .xl\\:pr-2{
    padding-right: 0.5rem !important;
  }

  [dir=rtl] .xl\\:pr-2{
    padding-left: 0.5rem !important;
  }

  [dir] .xl\\:pb-2{
    padding-bottom: 0.5rem !important;
  }

  [dir=ltr] .xl\\:pl-2{
    padding-left: 0.5rem !important;
  }

  [dir=rtl] .xl\\:pl-2{
    padding-right: 0.5rem !important;
  }

  [dir] .xl\\:pt-3{
    padding-top: 0.75rem !important;
  }

  [dir=ltr] .xl\\:pr-3{
    padding-right: 0.75rem !important;
  }

  [dir=rtl] .xl\\:pr-3{
    padding-left: 0.75rem !important;
  }

  [dir] .xl\\:pb-3{
    padding-bottom: 0.75rem !important;
  }

  [dir=ltr] .xl\\:pl-3{
    padding-left: 0.75rem !important;
  }

  [dir=rtl] .xl\\:pl-3{
    padding-right: 0.75rem !important;
  }

  [dir] .xl\\:pt-4{
    padding-top: 1rem !important;
  }

  [dir=ltr] .xl\\:pr-4{
    padding-right: 1rem !important;
  }

  [dir=rtl] .xl\\:pr-4{
    padding-left: 1rem !important;
  }

  [dir] .xl\\:pb-4{
    padding-bottom: 1rem !important;
  }

  [dir=ltr] .xl\\:pl-4{
    padding-left: 1rem !important;
  }

  [dir=rtl] .xl\\:pl-4{
    padding-right: 1rem !important;
  }

  [dir] .xl\\:pt-5{
    padding-top: 1.25rem !important;
  }

  [dir=ltr] .xl\\:pr-5{
    padding-right: 1.25rem !important;
  }

  [dir=rtl] .xl\\:pr-5{
    padding-left: 1.25rem !important;
  }

  [dir] .xl\\:pb-5{
    padding-bottom: 1.25rem !important;
  }

  [dir=ltr] .xl\\:pl-5{
    padding-left: 1.25rem !important;
  }

  [dir=rtl] .xl\\:pl-5{
    padding-right: 1.25rem !important;
  }

  [dir] .xl\\:pt-6{
    padding-top: 1.5rem !important;
  }

  [dir=ltr] .xl\\:pr-6{
    padding-right: 1.5rem !important;
  }

  [dir=rtl] .xl\\:pr-6{
    padding-left: 1.5rem !important;
  }

  [dir] .xl\\:pb-6{
    padding-bottom: 1.5rem !important;
  }

  [dir=ltr] .xl\\:pl-6{
    padding-left: 1.5rem !important;
  }

  [dir=rtl] .xl\\:pl-6{
    padding-right: 1.5rem !important;
  }

  [dir] .xl\\:pt-8{
    padding-top: 2rem !important;
  }

  [dir=ltr] .xl\\:pr-8{
    padding-right: 2rem !important;
  }

  [dir=rtl] .xl\\:pr-8{
    padding-left: 2rem !important;
  }

  [dir] .xl\\:pb-8{
    padding-bottom: 2rem !important;
  }

  [dir=ltr] .xl\\:pl-8{
    padding-left: 2rem !important;
  }

  [dir=rtl] .xl\\:pl-8{
    padding-right: 2rem !important;
  }

  [dir] .xl\\:pt-10{
    padding-top: 2.5rem !important;
  }

  [dir=ltr] .xl\\:pr-10{
    padding-right: 2.5rem !important;
  }

  [dir=rtl] .xl\\:pr-10{
    padding-left: 2.5rem !important;
  }

  [dir] .xl\\:pb-10{
    padding-bottom: 2.5rem !important;
  }

  [dir=ltr] .xl\\:pl-10{
    padding-left: 2.5rem !important;
  }

  [dir=rtl] .xl\\:pl-10{
    padding-right: 2.5rem !important;
  }

  [dir] .xl\\:pt-12{
    padding-top: 3rem !important;
  }

  [dir=ltr] .xl\\:pr-12{
    padding-right: 3rem !important;
  }

  [dir=rtl] .xl\\:pr-12{
    padding-left: 3rem !important;
  }

  [dir] .xl\\:pb-12{
    padding-bottom: 3rem !important;
  }

  [dir=ltr] .xl\\:pl-12{
    padding-left: 3rem !important;
  }

  [dir=rtl] .xl\\:pl-12{
    padding-right: 3rem !important;
  }

  [dir] .xl\\:pt-16{
    padding-top: 4rem !important;
  }

  [dir=ltr] .xl\\:pr-16{
    padding-right: 4rem !important;
  }

  [dir=rtl] .xl\\:pr-16{
    padding-left: 4rem !important;
  }

  [dir] .xl\\:pb-16{
    padding-bottom: 4rem !important;
  }

  [dir=ltr] .xl\\:pl-16{
    padding-left: 4rem !important;
  }

  [dir=rtl] .xl\\:pl-16{
    padding-right: 4rem !important;
  }

  [dir] .xl\\:pt-20{
    padding-top: 5rem !important;
  }

  [dir=ltr] .xl\\:pr-20{
    padding-right: 5rem !important;
  }

  [dir=rtl] .xl\\:pr-20{
    padding-left: 5rem !important;
  }

  [dir] .xl\\:pb-20{
    padding-bottom: 5rem !important;
  }

  [dir=ltr] .xl\\:pl-20{
    padding-left: 5rem !important;
  }

  [dir=rtl] .xl\\:pl-20{
    padding-right: 5rem !important;
  }

  [dir] .xl\\:pt-24{
    padding-top: 6rem !important;
  }

  [dir=ltr] .xl\\:pr-24{
    padding-right: 6rem !important;
  }

  [dir=rtl] .xl\\:pr-24{
    padding-left: 6rem !important;
  }

  [dir] .xl\\:pb-24{
    padding-bottom: 6rem !important;
  }

  [dir=ltr] .xl\\:pl-24{
    padding-left: 6rem !important;
  }

  [dir=rtl] .xl\\:pl-24{
    padding-right: 6rem !important;
  }

  [dir] .xl\\:pt-32{
    padding-top: 8rem !important;
  }

  [dir=ltr] .xl\\:pr-32{
    padding-right: 8rem !important;
  }

  [dir=rtl] .xl\\:pr-32{
    padding-left: 8rem !important;
  }

  [dir] .xl\\:pb-32{
    padding-bottom: 8rem !important;
  }

  [dir=ltr] .xl\\:pl-32{
    padding-left: 8rem !important;
  }

  [dir=rtl] .xl\\:pl-32{
    padding-right: 8rem !important;
  }

  [dir] .xl\\:pt-px{
    padding-top: 1px !important;
  }

  [dir=ltr] .xl\\:pr-px{
    padding-right: 1px !important;
  }

  [dir=rtl] .xl\\:pr-px{
    padding-left: 1px !important;
  }

  [dir] .xl\\:pb-px{
    padding-bottom: 1px !important;
  }

  [dir=ltr] .xl\\:pl-px{
    padding-left: 1px !important;
  }

  [dir=rtl] .xl\\:pl-px{
    padding-right: 1px !important;
  }

  [dir] .xl\\:pt-base{
    padding-top: 2.2rem !important;
  }

  [dir=ltr] .xl\\:pr-base{
    padding-right: 2.2rem !important;
  }

  [dir=rtl] .xl\\:pr-base{
    padding-left: 2.2rem !important;
  }

  [dir] .xl\\:pb-base{
    padding-bottom: 2.2rem !important;
  }

  [dir=ltr] .xl\\:pl-base{
    padding-left: 2.2rem !important;
  }

  [dir=rtl] .xl\\:pl-base{
    padding-right: 2.2rem !important;
  }

  .xl\\:placeholder-transparent::placeholder{
    color: transparent !important;
  }

  .xl\\:placeholder-black::placeholder{
    --placeholder-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--placeholder-opacity)) !important;
  }

  .xl\\:placeholder-white::placeholder{
    --placeholder-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--placeholder-opacity)) !important;
  }

  .xl\\:placeholder-grey::placeholder{
    --placeholder-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--placeholder-opacity)) !important;
  }

  .xl\\:placeholder-grey-light::placeholder{
    --placeholder-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--placeholder-opacity)) !important;
  }

  .xl\\:focus\\:placeholder-transparent:focus::placeholder{
    color: transparent !important;
  }

  .xl\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--placeholder-opacity)) !important;
  }

  .xl\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--placeholder-opacity)) !important;
  }

  .xl\\:focus\\:placeholder-grey:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--placeholder-opacity)) !important;
  }

  .xl\\:focus\\:placeholder-grey-light:focus::placeholder{
    --placeholder-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--placeholder-opacity)) !important;
  }

  .xl\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity: 0 !important;
  }

  .xl\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity: 0.25 !important;
  }

  .xl\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity: 0.5 !important;
  }

  .xl\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity: 0.75 !important;
  }

  .xl\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity: 1 !important;
  }

  .xl\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity: 0 !important;
  }

  .xl\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity: 0.25 !important;
  }

  .xl\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity: 0.5 !important;
  }

  .xl\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity: 0.75 !important;
  }

  .xl\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity: 1 !important;
  }

  .xl\\:pointer-events-none{
    pointer-events: none !important;
  }

  .xl\\:pointer-events-auto{
    pointer-events: auto !important;
  }

  .xl\\:static{
    position: static !important;
  }

  .xl\\:fixed{
    position: fixed !important;
  }

  .xl\\:absolute{
    position: absolute !important;
  }

  .xl\\:relative{
    position: relative !important;
  }

  .xl\\:sticky{
    position: sticky !important;
  }

  .xl\\:inset-0{
    top: 0 !important;
    bottom: 0 !important;
  }

  [dir=ltr] .xl\\:inset-0{
    right: 0 !important;
    left: 0 !important;
  }

  [dir=rtl] .xl\\:inset-0{
    left: 0 !important;
    right: 0 !important;
  }

  .xl\\:inset-auto{
    top: auto !important;
    bottom: auto !important;
  }

  [dir=ltr] .xl\\:inset-auto{
    right: auto !important;
    left: auto !important;
  }

  [dir=rtl] .xl\\:inset-auto{
    left: auto !important;
    right: auto !important;
  }

  .xl\\:inset-y-0{
    top: 0 !important;
    bottom: 0 !important;
  }

  [dir=ltr] .xl\\:inset-x-0{
    right: 0 !important;
    left: 0 !important;
  }

  [dir=rtl] .xl\\:inset-x-0{
    left: 0 !important;
    right: 0 !important;
  }

  .xl\\:inset-y-auto{
    top: auto !important;
    bottom: auto !important;
  }

  [dir=ltr] .xl\\:inset-x-auto{
    right: auto !important;
    left: auto !important;
  }

  [dir=rtl] .xl\\:inset-x-auto{
    left: auto !important;
    right: auto !important;
  }

  .xl\\:top-0{
    top: 0 !important;
  }

  [dir=ltr] .xl\\:right-0{
    right: 0 !important;
  }

  [dir=rtl] .xl\\:right-0{
    left: 0 !important;
  }

  .xl\\:bottom-0{
    bottom: 0 !important;
  }

  [dir=ltr] .xl\\:left-0{
    left: 0 !important;
  }

  [dir=rtl] .xl\\:left-0{
    right: 0 !important;
  }

  .xl\\:top-auto{
    top: auto !important;
  }

  [dir=ltr] .xl\\:right-auto{
    right: auto !important;
  }

  [dir=rtl] .xl\\:right-auto{
    left: auto !important;
  }

  .xl\\:bottom-auto{
    bottom: auto !important;
  }

  [dir=ltr] .xl\\:left-auto{
    left: auto !important;
  }

  [dir=rtl] .xl\\:left-auto{
    right: auto !important;
  }

  .xl\\:resize-none{
    resize: none !important;
  }

  .xl\\:resize-y{
    resize: vertical !important;
  }

  .xl\\:resize-x{
    resize: horizontal !important;
  }

  .xl\\:resize{
    resize: both !important;
  }

  [dir] .xl\\:shadow{
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
  }

  [dir] .xl\\:shadow-md{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .xl\\:shadow-lg{
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .xl\\:shadow-inner{
    box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
  }

  [dir] .xl\\:shadow-xl{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  [dir] .xl\\:shadow-2xl{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }

  [dir] .xl\\:shadow-outline{
    box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
  }

  [dir] .xl\\:shadow-none{
    box-shadow: none !important;
  }

  [dir] .xl\\:shadow-drop{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
  }

  [dir] .xl\\:hover\\:shadow:hover{
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
  }

  [dir] .xl\\:hover\\:shadow-md:hover{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .xl\\:hover\\:shadow-lg:hover{
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .xl\\:hover\\:shadow-inner:hover{
    box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
  }

  [dir] .xl\\:hover\\:shadow-xl:hover{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  [dir] .xl\\:hover\\:shadow-2xl:hover{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }

  [dir] .xl\\:hover\\:shadow-outline:hover{
    box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
  }

  [dir] .xl\\:hover\\:shadow-none:hover{
    box-shadow: none !important;
  }

  [dir] .xl\\:hover\\:shadow-drop:hover{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
  }

  [dir] .xl\\:focus\\:shadow:focus{
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10) !important;
  }

  [dir] .xl\\:focus\\:shadow-md:focus{
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .xl\\:focus\\:shadow-lg:focus{
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  }

  [dir] .xl\\:focus\\:shadow-inner:focus{
    box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.06) !important;
  }

  [dir] .xl\\:focus\\:shadow-xl:focus{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  [dir] .xl\\:focus\\:shadow-2xl:focus{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
  }

  [dir] .xl\\:focus\\:shadow-outline:focus{
    box-shadow: 0 0 0 3px rgba(52,144,220,0.5) !important;
  }

  [dir] .xl\\:focus\\:shadow-none:focus{
    box-shadow: none !important;
  }

  [dir] .xl\\:focus\\:shadow-drop:focus{
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.14) !important;
  }

  .xl\\:stroke-0{
    stroke-width: 0 !important;
  }

  .xl\\:stroke-1{
    stroke-width: 1 !important;
  }

  .xl\\:stroke-2{
    stroke-width: 2 !important;
  }

  .xl\\:table-auto{
    table-layout: auto !important;
  }

  .xl\\:table-fixed{
    table-layout: fixed !important;
  }

  [dir=ltr] .xl\\:text-left{
    text-align: left !important;
  }

  [dir=rtl] .xl\\:text-left{
    text-align: right !important;
  }

  [dir] .xl\\:text-center{
    text-align: center !important;
  }

  [dir=ltr] .xl\\:text-right{
    text-align: right !important;
  }

  [dir=rtl] .xl\\:text-right{
    text-align: left !important;
  }

  [dir] .xl\\:text-justify{
    text-align: justify !important;
  }

  .xl\\:text-inherit{
    color: inherit !important;
  }

  .xl\\:text-transparent{
    color: transparent !important;
  }

  .xl\\:text-black{
    --text-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--text-opacity)) !important;
  }

  .xl\\:text-white{
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }

  .xl\\:text-grey{
    --text-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--text-opacity)) !important;
  }

  .xl\\:text-grey-light{
    --text-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--text-opacity)) !important;
  }

  .xl\\:hover\\:text-inherit:hover{
    color: inherit !important;
  }

  .xl\\:hover\\:text-transparent:hover{
    color: transparent !important;
  }

  .xl\\:hover\\:text-black:hover{
    --text-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--text-opacity)) !important;
  }

  .xl\\:hover\\:text-white:hover{
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }

  .xl\\:hover\\:text-grey:hover{
    --text-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--text-opacity)) !important;
  }

  .xl\\:hover\\:text-grey-light:hover{
    --text-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--text-opacity)) !important;
  }

  .xl\\:focus\\:text-inherit:focus{
    color: inherit !important;
  }

  .xl\\:focus\\:text-transparent:focus{
    color: transparent !important;
  }

  .xl\\:focus\\:text-black:focus{
    --text-opacity: 1 !important;
    color: #22292f !important;
    color: rgba(34, 41, 47, var(--text-opacity)) !important;
  }

  .xl\\:focus\\:text-white:focus{
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }

  .xl\\:focus\\:text-grey:focus{
    --text-opacity: 1 !important;
    color: #b8c2cc !important;
    color: rgba(184, 194, 204, var(--text-opacity)) !important;
  }

  .xl\\:focus\\:text-grey-light:focus{
    --text-opacity: 1 !important;
    color: #dae1e7 !important;
    color: rgba(218, 225, 231, var(--text-opacity)) !important;
  }

  .xl\\:text-opacity-0{
    --text-opacity: 0 !important;
  }

  .xl\\:text-opacity-25{
    --text-opacity: 0.25 !important;
  }

  .xl\\:text-opacity-50{
    --text-opacity: 0.5 !important;
  }

  .xl\\:text-opacity-75{
    --text-opacity: 0.75 !important;
  }

  .xl\\:text-opacity-100{
    --text-opacity: 1 !important;
  }

  .xl\\:hover\\:text-opacity-0:hover{
    --text-opacity: 0 !important;
  }

  .xl\\:hover\\:text-opacity-25:hover{
    --text-opacity: 0.25 !important;
  }

  .xl\\:hover\\:text-opacity-50:hover{
    --text-opacity: 0.5 !important;
  }

  .xl\\:hover\\:text-opacity-75:hover{
    --text-opacity: 0.75 !important;
  }

  .xl\\:hover\\:text-opacity-100:hover{
    --text-opacity: 1 !important;
  }

  .xl\\:focus\\:text-opacity-0:focus{
    --text-opacity: 0 !important;
  }

  .xl\\:focus\\:text-opacity-25:focus{
    --text-opacity: 0.25 !important;
  }

  .xl\\:focus\\:text-opacity-50:focus{
    --text-opacity: 0.5 !important;
  }

  .xl\\:focus\\:text-opacity-75:focus{
    --text-opacity: 0.75 !important;
  }

  .xl\\:focus\\:text-opacity-100:focus{
    --text-opacity: 1 !important;
  }

  .xl\\:italic{
    font-style: italic !important;
  }

  .xl\\:not-italic{
    font-style: normal !important;
  }

  .xl\\:hover\\:italic:hover{
    font-style: italic !important;
  }

  .xl\\:hover\\:not-italic:hover{
    font-style: normal !important;
  }

  .xl\\:focus\\:italic:focus{
    font-style: italic !important;
  }

  .xl\\:focus\\:not-italic:focus{
    font-style: normal !important;
  }

  .xl\\:uppercase{
    text-transform: uppercase !important;
  }

  .xl\\:lowercase{
    text-transform: lowercase !important;
  }

  .xl\\:capitalize{
    text-transform: capitalize !important;
  }

  .xl\\:normal-case{
    text-transform: none !important;
  }

  .xl\\:hover\\:uppercase:hover{
    text-transform: uppercase !important;
  }

  .xl\\:hover\\:lowercase:hover{
    text-transform: lowercase !important;
  }

  .xl\\:hover\\:capitalize:hover{
    text-transform: capitalize !important;
  }

  .xl\\:hover\\:normal-case:hover{
    text-transform: none !important;
  }

  .xl\\:focus\\:uppercase:focus{
    text-transform: uppercase !important;
  }

  .xl\\:focus\\:lowercase:focus{
    text-transform: lowercase !important;
  }

  .xl\\:focus\\:capitalize:focus{
    text-transform: capitalize !important;
  }

  .xl\\:focus\\:normal-case:focus{
    text-transform: none !important;
  }

  .xl\\:underline{
    text-decoration: underline !important;
  }

  .xl\\:line-through{
    text-decoration: line-through !important;
  }

  .xl\\:no-underline{
    text-decoration: none !important;
  }

  .xl\\:hover\\:underline:hover{
    text-decoration: underline !important;
  }

  .xl\\:hover\\:line-through:hover{
    text-decoration: line-through !important;
  }

  .xl\\:hover\\:no-underline:hover{
    text-decoration: none !important;
  }

  .xl\\:focus\\:underline:focus{
    text-decoration: underline !important;
  }

  .xl\\:focus\\:line-through:focus{
    text-decoration: line-through !important;
  }

  .xl\\:focus\\:no-underline:focus{
    text-decoration: none !important;
  }

  .xl\\:antialiased{
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }

  .xl\\:subpixel-antialiased{
    -webkit-font-smoothing: auto !important;
    -moz-osx-font-smoothing: auto !important;
  }

  .xl\\:hover\\:antialiased:hover{
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }

  .xl\\:hover\\:subpixel-antialiased:hover{
    -webkit-font-smoothing: auto !important;
    -moz-osx-font-smoothing: auto !important;
  }

  .xl\\:focus\\:antialiased:focus{
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
  }

  .xl\\:focus\\:subpixel-antialiased:focus{
    -webkit-font-smoothing: auto !important;
    -moz-osx-font-smoothing: auto !important;
  }

  .xl\\:ordinal, .xl\\:slashed-zero, .xl\\:lining-nums, .xl\\:oldstyle-nums, .xl\\:proportional-nums, .xl\\:tabular-nums, .xl\\:diagonal-fractions, .xl\\:stacked-fractions{
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/) !important;
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/) !important;
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction) !important;
  }

  .xl\\:normal-nums{
    font-variant-numeric: normal !important;
  }

  .xl\\:ordinal{
    --font-variant-numeric-ordinal: ordinal !important;
  }

  .xl\\:slashed-zero{
    --font-variant-numeric-slashed-zero: slashed-zero !important;
  }

  .xl\\:lining-nums{
    --font-variant-numeric-figure: lining-nums !important;
  }

  .xl\\:oldstyle-nums{
    --font-variant-numeric-figure: oldstyle-nums !important;
  }

  .xl\\:proportional-nums{
    --font-variant-numeric-spacing: proportional-nums !important;
  }

  .xl\\:tabular-nums{
    --font-variant-numeric-spacing: tabular-nums !important;
  }

  .xl\\:diagonal-fractions{
    --font-variant-numeric-fraction: diagonal-fractions !important;
  }

  .xl\\:stacked-fractions{
    --font-variant-numeric-fraction: stacked-fractions !important;
  }

  .xl\\:select-none{
    -webkit-user-select: none !important;
            user-select: none !important;
  }

  .xl\\:select-text{
    -webkit-user-select: text !important;
            user-select: text !important;
  }

  .xl\\:select-all{
    -webkit-user-select: all !important;
            user-select: all !important;
  }

  .xl\\:select-auto{
    -webkit-user-select: auto !important;
            user-select: auto !important;
  }

  .xl\\:align-baseline{
    vertical-align: baseline !important;
  }

  .xl\\:align-top{
    vertical-align: top !important;
  }

  .xl\\:align-middle{
    vertical-align: middle !important;
  }

  .xl\\:align-bottom{
    vertical-align: bottom !important;
  }

  .xl\\:align-text-top{
    vertical-align: text-top !important;
  }

  .xl\\:align-text-bottom{
    vertical-align: text-bottom !important;
  }

  .xl\\:visible{
    visibility: visible !important;
  }

  .xl\\:invisible{
    visibility: hidden !important;
  }

  .xl\\:whitespace-normal{
    white-space: normal !important;
  }

  .xl\\:whitespace-no-wrap{
    white-space: nowrap !important;
  }

  .xl\\:whitespace-pre{
    white-space: pre !important;
  }

  .xl\\:whitespace-pre-line{
    white-space: pre-line !important;
  }

  .xl\\:whitespace-pre-wrap{
    white-space: pre-wrap !important;
  }

  .xl\\:break-normal{
    word-wrap: normal !important;
    overflow-wrap: normal !important;
    word-break: normal !important;
  }

  .xl\\:break-words{
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
  }

  .xl\\:break-all{
    word-break: break-all !important;
  }

  .xl\\:truncate{
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .xl\\:w-1{
    width: 0.25rem !important;
  }

  .xl\\:w-2{
    width: 0.5rem !important;
  }

  .xl\\:w-3{
    width: 0.75rem !important;
  }

  .xl\\:w-4{
    width: 1rem !important;
  }

  .xl\\:w-5{
    width: 1.25rem !important;
  }

  .xl\\:w-6{
    width: 1.5rem !important;
  }

  .xl\\:w-8{
    width: 2rem !important;
  }

  .xl\\:w-10{
    width: 2.5rem !important;
  }

  .xl\\:w-12{
    width: 3rem !important;
  }

  .xl\\:w-16{
    width: 4rem !important;
  }

  .xl\\:w-24{
    width: 6rem !important;
  }

  .xl\\:w-32{
    width: 8rem !important;
  }

  .xl\\:w-48{
    width: 12rem !important;
  }

  .xl\\:w-64{
    width: 16rem !important;
  }

  .xl\\:w-auto{
    width: auto !important;
  }

  .xl\\:w-px{
    width: 1px !important;
  }

  .xl\\:w-1\\/2{
    width: 50% !important;
  }

  .xl\\:w-1\\/3{
    width: 33.33333% !important;
  }

  .xl\\:w-2\\/3{
    width: 66.66667% !important;
  }

  .xl\\:w-1\\/4{
    width: 25% !important;
  }

  .xl\\:w-3\\/4{
    width: 75% !important;
  }

  .xl\\:w-1\\/5{
    width: 20% !important;
  }

  .xl\\:w-2\\/5{
    width: 40% !important;
  }

  .xl\\:w-3\\/5{
    width: 60% !important;
  }

  .xl\\:w-4\\/5{
    width: 80% !important;
  }

  .xl\\:w-1\\/6{
    width: 16.66667% !important;
  }

  .xl\\:w-5\\/6{
    width: 83.33333% !important;
  }

  .xl\\:w-1\\/12{
    width: 8.33333% !important;
  }

  .xl\\:w-2\\/12{
    width: 16.66667% !important;
  }

  .xl\\:w-3\\/12{
    width: 25% !important;
  }

  .xl\\:w-4\\/12{
    width: 33.33333% !important;
  }

  .xl\\:w-5\\/12{
    width: 41.66667% !important;
  }

  .xl\\:w-6\\/12{
    width: 50% !important;
  }

  .xl\\:w-7\\/12{
    width: 58.33333% !important;
  }

  .xl\\:w-8\\/12{
    width: 66.66667% !important;
  }

  .xl\\:w-9\\/12{
    width: 75% !important;
  }

  .xl\\:w-10\\/12{
    width: 83.33333% !important;
  }

  .xl\\:w-11\\/12{
    width: 91.66667% !important;
  }

  .xl\\:w-full{
    width: 100% !important;
  }

  .xl\\:w-screen{
    width: 100vw !important;
  }

  .xl\\:z-0{
    z-index: 0 !important;
  }

  .xl\\:z-10{
    z-index: 10 !important;
  }

  .xl\\:z-20{
    z-index: 20 !important;
  }

  .xl\\:z-30{
    z-index: 30 !important;
  }

  .xl\\:z-40{
    z-index: 40 !important;
  }

  .xl\\:z-50{
    z-index: 50 !important;
  }

  .xl\\:z-auto{
    z-index: auto !important;
  }

  .xl\\:gap-0{
    grid-gap: 0 !important;
    gap: 0 !important;
  }

  .xl\\:gap-1{
    grid-gap: 0.25rem !important;
    gap: 0.25rem !important;
  }

  .xl\\:gap-2{
    grid-gap: 0.5rem !important;
    gap: 0.5rem !important;
  }

  .xl\\:gap-3{
    grid-gap: 0.75rem !important;
    gap: 0.75rem !important;
  }

  .xl\\:gap-4{
    grid-gap: 1rem !important;
    gap: 1rem !important;
  }

  .xl\\:gap-5{
    grid-gap: 1.25rem !important;
    gap: 1.25rem !important;
  }

  .xl\\:gap-6{
    grid-gap: 1.5rem !important;
    gap: 1.5rem !important;
  }

  .xl\\:gap-8{
    grid-gap: 2rem !important;
    gap: 2rem !important;
  }

  .xl\\:gap-10{
    grid-gap: 2.5rem !important;
    gap: 2.5rem !important;
  }

  .xl\\:gap-12{
    grid-gap: 3rem !important;
    gap: 3rem !important;
  }

  .xl\\:gap-16{
    grid-gap: 4rem !important;
    gap: 4rem !important;
  }

  .xl\\:gap-20{
    grid-gap: 5rem !important;
    gap: 5rem !important;
  }

  .xl\\:gap-24{
    grid-gap: 6rem !important;
    gap: 6rem !important;
  }

  .xl\\:gap-32{
    grid-gap: 8rem !important;
    gap: 8rem !important;
  }

  .xl\\:gap-40{
    grid-gap: 10rem !important;
    gap: 10rem !important;
  }

  .xl\\:gap-48{
    grid-gap: 12rem !important;
    gap: 12rem !important;
  }

  .xl\\:gap-56{
    grid-gap: 14rem !important;
    gap: 14rem !important;
  }

  .xl\\:gap-64{
    grid-gap: 16rem !important;
    gap: 16rem !important;
  }

  .xl\\:gap-px{
    grid-gap: 1px !important;
    gap: 1px !important;
  }

  .xl\\:col-gap-0{
    grid-column-gap: 0 !important;
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .xl\\:col-gap-1{
    grid-column-gap: 0.25rem !important;
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .xl\\:col-gap-2{
    grid-column-gap: 0.5rem !important;
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .xl\\:col-gap-3{
    grid-column-gap: 0.75rem !important;
    -moz-column-gap: 0.75rem !important;
         column-gap: 0.75rem !important;
  }

  .xl\\:col-gap-4{
    grid-column-gap: 1rem !important;
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .xl\\:col-gap-5{
    grid-column-gap: 1.25rem !important;
    -moz-column-gap: 1.25rem !important;
         column-gap: 1.25rem !important;
  }

  .xl\\:col-gap-6{
    grid-column-gap: 1.5rem !important;
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .xl\\:col-gap-8{
    grid-column-gap: 2rem !important;
    -moz-column-gap: 2rem !important;
         column-gap: 2rem !important;
  }

  .xl\\:col-gap-10{
    grid-column-gap: 2.5rem !important;
    -moz-column-gap: 2.5rem !important;
         column-gap: 2.5rem !important;
  }

  .xl\\:col-gap-12{
    grid-column-gap: 3rem !important;
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  .xl\\:col-gap-16{
    grid-column-gap: 4rem !important;
    -moz-column-gap: 4rem !important;
         column-gap: 4rem !important;
  }

  .xl\\:col-gap-20{
    grid-column-gap: 5rem !important;
    -moz-column-gap: 5rem !important;
         column-gap: 5rem !important;
  }

  .xl\\:col-gap-24{
    grid-column-gap: 6rem !important;
    -moz-column-gap: 6rem !important;
         column-gap: 6rem !important;
  }

  .xl\\:col-gap-32{
    grid-column-gap: 8rem !important;
    -moz-column-gap: 8rem !important;
         column-gap: 8rem !important;
  }

  .xl\\:col-gap-40{
    grid-column-gap: 10rem !important;
    -moz-column-gap: 10rem !important;
         column-gap: 10rem !important;
  }

  .xl\\:col-gap-48{
    grid-column-gap: 12rem !important;
    -moz-column-gap: 12rem !important;
         column-gap: 12rem !important;
  }

  .xl\\:col-gap-56{
    grid-column-gap: 14rem !important;
    -moz-column-gap: 14rem !important;
         column-gap: 14rem !important;
  }

  .xl\\:col-gap-64{
    grid-column-gap: 16rem !important;
    -moz-column-gap: 16rem !important;
         column-gap: 16rem !important;
  }

  .xl\\:col-gap-px{
    grid-column-gap: 1px !important;
    -moz-column-gap: 1px !important;
         column-gap: 1px !important;
  }

  .xl\\:gap-x-0{
    grid-column-gap: 0 !important;
    -moz-column-gap: 0 !important;
         column-gap: 0 !important;
  }

  .xl\\:gap-x-1{
    grid-column-gap: 0.25rem !important;
    -moz-column-gap: 0.25rem !important;
         column-gap: 0.25rem !important;
  }

  .xl\\:gap-x-2{
    grid-column-gap: 0.5rem !important;
    -moz-column-gap: 0.5rem !important;
         column-gap: 0.5rem !important;
  }

  .xl\\:gap-x-3{
    grid-column-gap: 0.75rem !important;
    -moz-column-gap: 0.75rem !important;
         column-gap: 0.75rem !important;
  }

  .xl\\:gap-x-4{
    grid-column-gap: 1rem !important;
    -moz-column-gap: 1rem !important;
         column-gap: 1rem !important;
  }

  .xl\\:gap-x-5{
    grid-column-gap: 1.25rem !important;
    -moz-column-gap: 1.25rem !important;
         column-gap: 1.25rem !important;
  }

  .xl\\:gap-x-6{
    grid-column-gap: 1.5rem !important;
    -moz-column-gap: 1.5rem !important;
         column-gap: 1.5rem !important;
  }

  .xl\\:gap-x-8{
    grid-column-gap: 2rem !important;
    -moz-column-gap: 2rem !important;
         column-gap: 2rem !important;
  }

  .xl\\:gap-x-10{
    grid-column-gap: 2.5rem !important;
    -moz-column-gap: 2.5rem !important;
         column-gap: 2.5rem !important;
  }

  .xl\\:gap-x-12{
    grid-column-gap: 3rem !important;
    -moz-column-gap: 3rem !important;
         column-gap: 3rem !important;
  }

  .xl\\:gap-x-16{
    grid-column-gap: 4rem !important;
    -moz-column-gap: 4rem !important;
         column-gap: 4rem !important;
  }

  .xl\\:gap-x-20{
    grid-column-gap: 5rem !important;
    -moz-column-gap: 5rem !important;
         column-gap: 5rem !important;
  }

  .xl\\:gap-x-24{
    grid-column-gap: 6rem !important;
    -moz-column-gap: 6rem !important;
         column-gap: 6rem !important;
  }

  .xl\\:gap-x-32{
    grid-column-gap: 8rem !important;
    -moz-column-gap: 8rem !important;
         column-gap: 8rem !important;
  }

  .xl\\:gap-x-40{
    grid-column-gap: 10rem !important;
    -moz-column-gap: 10rem !important;
         column-gap: 10rem !important;
  }

  .xl\\:gap-x-48{
    grid-column-gap: 12rem !important;
    -moz-column-gap: 12rem !important;
         column-gap: 12rem !important;
  }

  .xl\\:gap-x-56{
    grid-column-gap: 14rem !important;
    -moz-column-gap: 14rem !important;
         column-gap: 14rem !important;
  }

  .xl\\:gap-x-64{
    grid-column-gap: 16rem !important;
    -moz-column-gap: 16rem !important;
         column-gap: 16rem !important;
  }

  .xl\\:gap-x-px{
    grid-column-gap: 1px !important;
    -moz-column-gap: 1px !important;
         column-gap: 1px !important;
  }

  .xl\\:row-gap-0{
    grid-row-gap: 0 !important;
    row-gap: 0 !important;
  }

  .xl\\:row-gap-1{
    grid-row-gap: 0.25rem !important;
    row-gap: 0.25rem !important;
  }

  .xl\\:row-gap-2{
    grid-row-gap: 0.5rem !important;
    row-gap: 0.5rem !important;
  }

  .xl\\:row-gap-3{
    grid-row-gap: 0.75rem !important;
    row-gap: 0.75rem !important;
  }

  .xl\\:row-gap-4{
    grid-row-gap: 1rem !important;
    row-gap: 1rem !important;
  }

  .xl\\:row-gap-5{
    grid-row-gap: 1.25rem !important;
    row-gap: 1.25rem !important;
  }

  .xl\\:row-gap-6{
    grid-row-gap: 1.5rem !important;
    row-gap: 1.5rem !important;
  }

  .xl\\:row-gap-8{
    grid-row-gap: 2rem !important;
    row-gap: 2rem !important;
  }

  .xl\\:row-gap-10{
    grid-row-gap: 2.5rem !important;
    row-gap: 2.5rem !important;
  }

  .xl\\:row-gap-12{
    grid-row-gap: 3rem !important;
    row-gap: 3rem !important;
  }

  .xl\\:row-gap-16{
    grid-row-gap: 4rem !important;
    row-gap: 4rem !important;
  }

  .xl\\:row-gap-20{
    grid-row-gap: 5rem !important;
    row-gap: 5rem !important;
  }

  .xl\\:row-gap-24{
    grid-row-gap: 6rem !important;
    row-gap: 6rem !important;
  }

  .xl\\:row-gap-32{
    grid-row-gap: 8rem !important;
    row-gap: 8rem !important;
  }

  .xl\\:row-gap-40{
    grid-row-gap: 10rem !important;
    row-gap: 10rem !important;
  }

  .xl\\:row-gap-48{
    grid-row-gap: 12rem !important;
    row-gap: 12rem !important;
  }

  .xl\\:row-gap-56{
    grid-row-gap: 14rem !important;
    row-gap: 14rem !important;
  }

  .xl\\:row-gap-64{
    grid-row-gap: 16rem !important;
    row-gap: 16rem !important;
  }

  .xl\\:row-gap-px{
    grid-row-gap: 1px !important;
    row-gap: 1px !important;
  }

  .xl\\:gap-y-0{
    grid-row-gap: 0 !important;
    row-gap: 0 !important;
  }

  .xl\\:gap-y-1{
    grid-row-gap: 0.25rem !important;
    row-gap: 0.25rem !important;
  }

  .xl\\:gap-y-2{
    grid-row-gap: 0.5rem !important;
    row-gap: 0.5rem !important;
  }

  .xl\\:gap-y-3{
    grid-row-gap: 0.75rem !important;
    row-gap: 0.75rem !important;
  }

  .xl\\:gap-y-4{
    grid-row-gap: 1rem !important;
    row-gap: 1rem !important;
  }

  .xl\\:gap-y-5{
    grid-row-gap: 1.25rem !important;
    row-gap: 1.25rem !important;
  }

  .xl\\:gap-y-6{
    grid-row-gap: 1.5rem !important;
    row-gap: 1.5rem !important;
  }

  .xl\\:gap-y-8{
    grid-row-gap: 2rem !important;
    row-gap: 2rem !important;
  }

  .xl\\:gap-y-10{
    grid-row-gap: 2.5rem !important;
    row-gap: 2.5rem !important;
  }

  .xl\\:gap-y-12{
    grid-row-gap: 3rem !important;
    row-gap: 3rem !important;
  }

  .xl\\:gap-y-16{
    grid-row-gap: 4rem !important;
    row-gap: 4rem !important;
  }

  .xl\\:gap-y-20{
    grid-row-gap: 5rem !important;
    row-gap: 5rem !important;
  }

  .xl\\:gap-y-24{
    grid-row-gap: 6rem !important;
    row-gap: 6rem !important;
  }

  .xl\\:gap-y-32{
    grid-row-gap: 8rem !important;
    row-gap: 8rem !important;
  }

  .xl\\:gap-y-40{
    grid-row-gap: 10rem !important;
    row-gap: 10rem !important;
  }

  .xl\\:gap-y-48{
    grid-row-gap: 12rem !important;
    row-gap: 12rem !important;
  }

  .xl\\:gap-y-56{
    grid-row-gap: 14rem !important;
    row-gap: 14rem !important;
  }

  .xl\\:gap-y-64{
    grid-row-gap: 16rem !important;
    row-gap: 16rem !important;
  }

  .xl\\:gap-y-px{
    grid-row-gap: 1px !important;
    row-gap: 1px !important;
  }

  .xl\\:grid-flow-row{
    grid-auto-flow: row !important;
  }

  .xl\\:grid-flow-col{
    grid-auto-flow: column !important;
  }

  .xl\\:grid-flow-row-dense{
    grid-auto-flow: row dense !important;
  }

  .xl\\:grid-flow-col-dense{
    grid-auto-flow: column dense !important;
  }

  .xl\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-cols-none{
    grid-template-columns: none !important;
  }

  .xl\\:auto-cols-auto{
    grid-auto-columns: auto !important;
  }

  .xl\\:auto-cols-min{
    grid-auto-columns: min-content !important;
  }

  .xl\\:auto-cols-max{
    grid-auto-columns: max-content !important;
  }

  .xl\\:auto-cols-fr{
    grid-auto-columns: minmax(0, 1fr) !important;
  }

  .xl\\:col-auto{
    grid-column: auto !important;
  }

  .xl\\:col-span-1{
    grid-column: span 1 / span 1 !important;
  }

  .xl\\:col-span-2{
    grid-column: span 2 / span 2 !important;
  }

  .xl\\:col-span-3{
    grid-column: span 3 / span 3 !important;
  }

  .xl\\:col-span-4{
    grid-column: span 4 / span 4 !important;
  }

  .xl\\:col-span-5{
    grid-column: span 5 / span 5 !important;
  }

  .xl\\:col-span-6{
    grid-column: span 6 / span 6 !important;
  }

  .xl\\:col-span-7{
    grid-column: span 7 / span 7 !important;
  }

  .xl\\:col-span-8{
    grid-column: span 8 / span 8 !important;
  }

  .xl\\:col-span-9{
    grid-column: span 9 / span 9 !important;
  }

  .xl\\:col-span-10{
    grid-column: span 10 / span 10 !important;
  }

  .xl\\:col-span-11{
    grid-column: span 11 / span 11 !important;
  }

  .xl\\:col-span-12{
    grid-column: span 12 / span 12 !important;
  }

  .xl\\:col-span-full{
    grid-column: 1 / -1 !important;
  }

  .xl\\:col-start-1{
    grid-column-start: 1 !important;
  }

  .xl\\:col-start-2{
    grid-column-start: 2 !important;
  }

  .xl\\:col-start-3{
    grid-column-start: 3 !important;
  }

  .xl\\:col-start-4{
    grid-column-start: 4 !important;
  }

  .xl\\:col-start-5{
    grid-column-start: 5 !important;
  }

  .xl\\:col-start-6{
    grid-column-start: 6 !important;
  }

  .xl\\:col-start-7{
    grid-column-start: 7 !important;
  }

  .xl\\:col-start-8{
    grid-column-start: 8 !important;
  }

  .xl\\:col-start-9{
    grid-column-start: 9 !important;
  }

  .xl\\:col-start-10{
    grid-column-start: 10 !important;
  }

  .xl\\:col-start-11{
    grid-column-start: 11 !important;
  }

  .xl\\:col-start-12{
    grid-column-start: 12 !important;
  }

  .xl\\:col-start-13{
    grid-column-start: 13 !important;
  }

  .xl\\:col-start-auto{
    grid-column-start: auto !important;
  }

  .xl\\:col-end-1{
    grid-column-end: 1 !important;
  }

  .xl\\:col-end-2{
    grid-column-end: 2 !important;
  }

  .xl\\:col-end-3{
    grid-column-end: 3 !important;
  }

  .xl\\:col-end-4{
    grid-column-end: 4 !important;
  }

  .xl\\:col-end-5{
    grid-column-end: 5 !important;
  }

  .xl\\:col-end-6{
    grid-column-end: 6 !important;
  }

  .xl\\:col-end-7{
    grid-column-end: 7 !important;
  }

  .xl\\:col-end-8{
    grid-column-end: 8 !important;
  }

  .xl\\:col-end-9{
    grid-column-end: 9 !important;
  }

  .xl\\:col-end-10{
    grid-column-end: 10 !important;
  }

  .xl\\:col-end-11{
    grid-column-end: 11 !important;
  }

  .xl\\:col-end-12{
    grid-column-end: 12 !important;
  }

  .xl\\:col-end-13{
    grid-column-end: 13 !important;
  }

  .xl\\:col-end-auto{
    grid-column-end: auto !important;
  }

  .xl\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-rows-2{
    grid-template-rows: repeat(2, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-rows-3{
    grid-template-rows: repeat(3, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-rows-4{
    grid-template-rows: repeat(4, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-rows-5{
    grid-template-rows: repeat(5, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-rows-6{
    grid-template-rows: repeat(6, minmax(0, 1fr)) !important;
  }

  .xl\\:grid-rows-none{
    grid-template-rows: none !important;
  }

  .xl\\:auto-rows-auto{
    grid-auto-rows: auto !important;
  }

  .xl\\:auto-rows-min{
    grid-auto-rows: min-content !important;
  }

  .xl\\:auto-rows-max{
    grid-auto-rows: max-content !important;
  }

  .xl\\:auto-rows-fr{
    grid-auto-rows: minmax(0, 1fr) !important;
  }

  .xl\\:row-auto{
    grid-row: auto !important;
  }

  .xl\\:row-span-1{
    grid-row: span 1 / span 1 !important;
  }

  .xl\\:row-span-2{
    grid-row: span 2 / span 2 !important;
  }

  .xl\\:row-span-3{
    grid-row: span 3 / span 3 !important;
  }

  .xl\\:row-span-4{
    grid-row: span 4 / span 4 !important;
  }

  .xl\\:row-span-5{
    grid-row: span 5 / span 5 !important;
  }

  .xl\\:row-span-6{
    grid-row: span 6 / span 6 !important;
  }

  .xl\\:row-span-full{
    grid-row: 1 / -1 !important;
  }

  .xl\\:row-start-1{
    grid-row-start: 1 !important;
  }

  .xl\\:row-start-2{
    grid-row-start: 2 !important;
  }

  .xl\\:row-start-3{
    grid-row-start: 3 !important;
  }

  .xl\\:row-start-4{
    grid-row-start: 4 !important;
  }

  .xl\\:row-start-5{
    grid-row-start: 5 !important;
  }

  .xl\\:row-start-6{
    grid-row-start: 6 !important;
  }

  .xl\\:row-start-7{
    grid-row-start: 7 !important;
  }

  .xl\\:row-start-auto{
    grid-row-start: auto !important;
  }

  .xl\\:row-end-1{
    grid-row-end: 1 !important;
  }

  .xl\\:row-end-2{
    grid-row-end: 2 !important;
  }

  .xl\\:row-end-3{
    grid-row-end: 3 !important;
  }

  .xl\\:row-end-4{
    grid-row-end: 4 !important;
  }

  .xl\\:row-end-5{
    grid-row-end: 5 !important;
  }

  .xl\\:row-end-6{
    grid-row-end: 6 !important;
  }

  .xl\\:row-end-7{
    grid-row-end: 7 !important;
  }

  .xl\\:row-end-auto{
    grid-row-end: auto !important;
  }

  .xl\\:transform{
    --transform-translate-x: 0 !important;
    --transform-translate-y: 0 !important;
    --transform-rotate: 0 !important;
    --transform-skew-x: 0 !important;
    --transform-skew-y: 0 !important;
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  [dir] .xl\\:transform{
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y)) !important;
  }

  [dir] .xl\\:transform-none{
    transform: none !important;
  }

  [dir] .xl\\:origin-center{
    transform-origin: center !important;
  }

  [dir] .xl\\:origin-top{
    transform-origin: top !important;
  }

  [dir=ltr] .xl\\:origin-top-right{
    transform-origin: top right !important;
  }

  [dir=rtl] .xl\\:origin-top-right{
    transform-origin: top left !important;
  }

  [dir=ltr] .xl\\:origin-right{
    transform-origin: right !important;
  }

  [dir=rtl] .xl\\:origin-right{
    transform-origin: left !important;
  }

  [dir=ltr] .xl\\:origin-bottom-right{
    transform-origin: bottom right !important;
  }

  [dir=rtl] .xl\\:origin-bottom-right{
    transform-origin: bottom left !important;
  }

  [dir] .xl\\:origin-bottom{
    transform-origin: bottom !important;
  }

  [dir=ltr] .xl\\:origin-bottom-left{
    transform-origin: bottom left !important;
  }

  [dir=rtl] .xl\\:origin-bottom-left{
    transform-origin: bottom right !important;
  }

  [dir=ltr] .xl\\:origin-left{
    transform-origin: left !important;
  }

  [dir=rtl] .xl\\:origin-left{
    transform-origin: right !important;
  }

  [dir=ltr] .xl\\:origin-top-left{
    transform-origin: top left !important;
  }

  [dir=rtl] .xl\\:origin-top-left{
    transform-origin: top right !important;
  }

  .xl\\:scale-0{
    --transform-scale-x: 0 !important;
    --transform-scale-y: 0 !important;
  }

  .xl\\:scale-50{
    --transform-scale-x: .5 !important;
    --transform-scale-y: .5 !important;
  }

  .xl\\:scale-75{
    --transform-scale-x: .75 !important;
    --transform-scale-y: .75 !important;
  }

  .xl\\:scale-90{
    --transform-scale-x: .9 !important;
    --transform-scale-y: .9 !important;
  }

  .xl\\:scale-95{
    --transform-scale-x: .95 !important;
    --transform-scale-y: .95 !important;
  }

  .xl\\:scale-100{
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  .xl\\:scale-105{
    --transform-scale-x: 1.05 !important;
    --transform-scale-y: 1.05 !important;
  }

  .xl\\:scale-110{
    --transform-scale-x: 1.1 !important;
    --transform-scale-y: 1.1 !important;
  }

  .xl\\:scale-125{
    --transform-scale-x: 1.25 !important;
    --transform-scale-y: 1.25 !important;
  }

  .xl\\:scale-150{
    --transform-scale-x: 1.5 !important;
    --transform-scale-y: 1.5 !important;
  }

  .xl\\:scale-x-0{
    --transform-scale-x: 0 !important;
  }

  .xl\\:scale-x-50{
    --transform-scale-x: .5 !important;
  }

  .xl\\:scale-x-75{
    --transform-scale-x: .75 !important;
  }

  .xl\\:scale-x-90{
    --transform-scale-x: .9 !important;
  }

  .xl\\:scale-x-95{
    --transform-scale-x: .95 !important;
  }

  .xl\\:scale-x-100{
    --transform-scale-x: 1 !important;
  }

  .xl\\:scale-x-105{
    --transform-scale-x: 1.05 !important;
  }

  .xl\\:scale-x-110{
    --transform-scale-x: 1.1 !important;
  }

  .xl\\:scale-x-125{
    --transform-scale-x: 1.25 !important;
  }

  .xl\\:scale-x-150{
    --transform-scale-x: 1.5 !important;
  }

  .xl\\:scale-y-0{
    --transform-scale-y: 0 !important;
  }

  .xl\\:scale-y-50{
    --transform-scale-y: .5 !important;
  }

  .xl\\:scale-y-75{
    --transform-scale-y: .75 !important;
  }

  .xl\\:scale-y-90{
    --transform-scale-y: .9 !important;
  }

  .xl\\:scale-y-95{
    --transform-scale-y: .95 !important;
  }

  .xl\\:scale-y-100{
    --transform-scale-y: 1 !important;
  }

  .xl\\:scale-y-105{
    --transform-scale-y: 1.05 !important;
  }

  .xl\\:scale-y-110{
    --transform-scale-y: 1.1 !important;
  }

  .xl\\:scale-y-125{
    --transform-scale-y: 1.25 !important;
  }

  .xl\\:scale-y-150{
    --transform-scale-y: 1.5 !important;
  }

  .xl\\:hover\\:scale-0:hover{
    --transform-scale-x: 0 !important;
    --transform-scale-y: 0 !important;
  }

  .xl\\:hover\\:scale-50:hover{
    --transform-scale-x: .5 !important;
    --transform-scale-y: .5 !important;
  }

  .xl\\:hover\\:scale-75:hover{
    --transform-scale-x: .75 !important;
    --transform-scale-y: .75 !important;
  }

  .xl\\:hover\\:scale-90:hover{
    --transform-scale-x: .9 !important;
    --transform-scale-y: .9 !important;
  }

  .xl\\:hover\\:scale-95:hover{
    --transform-scale-x: .95 !important;
    --transform-scale-y: .95 !important;
  }

  .xl\\:hover\\:scale-100:hover{
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  .xl\\:hover\\:scale-105:hover{
    --transform-scale-x: 1.05 !important;
    --transform-scale-y: 1.05 !important;
  }

  .xl\\:hover\\:scale-110:hover{
    --transform-scale-x: 1.1 !important;
    --transform-scale-y: 1.1 !important;
  }

  .xl\\:hover\\:scale-125:hover{
    --transform-scale-x: 1.25 !important;
    --transform-scale-y: 1.25 !important;
  }

  .xl\\:hover\\:scale-150:hover{
    --transform-scale-x: 1.5 !important;
    --transform-scale-y: 1.5 !important;
  }

  .xl\\:hover\\:scale-x-0:hover{
    --transform-scale-x: 0 !important;
  }

  .xl\\:hover\\:scale-x-50:hover{
    --transform-scale-x: .5 !important;
  }

  .xl\\:hover\\:scale-x-75:hover{
    --transform-scale-x: .75 !important;
  }

  .xl\\:hover\\:scale-x-90:hover{
    --transform-scale-x: .9 !important;
  }

  .xl\\:hover\\:scale-x-95:hover{
    --transform-scale-x: .95 !important;
  }

  .xl\\:hover\\:scale-x-100:hover{
    --transform-scale-x: 1 !important;
  }

  .xl\\:hover\\:scale-x-105:hover{
    --transform-scale-x: 1.05 !important;
  }

  .xl\\:hover\\:scale-x-110:hover{
    --transform-scale-x: 1.1 !important;
  }

  .xl\\:hover\\:scale-x-125:hover{
    --transform-scale-x: 1.25 !important;
  }

  .xl\\:hover\\:scale-x-150:hover{
    --transform-scale-x: 1.5 !important;
  }

  .xl\\:hover\\:scale-y-0:hover{
    --transform-scale-y: 0 !important;
  }

  .xl\\:hover\\:scale-y-50:hover{
    --transform-scale-y: .5 !important;
  }

  .xl\\:hover\\:scale-y-75:hover{
    --transform-scale-y: .75 !important;
  }

  .xl\\:hover\\:scale-y-90:hover{
    --transform-scale-y: .9 !important;
  }

  .xl\\:hover\\:scale-y-95:hover{
    --transform-scale-y: .95 !important;
  }

  .xl\\:hover\\:scale-y-100:hover{
    --transform-scale-y: 1 !important;
  }

  .xl\\:hover\\:scale-y-105:hover{
    --transform-scale-y: 1.05 !important;
  }

  .xl\\:hover\\:scale-y-110:hover{
    --transform-scale-y: 1.1 !important;
  }

  .xl\\:hover\\:scale-y-125:hover{
    --transform-scale-y: 1.25 !important;
  }

  .xl\\:hover\\:scale-y-150:hover{
    --transform-scale-y: 1.5 !important;
  }

  .xl\\:focus\\:scale-0:focus{
    --transform-scale-x: 0 !important;
    --transform-scale-y: 0 !important;
  }

  .xl\\:focus\\:scale-50:focus{
    --transform-scale-x: .5 !important;
    --transform-scale-y: .5 !important;
  }

  .xl\\:focus\\:scale-75:focus{
    --transform-scale-x: .75 !important;
    --transform-scale-y: .75 !important;
  }

  .xl\\:focus\\:scale-90:focus{
    --transform-scale-x: .9 !important;
    --transform-scale-y: .9 !important;
  }

  .xl\\:focus\\:scale-95:focus{
    --transform-scale-x: .95 !important;
    --transform-scale-y: .95 !important;
  }

  .xl\\:focus\\:scale-100:focus{
    --transform-scale-x: 1 !important;
    --transform-scale-y: 1 !important;
  }

  .xl\\:focus\\:scale-105:focus{
    --transform-scale-x: 1.05 !important;
    --transform-scale-y: 1.05 !important;
  }

  .xl\\:focus\\:scale-110:focus{
    --transform-scale-x: 1.1 !important;
    --transform-scale-y: 1.1 !important;
  }

  .xl\\:focus\\:scale-125:focus{
    --transform-scale-x: 1.25 !important;
    --transform-scale-y: 1.25 !important;
  }

  .xl\\:focus\\:scale-150:focus{
    --transform-scale-x: 1.5 !important;
    --transform-scale-y: 1.5 !important;
  }

  .xl\\:focus\\:scale-x-0:focus{
    --transform-scale-x: 0 !important;
  }

  .xl\\:focus\\:scale-x-50:focus{
    --transform-scale-x: .5 !important;
  }

  .xl\\:focus\\:scale-x-75:focus{
    --transform-scale-x: .75 !important;
  }

  .xl\\:focus\\:scale-x-90:focus{
    --transform-scale-x: .9 !important;
  }

  .xl\\:focus\\:scale-x-95:focus{
    --transform-scale-x: .95 !important;
  }

  .xl\\:focus\\:scale-x-100:focus{
    --transform-scale-x: 1 !important;
  }

  .xl\\:focus\\:scale-x-105:focus{
    --transform-scale-x: 1.05 !important;
  }

  .xl\\:focus\\:scale-x-110:focus{
    --transform-scale-x: 1.1 !important;
  }

  .xl\\:focus\\:scale-x-125:focus{
    --transform-scale-x: 1.25 !important;
  }

  .xl\\:focus\\:scale-x-150:focus{
    --transform-scale-x: 1.5 !important;
  }

  .xl\\:focus\\:scale-y-0:focus{
    --transform-scale-y: 0 !important;
  }

  .xl\\:focus\\:scale-y-50:focus{
    --transform-scale-y: .5 !important;
  }

  .xl\\:focus\\:scale-y-75:focus{
    --transform-scale-y: .75 !important;
  }

  .xl\\:focus\\:scale-y-90:focus{
    --transform-scale-y: .9 !important;
  }

  .xl\\:focus\\:scale-y-95:focus{
    --transform-scale-y: .95 !important;
  }

  .xl\\:focus\\:scale-y-100:focus{
    --transform-scale-y: 1 !important;
  }

  .xl\\:focus\\:scale-y-105:focus{
    --transform-scale-y: 1.05 !important;
  }

  .xl\\:focus\\:scale-y-110:focus{
    --transform-scale-y: 1.1 !important;
  }

  .xl\\:focus\\:scale-y-125:focus{
    --transform-scale-y: 1.25 !important;
  }

  .xl\\:focus\\:scale-y-150:focus{
    --transform-scale-y: 1.5 !important;
  }

  .xl\\:rotate-0{
    --transform-rotate: 0 !important;
  }

  .xl\\:rotate-1{
    --transform-rotate: 1deg !important;
  }

  .xl\\:rotate-2{
    --transform-rotate: 2deg !important;
  }

  .xl\\:rotate-3{
    --transform-rotate: 3deg !important;
  }

  .xl\\:rotate-6{
    --transform-rotate: 6deg !important;
  }

  .xl\\:rotate-12{
    --transform-rotate: 12deg !important;
  }

  .xl\\:rotate-45{
    --transform-rotate: 45deg !important;
  }

  .xl\\:rotate-90{
    --transform-rotate: 90deg !important;
  }

  .xl\\:rotate-180{
    --transform-rotate: 180deg !important;
  }

  .xl\\:-rotate-180{
    --transform-rotate: -180deg !important;
  }

  .xl\\:-rotate-90{
    --transform-rotate: -90deg !important;
  }

  .xl\\:-rotate-45{
    --transform-rotate: -45deg !important;
  }

  .xl\\:-rotate-12{
    --transform-rotate: -12deg !important;
  }

  .xl\\:-rotate-6{
    --transform-rotate: -6deg !important;
  }

  .xl\\:-rotate-3{
    --transform-rotate: -3deg !important;
  }

  .xl\\:-rotate-2{
    --transform-rotate: -2deg !important;
  }

  .xl\\:-rotate-1{
    --transform-rotate: -1deg !important;
  }

  .xl\\:hover\\:rotate-0:hover{
    --transform-rotate: 0 !important;
  }

  .xl\\:hover\\:rotate-1:hover{
    --transform-rotate: 1deg !important;
  }

  .xl\\:hover\\:rotate-2:hover{
    --transform-rotate: 2deg !important;
  }

  .xl\\:hover\\:rotate-3:hover{
    --transform-rotate: 3deg !important;
  }

  .xl\\:hover\\:rotate-6:hover{
    --transform-rotate: 6deg !important;
  }

  .xl\\:hover\\:rotate-12:hover{
    --transform-rotate: 12deg !important;
  }

  .xl\\:hover\\:rotate-45:hover{
    --transform-rotate: 45deg !important;
  }

  .xl\\:hover\\:rotate-90:hover{
    --transform-rotate: 90deg !important;
  }

  .xl\\:hover\\:rotate-180:hover{
    --transform-rotate: 180deg !important;
  }

  .xl\\:hover\\:-rotate-180:hover{
    --transform-rotate: -180deg !important;
  }

  .xl\\:hover\\:-rotate-90:hover{
    --transform-rotate: -90deg !important;
  }

  .xl\\:hover\\:-rotate-45:hover{
    --transform-rotate: -45deg !important;
  }

  .xl\\:hover\\:-rotate-12:hover{
    --transform-rotate: -12deg !important;
  }

  .xl\\:hover\\:-rotate-6:hover{
    --transform-rotate: -6deg !important;
  }

  .xl\\:hover\\:-rotate-3:hover{
    --transform-rotate: -3deg !important;
  }

  .xl\\:hover\\:-rotate-2:hover{
    --transform-rotate: -2deg !important;
  }

  .xl\\:hover\\:-rotate-1:hover{
    --transform-rotate: -1deg !important;
  }

  .xl\\:focus\\:rotate-0:focus{
    --transform-rotate: 0 !important;
  }

  .xl\\:focus\\:rotate-1:focus{
    --transform-rotate: 1deg !important;
  }

  .xl\\:focus\\:rotate-2:focus{
    --transform-rotate: 2deg !important;
  }

  .xl\\:focus\\:rotate-3:focus{
    --transform-rotate: 3deg !important;
  }

  .xl\\:focus\\:rotate-6:focus{
    --transform-rotate: 6deg !important;
  }

  .xl\\:focus\\:rotate-12:focus{
    --transform-rotate: 12deg !important;
  }

  .xl\\:focus\\:rotate-45:focus{
    --transform-rotate: 45deg !important;
  }

  .xl\\:focus\\:rotate-90:focus{
    --transform-rotate: 90deg !important;
  }

  .xl\\:focus\\:rotate-180:focus{
    --transform-rotate: 180deg !important;
  }

  .xl\\:focus\\:-rotate-180:focus{
    --transform-rotate: -180deg !important;
  }

  .xl\\:focus\\:-rotate-90:focus{
    --transform-rotate: -90deg !important;
  }

  .xl\\:focus\\:-rotate-45:focus{
    --transform-rotate: -45deg !important;
  }

  .xl\\:focus\\:-rotate-12:focus{
    --transform-rotate: -12deg !important;
  }

  .xl\\:focus\\:-rotate-6:focus{
    --transform-rotate: -6deg !important;
  }

  .xl\\:focus\\:-rotate-3:focus{
    --transform-rotate: -3deg !important;
  }

  .xl\\:focus\\:-rotate-2:focus{
    --transform-rotate: -2deg !important;
  }

  .xl\\:focus\\:-rotate-1:focus{
    --transform-rotate: -1deg !important;
  }

  .xl\\:translate-x-0{
    --transform-translate-x: 0 !important;
  }

  .xl\\:translate-x-1{
    --transform-translate-x: 0.25rem !important;
  }

  .xl\\:translate-x-2{
    --transform-translate-x: 0.5rem !important;
  }

  .xl\\:translate-x-3{
    --transform-translate-x: 0.75rem !important;
  }

  .xl\\:translate-x-4{
    --transform-translate-x: 1rem !important;
  }

  .xl\\:translate-x-5{
    --transform-translate-x: 1.25rem !important;
  }

  .xl\\:translate-x-6{
    --transform-translate-x: 1.5rem !important;
  }

  .xl\\:translate-x-8{
    --transform-translate-x: 2rem !important;
  }

  .xl\\:translate-x-10{
    --transform-translate-x: 2.5rem !important;
  }

  .xl\\:translate-x-12{
    --transform-translate-x: 3rem !important;
  }

  .xl\\:translate-x-16{
    --transform-translate-x: 4rem !important;
  }

  .xl\\:translate-x-20{
    --transform-translate-x: 5rem !important;
  }

  .xl\\:translate-x-24{
    --transform-translate-x: 6rem !important;
  }

  .xl\\:translate-x-32{
    --transform-translate-x: 8rem !important;
  }

  .xl\\:translate-x-40{
    --transform-translate-x: 10rem !important;
  }

  .xl\\:translate-x-48{
    --transform-translate-x: 12rem !important;
  }

  .xl\\:translate-x-56{
    --transform-translate-x: 14rem !important;
  }

  .xl\\:translate-x-64{
    --transform-translate-x: 16rem !important;
  }

  .xl\\:translate-x-px{
    --transform-translate-x: 1px !important;
  }

  .xl\\:-translate-x-1{
    --transform-translate-x: -0.25rem !important;
  }

  .xl\\:-translate-x-2{
    --transform-translate-x: -0.5rem !important;
  }

  .xl\\:-translate-x-3{
    --transform-translate-x: -0.75rem !important;
  }

  .xl\\:-translate-x-4{
    --transform-translate-x: -1rem !important;
  }

  .xl\\:-translate-x-5{
    --transform-translate-x: -1.25rem !important;
  }

  .xl\\:-translate-x-6{
    --transform-translate-x: -1.5rem !important;
  }

  .xl\\:-translate-x-8{
    --transform-translate-x: -2rem !important;
  }

  .xl\\:-translate-x-10{
    --transform-translate-x: -2.5rem !important;
  }

  .xl\\:-translate-x-12{
    --transform-translate-x: -3rem !important;
  }

  .xl\\:-translate-x-16{
    --transform-translate-x: -4rem !important;
  }

  .xl\\:-translate-x-20{
    --transform-translate-x: -5rem !important;
  }

  .xl\\:-translate-x-24{
    --transform-translate-x: -6rem !important;
  }

  .xl\\:-translate-x-32{
    --transform-translate-x: -8rem !important;
  }

  .xl\\:-translate-x-40{
    --transform-translate-x: -10rem !important;
  }

  .xl\\:-translate-x-48{
    --transform-translate-x: -12rem !important;
  }

  .xl\\:-translate-x-56{
    --transform-translate-x: -14rem !important;
  }

  .xl\\:-translate-x-64{
    --transform-translate-x: -16rem !important;
  }

  .xl\\:-translate-x-px{
    --transform-translate-x: -1px !important;
  }

  .xl\\:-translate-x-full{
    --transform-translate-x: -100% !important;
  }

  .xl\\:-translate-x-1\\/2{
    --transform-translate-x: -50% !important;
  }

  .xl\\:translate-x-1\\/2{
    --transform-translate-x: 50% !important;
  }

  .xl\\:translate-x-full{
    --transform-translate-x: 100% !important;
  }

  .xl\\:translate-y-0{
    --transform-translate-y: 0 !important;
  }

  .xl\\:translate-y-1{
    --transform-translate-y: 0.25rem !important;
  }

  .xl\\:translate-y-2{
    --transform-translate-y: 0.5rem !important;
  }

  .xl\\:translate-y-3{
    --transform-translate-y: 0.75rem !important;
  }

  .xl\\:translate-y-4{
    --transform-translate-y: 1rem !important;
  }

  .xl\\:translate-y-5{
    --transform-translate-y: 1.25rem !important;
  }

  .xl\\:translate-y-6{
    --transform-translate-y: 1.5rem !important;
  }

  .xl\\:translate-y-8{
    --transform-translate-y: 2rem !important;
  }

  .xl\\:translate-y-10{
    --transform-translate-y: 2.5rem !important;
  }

  .xl\\:translate-y-12{
    --transform-translate-y: 3rem !important;
  }

  .xl\\:translate-y-16{
    --transform-translate-y: 4rem !important;
  }

  .xl\\:translate-y-20{
    --transform-translate-y: 5rem !important;
  }

  .xl\\:translate-y-24{
    --transform-translate-y: 6rem !important;
  }

  .xl\\:translate-y-32{
    --transform-translate-y: 8rem !important;
  }

  .xl\\:translate-y-40{
    --transform-translate-y: 10rem !important;
  }

  .xl\\:translate-y-48{
    --transform-translate-y: 12rem !important;
  }

  .xl\\:translate-y-56{
    --transform-translate-y: 14rem !important;
  }

  .xl\\:translate-y-64{
    --transform-translate-y: 16rem !important;
  }

  .xl\\:translate-y-px{
    --transform-translate-y: 1px !important;
  }

  .xl\\:-translate-y-1{
    --transform-translate-y: -0.25rem !important;
  }

  .xl\\:-translate-y-2{
    --transform-translate-y: -0.5rem !important;
  }

  .xl\\:-translate-y-3{
    --transform-translate-y: -0.75rem !important;
  }

  .xl\\:-translate-y-4{
    --transform-translate-y: -1rem !important;
  }

  .xl\\:-translate-y-5{
    --transform-translate-y: -1.25rem !important;
  }

  .xl\\:-translate-y-6{
    --transform-translate-y: -1.5rem !important;
  }

  .xl\\:-translate-y-8{
    --transform-translate-y: -2rem !important;
  }

  .xl\\:-translate-y-10{
    --transform-translate-y: -2.5rem !important;
  }

  .xl\\:-translate-y-12{
    --transform-translate-y: -3rem !important;
  }

  .xl\\:-translate-y-16{
    --transform-translate-y: -4rem !important;
  }

  .xl\\:-translate-y-20{
    --transform-translate-y: -5rem !important;
  }

  .xl\\:-translate-y-24{
    --transform-translate-y: -6rem !important;
  }

  .xl\\:-translate-y-32{
    --transform-translate-y: -8rem !important;
  }

  .xl\\:-translate-y-40{
    --transform-translate-y: -10rem !important;
  }

  .xl\\:-translate-y-48{
    --transform-translate-y: -12rem !important;
  }

  .xl\\:-translate-y-56{
    --transform-translate-y: -14rem !important;
  }

  .xl\\:-translate-y-64{
    --transform-translate-y: -16rem !important;
  }

  .xl\\:-translate-y-px{
    --transform-translate-y: -1px !important;
  }

  .xl\\:-translate-y-full{
    --transform-translate-y: -100% !important;
  }

  .xl\\:-translate-y-1\\/2{
    --transform-translate-y: -50% !important;
  }

  .xl\\:translate-y-1\\/2{
    --transform-translate-y: 50% !important;
  }

  .xl\\:translate-y-full{
    --transform-translate-y: 100% !important;
  }

  .xl\\:hover\\:translate-x-0:hover{
    --transform-translate-x: 0 !important;
  }

  .xl\\:hover\\:translate-x-1:hover{
    --transform-translate-x: 0.25rem !important;
  }

  .xl\\:hover\\:translate-x-2:hover{
    --transform-translate-x: 0.5rem !important;
  }

  .xl\\:hover\\:translate-x-3:hover{
    --transform-translate-x: 0.75rem !important;
  }

  .xl\\:hover\\:translate-x-4:hover{
    --transform-translate-x: 1rem !important;
  }

  .xl\\:hover\\:translate-x-5:hover{
    --transform-translate-x: 1.25rem !important;
  }

  .xl\\:hover\\:translate-x-6:hover{
    --transform-translate-x: 1.5rem !important;
  }

  .xl\\:hover\\:translate-x-8:hover{
    --transform-translate-x: 2rem !important;
  }

  .xl\\:hover\\:translate-x-10:hover{
    --transform-translate-x: 2.5rem !important;
  }

  .xl\\:hover\\:translate-x-12:hover{
    --transform-translate-x: 3rem !important;
  }

  .xl\\:hover\\:translate-x-16:hover{
    --transform-translate-x: 4rem !important;
  }

  .xl\\:hover\\:translate-x-20:hover{
    --transform-translate-x: 5rem !important;
  }

  .xl\\:hover\\:translate-x-24:hover{
    --transform-translate-x: 6rem !important;
  }

  .xl\\:hover\\:translate-x-32:hover{
    --transform-translate-x: 8rem !important;
  }

  .xl\\:hover\\:translate-x-40:hover{
    --transform-translate-x: 10rem !important;
  }

  .xl\\:hover\\:translate-x-48:hover{
    --transform-translate-x: 12rem !important;
  }

  .xl\\:hover\\:translate-x-56:hover{
    --transform-translate-x: 14rem !important;
  }

  .xl\\:hover\\:translate-x-64:hover{
    --transform-translate-x: 16rem !important;
  }

  .xl\\:hover\\:translate-x-px:hover{
    --transform-translate-x: 1px !important;
  }

  .xl\\:hover\\:-translate-x-1:hover{
    --transform-translate-x: -0.25rem !important;
  }

  .xl\\:hover\\:-translate-x-2:hover{
    --transform-translate-x: -0.5rem !important;
  }

  .xl\\:hover\\:-translate-x-3:hover{
    --transform-translate-x: -0.75rem !important;
  }

  .xl\\:hover\\:-translate-x-4:hover{
    --transform-translate-x: -1rem !important;
  }

  .xl\\:hover\\:-translate-x-5:hover{
    --transform-translate-x: -1.25rem !important;
  }

  .xl\\:hover\\:-translate-x-6:hover{
    --transform-translate-x: -1.5rem !important;
  }

  .xl\\:hover\\:-translate-x-8:hover{
    --transform-translate-x: -2rem !important;
  }

  .xl\\:hover\\:-translate-x-10:hover{
    --transform-translate-x: -2.5rem !important;
  }

  .xl\\:hover\\:-translate-x-12:hover{
    --transform-translate-x: -3rem !important;
  }

  .xl\\:hover\\:-translate-x-16:hover{
    --transform-translate-x: -4rem !important;
  }

  .xl\\:hover\\:-translate-x-20:hover{
    --transform-translate-x: -5rem !important;
  }

  .xl\\:hover\\:-translate-x-24:hover{
    --transform-translate-x: -6rem !important;
  }

  .xl\\:hover\\:-translate-x-32:hover{
    --transform-translate-x: -8rem !important;
  }

  .xl\\:hover\\:-translate-x-40:hover{
    --transform-translate-x: -10rem !important;
  }

  .xl\\:hover\\:-translate-x-48:hover{
    --transform-translate-x: -12rem !important;
  }

  .xl\\:hover\\:-translate-x-56:hover{
    --transform-translate-x: -14rem !important;
  }

  .xl\\:hover\\:-translate-x-64:hover{
    --transform-translate-x: -16rem !important;
  }

  .xl\\:hover\\:-translate-x-px:hover{
    --transform-translate-x: -1px !important;
  }

  .xl\\:hover\\:-translate-x-full:hover{
    --transform-translate-x: -100% !important;
  }

  .xl\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x: -50% !important;
  }

  .xl\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x: 50% !important;
  }

  .xl\\:hover\\:translate-x-full:hover{
    --transform-translate-x: 100% !important;
  }

  .xl\\:hover\\:translate-y-0:hover{
    --transform-translate-y: 0 !important;
  }

  .xl\\:hover\\:translate-y-1:hover{
    --transform-translate-y: 0.25rem !important;
  }

  .xl\\:hover\\:translate-y-2:hover{
    --transform-translate-y: 0.5rem !important;
  }

  .xl\\:hover\\:translate-y-3:hover{
    --transform-translate-y: 0.75rem !important;
  }

  .xl\\:hover\\:translate-y-4:hover{
    --transform-translate-y: 1rem !important;
  }

  .xl\\:hover\\:translate-y-5:hover{
    --transform-translate-y: 1.25rem !important;
  }

  .xl\\:hover\\:translate-y-6:hover{
    --transform-translate-y: 1.5rem !important;
  }

  .xl\\:hover\\:translate-y-8:hover{
    --transform-translate-y: 2rem !important;
  }

  .xl\\:hover\\:translate-y-10:hover{
    --transform-translate-y: 2.5rem !important;
  }

  .xl\\:hover\\:translate-y-12:hover{
    --transform-translate-y: 3rem !important;
  }

  .xl\\:hover\\:translate-y-16:hover{
    --transform-translate-y: 4rem !important;
  }

  .xl\\:hover\\:translate-y-20:hover{
    --transform-translate-y: 5rem !important;
  }

  .xl\\:hover\\:translate-y-24:hover{
    --transform-translate-y: 6rem !important;
  }

  .xl\\:hover\\:translate-y-32:hover{
    --transform-translate-y: 8rem !important;
  }

  .xl\\:hover\\:translate-y-40:hover{
    --transform-translate-y: 10rem !important;
  }

  .xl\\:hover\\:translate-y-48:hover{
    --transform-translate-y: 12rem !important;
  }

  .xl\\:hover\\:translate-y-56:hover{
    --transform-translate-y: 14rem !important;
  }

  .xl\\:hover\\:translate-y-64:hover{
    --transform-translate-y: 16rem !important;
  }

  .xl\\:hover\\:translate-y-px:hover{
    --transform-translate-y: 1px !important;
  }

  .xl\\:hover\\:-translate-y-1:hover{
    --transform-translate-y: -0.25rem !important;
  }

  .xl\\:hover\\:-translate-y-2:hover{
    --transform-translate-y: -0.5rem !important;
  }

  .xl\\:hover\\:-translate-y-3:hover{
    --transform-translate-y: -0.75rem !important;
  }

  .xl\\:hover\\:-translate-y-4:hover{
    --transform-translate-y: -1rem !important;
  }

  .xl\\:hover\\:-translate-y-5:hover{
    --transform-translate-y: -1.25rem !important;
  }

  .xl\\:hover\\:-translate-y-6:hover{
    --transform-translate-y: -1.5rem !important;
  }

  .xl\\:hover\\:-translate-y-8:hover{
    --transform-translate-y: -2rem !important;
  }

  .xl\\:hover\\:-translate-y-10:hover{
    --transform-translate-y: -2.5rem !important;
  }

  .xl\\:hover\\:-translate-y-12:hover{
    --transform-translate-y: -3rem !important;
  }

  .xl\\:hover\\:-translate-y-16:hover{
    --transform-translate-y: -4rem !important;
  }

  .xl\\:hover\\:-translate-y-20:hover{
    --transform-translate-y: -5rem !important;
  }

  .xl\\:hover\\:-translate-y-24:hover{
    --transform-translate-y: -6rem !important;
  }

  .xl\\:hover\\:-translate-y-32:hover{
    --transform-translate-y: -8rem !important;
  }

  .xl\\:hover\\:-translate-y-40:hover{
    --transform-translate-y: -10rem !important;
  }

  .xl\\:hover\\:-translate-y-48:hover{
    --transform-translate-y: -12rem !important;
  }

  .xl\\:hover\\:-translate-y-56:hover{
    --transform-translate-y: -14rem !important;
  }

  .xl\\:hover\\:-translate-y-64:hover{
    --transform-translate-y: -16rem !important;
  }

  .xl\\:hover\\:-translate-y-px:hover{
    --transform-translate-y: -1px !important;
  }

  .xl\\:hover\\:-translate-y-full:hover{
    --transform-translate-y: -100% !important;
  }

  .xl\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y: -50% !important;
  }

  .xl\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y: 50% !important;
  }

  .xl\\:hover\\:translate-y-full:hover{
    --transform-translate-y: 100% !important;
  }

  .xl\\:focus\\:translate-x-0:focus{
    --transform-translate-x: 0 !important;
  }

  .xl\\:focus\\:translate-x-1:focus{
    --transform-translate-x: 0.25rem !important;
  }

  .xl\\:focus\\:translate-x-2:focus{
    --transform-translate-x: 0.5rem !important;
  }

  .xl\\:focus\\:translate-x-3:focus{
    --transform-translate-x: 0.75rem !important;
  }

  .xl\\:focus\\:translate-x-4:focus{
    --transform-translate-x: 1rem !important;
  }

  .xl\\:focus\\:translate-x-5:focus{
    --transform-translate-x: 1.25rem !important;
  }

  .xl\\:focus\\:translate-x-6:focus{
    --transform-translate-x: 1.5rem !important;
  }

  .xl\\:focus\\:translate-x-8:focus{
    --transform-translate-x: 2rem !important;
  }

  .xl\\:focus\\:translate-x-10:focus{
    --transform-translate-x: 2.5rem !important;
  }

  .xl\\:focus\\:translate-x-12:focus{
    --transform-translate-x: 3rem !important;
  }

  .xl\\:focus\\:translate-x-16:focus{
    --transform-translate-x: 4rem !important;
  }

  .xl\\:focus\\:translate-x-20:focus{
    --transform-translate-x: 5rem !important;
  }

  .xl\\:focus\\:translate-x-24:focus{
    --transform-translate-x: 6rem !important;
  }

  .xl\\:focus\\:translate-x-32:focus{
    --transform-translate-x: 8rem !important;
  }

  .xl\\:focus\\:translate-x-40:focus{
    --transform-translate-x: 10rem !important;
  }

  .xl\\:focus\\:translate-x-48:focus{
    --transform-translate-x: 12rem !important;
  }

  .xl\\:focus\\:translate-x-56:focus{
    --transform-translate-x: 14rem !important;
  }

  .xl\\:focus\\:translate-x-64:focus{
    --transform-translate-x: 16rem !important;
  }

  .xl\\:focus\\:translate-x-px:focus{
    --transform-translate-x: 1px !important;
  }

  .xl\\:focus\\:-translate-x-1:focus{
    --transform-translate-x: -0.25rem !important;
  }

  .xl\\:focus\\:-translate-x-2:focus{
    --transform-translate-x: -0.5rem !important;
  }

  .xl\\:focus\\:-translate-x-3:focus{
    --transform-translate-x: -0.75rem !important;
  }

  .xl\\:focus\\:-translate-x-4:focus{
    --transform-translate-x: -1rem !important;
  }

  .xl\\:focus\\:-translate-x-5:focus{
    --transform-translate-x: -1.25rem !important;
  }

  .xl\\:focus\\:-translate-x-6:focus{
    --transform-translate-x: -1.5rem !important;
  }

  .xl\\:focus\\:-translate-x-8:focus{
    --transform-translate-x: -2rem !important;
  }

  .xl\\:focus\\:-translate-x-10:focus{
    --transform-translate-x: -2.5rem !important;
  }

  .xl\\:focus\\:-translate-x-12:focus{
    --transform-translate-x: -3rem !important;
  }

  .xl\\:focus\\:-translate-x-16:focus{
    --transform-translate-x: -4rem !important;
  }

  .xl\\:focus\\:-translate-x-20:focus{
    --transform-translate-x: -5rem !important;
  }

  .xl\\:focus\\:-translate-x-24:focus{
    --transform-translate-x: -6rem !important;
  }

  .xl\\:focus\\:-translate-x-32:focus{
    --transform-translate-x: -8rem !important;
  }

  .xl\\:focus\\:-translate-x-40:focus{
    --transform-translate-x: -10rem !important;
  }

  .xl\\:focus\\:-translate-x-48:focus{
    --transform-translate-x: -12rem !important;
  }

  .xl\\:focus\\:-translate-x-56:focus{
    --transform-translate-x: -14rem !important;
  }

  .xl\\:focus\\:-translate-x-64:focus{
    --transform-translate-x: -16rem !important;
  }

  .xl\\:focus\\:-translate-x-px:focus{
    --transform-translate-x: -1px !important;
  }

  .xl\\:focus\\:-translate-x-full:focus{
    --transform-translate-x: -100% !important;
  }

  .xl\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x: -50% !important;
  }

  .xl\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x: 50% !important;
  }

  .xl\\:focus\\:translate-x-full:focus{
    --transform-translate-x: 100% !important;
  }

  .xl\\:focus\\:translate-y-0:focus{
    --transform-translate-y: 0 !important;
  }

  .xl\\:focus\\:translate-y-1:focus{
    --transform-translate-y: 0.25rem !important;
  }

  .xl\\:focus\\:translate-y-2:focus{
    --transform-translate-y: 0.5rem !important;
  }

  .xl\\:focus\\:translate-y-3:focus{
    --transform-translate-y: 0.75rem !important;
  }

  .xl\\:focus\\:translate-y-4:focus{
    --transform-translate-y: 1rem !important;
  }

  .xl\\:focus\\:translate-y-5:focus{
    --transform-translate-y: 1.25rem !important;
  }

  .xl\\:focus\\:translate-y-6:focus{
    --transform-translate-y: 1.5rem !important;
  }

  .xl\\:focus\\:translate-y-8:focus{
    --transform-translate-y: 2rem !important;
  }

  .xl\\:focus\\:translate-y-10:focus{
    --transform-translate-y: 2.5rem !important;
  }

  .xl\\:focus\\:translate-y-12:focus{
    --transform-translate-y: 3rem !important;
  }

  .xl\\:focus\\:translate-y-16:focus{
    --transform-translate-y: 4rem !important;
  }

  .xl\\:focus\\:translate-y-20:focus{
    --transform-translate-y: 5rem !important;
  }

  .xl\\:focus\\:translate-y-24:focus{
    --transform-translate-y: 6rem !important;
  }

  .xl\\:focus\\:translate-y-32:focus{
    --transform-translate-y: 8rem !important;
  }

  .xl\\:focus\\:translate-y-40:focus{
    --transform-translate-y: 10rem !important;
  }

  .xl\\:focus\\:translate-y-48:focus{
    --transform-translate-y: 12rem !important;
  }

  .xl\\:focus\\:translate-y-56:focus{
    --transform-translate-y: 14rem !important;
  }

  .xl\\:focus\\:translate-y-64:focus{
    --transform-translate-y: 16rem !important;
  }

  .xl\\:focus\\:translate-y-px:focus{
    --transform-translate-y: 1px !important;
  }

  .xl\\:focus\\:-translate-y-1:focus{
    --transform-translate-y: -0.25rem !important;
  }

  .xl\\:focus\\:-translate-y-2:focus{
    --transform-translate-y: -0.5rem !important;
  }

  .xl\\:focus\\:-translate-y-3:focus{
    --transform-translate-y: -0.75rem !important;
  }

  .xl\\:focus\\:-translate-y-4:focus{
    --transform-translate-y: -1rem !important;
  }

  .xl\\:focus\\:-translate-y-5:focus{
    --transform-translate-y: -1.25rem !important;
  }

  .xl\\:focus\\:-translate-y-6:focus{
    --transform-translate-y: -1.5rem !important;
  }

  .xl\\:focus\\:-translate-y-8:focus{
    --transform-translate-y: -2rem !important;
  }

  .xl\\:focus\\:-translate-y-10:focus{
    --transform-translate-y: -2.5rem !important;
  }

  .xl\\:focus\\:-translate-y-12:focus{
    --transform-translate-y: -3rem !important;
  }

  .xl\\:focus\\:-translate-y-16:focus{
    --transform-translate-y: -4rem !important;
  }

  .xl\\:focus\\:-translate-y-20:focus{
    --transform-translate-y: -5rem !important;
  }

  .xl\\:focus\\:-translate-y-24:focus{
    --transform-translate-y: -6rem !important;
  }

  .xl\\:focus\\:-translate-y-32:focus{
    --transform-translate-y: -8rem !important;
  }

  .xl\\:focus\\:-translate-y-40:focus{
    --transform-translate-y: -10rem !important;
  }

  .xl\\:focus\\:-translate-y-48:focus{
    --transform-translate-y: -12rem !important;
  }

  .xl\\:focus\\:-translate-y-56:focus{
    --transform-translate-y: -14rem !important;
  }

  .xl\\:focus\\:-translate-y-64:focus{
    --transform-translate-y: -16rem !important;
  }

  .xl\\:focus\\:-translate-y-px:focus{
    --transform-translate-y: -1px !important;
  }

  .xl\\:focus\\:-translate-y-full:focus{
    --transform-translate-y: -100% !important;
  }

  .xl\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y: -50% !important;
  }

  .xl\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y: 50% !important;
  }

  .xl\\:focus\\:translate-y-full:focus{
    --transform-translate-y: 100% !important;
  }

  .xl\\:skew-x-0{
    --transform-skew-x: 0 !important;
  }

  .xl\\:skew-x-1{
    --transform-skew-x: 1deg !important;
  }

  .xl\\:skew-x-2{
    --transform-skew-x: 2deg !important;
  }

  .xl\\:skew-x-3{
    --transform-skew-x: 3deg !important;
  }

  .xl\\:skew-x-6{
    --transform-skew-x: 6deg !important;
  }

  .xl\\:skew-x-12{
    --transform-skew-x: 12deg !important;
  }

  .xl\\:-skew-x-12{
    --transform-skew-x: -12deg !important;
  }

  .xl\\:-skew-x-6{
    --transform-skew-x: -6deg !important;
  }

  .xl\\:-skew-x-3{
    --transform-skew-x: -3deg !important;
  }

  .xl\\:-skew-x-2{
    --transform-skew-x: -2deg !important;
  }

  .xl\\:-skew-x-1{
    --transform-skew-x: -1deg !important;
  }

  .xl\\:skew-y-0{
    --transform-skew-y: 0 !important;
  }

  .xl\\:skew-y-1{
    --transform-skew-y: 1deg !important;
  }

  .xl\\:skew-y-2{
    --transform-skew-y: 2deg !important;
  }

  .xl\\:skew-y-3{
    --transform-skew-y: 3deg !important;
  }

  .xl\\:skew-y-6{
    --transform-skew-y: 6deg !important;
  }

  .xl\\:skew-y-12{
    --transform-skew-y: 12deg !important;
  }

  .xl\\:-skew-y-12{
    --transform-skew-y: -12deg !important;
  }

  .xl\\:-skew-y-6{
    --transform-skew-y: -6deg !important;
  }

  .xl\\:-skew-y-3{
    --transform-skew-y: -3deg !important;
  }

  .xl\\:-skew-y-2{
    --transform-skew-y: -2deg !important;
  }

  .xl\\:-skew-y-1{
    --transform-skew-y: -1deg !important;
  }

  .xl\\:hover\\:skew-x-0:hover{
    --transform-skew-x: 0 !important;
  }

  .xl\\:hover\\:skew-x-1:hover{
    --transform-skew-x: 1deg !important;
  }

  .xl\\:hover\\:skew-x-2:hover{
    --transform-skew-x: 2deg !important;
  }

  .xl\\:hover\\:skew-x-3:hover{
    --transform-skew-x: 3deg !important;
  }

  .xl\\:hover\\:skew-x-6:hover{
    --transform-skew-x: 6deg !important;
  }

  .xl\\:hover\\:skew-x-12:hover{
    --transform-skew-x: 12deg !important;
  }

  .xl\\:hover\\:-skew-x-12:hover{
    --transform-skew-x: -12deg !important;
  }

  .xl\\:hover\\:-skew-x-6:hover{
    --transform-skew-x: -6deg !important;
  }

  .xl\\:hover\\:-skew-x-3:hover{
    --transform-skew-x: -3deg !important;
  }

  .xl\\:hover\\:-skew-x-2:hover{
    --transform-skew-x: -2deg !important;
  }

  .xl\\:hover\\:-skew-x-1:hover{
    --transform-skew-x: -1deg !important;
  }

  .xl\\:hover\\:skew-y-0:hover{
    --transform-skew-y: 0 !important;
  }

  .xl\\:hover\\:skew-y-1:hover{
    --transform-skew-y: 1deg !important;
  }

  .xl\\:hover\\:skew-y-2:hover{
    --transform-skew-y: 2deg !important;
  }

  .xl\\:hover\\:skew-y-3:hover{
    --transform-skew-y: 3deg !important;
  }

  .xl\\:hover\\:skew-y-6:hover{
    --transform-skew-y: 6deg !important;
  }

  .xl\\:hover\\:skew-y-12:hover{
    --transform-skew-y: 12deg !important;
  }

  .xl\\:hover\\:-skew-y-12:hover{
    --transform-skew-y: -12deg !important;
  }

  .xl\\:hover\\:-skew-y-6:hover{
    --transform-skew-y: -6deg !important;
  }

  .xl\\:hover\\:-skew-y-3:hover{
    --transform-skew-y: -3deg !important;
  }

  .xl\\:hover\\:-skew-y-2:hover{
    --transform-skew-y: -2deg !important;
  }

  .xl\\:hover\\:-skew-y-1:hover{
    --transform-skew-y: -1deg !important;
  }

  .xl\\:focus\\:skew-x-0:focus{
    --transform-skew-x: 0 !important;
  }

  .xl\\:focus\\:skew-x-1:focus{
    --transform-skew-x: 1deg !important;
  }

  .xl\\:focus\\:skew-x-2:focus{
    --transform-skew-x: 2deg !important;
  }

  .xl\\:focus\\:skew-x-3:focus{
    --transform-skew-x: 3deg !important;
  }

  .xl\\:focus\\:skew-x-6:focus{
    --transform-skew-x: 6deg !important;
  }

  .xl\\:focus\\:skew-x-12:focus{
    --transform-skew-x: 12deg !important;
  }

  .xl\\:focus\\:-skew-x-12:focus{
    --transform-skew-x: -12deg !important;
  }

  .xl\\:focus\\:-skew-x-6:focus{
    --transform-skew-x: -6deg !important;
  }

  .xl\\:focus\\:-skew-x-3:focus{
    --transform-skew-x: -3deg !important;
  }

  .xl\\:focus\\:-skew-x-2:focus{
    --transform-skew-x: -2deg !important;
  }

  .xl\\:focus\\:-skew-x-1:focus{
    --transform-skew-x: -1deg !important;
  }

  .xl\\:focus\\:skew-y-0:focus{
    --transform-skew-y: 0 !important;
  }

  .xl\\:focus\\:skew-y-1:focus{
    --transform-skew-y: 1deg !important;
  }

  .xl\\:focus\\:skew-y-2:focus{
    --transform-skew-y: 2deg !important;
  }

  .xl\\:focus\\:skew-y-3:focus{
    --transform-skew-y: 3deg !important;
  }

  .xl\\:focus\\:skew-y-6:focus{
    --transform-skew-y: 6deg !important;
  }

  .xl\\:focus\\:skew-y-12:focus{
    --transform-skew-y: 12deg !important;
  }

  .xl\\:focus\\:-skew-y-12:focus{
    --transform-skew-y: -12deg !important;
  }

  .xl\\:focus\\:-skew-y-6:focus{
    --transform-skew-y: -6deg !important;
  }

  .xl\\:focus\\:-skew-y-3:focus{
    --transform-skew-y: -3deg !important;
  }

  .xl\\:focus\\:-skew-y-2:focus{
    --transform-skew-y: -2deg !important;
  }

  .xl\\:focus\\:-skew-y-1:focus{
    --transform-skew-y: -1deg !important;
  }

  [dir] .xl\\:transition-none{
    transition-property: none !important;
  }

  [dir] .xl\\:transition-all{
    transition-property: all !important;
  }

  [dir] .xl\\:transition{
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform !important;
  }

  [dir] .xl\\:transition-colors{
    transition-property: background-color, border-color, color, fill, stroke !important;
  }

  [dir] .xl\\:transition-opacity{
    transition-property: opacity !important;
  }

  [dir] .xl\\:transition-shadow{
    transition-property: box-shadow !important;
  }

  [dir] .xl\\:transition-transform{
    transition-property: transform !important;
  }

  [dir] .xl\\:ease-linear{
    transition-timing-function: linear !important;
  }

  [dir] .xl\\:ease-in{
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1) !important;
  }

  [dir] .xl\\:ease-out{
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1) !important;
  }

  [dir] .xl\\:ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  }

  [dir] .xl\\:duration-75{
    transition-duration: 75ms !important;
  }

  [dir] .xl\\:duration-100{
    transition-duration: 100ms !important;
  }

  [dir] .xl\\:duration-150{
    transition-duration: 150ms !important;
  }

  [dir] .xl\\:duration-200{
    transition-duration: 200ms !important;
  }

  [dir] .xl\\:duration-300{
    transition-duration: 300ms !important;
  }

  [dir] .xl\\:duration-500{
    transition-duration: 500ms !important;
  }

  [dir] .xl\\:duration-700{
    transition-duration: 700ms !important;
  }

  [dir] .xl\\:duration-1000{
    transition-duration: 1000ms !important;
  }

  [dir] .xl\\:delay-75{
    transition-delay: 75ms !important;
  }

  [dir] .xl\\:delay-100{
    transition-delay: 100ms !important;
  }

  [dir] .xl\\:delay-150{
    transition-delay: 150ms !important;
  }

  [dir] .xl\\:delay-200{
    transition-delay: 200ms !important;
  }

  [dir] .xl\\:delay-300{
    transition-delay: 300ms !important;
  }

  [dir] .xl\\:delay-500{
    transition-delay: 500ms !important;
  }

  [dir] .xl\\:delay-700{
    transition-delay: 700ms !important;
  }

  [dir] .xl\\:delay-1000{
    transition-delay: 1000ms !important;
  }

  [dir=ltr] .xl\\:animate-none{
    animation: none !important;
  }

  [dir=rtl] .xl\\:animate-none{
    animation: none !important;
  }

  [dir=ltr] .xl\\:animate-spin{
    animation:  spin-ltr 1s linear infinite !important;
  }

  [dir=rtl] .xl\\:animate-spin{
    animation:  spin-rtl 1s linear infinite !important;
  }

  [dir=ltr] .xl\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite !important;
  }

  [dir=rtl] .xl\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite !important;
  }

  [dir=ltr] .xl\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
  }

  [dir=rtl] .xl\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
  }

  [dir=ltr] .xl\\:animate-bounce{
    animation: bounce 1s infinite !important;
  }

  [dir=rtl] .xl\\:animate-bounce{
    animation: bounce 1s infinite !important;
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
